// tslint:disable
import { Injectable } from '@angular/core';

import { DwQuery, DwQueryBuilderGen, DwItem2, DwItemAttributeCollection, DwItemAttribute, DwItemRelationshipCollection, DwItemRelationship, DwItemDetail2, DwOrmData } from '@devwareapps/devware-cap';
import * as EnterpriseMetaData from '@devwareapps/devware-cap';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/************************************************
   Generated with the Devware CAP CLI 4.4.55
   Code Gen Name   App
   API Url         https://aviator-online-test-api4.azurewebsites.net/

   Generated By    DEVWARE/Anthony.Monsees
   Generate On     10/26/2026 11:38:30 AM
************************************************/

export enum AppMetaDataItemNames {
    AchievementDefinition = 'AchievementDefinition',
    AchievementTier = 'AchievementTier',
    AcquisitionSource = 'AcquisitionSource',
    AcsAreaOfOperation = 'AcsAreaOfOperation',
    AcsAreaOfOperationTask = 'AcsAreaOfOperationTask',
    AcsCode = 'AcsCode',
    AcsCodeType = 'AcsCodeType',
    AcsTaskMultiAssign = 'AcsTaskMultiAssign',
    AcsTaskMultiAssignLesson = 'AcsTaskMultiAssignLesson',
    AcsTaskMultiAssignTask = 'AcsTaskMultiAssignTask',
    AcsTest = 'AcsTest',
    AcsTestStatus = 'AcsTestStatus',
    AcsWrittenResult = 'AcsWrittenResult',
    AcsWrittenResultMissedCode = 'AcsWrittenResultMissedCode',
    AcsWrittenTestStatus = 'AcsWrittenTestStatus',
    Address = 'Address',
    AiProcessConfig = 'AiProcessConfig',
    AIProcessingReference = 'AIProcessingReference',
    AIProcessingReferenceStatus = 'AIProcessingReferenceStatus',
    AIPromptModel = 'AIPromptModel',
    AIPromptRequest = 'AIPromptRequest',
    AIPromptRequestStatus = 'AIPromptRequestStatus',
    AiPromptRequestType = 'AiPromptRequestType',
    AIPromptResultType = 'AIPromptResultType',
    AIPromptSetup = 'AIPromptSetup',
    AiPromptSetupStatus = 'AiPromptSetupStatus',
    AIPromptTokenType = 'AIPromptTokenType',
    AIPromptType = 'AIPromptType',
    AircraftType = 'AircraftType',
    Airport = 'Airport',
    Assignment = 'Assignment',
    AssignmentCourseLesson = 'AssignmentCourseLesson',
    AssignmentStatus = 'AssignmentStatus',
    AssignmentStudent = 'AssignmentStudent',
    AssignmentType = 'AssignmentType',
    AviationGoal = 'AviationGoal',
    Country = 'Country',
    Course = 'Course',
    CourseAssignmentSourceType = 'CourseAssignmentSourceType',
    CourseAvailabilityNotification = 'CourseAvailabilityNotification',
    CourseDocumentItem = 'CourseDocumentItem',
    CourseDocumentProcessingStatus = 'CourseDocumentProcessingStatus',
    CourseEndorsement = 'CourseEndorsement',
    CourseEndorsementLesson = 'CourseEndorsementLesson',
    CourseEndorsementStudent = 'CourseEndorsementStudent',
    CourseEndorsementTemplate = 'CourseEndorsementTemplate',
    CourseEndorsementTemplateField = 'CourseEndorsementTemplateField',
    CourseLesson = 'CourseLesson',
    CourseLessonAcsTask = 'CourseLessonAcsTask',
    CourseLessonDocumentLink = 'CourseLessonDocumentLink',
    CourseLessonDocumentLinkReference = 'CourseLessonDocumentLinkReference',
    CourseLessonFlag = 'CourseLessonFlag',
    CourseLessonFlagStatus = 'CourseLessonFlagStatus',
    CourseLessonFlagType = 'CourseLessonFlagType',
    CourseLessonProgress = 'CourseLessonProgress',
    CourseLessonSession = 'CourseLessonSession',
    CourseModificationHistory = 'CourseModificationHistory',
    CourseModule = 'CourseModule',
    CourseModuleDocumentItem = 'CourseModuleDocumentItem',
    CourseModuleProgress = 'CourseModuleProgress',
    CoursePurchase = 'CoursePurchase',
    CoursePurchaseBillingAttempt = 'CoursePurchaseBillingAttempt',
    CoursePurchaseBillingAttemptStatus = 'CoursePurchaseBillingAttemptStatus',
    CoursePurchaseCourse = 'CoursePurchaseCourse',
    CoursePurchasePackage = 'CoursePurchasePackage',
    CoursePurchaseReservation = 'CoursePurchaseReservation',
    CoursePurchaseReservationCourse = 'CoursePurchaseReservationCourse',
    CoursePurchaseReservationStatus = 'CoursePurchaseReservationStatus',
    CoursePurchaseStudent = 'CoursePurchaseStudent',
    CourseType = 'CourseType',
    DailyQuiz = 'DailyQuiz',
    Discount = 'Discount',
    DiscountCourse = 'DiscountCourse',
    DiscountPackage = 'DiscountPackage',
    DiscountSubscriptionRole = 'DiscountSubscriptionRole',
    DiscountUsageFlightSchool = 'DiscountUsageFlightSchool',
    DiscountUsageUser = 'DiscountUsageUser',
    DocumentAiProcessingStatus = 'DocumentAiProcessingStatus',
    DocumentAnchor = 'DocumentAnchor',
    DocumentAnchorType = 'DocumentAnchorType',
    DocumentAsset = 'DocumentAsset',
    DocumentAssetType = 'DocumentAssetType',
    DocumentChangeLogType = 'DocumentChangeLogType',
    DocumentContentFormatType = 'DocumentContentFormatType',
    DocumentFolder = 'DocumentFolder',
    DocumentFolderChangeLog = 'DocumentFolderChangeLog',
    DocumentGroup = 'DocumentGroup',
    DocumentImportJob = 'DocumentImportJob',
    DocumentImportJobStatus = 'DocumentImportJobStatus',
    DocumentImportJobType = 'DocumentImportJobType',
    DocumentItem = 'DocumentItem',
    DocumentItemAcknowledgement = 'DocumentItemAcknowledgement',
    DocumentItemChangeLog = 'DocumentItemChangeLog',
    DocumentItemChunk = 'DocumentItemChunk',
    DocumentItemChunkContentType = 'DocumentItemChunkContentType',
    DocumentItemPage = 'DocumentItemPage',
    DocumentItemStatus = 'DocumentItemStatus',
    DocumentLinkProcessingRun = 'DocumentLinkProcessingRun',
    DocumentLinkProcessingRunItem = 'DocumentLinkProcessingRunItem',
    DocumentLinkProcessingRunItemStatus = 'DocumentLinkProcessingRunItemStatus',
    DocumentLinkProcessingRunStatus = 'DocumentLinkProcessingRunStatus',
    DocumentLinkProcessingTriggerType = 'DocumentLinkProcessingTriggerType',
    DocumentLinkSourceType = 'DocumentLinkSourceType',
    DocumentOwnerType = 'DocumentOwnerType',
    DocumentPublication = 'DocumentPublication',
    DocumentPublicationType = 'DocumentPublicationType',
    DocumentReferenceSource = 'DocumentReferenceSource',
    DocumentSection = 'DocumentSection',
    DocumentSectionContent = 'DocumentSectionContent',
    DocumentSectionType = 'DocumentSectionType',
    DocumentType = 'DocumentType',
    DocumentVersion = 'DocumentVersion',
    DocumentVersionType = 'DocumentVersionType',
    DwMedia = 'dw_Media',
    DwMediaGroup = 'dw_MediaGroup',
    DwMetaDataItem = 'dw_MetaDataItem',
    DwProcessDefinition = 'dw_ProcessDefinition',
    DwRole = 'dw_Role',
    DwRoMedia = 'dw_roMedia',
    DwTheme = 'dw_Theme',
    DwThemeProperty = 'dw_ThemeProperty',
    DwThemePropertyDefinition = 'dw_ThemePropertyDefinition',
    DwThemePropertyType = 'dw_ThemePropertyType',
    DwUser = 'dw_User',
    DwUserRole = 'dw_UserRole',
    DwUserType = 'dw_UserType',
    FlightSchool = 'FlightSchool',
    FlightSchoolBillingContact = 'FlightSchoolBillingContact',
    FlightSchoolBranding = 'FlightSchoolBranding',
    FlightSchoolCourse = 'FlightSchoolCourse',
    FlightSchoolFeature = 'FlightSchoolFeature',
    FlightSchoolGroup = 'FlightSchoolGroup',
    FlightSchoolGroupStudent = 'FlightSchoolGroupStudent',
    FlightSchoolInstructor = 'FlightSchoolInstructor',
    FlightSchoolPackage = 'FlightSchoolPackage',
    FlightSchoolPosition = 'FlightSchoolPosition',
    FlightSchoolRegistrationEmailDomain = 'FlightSchoolRegistrationEmailDomain',
    FlightSchoolRegistrationLink = 'FlightSchoolRegistrationLink',
    FlightSchoolStatus = 'FlightSchoolStatus',
    GamificationConfiguration = 'GamificationConfiguration',
    Instructor = 'Instructor',
    InstructorStatus = 'InstructorStatus',
    InstructorStudent = 'InstructorStudent',
    IntegrationCoursePurchase = 'IntegrationCoursePurchase',
    IntegrationCoursePurchaseRequest = 'IntegrationCoursePurchaseRequest',
    IntegrationCoursePurchaseRequestStatus = 'IntegrationCoursePurchaseRequestStatus',
    IntegrationEventType = 'IntegrationEventType',
    IntegrationOrganization = 'IntegrationOrganization',
    IntegrationOrganizationStatus = 'IntegrationOrganizationStatus',
    IntegrationSystem = 'IntegrationSystem',
    IntegrationSystemCourse = 'IntegrationSystemCourse',
    IntegrationUser = 'IntegrationUser',
    IntegrationUserEvent = 'IntegrationUserEvent',
    IntegrationUserEventStatus = 'IntegrationUserEventStatus',
    IntegrationUserStatus = 'IntegrationUserStatus',
    Invoice = 'Invoice',
    InvoiceErrorCode = 'InvoiceErrorCode',
    InvoiceErrorLog = 'InvoiceErrorLog',
    InvoiceLine = 'InvoiceLine',
    InvoiceLog = 'InvoiceLog',
    InvoiceRefund = 'InvoiceRefund',
    InvoiceStatus = 'InvoiceStatus',
    InvoiceType = 'InvoiceType',
    JoinRequest = 'JoinRequest',
    JoinRequestCourse = 'JoinRequestCourse',
    JoinRequestCourseFulfillmentStatus = 'JoinRequestCourseFulfillmentStatus',
    JoinRequestCoursePurchase = 'JoinRequestCoursePurchase',
    JoinRequestCoursePurchaseStatus = 'JoinRequestCoursePurchaseStatus',
    JoinRequestEmail = 'JoinRequestEmail',
    JoinRequestStatus = 'JoinRequestStatus',
    JoinRequestType = 'JoinRequestType',
    JoinRequestTypeRole = 'JoinRequestTypeRole',
    JoinRequestTypeSubscriptionRole = 'JoinRequestTypeSubscriptionRole',
    LessonType = 'LessonType',
    MetricType = 'MetricType',
    ModificationHistory = 'ModificationHistory',
    ModificationHistoryStatus = 'ModificationHistoryStatus',
    ModificationHistoryStudent = 'ModificationHistoryStudent',
    ModificationHistoryStudentStatus = 'ModificationHistoryStudentStatus',
    MultipleAssign = 'MultipleAssign',
    MultipleAssignCourse = 'MultipleAssignCourse',
    MultipleAssignFlightSchool = 'MultipleAssignFlightSchool',
    MultipleAssignPackage = 'MultipleAssignPackage',
    Package = 'Package',
    PackageCourse = 'PackageCourse',
    PaymentEvent = 'PaymentEvent',
    PaymentEventSource = 'PaymentEventSource',
    PaymentEventStatus = 'PaymentEventStatus',
    PaymentEventType = 'PaymentEventType',
    PaymentMethod = 'PaymentMethod',
    PaymentPartyType = 'PaymentPartyType',
    PilotType = 'PilotType',
    PostalCode = 'PostalCode',
    ProcessorConfig = 'ProcessorConfig',
    ProcessorConfigCustomerHistory = 'ProcessorConfigCustomerHistory',
    ProcessorLog = 'ProcessorLog',
    Product = 'Product',
    ProductPaymentLink = 'ProductPaymentLink',
    ProductType = 'ProductType',
    ProfitShare = 'ProfitShare',
    ProfitShareStatus = 'ProfitShareStatus',
    ProfitShareType = 'ProfitShareType',
    ProgramType = 'ProgramType',
    Question = 'Question',
    QuestionNotUsed = 'Question_NotUsed',
    QuestionAIProcessingStatus = 'QuestionAIProcessingStatus',
    QuestionAnswer = 'QuestionAnswer',
    QuestionAnswerAIExplanation = 'QuestionAnswerAIExplanation',
    QuestionImportCharacterConversion = 'QuestionImportCharacterConversion',
    QuestionStatus = 'QuestionStatus',
    QuestionTag = 'QuestionTag',
    QuestionTagLink = 'QuestionTagLink',
    QuestionType = 'QuestionType',
    Quiz = 'Quiz',
    QuizOutcome = 'QuizOutcome',
    QuizQuestionAnswerNotUsed = 'QuizQuestionAnswer_NotUsed',
    QuizQuestionLink = 'QuizQuestionLink',
    QuizReferenceQuizLink = 'QuizReferenceQuizLink',
    QuizResult = 'QuizResult',
    QuizResultQuestion = 'QuizResultQuestion',
    QuizResultStatus = 'QuizResultStatus',
    QuizResultType = 'QuizResultType',
    QuizType = 'QuizType',
    ReferenceImage = 'ReferenceImage',
    ReferenceStatus = 'ReferenceStatus',
    RoAcsWrittenMissedCodeStats = 'roAcsWrittenMissedCodeStats',
    RoAssignmentDetail = 'roAssignmentDetail',
    RoAssignmentResetLessonImpact = 'roAssignmentResetLessonImpact',
    RoAssignmentResetStudentImpact = 'roAssignmentResetStudentImpact',
    RoAssignmentStudentCompletedDetails = 'roAssignmentStudentCompletedDetails',
    RoAssignmentStudentCourseLessonProgress = 'roAssignmentStudentCourseLessonProgress',
    RoAssignmentStudentStat = 'roAssignmentStudentStat',
    RoCompletedInvoices = 'roCompletedInvoices',
    RoCourseEndorsementStudentActive = 'roCourseEndorsementStudentActive',
    RoCourseModuleLesson = 'roCourseModuleLesson',
    RoFlightSchoolAdmins = 'roFlightSchoolAdmins',
    RoFlightSchoolCoursePackageCount = 'roFlightSchoolCoursePackageCount',
    RoFlightSchoolCourseUnique = 'roFlightSchoolCourseUnique',
    RoFlightSchoolPaymentInfo = 'roFlightSchoolPaymentInfo',
    RoInstructorAssignmentsPerWeek = 'roInstructorAssignmentsPerWeek',
    RoIntegationCouresPurchase = 'RoIntegationCouresPurchase',
    RoLessonQuizStats = 'roLessonQuizStats',
    RoModuleLessonMaxOrder = 'roModuleLessonMaxOrder',
    RoPostLoginSummary = 'roPostLoginSummary',
    RoProduct = 'roProduct',
    RoSchoolAssignmentStats = 'roSchoolAssignmentStats',
    RoSchoolBillingDetails = 'roSchoolBillingDetails',
    RoSchoolCourseEnrollmentStats = 'roSchoolCourseEnrollmentStats',
    RoSchoolInvoices = 'roSchoolInvoices',
    RoSchoolPaymentMethod = 'roSchoolPaymentMethod',
    RoSchoolStudentStats = 'roSchoolStudentStats',
    RoSchoolSubscription = 'roSchoolSubscription',
    RoStudentCourseAcsTestResultDetail = 'RoStudentCourseAcsTestResultDetail',
    RoStudentCourseDetail = 'roStudentCourseDetail',
    RoStudentCourseInstructor = 'roStudentCourseInstructor',
    RoStudentCourseProgressMismatch = 'roStudentCourseProgressMismatch',
    RoStudentOverviewDetails = 'roStudentOverviewDetails',
    RoStudentPaymentMethod = 'roStudentPaymentMethod',
    RoStudentSchoolCourses = 'roStudentSchoolCourses',
    RoUserRoleDetail = 'roUserRoleDetail',
    RptInvoiceProductDetail = 'rptInvoiceProductDetail',
    RptProfitShare = 'rptProfitShare',
    SchoolBillingMode = 'SchoolBillingMode',
    SchoolBillingPolicyPeriod = 'SchoolBillingPolicyPeriod',
    SchoolFeature = 'SchoolFeature',
    StandardColorSet = 'StandardColorSet',
    StandardLoginMedia = 'StandardLoginMedia',
    StateProvince = 'StateProvince',
    StripeCheckoutSession = 'StripeCheckoutSession',
    StripeCheckoutSessionProduct = 'StripeCheckoutSessionProduct',
    StripeCheckoutSessionStatus = 'StripeCheckoutSessionStatus',
    Student = 'Student',
    StudentAchievement = 'StudentAchievement',
    StudentAchievementAward = 'StudentAchievementAward',
    StudentActivity = 'StudentActivity',
    StudentActivityType = 'StudentActivityType',
    StudentCourse = 'StudentCourse',
    StudentCourseLockInstructor = 'StudentCourseLockInstructor',
    StudentCourseProgressStatus = 'StudentCourseProgressStatus',
    StudentGamificationDay = 'StudentGamificationDay',
    StudentGamificationSummary = 'StudentGamificationSummary',
    StudentLessonProgressEvent = 'StudentLessonProgressEvent',
    StudentModuleSummary = 'StudentModuleSummary',
    StudentModuleSummaryStatus = 'StudentModuleSummaryStatus',
    StudentProgressResetEvent = 'StudentProgressResetEvent',
    StudentWeatherDayTransaction = 'StudentWeatherDayTransaction',
    SubdomainSetupStatus = 'SubdomainSetupStatus',
    SubdomainType = 'SubdomainType',
    Subscription = 'Subscription',
    SubscriptionCourseTracking = 'SubscriptionCourseTracking',
    SubscriptionFeature = 'SubscriptionFeature',
    SubscriptionRole = 'SubscriptionRole',
    SubscriptionRoleTracking = 'SubscriptionRoleTracking',
    SubscriptionStatus = 'SubscriptionStatus',
    SubscriptionTier = 'SubscriptionTier',
    SubscriptionTierBenefit = 'SubscriptionTierBenefit',
    SubscriptionTierFeature = 'SubscriptionTierFeature',
    SubscriptionTierFlightSchool = 'SubscriptionTierFlightSchool',
    SubscriptionTierRole = 'SubscriptionTierRole',
    SubscriptionTierStatus = 'SubscriptionTierStatus',
    TemplateFieldAlignment = 'TemplateFieldAlignment',
    TemplateFieldType = 'TemplateFieldType',
    TemplateFontStyle = 'TemplateFontStyle',
    TimeZone = 'TimeZone',
    UserDetail = 'UserDetail',
    UserDocumentSectionFavorite = 'UserDocumentSectionFavorite',
    UserSubscriptionRole = 'UserSubscriptionRole',
    VectorProvider = 'VectorProvider',
    VectorReference = 'VectorReference',
    Video = 'Video',
    VideoHistory = 'VideoHistory',
    VideoLibrary = 'VideoLibrary',
    VideoPlaybackAuthenticationMode = 'VideoPlaybackAuthenticationMode',
    VideoProcessingStatus = 'VideoProcessingStatus',
    VideoStatus = 'VideoStatus',
    VideoStreamingProvider = 'VideoStreamingProvider',
    VideoTagLink = 'VideoTagLink',
}

export enum AppMetaDataLookups {
    AchievementDefinitionAllItems = 533,
    AchievementTierAllItems = 532,
    AcquisitionSourceAllItems = 448,
    AcsAreaOfOperationAllItems = 355,
    AcsAreaOfOperationTaskByACSTest = 361,
    AcsAreaOfOperationTaskAllItems = 354,
    AcsCodeAllItems = 356,
    AcsCodeTypeAllItems = 357,
    AcsTaskMultiAssignAllItems = 376,
    AcsTaskMultiAssignLessonAllItems = 374,
    AcsTaskMultiAssignTaskAllItems = 375,
    AcsTestAllItems = 359,
    AcsTestStatusAllItems = 358,
    AcsWrittenResultAllItems = 352,
    AcsWrittenResultMissedCodeAllItems = 353,
    AcsWrittenTestStatusAllItems = 362,
    AddressAllItems = 221,
    AiProcessConfigAllItems = 393,
    AIProcessingReferenceAllItems = 433,
    AIProcessingReferenceStatusAllItems = 434,
    AIPromptModelAllItems = 387,
    AIPromptRequestAllItems = 381,
    AIPromptRequestStatusAllItems = 383,
    AiPromptRequestTypeAllItems = 384,
    AIPromptResultTypeAllItems = 382,
    AIPromptSetupAllItems = 388,
    AiPromptSetupStatusAllItems = 385,
    AIPromptTokenTypeAllItems = 390,
    AIPromptTypeAllItems = 386,
    AircraftTypeAllItems = 158,
    AirportAllItems = 224,
    AssignmentAllItems = 200,
    AssignmentStudentByCourse = 399,
    AssignmentCourseLessonAllItems = 210,
    AssignmentStatusAllItems = 202,
    AssignmentStudentAllItems = 203,
    AssignmentTypeAllItems = 201,
    AviationGoalAllItems = 520,
    CountryAllItems = 220,
    CourseActiveOnly = 413,
    CourseBySchool = 207,
    CourseBySchoolStudent = 412,
    CourseAllItems = 154,
    CourseAssignmentSourceTypeAllItems = 516,
    CourseAvailabilityNotificationAllItems = 504,
    CourseDocumentItemAllItems = 438,
    CourseDocumentProcessingStatusAllItems = 443,
    CourseEndorsementAllItems = 240,
    CourseEndorsementLessonAllItems = 241,
    CourseEndorsementStudentAllItems = 242,
    CourseEndorsementTemplateAllItems = 243,
    CourseEndorsementTemplateFieldAllItems = 244,
    CourseLessonByCourse = 206,
    CourseLessonWithDetail = 253,
    CourseLessonAllItems = 162,
    CourseLessonAcsTaskAllItems = 360,
    CourseLessonDocumentLinkAllItems = 435,
    CourseLessonDocumentLinkReferenceAllItems = 501,
    CourseLessonFlagAllItems = 250,
    CourseLessonFlagStatusAllItems = 252,
    CourseLessonFlagTypeAllItems = 251,
    CourseLessonProgressAllItems = 144,
    CourseLessonSessionAllItems = 175,
    CourseModificationHistoryAllItems = 255,
    CourseModuleAllItems = 161,
    CourseModuleDocumentItemAllItems = 439,
    CourseModuleProgressAllItems = 143,
    CoursePurchaseAllItems = 306,
    CoursePurchaseBillingAttemptAllItems = 546,
    CoursePurchaseBillingAttemptStatusAllItems = 545,
    CoursePurchaseCourseAllItems = 302,
    CoursePurchasePackageAllItems = 307,
    CoursePurchaseReservationAllItems = 544,
    CoursePurchaseReservationCourseAllItems = 547,
    CoursePurchaseReservationStatusAllItems = 543,
    CoursePurchaseStudentAllItems = 303,
    CourseTypeAllItems = 155,
    DailyQuizAllItems = 522,
    DiscountAllItems = 285,
    DiscountCourseAllItems = 286,
    DiscountPackageAllItems = 287,
    DiscountSubscriptionRoleAllItems = 284,
    DiscountUsageFlightSchoolAllItems = 283,
    DiscountUsageUserAllItems = 282,
    DocumentAiProcessingStatusAllItems = 442,
    DocumentAnchorAllItems = 481,
    DocumentAnchorTypeAllItems = 487,
    DocumentAssetAllItems = 482,
    DocumentAssetTypeAllItems = 486,
    DocumentChangeLogTypeAllItems = 425,
    DocumentContentFormatTypeAllItems = 485,
    DocumentFolderAllItems = 415,
    DocumentFolderChangeLogAllItems = 424,
    DocumentGroupAllItems = 403,
    DocumentImportJobAllItems = 483,
    DocumentImportJobStatusAllItems = 490,
    DocumentImportJobTypeAllItems = 489,
    DocumentItemProTools = 417,
    DocumentItemAllItems = 404,
    DocumentItemAcknowledgementAllItems = 426,
    DocumentItemChangeLogAllItems = 423,
    DocumentItemChunkAllItems = 437,
    DocumentItemChunkContentTypeAllItems = 447,
    DocumentItemPageAllItems = 436,
    DocumentItemStatusAllItems = 406,
    DocumentLinkProcessingRunAllItems = 510,
    DocumentLinkProcessingRunItemAllItems = 505,
    DocumentLinkProcessingRunItemStatusAllItems = 507,
    DocumentLinkProcessingRunStatusAllItems = 508,
    DocumentLinkProcessingTriggerTypeAllItems = 506,
    DocumentLinkSourceTypeAllItems = 509,
    DocumentOwnerTypeAllItems = 416,
    DocumentPublicationAllItems = 488,
    DocumentPublicationTypeAllItems = 494,
    DocumentReferenceSourceAllItems = 496,
    DocumentSectionAllItems = 492,
    DocumentSectionContentAllItems = 491,
    DocumentSectionTypeAllItems = 484,
    DocumentTypeAllItems = 405,
    DocumentVersionAllItems = 493,
    DocumentVersionTypeAllItems = 495,
    FlightSchoolActiveOnly = 292,
    FlightSchoolAllItems = 187,
    FlightSchoolBillingContactAllItems = 511,
    FlightSchoolBrandingAllItems = 262,
    FlightSchoolCourseAllItems = 188,
    FlightSchoolFeatureAllItems = 407,
    FlightSchoolGroupBySchool = 239,
    FlightSchoolGroupAllItems = 204,
    FlightSchoolGroupStudentBySchool = 238,
    FlightSchoolGroupStudentAllItems = 205,
    FlightSchoolInstructorAllItems = 228,
    FlightSchoolPackageAllItems = 191,
    FlightSchoolPositionAllItems = 450,
    FlightSchoolRegistrationEmailDomainAllItems = 517,
    FlightSchoolRegistrationLinkAllItems = 518,
    FlightSchoolStatusAllItems = 186,
    GamificationConfigurationAllItems = 530,
    InstructorAllItems = 227,
    InstructorsBySchool = 237,
    InstructorStatusAllItems = 235,
    InstructorStudentAllItems = 229,
    IntegrationCoursePurchaseAllItems = 314,
    IntegrationCoursePurchaseRequestAllItems = 394,
    IntegrationCoursePurchaseRequestStatusAllItems = 395,
    IntegrationEventTypeAllItems = 337,
    IntegrationOrganizationAllItems = 299,
    IntegrationOrganizationStatusAllItems = 297,
    IntegrationSystemAllItems = 296,
    IntegrationSystemCourseAllItems = 339,
    IntegrationUserAllItems = 298,
    IntegrationUserEventAllItems = 336,
    IntegrationUserEventStatusAllItems = 338,
    IntegrationUserStatusAllItems = 300,
    InvoiceAllItems = 276,
    InvoiceBySchool = 315,
    InvoiceErrorCodeAllItems = 326,
    InvoiceErrorLogAllItems = 327,
    InvoiceLineAllItems = 277,
    InvoiceLogAllItems = 278,
    InvoiceRefundAllItems = 414,
    InvoiceStatusAllItems = 325,
    InvoiceTypeAllItems = 324,
    JoinRequestAllItems = 213,
    JoinRequestCourseAllItems = 218,
    JoinRequestCourseFulfillmentStatusAllItems = 513,
    JoinRequestCoursePurchaseAllItems = 515,
    JoinRequestCoursePurchaseStatusAllItems = 514,
    JoinRequestEmailAllItems = 212,
    JoinRequestStatusAllItems = 219,
    JoinRequestTypeAllItems = 217,
    JoinRequestTypeRoleAllItems = 215,
    JoinRequestTypeSubscriptionRoleAllItems = 330,
    LessonTypeAllItems = 163,
    MediaAllItems = 82,
    MediaGroupAllItems = 66,
    MetaDataItemGroupByDatabase = 49,
    MetaDataSchemasByDatabase = 50,
    MetaDataItemAllItems = 48,
    MetricTypeAllItems = 531,
    ModificationHistoryAllItems = 342,
    ModificationHistoryStatusAllItems = 340,
    ModificationHistoryStudentAllItems = 341,
    ModificationHistoryStudentStatusAllItems = 343,
    ModuleByCourse = 195,
    MultipleAssignAllItems = 333,
    MultipleAssignCourseAllItems = 335,
    MultipleAssignFlightSchoolAllItems = 332,
    MultipleAssignPackageAllItems = 334,
    PackageBySchool = 308,
    PackageAllItems = 194,
    PackageCourseAllItems = 193,
    PaymentEventAllItems = 364,
    PaymentEventSourceAllItems = 365,
    PaymentEventStatusAllItems = 363,
    PaymentEventTypeAllItems = 366,
    PaymentMethodAllItems = 273,
    PaymentPartyTypeAllItems = 304,
    PilotTypeAllItems = 449,
    PostalCodeAllItems = 225,
    ProcessDefinitionByMeaning = 397,
    ProcessDefinitionAllItems = 117,
    ProcessorConfigAllItems = 271,
    ProcessorConfigCustomerHistoryAllItems = 512,
    ProcessorLogAllItems = 279,
    ProductAllItems = 295,
    ProductPaymentLinkAllItems = 398,
    ProductTypeAllItems = 301,
    ProfitShareAllItems = 316,
    ProfitShareStatusAllItems = 317,
    ProfitShareTypeAllItems = 318,
    ProgramTypeAllItems = 156,
    QuestionNotUsedAllItems = 177,
    QuestionAIProcessingStatusAllItems = 402,
    QuestionAnswerAllItems = 181,
    QuestionAnswerAIExplanationAllItems = 401,
    QuestionImportCharacterConversionAllItems = 226,
    QuestionStatusAllItems = 196,
    QuestionTagAllItems = 178,
    QuestionTagLinkAllItems = 179,
    QuestionTypeAllItems = 172,
    QuizAllItems = 146,
    QuizOutcomeAllItems = 171,
    QuizQuestionAllItems = 147,
    QuizQuestionAnswerNotUsedAllItems = 180,
    QuizQuestionLinkAllItems = 176,
    QuizReferenceQuizLinkAllItems = 230,
    QuizResultAllItems = 149,
    QuizResultQuestionAllItems = 150,
    QuizResultStatusAllItems = 182,
    QuizResultTypeAllItems = 521,
    QuizTypeAllItems = 170,
    ReferenceImageAllItems = 248,
    ReferenceStatusAllItems = 254,
    RoAcsWrittenMissedCodeStatsAllItems = 432,
    RoAssignmentDetailAllItems = 410,
    RoAssignmentResetLessonImpactAllItems = 535,
    RoAssignmentResetStudentImpactAllItems = 536,
    RoAssignmentStudentCompletedDetailsAllItems = 249,
    RoAssignmentStudentCourseLessonProgressAllItems = 211,
    RoAssignmentStudentStatAllItems = 430,
    RoCompletedInvoicesAllItems = 281,
    RoCourseEndorsementStudentActiveAllItems = 431,
    RoCourseModuleLessonAllItems = 500,
    RoFlightSchoolAdminsAllItems = 309,
    RoFlightSchoolCoursePackageCountAllItems = 331,
    RoFlightSchoolCourseUniqueAllItems = 208,
    RoFlightSchoolPaymentInfoAllItems = 445,
    RoInstructorAssignmentsPerWeekAllItems = 421,
    RoIntegationCouresPurchaseAllItems = 396,
    RoleAllItems = 47,
    RoLessonQuizStatsAllItems = 422,
    RoMediaAllItems = 79,
    RoModuleLessonMaxOrderAllItems = 173,
    RoPostLoginSummaryAllItems = 524,
    RoProductAllItems = 305,
    RoSchoolAssignmentStatsAllItems = 420,
    RoSchoolBillingDetailsAllItems = 290,
    RoSchoolCourseEnrollmentStatsAllItems = 419,
    RoSchoolInvoicesAllItems = 280,
    RoSchoolPaymentMethodAllItems = 291,
    RoSchoolStudentStatsAllItems = 409,
    RoSchoolSubscriptionAllItems = 289,
    RoStudentCourseAcsTestResultDetailAllItems = 378,
    RoStudentCourseDetailAllItems = 411,
    RoStudentCourseInstructorAllItems = 429,
    RoStudentCourseProgressMismatchAllItems = 400,
    RoStudentOverviewDetailsAllItems = 497,
    RoStudentPaymentMethodAllItems = 321,
    RoStudentSchoolCoursesAllItems = 293,
    RoUserRoleDetailAllItems = 236,
    RptInvoiceProductDetailAllItems = 328,
    RptProfitShareAllItems = 329,
    SchoolFeatureKeys = 427,
    SchoolBillingModeAllItems = 542,
    SchoolBillingPolicyPeriodAllItems = 540,
    SchoolFeatureAllItems = 408,
    StandardColorSetAllItems = 272,
    StandardLoginMediaAllItems = 480,
    StateProvideStateCodeByCountry = 451,
    StateProvinceByCountry = 322,
    StateProvinceAllItems = 222,
    StripeCheckoutSessionAllItems = 373,
    StripeCheckoutSessionProductAllItems = 372,
    StripeCheckoutSessionStatusAllItems = 371,
    StudentBySchool = 209,
    StudentBySchoolCourse = 232,
    StudentAllItems = 153,
    StudentAchievementAllItems = 529,
    StudentAchievementAwardAllItems = 526,
    StudentActivityAllItems = 499,
    StudentActivityTypeAllItems = 498,
    StudentCourseActiveByCourse = 391,
    StudentCourseAllItems = 174,
    StudentCourseLockInstructorAllItems = 428,
    StudentCourseProgressStatusAllItems = 503,
    StudentGamificationDayAllItems = 534,
    StudentGamificationSummaryAllItems = 528,
    StudentLessonProgressEventAllItems = 539,
    StudentModuleSummaryAllItems = 379,
    StudentModuleSummaryStatusAllItems = 380,
    StudentProgressResetEventAllItems = 523,
    StudentWeatherDayTransactionAllItems = 527,
    SubdomainSetupStatusAllItems = 261,
    SubdomainTypeAllItems = 260,
    SubscriptionAllItems = 265,
    SubscriptionCourseTrackingAllItems = 537,
    SubscriptionFeatureKeys = 312,
    SubscriptionFeatureAllItems = 310,
    SubscriptionRoleAllItems = 267,
    SubscriptionRoleBySubscriptionTierLookup = 313,
    SubscriptionRoleTrackingAllItems = 270,
    SubscriptionStatusAllItems = 266,
    SubscriptionTierAllItems = 263,
    SubscriptionTierBenefitAllItems = 288,
    SubscriptionTierFeatureAllItems = 311,
    SubscriptionTierFlightSchoolAllItems = 538,
    SubscriptionTierRoleAllItems = 268,
    SubscriptionTierStatusAllItems = 264,
    TemplateFieldAlignmentAllItems = 247,
    TemplateFieldTypeAllItems = 245,
    TemplateFontStyleAllItems = 246,
    ThemeAllItems = 256,
    ThemePropertyAllItems = 257,
    ThemePropertyDefinitionAllItems = 258,
    ThemePropertyTypeAllItems = 259,
    TimeZoneAllItems = 223,
    UserAllItems = 54,
    UserDetailAllItems = 234,
    UserDocumentSectionFavoriteAllItems = 502,
    UserRoleAllItems = 51,
    UserSubscriptionRoleAllItems = 269,
    UserTypeAllItems = 137,
    VectorProviderAllItems = 441,
    VectorReferenceAllItems = 440,
    VideoAllItems = 165,
    VideoHistoryAllItems = 233,
    VideoLibraryByStreamingProvider = 184,
    VideoLibraryAllItems = 167,
    VideoPlaybackAuthenticationModeAllItems = 525,
    VideoProcessingStatusAllItems = 444,
    VideosNotDeleted = 185,
    VideoStatusAllItems = 183,
    VideoStreamingProviderAllItems = 168,
    VideoTagLinkAllItems = 231,
}


// Generated Classes for MetaData service
export class AchievementDefinitionMetaData implements DwItem2<AchievementDefinitionEntity, AchievementDefinitionMetaDataAttributes,AchievementDefinitionMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=497;
        this.ItemDetail.itemName='AchievementDefinition';
        this.ItemDetail.keyName='AchievementDefinitionId';
    }

    CreateEntity(): AchievementDefinitionEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AchievementDefinitionQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AchievementDefinitionEntity, AchievementDefinitionMetaDataAttributes,AchievementDefinitionMetaDataRelations>(query, this);
    }
     Attributes = new AchievementDefinitionMetaDataAttributes();
     Relations = new AchievementDefinitionMetaDataRelations();

}


export type AchievementDefinitionQueryBuilder = DwQueryBuilderGen<AchievementDefinitionEntity, AchievementDefinitionMetaDataAttributes,AchievementDefinitionMetaDataRelations>


export class AchievementDefinitionMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AchievementDefinition';
    // Attributes
    AchievementDefinitionId = new DwItemAttribute(this.i, 'AchievementDefinitionId');
    AchievementKey = new DwItemAttribute(this.i, 'AchievementKey');
    AchievementName = new DwItemAttribute(this.i, 'AchievementName');
    AchievementDescription = new DwItemAttribute(this.i, 'AchievementDescription');
    ScopeType = new DwItemAttribute(this.i, 'ScopeType');
    IconCssClass = new DwItemAttribute(this.i, 'IconCssClass');
    DisplayOrder = new DwItemAttribute(this.i, 'DisplayOrder');
    Active = new DwItemAttribute(this.i, 'Active');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class AchievementDefinitionMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Achievement Tier */
            AchievementTier = new DwItemRelationship('AchievementDefinition|AchievementTier|AchievementDefinitionId', 'AchievementTier', 'AchievementTier');
            /** Relation: Student Achievement */
            StudentAchievement = new DwItemRelationship('AchievementDefinition|StudentAchievement|AchievementDefinitionId', 'StudentAchievement', 'StudentAchievement');
    };
export class AchievementTierMetaData implements DwItem2<AchievementTierEntity, AchievementTierMetaDataAttributes,AchievementTierMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=496;
        this.ItemDetail.itemName='AchievementTier';
        this.ItemDetail.keyName='AchievementTierId';
    }

    CreateEntity(): AchievementTierEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AchievementTierQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AchievementTierEntity, AchievementTierMetaDataAttributes,AchievementTierMetaDataRelations>(query, this);
    }
     Attributes = new AchievementTierMetaDataAttributes();
     Relations = new AchievementTierMetaDataRelations();

}


export type AchievementTierQueryBuilder = DwQueryBuilderGen<AchievementTierEntity, AchievementTierMetaDataAttributes,AchievementTierMetaDataRelations>


export class AchievementTierMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AchievementTier';
    // Attributes
    AchievementTierId = new DwItemAttribute(this.i, 'AchievementTierId');
    AchievementDefinitionId = new DwItemAttribute(this.i, 'AchievementDefinitionId');
    TierOrder = new DwItemAttribute(this.i, 'TierOrder');
    TierKey = new DwItemAttribute(this.i, 'TierKey');
    MetricTypeId = new DwItemAttribute(this.i, 'MetricTypeId');
    Threshold = new DwItemAttribute(this.i, 'Threshold');
    RequirementText = new DwItemAttribute(this.i, 'RequirementText');
    Active = new DwItemAttribute(this.i, 'Active');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class AchievementTierMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Achievement Definition */
            AchievementDefinition = new DwItemRelationship('AchievementDefinition|AchievementTier|AchievementDefinitionId', 'AchievementDefinition', 'AchievementDefinition');
            /** Relation: Metric Type */
            MetricType = new DwItemRelationship('MetricType|AchievementTier|MetricTypeId', 'MetricType', 'MetricType');
            /** Relation: Student Achievement - Current - Many */
            StudentAchievementByCurrentAchievementTierId = new DwItemRelationship('AchievementTier|StudentAchievement|CurrentAchievementTierId', 'CurrentStudentAchievement', 'CurrentStudentAchievement');
            /** Relation: Student Achievement - Next - Many */
            StudentAchievementByNextAchievementTierId = new DwItemRelationship('AchievementTier|StudentAchievement|NextAchievementTierId', 'NextStudentAchievement', 'NextStudentAchievement');
            /** Relation: Student Achievement Award */
            StudentAchievementAward = new DwItemRelationship('AchievementTier|StudentAchievementAward|AchievementTierId', 'StudentAchievementAward', 'StudentAchievementAward');
    };
export class AcquisitionSourceMetaData implements DwItem2<AcquisitionSourceEntity, AcquisitionSourceMetaDataAttributes,AcquisitionSourceMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=413;
        this.ItemDetail.itemName='AcquisitionSource';
        this.ItemDetail.keyName='AcquisitionSourceId';
    }

    CreateEntity(): AcquisitionSourceEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AcquisitionSourceQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AcquisitionSourceEntity, AcquisitionSourceMetaDataAttributes,AcquisitionSourceMetaDataRelations>(query, this);
    }
     Attributes = new AcquisitionSourceMetaDataAttributes();
     Relations = new AcquisitionSourceMetaDataRelations();

}


export type AcquisitionSourceQueryBuilder = DwQueryBuilderGen<AcquisitionSourceEntity, AcquisitionSourceMetaDataAttributes,AcquisitionSourceMetaDataRelations>


export class AcquisitionSourceMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AcquisitionSource';
    // Attributes
    AcquisitionSourceId = new DwItemAttribute(this.i, 'AcquisitionSourceId');
    AcquisitionSource = new DwItemAttribute(this.i, 'AcquisitionSource');
    Order = new DwItemAttribute(this.i, 'Order');
}

class AcquisitionSourceMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Student */
            Student = new DwItemRelationship('AcquisitionSource|Student|AcquisitionSourceId', 'Student', 'Student');
    };
export class AcsAreaOfOperationMetaData implements DwItem2<AcsAreaOfOperationEntity, AcsAreaOfOperationMetaDataAttributes,AcsAreaOfOperationMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=328;
        this.ItemDetail.itemName='AcsAreaOfOperation';
        this.ItemDetail.keyName='AcsAreaOfOperationId';
    }

    CreateEntity(): AcsAreaOfOperationEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AcsAreaOfOperationQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AcsAreaOfOperationEntity, AcsAreaOfOperationMetaDataAttributes,AcsAreaOfOperationMetaDataRelations>(query, this);
    }
     Attributes = new AcsAreaOfOperationMetaDataAttributes();
     Relations = new AcsAreaOfOperationMetaDataRelations();

}


export type AcsAreaOfOperationQueryBuilder = DwQueryBuilderGen<AcsAreaOfOperationEntity, AcsAreaOfOperationMetaDataAttributes,AcsAreaOfOperationMetaDataRelations>


export class AcsAreaOfOperationMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AcsAreaOfOperation';
    // Attributes
    AcsAreaOfOperationId = new DwItemAttribute(this.i, 'AcsAreaOfOperationId');
    AcsTestId = new DwItemAttribute(this.i, 'AcsTestId');
    AreaOfOperationName = new DwItemAttribute(this.i, 'AreaOfOperationName');
    AreaOfOperationOrder = new DwItemAttribute(this.i, 'AreaOfOperationOrder');
    AreaOfOperationCode = new DwItemAttribute(this.i, 'AreaOfOperationCode');
    AcsTestPortionId = new DwItemAttribute(this.i, 'AcsTestPortionId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class AcsAreaOfOperationMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Acs Test */
            AcsTest = new DwItemRelationship('AcsTest|AcsAreaOfOperation|AcsTestId', 'AcsTest', 'AcsTest');
            /** Relation: Acs Area Of Operation Task */
            AcsAreaOfOperationTask = new DwItemRelationship('AcsAreaOfOperation|AcsAreaOfOperationTask|AcsAreaOfOperationId', 'AcsAreaOfOperationTask', 'AcsAreaOfOperationTask');
    };
export class AcsAreaOfOperationTaskMetaData implements DwItem2<AcsAreaOfOperationTaskEntity, AcsAreaOfOperationTaskMetaDataAttributes,AcsAreaOfOperationTaskMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=327;
        this.ItemDetail.itemName='AcsAreaOfOperationTask';
        this.ItemDetail.keyName='AcsAreaOfOperationTaskId';
    }

    CreateEntity(): AcsAreaOfOperationTaskEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AcsAreaOfOperationTaskQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AcsAreaOfOperationTaskEntity, AcsAreaOfOperationTaskMetaDataAttributes,AcsAreaOfOperationTaskMetaDataRelations>(query, this);
    }
     Attributes = new AcsAreaOfOperationTaskMetaDataAttributes();
     Relations = new AcsAreaOfOperationTaskMetaDataRelations();

}


export type AcsAreaOfOperationTaskQueryBuilder = DwQueryBuilderGen<AcsAreaOfOperationTaskEntity, AcsAreaOfOperationTaskMetaDataAttributes,AcsAreaOfOperationTaskMetaDataRelations>


export class AcsAreaOfOperationTaskMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AcsAreaOfOperationTask';
    // Attributes
    AcsAreaOfOperationTaskId = new DwItemAttribute(this.i, 'AcsAreaOfOperationTaskId');
    AcsAreaOfOperationId = new DwItemAttribute(this.i, 'AcsAreaOfOperationId');
    TaskName = new DwItemAttribute(this.i, 'TaskName');
    TaskOrder = new DwItemAttribute(this.i, 'TaskOrder');
    TaskCode = new DwItemAttribute(this.i, 'TaskCode');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class AcsAreaOfOperationTaskMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Acs Area Of Operation */
            AcsAreaOfOperation = new DwItemRelationship('AcsAreaOfOperation|AcsAreaOfOperationTask|AcsAreaOfOperationId', 'AcsAreaOfOperation', 'AcsAreaOfOperation');
            /** Relation: Acs Code */
            AcsCode = new DwItemRelationship('AcsAreaOfOperationTask|AcsCode|AcsAreaOfOperationTaskId', 'AcsCode', 'AcsCode');
            /** Relation: Acs Task Multi Assign Task */
            AcsTaskMultiAssignTask = new DwItemRelationship('AcsAreaOfOperationTask|AcsTaskMultiAssignTask|AcsAreaOfOperationTaskId', 'AcsTaskMultiAssignTask', 'AcsTaskMultiAssignTask');
            /** Relation: Course Lesson Acs Task */
            CourseLessonAcsTask = new DwItemRelationship('AcsAreaOfOperationTask|CourseLessonAcsTask|AcsAreaOfOperationTaskId', 'CourseLessonAcsTask', 'CourseLessonAcsTask');
    };
export class AcsCodeMetaData implements DwItem2<AcsCodeEntity, AcsCodeMetaDataAttributes,AcsCodeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=329;
        this.ItemDetail.itemName='AcsCode';
        this.ItemDetail.keyName='AcsCodeId';
    }

    CreateEntity(): AcsCodeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AcsCodeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AcsCodeEntity, AcsCodeMetaDataAttributes,AcsCodeMetaDataRelations>(query, this);
    }
     Attributes = new AcsCodeMetaDataAttributes();
     Relations = new AcsCodeMetaDataRelations();

}


export type AcsCodeQueryBuilder = DwQueryBuilderGen<AcsCodeEntity, AcsCodeMetaDataAttributes,AcsCodeMetaDataRelations>


export class AcsCodeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AcsCode';
    // Attributes
    AcsCodeId = new DwItemAttribute(this.i, 'AcsCodeId');
    AcsAreaOfOperationTaskId = new DwItemAttribute(this.i, 'AcsAreaOfOperationTaskId');
    AscCodeTypeId = new DwItemAttribute(this.i, 'AscCodeTypeId');
    AcsCode = new DwItemAttribute(this.i, 'AcsCode');
    AscCodeDescription = new DwItemAttribute(this.i, 'AscCodeDescription');
    AcsCodeOrder = new DwItemAttribute(this.i, 'AcsCodeOrder');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class AcsCodeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Acs Area Of Operation Task */
            AcsAreaOfOperationTask = new DwItemRelationship('AcsAreaOfOperationTask|AcsCode|AcsAreaOfOperationTaskId', 'AcsAreaOfOperationTask', 'AcsAreaOfOperationTask');
            /** Relation: Acs Code Type - Asc Code Type */
            AcsCodeTypeByAscCodeTypeId = new DwItemRelationship('AcsCodeType|AcsCode|AscCodeTypeId', 'AscCodeTypeIdAcsCodeType', 'AscCodeTypeIdAcsCodeType');
            /** Relation: Acs Written Result Missed Code */
            AcsWrittenResultMissedCode = new DwItemRelationship('AcsCode|AcsWrittenResultMissedCode|AcsCodeId', 'AcsWrittenResultMissedCode', 'AcsWrittenResultMissedCode');
    };
export class AcsCodeTypeMetaData implements DwItem2<AcsCodeTypeEntity, AcsCodeTypeMetaDataAttributes,AcsCodeTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=330;
        this.ItemDetail.itemName='AcsCodeType';
        this.ItemDetail.keyName='AcsCodeTypeId';
    }

    CreateEntity(): AcsCodeTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AcsCodeTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AcsCodeTypeEntity, AcsCodeTypeMetaDataAttributes,AcsCodeTypeMetaDataRelations>(query, this);
    }
     Attributes = new AcsCodeTypeMetaDataAttributes();
     Relations = new AcsCodeTypeMetaDataRelations();

}


export type AcsCodeTypeQueryBuilder = DwQueryBuilderGen<AcsCodeTypeEntity, AcsCodeTypeMetaDataAttributes,AcsCodeTypeMetaDataRelations>


export class AcsCodeTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AcsCodeType';
    // Attributes
    AcsCodeTypeId = new DwItemAttribute(this.i, 'AcsCodeTypeId');
    AcsCodeTypeName = new DwItemAttribute(this.i, 'AcsCodeTypeName');
    AcsCodeTypeShortName = new DwItemAttribute(this.i, 'AcsCodeTypeShortName');
}

class AcsCodeTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Acs Code - Asc Code Type - Many */
            AcsCodeByAscCodeTypeId = new DwItemRelationship('AcsCodeType|AcsCode|AscCodeTypeId', 'AscCodeTypeIdAcsCode', 'AscCodeTypeIdAcsCode');
    };
export class AcsTaskMultiAssignMetaData implements DwItem2<AcsTaskMultiAssignEntity, AcsTaskMultiAssignMetaDataAttributes,AcsTaskMultiAssignMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=348;
        this.ItemDetail.itemName='AcsTaskMultiAssign';
        this.ItemDetail.keyName='AcsTaskMultiAssignId';
    }

    CreateEntity(): AcsTaskMultiAssignEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AcsTaskMultiAssignQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AcsTaskMultiAssignEntity, AcsTaskMultiAssignMetaDataAttributes,AcsTaskMultiAssignMetaDataRelations>(query, this);
    }
     Attributes = new AcsTaskMultiAssignMetaDataAttributes();
     Relations = new AcsTaskMultiAssignMetaDataRelations();

}


export type AcsTaskMultiAssignQueryBuilder = DwQueryBuilderGen<AcsTaskMultiAssignEntity, AcsTaskMultiAssignMetaDataAttributes,AcsTaskMultiAssignMetaDataRelations>


export class AcsTaskMultiAssignMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AcsTaskMultiAssign';
    // Attributes
    AcsTaskMultiAssignId = new DwItemAttribute(this.i, 'AcsTaskMultiAssignId');
    CourseId = new DwItemAttribute(this.i, 'CourseId');
    ReplaceExistingTasks = new DwItemAttribute(this.i, 'ReplaceExistingTasks');
}

class AcsTaskMultiAssignMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Course */
            Course = new DwItemRelationship('Course|AcsTaskMultiAssign|CourseId', 'Course', 'Course');
            /** Relation: Acs Task Multi Assign Lesson - Acs Task Multi Assigsn - Many */
            AcsTaskMultiAssignLessonByAcsTaskMultiAssigsnId = new DwItemRelationship('AcsTaskMultiAssign|AcsTaskMultiAssignLesson|AcsTaskMultiAssigsnId', 'AcsTaskMultiAssigsnIdAcsTaskMultiAssignLesson', 'AcsTaskMultiAssigsnIdAcsTaskMultiAssignLesson');
            /** Relation: Acs Task Multi Assign Task */
            AcsTaskMultiAssignTask = new DwItemRelationship('AcsTaskMultiAssign|AcsTaskMultiAssignTask|AcsTaskMultiAssignId', 'AcsTaskMultiAssignTask', 'AcsTaskMultiAssignTask');
    };
export class AcsTaskMultiAssignLessonMetaData implements DwItem2<AcsTaskMultiAssignLessonEntity, AcsTaskMultiAssignLessonMetaDataAttributes,AcsTaskMultiAssignLessonMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=346;
        this.ItemDetail.itemName='AcsTaskMultiAssignLesson';
        this.ItemDetail.keyName='AcsTaskMultiAssignLessonId';
    }

    CreateEntity(): AcsTaskMultiAssignLessonEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AcsTaskMultiAssignLessonQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AcsTaskMultiAssignLessonEntity, AcsTaskMultiAssignLessonMetaDataAttributes,AcsTaskMultiAssignLessonMetaDataRelations>(query, this);
    }
     Attributes = new AcsTaskMultiAssignLessonMetaDataAttributes();
     Relations = new AcsTaskMultiAssignLessonMetaDataRelations();

}


export type AcsTaskMultiAssignLessonQueryBuilder = DwQueryBuilderGen<AcsTaskMultiAssignLessonEntity, AcsTaskMultiAssignLessonMetaDataAttributes,AcsTaskMultiAssignLessonMetaDataRelations>


export class AcsTaskMultiAssignLessonMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AcsTaskMultiAssignLesson';
    // Attributes
    AcsTaskMultiAssignLessonId = new DwItemAttribute(this.i, 'AcsTaskMultiAssignLessonId');
    AcsTaskMultiAssigsnId = new DwItemAttribute(this.i, 'AcsTaskMultiAssigsnId');
    CourseLessonId = new DwItemAttribute(this.i, 'CourseLessonId');
}

class AcsTaskMultiAssignLessonMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Acs Task Multi Assign - Acs Task Multi Assigsn */
            AcsTaskMultiAssignByAcsTaskMultiAssigsnId = new DwItemRelationship('AcsTaskMultiAssign|AcsTaskMultiAssignLesson|AcsTaskMultiAssigsnId', 'AcsTaskMultiAssigsnIdAcsTaskMultiAssign', 'AcsTaskMultiAssigsnIdAcsTaskMultiAssign');
            /** Relation: Lesson */
            CourseLesson = new DwItemRelationship('CourseLesson|AcsTaskMultiAssignLesson|CourseLessonId', 'CourseLesson', 'CourseLesson');
    };
export class AcsTaskMultiAssignTaskMetaData implements DwItem2<AcsTaskMultiAssignTaskEntity, AcsTaskMultiAssignTaskMetaDataAttributes,AcsTaskMultiAssignTaskMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=347;
        this.ItemDetail.itemName='AcsTaskMultiAssignTask';
        this.ItemDetail.keyName='AcsTaskMultiAssignTaskId';
    }

    CreateEntity(): AcsTaskMultiAssignTaskEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AcsTaskMultiAssignTaskQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AcsTaskMultiAssignTaskEntity, AcsTaskMultiAssignTaskMetaDataAttributes,AcsTaskMultiAssignTaskMetaDataRelations>(query, this);
    }
     Attributes = new AcsTaskMultiAssignTaskMetaDataAttributes();
     Relations = new AcsTaskMultiAssignTaskMetaDataRelations();

}


export type AcsTaskMultiAssignTaskQueryBuilder = DwQueryBuilderGen<AcsTaskMultiAssignTaskEntity, AcsTaskMultiAssignTaskMetaDataAttributes,AcsTaskMultiAssignTaskMetaDataRelations>


export class AcsTaskMultiAssignTaskMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AcsTaskMultiAssignTask';
    // Attributes
    AcsTaskMultiAssignTaskId = new DwItemAttribute(this.i, 'AcsTaskMultiAssignTaskId');
    AcsTaskMultiAssignId = new DwItemAttribute(this.i, 'AcsTaskMultiAssignId');
    AcsAreaOfOperationTaskId = new DwItemAttribute(this.i, 'AcsAreaOfOperationTaskId');
}

class AcsTaskMultiAssignTaskMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Acs Area Of Operation Task */
            AcsAreaOfOperationTask = new DwItemRelationship('AcsAreaOfOperationTask|AcsTaskMultiAssignTask|AcsAreaOfOperationTaskId', 'AcsAreaOfOperationTask', 'AcsAreaOfOperationTask');
            /** Relation: Acs Task Multi Assign */
            AcsTaskMultiAssign = new DwItemRelationship('AcsTaskMultiAssign|AcsTaskMultiAssignTask|AcsTaskMultiAssignId', 'AcsTaskMultiAssign', 'AcsTaskMultiAssign');
    };
export class AcsTestMetaData implements DwItem2<AcsTestEntity, AcsTestMetaDataAttributes,AcsTestMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=332;
        this.ItemDetail.itemName='AcsTest';
        this.ItemDetail.keyName='AcsTestId';
    }

    CreateEntity(): AcsTestEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AcsTestQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AcsTestEntity, AcsTestMetaDataAttributes,AcsTestMetaDataRelations>(query, this);
    }
     Attributes = new AcsTestMetaDataAttributes();
     Relations = new AcsTestMetaDataRelations();

}


export type AcsTestQueryBuilder = DwQueryBuilderGen<AcsTestEntity, AcsTestMetaDataAttributes,AcsTestMetaDataRelations>


export class AcsTestMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AcsTest';
    // Attributes
    AcsTestId = new DwItemAttribute(this.i, 'AcsTestId');
    TestName = new DwItemAttribute(this.i, 'TestName');
    TestDescription = new DwItemAttribute(this.i, 'TestDescription');
    CheckRideGroupId = new DwItemAttribute(this.i, 'CheckRideGroupId');
    TestCode = new DwItemAttribute(this.i, 'TestCode');
    TestExpirationDate = new DwItemAttribute(this.i, 'TestExpirationDate');
    AcsTestStatusId = new DwItemAttribute(this.i, 'AcsTestStatusId');
    AcsTestPdfMediaId = new DwItemAttribute(this.i, 'AcsTestPdfMediaId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    ACSTestOfficialName = new DwItemAttribute(this.i, 'ACSTestOfficialName');
}

class AcsTestMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Acs Test Status */
            AcsTestStatus = new DwItemRelationship('AcsTestStatus|AcsTest|AcsTestStatusId', 'AcsTestStatus', 'AcsTestStatus');
            /** Relation: Acs Area Of Operation */
            AcsAreaOfOperation = new DwItemRelationship('AcsTest|AcsAreaOfOperation|AcsTestId', 'AcsAreaOfOperation', 'AcsAreaOfOperation');
            /** Relation: Acs Written Result */
            AcsWrittenResult = new DwItemRelationship('AcsTest|AcsWrittenResult|AcsTestId', 'AcsWrittenResult', 'AcsWrittenResult');
            /** Relation: Course */
            Course = new DwItemRelationship('AcsTest|Course|AcsTestId', 'Course', 'Course');
    };
export class AcsTestStatusMetaData implements DwItem2<AcsTestStatusEntity, AcsTestStatusMetaDataAttributes,AcsTestStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=331;
        this.ItemDetail.itemName='AcsTestStatus';
        this.ItemDetail.keyName='AcsTestStatusId';
    }

    CreateEntity(): AcsTestStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AcsTestStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AcsTestStatusEntity, AcsTestStatusMetaDataAttributes,AcsTestStatusMetaDataRelations>(query, this);
    }
     Attributes = new AcsTestStatusMetaDataAttributes();
     Relations = new AcsTestStatusMetaDataRelations();

}


export type AcsTestStatusQueryBuilder = DwQueryBuilderGen<AcsTestStatusEntity, AcsTestStatusMetaDataAttributes,AcsTestStatusMetaDataRelations>


export class AcsTestStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AcsTestStatus';
    // Attributes
    AcsTestStatusId = new DwItemAttribute(this.i, 'AcsTestStatusId');
    AcsTestStatus = new DwItemAttribute(this.i, 'AcsTestStatus');
}

class AcsTestStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Acs Test */
            AcsTest = new DwItemRelationship('AcsTestStatus|AcsTest|AcsTestStatusId', 'AcsTest', 'AcsTest');
    };
export class AcsWrittenResultMetaData implements DwItem2<AcsWrittenResultEntity, AcsWrittenResultMetaDataAttributes,AcsWrittenResultMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=325;
        this.ItemDetail.itemName='AcsWrittenResult';
        this.ItemDetail.keyName='AcsWrittenResultId';
    }

    CreateEntity(): AcsWrittenResultEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AcsWrittenResultQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AcsWrittenResultEntity, AcsWrittenResultMetaDataAttributes,AcsWrittenResultMetaDataRelations>(query, this);
    }
     Attributes = new AcsWrittenResultMetaDataAttributes();
     Relations = new AcsWrittenResultMetaDataRelations();

}


export type AcsWrittenResultQueryBuilder = DwQueryBuilderGen<AcsWrittenResultEntity, AcsWrittenResultMetaDataAttributes,AcsWrittenResultMetaDataRelations>


export class AcsWrittenResultMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AcsWrittenResult';
    // Attributes
    AcsWrittenResultId = new DwItemAttribute(this.i, 'AcsWrittenResultId');
    TestResultMediaId = new DwItemAttribute(this.i, 'TestResultMediaId');
    StudentName = new DwItemAttribute(this.i, 'StudentName');
    FaaTrackingNumber = new DwItemAttribute(this.i, 'FaaTrackingNumber');
    ExamName = new DwItemAttribute(this.i, 'ExamName');
    ExamDate = new DwItemAttribute(this.i, 'ExamDate');
    Score = new DwItemAttribute(this.i, 'Score');
    Grade = new DwItemAttribute(this.i, 'Grade');
    ExpirationDate = new DwItemAttribute(this.i, 'ExpirationDate');
    ExamIdCode = new DwItemAttribute(this.i, 'ExamIdCode');
    ExamSiteIdCode = new DwItemAttribute(this.i, 'ExamSiteIdCode');
    Passed = new DwItemAttribute(this.i, 'Passed');
    Take = new DwItemAttribute(this.i, 'Take');
    AcsTestId = new DwItemAttribute(this.i, 'AcsTestId');
    AcsWrittenTestStatusId = new DwItemAttribute(this.i, 'AcsWrittenTestStatusId');
    StudentCourseId = new DwItemAttribute(this.i, 'StudentCourseId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    LastLogId = new DwItemAttribute(this.i, 'LastLogId');
    AssignmentId = new DwItemAttribute(this.i, 'AssignmentId');
}

class AcsWrittenResultMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Acs Test */
            AcsTest = new DwItemRelationship('AcsTest|AcsWrittenResult|AcsTestId', 'AcsTest', 'AcsTest');
            /** Relation: Acs Written Test Status */
            AcsWrittenTestStatus = new DwItemRelationship('AcsWrittenTestStatus|AcsWrittenResult|AcsWrittenTestStatusId', 'AcsWrittenTestStatus', 'AcsWrittenTestStatus');
            /** Relation: Student Course */
            StudentCourse = new DwItemRelationship('StudentCourse|AcsWrittenResult|StudentCourseId', 'StudentCourse', 'StudentCourse');
            /** Relation: Acs Written Result Missed Code */
            AcsWrittenResultMissedCode = new DwItemRelationship('AcsWrittenResult|AcsWrittenResultMissedCode|AcsWrittenResultId', 'AcsWrittenResultMissedCode', 'AcsWrittenResultMissedCode');
            /** Relation: Ro Acs Written Missed Code Stats */
            RoAcsWrittenMissedCodeStats = new DwItemRelationship('AcsWrittenResult_RoAcsWrittenMissedCodeStats_AcsWrittenResultId', 'RoAcsWrittenMissedCodeStats', 'RoAcsWrittenMissedCodeStats');
    };
export class AcsWrittenResultMissedCodeMetaData implements DwItem2<AcsWrittenResultMissedCodeEntity, AcsWrittenResultMissedCodeMetaDataAttributes,AcsWrittenResultMissedCodeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=326;
        this.ItemDetail.itemName='AcsWrittenResultMissedCode';
        this.ItemDetail.keyName='AcsWrittenResultMissedCode';
    }

    CreateEntity(): AcsWrittenResultMissedCodeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AcsWrittenResultMissedCodeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AcsWrittenResultMissedCodeEntity, AcsWrittenResultMissedCodeMetaDataAttributes,AcsWrittenResultMissedCodeMetaDataRelations>(query, this);
    }
     Attributes = new AcsWrittenResultMissedCodeMetaDataAttributes();
     Relations = new AcsWrittenResultMissedCodeMetaDataRelations();

}


export type AcsWrittenResultMissedCodeQueryBuilder = DwQueryBuilderGen<AcsWrittenResultMissedCodeEntity, AcsWrittenResultMissedCodeMetaDataAttributes,AcsWrittenResultMissedCodeMetaDataRelations>


export class AcsWrittenResultMissedCodeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AcsWrittenResultMissedCode';
    // Attributes
    AcsWrittenResultMissedCode = new DwItemAttribute(this.i, 'AcsWrittenResultMissedCode');
    AcsWrittenResultId = new DwItemAttribute(this.i, 'AcsWrittenResultId');
    MissedCode = new DwItemAttribute(this.i, 'MissedCode');
    AcsCodeId = new DwItemAttribute(this.i, 'AcsCodeId');
}

class AcsWrittenResultMissedCodeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Acs Code */
            AcsCode = new DwItemRelationship('AcsCode|AcsWrittenResultMissedCode|AcsCodeId', 'AcsCode', 'AcsCode');
            /** Relation: Acs Written Result */
            AcsWrittenResult = new DwItemRelationship('AcsWrittenResult|AcsWrittenResultMissedCode|AcsWrittenResultId', 'AcsWrittenResult', 'AcsWrittenResult');
    };
export class AcsWrittenTestStatusMetaData implements DwItem2<AcsWrittenTestStatusEntity, AcsWrittenTestStatusMetaDataAttributes,AcsWrittenTestStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=334;
        this.ItemDetail.itemName='AcsWrittenTestStatus';
        this.ItemDetail.keyName='AcsWrittenTestStatusId';
    }

    CreateEntity(): AcsWrittenTestStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AcsWrittenTestStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AcsWrittenTestStatusEntity, AcsWrittenTestStatusMetaDataAttributes,AcsWrittenTestStatusMetaDataRelations>(query, this);
    }
     Attributes = new AcsWrittenTestStatusMetaDataAttributes();
     Relations = new AcsWrittenTestStatusMetaDataRelations();

}


export type AcsWrittenTestStatusQueryBuilder = DwQueryBuilderGen<AcsWrittenTestStatusEntity, AcsWrittenTestStatusMetaDataAttributes,AcsWrittenTestStatusMetaDataRelations>


export class AcsWrittenTestStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AcsWrittenTestStatus';
    // Attributes
    AcsWrittenTestStatusId = new DwItemAttribute(this.i, 'AcsWrittenTestStatusId');
    AcsWrittenTestStatus = new DwItemAttribute(this.i, 'AcsWrittenTestStatus');
}

class AcsWrittenTestStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Acs Written Result */
            AcsWrittenResult = new DwItemRelationship('AcsWrittenTestStatus|AcsWrittenResult|AcsWrittenTestStatusId', 'AcsWrittenResult', 'AcsWrittenResult');
    };
export class AddressMetaData implements DwItem2<AddressEntity, AddressMetaDataAttributes,AddressMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=205;
        this.ItemDetail.itemName='Address';
        this.ItemDetail.keyName='AddressId';
    }

    CreateEntity(): AddressEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AddressQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AddressEntity, AddressMetaDataAttributes,AddressMetaDataRelations>(query, this);
    }
     Attributes = new AddressMetaDataAttributes();
     Relations = new AddressMetaDataRelations();

}


export type AddressQueryBuilder = DwQueryBuilderGen<AddressEntity, AddressMetaDataAttributes,AddressMetaDataRelations>


export class AddressMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Address';
    // Attributes
    AddressId = new DwItemAttribute(this.i, 'AddressId');
    StreetAddress1 = new DwItemAttribute(this.i, 'StreetAddress1');
    StreetAddress2 = new DwItemAttribute(this.i, 'StreetAddress2');
    City = new DwItemAttribute(this.i, 'City');
    StateProvinceId = new DwItemAttribute(this.i, 'StateProvinceId');
    CountryId = new DwItemAttribute(this.i, 'CountryId');
    CountyName = new DwItemAttribute(this.i, 'CountyName');
    PostalCode = new DwItemAttribute(this.i, 'PostalCode');
    PostalCodePlus4 = new DwItemAttribute(this.i, 'PostalCodePlus4');
    Phone = new DwItemAttribute(this.i, 'Phone');
    Fax = new DwItemAttribute(this.i, 'Fax');
    Latitude = new DwItemAttribute(this.i, 'Latitude');
    Longitude = new DwItemAttribute(this.i, 'Longitude');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    TimezoneId = new DwItemAttribute(this.i, 'TimezoneId');
    ObservesDst = new DwItemAttribute(this.i, 'ObservesDst');
}

class AddressMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Country */
            Country = new DwItemRelationship('Country|Address|CountryId', 'Country', 'Country');
            /** Relation: State Province */
            StateProvince = new DwItemRelationship('StateProvince|Address|StateProvinceId', 'StateProvince', 'StateProvince');
            /** Relation: Time Zone */
            TimeZone = new DwItemRelationship('TimeZone|Address|TimezoneId', 'TimeZone', 'TimeZone');
            /** Relation: Airport - Airport - Many */
            AirportByAirportAddressId = new DwItemRelationship('Address|Airport|AirportAddressId', 'AirportAirport', 'AirportAirport');
            /** Relation: Flight School - Billing - Many */
            FlightSchoolByBillingAddressId = new DwItemRelationship('Address|FlightSchool|BillingAddressId', 'BillingFlightSchool', 'BillingFlightSchool');
            /** Relation: Stripe Checkout Session - Customer - Many */
            StripeCheckoutSessionByCustomerAddressId = new DwItemRelationship('Address|StripeCheckoutSession|CustomerAddressId', 'CustomerStripeCheckoutSession', 'CustomerStripeCheckoutSession');
            /** Relation: Student */
            Student = new DwItemRelationship('Address|Student|AddressId', 'Student', 'Student');
    };
export class AiProcessConfigMetaData implements DwItem2<AiProcessConfigEntity, AiProcessConfigMetaDataAttributes,AiProcessConfigMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=364;
        this.ItemDetail.itemName='AiProcessConfig';
        this.ItemDetail.keyName='AiProcessConfigId';
    }

    CreateEntity(): AiProcessConfigEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AiProcessConfigQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AiProcessConfigEntity, AiProcessConfigMetaDataAttributes,AiProcessConfigMetaDataRelations>(query, this);
    }
     Attributes = new AiProcessConfigMetaDataAttributes();
     Relations = new AiProcessConfigMetaDataRelations();

}


export type AiProcessConfigQueryBuilder = DwQueryBuilderGen<AiProcessConfigEntity, AiProcessConfigMetaDataAttributes,AiProcessConfigMetaDataRelations>


export class AiProcessConfigMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AiProcessConfig';
    // Attributes
    AiProcessConfigId = new DwItemAttribute(this.i, 'AiProcessConfigId');
    ProcessName = new DwItemAttribute(this.i, 'ProcessName');
    AiPromptSetupId = new DwItemAttribute(this.i, 'AiPromptSetupId');
    IsEnabled = new DwItemAttribute(this.i, 'IsEnabled');
    LimitConfigJSON = new DwItemAttribute(this.i, 'LimitConfigJSON');
    LimitValue1 = new DwItemAttribute(this.i, 'LimitValue1');
    LimitValue2 = new DwItemAttribute(this.i, 'LimitValue2');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class AiProcessConfigMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: AI Prompt Setup - A I Prompt Setup */
            AIPromptSetupByAiPromptSetupId = new DwItemRelationship('AIPromptSetup|AiProcessConfig|AiPromptSetupId', 'AiPromptSetupIdAIPromptSetup', 'AiPromptSetupIdAIPromptSetup');
    };
export class AIProcessingReferenceMetaData implements DwItem2<AIProcessingReferenceEntity, AIProcessingReferenceMetaDataAttributes,AIProcessingReferenceMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=398;
        this.ItemDetail.itemName='AIProcessingReference';
        this.ItemDetail.keyName='AIProcessingReferenceId';
    }

    CreateEntity(): AIProcessingReferenceEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AIProcessingReferenceQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AIProcessingReferenceEntity, AIProcessingReferenceMetaDataAttributes,AIProcessingReferenceMetaDataRelations>(query, this);
    }
     Attributes = new AIProcessingReferenceMetaDataAttributes();
     Relations = new AIProcessingReferenceMetaDataRelations();

}


export type AIProcessingReferenceQueryBuilder = DwQueryBuilderGen<AIProcessingReferenceEntity, AIProcessingReferenceMetaDataAttributes,AIProcessingReferenceMetaDataRelations>


export class AIProcessingReferenceMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AIProcessingReference';
    // Attributes
    AIProcessingReferenceId = new DwItemAttribute(this.i, 'AIProcessingReferenceId');
    MetaDataItemId = new DwItemAttribute(this.i, 'MetaDataItemId');
    KeyValue = new DwItemAttribute(this.i, 'KeyValue');
    AIProcessingStatusId = new DwItemAttribute(this.i, 'AIProcessingStatusId');
    LastAIPromptRequestId = new DwItemAttribute(this.i, 'LastAIPromptRequestId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    ProcessingGroupKey = new DwItemAttribute(this.i, 'ProcessingGroupKey');
    ProcessingOrder = new DwItemAttribute(this.i, 'ProcessingOrder');
}

class AIProcessingReferenceMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: AI Processing Reference Status - AI Processing Status */
            AIProcessingReferenceStatusByAIProcessingStatusId = new DwItemRelationship('AIProcessingReferenceStatus|AIProcessingReference|AIProcessingStatusId', 'AIProcessingStatusIdAIProcessingReferenceStatus', 'AIProcessingStatusIdAIProcessingReferenceStatus');
            /** Relation: AI Prompt Request - Last AI Prompt Request */
            AIPromptRequestByLastAIPromptRequestId = new DwItemRelationship('AIPromptRequest|AIProcessingReference|LastAIPromptRequestId', 'LastAIPromptRequest', 'LastAIPromptRequest');
            /** Relation: Meta Data Item */
            DwMetaDataItem = new DwItemRelationship('dw_MetaDataItem|AIProcessingReference|MetaDataItemId', 'DwMetaDataItem', 'DwMetaDataItem');
            /** Relation: Course Document Item */
            CourseDocumentItem = new DwItemRelationship('AIProcessingReference|CourseDocumentItem|AIProcessingReferenceId', 'CourseDocumentItem', 'CourseDocumentItem');
            /** Relation: Lesson */
            CourseLesson = new DwItemRelationship('AIProcessingReference|CourseLesson|AIProcessingReferenceId', 'CourseLesson', 'CourseLesson');
            /** Relation: Module */
            CourseModule = new DwItemRelationship('AIProcessingReference|CourseModule|AIProcessingReferenceId', 'CourseModule', 'CourseModule');
            /** Relation: Course Module Document Item - AI Processing Reference Id - Many */
            CourseModuleDocumentItemByAiProcessingReferenceId = new DwItemRelationship('AIProcessingReference|CourseModuleDocumentItem|AiProcessingReferenceId', 'AiProcessingReferenceIdCourseModuleDocumentItem', 'AiProcessingReferenceIdCourseModuleDocumentItem');
            /** Relation: Document Item Chunk */
            DocumentItemChunk = new DwItemRelationship('AIProcessingReference|DocumentItemChunk|AiProcessingReferenceId', 'DocumentItemChunk', 'DocumentItemChunk');
            /** Relation: Document Link Processing Run Item */
            DocumentLinkProcessingRunItem = new DwItemRelationship('AIProcessingReference|DocumentLinkProcessingRunItem|AIProcessingReferenceId', 'DocumentLinkProcessingRunItem', 'DocumentLinkProcessingRunItem');
    };
export class AIProcessingReferenceStatusMetaData implements DwItem2<AIProcessingReferenceStatusEntity, AIProcessingReferenceStatusMetaDataAttributes,AIProcessingReferenceStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=399;
        this.ItemDetail.itemName='AIProcessingReferenceStatus';
        this.ItemDetail.keyName='AIProcessingReferenceStatusId';
    }

    CreateEntity(): AIProcessingReferenceStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AIProcessingReferenceStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AIProcessingReferenceStatusEntity, AIProcessingReferenceStatusMetaDataAttributes,AIProcessingReferenceStatusMetaDataRelations>(query, this);
    }
     Attributes = new AIProcessingReferenceStatusMetaDataAttributes();
     Relations = new AIProcessingReferenceStatusMetaDataRelations();

}


export type AIProcessingReferenceStatusQueryBuilder = DwQueryBuilderGen<AIProcessingReferenceStatusEntity, AIProcessingReferenceStatusMetaDataAttributes,AIProcessingReferenceStatusMetaDataRelations>


export class AIProcessingReferenceStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AIProcessingReferenceStatus';
    // Attributes
    AIProcessingReferenceStatusId = new DwItemAttribute(this.i, 'AIProcessingReferenceStatusId');
    AIProcessingReferenceStatus = new DwItemAttribute(this.i, 'AIProcessingReferenceStatus');
}

class AIProcessingReferenceStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: AI Processing Reference - AI Processing Reference Status Id - Many */
            AIProcessingReferenceByAIProcessingStatusId = new DwItemRelationship('AIProcessingReferenceStatus|AIProcessingReference|AIProcessingStatusId', 'AIProcessingStatusIdAIProcessingReference', 'AIProcessingStatusIdAIProcessingReference');
    };
export class AIPromptModelMetaData implements DwItem2<AIPromptModelEntity, AIPromptModelMetaDataAttributes,AIPromptModelMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=359;
        this.ItemDetail.itemName='AIPromptModel';
        this.ItemDetail.keyName='AIPromptModelId';
    }

    CreateEntity(): AIPromptModelEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AIPromptModelQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AIPromptModelEntity, AIPromptModelMetaDataAttributes,AIPromptModelMetaDataRelations>(query, this);
    }
     Attributes = new AIPromptModelMetaDataAttributes();
     Relations = new AIPromptModelMetaDataRelations();

}


export type AIPromptModelQueryBuilder = DwQueryBuilderGen<AIPromptModelEntity, AIPromptModelMetaDataAttributes,AIPromptModelMetaDataRelations>


export class AIPromptModelMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AIPromptModel';
    // Attributes
    AIPromptModelId = new DwItemAttribute(this.i, 'AIPromptModelId');
    AIPromptModel = new DwItemAttribute(this.i, 'AIPromptModel');
    ModelCode = new DwItemAttribute(this.i, 'ModelCode');
    InputTokenCostPerMil = new DwItemAttribute(this.i, 'InputTokenCostPerMil');
    InputCachedTokenCostPerMil = new DwItemAttribute(this.i, 'InputCachedTokenCostPerMil');
    OutputTokenCostPerMil = new DwItemAttribute(this.i, 'OutputTokenCostPerMil');
}

class AIPromptModelMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: AI Prompt Setup */
            AIPromptSetup = new DwItemRelationship('AIPromptModel|AIPromptSetup|AIPromptModelId', 'AIPromptSetup', 'AIPromptSetup');
    };
export class AIPromptRequestMetaData implements DwItem2<AIPromptRequestEntity, AIPromptRequestMetaDataAttributes,AIPromptRequestMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=353;
        this.ItemDetail.itemName='AIPromptRequest';
        this.ItemDetail.keyName='AIPromptRequestId';
    }

    CreateEntity(): AIPromptRequestEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AIPromptRequestQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AIPromptRequestEntity, AIPromptRequestMetaDataAttributes,AIPromptRequestMetaDataRelations>(query, this);
    }
     Attributes = new AIPromptRequestMetaDataAttributes();
     Relations = new AIPromptRequestMetaDataRelations();

}


export type AIPromptRequestQueryBuilder = DwQueryBuilderGen<AIPromptRequestEntity, AIPromptRequestMetaDataAttributes,AIPromptRequestMetaDataRelations>


export class AIPromptRequestMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AIPromptRequest';
    // Attributes
    AIPromptRequestId = new DwItemAttribute(this.i, 'AIPromptRequestId');
    Result = new DwItemAttribute(this.i, 'Result');
    CourseId = new DwItemAttribute(this.i, 'CourseId');
    CourseModuleId = new DwItemAttribute(this.i, 'CourseModuleId');
    CourseLessonId = new DwItemAttribute(this.i, 'CourseLessonId');
    IncludeCourseData = new DwItemAttribute(this.i, 'IncludeCourseData');
    IncludeStudentProgressData = new DwItemAttribute(this.i, 'IncludeStudentProgressData');
    IncludeQuizMissedQuestionData = new DwItemAttribute(this.i, 'IncludeQuizMissedQuestionData');
    SystemPromptAcutal = new DwItemAttribute(this.i, 'SystemPromptAcutal');
    UserPromptActual = new DwItemAttribute(this.i, 'UserPromptActual');
    AIPromptSetupId = new DwItemAttribute(this.i, 'AIPromptSetupId');
    AIPromptRequestStatusId = new DwItemAttribute(this.i, 'AIPromptRequestStatusId');
    InputTokens = new DwItemAttribute(this.i, 'InputTokens');
    InputCachedTokens = new DwItemAttribute(this.i, 'InputCachedTokens');
    OutputTokens = new DwItemAttribute(this.i, 'OutputTokens');
    TotalCost = new DwItemAttribute(this.i, 'TotalCost');
    StudentCoursetId = new DwItemAttribute(this.i, 'StudentCoursetId');
    UsePromptTokens = new DwItemAttribute(this.i, 'UsePromptTokens');
    ProcessingTimeSeconds = new DwItemAttribute(this.i, 'ProcessingTimeSeconds');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    LastLogId = new DwItemAttribute(this.i, 'LastLogId');
    AssignmentStudentId = new DwItemAttribute(this.i, 'AssignmentStudentId');
}

class AIPromptRequestMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: AI Prompt Request Status */
            AIPromptRequestStatus = new DwItemRelationship('AIPromptRequestStatus|AIPromptRequest|AIPromptRequestStatusId', 'AIPromptRequestStatus', 'AIPromptRequestStatus');
            /** Relation: AI Prompt Setup */
            AIPromptSetup = new DwItemRelationship('AIPromptSetup|AiPromptRequest|AiPromptSetupId', 'AIPromptSetup', 'AIPromptSetup');
            /** Relation: Assignment Student */
            AssignmentStudent = new DwItemRelationship('AssignmentStudent|AIPromptRequest|AssignmentStudentId', 'AssignmentStudent', 'AssignmentStudent');
            /** Relation: Course */
            Course = new DwItemRelationship('Course|AIPromptRequest|CourseId', 'Course', 'Course');
            /** Relation: Lesson */
            CourseLesson = new DwItemRelationship('CourseLesson|AIPromptRequest|CourseLessonId', 'CourseLesson', 'CourseLesson');
            /** Relation: Module */
            CourseModule = new DwItemRelationship('CourseModule|AIPromptRequest|CourseModuleId', 'CourseModule', 'CourseModule');
            /** Relation: Student Course - Student Courset */
            StudentCourseByStudentCoursetId = new DwItemRelationship('StudentCourse|AIPromptRequest|StudenCoursetId', 'StudentCoursetIdStudentCourse', 'StudentCoursetIdStudentCourse');
            /** Relation: AI Processing Reference - Prompt Request Id - Many */
            AIProcessingReferenceByLastAIPromptRequestId = new DwItemRelationship('AIPromptRequest|AIProcessingReference|LastAIPromptRequestId', 'LastAIProcessingReference', 'LastAIProcessingReference');
            /** Relation: Assignment Student - Prompt Request Id - Many */
            AssignmentStudentByAiPromptRequestId = new DwItemRelationship('AIPromptRequest|AssignmentStudent|AiPromptRequestId', 'AiPromptRequestIdAssignmentStudent', 'AiPromptRequestIdAssignmentStudent');
            /** Relation: Course Module Progress */
            CourseModuleProgress = new DwItemRelationship('AIPromptRequest|CourseModuleProgress|AIPromptRequestId', 'CourseModuleProgress', 'CourseModuleProgress');
    };
export class AIPromptRequestStatusMetaData implements DwItem2<AIPromptRequestStatusEntity, AIPromptRequestStatusMetaDataAttributes,AIPromptRequestStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=355;
        this.ItemDetail.itemName='AIPromptRequestStatus';
        this.ItemDetail.keyName='AIPromptRequestStatusId';
    }

    CreateEntity(): AIPromptRequestStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AIPromptRequestStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AIPromptRequestStatusEntity, AIPromptRequestStatusMetaDataAttributes,AIPromptRequestStatusMetaDataRelations>(query, this);
    }
     Attributes = new AIPromptRequestStatusMetaDataAttributes();
     Relations = new AIPromptRequestStatusMetaDataRelations();

}


export type AIPromptRequestStatusQueryBuilder = DwQueryBuilderGen<AIPromptRequestStatusEntity, AIPromptRequestStatusMetaDataAttributes,AIPromptRequestStatusMetaDataRelations>


export class AIPromptRequestStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AIPromptRequestStatus';
    // Attributes
    AIPromptRequestStatusId = new DwItemAttribute(this.i, 'AIPromptRequestStatusId');
    AIPromptRequestStatus = new DwItemAttribute(this.i, 'AIPromptRequestStatus');
}

class AIPromptRequestStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: AI Prompt Request */
            AIPromptRequest = new DwItemRelationship('AIPromptRequestStatus|AIPromptRequest|AIPromptRequestStatusId', 'AIPromptRequest', 'AIPromptRequest');
    };
export class AiPromptRequestTypeMetaData implements DwItem2<AiPromptRequestTypeEntity, AiPromptRequestTypeMetaDataAttributes,AiPromptRequestTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=356;
        this.ItemDetail.itemName='AiPromptRequestType';
        this.ItemDetail.keyName='AiPromptRequestTypeId';
    }

    CreateEntity(): AiPromptRequestTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AiPromptRequestTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AiPromptRequestTypeEntity, AiPromptRequestTypeMetaDataAttributes,AiPromptRequestTypeMetaDataRelations>(query, this);
    }
     Attributes = new AiPromptRequestTypeMetaDataAttributes();
     Relations = new AiPromptRequestTypeMetaDataRelations();

}


export type AiPromptRequestTypeQueryBuilder = DwQueryBuilderGen<AiPromptRequestTypeEntity, AiPromptRequestTypeMetaDataAttributes,AiPromptRequestTypeMetaDataRelations>


export class AiPromptRequestTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AiPromptRequestType';
    // Attributes
    AiPromptRequestTypeId = new DwItemAttribute(this.i, 'AiPromptRequestTypeId');
    AiPromptRequestType = new DwItemAttribute(this.i, 'AiPromptRequestType');
}

class AiPromptRequestTypeMetaDataRelations implements DwItemRelationshipCollection {
    };
export class AIPromptResultTypeMetaData implements DwItem2<AIPromptResultTypeEntity, AIPromptResultTypeMetaDataAttributes,AIPromptResultTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=354;
        this.ItemDetail.itemName='AIPromptResultType';
        this.ItemDetail.keyName='AIPromptResultTypeId';
    }

    CreateEntity(): AIPromptResultTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AIPromptResultTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AIPromptResultTypeEntity, AIPromptResultTypeMetaDataAttributes,AIPromptResultTypeMetaDataRelations>(query, this);
    }
     Attributes = new AIPromptResultTypeMetaDataAttributes();
     Relations = new AIPromptResultTypeMetaDataRelations();

}


export type AIPromptResultTypeQueryBuilder = DwQueryBuilderGen<AIPromptResultTypeEntity, AIPromptResultTypeMetaDataAttributes,AIPromptResultTypeMetaDataRelations>


export class AIPromptResultTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AIPromptResultType';
    // Attributes
    AIPromptResultTypeId = new DwItemAttribute(this.i, 'AIPromptResultTypeId');
    AIPromptResultType = new DwItemAttribute(this.i, 'AIPromptResultType');
}

class AIPromptResultTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: AI Prompt Setup */
            AIPromptSetup = new DwItemRelationship('AIPromptResultType|AIPromptSetup|AIPromptResultTypeId', 'AIPromptSetup', 'AIPromptSetup');
    };
export class AIPromptSetupMetaData implements DwItem2<AIPromptSetupEntity, AIPromptSetupMetaDataAttributes,AIPromptSetupMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=360;
        this.ItemDetail.itemName='AIPromptSetup';
        this.ItemDetail.keyName='AIPromptSetupId';
    }

    CreateEntity(): AIPromptSetupEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AIPromptSetupQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AIPromptSetupEntity, AIPromptSetupMetaDataAttributes,AIPromptSetupMetaDataRelations>(query, this);
    }
     Attributes = new AIPromptSetupMetaDataAttributes();
     Relations = new AIPromptSetupMetaDataRelations();

}


export type AIPromptSetupQueryBuilder = DwQueryBuilderGen<AIPromptSetupEntity, AIPromptSetupMetaDataAttributes,AIPromptSetupMetaDataRelations>


export class AIPromptSetupMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AIPromptSetup';
    // Attributes
    AIPromptSetupId = new DwItemAttribute(this.i, 'AIPromptSetupId');
    AiPromptTypeId = new DwItemAttribute(this.i, 'AiPromptTypeId');
    AIPromptModelId = new DwItemAttribute(this.i, 'AIPromptModelId');
    AIPromptSetupStatusId = new DwItemAttribute(this.i, 'AIPromptSetupStatusId');
    SystemPrompt = new DwItemAttribute(this.i, 'SystemPrompt');
    UserPrompt = new DwItemAttribute(this.i, 'UserPrompt');
    AIPromptResultTypeId = new DwItemAttribute(this.i, 'AIPromptResultTypeId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    PromptName = new DwItemAttribute(this.i, 'PromptName');
}

class AIPromptSetupMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: AI Prompt Model */
            AIPromptModel = new DwItemRelationship('AIPromptModel|AIPromptSetup|AIPromptModelId', 'AIPromptModel', 'AIPromptModel');
            /** Relation: Prompt Result Type */
            AIPromptResultType = new DwItemRelationship('AIPromptResultType|AIPromptSetup|AIPromptResultTypeId', 'AIPromptResultType', 'AIPromptResultType');
            /** Relation: AI Prompt Setup Status - Setup Status */
            AiPromptSetupStatusByAIPromptSetupStatusId = new DwItemRelationship('AiPromptSetupStatus|AIPromptSetup|AIPromptSetupStatusId', 'AIPromptSetupStatusIdAiPromptSetupStatus', 'AIPromptSetupStatusIdAiPromptSetupStatus');
            /** Relation: AI Prompt Type - Prompt Type */
            AIPromptTypeByAiPromptTypeId = new DwItemRelationship('AIPromptType|AIPromptSetup|AiPromptTypeId', 'AiPromptTypeIdAIPromptType', 'AiPromptTypeIdAIPromptType');
            /** Relation: AI Process Config - Prompt Setup Id - Many */
            AiProcessConfigByAiPromptSetupId = new DwItemRelationship('AIPromptSetup|AiProcessConfig|AiPromptSetupId', 'AiPromptSetupIdAiProcessConfig', 'AiPromptSetupIdAiProcessConfig');
            /** Relation: AI Prompt Request */
            AIPromptRequest = new DwItemRelationship('AIPromptSetup|AiPromptRequest|AiPromptSetupId', 'AIPromptRequest', 'AIPromptRequest');
    };
export class AiPromptSetupStatusMetaData implements DwItem2<AiPromptSetupStatusEntity, AiPromptSetupStatusMetaDataAttributes,AiPromptSetupStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=357;
        this.ItemDetail.itemName='AiPromptSetupStatus';
        this.ItemDetail.keyName='AiPromptSetupStatusId';
    }

    CreateEntity(): AiPromptSetupStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AiPromptSetupStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AiPromptSetupStatusEntity, AiPromptSetupStatusMetaDataAttributes,AiPromptSetupStatusMetaDataRelations>(query, this);
    }
     Attributes = new AiPromptSetupStatusMetaDataAttributes();
     Relations = new AiPromptSetupStatusMetaDataRelations();

}


export type AiPromptSetupStatusQueryBuilder = DwQueryBuilderGen<AiPromptSetupStatusEntity, AiPromptSetupStatusMetaDataAttributes,AiPromptSetupStatusMetaDataRelations>


export class AiPromptSetupStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AiPromptSetupStatus';
    // Attributes
    AiPromptSetupStatusId = new DwItemAttribute(this.i, 'AiPromptSetupStatusId');
    AiPromptSetupStatus = new DwItemAttribute(this.i, 'AiPromptSetupStatus');
}

class AiPromptSetupStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: AI Prompt Setup - AI Prompt Setup Status Id - Many */
            AIPromptSetupByAIPromptSetupStatusId = new DwItemRelationship('AiPromptSetupStatus|AIPromptSetup|AIPromptSetupStatusId', 'AIPromptSetupStatusIdAIPromptSetup', 'AIPromptSetupStatusIdAIPromptSetup');
    };
export class AIPromptTokenTypeMetaData implements DwItem2<AIPromptTokenTypeEntity, AIPromptTokenTypeMetaDataAttributes,AIPromptTokenTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=362;
        this.ItemDetail.itemName='AIPromptTokenType';
        this.ItemDetail.keyName='AiPromptTokenTypeId';
    }

    CreateEntity(): AIPromptTokenTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AIPromptTokenTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AIPromptTokenTypeEntity, AIPromptTokenTypeMetaDataAttributes,AIPromptTokenTypeMetaDataRelations>(query, this);
    }
     Attributes = new AIPromptTokenTypeMetaDataAttributes();
     Relations = new AIPromptTokenTypeMetaDataRelations();

}


export type AIPromptTokenTypeQueryBuilder = DwQueryBuilderGen<AIPromptTokenTypeEntity, AIPromptTokenTypeMetaDataAttributes,AIPromptTokenTypeMetaDataRelations>


export class AIPromptTokenTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AIPromptTokenType';
    // Attributes
    AiPromptTokenTypeId = new DwItemAttribute(this.i, 'AiPromptTokenTypeId');
    AiPromptToken = new DwItemAttribute(this.i, 'AiPromptToken');
    AiPromptTokenDescription = new DwItemAttribute(this.i, 'AiPromptTokenDescription');
}

class AIPromptTokenTypeMetaDataRelations implements DwItemRelationshipCollection {
    };
export class AIPromptTypeMetaData implements DwItem2<AIPromptTypeEntity, AIPromptTypeMetaDataAttributes,AIPromptTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=358;
        this.ItemDetail.itemName='AIPromptType';
        this.ItemDetail.keyName='AIPromptTypeId';
    }

    CreateEntity(): AIPromptTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AIPromptTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AIPromptTypeEntity, AIPromptTypeMetaDataAttributes,AIPromptTypeMetaDataRelations>(query, this);
    }
     Attributes = new AIPromptTypeMetaDataAttributes();
     Relations = new AIPromptTypeMetaDataRelations();

}


export type AIPromptTypeQueryBuilder = DwQueryBuilderGen<AIPromptTypeEntity, AIPromptTypeMetaDataAttributes,AIPromptTypeMetaDataRelations>


export class AIPromptTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AIPromptType';
    // Attributes
    AIPromptTypeId = new DwItemAttribute(this.i, 'AIPromptTypeId');
    AIPromptType = new DwItemAttribute(this.i, 'AIPromptType');
}

class AIPromptTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: AI Prompt Setup - AI Prompt Type Id - Many */
            AIPromptSetupByAiPromptTypeId = new DwItemRelationship('AIPromptType|AIPromptSetup|AiPromptTypeId', 'AiPromptTypeIdAIPromptSetup', 'AiPromptTypeIdAIPromptSetup');
    };
export class AircraftTypeMetaData implements DwItem2<AircraftTypeEntity, AircraftTypeMetaDataAttributes,AircraftTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=149;
        this.ItemDetail.itemName='AircraftType';
        this.ItemDetail.keyName='AircraftTypeId';
    }

    CreateEntity(): AircraftTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AircraftTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AircraftTypeEntity, AircraftTypeMetaDataAttributes,AircraftTypeMetaDataRelations>(query, this);
    }
     Attributes = new AircraftTypeMetaDataAttributes();
     Relations = new AircraftTypeMetaDataRelations();

}


export type AircraftTypeQueryBuilder = DwQueryBuilderGen<AircraftTypeEntity, AircraftTypeMetaDataAttributes,AircraftTypeMetaDataRelations>


export class AircraftTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AircraftType';
    // Attributes
    AircraftTypeId = new DwItemAttribute(this.i, 'AircraftTypeId');
    AircraftType = new DwItemAttribute(this.i, 'AircraftType');
    AircraftTypeDescription = new DwItemAttribute(this.i, 'AircraftTypeDescription');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class AircraftTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Course */
            Course = new DwItemRelationship('AircraftType|Course|AircraftTypeId', 'Course', 'Course');
    };
export class AirportMetaData implements DwItem2<AirportEntity, AirportMetaDataAttributes,AirportMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=208;
        this.ItemDetail.itemName='Airport';
        this.ItemDetail.keyName='AirportId';
    }

    CreateEntity(): AirportEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AirportQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AirportEntity, AirportMetaDataAttributes,AirportMetaDataRelations>(query, this);
    }
     Attributes = new AirportMetaDataAttributes();
     Relations = new AirportMetaDataRelations();

}


export type AirportQueryBuilder = DwQueryBuilderGen<AirportEntity, AirportMetaDataAttributes,AirportMetaDataRelations>


export class AirportMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Airport';
    // Attributes
    AirportId = new DwItemAttribute(this.i, 'AirportId');
    AviationAuthorityId = new DwItemAttribute(this.i, 'AviationAuthorityId');
    AirportName = new DwItemAttribute(this.i, 'AirportName');
    AirportCode = new DwItemAttribute(this.i, 'AirportCode');
    AirportAddressId = new DwItemAttribute(this.i, 'AirportAddressId');
    Elevation = new DwItemAttribute(this.i, 'Elevation');
    OwnershipCode = new DwItemAttribute(this.i, 'OwnershipCode');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class AirportMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Address - Airport Address */
            AddressByAirportAddressId = new DwItemRelationship('Address|Airport|AirportAddressId', 'AirportAddress', 'AirportAddress');
    };
export class AssignmentMetaData implements DwItem2<AssignmentEntity, AssignmentMetaDataAttributes,AssignmentMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=188;
        this.ItemDetail.itemName='Assignment';
        this.ItemDetail.keyName='AssignmentId';
    }

    CreateEntity(): AssignmentEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AssignmentQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AssignmentEntity, AssignmentMetaDataAttributes,AssignmentMetaDataRelations>(query, this);
    }
     Attributes = new AssignmentMetaDataAttributes();
     Relations = new AssignmentMetaDataRelations();

}


export type AssignmentQueryBuilder = DwQueryBuilderGen<AssignmentEntity, AssignmentMetaDataAttributes,AssignmentMetaDataRelations>


export class AssignmentMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Assignment';
    // Attributes
    AssignmentId = new DwItemAttribute(this.i, 'AssignmentId');
    CourseId = new DwItemAttribute(this.i, 'CourseId');
    AssignmentDescription = new DwItemAttribute(this.i, 'AssignmentDescription');
    AssignmentTypeId = new DwItemAttribute(this.i, 'AssignmentTypeId');
    AssignmentStatusId = new DwItemAttribute(this.i, 'AssignmentStatusId');
    AssignmentLinkUrl = new DwItemAttribute(this.i, 'AssignmentLinkUrl');
    MediaId = new DwItemAttribute(this.i, 'MediaId');
    DueDateTime = new DwItemAttribute(this.i, 'DueDateTime');
    FlightSchoolGroupId = new DwItemAttribute(this.i, 'FlightSchoolGroupId');
    AssignedDateTime = new DwItemAttribute(this.i, 'AssignedDateTime');
    CompletedDateTime = new DwItemAttribute(this.i, 'CompletedDateTime');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    ResetLessonProgress = new DwItemAttribute(this.i, 'ResetLessonProgress');
    UseGroupAssignment = new DwItemAttribute(this.i, 'UseGroupAssignment');
    InstructorId = new DwItemAttribute(this.i, 'InstructorId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class AssignmentMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Assignment Status */
            AssignmentStatus = new DwItemRelationship('AssignmentStatus|Assignment|AssignmentStatusId', 'AssignmentStatus', 'AssignmentStatus');
            /** Relation: Assignment Type */
            AssignmentType = new DwItemRelationship('AssignmentType|Assignment|AssignmentTypeId', 'AssignmentType', 'AssignmentType');
            /** Relation: Course */
            Course = new DwItemRelationship('Course|Assignment|CourseId', 'Course', 'Course');
            /** Relation: Flight School */
            FlightSchool = new DwItemRelationship('CourseLesson|Assignment|CourseLessonId', 'FlightSchool', 'FlightSchool');
            /** Relation: Flight School Group */
            FlightSchoolGroup = new DwItemRelationship('FlightSchoolGroup|Assignment|FlightSchoolGroupId', 'FlightSchoolGroup', 'FlightSchoolGroup');
            /** Relation: Instructor */
            Instructor = new DwItemRelationship('Instructor|Assignment|InstructorId', 'Instructor', 'Instructor');
            /** Relation: Media */
            DwMedia = new DwItemRelationship('dw_Media|Assignment|MediaId', 'DwMedia', 'DwMedia');
            /** Relation: Assignment Course Lesson */
            AssignmentCourseLesson = new DwItemRelationship('Assignment|AssignmentCourseLesson|AssignmentId', 'AssignmentCourseLesson', 'AssignmentCourseLesson');
            /** Relation: Assignment Student */
            AssignmentStudent = new DwItemRelationship('Assignment|AssignmentStudent|AssignmentId', 'AssignmentStudent', 'AssignmentStudent');
            /** Relation: Ro Assignment Student Course Lesson Progress - Assignment - Many */
            RoAssignmentStudentCourseLessonProgressByassignmentId = new DwItemRelationship('Assignment|RoAssignmentStudentCourseLessonProgress', 'AssignmentIdRoAssignmentStudentCourseLessonProgress', 'AssignmentIdRoAssignmentStudentCourseLessonProgress');
            /** Relation: Ro Assignment Student Stat */
            RoAssignmentStudentStat = new DwItemRelationship('Assignment|RoAssignmentStudentStat|AssignmentId', 'RoAssignmentStudentStat', 'RoAssignmentStudentStat');
            /** Relation: Student Progress Reset Event */
            StudentProgressResetEvent = new DwItemRelationship('Assignment|StudentProgressResetEvent|AssignmentId', 'StudentProgressResetEvent', 'StudentProgressResetEvent');
    };
export class AssignmentCourseLessonMetaData implements DwItem2<AssignmentCourseLessonEntity, AssignmentCourseLessonMetaDataAttributes,AssignmentCourseLessonMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=195;
        this.ItemDetail.itemName='AssignmentCourseLesson';
        this.ItemDetail.keyName='AssignmentCourseLessonId';
    }

    CreateEntity(): AssignmentCourseLessonEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AssignmentCourseLessonQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AssignmentCourseLessonEntity, AssignmentCourseLessonMetaDataAttributes,AssignmentCourseLessonMetaDataRelations>(query, this);
    }
     Attributes = new AssignmentCourseLessonMetaDataAttributes();
     Relations = new AssignmentCourseLessonMetaDataRelations();

}


export type AssignmentCourseLessonQueryBuilder = DwQueryBuilderGen<AssignmentCourseLessonEntity, AssignmentCourseLessonMetaDataAttributes,AssignmentCourseLessonMetaDataRelations>


export class AssignmentCourseLessonMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AssignmentCourseLesson';
    // Attributes
    AssignmentCourseLessonId = new DwItemAttribute(this.i, 'AssignmentCourseLessonId');
    AssignmentId = new DwItemAttribute(this.i, 'AssignmentId');
    CourseLessonId = new DwItemAttribute(this.i, 'CourseLessonId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class AssignmentCourseLessonMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Assignment */
            Assignment = new DwItemRelationship('Assignment|AssignmentCourseLesson|AssignmentId', 'Assignment', 'Assignment');
            /** Relation: Lesson */
            CourseLesson = new DwItemRelationship('CourseLesson|AssignmentCourseLesson|CourseLessonId', 'CourseLesson', 'CourseLesson');
    };
export class AssignmentStatusMetaData implements DwItem2<AssignmentStatusEntity, AssignmentStatusMetaDataAttributes,AssignmentStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=190;
        this.ItemDetail.itemName='AssignmentStatus';
        this.ItemDetail.keyName='AssignmentStatusId';
    }

    CreateEntity(): AssignmentStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AssignmentStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AssignmentStatusEntity, AssignmentStatusMetaDataAttributes,AssignmentStatusMetaDataRelations>(query, this);
    }
     Attributes = new AssignmentStatusMetaDataAttributes();
     Relations = new AssignmentStatusMetaDataRelations();

}


export type AssignmentStatusQueryBuilder = DwQueryBuilderGen<AssignmentStatusEntity, AssignmentStatusMetaDataAttributes,AssignmentStatusMetaDataRelations>


export class AssignmentStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AssignmentStatus';
    // Attributes
    AssignmentStatusId = new DwItemAttribute(this.i, 'AssignmentStatusId');
    AssignmentStatus = new DwItemAttribute(this.i, 'AssignmentStatus');
}

class AssignmentStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Assignment */
            Assignment = new DwItemRelationship('AssignmentStatus|Assignment|AssignmentStatusId', 'Assignment', 'Assignment');
    };
export class AssignmentStudentMetaData implements DwItem2<AssignmentStudentEntity, AssignmentStudentMetaDataAttributes,AssignmentStudentMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=191;
        this.ItemDetail.itemName='AssignmentStudent';
        this.ItemDetail.keyName='AssignmentStudentId';
    }

    CreateEntity(): AssignmentStudentEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AssignmentStudentQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AssignmentStudentEntity, AssignmentStudentMetaDataAttributes,AssignmentStudentMetaDataRelations>(query, this);
    }
     Attributes = new AssignmentStudentMetaDataAttributes();
     Relations = new AssignmentStudentMetaDataRelations();

}


export type AssignmentStudentQueryBuilder = DwQueryBuilderGen<AssignmentStudentEntity, AssignmentStudentMetaDataAttributes,AssignmentStudentMetaDataRelations>


export class AssignmentStudentMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AssignmentStudent';
    // Attributes
    AssignmentStudentId = new DwItemAttribute(this.i, 'AssignmentStudentId');
    AssignmentId = new DwItemAttribute(this.i, 'AssignmentId');
    StudentId = new DwItemAttribute(this.i, 'StudentId');
    PercentComplete = new DwItemAttribute(this.i, 'PercentComplete');
    CompletedDateTime = new DwItemAttribute(this.i, 'CompletedDateTime');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    Acknowledged = new DwItemAttribute(this.i, 'Acknowledged');
    AcknowledgedDateTime = new DwItemAttribute(this.i, 'AcknowledgedDateTime');
    AiPromptRequestId = new DwItemAttribute(this.i, 'AiPromptRequestId');
    ShowAISummary = new DwItemAttribute(this.i, 'ShowAISummary');
}

class AssignmentStudentMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: AI Prompt Request - A I Prompt Request */
            AIPromptRequestByAiPromptRequestId = new DwItemRelationship('AIPromptRequest|AssignmentStudent|AiPromptRequestId', 'AiPromptRequestIdAIPromptRequest', 'AiPromptRequestIdAIPromptRequest');
            /** Relation: Assignment */
            Assignment = new DwItemRelationship('Assignment|AssignmentStudent|AssignmentId', 'Assignment', 'Assignment');
            /** Relation: Student */
            Student = new DwItemRelationship('Student|AssignmentStudent|StudentId', 'Student', 'Student');
            /** Relation: AI Prompt Request */
            AIPromptRequest = new DwItemRelationship('AssignmentStudent|AIPromptRequest|AssignmentStudentId', 'AIPromptRequest', 'AIPromptRequest');
            /** Relation: Ro Assignment Student Completed Details */
            RoAssignmentStudentCompletedDetails = new DwItemRelationship('AssignmentStudent|RoAssignmentStudent|AssignmentStudentId', 'RoAssignmentStudentCompletedDetails', 'RoAssignmentStudentCompletedDetails');
            /** Relation: Ro Assignment Student Course Lesson Progress */
            RoAssignmentStudentCourseLessonProgress = new DwItemRelationship('AssignmentStudent|RoAssignmentStudentCourseLessonProgress', 'RoAssignmentStudentCourseLessonProgress', 'RoAssignmentStudentCourseLessonProgress');
            /** Relation: Ro School Assignment Stats */
            RoSchoolAssignmentStatsByAssignmentId = new DwItemRelationship('AssignmentStudent|RoSchoolAssignmentStat|AssignmentId', 'RoSchoolAssignmentStatsAssignmentId', 'RoSchoolAssignmentStatsAssignmentId');
            /** Relation: Student Progress Reset Event */
            StudentProgressResetEvent = new DwItemRelationship('AssignmentStudent|StudentProgressResetEvent|AssignmentStudentId', 'StudentProgressResetEvent', 'StudentProgressResetEvent');
    };
export class AssignmentTypeMetaData implements DwItem2<AssignmentTypeEntity, AssignmentTypeMetaDataAttributes,AssignmentTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=189;
        this.ItemDetail.itemName='AssignmentType';
        this.ItemDetail.keyName='AssignmentTypeId';
    }

    CreateEntity(): AssignmentTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AssignmentTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AssignmentTypeEntity, AssignmentTypeMetaDataAttributes,AssignmentTypeMetaDataRelations>(query, this);
    }
     Attributes = new AssignmentTypeMetaDataAttributes();
     Relations = new AssignmentTypeMetaDataRelations();

}


export type AssignmentTypeQueryBuilder = DwQueryBuilderGen<AssignmentTypeEntity, AssignmentTypeMetaDataAttributes,AssignmentTypeMetaDataRelations>


export class AssignmentTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AssignmentType';
    // Attributes
    AssignmentTypeId = new DwItemAttribute(this.i, 'AssignmentTypeId');
    AssignmentType = new DwItemAttribute(this.i, 'AssignmentType');
}

class AssignmentTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Assignment */
            Assignment = new DwItemRelationship('AssignmentType|Assignment|AssignmentTypeId', 'Assignment', 'Assignment');
    };
export class AviationGoalMetaData implements DwItem2<AviationGoalEntity, AviationGoalMetaDataAttributes,AviationGoalMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=484;
        this.ItemDetail.itemName='AviationGoal';
        this.ItemDetail.keyName='AviationGoalId';
    }

    CreateEntity(): AviationGoalEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AviationGoalQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AviationGoalEntity, AviationGoalMetaDataAttributes,AviationGoalMetaDataRelations>(query, this);
    }
     Attributes = new AviationGoalMetaDataAttributes();
     Relations = new AviationGoalMetaDataRelations();

}


export type AviationGoalQueryBuilder = DwQueryBuilderGen<AviationGoalEntity, AviationGoalMetaDataAttributes,AviationGoalMetaDataRelations>


export class AviationGoalMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AviationGoal';
    // Attributes
    AviationGoalId = new DwItemAttribute(this.i, 'AviationGoalId');
    AviationGoal = new DwItemAttribute(this.i, 'AviationGoal');
    GoalOrder = new DwItemAttribute(this.i, 'GoalOrder');
}

class AviationGoalMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Student */
            Student = new DwItemRelationship('AviationGoal|Student|AviationGoalId', 'Student', 'Student');
    };
export class CountryMetaData implements DwItem2<CountryEntity, CountryMetaDataAttributes,CountryMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=204;
        this.ItemDetail.itemName='Country';
        this.ItemDetail.keyName='CountryId';
    }

    CreateEntity(): CountryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CountryQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CountryEntity, CountryMetaDataAttributes,CountryMetaDataRelations>(query, this);
    }
     Attributes = new CountryMetaDataAttributes();
     Relations = new CountryMetaDataRelations();

}


export type CountryQueryBuilder = DwQueryBuilderGen<CountryEntity, CountryMetaDataAttributes,CountryMetaDataRelations>


export class CountryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Country';
    // Attributes
    CountryId = new DwItemAttribute(this.i, 'CountryId');
    CountryName = new DwItemAttribute(this.i, 'CountryName');
    CountryShortName = new DwItemAttribute(this.i, 'CountryShortName');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    SortFirst = new DwItemAttribute(this.i, 'SortFirst');
}

class CountryMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Address */
            Address = new DwItemRelationship('Country|Address|CountryId', 'Address', 'Address');
            /** Relation: State Province */
            StateProvince = new DwItemRelationship('Country|StateProvince|CountryId', 'StateProvince', 'StateProvince');
            /** Relation: Student - Citizenship - Many */
            StudentByCitizenshipCountryId = new DwItemRelationship('Country|Student|CitizenshipCountryId', 'CitizenshipStudent', 'CitizenshipStudent');
    };
export class CourseMetaData implements DwItem2<CourseEntity, CourseMetaDataAttributes,CourseMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=145;
        this.ItemDetail.itemName='Course';
        this.ItemDetail.keyName='CourseId';
    }

    CreateEntity(): CourseEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CourseQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CourseEntity, CourseMetaDataAttributes,CourseMetaDataRelations>(query, this);
    }
     Attributes = new CourseMetaDataAttributes();
     Relations = new CourseMetaDataRelations();

}


export type CourseQueryBuilder = DwQueryBuilderGen<CourseEntity, CourseMetaDataAttributes,CourseMetaDataRelations>


export class CourseMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Course';
    // Attributes
    CourseId = new DwItemAttribute(this.i, 'CourseId');
    CourseName = new DwItemAttribute(this.i, 'CourseName');
    CourseDescription = new DwItemAttribute(this.i, 'CourseDescription');
    CourseTypeId = new DwItemAttribute(this.i, 'CourseTypeId');
    CourseImageMediaId = new DwItemAttribute(this.i, 'CourseImageMediaId');
    CourseNotes = new DwItemAttribute(this.i, 'CourseNotes');
    AircraftTypeId = new DwItemAttribute(this.i, 'AircraftTypeId');
    AvionicsType = new DwItemAttribute(this.i, 'AvionicsType');
    ProgramTypeId = new DwItemAttribute(this.i, 'ProgramTypeId');
    RetailPrice = new DwItemAttribute(this.i, 'RetailPrice');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    CourseStatusId = new DwItemAttribute(this.i, 'CourseStatusId');
    TotalCourseTimeSeconds = new DwItemAttribute(this.i, 'TotalCourseTimeSeconds');
    TotalCourseVideoTimeSeconds = new DwItemAttribute(this.i, 'TotalCourseVideoTimeSeconds');
    TotalCourseQuizTimeSeconds = new DwItemAttribute(this.i, 'TotalCourseQuizTimeSeconds');
    CourseKey = new DwItemAttribute(this.i, 'CourseKey');
    DefaultSchoolCourse = new DwItemAttribute(this.i, 'DefaultSchoolCourse');
    AcsTestId = new DwItemAttribute(this.i, 'AcsTestId');
    CourseOrder = new DwItemAttribute(this.i, 'CourseOrder');
    ModulePrefixOverride = new DwItemAttribute(this.i, 'ModulePrefixOverride');
    ComingSoon = new DwItemAttribute(this.i, 'ComingSoon');
}

class CourseMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Acs Test */
            AcsTest = new DwItemRelationship('AcsTest|Course|AcsTestId', 'AcsTest', 'AcsTest');
            /** Relation: Aircraft Type */
            AircraftType = new DwItemRelationship('AircraftType|Course|AircraftTypeId', 'AircraftType', 'AircraftType');
            /** Relation: Course Type */
            CourseType = new DwItemRelationship('CourseType|Course|CourseTypeId', 'CourseType', 'CourseType');
            /** Relation: Media - Course Image Media */
            DwMediaByCourseImageMediaId = new DwItemRelationship('dw_Media|Course|CourseImageMediaId', 'CourseImageDwMedia', 'CourseImageDwMedia');
            /** Relation: Ro Media - Course Image Media */
            DwRoMediaByCourseImageMediaId = new DwItemRelationship('Course|roMedia', 'CourseImageDwroMedia', 'CourseImageDwroMedia');
            /** Relation: Program Type */
            ProgramType = new DwItemRelationship('ProgramType|Course|ProgramTypeId', 'ProgramType', 'ProgramType');
            /** Relation: Reference Status - Course Status */
            ReferenceStatusByCourseStatusId = new DwItemRelationship('ReferenceStatus|Course|CourseStatusId', 'CourseStatusIdReferenceStatus', 'CourseStatusIdReferenceStatus');
            /** Relation: Acs Task Multi Assign */
            AcsTaskMultiAssign = new DwItemRelationship('Course|AcsTaskMultiAssign|CourseId', 'AcsTaskMultiAssign', 'AcsTaskMultiAssign');
            /** Relation: AI Prompt Request */
            AIPromptRequest = new DwItemRelationship('Course|AIPromptRequest|CourseId', 'AIPromptRequest', 'AIPromptRequest');
            /** Relation: Assignment */
            Assignment = new DwItemRelationship('Course|Assignment|CourseId', 'Assignment', 'Assignment');
            /** Relation: Course Availability Notification */
            CourseAvailabilityNotification = new DwItemRelationship('Course|CourseAvailabilityNotification|CourseId', 'CourseAvailabilityNotification', 'CourseAvailabilityNotification');
            /** Relation: Course Document Item */
            CourseDocumentItem = new DwItemRelationship('Course|CourseDocumentItem|CousreId', 'CourseDocumentItem', 'CourseDocumentItem');
            /** Relation: Course Endorsement */
            CourseEndorsement = new DwItemRelationship('Course|CourseEndorsement|CourseId', 'CourseEndorsement', 'CourseEndorsement');
            /** Relation: Course Lesson Flag */
            CourseLessonFlag = new DwItemRelationship('Course|CourseLessonFlag|CourseId', 'CourseLessonFlag', 'CourseLessonFlag');
            /** Relation: Course Modification History */
            CourseModificationHistory = new DwItemRelationship('Course|CourseModificationHistory|CourseId', 'CourseModificationHistory', 'CourseModificationHistory');
            /** Relation: Module */
            CourseModule = new DwItemRelationship('Course|CourseModule|CourseId', 'CourseModule', 'CourseModule');
            /** Relation: Course Purchase Course */
            CoursePurchaseCourse = new DwItemRelationship('Course|CoursePurchaseCourse|CourseId', 'CoursePurchaseCourse', 'CoursePurchaseCourse');
            /** Relation: Course Purchase Reservation Course */
            CoursePurchaseReservationCourse = new DwItemRelationship('Course|CoursePurchaseReservationCourse|CourseId', 'CoursePurchaseReservationCourse', 'CoursePurchaseReservationCourse');
            /** Relation: Discount Course */
            DiscountCourse = new DwItemRelationship('Course|DiscountCourse|CourseId', 'DiscountCourse', 'DiscountCourse');
            /** Relation: Document Link Processing Run */
            DocumentLinkProcessingRun = new DwItemRelationship('Course|DocumentLinkProcessingRun|CourseId', 'DocumentLinkProcessingRun', 'DocumentLinkProcessingRun');
            /** Relation: Document Link Processing Run Item */
            DocumentLinkProcessingRunItem = new DwItemRelationship('Course|DocumentLinkProcessingRunItem|CourseId', 'DocumentLinkProcessingRunItem', 'DocumentLinkProcessingRunItem');
            /** Relation: Flight School Course */
            FlightSchoolCourse = new DwItemRelationship('Course|FlightSchoolCourse|CourseId', 'FlightSchoolCourse', 'FlightSchoolCourse');
            /** Relation: Integration Course Purchase */
            IntegrationCoursePurchase = new DwItemRelationship('Course|IntegrationCoursePurchase|CourseId', 'IntegrationCoursePurchase', 'IntegrationCoursePurchase');
            /** Relation: Integration Course Purchase Request */
            IntegrationCoursePurchaseRequest = new DwItemRelationship('Course|IntegrationCoursePurchaseRequest|CourseId', 'IntegrationCoursePurchaseRequest', 'IntegrationCoursePurchaseRequest');
            /** Relation: Integration System Course */
            IntegrationSystemCourse = new DwItemRelationship('Course|IntegrationSystemCourse|CourseId', 'IntegrationSystemCourse', 'IntegrationSystemCourse');
            /** Relation: Integration User Event */
            IntegrationUserEvent = new DwItemRelationship('Course|IntegrationUserEvent|CourseId', 'IntegrationUserEvent', 'IntegrationUserEvent');
            /** Relation: Join Request Course */
            JoinRequestCourse = new DwItemRelationship('Course|JoinRequestCourse|CourseId', 'JoinRequestCourse', 'JoinRequestCourse');
            /** Relation: Join Request Course Purchase */
            JoinRequestCoursePurchase = new DwItemRelationship('Course|JoinRequestCoursePurchase|CourseId', 'JoinRequestCoursePurchase', 'JoinRequestCoursePurchase');
            /** Relation: Modification History */
            ModificationHistory = new DwItemRelationship('Course|ModificationHistory|CourseId', 'ModificationHistory', 'ModificationHistory');
            /** Relation: Multiple Assign Course */
            MultipleAssignCourse = new DwItemRelationship('Course|MultipleAssignCourse|CourseId', 'MultipleAssignCourse', 'MultipleAssignCourse');
            /** Relation: Package Course */
            PackageCourse = new DwItemRelationship('Course|PackageCourse|CourseId', 'PackageCourse', 'PackageCourse');
            /** Relation: Product */
            Product = new DwItemRelationship('Course|Product|CourseId', 'Product', 'Product');
            /** Relation: Question */
            Question = new DwItemRelationship('Course|Question|CourseId', 'Question', 'Question');
            /** Relation: Ro Flight School Course Unique */
            RoFlightSchoolCourseUnique = new DwItemRelationship('Course|RoFlightSchoolCourseUnique', 'RoFlightSchoolCourseUnique', 'RoFlightSchoolCourseUnique');
            /** Relation: Ro Student School Course */
            RoStudentSchoolCourses = new DwItemRelationship('RoStudentSchoolCourse|Course|CourseId', 'RoStudentSchoolCourses', 'RoStudentSchoolCourses');
            /** Relation: Student Course */
            StudentCourse = new DwItemRelationship('Course|StudentCourse|CourseId', 'StudentCourse', 'StudentCourse');
            /** Relation: Student Progress Reset Event */
            StudentProgressResetEvent = new DwItemRelationship('Course|StudentProgressResetEvent|CourseId', 'StudentProgressResetEvent', 'StudentProgressResetEvent');
            /** Relation: Subscription Course Tracking */
            SubscriptionCourseTracking = new DwItemRelationship('Course|SubscriptionCourseTracking|CourseId', 'SubscriptionCourseTracking', 'SubscriptionCourseTracking');
    };
export class CourseAssignmentSourceTypeMetaData implements DwItem2<CourseAssignmentSourceTypeEntity, CourseAssignmentSourceTypeMetaDataAttributes,CourseAssignmentSourceTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=480;
        this.ItemDetail.itemName='CourseAssignmentSourceType';
        this.ItemDetail.keyName='CourseAssignmentSourceTypeId';
    }

    CreateEntity(): CourseAssignmentSourceTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CourseAssignmentSourceTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CourseAssignmentSourceTypeEntity, CourseAssignmentSourceTypeMetaDataAttributes,CourseAssignmentSourceTypeMetaDataRelations>(query, this);
    }
     Attributes = new CourseAssignmentSourceTypeMetaDataAttributes();
     Relations = new CourseAssignmentSourceTypeMetaDataRelations();

}


export type CourseAssignmentSourceTypeQueryBuilder = DwQueryBuilderGen<CourseAssignmentSourceTypeEntity, CourseAssignmentSourceTypeMetaDataAttributes,CourseAssignmentSourceTypeMetaDataRelations>


export class CourseAssignmentSourceTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CourseAssignmentSourceType';
    // Attributes
    CourseAssignmentSourceTypeId = new DwItemAttribute(this.i, 'CourseAssignmentSourceTypeId');
    CourseAssignmentSourceType = new DwItemAttribute(this.i, 'CourseAssignmentSourceType');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class CourseAssignmentSourceTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Student Activity */
            StudentActivity = new DwItemRelationship('CourseAssignmentSourceType|StudentActivity|CourseAssignmentSourceTypeId', 'StudentActivity', 'StudentActivity');
    };
export class CourseAvailabilityNotificationMetaData implements DwItem2<CourseAvailabilityNotificationEntity, CourseAvailabilityNotificationMetaDataAttributes,CourseAvailabilityNotificationMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=468;
        this.ItemDetail.itemName='CourseAvailabilityNotification';
        this.ItemDetail.keyName='CourseAvailabilityNotificationId';
    }

    CreateEntity(): CourseAvailabilityNotificationEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CourseAvailabilityNotificationQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CourseAvailabilityNotificationEntity, CourseAvailabilityNotificationMetaDataAttributes,CourseAvailabilityNotificationMetaDataRelations>(query, this);
    }
     Attributes = new CourseAvailabilityNotificationMetaDataAttributes();
     Relations = new CourseAvailabilityNotificationMetaDataRelations();

}


export type CourseAvailabilityNotificationQueryBuilder = DwQueryBuilderGen<CourseAvailabilityNotificationEntity, CourseAvailabilityNotificationMetaDataAttributes,CourseAvailabilityNotificationMetaDataRelations>


export class CourseAvailabilityNotificationMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CourseAvailabilityNotification';
    // Attributes
    CourseAvailabilityNotificationId = new DwItemAttribute(this.i, 'CourseAvailabilityNotificationId');
    CourseId = new DwItemAttribute(this.i, 'CourseId');
    UserId = new DwItemAttribute(this.i, 'UserId');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    RequestedDateTime = new DwItemAttribute(this.i, 'RequestedDateTime');
    CancelledDateTime = new DwItemAttribute(this.i, 'CancelledDateTime');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    CourseAvailableDateTime = new DwItemAttribute(this.i, 'CourseAvailableDateTime');
}

class CourseAvailabilityNotificationMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Course */
            Course = new DwItemRelationship('Course|CourseAvailabilityNotification|CourseId', 'Course', 'Course');
            /** Relation: Flight School */
            FlightSchool = new DwItemRelationship('FlightSchool|CourseAvailabilityNotification|FlightSchoolId', 'FlightSchool', 'FlightSchool');
            /** Relation: User */
            DwUser = new DwItemRelationship('dw_User|CourseAvailabilityNotification|UserId', 'DwUser', 'DwUser');
    };
export class CourseDocumentItemMetaData implements DwItem2<CourseDocumentItemEntity, CourseDocumentItemMetaDataAttributes,CourseDocumentItemMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=403;
        this.ItemDetail.itemName='CourseDocumentItem';
        this.ItemDetail.keyName='CourseDocumentItemId';
    }

    CreateEntity(): CourseDocumentItemEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CourseDocumentItemQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CourseDocumentItemEntity, CourseDocumentItemMetaDataAttributes,CourseDocumentItemMetaDataRelations>(query, this);
    }
     Attributes = new CourseDocumentItemMetaDataAttributes();
     Relations = new CourseDocumentItemMetaDataRelations();

}


export type CourseDocumentItemQueryBuilder = DwQueryBuilderGen<CourseDocumentItemEntity, CourseDocumentItemMetaDataAttributes,CourseDocumentItemMetaDataRelations>


export class CourseDocumentItemMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CourseDocumentItem';
    // Attributes
    CourseDocumentItemId = new DwItemAttribute(this.i, 'CourseDocumentItemId');
    DocumentItemId = new DwItemAttribute(this.i, 'DocumentItemId');
    AIProcessingReferenceId = new DwItemAttribute(this.i, 'AIProcessingReferenceId');
    CourseId = new DwItemAttribute(this.i, 'CourseId');
    CourseDocumentProcessingStatusId = new DwItemAttribute(this.i, 'CourseDocumentProcessingStatusId');
    CourseDocumentProcessingProgressText = new DwItemAttribute(this.i, 'CourseDocumentProcessingProgressText');
    CourseDocumentProcessingErrorText = new DwItemAttribute(this.i, 'CourseDocumentProcessingErrorText');
    CourseDocumentProcessingStartDateTime = new DwItemAttribute(this.i, 'CourseDocumentProcessingStartDateTime');
    CourseDocumentProcessingCompletedDateTime = new DwItemAttribute(this.i, 'CourseDocumentProcessingCompletedDateTime');
    CourseDocumentProcessingLastUpdatedDateTime = new DwItemAttribute(this.i, 'CourseDocumentProcessingLastUpdatedDateTime');
    CourseDocumentProcessingEstimatedCompletedDateTime = new DwItemAttribute(this.i, 'CourseDocumentProcessingEstimatedCompletedDateTime');
    CourseDocumentProcessingTotalModuleCount = new DwItemAttribute(this.i, 'CourseDocumentProcessingTotalModuleCount');
    CourseDocumentProcessingProcessedModuleCount = new DwItemAttribute(this.i, 'CourseDocumentProcessingProcessedModuleCount');
    CourseDocumentProcessingFailedModuleCount = new DwItemAttribute(this.i, 'CourseDocumentProcessingFailedModuleCount');
    CourseDocumentItemStatusId = new DwItemAttribute(this.i, 'CourseDocumentItemStatusId');
}

class CourseDocumentItemMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: AI Processing Reference */
            AIProcessingReference = new DwItemRelationship('AIProcessingReference|CourseDocumentItem|AIProcessingReferenceId', 'AIProcessingReference', 'AIProcessingReference');
            /** Relation: Course */
            Course = new DwItemRelationship('Course|CourseDocumentItem|CousreId', 'Course', 'Course');
            /** Relation: Course Document Processing Status */
            CourseDocumentProcessingStatus = new DwItemRelationship('CourseDocumentProcessingStatus|CourseDocumentItem|CourseDocumentProcessingStatusId', 'CourseDocumentProcessingStatus', 'CourseDocumentProcessingStatus');
            /** Relation: Document Item */
            DocumentItem = new DwItemRelationship('DocumentItem|CourseDocumentItem|DocumentItemId', 'DocumentItem', 'DocumentItem');
            /** Relation: Reference Status - Course Document Item Status */
            ReferenceStatusByCourseDocumentItemStatusId = new DwItemRelationship('ReferenceStatus|CourseDocumentItem|CourseDocumentItemStatusId', 'CourseDocumentItemStatusIdReferenceStatus', 'CourseDocumentItemStatusIdReferenceStatus');
            /** Relation: Course Module Document Item */
            CourseModuleDocumentItem = new DwItemRelationship('CourseDocumentItem|CourseModuleDocumentItem|CourseDocumentItemId', 'CourseModuleDocumentItem', 'CourseModuleDocumentItem');
    };
export class CourseDocumentProcessingStatusMetaData implements DwItem2<CourseDocumentProcessingStatusEntity, CourseDocumentProcessingStatusMetaDataAttributes,CourseDocumentProcessingStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=408;
        this.ItemDetail.itemName='CourseDocumentProcessingStatus';
        this.ItemDetail.keyName='CourseDocumentProcessingStatusId';
    }

    CreateEntity(): CourseDocumentProcessingStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CourseDocumentProcessingStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CourseDocumentProcessingStatusEntity, CourseDocumentProcessingStatusMetaDataAttributes,CourseDocumentProcessingStatusMetaDataRelations>(query, this);
    }
     Attributes = new CourseDocumentProcessingStatusMetaDataAttributes();
     Relations = new CourseDocumentProcessingStatusMetaDataRelations();

}


export type CourseDocumentProcessingStatusQueryBuilder = DwQueryBuilderGen<CourseDocumentProcessingStatusEntity, CourseDocumentProcessingStatusMetaDataAttributes,CourseDocumentProcessingStatusMetaDataRelations>


export class CourseDocumentProcessingStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CourseDocumentProcessingStatus';
    // Attributes
    CourseDocumentProcessingStatusId = new DwItemAttribute(this.i, 'CourseDocumentProcessingStatusId');
    CourseDocumentProcessingStatus = new DwItemAttribute(this.i, 'CourseDocumentProcessingStatus');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class CourseDocumentProcessingStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Course Document Item */
            CourseDocumentItem = new DwItemRelationship('CourseDocumentProcessingStatus|CourseDocumentItem|CourseDocumentProcessingStatusId', 'CourseDocumentItem', 'CourseDocumentItem');
    };
export class CourseEndorsementMetaData implements DwItem2<CourseEndorsementEntity, CourseEndorsementMetaDataAttributes,CourseEndorsementMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=220;
        this.ItemDetail.itemName='CourseEndorsement';
        this.ItemDetail.keyName='CourseEndorsementId';
    }

    CreateEntity(): CourseEndorsementEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CourseEndorsementQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CourseEndorsementEntity, CourseEndorsementMetaDataAttributes,CourseEndorsementMetaDataRelations>(query, this);
    }
     Attributes = new CourseEndorsementMetaDataAttributes();
     Relations = new CourseEndorsementMetaDataRelations();

}


export type CourseEndorsementQueryBuilder = DwQueryBuilderGen<CourseEndorsementEntity, CourseEndorsementMetaDataAttributes,CourseEndorsementMetaDataRelations>


export class CourseEndorsementMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CourseEndorsement';
    // Attributes
    CourseEndorsementId = new DwItemAttribute(this.i, 'CourseEndorsementId');
    CourseId = new DwItemAttribute(this.i, 'CourseId');
    EndorsementName = new DwItemAttribute(this.i, 'EndorsementName');
    ExpirationPeriodDays = new DwItemAttribute(this.i, 'ExpirationPeriodDays');
    EndorsementPDFMediaId = new DwItemAttribute(this.i, 'EndorsementPDFMediaId');
    EndorsementDescription = new DwItemAttribute(this.i, 'EndorsementDescription');
    CourseEndorsementTemplateId = new DwItemAttribute(this.i, 'CourseEndorsementTemplateId');
    RequireAllLessonsComplete = new DwItemAttribute(this.i, 'RequireAllLessonsComplete');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    IsEndorsementEnabled = new DwItemAttribute(this.i, 'IsEndorsementEnabled');
    RequireCourseFinalComplete = new DwItemAttribute(this.i, 'RequireCourseFinalComplete');
}

class CourseEndorsementMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Course */
            Course = new DwItemRelationship('Course|CourseEndorsement|CourseId', 'Course', 'Course');
            /** Relation: Course Endorsement Template */
            CourseEndorsementTemplate = new DwItemRelationship('CourseEndorsementTemplate|CourseEndorsement|CourseEndorsementTemplateId', 'CourseEndorsementTemplate', 'CourseEndorsementTemplate');
            /** Relation: Media - Endorsement PDF */
            DwMediaByEndorsementPDFMediaId = new DwItemRelationship('dw_Media|CourseEndorsement|EndorsementPDFMediaId', 'EndorsementPDFDwMedia', 'EndorsementPDFDwMedia');
            /** Relation: Course Endorsement Lesson */
            CourseEndorsementLesson = new DwItemRelationship('CourseEndorsement|CourseEndorsementLesson|CourseEndorsementId', 'CourseEndorsementLesson', 'CourseEndorsementLesson');
            /** Relation: Course Endorsement Student */
            CourseEndorsementStudent = new DwItemRelationship('CourseEndorsement|CourseEndorsementStudent|CourseEndorsementId', 'CourseEndorsementStudent', 'CourseEndorsementStudent');
    };
export class CourseEndorsementLessonMetaData implements DwItem2<CourseEndorsementLessonEntity, CourseEndorsementLessonMetaDataAttributes,CourseEndorsementLessonMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=221;
        this.ItemDetail.itemName='CourseEndorsementLesson';
        this.ItemDetail.keyName='CourseEndorsementLessonId';
    }

    CreateEntity(): CourseEndorsementLessonEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CourseEndorsementLessonQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CourseEndorsementLessonEntity, CourseEndorsementLessonMetaDataAttributes,CourseEndorsementLessonMetaDataRelations>(query, this);
    }
     Attributes = new CourseEndorsementLessonMetaDataAttributes();
     Relations = new CourseEndorsementLessonMetaDataRelations();

}


export type CourseEndorsementLessonQueryBuilder = DwQueryBuilderGen<CourseEndorsementLessonEntity, CourseEndorsementLessonMetaDataAttributes,CourseEndorsementLessonMetaDataRelations>


export class CourseEndorsementLessonMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CourseEndorsementLesson';
    // Attributes
    CourseEndorsementLessonId = new DwItemAttribute(this.i, 'CourseEndorsementLessonId');
    CourseEndorsementId = new DwItemAttribute(this.i, 'CourseEndorsementId');
    CourseLessonId = new DwItemAttribute(this.i, 'CourseLessonId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class CourseEndorsementLessonMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Course Endorsement */
            CourseEndorsement = new DwItemRelationship('CourseEndorsement|CourseEndorsementLesson|CourseEndorsementId', 'CourseEndorsement', 'CourseEndorsement');
            /** Relation: Lesson */
            CourseLesson = new DwItemRelationship('CourseLesson|CourseEndorsementLesson|CourseLessonId', 'CourseLesson', 'CourseLesson');
    };
export class CourseEndorsementStudentMetaData implements DwItem2<CourseEndorsementStudentEntity, CourseEndorsementStudentMetaDataAttributes,CourseEndorsementStudentMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=222;
        this.ItemDetail.itemName='CourseEndorsementStudent';
        this.ItemDetail.keyName='CourseEndorsementStudentId';
    }

    CreateEntity(): CourseEndorsementStudentEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CourseEndorsementStudentQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CourseEndorsementStudentEntity, CourseEndorsementStudentMetaDataAttributes,CourseEndorsementStudentMetaDataRelations>(query, this);
    }
     Attributes = new CourseEndorsementStudentMetaDataAttributes();
     Relations = new CourseEndorsementStudentMetaDataRelations();

}


export type CourseEndorsementStudentQueryBuilder = DwQueryBuilderGen<CourseEndorsementStudentEntity, CourseEndorsementStudentMetaDataAttributes,CourseEndorsementStudentMetaDataRelations>


export class CourseEndorsementStudentMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CourseEndorsementStudent';
    // Attributes
    CourseEndorsementStudentId = new DwItemAttribute(this.i, 'CourseEndorsementStudentId');
    CourseEndorsementId = new DwItemAttribute(this.i, 'CourseEndorsementId');
    StudentCourseId = new DwItemAttribute(this.i, 'StudentCourseId');
    CompletionDateTime = new DwItemAttribute(this.i, 'CompletionDateTime');
    ExpirationDateTime = new DwItemAttribute(this.i, 'ExpirationDateTime');
    EndorsementPDFMediaId = new DwItemAttribute(this.i, 'EndorsementPDFMediaId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    CourseEndorsementStudentStatusId = new DwItemAttribute(this.i, 'CourseEndorsementStudentStatusId');
}

class CourseEndorsementStudentMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Course Endorsement */
            CourseEndorsement = new DwItemRelationship('CourseEndorsement|CourseEndorsementStudent|CourseEndorsementId', 'CourseEndorsement', 'CourseEndorsement');
            /** Relation: Media - Endorsement P D F Media */
            DwMediaByEndorsementPDFMediaId = new DwItemRelationship('dw_Media|CourseEndorsementStudent|EndorsementPDFMediaId', 'EndorsementPDFDwMedia', 'EndorsementPDFDwMedia');
            /** Relation: Reference Status - Course Endorsement Student Status */
            ReferenceStatusByCourseEndorsementStudentStatusId = new DwItemRelationship('ReferenceStatus|CourseEndorsementStudent|CourseEndorsementStutudentStatusId', 'CourseEndorsementStudentStatusIdReferenceStatus', 'CourseEndorsementStudentStatusIdReferenceStatus');
            /** Relation: Student Course */
            StudentCourse = new DwItemRelationship('StudentCourse|CourseEndorsementStudent|StudentCourseId', 'StudentCourse', 'StudentCourse');
    };
export class CourseEndorsementTemplateMetaData implements DwItem2<CourseEndorsementTemplateEntity, CourseEndorsementTemplateMetaDataAttributes,CourseEndorsementTemplateMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=223;
        this.ItemDetail.itemName='CourseEndorsementTemplate';
        this.ItemDetail.keyName='CourseEndorsementTemplateId';
    }

    CreateEntity(): CourseEndorsementTemplateEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CourseEndorsementTemplateQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CourseEndorsementTemplateEntity, CourseEndorsementTemplateMetaDataAttributes,CourseEndorsementTemplateMetaDataRelations>(query, this);
    }
     Attributes = new CourseEndorsementTemplateMetaDataAttributes();
     Relations = new CourseEndorsementTemplateMetaDataRelations();

}


export type CourseEndorsementTemplateQueryBuilder = DwQueryBuilderGen<CourseEndorsementTemplateEntity, CourseEndorsementTemplateMetaDataAttributes,CourseEndorsementTemplateMetaDataRelations>


export class CourseEndorsementTemplateMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CourseEndorsementTemplate';
    // Attributes
    CourseEndorsementTemplateId = new DwItemAttribute(this.i, 'CourseEndorsementTemplateId');
    TemplateName = new DwItemAttribute(this.i, 'TemplateName');
    TemplatePDFMediaId = new DwItemAttribute(this.i, 'TemplatePDFMediaId');
    OverlayPDFMediaId = new DwItemAttribute(this.i, 'OverlayPDFMediaId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class CourseEndorsementTemplateMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Course Endorsement */
            CourseEndorsement = new DwItemRelationship('CourseEndorsementTemplate|CourseEndorsement|CourseEndorsementTemplateId', 'CourseEndorsement', 'CourseEndorsement');
            /** Relation: Course Endorsement Template Field */
            CourseEndorsementTemplateField = new DwItemRelationship('CourseEndorsementTemplate|CourseEndorsementTemplateField|CourseEndorsementTemplateId', 'CourseEndorsementTemplateField', 'CourseEndorsementTemplateField');
    };
export class CourseEndorsementTemplateFieldMetaData implements DwItem2<CourseEndorsementTemplateFieldEntity, CourseEndorsementTemplateFieldMetaDataAttributes,CourseEndorsementTemplateFieldMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=224;
        this.ItemDetail.itemName='CourseEndorsementTemplateField';
        this.ItemDetail.keyName='CourseEndorsementTemplateFieldId';
    }

    CreateEntity(): CourseEndorsementTemplateFieldEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CourseEndorsementTemplateFieldQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CourseEndorsementTemplateFieldEntity, CourseEndorsementTemplateFieldMetaDataAttributes,CourseEndorsementTemplateFieldMetaDataRelations>(query, this);
    }
     Attributes = new CourseEndorsementTemplateFieldMetaDataAttributes();
     Relations = new CourseEndorsementTemplateFieldMetaDataRelations();

}


export type CourseEndorsementTemplateFieldQueryBuilder = DwQueryBuilderGen<CourseEndorsementTemplateFieldEntity, CourseEndorsementTemplateFieldMetaDataAttributes,CourseEndorsementTemplateFieldMetaDataRelations>


export class CourseEndorsementTemplateFieldMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CourseEndorsementTemplateField';
    // Attributes
    CourseEndorsementTemplateFieldId = new DwItemAttribute(this.i, 'CourseEndorsementTemplateFieldId');
    CourseEndorsementTemplateId = new DwItemAttribute(this.i, 'CourseEndorsementTemplateId');
    TemplateFieldTypeId = new DwItemAttribute(this.i, 'TemplateFieldTypeId');
    TemplateFieldDefaultValue = new DwItemAttribute(this.i, 'TemplateFieldDefaultValue');
    MetaDataAttributeId = new DwItemAttribute(this.i, 'MetaDataAttributeId');
    TopPosition = new DwItemAttribute(this.i, 'TopPosition');
    LeftPosition = new DwItemAttribute(this.i, 'LeftPosition');
    RightPosition = new DwItemAttribute(this.i, 'RightPosition');
    Height = new DwItemAttribute(this.i, 'Height');
    TemplateFontStyleId = new DwItemAttribute(this.i, 'TemplateFontStyleId');
    TemplateFieldAlignmentId = new DwItemAttribute(this.i, 'TemplateFieldAlignmentId');
    ReferenceImageId = new DwItemAttribute(this.i, 'ReferenceImageId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class CourseEndorsementTemplateFieldMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Course Endorsement Template */
            CourseEndorsementTemplate = new DwItemRelationship('CourseEndorsementTemplate|CourseEndorsementTemplateField|CourseEndorsementTemplateId', 'CourseEndorsementTemplate', 'CourseEndorsementTemplate');
            /** Relation: Reference Image */
            ReferenceImage = new DwItemRelationship('ReferenceImage|CourseEndorsementTemplateField|ReferenceImageId', 'ReferenceImage', 'ReferenceImage');
            /** Relation: Template Field Alignment */
            TemplateFieldAlignment = new DwItemRelationship('TemplateFieldAlignment|CourseEndorsementTemplateField|TemplateFieldAlignmentId', 'TemplateFieldAlignment', 'TemplateFieldAlignment');
            /** Relation: Template Field Type */
            TemplateFieldType = new DwItemRelationship('TemplateFieldType|CourseEndorsementTemplateField|TemplateFieldTypeId', 'TemplateFieldType', 'TemplateFieldType');
            /** Relation: Template Font Style */
            TemplateFontStyle = new DwItemRelationship('TemplateFontStyle|CourseEndorsementTemplateField|TemplateFontStyleId', 'TemplateFontStyle', 'TemplateFontStyle');
    };
export class CourseLessonMetaData implements DwItem2<CourseLessonEntity, CourseLessonMetaDataAttributes,CourseLessonMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=153;
        this.ItemDetail.itemName='CourseLesson';
        this.ItemDetail.keyName='CourseLessonId';
    }

    CreateEntity(): CourseLessonEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CourseLessonQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CourseLessonEntity, CourseLessonMetaDataAttributes,CourseLessonMetaDataRelations>(query, this);
    }
     Attributes = new CourseLessonMetaDataAttributes();
     Relations = new CourseLessonMetaDataRelations();

}


export type CourseLessonQueryBuilder = DwQueryBuilderGen<CourseLessonEntity, CourseLessonMetaDataAttributes,CourseLessonMetaDataRelations>


export class CourseLessonMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CourseLesson';
    // Attributes
    CourseLessonId = new DwItemAttribute(this.i, 'CourseLessonId');
    CourseModuleId = new DwItemAttribute(this.i, 'CourseModuleId');
    LessonName = new DwItemAttribute(this.i, 'LessonName');
    LessonDescription = new DwItemAttribute(this.i, 'LessonDescription');
    LessonTypeId = new DwItemAttribute(this.i, 'LessonTypeId');
    VideoId = new DwItemAttribute(this.i, 'VideoId');
    QuizId = new DwItemAttribute(this.i, 'QuizId');
    LessonOrder = new DwItemAttribute(this.i, 'LessonOrder');
    LessonImageMediaId = new DwItemAttribute(this.i, 'LessonImageMediaId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    LessonReferebcePdfMediaId = new DwItemAttribute(this.i, 'LessonReferebcePdfMediaId');
    LessonReferenceNotes = new DwItemAttribute(this.i, 'LessonReferenceNotes');
    LessonStatusId = new DwItemAttribute(this.i, 'LessonStatusId');
    DocumentItemId = new DwItemAttribute(this.i, 'DocumentItemId');
    IsPreview = new DwItemAttribute(this.i, 'IsPreview');
    AIOverviewHtml = new DwItemAttribute(this.i, 'AIOverviewHtml');
    AIKeyConceptText = new DwItemAttribute(this.i, 'AIKeyConceptText');
    AIProcessingReferenceId = new DwItemAttribute(this.i, 'AIProcessingReferenceId');
    LessonBasicName = new DwItemAttribute(this.i, 'LessonBasicName');
}

class CourseLessonMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: AI Processing Reference */
            AIProcessingReference = new DwItemRelationship('AIProcessingReference|CourseLesson|AIProcessingReferenceId', 'AIProcessingReference', 'AIProcessingReference');
            /** Relation: Module */
            CourseModule = new DwItemRelationship('CourseModule|CourseLesson|CourseModuleId', 'CourseModule', 'CourseModule');
            /** Relation: Document Item */
            DocumentItem = new DwItemRelationship('DocumentItem|CourseLesson|DocumentItemId', 'DocumentItem', 'DocumentItem');
            /** Relation: Lesson Type */
            LessonType = new DwItemRelationship('LessonType|CourseLesson|LessonTypeId', 'LessonType', 'LessonType');
            /** Relation: Ro Media - Lesson Image Media */
            DwRoMediaByLessonImageMediaId = new DwItemRelationship('RoMedia|CourseLesson|LessonImageMediaId', 'LessonImageDwroMedia', 'LessonImageDwroMedia');
            /** Relation: Quiz */
            Quiz = new DwItemRelationship('Quiz|CourseLesson|QuizId', 'Quiz', 'Quiz');
            /** Relation: Reference Status - Lesson Status */
            ReferenceStatusByLessonStatusId = new DwItemRelationship('ReferenceStatus|CourseLesson|LessonStatusId', 'LessonStatusIdReferenceStatus', 'LessonStatusIdReferenceStatus');
            /** Relation: Video */
            Video = new DwItemRelationship('Video|CourseLesson|VideoId', 'Video', 'Video');
            /** Relation: Acs Task Multi Assign Lesson */
            AcsTaskMultiAssignLesson = new DwItemRelationship('CourseLesson|AcsTaskMultiAssignLesson|CourseLessonId', 'AcsTaskMultiAssignLesson', 'AcsTaskMultiAssignLesson');
            /** Relation: AI Prompt Request */
            AIPromptRequest = new DwItemRelationship('CourseLesson|AIPromptRequest|CourseLessonId', 'AIPromptRequest', 'AIPromptRequest');
            /** Relation: Assignment Course Lesson */
            AssignmentCourseLesson = new DwItemRelationship('CourseLesson|AssignmentCourseLesson|CourseLessonId', 'AssignmentCourseLesson', 'AssignmentCourseLesson');
            /** Relation: Course Endorsement Lesson */
            CourseEndorsementLesson = new DwItemRelationship('CourseLesson|CourseEndorsementLesson|CourseLessonId', 'CourseEndorsementLesson', 'CourseEndorsementLesson');
            /** Relation: Course Lesson Acs Task */
            CourseLessonAcsTask = new DwItemRelationship('CourseLesson|CourseLessonAcsTask|CourseLessonId', 'CourseLessonAcsTask', 'CourseLessonAcsTask');
            /** Relation: Course Lesson Document Link */
            CourseLessonDocumentLink = new DwItemRelationship('CourseLesson|CourseLessonDocumentLink|CourseLessonId', 'CourseLessonDocumentLink', 'CourseLessonDocumentLink');
            /** Relation: Course Lesson Flag */
            CourseLessonFlag = new DwItemRelationship('CourseLesson|CourseLessonFlag|CourseLessonId', 'CourseLessonFlag', 'CourseLessonFlag');
            /** Relation: Course Lesson Progress */
            CourseLessonProgress = new DwItemRelationship('CourseLesson|CourseLessonProgress|CourseLessonId', 'CourseLessonProgress', 'CourseLessonProgress');
            /** Relation: Document Link Processing Run Item */
            DocumentLinkProcessingRunItem = new DwItemRelationship('CourseLesson|DocumentLinkProcessingRunItem|CourseLessonId', 'DocumentLinkProcessingRunItem', 'DocumentLinkProcessingRunItem');
            /** Relation: Integration User Event - Cousre Lesson - Many */
            IntegrationUserEventByCousreLessonId = new DwItemRelationship('CourseLesson|IntegrationUserEvent|CousreLessonId', 'CousreLessonIdIntegrationUserEvent', 'CousreLessonIdIntegrationUserEvent');
            /** Relation: Ro Assignment Student Course Lesson Progress */
            RoAssignmentStudentCourseLessonProgress = new DwItemRelationship('Lesson|RoAssignmentStudentCourseLessonProgress', 'RoAssignmentStudentCourseLessonProgress', 'RoAssignmentStudentCourseLessonProgress');
            /** Relation: Student Course - Next - Many */
            StudentCourseByNextCourseLessonId = new DwItemRelationship('CourseLesson|StudentCourse|NextCourseLessonId', 'NextStudentCourse', 'NextStudentCourse');
    };
export class CourseLessonAcsTaskMetaData implements DwItem2<CourseLessonAcsTaskEntity, CourseLessonAcsTaskMetaDataAttributes,CourseLessonAcsTaskMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=333;
        this.ItemDetail.itemName='CourseLessonAcsTask';
        this.ItemDetail.keyName='CourseLessonAcsTaskId';
    }

    CreateEntity(): CourseLessonAcsTaskEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CourseLessonAcsTaskQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CourseLessonAcsTaskEntity, CourseLessonAcsTaskMetaDataAttributes,CourseLessonAcsTaskMetaDataRelations>(query, this);
    }
     Attributes = new CourseLessonAcsTaskMetaDataAttributes();
     Relations = new CourseLessonAcsTaskMetaDataRelations();

}


export type CourseLessonAcsTaskQueryBuilder = DwQueryBuilderGen<CourseLessonAcsTaskEntity, CourseLessonAcsTaskMetaDataAttributes,CourseLessonAcsTaskMetaDataRelations>


export class CourseLessonAcsTaskMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CourseLessonAcsTask';
    // Attributes
    CourseLessonAcsTaskId = new DwItemAttribute(this.i, 'CourseLessonAcsTaskId');
    CourseLessonId = new DwItemAttribute(this.i, 'CourseLessonId');
    AcsAreaOfOperationTaskId = new DwItemAttribute(this.i, 'AcsAreaOfOperationTaskId');
}

class CourseLessonAcsTaskMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Acs Area Of Operation Task */
            AcsAreaOfOperationTask = new DwItemRelationship('AcsAreaOfOperationTask|CourseLessonAcsTask|AcsAreaOfOperationTaskId', 'AcsAreaOfOperationTask', 'AcsAreaOfOperationTask');
            /** Relation: Lesson */
            CourseLesson = new DwItemRelationship('CourseLesson|CourseLessonAcsTask|CourseLessonId', 'CourseLesson', 'CourseLesson');
    };
export class CourseLessonDocumentLinkMetaData implements DwItem2<CourseLessonDocumentLinkEntity, CourseLessonDocumentLinkMetaDataAttributes,CourseLessonDocumentLinkMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=400;
        this.ItemDetail.itemName='CourseLessonDocumentLink';
        this.ItemDetail.keyName='CourseLessonDocumentLinkId';
    }

    CreateEntity(): CourseLessonDocumentLinkEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CourseLessonDocumentLinkQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CourseLessonDocumentLinkEntity, CourseLessonDocumentLinkMetaDataAttributes,CourseLessonDocumentLinkMetaDataRelations>(query, this);
    }
     Attributes = new CourseLessonDocumentLinkMetaDataAttributes();
     Relations = new CourseLessonDocumentLinkMetaDataRelations();

}


export type CourseLessonDocumentLinkQueryBuilder = DwQueryBuilderGen<CourseLessonDocumentLinkEntity, CourseLessonDocumentLinkMetaDataAttributes,CourseLessonDocumentLinkMetaDataRelations>


export class CourseLessonDocumentLinkMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CourseLessonDocumentLink';
    // Attributes
    CourseLessonDocumentLinkId = new DwItemAttribute(this.i, 'CourseLessonDocumentLinkId');
    CourseLessonId = new DwItemAttribute(this.i, 'CourseLessonId');
    DocumentItemId = new DwItemAttribute(this.i, 'DocumentItemId');
    PageNumbers = new DwItemAttribute(this.i, 'PageNumbers');
    FirstPageNumber = new DwItemAttribute(this.i, 'FirstPageNumber');
    AIConfidence = new DwItemAttribute(this.i, 'AIConfidence');
    AIMatchReason = new DwItemAttribute(this.i, 'AIMatchReason');
    AISupportingChunkIds = new DwItemAttribute(this.i, 'AISupportingChunkIds');
    CourseLessonDocumentLinkStatusId = new DwItemAttribute(this.i, 'CourseLessonDocumentLinkStatusId');
    ReferenceSummaryText = new DwItemAttribute(this.i, 'ReferenceSummaryText');
}

class CourseLessonDocumentLinkMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Lesson */
            CourseLesson = new DwItemRelationship('CourseLesson|CourseLessonDocumentLink|CourseLessonId', 'CourseLesson', 'CourseLesson');
            /** Relation: Document Item */
            DocumentItem = new DwItemRelationship('DocumentItem|CourseLessonDocumentLink|DocumentItemId', 'DocumentItem', 'DocumentItem');
            /** Relation: Reference Status - Course Lesson Document Link Status */
            ReferenceStatusByCourseLessonDocumentLinkStatusId = new DwItemRelationship('ReferenceStatus|CourseLessonDocumentLink|CourseLessonDocumentLinkStatusId', 'CourseLessonDocumentLinkStatusIdReferenceStatus', 'CourseLessonDocumentLinkStatusIdReferenceStatus');
            /** Relation: Course Lesson Document Link Reference */
            CourseLessonDocumentLinkReference = new DwItemRelationship('CourseLessonDocumentLink|CourseLessonDocumentLinkReference|CourseLessonDocumentLinkId', 'CourseLessonDocumentLinkReference', 'CourseLessonDocumentLinkReference');
            /** Relation: Document Link Processing Run Item */
            DocumentLinkProcessingRunItem = new DwItemRelationship('CourseLessonDocumentLink|DocumentLinkProcessingRunItem|CourseLessonDocumentLinkId', 'DocumentLinkProcessingRunItem', 'DocumentLinkProcessingRunItem');
    };
export class CourseLessonDocumentLinkReferenceMetaData implements DwItem2<CourseLessonDocumentLinkReferenceEntity, CourseLessonDocumentLinkReferenceMetaDataAttributes,CourseLessonDocumentLinkReferenceMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=465;
        this.ItemDetail.itemName='CourseLessonDocumentLinkReference';
        this.ItemDetail.keyName='CourseLessonDocumentLinkReferenceId';
    }

    CreateEntity(): CourseLessonDocumentLinkReferenceEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CourseLessonDocumentLinkReferenceQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CourseLessonDocumentLinkReferenceEntity, CourseLessonDocumentLinkReferenceMetaDataAttributes,CourseLessonDocumentLinkReferenceMetaDataRelations>(query, this);
    }
     Attributes = new CourseLessonDocumentLinkReferenceMetaDataAttributes();
     Relations = new CourseLessonDocumentLinkReferenceMetaDataRelations();

}


export type CourseLessonDocumentLinkReferenceQueryBuilder = DwQueryBuilderGen<CourseLessonDocumentLinkReferenceEntity, CourseLessonDocumentLinkReferenceMetaDataAttributes,CourseLessonDocumentLinkReferenceMetaDataRelations>


export class CourseLessonDocumentLinkReferenceMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CourseLessonDocumentLinkReference';
    // Attributes
    CourseLessonDocumentLinkReferenceId = new DwItemAttribute(this.i, 'CourseLessonDocumentLinkReferenceId');
    CourseLessonDocumentLinkId = new DwItemAttribute(this.i, 'CourseLessonDocumentLinkId');
    DocumentPublicationId = new DwItemAttribute(this.i, 'DocumentPublicationId');
    DocumentVersionId = new DwItemAttribute(this.i, 'DocumentVersionId');
    DocumentSectionId = new DwItemAttribute(this.i, 'DocumentSectionId');
    DocumentAnchorId = new DwItemAttribute(this.i, 'DocumentAnchorId');
    ReferenceLocatorText = new DwItemAttribute(this.i, 'ReferenceLocatorText');
    DisplayOrder = new DwItemAttribute(this.i, 'DisplayOrder');
    ReferenceStatusId = new DwItemAttribute(this.i, 'ReferenceStatusId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class CourseLessonDocumentLinkReferenceMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Course Lesson Document Link */
            CourseLessonDocumentLink = new DwItemRelationship('CourseLessonDocumentLink|CourseLessonDocumentLinkReference|CourseLessonDocumentLinkId', 'CourseLessonDocumentLink', 'CourseLessonDocumentLink');
            /** Relation: Document Anchor */
            DocumentAnchor = new DwItemRelationship('DocumentAnchor|CourseLessonDocumentLinkReference|DocumentAnchorId', 'DocumentAnchor', 'DocumentAnchor');
            /** Relation: Document Publication */
            DocumentPublication = new DwItemRelationship('DocumentPublication|CourseLessonDocumentLinkReference|DocumentPublicationId', 'DocumentPublication', 'DocumentPublication');
            /** Relation: Document Section */
            DocumentSection = new DwItemRelationship('DocumentSection|CourseLessonDocumentLinkReference|DocumentSectionId', 'DocumentSection', 'DocumentSection');
            /** Relation: Document Version */
            DocumentVersion = new DwItemRelationship('DocumentVersion|CourseLessonDocumentLinkReference|DocumentVersionId', 'DocumentVersion', 'DocumentVersion');
            /** Relation: Reference Status */
            ReferenceStatus = new DwItemRelationship('ReferenceStatus|CourseLessonDocumentLinkReference|ReferenceStatusId', 'ReferenceStatus', 'ReferenceStatus');
    };
export class CourseLessonFlagMetaData implements DwItem2<CourseLessonFlagEntity, CourseLessonFlagMetaDataAttributes,CourseLessonFlagMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=230;
        this.ItemDetail.itemName='CourseLessonFlag';
        this.ItemDetail.keyName='CourseLessonFlagId';
    }

    CreateEntity(): CourseLessonFlagEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CourseLessonFlagQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CourseLessonFlagEntity, CourseLessonFlagMetaDataAttributes,CourseLessonFlagMetaDataRelations>(query, this);
    }
     Attributes = new CourseLessonFlagMetaDataAttributes();
     Relations = new CourseLessonFlagMetaDataRelations();

}


export type CourseLessonFlagQueryBuilder = DwQueryBuilderGen<CourseLessonFlagEntity, CourseLessonFlagMetaDataAttributes,CourseLessonFlagMetaDataRelations>


export class CourseLessonFlagMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CourseLessonFlag';
    // Attributes
    CourseLessonFlagId = new DwItemAttribute(this.i, 'CourseLessonFlagId');
    CourseLessonId = new DwItemAttribute(this.i, 'CourseLessonId');
    QuizId = new DwItemAttribute(this.i, 'QuizId');
    QuestionId = new DwItemAttribute(this.i, 'QuestionId');
    FlagComment = new DwItemAttribute(this.i, 'FlagComment');
    CourseLessonFlagStatusId = new DwItemAttribute(this.i, 'CourseLessonFlagStatusId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    CourseLessonFlagTypeId = new DwItemAttribute(this.i, 'CourseLessonFlagTypeId');
    CourseId = new DwItemAttribute(this.i, 'CourseId');
}

class CourseLessonFlagMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Course */
            Course = new DwItemRelationship('Course|CourseLessonFlag|CourseId', 'Course', 'Course');
            /** Relation: Lesson */
            CourseLesson = new DwItemRelationship('CourseLesson|CourseLessonFlag|CourseLessonId', 'CourseLesson', 'CourseLesson');
            /** Relation: Course Lesson Flag Status */
            CourseLessonFlagStatus = new DwItemRelationship('CourseLessonFlagStatus|CourseLessonFlag|CourseLessonFlagStatusId', 'CourseLessonFlagStatus', 'CourseLessonFlagStatus');
            /** Relation: Course Lesson Flag Type */
            CourseLessonFlagType = new DwItemRelationship('CourseLessonFlagType|CourseLessonFlag|CourseLessonFlagTypeId', 'CourseLessonFlagType', 'CourseLessonFlagType');
            /** Relation: Question */
            Question = new DwItemRelationship('Question|CourseLessonFlag|QuestionId', 'Question', 'Question');
            /** Relation: Quiz */
            Quiz = new DwItemRelationship('Quiz|CourseLessonFlag|QuizId', 'Quiz', 'Quiz');
            /** Relation: User - Modified By */
            DwUserByModifiedBy = new DwItemRelationship('dw_User|CourseLessonFlag|ModifiedBy', 'ModifiedByDwUser', 'ModifiedByDwUser');
            /** Relation: User - Created By */
            DwUserByCreatedBy = new DwItemRelationship('dw_User|CourseLessonFlag|CreatedBy', 'CreatedByDwUser', 'CreatedByDwUser');
    };
export class CourseLessonFlagStatusMetaData implements DwItem2<CourseLessonFlagStatusEntity, CourseLessonFlagStatusMetaDataAttributes,CourseLessonFlagStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=232;
        this.ItemDetail.itemName='CourseLessonFlagStatus';
        this.ItemDetail.keyName='CourseLessonFlagStatusId';
    }

    CreateEntity(): CourseLessonFlagStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CourseLessonFlagStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CourseLessonFlagStatusEntity, CourseLessonFlagStatusMetaDataAttributes,CourseLessonFlagStatusMetaDataRelations>(query, this);
    }
     Attributes = new CourseLessonFlagStatusMetaDataAttributes();
     Relations = new CourseLessonFlagStatusMetaDataRelations();

}


export type CourseLessonFlagStatusQueryBuilder = DwQueryBuilderGen<CourseLessonFlagStatusEntity, CourseLessonFlagStatusMetaDataAttributes,CourseLessonFlagStatusMetaDataRelations>


export class CourseLessonFlagStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CourseLessonFlagStatus';
    // Attributes
    CourseLessonFlagStatusId = new DwItemAttribute(this.i, 'CourseLessonFlagStatusId');
    FlagStatus = new DwItemAttribute(this.i, 'FlagStatus');
}

class CourseLessonFlagStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Course Lesson Flag */
            CourseLessonFlag = new DwItemRelationship('CourseLessonFlagStatus|CourseLessonFlag|CourseLessonFlagStatusId', 'CourseLessonFlag', 'CourseLessonFlag');
    };
export class CourseLessonFlagTypeMetaData implements DwItem2<CourseLessonFlagTypeEntity, CourseLessonFlagTypeMetaDataAttributes,CourseLessonFlagTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=231;
        this.ItemDetail.itemName='CourseLessonFlagType';
        this.ItemDetail.keyName='CourseLessonFlagTypeId';
    }

    CreateEntity(): CourseLessonFlagTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CourseLessonFlagTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CourseLessonFlagTypeEntity, CourseLessonFlagTypeMetaDataAttributes,CourseLessonFlagTypeMetaDataRelations>(query, this);
    }
     Attributes = new CourseLessonFlagTypeMetaDataAttributes();
     Relations = new CourseLessonFlagTypeMetaDataRelations();

}


export type CourseLessonFlagTypeQueryBuilder = DwQueryBuilderGen<CourseLessonFlagTypeEntity, CourseLessonFlagTypeMetaDataAttributes,CourseLessonFlagTypeMetaDataRelations>


export class CourseLessonFlagTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CourseLessonFlagType';
    // Attributes
    CourseLessonFlagTypeId = new DwItemAttribute(this.i, 'CourseLessonFlagTypeId');
    FlagType = new DwItemAttribute(this.i, 'FlagType');
}

class CourseLessonFlagTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Course Lesson Flag */
            CourseLessonFlag = new DwItemRelationship('CourseLessonFlagType|CourseLessonFlag|CourseLessonFlagTypeId', 'CourseLessonFlag', 'CourseLessonFlag');
    };
export class CourseLessonProgressMetaData implements DwItem2<CourseLessonProgressEntity, CourseLessonProgressMetaDataAttributes,CourseLessonProgressMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=135;
        this.ItemDetail.itemName='CourseLessonProgress';
        this.ItemDetail.keyName='CourseLessonProgressId';
    }

    CreateEntity(): CourseLessonProgressEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CourseLessonProgressQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CourseLessonProgressEntity, CourseLessonProgressMetaDataAttributes,CourseLessonProgressMetaDataRelations>(query, this);
    }
     Attributes = new CourseLessonProgressMetaDataAttributes();
     Relations = new CourseLessonProgressMetaDataRelations();

}


export type CourseLessonProgressQueryBuilder = DwQueryBuilderGen<CourseLessonProgressEntity, CourseLessonProgressMetaDataAttributes,CourseLessonProgressMetaDataRelations>


export class CourseLessonProgressMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CourseLessonProgress';
    // Attributes
    CourseLessonProgressId = new DwItemAttribute(this.i, 'CourseLessonProgressId');
    CourseLessonId = new DwItemAttribute(this.i, 'CourseLessonId');
    CourseModuleProgressId = new DwItemAttribute(this.i, 'CourseModuleProgressId');
    LessonComplete = new DwItemAttribute(this.i, 'LessonComplete');
    VideoFurthestTimeSeconds = new DwItemAttribute(this.i, 'VideoFurthestTimeSeconds');
    BestQuizResultId = new DwItemAttribute(this.i, 'BestQuizResultId');
    LastActivityDateTime = new DwItemAttribute(this.i, 'LastActivityDateTime');
    LessonNotes = new DwItemAttribute(this.i, 'LessonNotes');
    PercentComplete = new DwItemAttribute(this.i, 'PercentComplete');
    TotalTimeSeconds = new DwItemAttribute(this.i, 'TotalTimeSeconds');
    FirstActivityDateTime = new DwItemAttribute(this.i, 'FirstActivityDateTime');
    CompletedDateTime = new DwItemAttribute(this.i, 'CompletedDateTime');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    LessonProgressStatusId = new DwItemAttribute(this.i, 'LessonProgressStatusId');
    CompletedQuizAttemptCount = new DwItemAttribute(this.i, 'CompletedQuizAttemptCount');
    PassedQuizAttemptCount = new DwItemAttribute(this.i, 'PassedQuizAttemptCount');
}

class CourseLessonProgressMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Lesson */
            CourseLesson = new DwItemRelationship('CourseLesson|CourseLessonProgress|CourseLessonId', 'CourseLesson', 'CourseLesson');
            /** Relation: Course Module Progress */
            CourseModuleProgress = new DwItemRelationship('CourseModuleProgress|CourseLessonProgress|CourseModuleProgressId', 'CourseModuleProgress', 'CourseModuleProgress');
            /** Relation: Quiz Result - Best Quiz Result */
            QuizResultByBestQuizResultId = new DwItemRelationship('QuizResult|CourseLessonProgress|BestQuizResultId', 'BestQuizResult', 'BestQuizResult');
            /** Relation: Reference Status - Lesson Progress Status */
            ReferenceStatusByLessonProgressStatusId = new DwItemRelationship('ReferenceStatus|CourseLessonProgress|LessonProgressStatusId', 'LessonProgressStatusIdReferenceStatus', 'LessonProgressStatusIdReferenceStatus');
            /** Relation: Course Lesson Session */
            CourseLessonSession = new DwItemRelationship('CourseLessonProgress|CourseLessonSession|CourseLessonProgressId', 'CourseLessonSession', 'CourseLessonSession');
            /** Relation: Quiz Result */
            QuizResult = new DwItemRelationship('CourseLessonProgress|QuizResult|CourseLessonProgressId', 'QuizResult', 'QuizResult');
            /** Relation: Ro Assignment Student Course Lesson Progress */
            RoAssignmentStudentCourseLessonProgress = new DwItemRelationship('CourseLessonProgress|RoAssignmentStudentCourseLessonProgress', 'RoAssignmentStudentCourseLessonProgress', 'RoAssignmentStudentCourseLessonProgress');
    };
export class CourseLessonSessionMetaData implements DwItem2<CourseLessonSessionEntity, CourseLessonSessionMetaDataAttributes,CourseLessonSessionMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=166;
        this.ItemDetail.itemName='CourseLessonSession';
        this.ItemDetail.keyName='CourseLessonSessionId';
    }

    CreateEntity(): CourseLessonSessionEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CourseLessonSessionQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CourseLessonSessionEntity, CourseLessonSessionMetaDataAttributes,CourseLessonSessionMetaDataRelations>(query, this);
    }
     Attributes = new CourseLessonSessionMetaDataAttributes();
     Relations = new CourseLessonSessionMetaDataRelations();

}


export type CourseLessonSessionQueryBuilder = DwQueryBuilderGen<CourseLessonSessionEntity, CourseLessonSessionMetaDataAttributes,CourseLessonSessionMetaDataRelations>


export class CourseLessonSessionMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CourseLessonSession';
    // Attributes
    CourseLessonSessionId = new DwItemAttribute(this.i, 'CourseLessonSessionId');
    CourseLessonProgressId = new DwItemAttribute(this.i, 'CourseLessonProgressId');
    LessonCompleted = new DwItemAttribute(this.i, 'LessonCompleted');
    VideoId = new DwItemAttribute(this.i, 'VideoId');
    VideoFurthestTimeSeconds = new DwItemAttribute(this.i, 'VideoFurthestTimeSeconds');
    QuizResultId = new DwItemAttribute(this.i, 'QuizResultId');
    SessionStartDateTime = new DwItemAttribute(this.i, 'SessionStartDateTime');
    SessionEndDateTime = new DwItemAttribute(this.i, 'SessionEndDateTime');
    TotalTimeSeconds = new DwItemAttribute(this.i, 'TotalTimeSeconds');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    LessonSessionStatusId = new DwItemAttribute(this.i, 'LessonSessionStatusId');
}

class CourseLessonSessionMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Course Lesson Progress */
            CourseLessonProgress = new DwItemRelationship('CourseLessonProgress|CourseLessonSession|CourseLessonProgressId', 'CourseLessonProgress', 'CourseLessonProgress');
            /** Relation: Quiz Result */
            QuizResult = new DwItemRelationship('QuizResult|CourseLessonSession|QuizResultId', 'QuizResult', 'QuizResult');
            /** Relation: Reference Status - Lesson Session Status */
            ReferenceStatusByLessonSessionStatusId = new DwItemRelationship('ReferenceStatus|CourseLessonSession|LessonSessionStatusId', 'LessonSessionStatusIdReferenceStatus', 'LessonSessionStatusIdReferenceStatus');
    };
export class CourseModificationHistoryMetaData implements DwItem2<CourseModificationHistoryEntity, CourseModificationHistoryMetaDataAttributes,CourseModificationHistoryMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=234;
        this.ItemDetail.itemName='CourseModificationHistory';
        this.ItemDetail.keyName='CourseModicationHistoryId';
    }

    CreateEntity(): CourseModificationHistoryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CourseModificationHistoryQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CourseModificationHistoryEntity, CourseModificationHistoryMetaDataAttributes,CourseModificationHistoryMetaDataRelations>(query, this);
    }
     Attributes = new CourseModificationHistoryMetaDataAttributes();
     Relations = new CourseModificationHistoryMetaDataRelations();

}


export type CourseModificationHistoryQueryBuilder = DwQueryBuilderGen<CourseModificationHistoryEntity, CourseModificationHistoryMetaDataAttributes,CourseModificationHistoryMetaDataRelations>


export class CourseModificationHistoryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CourseModificationHistory';
    // Attributes
    CourseModicationHistoryId = new DwItemAttribute(this.i, 'CourseModicationHistoryId');
    CourseId = new DwItemAttribute(this.i, 'CourseId');
    CourseChangeDateTime = new DwItemAttribute(this.i, 'CourseChangeDateTime');
    CourseChangeDetail = new DwItemAttribute(this.i, 'CourseChangeDetail');
    Processed = new DwItemAttribute(this.i, 'Processed');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class CourseModificationHistoryMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Course */
            Course = new DwItemRelationship('Course|CourseModificationHistory|CourseId', 'Course', 'Course');
    };
export class CourseModuleMetaData implements DwItem2<CourseModuleEntity, CourseModuleMetaDataAttributes,CourseModuleMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=152;
        this.ItemDetail.itemName='CourseModule';
        this.ItemDetail.keyName='CourseModuleId';
    }

    CreateEntity(): CourseModuleEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CourseModuleQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CourseModuleEntity, CourseModuleMetaDataAttributes,CourseModuleMetaDataRelations>(query, this);
    }
     Attributes = new CourseModuleMetaDataAttributes();
     Relations = new CourseModuleMetaDataRelations();

}


export type CourseModuleQueryBuilder = DwQueryBuilderGen<CourseModuleEntity, CourseModuleMetaDataAttributes,CourseModuleMetaDataRelations>


export class CourseModuleMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CourseModule';
    // Attributes
    CourseModuleId = new DwItemAttribute(this.i, 'CourseModuleId');
    CourseId = new DwItemAttribute(this.i, 'CourseId');
    ModuleName = new DwItemAttribute(this.i, 'ModuleName');
    ModuleDescription = new DwItemAttribute(this.i, 'ModuleDescription');
    ModuleImageMediaId = new DwItemAttribute(this.i, 'ModuleImageMediaId');
    ModuleOrder = new DwItemAttribute(this.i, 'ModuleOrder');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    ModuleStatusId = new DwItemAttribute(this.i, 'ModuleStatusId');
    TotalModuleTimeSeconds = new DwItemAttribute(this.i, 'TotalModuleTimeSeconds');
    TotalModuleVideoTimeSeconds = new DwItemAttribute(this.i, 'TotalModuleVideoTimeSeconds');
    TotalModuleQuizTimeSeconds = new DwItemAttribute(this.i, 'TotalModuleQuizTimeSeconds');
    AIOverviewHtml = new DwItemAttribute(this.i, 'AIOverviewHtml');
    AIKeyConceptText = new DwItemAttribute(this.i, 'AIKeyConceptText');
    AIProcessingReferenceId = new DwItemAttribute(this.i, 'AIProcessingReferenceId');
    ModuleBasicName = new DwItemAttribute(this.i, 'ModuleBasicName');
    DisableDocumentLinking = new DwItemAttribute(this.i, 'DisableDocumentLinking');
}

class CourseModuleMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: AI Processing Reference */
            AIProcessingReference = new DwItemRelationship('AIProcessingReference|CourseModule|AIProcessingReferenceId', 'AIProcessingReference', 'AIProcessingReference');
            /** Relation: Course */
            Course = new DwItemRelationship('Course|CourseModule|CourseId', 'Course', 'Course');
            /** Relation: Media - Module Image Media */
            DwMediaByModuleImageMediaId = new DwItemRelationship('dw_Media|CourseModule|ModuleImageMediaId', 'ModuleImageDwMedia', 'ModuleImageDwMedia');
            /** Relation: Ro Media - Module Image Media */
            DwRoMediaByModuleImageMediaId = new DwItemRelationship('CourseModule|roMedia', 'ModuleImageDwroMedia', 'ModuleImageDwroMedia');
            /** Relation: Reference Status - Module Status */
            ReferenceStatusByModuleStatusId = new DwItemRelationship('ReferenceStatus|CourseModule|ModuleStatusId', 'ModuleStatusIdReferenceStatus', 'ModuleStatusIdReferenceStatus');
            /** Relation: AI Prompt Request */
            AIPromptRequest = new DwItemRelationship('CourseModule|AIPromptRequest|CourseModuleId', 'AIPromptRequest', 'AIPromptRequest');
            /** Relation: Lesson */
            CourseLesson = new DwItemRelationship('CourseModule|CourseLesson|CourseModuleId', 'CourseLesson', 'CourseLesson');
            /** Relation: Course Module Document Item */
            CourseModuleDocumentItem = new DwItemRelationship('CourseModule|CourseModuleDocumentItem|CourseModuleId', 'CourseModuleDocumentItem', 'CourseModuleDocumentItem');
            /** Relation: Course Module Progress */
            CourseModuleProgress = new DwItemRelationship('CourseModule|CourseModuleProgress|CourseModuleId', 'CourseModuleProgress', 'CourseModuleProgress');
            /** Relation: Document Link Processing Run Item */
            DocumentLinkProcessingRunItem = new DwItemRelationship('CourseModule|DocumentLinkProcessingRunItem|CourseModuleId', 'DocumentLinkProcessingRunItem', 'DocumentLinkProcessingRunItem');
            /** Relation: Question */
            Question = new DwItemRelationship('CourseModule|Question|CourseModuleId', 'Question', 'Question');
            /** Relation: Student Module Summary */
            StudentModuleSummary = new DwItemRelationship('CourseModule|StudentModuleSummary|CourseModuleId', 'StudentModuleSummary', 'StudentModuleSummary');
    };
export class CourseModuleDocumentItemMetaData implements DwItem2<CourseModuleDocumentItemEntity, CourseModuleDocumentItemMetaDataAttributes,CourseModuleDocumentItemMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=404;
        this.ItemDetail.itemName='CourseModuleDocumentItem';
        this.ItemDetail.keyName='CourseModuleDocumentItemId';
    }

    CreateEntity(): CourseModuleDocumentItemEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CourseModuleDocumentItemQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CourseModuleDocumentItemEntity, CourseModuleDocumentItemMetaDataAttributes,CourseModuleDocumentItemMetaDataRelations>(query, this);
    }
     Attributes = new CourseModuleDocumentItemMetaDataAttributes();
     Relations = new CourseModuleDocumentItemMetaDataRelations();

}


export type CourseModuleDocumentItemQueryBuilder = DwQueryBuilderGen<CourseModuleDocumentItemEntity, CourseModuleDocumentItemMetaDataAttributes,CourseModuleDocumentItemMetaDataRelations>


export class CourseModuleDocumentItemMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CourseModuleDocumentItem';
    // Attributes
    CourseModuleDocumentItemId = new DwItemAttribute(this.i, 'CourseModuleDocumentItemId');
    CourseModuleId = new DwItemAttribute(this.i, 'CourseModuleId');
    CourseDocumentItemId = new DwItemAttribute(this.i, 'CourseDocumentItemId');
    AiProcessingReferenceId = new DwItemAttribute(this.i, 'AiProcessingReferenceId');
    CourseModuleDocumentItemStatusId = new DwItemAttribute(this.i, 'CourseModuleDocumentItemStatusId');
}

class CourseModuleDocumentItemMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: AI Processing Reference - A I Processing Reference */
            AIProcessingReferenceByAiProcessingReferenceId = new DwItemRelationship('AIProcessingReference|CourseModuleDocumentItem|AiProcessingReferenceId', 'AiProcessingReferenceIdAIProcessingReference', 'AiProcessingReferenceIdAIProcessingReference');
            /** Relation: Course Document Item */
            CourseDocumentItem = new DwItemRelationship('CourseDocumentItem|CourseModuleDocumentItem|CourseDocumentItemId', 'CourseDocumentItem', 'CourseDocumentItem');
            /** Relation: Module */
            CourseModule = new DwItemRelationship('CourseModule|CourseModuleDocumentItem|CourseModuleId', 'CourseModule', 'CourseModule');
            /** Relation: Reference Status - Course Module Document Item Status */
            ReferenceStatusByCourseModuleDocumentItemStatusId = new DwItemRelationship('ReferenceStatus|CourseModuleDocumentItem|CourseModuleDocumentItemStatusId', 'CourseModuleDocumentItemStatusIdReferenceStatus', 'CourseModuleDocumentItemStatusIdReferenceStatus');
    };
export class CourseModuleProgressMetaData implements DwItem2<CourseModuleProgressEntity, CourseModuleProgressMetaDataAttributes,CourseModuleProgressMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=134;
        this.ItemDetail.itemName='CourseModuleProgress';
        this.ItemDetail.keyName='CourseModuleProgressId';
    }

    CreateEntity(): CourseModuleProgressEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CourseModuleProgressQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CourseModuleProgressEntity, CourseModuleProgressMetaDataAttributes,CourseModuleProgressMetaDataRelations>(query, this);
    }
     Attributes = new CourseModuleProgressMetaDataAttributes();
     Relations = new CourseModuleProgressMetaDataRelations();

}


export type CourseModuleProgressQueryBuilder = DwQueryBuilderGen<CourseModuleProgressEntity, CourseModuleProgressMetaDataAttributes,CourseModuleProgressMetaDataRelations>


export class CourseModuleProgressMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CourseModuleProgress';
    // Attributes
    CourseModuleProgressId = new DwItemAttribute(this.i, 'CourseModuleProgressId');
    CourseModuleId = new DwItemAttribute(this.i, 'CourseModuleId');
    PercentComplete = new DwItemAttribute(this.i, 'PercentComplete');
    LessonsCompleted = new DwItemAttribute(this.i, 'LessonsCompleted');
    LessonsCount = new DwItemAttribute(this.i, 'LessonsCount');
    StudentCourseId = new DwItemAttribute(this.i, 'StudentCourseId');
    LastActivityDateTime = new DwItemAttribute(this.i, 'LastActivityDateTime');
    TotalTimeSeconds = new DwItemAttribute(this.i, 'TotalTimeSeconds');
    FirstActivityDateTime = new DwItemAttribute(this.i, 'FirstActivityDateTime');
    CompletedDateTime = new DwItemAttribute(this.i, 'CompletedDateTime');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    ModuleProgressStatusId = new DwItemAttribute(this.i, 'ModuleProgressStatusId');
    TotalVideoTimeSeconds = new DwItemAttribute(this.i, 'TotalVideoTimeSeconds');
    TotalQuizTimeSeconds = new DwItemAttribute(this.i, 'TotalQuizTimeSeconds');
    AISummaryLastProcessedDateTime = new DwItemAttribute(this.i, 'AISummaryLastProcessedDateTime');
    AIPromptRequestId = new DwItemAttribute(this.i, 'AIPromptRequestId');
}

class CourseModuleProgressMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: AI Prompt Request */
            AIPromptRequest = new DwItemRelationship('AIPromptRequest|CourseModuleProgress|AIPromptRequestId', 'AIPromptRequest', 'AIPromptRequest');
            /** Relation: Module */
            CourseModule = new DwItemRelationship('CourseModule|CourseModuleProgress|CourseModuleId', 'CourseModule', 'CourseModule');
            /** Relation: Reference Status - Module Progress Status */
            ReferenceStatusByModuleProgressStatusId = new DwItemRelationship('ReferenceStatus|CourseModuleProgress|ModuleProgressStatusId', 'ModuleProgressStatusIdReferenceStatus', 'ModuleProgressStatusIdReferenceStatus');
            /** Relation: Student Course */
            StudentCourse = new DwItemRelationship('StudentCourse|CourseModuleProgress|StudentCourseId', 'StudentCourse', 'StudentCourse');
            /** Relation: Course Lesson Progress */
            CourseLessonProgress = new DwItemRelationship('CourseModuleProgress|CourseLessonProgress|CourseModuleProgressId', 'CourseLessonProgress', 'CourseLessonProgress');
            /** Relation: Student Module Summary */
            StudentModuleSummary = new DwItemRelationship('CourseModuleProgress|StudentModuleSummary|CourseModuleProgressId', 'StudentModuleSummary', 'StudentModuleSummary');
    };
export class CoursePurchaseMetaData implements DwItem2<CoursePurchaseEntity, CoursePurchaseMetaDataAttributes,CoursePurchaseMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=284;
        this.ItemDetail.itemName='CoursePurchase';
        this.ItemDetail.keyName='CoursePurchaseId';
    }

    CreateEntity(): CoursePurchaseEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CoursePurchaseQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CoursePurchaseEntity, CoursePurchaseMetaDataAttributes,CoursePurchaseMetaDataRelations>(query, this);
    }
     Attributes = new CoursePurchaseMetaDataAttributes();
     Relations = new CoursePurchaseMetaDataRelations();

}


export type CoursePurchaseQueryBuilder = DwQueryBuilderGen<CoursePurchaseEntity, CoursePurchaseMetaDataAttributes,CoursePurchaseMetaDataRelations>


export class CoursePurchaseMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CoursePurchase';
    // Attributes
    CoursePurchaseId = new DwItemAttribute(this.i, 'CoursePurchaseId');
    AddCoursePackage = new DwItemAttribute(this.i, 'AddCoursePackage');
    PaymentPartyTypeId = new DwItemAttribute(this.i, 'PaymentPartyTypeId');
    InvoiceId = new DwItemAttribute(this.i, 'InvoiceId');
    UseFlightSchoolGroup = new DwItemAttribute(this.i, 'UseFlightSchoolGroup');
    FlightSchoolGroupId = new DwItemAttribute(this.i, 'FlightSchoolGroupId');
    DiscountCode = new DwItemAttribute(this.i, 'DiscountCode');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    StripeCheckoutSessionId = new DwItemAttribute(this.i, 'StripeCheckoutSessionId');
}

class CoursePurchaseMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School Group */
            FlightSchoolGroup = new DwItemRelationship('FlightSchoolGroup|CoursePurchase|FlightSchoolGroupId', 'FlightSchoolGroup', 'FlightSchoolGroup');
            /** Relation: Invoice */
            Invoice = new DwItemRelationship('Invoice|CoursePurchase|InvoiceId', 'Invoice', 'Invoice');
            /** Relation: Payment Party Type */
            PaymentPartyType = new DwItemRelationship('PaymentPartyType|CoursePurchase|PaymentPartyTypeId', 'PaymentPartyType', 'PaymentPartyType');
            /** Relation: Stripe Checkout Session */
            StripeCheckoutSession = new DwItemRelationship('StripeCheckoutSession|CoursePurchase|StripeCheckoutSessionId', 'StripeCheckoutSession', 'StripeCheckoutSession');
            /** Relation: Course Purchase Course */
            CoursePurchaseCourse = new DwItemRelationship('CoursePurchase|CoursePurchaseCourse|CoursePurchaseId', 'CoursePurchaseCourse', 'CoursePurchaseCourse');
            /** Relation: Course Purchase Package */
            CoursePurchasePackage = new DwItemRelationship('CoursePurchase|CoursePurchasePackage|CoursePurchaseId', 'CoursePurchasePackage', 'CoursePurchasePackage');
            /** Relation: Course Purchase Reservation */
            CoursePurchaseReservation = new DwItemRelationship('CoursePurchase|CoursePurchaseReservation|CoursePurchaseId', 'CoursePurchaseReservation', 'CoursePurchaseReservation');
            /** Relation: Course Purchase Student */
            CoursePurchaseStudent = new DwItemRelationship('CoursePurchase|CoursePurchaseStudent|CoursePurchaseId', 'CoursePurchaseStudent', 'CoursePurchaseStudent');
    };
export class CoursePurchaseBillingAttemptMetaData implements DwItem2<CoursePurchaseBillingAttemptEntity, CoursePurchaseBillingAttemptMetaDataAttributes,CoursePurchaseBillingAttemptMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=510;
        this.ItemDetail.itemName='CoursePurchaseBillingAttempt';
        this.ItemDetail.keyName='CoursePurchaseBillingAttemptId';
    }

    CreateEntity(): CoursePurchaseBillingAttemptEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CoursePurchaseBillingAttemptQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CoursePurchaseBillingAttemptEntity, CoursePurchaseBillingAttemptMetaDataAttributes,CoursePurchaseBillingAttemptMetaDataRelations>(query, this);
    }
     Attributes = new CoursePurchaseBillingAttemptMetaDataAttributes();
     Relations = new CoursePurchaseBillingAttemptMetaDataRelations();

}


export type CoursePurchaseBillingAttemptQueryBuilder = DwQueryBuilderGen<CoursePurchaseBillingAttemptEntity, CoursePurchaseBillingAttemptMetaDataAttributes,CoursePurchaseBillingAttemptMetaDataRelations>


export class CoursePurchaseBillingAttemptMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CoursePurchaseBillingAttempt';
    // Attributes
    CoursePurchaseBillingAttemptId = new DwItemAttribute(this.i, 'CoursePurchaseBillingAttemptId');
    CoursePurchaseReservationId = new DwItemAttribute(this.i, 'CoursePurchaseReservationId');
    OperationKey = new DwItemAttribute(this.i, 'OperationKey');
    AttemptNumber = new DwItemAttribute(this.i, 'AttemptNumber');
    StripeIdempotencyKey = new DwItemAttribute(this.i, 'StripeIdempotencyKey');
    RequestFingerprint = new DwItemAttribute(this.i, 'RequestFingerprint');
    CoursePurchaseBillingAttemptStatusId = new DwItemAttribute(this.i, 'CoursePurchaseBillingAttemptStatusId');
    StripeInvoiceRef = new DwItemAttribute(this.i, 'StripeInvoiceRef');
    StripePaymentIntentRef = new DwItemAttribute(this.i, 'StripePaymentIntentRef');
    StripeCheckoutSessionRef = new DwItemAttribute(this.i, 'StripeCheckoutSessionRef');
    LastErrorLogId = new DwItemAttribute(this.i, 'LastErrorLogId');
    LastErrorMessage = new DwItemAttribute(this.i, 'LastErrorMessage');
    CompletedUtc = new DwItemAttribute(this.i, 'CompletedUtc');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class CoursePurchaseBillingAttemptMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Course Purchase Billing Attempt Status */
            CoursePurchaseBillingAttemptStatus = new DwItemRelationship('CoursePurchaseBillingAttemptStatus|CoursePurchaseBillingAttempt|CoursePurchaseBillingAttemptStatusId', 'CoursePurchaseBillingAttemptStatus', 'CoursePurchaseBillingAttemptStatus');
            /** Relation: Course Purchase Reservation */
            CoursePurchaseReservation = new DwItemRelationship('CoursePurchaseReservation|CoursePurchaseBillingAttempt|CoursePurchaseReservationId', 'CoursePurchaseReservation', 'CoursePurchaseReservation');
    };
export class CoursePurchaseBillingAttemptStatusMetaData implements DwItem2<CoursePurchaseBillingAttemptStatusEntity, CoursePurchaseBillingAttemptStatusMetaDataAttributes,CoursePurchaseBillingAttemptStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=509;
        this.ItemDetail.itemName='CoursePurchaseBillingAttemptStatus';
        this.ItemDetail.keyName='CoursePurchaseBillingAttemptStatusId';
    }

    CreateEntity(): CoursePurchaseBillingAttemptStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CoursePurchaseBillingAttemptStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CoursePurchaseBillingAttemptStatusEntity, CoursePurchaseBillingAttemptStatusMetaDataAttributes,CoursePurchaseBillingAttemptStatusMetaDataRelations>(query, this);
    }
     Attributes = new CoursePurchaseBillingAttemptStatusMetaDataAttributes();
     Relations = new CoursePurchaseBillingAttemptStatusMetaDataRelations();

}


export type CoursePurchaseBillingAttemptStatusQueryBuilder = DwQueryBuilderGen<CoursePurchaseBillingAttemptStatusEntity, CoursePurchaseBillingAttemptStatusMetaDataAttributes,CoursePurchaseBillingAttemptStatusMetaDataRelations>


export class CoursePurchaseBillingAttemptStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CoursePurchaseBillingAttemptStatus';
    // Attributes
    CoursePurchaseBillingAttemptStatusId = new DwItemAttribute(this.i, 'CoursePurchaseBillingAttemptStatusId');
    CoursePurchaseBillingAttemptStatus = new DwItemAttribute(this.i, 'CoursePurchaseBillingAttemptStatus');
}

class CoursePurchaseBillingAttemptStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Course Purchase Billing Attempt */
            CoursePurchaseBillingAttempt = new DwItemRelationship('CoursePurchaseBillingAttemptStatus|CoursePurchaseBillingAttempt|CoursePurchaseBillingAttemptStatusId', 'CoursePurchaseBillingAttempt', 'CoursePurchaseBillingAttempt');
    };
export class CoursePurchaseCourseMetaData implements DwItem2<CoursePurchaseCourseEntity, CoursePurchaseCourseMetaDataAttributes,CoursePurchaseCourseMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=280;
        this.ItemDetail.itemName='CoursePurchaseCourse';
        this.ItemDetail.keyName='CoursePurchaseCourseId';
    }

    CreateEntity(): CoursePurchaseCourseEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CoursePurchaseCourseQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CoursePurchaseCourseEntity, CoursePurchaseCourseMetaDataAttributes,CoursePurchaseCourseMetaDataRelations>(query, this);
    }
     Attributes = new CoursePurchaseCourseMetaDataAttributes();
     Relations = new CoursePurchaseCourseMetaDataRelations();

}


export type CoursePurchaseCourseQueryBuilder = DwQueryBuilderGen<CoursePurchaseCourseEntity, CoursePurchaseCourseMetaDataAttributes,CoursePurchaseCourseMetaDataRelations>


export class CoursePurchaseCourseMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CoursePurchaseCourse';
    // Attributes
    CoursePurchaseCourseId = new DwItemAttribute(this.i, 'CoursePurchaseCourseId');
    CoursePurchaseId = new DwItemAttribute(this.i, 'CoursePurchaseId');
    CourseId = new DwItemAttribute(this.i, 'CourseId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class CoursePurchaseCourseMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Course */
            Course = new DwItemRelationship('Course|CoursePurchaseCourse|CourseId', 'Course', 'Course');
            /** Relation: Course Purchase */
            CoursePurchase = new DwItemRelationship('CoursePurchase|CoursePurchaseCourse|CoursePurchaseId', 'CoursePurchase', 'CoursePurchase');
    };
export class CoursePurchasePackageMetaData implements DwItem2<CoursePurchasePackageEntity, CoursePurchasePackageMetaDataAttributes,CoursePurchasePackageMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=285;
        this.ItemDetail.itemName='CoursePurchasePackage';
        this.ItemDetail.keyName='CoursePurchasePackageId';
    }

    CreateEntity(): CoursePurchasePackageEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CoursePurchasePackageQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CoursePurchasePackageEntity, CoursePurchasePackageMetaDataAttributes,CoursePurchasePackageMetaDataRelations>(query, this);
    }
     Attributes = new CoursePurchasePackageMetaDataAttributes();
     Relations = new CoursePurchasePackageMetaDataRelations();

}


export type CoursePurchasePackageQueryBuilder = DwQueryBuilderGen<CoursePurchasePackageEntity, CoursePurchasePackageMetaDataAttributes,CoursePurchasePackageMetaDataRelations>


export class CoursePurchasePackageMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CoursePurchasePackage';
    // Attributes
    CoursePurchasePackageId = new DwItemAttribute(this.i, 'CoursePurchasePackageId');
    CoursePurchaseId = new DwItemAttribute(this.i, 'CoursePurchaseId');
    PackageId = new DwItemAttribute(this.i, 'PackageId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class CoursePurchasePackageMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Course Purchase */
            CoursePurchase = new DwItemRelationship('CoursePurchase|CoursePurchasePackage|CoursePurchaseId', 'CoursePurchase', 'CoursePurchase');
            /** Relation: Package */
            Package = new DwItemRelationship('Package|CoursePurchasePackage|PackageId', 'Package', 'Package');
    };
export class CoursePurchaseReservationMetaData implements DwItem2<CoursePurchaseReservationEntity, CoursePurchaseReservationMetaDataAttributes,CoursePurchaseReservationMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=508;
        this.ItemDetail.itemName='CoursePurchaseReservation';
        this.ItemDetail.keyName='CoursePurchaseReservationId';
    }

    CreateEntity(): CoursePurchaseReservationEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CoursePurchaseReservationQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CoursePurchaseReservationEntity, CoursePurchaseReservationMetaDataAttributes,CoursePurchaseReservationMetaDataRelations>(query, this);
    }
     Attributes = new CoursePurchaseReservationMetaDataAttributes();
     Relations = new CoursePurchaseReservationMetaDataRelations();

}


export type CoursePurchaseReservationQueryBuilder = DwQueryBuilderGen<CoursePurchaseReservationEntity, CoursePurchaseReservationMetaDataAttributes,CoursePurchaseReservationMetaDataRelations>


export class CoursePurchaseReservationMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CoursePurchaseReservation';
    // Attributes
    CoursePurchaseReservationId = new DwItemAttribute(this.i, 'CoursePurchaseReservationId');
    RequestKey = new DwItemAttribute(this.i, 'RequestKey');
    RequestFingerprint = new DwItemAttribute(this.i, 'RequestFingerprint');
    CoursePurchaseId = new DwItemAttribute(this.i, 'CoursePurchaseId');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    PaymentPartyTypeId = new DwItemAttribute(this.i, 'PaymentPartyTypeId');
    CoursePurchaseReservationStatusId = new DwItemAttribute(this.i, 'CoursePurchaseReservationStatusId');
    InvoiceId = new DwItemAttribute(this.i, 'InvoiceId');
    WorkerToken = new DwItemAttribute(this.i, 'WorkerToken');
    WorkerLeaseExpiresUtc = new DwItemAttribute(this.i, 'WorkerLeaseExpiresUtc');
    LastAttemptUtc = new DwItemAttribute(this.i, 'LastAttemptUtc');
    LastErrorLogId = new DwItemAttribute(this.i, 'LastErrorLogId');
    LastErrorMessage = new DwItemAttribute(this.i, 'LastErrorMessage');
    FulfilledUtc = new DwItemAttribute(this.i, 'FulfilledUtc');
    ReleasedUtc = new DwItemAttribute(this.i, 'ReleasedUtc');
    ReleaseReason = new DwItemAttribute(this.i, 'ReleaseReason');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class CoursePurchaseReservationMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Course Purchase */
            CoursePurchase = new DwItemRelationship('CoursePurchase|CoursePurchaseReservation|CoursePurchaseId', 'CoursePurchase', 'CoursePurchase');
            /** Relation: Course Purchase Reservation Status */
            CoursePurchaseReservationStatus = new DwItemRelationship('CoursePurchaseReservationStatus|CoursePurchaseReservation|CoursePurchaseReservationStatusId', 'CoursePurchaseReservationStatus', 'CoursePurchaseReservationStatus');
            /** Relation: Flight School */
            FlightSchool = new DwItemRelationship('FlightSchool|CoursePurchaseReservation|FlightSchoolId', 'FlightSchool', 'FlightSchool');
            /** Relation: Invoice */
            Invoice = new DwItemRelationship('Invoice|CoursePurchaseReservation|InvoiceId', 'Invoice', 'Invoice');
            /** Relation: Payment Party Type */
            PaymentPartyType = new DwItemRelationship('PaymentPartyType|CoursePurchaseReservation|PaymentPartyTypeId', 'PaymentPartyType', 'PaymentPartyType');
            /** Relation: Course Purchase Billing Attempt */
            CoursePurchaseBillingAttempt = new DwItemRelationship('CoursePurchaseReservation|CoursePurchaseBillingAttempt|CoursePurchaseReservationId', 'CoursePurchaseBillingAttempt', 'CoursePurchaseBillingAttempt');
            /** Relation: Course Purchase Reservation Course */
            CoursePurchaseReservationCourse = new DwItemRelationship('CoursePurchaseReservation|CoursePurchaseReservationCourse|CoursePurchaseReservationId', 'CoursePurchaseReservationCourse', 'CoursePurchaseReservationCourse');
    };
export class CoursePurchaseReservationCourseMetaData implements DwItem2<CoursePurchaseReservationCourseEntity, CoursePurchaseReservationCourseMetaDataAttributes,CoursePurchaseReservationCourseMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=511;
        this.ItemDetail.itemName='CoursePurchaseReservationCourse';
        this.ItemDetail.keyName='CoursePurchaseReservationCourseId';
    }

    CreateEntity(): CoursePurchaseReservationCourseEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CoursePurchaseReservationCourseQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CoursePurchaseReservationCourseEntity, CoursePurchaseReservationCourseMetaDataAttributes,CoursePurchaseReservationCourseMetaDataRelations>(query, this);
    }
     Attributes = new CoursePurchaseReservationCourseMetaDataAttributes();
     Relations = new CoursePurchaseReservationCourseMetaDataRelations();

}


export type CoursePurchaseReservationCourseQueryBuilder = DwQueryBuilderGen<CoursePurchaseReservationCourseEntity, CoursePurchaseReservationCourseMetaDataAttributes,CoursePurchaseReservationCourseMetaDataRelations>


export class CoursePurchaseReservationCourseMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CoursePurchaseReservationCourse';
    // Attributes
    CoursePurchaseReservationCourseId = new DwItemAttribute(this.i, 'CoursePurchaseReservationCourseId');
    CoursePurchaseReservationId = new DwItemAttribute(this.i, 'CoursePurchaseReservationId');
    UserId = new DwItemAttribute(this.i, 'UserId');
    StudentId = new DwItemAttribute(this.i, 'StudentId');
    CourseId = new DwItemAttribute(this.i, 'CourseId');
    CoursePackageId = new DwItemAttribute(this.i, 'CoursePackageId');
    InvoiceLineId = new DwItemAttribute(this.i, 'InvoiceLineId');
    StudentCourseId = new DwItemAttribute(this.i, 'StudentCourseId');
    FulfilledUtc = new DwItemAttribute(this.i, 'FulfilledUtc');
    ReleasedUtc = new DwItemAttribute(this.i, 'ReleasedUtc');
    ReleaseReason = new DwItemAttribute(this.i, 'ReleaseReason');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class CoursePurchaseReservationCourseMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Course */
            Course = new DwItemRelationship('Course|CoursePurchaseReservationCourse|CourseId', 'Course', 'Course');
            /** Relation: Course Purchase Reservation */
            CoursePurchaseReservation = new DwItemRelationship('CoursePurchaseReservation|CoursePurchaseReservationCourse|CoursePurchaseReservationId', 'CoursePurchaseReservation', 'CoursePurchaseReservation');
            /** Relation: Invoice Line */
            InvoiceLine = new DwItemRelationship('InvoiceLine|CoursePurchaseReservationCourse|InvoiceLineId', 'InvoiceLine', 'InvoiceLine');
            /** Relation: Package - Course Package */
            PackageByCoursePackageId = new DwItemRelationship('Package|CoursePurchaseReservationCourse|CoursePackageId', 'CoursePackage', 'CoursePackage');
            /** Relation: Student */
            Student = new DwItemRelationship('Student|CoursePurchaseReservationCourse|StudentId', 'Student', 'Student');
            /** Relation: Student Course */
            StudentCourse = new DwItemRelationship('StudentCourse|CoursePurchaseReservationCourse|StudentCourseId', 'StudentCourse', 'StudentCourse');
            /** Relation: User */
            DwUser = new DwItemRelationship('dw_User|CoursePurchaseReservationCourse|UserId', 'DwUser', 'DwUser');
    };
export class CoursePurchaseReservationStatusMetaData implements DwItem2<CoursePurchaseReservationStatusEntity, CoursePurchaseReservationStatusMetaDataAttributes,CoursePurchaseReservationStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=507;
        this.ItemDetail.itemName='CoursePurchaseReservationStatus';
        this.ItemDetail.keyName='CoursePurchaseReservationStatusId';
    }

    CreateEntity(): CoursePurchaseReservationStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CoursePurchaseReservationStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CoursePurchaseReservationStatusEntity, CoursePurchaseReservationStatusMetaDataAttributes,CoursePurchaseReservationStatusMetaDataRelations>(query, this);
    }
     Attributes = new CoursePurchaseReservationStatusMetaDataAttributes();
     Relations = new CoursePurchaseReservationStatusMetaDataRelations();

}


export type CoursePurchaseReservationStatusQueryBuilder = DwQueryBuilderGen<CoursePurchaseReservationStatusEntity, CoursePurchaseReservationStatusMetaDataAttributes,CoursePurchaseReservationStatusMetaDataRelations>


export class CoursePurchaseReservationStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CoursePurchaseReservationStatus';
    // Attributes
    CoursePurchaseReservationStatusId = new DwItemAttribute(this.i, 'CoursePurchaseReservationStatusId');
    CoursePurchaseReservationStatus = new DwItemAttribute(this.i, 'CoursePurchaseReservationStatus');
}

class CoursePurchaseReservationStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Course Purchase Reservation */
            CoursePurchaseReservation = new DwItemRelationship('CoursePurchaseReservationStatus|CoursePurchaseReservation|CoursePurchaseReservationStatusId', 'CoursePurchaseReservation', 'CoursePurchaseReservation');
    };
export class CoursePurchaseStudentMetaData implements DwItem2<CoursePurchaseStudentEntity, CoursePurchaseStudentMetaDataAttributes,CoursePurchaseStudentMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=281;
        this.ItemDetail.itemName='CoursePurchaseStudent';
        this.ItemDetail.keyName='CoursePurchaseStudent';
    }

    CreateEntity(): CoursePurchaseStudentEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CoursePurchaseStudentQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CoursePurchaseStudentEntity, CoursePurchaseStudentMetaDataAttributes,CoursePurchaseStudentMetaDataRelations>(query, this);
    }
     Attributes = new CoursePurchaseStudentMetaDataAttributes();
     Relations = new CoursePurchaseStudentMetaDataRelations();

}


export type CoursePurchaseStudentQueryBuilder = DwQueryBuilderGen<CoursePurchaseStudentEntity, CoursePurchaseStudentMetaDataAttributes,CoursePurchaseStudentMetaDataRelations>


export class CoursePurchaseStudentMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CoursePurchaseStudent';
    // Attributes
    CoursePurchaseStudent = new DwItemAttribute(this.i, 'CoursePurchaseStudent');
    CoursePurchaseId = new DwItemAttribute(this.i, 'CoursePurchaseId');
    StudentId = new DwItemAttribute(this.i, 'StudentId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class CoursePurchaseStudentMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Course Purchase */
            CoursePurchase = new DwItemRelationship('CoursePurchase|CoursePurchaseStudent|CoursePurchaseId', 'CoursePurchase', 'CoursePurchase');
            /** Relation: Student */
            Student = new DwItemRelationship('Student|CoursePurchaseStudent|StudentId', 'Student', 'Student');
    };
export class CourseTypeMetaData implements DwItem2<CourseTypeEntity, CourseTypeMetaDataAttributes,CourseTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=146;
        this.ItemDetail.itemName='CourseType';
        this.ItemDetail.keyName='CourseTypeId';
    }

    CreateEntity(): CourseTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CourseTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CourseTypeEntity, CourseTypeMetaDataAttributes,CourseTypeMetaDataRelations>(query, this);
    }
     Attributes = new CourseTypeMetaDataAttributes();
     Relations = new CourseTypeMetaDataRelations();

}


export type CourseTypeQueryBuilder = DwQueryBuilderGen<CourseTypeEntity, CourseTypeMetaDataAttributes,CourseTypeMetaDataRelations>


export class CourseTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CourseType';
    // Attributes
    CourseTypeId = new DwItemAttribute(this.i, 'CourseTypeId');
    CourseType = new DwItemAttribute(this.i, 'CourseType');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class CourseTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Course */
            Course = new DwItemRelationship('CourseType|Course|CourseTypeId', 'Course', 'Course');
    };
export class DailyQuizMetaData implements DwItem2<DailyQuizEntity, DailyQuizMetaDataAttributes,DailyQuizMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=486;
        this.ItemDetail.itemName='DailyQuiz';
        this.ItemDetail.keyName='DailyQuizId';
    }

    CreateEntity(): DailyQuizEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DailyQuizQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DailyQuizEntity, DailyQuizMetaDataAttributes,DailyQuizMetaDataRelations>(query, this);
    }
     Attributes = new DailyQuizMetaDataAttributes();
     Relations = new DailyQuizMetaDataRelations();

}


export type DailyQuizQueryBuilder = DwQueryBuilderGen<DailyQuizEntity, DailyQuizMetaDataAttributes,DailyQuizMetaDataRelations>


export class DailyQuizMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'DailyQuiz';
    // Attributes
    DailyQuizId = new DwItemAttribute(this.i, 'DailyQuizId');
    StudentCourseId = new DwItemAttribute(this.i, 'StudentCourseId');
    DailyQuizDate = new DwItemAttribute(this.i, 'DailyQuizDate');
    AttemptCount = new DwItemAttribute(this.i, 'AttemptCount');
    MaxAttempts = new DwItemAttribute(this.i, 'MaxAttempts');
    PassingPercent = new DwItemAttribute(this.i, 'PassingPercent');
    BestQuizResultId = new DwItemAttribute(this.i, 'BestQuizResultId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    StudentId = new DwItemAttribute(this.i, 'StudentId');
}

class DailyQuizMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Quiz Result - Best Quiz Result */
            QuizResultByBestQuizResultId = new DwItemRelationship('QuizResult|DailyQuiz|BestQuizResultId', 'BestQuizResult', 'BestQuizResult');
            /** Relation: Student */
            Student = new DwItemRelationship('Student|DailyQuiz|StudentId', 'Student', 'Student');
            /** Relation: Student Course */
            StudentCourse = new DwItemRelationship('StudentCourse|DailyQuiz|StudentCourseId', 'StudentCourse', 'StudentCourse');
            /** Relation: Quiz Result */
            QuizResult = new DwItemRelationship('DailyQuiz|QuizResult|DailyQuizId', 'QuizResult', 'QuizResult');
    };
export class DiscountMetaData implements DwItem2<DiscountEntity, DiscountMetaDataAttributes,DiscountMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=264;
        this.ItemDetail.itemName='Discount';
        this.ItemDetail.keyName='DiscountId';
    }

    CreateEntity(): DiscountEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DiscountQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DiscountEntity, DiscountMetaDataAttributes,DiscountMetaDataRelations>(query, this);
    }
     Attributes = new DiscountMetaDataAttributes();
     Relations = new DiscountMetaDataRelations();

}


export type DiscountQueryBuilder = DwQueryBuilderGen<DiscountEntity, DiscountMetaDataAttributes,DiscountMetaDataRelations>


export class DiscountMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Discount';
    // Attributes
    DiscountId = new DwItemAttribute(this.i, 'DiscountId');
    DiscountName = new DwItemAttribute(this.i, 'DiscountName');
    DiscountCode = new DwItemAttribute(this.i, 'DiscountCode');
    StartDate = new DwItemAttribute(this.i, 'StartDate');
    EndDate = new DwItemAttribute(this.i, 'EndDate');
    AllowedUses = new DwItemAttribute(this.i, 'AllowedUses');
    CurrentUses = new DwItemAttribute(this.i, 'CurrentUses');
    AllowedUsesPerUser = new DwItemAttribute(this.i, 'AllowedUsesPerUser');
    AllowedUsesPerSchool = new DwItemAttribute(this.i, 'AllowedUsesPerSchool');
    LimitToUserId = new DwItemAttribute(this.i, 'LimitToUserId');
    LimitToFlightSchoolId = new DwItemAttribute(this.i, 'LimitToFlightSchoolId');
    ApplyToCourse = new DwItemAttribute(this.i, 'ApplyToCourse');
    ApplyToSubscription = new DwItemAttribute(this.i, 'ApplyToSubscription');
    CourseDiscountAmount = new DwItemAttribute(this.i, 'CourseDiscountAmount');
    CourseDiscountPercent = new DwItemAttribute(this.i, 'CourseDiscountPercent');
    SubscriptionDiscountAmount = new DwItemAttribute(this.i, 'SubscriptionDiscountAmount');
    SubscriptionDiscountPercent = new DwItemAttribute(this.i, 'SubscriptionDiscountPercent');
    SubscriptionTierId = new DwItemAttribute(this.i, 'SubscriptionTierId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    IsDefaultNewSchoolDiscount = new DwItemAttribute(this.i, 'IsDefaultNewSchoolDiscount');
    SubscriptionExpiresAfterMonths = new DwItemAttribute(this.i, 'SubscriptionExpiresAfterMonths');
    DiscountAppliedDescription = new DwItemAttribute(this.i, 'DiscountAppliedDescription');
    StripePromotionCodeId = new DwItemAttribute(this.i, 'StripePromotionCodeId');
    StripeCouponCodeId = new DwItemAttribute(this.i, 'StripeCouponCodeId');
}

class DiscountMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School - Limit To Flight School */
            FlightSchoolByLimitToFlightSchoolId = new DwItemRelationship('FlightSchool|Discount|LimitToFlightSchoolId', 'LimitToFlightSchool', 'LimitToFlightSchool');
            /** Relation: Subscription Tier */
            SubscriptionTier = new DwItemRelationship('SubscriptionTier|Discount|SubscriptionTierId', 'SubscriptionTier', 'SubscriptionTier');
            /** Relation: User - Limit To User */
            DwUserByLimitToUserId = new DwItemRelationship('dw_User|Discount|LimitToUserId', 'LimitToDwUser', 'LimitToDwUser');
            /** Relation: Discount Course */
            DiscountCourse = new DwItemRelationship('Discount|DiscountCourse|DiscountId', 'DiscountCourse', 'DiscountCourse');
            /** Relation: Discount Package */
            DiscountPackage = new DwItemRelationship('Discount|DiscountPackage|DiscountId', 'DiscountPackage', 'DiscountPackage');
            /** Relation: Discount Subscription Role */
            DiscountSubscriptionRole = new DwItemRelationship('Discount|DiscountSubscriptionRole|DiscountId', 'DiscountSubscriptionRole', 'DiscountSubscriptionRole');
            /** Relation: Discount Usage Flight School */
            DiscountUsageFlightSchool = new DwItemRelationship('Discount|DiscountUsageFlightSchool|DiscountId', 'DiscountUsageFlightSchool', 'DiscountUsageFlightSchool');
            /** Relation: Discount Usage User */
            DiscountUsageUser = new DwItemRelationship('Discount|DiscountUsageUser|DiscountId', 'DiscountUsageUser', 'DiscountUsageUser');
            /** Relation: Invoice Line */
            InvoiceLine = new DwItemRelationship('Discount|InvoiceLine|DiscountId', 'InvoiceLine', 'InvoiceLine');
            /** Relation: Stripe Checkout Session */
            StripeCheckoutSession = new DwItemRelationship('Discount|StripeCheckoutSession|DiscountId', 'StripeCheckoutSession', 'StripeCheckoutSession');
            /** Relation: Subscription */
            Subscription = new DwItemRelationship('Discount|Subscription|DiscountId', 'Subscription', 'Subscription');
    };
export class DiscountCourseMetaData implements DwItem2<DiscountCourseEntity, DiscountCourseMetaDataAttributes,DiscountCourseMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=265;
        this.ItemDetail.itemName='DiscountCourse';
        this.ItemDetail.keyName='DiscountCourseId';
    }

    CreateEntity(): DiscountCourseEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DiscountCourseQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DiscountCourseEntity, DiscountCourseMetaDataAttributes,DiscountCourseMetaDataRelations>(query, this);
    }
     Attributes = new DiscountCourseMetaDataAttributes();
     Relations = new DiscountCourseMetaDataRelations();

}


export type DiscountCourseQueryBuilder = DwQueryBuilderGen<DiscountCourseEntity, DiscountCourseMetaDataAttributes,DiscountCourseMetaDataRelations>


export class DiscountCourseMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'DiscountCourse';
    // Attributes
    DiscountCourseId = new DwItemAttribute(this.i, 'DiscountCourseId');
    DiscountId = new DwItemAttribute(this.i, 'DiscountId');
    CourseId = new DwItemAttribute(this.i, 'CourseId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class DiscountCourseMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Course */
            Course = new DwItemRelationship('Course|DiscountCourse|CourseId', 'Course', 'Course');
            /** Relation: Discount */
            Discount = new DwItemRelationship('Discount|DiscountCourse|DiscountId', 'Discount', 'Discount');
    };
export class DiscountPackageMetaData implements DwItem2<DiscountPackageEntity, DiscountPackageMetaDataAttributes,DiscountPackageMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=266;
        this.ItemDetail.itemName='DiscountPackage';
        this.ItemDetail.keyName='DiscountPackageId';
    }

    CreateEntity(): DiscountPackageEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DiscountPackageQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DiscountPackageEntity, DiscountPackageMetaDataAttributes,DiscountPackageMetaDataRelations>(query, this);
    }
     Attributes = new DiscountPackageMetaDataAttributes();
     Relations = new DiscountPackageMetaDataRelations();

}


export type DiscountPackageQueryBuilder = DwQueryBuilderGen<DiscountPackageEntity, DiscountPackageMetaDataAttributes,DiscountPackageMetaDataRelations>


export class DiscountPackageMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'DiscountPackage';
    // Attributes
    DiscountPackageId = new DwItemAttribute(this.i, 'DiscountPackageId');
    DiscountId = new DwItemAttribute(this.i, 'DiscountId');
    PackageId = new DwItemAttribute(this.i, 'PackageId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class DiscountPackageMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Discount */
            Discount = new DwItemRelationship('Discount|DiscountPackage|DiscountId', 'Discount', 'Discount');
            /** Relation: Package */
            Package = new DwItemRelationship('Package|DiscountPackage|PackageId', 'Package', 'Package');
    };
export class DiscountSubscriptionRoleMetaData implements DwItem2<DiscountSubscriptionRoleEntity, DiscountSubscriptionRoleMetaDataAttributes,DiscountSubscriptionRoleMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=263;
        this.ItemDetail.itemName='DiscountSubscriptionRole';
        this.ItemDetail.keyName='DiscountSubscriptionRoleId';
    }

    CreateEntity(): DiscountSubscriptionRoleEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DiscountSubscriptionRoleQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DiscountSubscriptionRoleEntity, DiscountSubscriptionRoleMetaDataAttributes,DiscountSubscriptionRoleMetaDataRelations>(query, this);
    }
     Attributes = new DiscountSubscriptionRoleMetaDataAttributes();
     Relations = new DiscountSubscriptionRoleMetaDataRelations();

}


export type DiscountSubscriptionRoleQueryBuilder = DwQueryBuilderGen<DiscountSubscriptionRoleEntity, DiscountSubscriptionRoleMetaDataAttributes,DiscountSubscriptionRoleMetaDataRelations>


export class DiscountSubscriptionRoleMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'DiscountSubscriptionRole';
    // Attributes
    DiscountSubscriptionRoleId = new DwItemAttribute(this.i, 'DiscountSubscriptionRoleId');
    DiscountId = new DwItemAttribute(this.i, 'DiscountId');
    SubscriptionRoleId = new DwItemAttribute(this.i, 'SubscriptionRoleId');
    DiscountAmount = new DwItemAttribute(this.i, 'DiscountAmount');
    DiscountPercent = new DwItemAttribute(this.i, 'DiscountPercent');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class DiscountSubscriptionRoleMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Discount */
            Discount = new DwItemRelationship('Discount|DiscountSubscriptionRole|DiscountId', 'Discount', 'Discount');
            /** Relation: Subscription Role */
            SubscriptionRole = new DwItemRelationship('SubscriptionRole|DiscountSubscriptionRole|SubscriptionRoleId', 'SubscriptionRole', 'SubscriptionRole');
    };
export class DiscountUsageFlightSchoolMetaData implements DwItem2<DiscountUsageFlightSchoolEntity, DiscountUsageFlightSchoolMetaDataAttributes,DiscountUsageFlightSchoolMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=262;
        this.ItemDetail.itemName='DiscountUsageFlightSchool';
        this.ItemDetail.keyName='DiscountUsageFlightSchoolId';
    }

    CreateEntity(): DiscountUsageFlightSchoolEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DiscountUsageFlightSchoolQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DiscountUsageFlightSchoolEntity, DiscountUsageFlightSchoolMetaDataAttributes,DiscountUsageFlightSchoolMetaDataRelations>(query, this);
    }
     Attributes = new DiscountUsageFlightSchoolMetaDataAttributes();
     Relations = new DiscountUsageFlightSchoolMetaDataRelations();

}


export type DiscountUsageFlightSchoolQueryBuilder = DwQueryBuilderGen<DiscountUsageFlightSchoolEntity, DiscountUsageFlightSchoolMetaDataAttributes,DiscountUsageFlightSchoolMetaDataRelations>


export class DiscountUsageFlightSchoolMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'DiscountUsageFlightSchool';
    // Attributes
    DiscountUsageFlightSchoolId = new DwItemAttribute(this.i, 'DiscountUsageFlightSchoolId');
    DiscountId = new DwItemAttribute(this.i, 'DiscountId');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    InvoiceLineId = new DwItemAttribute(this.i, 'InvoiceLineId');
    DiscountAppliedDateTime = new DwItemAttribute(this.i, 'DiscountAppliedDateTime');
    DiscountExpirationDateTime = new DwItemAttribute(this.i, 'DiscountExpirationDateTime');
}

class DiscountUsageFlightSchoolMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Discount */
            Discount = new DwItemRelationship('Discount|DiscountUsageFlightSchool|DiscountId', 'Discount', 'Discount');
            /** Relation: Flight School */
            FlightSchool = new DwItemRelationship('FlightSchool|DiscountUsageFlightSchool|FlightSchoolId', 'FlightSchool', 'FlightSchool');
            /** Relation: Invoice Line */
            InvoiceLine = new DwItemRelationship('InvoiceLine|DiscountUsageFlightSchool|InvoiceLineId', 'InvoiceLine', 'InvoiceLine');
    };
export class DiscountUsageUserMetaData implements DwItem2<DiscountUsageUserEntity, DiscountUsageUserMetaDataAttributes,DiscountUsageUserMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=261;
        this.ItemDetail.itemName='DiscountUsageUser';
        this.ItemDetail.keyName='DiscountUsageUserId';
    }

    CreateEntity(): DiscountUsageUserEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DiscountUsageUserQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DiscountUsageUserEntity, DiscountUsageUserMetaDataAttributes,DiscountUsageUserMetaDataRelations>(query, this);
    }
     Attributes = new DiscountUsageUserMetaDataAttributes();
     Relations = new DiscountUsageUserMetaDataRelations();

}


export type DiscountUsageUserQueryBuilder = DwQueryBuilderGen<DiscountUsageUserEntity, DiscountUsageUserMetaDataAttributes,DiscountUsageUserMetaDataRelations>


export class DiscountUsageUserMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'DiscountUsageUser';
    // Attributes
    DiscountUsageUserId = new DwItemAttribute(this.i, 'DiscountUsageUserId');
    DiscountId = new DwItemAttribute(this.i, 'DiscountId');
    UserId = new DwItemAttribute(this.i, 'UserId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class DiscountUsageUserMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Discount */
            Discount = new DwItemRelationship('Discount|DiscountUsageUser|DiscountId', 'Discount', 'Discount');
            /** Relation: User */
            DwUser = new DwItemRelationship('dw_User|DiscountUsageUser|UserId', 'DwUser', 'DwUser');
    };
export class DocumentAiProcessingStatusMetaData implements DwItem2<DocumentAiProcessingStatusEntity, DocumentAiProcessingStatusMetaDataAttributes,DocumentAiProcessingStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=407;
        this.ItemDetail.itemName='DocumentAiProcessingStatus';
        this.ItemDetail.keyName='DocumentAiProcessingStatusId';
    }

    CreateEntity(): DocumentAiProcessingStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DocumentAiProcessingStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DocumentAiProcessingStatusEntity, DocumentAiProcessingStatusMetaDataAttributes,DocumentAiProcessingStatusMetaDataRelations>(query, this);
    }
     Attributes = new DocumentAiProcessingStatusMetaDataAttributes();
     Relations = new DocumentAiProcessingStatusMetaDataRelations();

}


export type DocumentAiProcessingStatusQueryBuilder = DwQueryBuilderGen<DocumentAiProcessingStatusEntity, DocumentAiProcessingStatusMetaDataAttributes,DocumentAiProcessingStatusMetaDataRelations>


export class DocumentAiProcessingStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'DocumentAiProcessingStatus';
    // Attributes
    DocumentAiProcessingStatusId = new DwItemAttribute(this.i, 'DocumentAiProcessingStatusId');
    DocumentAiProcessingStatus = new DwItemAttribute(this.i, 'DocumentAiProcessingStatus');
}

class DocumentAiProcessingStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Document Item */
            DocumentItem = new DwItemRelationship('DocumentAiProcessingStatus|DocumentItem|DocumentAiProcessingStatusId', 'DocumentItem', 'DocumentItem');
    };
export class DocumentAnchorMetaData implements DwItem2<DocumentAnchorEntity, DocumentAnchorMetaDataAttributes,DocumentAnchorMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=445;
        this.ItemDetail.itemName='DocumentAnchor';
        this.ItemDetail.keyName='DocumentAnchorId';
    }

    CreateEntity(): DocumentAnchorEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DocumentAnchorQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DocumentAnchorEntity, DocumentAnchorMetaDataAttributes,DocumentAnchorMetaDataRelations>(query, this);
    }
     Attributes = new DocumentAnchorMetaDataAttributes();
     Relations = new DocumentAnchorMetaDataRelations();

}


export type DocumentAnchorQueryBuilder = DwQueryBuilderGen<DocumentAnchorEntity, DocumentAnchorMetaDataAttributes,DocumentAnchorMetaDataRelations>


export class DocumentAnchorMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'DocumentAnchor';
    // Attributes
    DocumentAnchorId = new DwItemAttribute(this.i, 'DocumentAnchorId');
    DocumentSectionId = new DwItemAttribute(this.i, 'DocumentSectionId');
    DocumentAnchorTypeId = new DwItemAttribute(this.i, 'DocumentAnchorTypeId');
    AnchorKey = new DwItemAttribute(this.i, 'AnchorKey');
    Label = new DwItemAttribute(this.i, 'Label');
    DisplayOrder = new DwItemAttribute(this.i, 'DisplayOrder');
    ReferenceStatusId = new DwItemAttribute(this.i, 'ReferenceStatusId');
}

class DocumentAnchorMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Document Anchor Type */
            DocumentAnchorType = new DwItemRelationship('DocumentAnchorType|DocumentAnchor|DocumentAnchorTypeId', 'DocumentAnchorType', 'DocumentAnchorType');
            /** Relation: Document Section */
            DocumentSection = new DwItemRelationship('DocumentSection|DocumentAnchor|DocumentSectionId', 'DocumentSection', 'DocumentSection');
            /** Relation: Reference Status */
            ReferenceStatus = new DwItemRelationship('ReferenceStatus|DocumentAnchor|ReferenceStatusId', 'ReferenceStatus', 'ReferenceStatus');
            /** Relation: Course Lesson Document Link Reference */
            CourseLessonDocumentLinkReference = new DwItemRelationship('DocumentAnchor|CourseLessonDocumentLinkReference|DocumentAnchorId', 'CourseLessonDocumentLinkReference', 'CourseLessonDocumentLinkReference');
    };
export class DocumentAnchorTypeMetaData implements DwItem2<DocumentAnchorTypeEntity, DocumentAnchorTypeMetaDataAttributes,DocumentAnchorTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=451;
        this.ItemDetail.itemName='DocumentAnchorType';
        this.ItemDetail.keyName='DocumentAnchorTypeId';
    }

    CreateEntity(): DocumentAnchorTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DocumentAnchorTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DocumentAnchorTypeEntity, DocumentAnchorTypeMetaDataAttributes,DocumentAnchorTypeMetaDataRelations>(query, this);
    }
     Attributes = new DocumentAnchorTypeMetaDataAttributes();
     Relations = new DocumentAnchorTypeMetaDataRelations();

}


export type DocumentAnchorTypeQueryBuilder = DwQueryBuilderGen<DocumentAnchorTypeEntity, DocumentAnchorTypeMetaDataAttributes,DocumentAnchorTypeMetaDataRelations>


export class DocumentAnchorTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'DocumentAnchorType';
    // Attributes
    DocumentAnchorTypeId = new DwItemAttribute(this.i, 'DocumentAnchorTypeId');
    DocumentAnchorType = new DwItemAttribute(this.i, 'DocumentAnchorType');
}

class DocumentAnchorTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Document Anchor */
            DocumentAnchor = new DwItemRelationship('DocumentAnchorType|DocumentAnchor|DocumentAnchorTypeId', 'DocumentAnchor', 'DocumentAnchor');
    };
export class DocumentAssetMetaData implements DwItem2<DocumentAssetEntity, DocumentAssetMetaDataAttributes,DocumentAssetMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=446;
        this.ItemDetail.itemName='DocumentAsset';
        this.ItemDetail.keyName='DocumentAssetId';
    }

    CreateEntity(): DocumentAssetEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DocumentAssetQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DocumentAssetEntity, DocumentAssetMetaDataAttributes,DocumentAssetMetaDataRelations>(query, this);
    }
     Attributes = new DocumentAssetMetaDataAttributes();
     Relations = new DocumentAssetMetaDataRelations();

}


export type DocumentAssetQueryBuilder = DwQueryBuilderGen<DocumentAssetEntity, DocumentAssetMetaDataAttributes,DocumentAssetMetaDataRelations>


export class DocumentAssetMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'DocumentAsset';
    // Attributes
    DocumentAssetId = new DwItemAttribute(this.i, 'DocumentAssetId');
    DocumentVersionId = new DwItemAttribute(this.i, 'DocumentVersionId');
    DocumentSectionId = new DwItemAttribute(this.i, 'DocumentSectionId');
    DocumentAssetTypeId = new DwItemAttribute(this.i, 'DocumentAssetTypeId');
    AssetKey = new DwItemAttribute(this.i, 'AssetKey');
    MediaId = new DwItemAttribute(this.i, 'MediaId');
    ReferenceStatusId = new DwItemAttribute(this.i, 'ReferenceStatusId');
}

class DocumentAssetMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Document Asset Type */
            DocumentAssetType = new DwItemRelationship('DocumentAssetType|DocumentAsset|DocumentAssetTypeId', 'DocumentAssetType', 'DocumentAssetType');
            /** Relation: Document Section */
            DocumentSection = new DwItemRelationship('DocumentSection|DocumentAsset|DocumentSectionId', 'DocumentSection', 'DocumentSection');
            /** Relation: Document Version */
            DocumentVersion = new DwItemRelationship('DocumentVersion|DocumentAsset|DocumentVersionId', 'DocumentVersion', 'DocumentVersion');
            /** Relation: Media */
            DwMedia = new DwItemRelationship('dw_Media|DocumentAsset|MediaId', 'DwMedia', 'DwMedia');
            /** Relation: Reference Status */
            ReferenceStatus = new DwItemRelationship('ReferenceStatus|DocumentAsset|ReferenceStatusId', 'ReferenceStatus', 'ReferenceStatus');
    };
export class DocumentAssetTypeMetaData implements DwItem2<DocumentAssetTypeEntity, DocumentAssetTypeMetaDataAttributes,DocumentAssetTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=450;
        this.ItemDetail.itemName='DocumentAssetType';
        this.ItemDetail.keyName='DocumentAssetTypeId';
    }

    CreateEntity(): DocumentAssetTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DocumentAssetTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DocumentAssetTypeEntity, DocumentAssetTypeMetaDataAttributes,DocumentAssetTypeMetaDataRelations>(query, this);
    }
     Attributes = new DocumentAssetTypeMetaDataAttributes();
     Relations = new DocumentAssetTypeMetaDataRelations();

}


export type DocumentAssetTypeQueryBuilder = DwQueryBuilderGen<DocumentAssetTypeEntity, DocumentAssetTypeMetaDataAttributes,DocumentAssetTypeMetaDataRelations>


export class DocumentAssetTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'DocumentAssetType';
    // Attributes
    DocumentAssetTypeId = new DwItemAttribute(this.i, 'DocumentAssetTypeId');
    DocumentAssetType = new DwItemAttribute(this.i, 'DocumentAssetType');
}

class DocumentAssetTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Document Asset */
            DocumentAsset = new DwItemRelationship('DocumentAssetType|DocumentAsset|DocumentAssetTypeId', 'DocumentAsset', 'DocumentAsset');
    };
export class DocumentChangeLogTypeMetaData implements DwItem2<DocumentChangeLogTypeEntity, DocumentChangeLogTypeMetaDataAttributes,DocumentChangeLogTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=391;
        this.ItemDetail.itemName='DocumentChangeLogType';
        this.ItemDetail.keyName='DocumentChangeLogTypeId';
    }

    CreateEntity(): DocumentChangeLogTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DocumentChangeLogTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DocumentChangeLogTypeEntity, DocumentChangeLogTypeMetaDataAttributes,DocumentChangeLogTypeMetaDataRelations>(query, this);
    }
     Attributes = new DocumentChangeLogTypeMetaDataAttributes();
     Relations = new DocumentChangeLogTypeMetaDataRelations();

}


export type DocumentChangeLogTypeQueryBuilder = DwQueryBuilderGen<DocumentChangeLogTypeEntity, DocumentChangeLogTypeMetaDataAttributes,DocumentChangeLogTypeMetaDataRelations>


export class DocumentChangeLogTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'DocumentChangeLogType';
    // Attributes
    DocumentChangeLogTypeId = new DwItemAttribute(this.i, 'DocumentChangeLogTypeId');
    DocumentChangeLogType = new DwItemAttribute(this.i, 'DocumentChangeLogType');
}

class DocumentChangeLogTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Document Folder Change Log - Change Log Type - Many */
            DocumentFolderChangeLogByChangeLogTypeId = new DwItemRelationship('DocumentChangeLogType|DocumentFolderChangeLog|ChangeLogTypeId', 'ChangeLogTypeIdDocumentFolderChangeLog', 'ChangeLogTypeIdDocumentFolderChangeLog');
            /** Relation: Document Item Change Log - Change Log Type - Many */
            DocumentItemChangeLogByChangeLogTypeId = new DwItemRelationship('DocumentChangeLogType|DocumentItemChangeLog|ChangeLogTypeId', 'ChangeLogTypeIdDocumentItemChangeLog', 'ChangeLogTypeIdDocumentItemChangeLog');
    };
export class DocumentContentFormatTypeMetaData implements DwItem2<DocumentContentFormatTypeEntity, DocumentContentFormatTypeMetaDataAttributes,DocumentContentFormatTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=449;
        this.ItemDetail.itemName='DocumentContentFormatType';
        this.ItemDetail.keyName='DocumentContentFormatTypeId';
    }

    CreateEntity(): DocumentContentFormatTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DocumentContentFormatTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DocumentContentFormatTypeEntity, DocumentContentFormatTypeMetaDataAttributes,DocumentContentFormatTypeMetaDataRelations>(query, this);
    }
     Attributes = new DocumentContentFormatTypeMetaDataAttributes();
     Relations = new DocumentContentFormatTypeMetaDataRelations();

}


export type DocumentContentFormatTypeQueryBuilder = DwQueryBuilderGen<DocumentContentFormatTypeEntity, DocumentContentFormatTypeMetaDataAttributes,DocumentContentFormatTypeMetaDataRelations>


export class DocumentContentFormatTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'DocumentContentFormatType';
    // Attributes
    DocumentContentFormatTypeId = new DwItemAttribute(this.i, 'DocumentContentFormatTypeId');
    DocumentContentFormatType = new DwItemAttribute(this.i, 'DocumentContentFormatType');
}

class DocumentContentFormatTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Document Section Content */
            DocumentSectionContent = new DwItemRelationship('DocumentContentFormatType|DocumentSectionContent|DocumentContentFormatTypeId', 'DocumentSectionContent', 'DocumentSectionContent');
    };
export class DocumentFolderMetaData implements DwItem2<DocumentFolderEntity, DocumentFolderMetaDataAttributes,DocumentFolderMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=382;
        this.ItemDetail.itemName='DocumentFolder';
        this.ItemDetail.keyName='DocumentFolderId';
    }

    CreateEntity(): DocumentFolderEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DocumentFolderQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DocumentFolderEntity, DocumentFolderMetaDataAttributes,DocumentFolderMetaDataRelations>(query, this);
    }
     Attributes = new DocumentFolderMetaDataAttributes();
     Relations = new DocumentFolderMetaDataRelations();

}


export type DocumentFolderQueryBuilder = DwQueryBuilderGen<DocumentFolderEntity, DocumentFolderMetaDataAttributes,DocumentFolderMetaDataRelations>


export class DocumentFolderMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'DocumentFolder';
    // Attributes
    DocumentFolderId = new DwItemAttribute(this.i, 'DocumentFolderId');
    DocumentGroupId = new DwItemAttribute(this.i, 'DocumentGroupId');
    ParentDocumentFolderId = new DwItemAttribute(this.i, 'ParentDocumentFolderId');
    FolderName = new DwItemAttribute(this.i, 'FolderName');
    FolderIconMediaId = new DwItemAttribute(this.i, 'FolderIconMediaId');
    DocumentItemStatusId = new DwItemAttribute(this.i, 'DocumentItemStatusId');
    DocumentOwnershipTypeId = new DwItemAttribute(this.i, 'DocumentOwnershipTypeId');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class DocumentFolderMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Document Group */
            DocumentGroup = new DwItemRelationship('DocumentGroup|DocumentFolder|DocumentGroupId', 'DocumentGroup', 'DocumentGroup');
            /** Relation: Document Item Status */
            DocumentItemStatus = new DwItemRelationship('DocumentItemStatus|DocumentFolder|DocumentItemStatusId', 'DocumentItemStatus', 'DocumentItemStatus');
            /** Relation: Document Owner Type - Document Ownership Type */
            DocumentOwnerTypeByDocumentOwnershipTypeId = new DwItemRelationship('DocumentOwnerType|DocumentFolder|DocumentOwnershipTypeId', 'DocumentOwnershipTypeIdDocumentOwnerType', 'DocumentOwnershipTypeIdDocumentOwnerType');
            /** Relation: Flight School */
            FlightSchool = new DwItemRelationship('FlightSchool|DocumentFolder|FlightSchoolId', 'FlightSchool', 'FlightSchool');
            /** Relation: Media - Folder Icon Media */
            DwMediaByFolderIconMediaId = new DwItemRelationship('dw_Media|DocumentFolder|FolderIconMediaId', 'FolderIconDwMedia', 'FolderIconDwMedia');
            /** Relation: Document Folder - Parent Document Folder - One */
            DocumentFolderByParentDocumentFolderId = new DwItemRelationship('DocumentFolder|DocumentFolder|ParentDocumentFolderId', 'ParentDocumentFolder', 'ParentDocumentFolder');
            /** Relation: Document Folder Change Log */
            DocumentFolderChangeLog = new DwItemRelationship('DocumentFolder|DocumentFolderChangeLog|DocumentFolderId', 'DocumentFolderChangeLog', 'DocumentFolderChangeLog');
            /** Relation: Document Item - Parent - Many */
            DocumentItemByParentDocumentFolderId = new DwItemRelationship('DocumentFolder|DocumentItem|ParentDocumentFolderId', 'ParentDocumentItem', 'ParentDocumentItem');
    };
export class DocumentFolderChangeLogMetaData implements DwItem2<DocumentFolderChangeLogEntity, DocumentFolderChangeLogMetaDataAttributes,DocumentFolderChangeLogMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=390;
        this.ItemDetail.itemName='DocumentFolderChangeLog';
        this.ItemDetail.keyName='DocumentFolderChangeLogId';
    }

    CreateEntity(): DocumentFolderChangeLogEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DocumentFolderChangeLogQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DocumentFolderChangeLogEntity, DocumentFolderChangeLogMetaDataAttributes,DocumentFolderChangeLogMetaDataRelations>(query, this);
    }
     Attributes = new DocumentFolderChangeLogMetaDataAttributes();
     Relations = new DocumentFolderChangeLogMetaDataRelations();

}


export type DocumentFolderChangeLogQueryBuilder = DwQueryBuilderGen<DocumentFolderChangeLogEntity, DocumentFolderChangeLogMetaDataAttributes,DocumentFolderChangeLogMetaDataRelations>


export class DocumentFolderChangeLogMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'DocumentFolderChangeLog';
    // Attributes
    DocumentFolderChangeLogId = new DwItemAttribute(this.i, 'DocumentFolderChangeLogId');
    DocumentFolderId = new DwItemAttribute(this.i, 'DocumentFolderId');
    ChangeLogTypeId = new DwItemAttribute(this.i, 'ChangeLogTypeId');
    ChangeLogText = new DwItemAttribute(this.i, 'ChangeLogText');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreateDateTime = new DwItemAttribute(this.i, 'CreateDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class DocumentFolderChangeLogMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Document Change Log Type - Change Log Type */
            DocumentChangeLogTypeByChangeLogTypeId = new DwItemRelationship('DocumentChangeLogType|DocumentFolderChangeLog|ChangeLogTypeId', 'ChangeLogTypeIdDocumentChangeLogType', 'ChangeLogTypeIdDocumentChangeLogType');
            /** Relation: Document Folder */
            DocumentFolder = new DwItemRelationship('DocumentFolder|DocumentFolderChangeLog|DocumentFolderId', 'DocumentFolder', 'DocumentFolder');
    };
export class DocumentGroupMetaData implements DwItem2<DocumentGroupEntity, DocumentGroupMetaDataAttributes,DocumentGroupMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=372;
        this.ItemDetail.itemName='DocumentGroup';
        this.ItemDetail.keyName='DocumentGroupId';
    }

    CreateEntity(): DocumentGroupEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DocumentGroupQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DocumentGroupEntity, DocumentGroupMetaDataAttributes,DocumentGroupMetaDataRelations>(query, this);
    }
     Attributes = new DocumentGroupMetaDataAttributes();
     Relations = new DocumentGroupMetaDataRelations();

}


export type DocumentGroupQueryBuilder = DwQueryBuilderGen<DocumentGroupEntity, DocumentGroupMetaDataAttributes,DocumentGroupMetaDataRelations>


export class DocumentGroupMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'DocumentGroup';
    // Attributes
    DocumentGroupId = new DwItemAttribute(this.i, 'DocumentGroupId');
    DocumentGroupName = new DwItemAttribute(this.i, 'DocumentGroupName');
    IsDefault = new DwItemAttribute(this.i, 'IsDefault');
    AllowSchoolDocuments = new DwItemAttribute(this.i, 'AllowSchoolDocuments');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class DocumentGroupMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Document Folder */
            DocumentFolder = new DwItemRelationship('DocumentGroup|DocumentFolder|DocumentGroupId', 'DocumentFolder', 'DocumentFolder');
            /** Relation: Document Item */
            DocumentItem = new DwItemRelationship('DocumentGroup|DocumentItem|DocumentGroupId', 'DocumentItem', 'DocumentItem');
    };
export class DocumentImportJobMetaData implements DwItem2<DocumentImportJobEntity, DocumentImportJobMetaDataAttributes,DocumentImportJobMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=447;
        this.ItemDetail.itemName='DocumentImportJob';
        this.ItemDetail.keyName='DocumentImportJobId';
    }

    CreateEntity(): DocumentImportJobEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DocumentImportJobQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DocumentImportJobEntity, DocumentImportJobMetaDataAttributes,DocumentImportJobMetaDataRelations>(query, this);
    }
     Attributes = new DocumentImportJobMetaDataAttributes();
     Relations = new DocumentImportJobMetaDataRelations();

}


export type DocumentImportJobQueryBuilder = DwQueryBuilderGen<DocumentImportJobEntity, DocumentImportJobMetaDataAttributes,DocumentImportJobMetaDataRelations>


export class DocumentImportJobMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'DocumentImportJob';
    // Attributes
    DocumentImportJobId = new DwItemAttribute(this.i, 'DocumentImportJobId');
    DocumentPublicationId = new DwItemAttribute(this.i, 'DocumentPublicationId');
    DocumentImportJobTypeId = new DwItemAttribute(this.i, 'DocumentImportJobTypeId');
    DocumentImportJobStatusId = new DwItemAttribute(this.i, 'DocumentImportJobStatusId');
    StartedDateTime = new DwItemAttribute(this.i, 'StartedDateTime');
    CompletedDateTime = new DwItemAttribute(this.i, 'CompletedDateTime');
    ImportedDocumentVersionId = new DwItemAttribute(this.i, 'ImportedDocumentVersionId');
    ErrorText = new DwItemAttribute(this.i, 'ErrorText');
    LastUpdatedDateTime = new DwItemAttribute(this.i, 'LastUpdatedDateTime');
    ProgressText = new DwItemAttribute(this.i, 'ProgressText');
    LastErrorLogId = new DwItemAttribute(this.i, 'LastErrorLogId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class DocumentImportJobMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Document Import Job Status */
            DocumentImportJobStatus = new DwItemRelationship('DocumentImportJobStatus|DocumentImportJob|DocumentImportJobStatusId', 'DocumentImportJobStatus', 'DocumentImportJobStatus');
            /** Relation: Document Import Job Type */
            DocumentImportJobType = new DwItemRelationship('DocumentImportJobType|DocumentImportJob|DocumentImportJobTypeId', 'DocumentImportJobType', 'DocumentImportJobType');
            /** Relation: Document Publication */
            DocumentPublication = new DwItemRelationship('DocumentPublication|DocumentImportJob|DocumentPublicationId', 'DocumentPublication', 'DocumentPublication');
            /** Relation: Document Version - Imported Document Version */
            DocumentVersionByImportedDocumentVersionId = new DwItemRelationship('DocumentVersion|DocumentImportJob|ImportedDocumentVersionId', 'ImportedDocumentVersion', 'ImportedDocumentVersion');
    };
export class DocumentImportJobStatusMetaData implements DwItem2<DocumentImportJobStatusEntity, DocumentImportJobStatusMetaDataAttributes,DocumentImportJobStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=454;
        this.ItemDetail.itemName='DocumentImportJobStatus';
        this.ItemDetail.keyName='DocumentImportJobStatusId';
    }

    CreateEntity(): DocumentImportJobStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DocumentImportJobStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DocumentImportJobStatusEntity, DocumentImportJobStatusMetaDataAttributes,DocumentImportJobStatusMetaDataRelations>(query, this);
    }
     Attributes = new DocumentImportJobStatusMetaDataAttributes();
     Relations = new DocumentImportJobStatusMetaDataRelations();

}


export type DocumentImportJobStatusQueryBuilder = DwQueryBuilderGen<DocumentImportJobStatusEntity, DocumentImportJobStatusMetaDataAttributes,DocumentImportJobStatusMetaDataRelations>


export class DocumentImportJobStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'DocumentImportJobStatus';
    // Attributes
    DocumentImportJobStatusId = new DwItemAttribute(this.i, 'DocumentImportJobStatusId');
    DocumentImportJobStatus = new DwItemAttribute(this.i, 'DocumentImportJobStatus');
}

class DocumentImportJobStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Document Import Job */
            DocumentImportJob = new DwItemRelationship('DocumentImportJobStatus|DocumentImportJob|DocumentImportJobStatusId', 'DocumentImportJob', 'DocumentImportJob');
    };
export class DocumentImportJobTypeMetaData implements DwItem2<DocumentImportJobTypeEntity, DocumentImportJobTypeMetaDataAttributes,DocumentImportJobTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=453;
        this.ItemDetail.itemName='DocumentImportJobType';
        this.ItemDetail.keyName='DocumentImportJobTypeId';
    }

    CreateEntity(): DocumentImportJobTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DocumentImportJobTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DocumentImportJobTypeEntity, DocumentImportJobTypeMetaDataAttributes,DocumentImportJobTypeMetaDataRelations>(query, this);
    }
     Attributes = new DocumentImportJobTypeMetaDataAttributes();
     Relations = new DocumentImportJobTypeMetaDataRelations();

}


export type DocumentImportJobTypeQueryBuilder = DwQueryBuilderGen<DocumentImportJobTypeEntity, DocumentImportJobTypeMetaDataAttributes,DocumentImportJobTypeMetaDataRelations>


export class DocumentImportJobTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'DocumentImportJobType';
    // Attributes
    DocumentImportJobTypeId = new DwItemAttribute(this.i, 'DocumentImportJobTypeId');
    DocumentImportJobType = new DwItemAttribute(this.i, 'DocumentImportJobType');
}

class DocumentImportJobTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Document Import Job */
            DocumentImportJob = new DwItemRelationship('DocumentImportJobType|DocumentImportJob|DocumentImportJobTypeId', 'DocumentImportJob', 'DocumentImportJob');
    };
export class DocumentItemMetaData implements DwItem2<DocumentItemEntity, DocumentItemMetaDataAttributes,DocumentItemMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=373;
        this.ItemDetail.itemName='DocumentItem';
        this.ItemDetail.keyName='DocumentItemId';
    }

    CreateEntity(): DocumentItemEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DocumentItemQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DocumentItemEntity, DocumentItemMetaDataAttributes,DocumentItemMetaDataRelations>(query, this);
    }
     Attributes = new DocumentItemMetaDataAttributes();
     Relations = new DocumentItemMetaDataRelations();

}


export type DocumentItemQueryBuilder = DwQueryBuilderGen<DocumentItemEntity, DocumentItemMetaDataAttributes,DocumentItemMetaDataRelations>


export class DocumentItemMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'DocumentItem';
    // Attributes
    DocumentItemId = new DwItemAttribute(this.i, 'DocumentItemId');
    DocumentGroupId = new DwItemAttribute(this.i, 'DocumentGroupId');
    DocumentItemName = new DwItemAttribute(this.i, 'DocumentItemName');
    MediaId = new DwItemAttribute(this.i, 'MediaId');
    CardIconMediaId = new DwItemAttribute(this.i, 'CardIconMediaId');
    DocumentTypeId = new DwItemAttribute(this.i, 'DocumentTypeId');
    DocumentItemStatusId = new DwItemAttribute(this.i, 'DocumentItemStatusId');
    EmbeddedMarkup = new DwItemAttribute(this.i, 'EmbeddedMarkup');
    ExtractedImageMediaId = new DwItemAttribute(this.i, 'ExtractedImageMediaId');
    UseCustomCardIcon = new DwItemAttribute(this.i, 'UseCustomCardIcon');
    DocumentOwnershipTypeId = new DwItemAttribute(this.i, 'DocumentOwnershipTypeId');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    ParentDocumentFolderId = new DwItemAttribute(this.i, 'ParentDocumentFolderId');
    RequireStudentAcknowledgement = new DwItemAttribute(this.i, 'RequireStudentAcknowledgement');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    AiProcessingReferenceId = new DwItemAttribute(this.i, 'AiProcessingReferenceId');
    DocumentFileHash = new DwItemAttribute(this.i, 'DocumentFileHash');
    DocumentAiComplete = new DwItemAttribute(this.i, 'DocumentAiComplete');
    DocumentAiProcessingStatusId = new DwItemAttribute(this.i, 'DocumentAiProcessingStatusId');
    DocumentAiProcessingProgressText = new DwItemAttribute(this.i, 'DocumentAiProcessingProgressText');
    DocumentAiProcessingErrorText = new DwItemAttribute(this.i, 'DocumentAiProcessingErrorText');
    DocumentAiProcessingStartDateTime = new DwItemAttribute(this.i, 'DocumentAiProcessingStartDateTime');
    DocumentAiProcessingCompletedDateTime = new DwItemAttribute(this.i, 'DocumentAiProcessingCompletedDateTime');
    DocumentAiProcessingLastUpdatedDateTime = new DwItemAttribute(this.i, 'DocumentAiProcessingLastUpdatedDateTime');
    DocumentAiProcessingEstimatedCompletedDateTime = new DwItemAttribute(this.i, 'DocumentAiProcessingEstimatedCompletedDateTime');
    DocumentAiProcessingTotalChunkCount = new DwItemAttribute(this.i, 'DocumentAiProcessingTotalChunkCount');
    DocumentAiProcessingProcessedChunkCount = new DwItemAttribute(this.i, 'DocumentAiProcessingProcessedChunkCount');
    DocumentAiProcessingFailedChunkCount = new DwItemAttribute(this.i, 'DocumentAiProcessingFailedChunkCount');
    DocumentAiProcessingTotalModuleLinkCount = new DwItemAttribute(this.i, 'DocumentAiProcessingTotalModuleLinkCount');
    DocumentAiProcessingProcessedModuleLinkCount = new DwItemAttribute(this.i, 'DocumentAiProcessingProcessedModuleLinkCount');
    DocumentAiProcessingFailedModuleLinkCount = new DwItemAttribute(this.i, 'DocumentAiProcessingFailedModuleLinkCount');
}

class DocumentItemMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Document Ai Processing Status */
            DocumentAiProcessingStatus = new DwItemRelationship('DocumentAiProcessingStatus|DocumentItem|DocumentAiProcessingStatusId', 'DocumentAiProcessingStatus', 'DocumentAiProcessingStatus');
            /** Relation: Document Folder - Parent Document Folder */
            DocumentFolderByParentDocumentFolderId = new DwItemRelationship('DocumentFolder|DocumentItem|ParentDocumentFolderId', 'ParentDocumentFolder', 'ParentDocumentFolder');
            /** Relation: Document Group */
            DocumentGroup = new DwItemRelationship('DocumentGroup|DocumentItem|DocumentGroupId', 'DocumentGroup', 'DocumentGroup');
            /** Relation: Document Item Status */
            DocumentItemStatus = new DwItemRelationship('DocumentItemStatus|DocumentItem|DocumentItemStatusId', 'DocumentItemStatus', 'DocumentItemStatus');
            /** Relation: Document Owner Type - Document Ownership Type */
            DocumentOwnerTypeByDocumentOwnershipTypeId = new DwItemRelationship('DocumentOwnerType|DocumentItem|DocumentOwnershipTypeId', 'DocumentOwnershipTypeIdDocumentOwnerType', 'DocumentOwnershipTypeIdDocumentOwnerType');
            /** Relation: Document Type */
            DocumentType = new DwItemRelationship('DocumentType|DocumentItem|DocumentTypeId', 'DocumentType', 'DocumentType');
            /** Relation: Flight School */
            FlightSchool = new DwItemRelationship('FlightSchool|DocumentItem|FlightSchoolId', 'FlightSchool', 'FlightSchool');
            /** Relation: Media */
            DwMedia = new DwItemRelationship('dw_Media|DocumentItem|MediaId', 'DwMedia', 'DwMedia');
            /** Relation: Media - Card Icon Media */
            DwMediaByCardIconMediaId = new DwItemRelationship('dw_Media|DocumentItem|CardIconMediaId', 'CardIconDwMedia', 'CardIconDwMedia');
            /** Relation: Media - Extracted Image Media */
            DwMediaByExtractedImageMediaId = new DwItemRelationship('dw_Media|DocumentItem|ExtractedImageMediaId', 'ExtractedImageDwMedia', 'ExtractedImageDwMedia');
            /** Relation: Course Document Item */
            CourseDocumentItem = new DwItemRelationship('DocumentItem|CourseDocumentItem|DocumentItemId', 'CourseDocumentItem', 'CourseDocumentItem');
            /** Relation: Lesson */
            CourseLesson = new DwItemRelationship('DocumentItem|CourseLesson|DocumentItemId', 'CourseLesson', 'CourseLesson');
            /** Relation: Course Lesson Document Link */
            CourseLessonDocumentLink = new DwItemRelationship('DocumentItem|CourseLessonDocumentLink|DocumentItemId', 'CourseLessonDocumentLink', 'CourseLessonDocumentLink');
            /** Relation: Document Item Acknowledgement */
            DocumentItemAcknowledgement = new DwItemRelationship('DocumentItem|DocumentItemAcknowledgement|DocumentItemId', 'DocumentItemAcknowledgement', 'DocumentItemAcknowledgement');
            /** Relation: Document Item Change Log */
            DocumentItemChangeLog = new DwItemRelationship('DocumentItem|DocumentItemChangeLog|DocumentItemId', 'DocumentItemChangeLog', 'DocumentItemChangeLog');
            /** Relation: Document Item Chunk */
            DocumentItemChunk = new DwItemRelationship('DocumentItem|DocumentItemChunk|DocumentItemId', 'DocumentItemChunk', 'DocumentItemChunk');
            /** Relation: Document Item Page */
            DocumentItemPage = new DwItemRelationship('DocumentItem|DocumentItemPage|DocumentItemId', 'DocumentItemPage', 'DocumentItemPage');
            /** Relation: Document Link Processing Run */
            DocumentLinkProcessingRun = new DwItemRelationship('DocumentItem|DocumentLinkProcessingRun|DocumentItemId', 'DocumentLinkProcessingRun', 'DocumentLinkProcessingRun');
            /** Relation: Document Publication */
            DocumentPublication = new DwItemRelationship('DocumentItem|DocumentPublication|DocumentItemId', 'DocumentPublication', 'DocumentPublication');
            /** Relation: User Document Section Favorite */
            UserDocumentSectionFavorite = new DwItemRelationship('DocumentItem|UserDocumentSectionFavorite|DocumentItemId', 'UserDocumentSectionFavorite', 'UserDocumentSectionFavorite');
    };
export class DocumentItemAcknowledgementMetaData implements DwItem2<DocumentItemAcknowledgementEntity, DocumentItemAcknowledgementMetaDataAttributes,DocumentItemAcknowledgementMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=392;
        this.ItemDetail.itemName='DocumentItemAcknowledgement';
        this.ItemDetail.keyName='DocumentItemAcknowledgementId';
    }

    CreateEntity(): DocumentItemAcknowledgementEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DocumentItemAcknowledgementQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DocumentItemAcknowledgementEntity, DocumentItemAcknowledgementMetaDataAttributes,DocumentItemAcknowledgementMetaDataRelations>(query, this);
    }
     Attributes = new DocumentItemAcknowledgementMetaDataAttributes();
     Relations = new DocumentItemAcknowledgementMetaDataRelations();

}


export type DocumentItemAcknowledgementQueryBuilder = DwQueryBuilderGen<DocumentItemAcknowledgementEntity, DocumentItemAcknowledgementMetaDataAttributes,DocumentItemAcknowledgementMetaDataRelations>


export class DocumentItemAcknowledgementMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'DocumentItemAcknowledgement';
    // Attributes
    DocumentItemAcknowledgementId = new DwItemAttribute(this.i, 'DocumentItemAcknowledgementId');
    DocumentItemId = new DwItemAttribute(this.i, 'DocumentItemId');
    StudentId = new DwItemAttribute(this.i, 'StudentId');
    AcknowledgedDateTime = new DwItemAttribute(this.i, 'AcknowledgedDateTime');
}

class DocumentItemAcknowledgementMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Document Item */
            DocumentItem = new DwItemRelationship('DocumentItem|DocumentItemAcknowledgement|DocumentItemId', 'DocumentItem', 'DocumentItem');
            /** Relation: Student */
            Student = new DwItemRelationship('Student|DocumentItemAcknowledgement|StudentId', 'Student', 'Student');
    };
export class DocumentItemChangeLogMetaData implements DwItem2<DocumentItemChangeLogEntity, DocumentItemChangeLogMetaDataAttributes,DocumentItemChangeLogMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=389;
        this.ItemDetail.itemName='DocumentItemChangeLog';
        this.ItemDetail.keyName='DocumentItemChangeLogId';
    }

    CreateEntity(): DocumentItemChangeLogEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DocumentItemChangeLogQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DocumentItemChangeLogEntity, DocumentItemChangeLogMetaDataAttributes,DocumentItemChangeLogMetaDataRelations>(query, this);
    }
     Attributes = new DocumentItemChangeLogMetaDataAttributes();
     Relations = new DocumentItemChangeLogMetaDataRelations();

}


export type DocumentItemChangeLogQueryBuilder = DwQueryBuilderGen<DocumentItemChangeLogEntity, DocumentItemChangeLogMetaDataAttributes,DocumentItemChangeLogMetaDataRelations>


export class DocumentItemChangeLogMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'DocumentItemChangeLog';
    // Attributes
    DocumentItemChangeLogId = new DwItemAttribute(this.i, 'DocumentItemChangeLogId');
    DocumentItemId = new DwItemAttribute(this.i, 'DocumentItemId');
    ChangeLogTypeId = new DwItemAttribute(this.i, 'ChangeLogTypeId');
    ChangeLogText = new DwItemAttribute(this.i, 'ChangeLogText');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreateDateTime = new DwItemAttribute(this.i, 'CreateDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    MediaId = new DwItemAttribute(this.i, 'MediaId');
}

class DocumentItemChangeLogMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Document Change Log Type - Change Log Type */
            DocumentChangeLogTypeByChangeLogTypeId = new DwItemRelationship('DocumentChangeLogType|DocumentItemChangeLog|ChangeLogTypeId', 'ChangeLogTypeIdDocumentChangeLogType', 'ChangeLogTypeIdDocumentChangeLogType');
            /** Relation: Document Item */
            DocumentItem = new DwItemRelationship('DocumentItem|DocumentItemChangeLog|DocumentItemId', 'DocumentItem', 'DocumentItem');
    };
export class DocumentItemChunkMetaData implements DwItem2<DocumentItemChunkEntity, DocumentItemChunkMetaDataAttributes,DocumentItemChunkMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=402;
        this.ItemDetail.itemName='DocumentItemChunk';
        this.ItemDetail.keyName='DocumentItemChunkId';
    }

    CreateEntity(): DocumentItemChunkEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DocumentItemChunkQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DocumentItemChunkEntity, DocumentItemChunkMetaDataAttributes,DocumentItemChunkMetaDataRelations>(query, this);
    }
     Attributes = new DocumentItemChunkMetaDataAttributes();
     Relations = new DocumentItemChunkMetaDataRelations();

}


export type DocumentItemChunkQueryBuilder = DwQueryBuilderGen<DocumentItemChunkEntity, DocumentItemChunkMetaDataAttributes,DocumentItemChunkMetaDataRelations>


export class DocumentItemChunkMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'DocumentItemChunk';
    // Attributes
    DocumentItemChunkId = new DwItemAttribute(this.i, 'DocumentItemChunkId');
    DocumentItemId = new DwItemAttribute(this.i, 'DocumentItemId');
    ChunkIndex = new DwItemAttribute(this.i, 'ChunkIndex');
    StartPageNumber = new DwItemAttribute(this.i, 'StartPageNumber');
    EndPageNumber = new DwItemAttribute(this.i, 'EndPageNumber');
    ChunkText = new DwItemAttribute(this.i, 'ChunkText');
    ChunkSummary = new DwItemAttribute(this.i, 'ChunkSummary');
    CharacterCount = new DwItemAttribute(this.i, 'CharacterCount');
    AIProcessingReferenceId = new DwItemAttribute(this.i, 'AIProcessingReferenceId');
    Keywords = new DwItemAttribute(this.i, 'Keywords');
    Topics = new DwItemAttribute(this.i, 'Topics');
    ImportantTerms = new DwItemAttribute(this.i, 'ImportantTerms');
    VectorReferenceId = new DwItemAttribute(this.i, 'VectorReferenceId');
    DocumentItemChunkContentTypeId = new DwItemAttribute(this.i, 'DocumentItemChunkContentTypeId');
}

class DocumentItemChunkMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: AI Processing Reference */
            AIProcessingReference = new DwItemRelationship('AIProcessingReference|DocumentItemChunk|AiProcessingReferenceId', 'AIProcessingReference', 'AIProcessingReference');
            /** Relation: Document Item */
            DocumentItem = new DwItemRelationship('DocumentItem|DocumentItemChunk|DocumentItemId', 'DocumentItem', 'DocumentItem');
            /** Relation: Document Item Chunk Content Type */
            DocumentItemChunkContentType = new DwItemRelationship('DocumentItemChunkContentType|DocumentItemChunk|DocumentItemChunkContentTypeId', 'DocumentItemChunkContentType', 'DocumentItemChunkContentType');
            /** Relation: Vector Reference */
            VectorReference = new DwItemRelationship('VectorReference|DocumentItemChunk|VectorReferenceId', 'VectorReference', 'VectorReference');
    };
export class DocumentItemChunkContentTypeMetaData implements DwItem2<DocumentItemChunkContentTypeEntity, DocumentItemChunkContentTypeMetaDataAttributes,DocumentItemChunkContentTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=412;
        this.ItemDetail.itemName='DocumentItemChunkContentType';
        this.ItemDetail.keyName='DocumentItemChunkContentTypeId';
    }

    CreateEntity(): DocumentItemChunkContentTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DocumentItemChunkContentTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DocumentItemChunkContentTypeEntity, DocumentItemChunkContentTypeMetaDataAttributes,DocumentItemChunkContentTypeMetaDataRelations>(query, this);
    }
     Attributes = new DocumentItemChunkContentTypeMetaDataAttributes();
     Relations = new DocumentItemChunkContentTypeMetaDataRelations();

}


export type DocumentItemChunkContentTypeQueryBuilder = DwQueryBuilderGen<DocumentItemChunkContentTypeEntity, DocumentItemChunkContentTypeMetaDataAttributes,DocumentItemChunkContentTypeMetaDataRelations>


export class DocumentItemChunkContentTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'DocumentItemChunkContentType';
    // Attributes
    DocumentItemChunkContentTypeId = new DwItemAttribute(this.i, 'DocumentItemChunkContentTypeId');
    DocumentItemChunkContentType = new DwItemAttribute(this.i, 'DocumentItemChunkContentType');
    ExcludeFromVectorSearch = new DwItemAttribute(this.i, 'ExcludeFromVectorSearch');
}

class DocumentItemChunkContentTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Document Item Chunk */
            DocumentItemChunk = new DwItemRelationship('DocumentItemChunkContentType|DocumentItemChunk|DocumentItemChunkContentTypeId', 'DocumentItemChunk', 'DocumentItemChunk');
    };
export class DocumentItemPageMetaData implements DwItem2<DocumentItemPageEntity, DocumentItemPageMetaDataAttributes,DocumentItemPageMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=401;
        this.ItemDetail.itemName='DocumentItemPage';
        this.ItemDetail.keyName='DocumentItemPageId';
    }

    CreateEntity(): DocumentItemPageEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DocumentItemPageQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DocumentItemPageEntity, DocumentItemPageMetaDataAttributes,DocumentItemPageMetaDataRelations>(query, this);
    }
     Attributes = new DocumentItemPageMetaDataAttributes();
     Relations = new DocumentItemPageMetaDataRelations();

}


export type DocumentItemPageQueryBuilder = DwQueryBuilderGen<DocumentItemPageEntity, DocumentItemPageMetaDataAttributes,DocumentItemPageMetaDataRelations>


export class DocumentItemPageMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'DocumentItemPage';
    // Attributes
    DocumentItemPageId = new DwItemAttribute(this.i, 'DocumentItemPageId');
    DocumentItemId = new DwItemAttribute(this.i, 'DocumentItemId');
    PageNumber = new DwItemAttribute(this.i, 'PageNumber');
    PageText = new DwItemAttribute(this.i, 'PageText');
    CharacterCount = new DwItemAttribute(this.i, 'CharacterCount');
    HasText = new DwItemAttribute(this.i, 'HasText');
}

class DocumentItemPageMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Document Item */
            DocumentItem = new DwItemRelationship('DocumentItem|DocumentItemPage|DocumentItemId', 'DocumentItem', 'DocumentItem');
    };
export class DocumentItemStatusMetaData implements DwItem2<DocumentItemStatusEntity, DocumentItemStatusMetaDataAttributes,DocumentItemStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=375;
        this.ItemDetail.itemName='DocumentItemStatus';
        this.ItemDetail.keyName='DocumentItemStatusId';
    }

    CreateEntity(): DocumentItemStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DocumentItemStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DocumentItemStatusEntity, DocumentItemStatusMetaDataAttributes,DocumentItemStatusMetaDataRelations>(query, this);
    }
     Attributes = new DocumentItemStatusMetaDataAttributes();
     Relations = new DocumentItemStatusMetaDataRelations();

}


export type DocumentItemStatusQueryBuilder = DwQueryBuilderGen<DocumentItemStatusEntity, DocumentItemStatusMetaDataAttributes,DocumentItemStatusMetaDataRelations>


export class DocumentItemStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'DocumentItemStatus';
    // Attributes
    DocumentItemStatusId = new DwItemAttribute(this.i, 'DocumentItemStatusId');
    DocumentItemStatus = new DwItemAttribute(this.i, 'DocumentItemStatus');
}

class DocumentItemStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Document Folder */
            DocumentFolder = new DwItemRelationship('DocumentItemStatus|DocumentFolder|DocumentItemStatusId', 'DocumentFolder', 'DocumentFolder');
            /** Relation: Document Item */
            DocumentItem = new DwItemRelationship('DocumentItemStatus|DocumentItem|DocumentItemStatusId', 'DocumentItem', 'DocumentItem');
    };
export class DocumentLinkProcessingRunMetaData implements DwItem2<DocumentLinkProcessingRunEntity, DocumentLinkProcessingRunMetaDataAttributes,DocumentLinkProcessingRunMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=474;
        this.ItemDetail.itemName='DocumentLinkProcessingRun';
        this.ItemDetail.keyName='DocumentLinkProcessingRunId';
    }

    CreateEntity(): DocumentLinkProcessingRunEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DocumentLinkProcessingRunQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DocumentLinkProcessingRunEntity, DocumentLinkProcessingRunMetaDataAttributes,DocumentLinkProcessingRunMetaDataRelations>(query, this);
    }
     Attributes = new DocumentLinkProcessingRunMetaDataAttributes();
     Relations = new DocumentLinkProcessingRunMetaDataRelations();

}


export type DocumentLinkProcessingRunQueryBuilder = DwQueryBuilderGen<DocumentLinkProcessingRunEntity, DocumentLinkProcessingRunMetaDataAttributes,DocumentLinkProcessingRunMetaDataRelations>


export class DocumentLinkProcessingRunMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'DocumentLinkProcessingRun';
    // Attributes
    DocumentLinkProcessingRunId = new DwItemAttribute(this.i, 'DocumentLinkProcessingRunId');
    DocumentItemId = new DwItemAttribute(this.i, 'DocumentItemId');
    DocumentPublicationId = new DwItemAttribute(this.i, 'DocumentPublicationId');
    DocumentVersionId = new DwItemAttribute(this.i, 'DocumentVersionId');
    CourseId = new DwItemAttribute(this.i, 'CourseId');
    DocumentLinkProcessingTriggerTypeId = new DwItemAttribute(this.i, 'DocumentLinkProcessingTriggerTypeId');
    DocumentLinkProcessingRunStatusId = new DwItemAttribute(this.i, 'DocumentLinkProcessingRunStatusId');
    CorrelationId = new DwItemAttribute(this.i, 'CorrelationId');
    CurrentStage = new DwItemAttribute(this.i, 'CurrentStage');
    ProgressText = new DwItemAttribute(this.i, 'ProgressText');
    ErrorText = new DwItemAttribute(this.i, 'ErrorText');
    StartedDateTime = new DwItemAttribute(this.i, 'StartedDateTime');
    CompletedDateTime = new DwItemAttribute(this.i, 'CompletedDateTime');
    LastUpdatedDateTime = new DwItemAttribute(this.i, 'LastUpdatedDateTime');
    TotalLessonCount = new DwItemAttribute(this.i, 'TotalLessonCount');
    EvaluatedLessonCount = new DwItemAttribute(this.i, 'EvaluatedLessonCount');
    DirectLinkedCount = new DwItemAttribute(this.i, 'DirectLinkedCount');
    AIQueuedCount = new DwItemAttribute(this.i, 'AIQueuedCount');
    AILinkedCount = new DwItemAttribute(this.i, 'AILinkedCount');
    SkippedCount = new DwItemAttribute(this.i, 'SkippedCount');
    FailedCount = new DwItemAttribute(this.i, 'FailedCount');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class DocumentLinkProcessingRunMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Course */
            Course = new DwItemRelationship('Course|DocumentLinkProcessingRun|CourseId', 'Course', 'Course');
            /** Relation: Document Item */
            DocumentItem = new DwItemRelationship('DocumentItem|DocumentLinkProcessingRun|DocumentItemId', 'DocumentItem', 'DocumentItem');
            /** Relation: Document Link Processing Run Status */
            DocumentLinkProcessingRunStatus = new DwItemRelationship('DocumentLinkProcessingRunStatus|DocumentLinkProcessingRun|DocumentLinkProcessingRunStatusId', 'DocumentLinkProcessingRunStatus', 'DocumentLinkProcessingRunStatus');
            /** Relation: Document Link Processing Trigger Type */
            DocumentLinkProcessingTriggerType = new DwItemRelationship('DocumentLinkProcessingTriggerType|DocumentLinkProcessingRun|DocumentLinkProcessingTriggerTypeId', 'DocumentLinkProcessingTriggerType', 'DocumentLinkProcessingTriggerType');
            /** Relation: Document Publication */
            DocumentPublication = new DwItemRelationship('DocumentPublication|DocumentLinkProcessingRun|DocumentPublicationId', 'DocumentPublication', 'DocumentPublication');
            /** Relation: Document Version */
            DocumentVersion = new DwItemRelationship('DocumentVersion|DocumentLinkProcessingRun|DocumentVersionId', 'DocumentVersion', 'DocumentVersion');
            /** Relation: Document Link Processing Run Item */
            DocumentLinkProcessingRunItem = new DwItemRelationship('DocumentLinkProcessingRun|DocumentLinkProcessingRunItem|DocumentLinkProcessingRunId', 'DocumentLinkProcessingRunItem', 'DocumentLinkProcessingRunItem');
    };
export class DocumentLinkProcessingRunItemMetaData implements DwItem2<DocumentLinkProcessingRunItemEntity, DocumentLinkProcessingRunItemMetaDataAttributes,DocumentLinkProcessingRunItemMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=469;
        this.ItemDetail.itemName='DocumentLinkProcessingRunItem';
        this.ItemDetail.keyName='DocumentLinkProcessingRunItemId';
    }

    CreateEntity(): DocumentLinkProcessingRunItemEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DocumentLinkProcessingRunItemQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DocumentLinkProcessingRunItemEntity, DocumentLinkProcessingRunItemMetaDataAttributes,DocumentLinkProcessingRunItemMetaDataRelations>(query, this);
    }
     Attributes = new DocumentLinkProcessingRunItemMetaDataAttributes();
     Relations = new DocumentLinkProcessingRunItemMetaDataRelations();

}


export type DocumentLinkProcessingRunItemQueryBuilder = DwQueryBuilderGen<DocumentLinkProcessingRunItemEntity, DocumentLinkProcessingRunItemMetaDataAttributes,DocumentLinkProcessingRunItemMetaDataRelations>


export class DocumentLinkProcessingRunItemMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'DocumentLinkProcessingRunItem';
    // Attributes
    DocumentLinkProcessingRunItemId = new DwItemAttribute(this.i, 'DocumentLinkProcessingRunItemId');
    DocumentLinkProcessingRunId = new DwItemAttribute(this.i, 'DocumentLinkProcessingRunId');
    CourseId = new DwItemAttribute(this.i, 'CourseId');
    CourseModuleId = new DwItemAttribute(this.i, 'CourseModuleId');
    CourseLessonId = new DwItemAttribute(this.i, 'CourseLessonId');
    CourseLessonDocumentLinkId = new DwItemAttribute(this.i, 'CourseLessonDocumentLinkId');
    AIProcessingReferenceId = new DwItemAttribute(this.i, 'AIProcessingReferenceId');
    DocumentLinkProcessingRunItemStatusId = new DwItemAttribute(this.i, 'DocumentLinkProcessingRunItemStatusId');
    DocumentLinkSourceTypeId = new DwItemAttribute(this.i, 'DocumentLinkSourceTypeId');
    ProgressText = new DwItemAttribute(this.i, 'ProgressText');
    ErrorCode = new DwItemAttribute(this.i, 'ErrorCode');
    ErrorText = new DwItemAttribute(this.i, 'ErrorText');
    StartedDateTime = new DwItemAttribute(this.i, 'StartedDateTime');
    CompletedDateTime = new DwItemAttribute(this.i, 'CompletedDateTime');
    LastUpdatedDateTime = new DwItemAttribute(this.i, 'LastUpdatedDateTime');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class DocumentLinkProcessingRunItemMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: AI Processing Reference */
            AIProcessingReference = new DwItemRelationship('AIProcessingReference|DocumentLinkProcessingRunItem|AIProcessingReferenceId', 'AIProcessingReference', 'AIProcessingReference');
            /** Relation: Course */
            Course = new DwItemRelationship('Course|DocumentLinkProcessingRunItem|CourseId', 'Course', 'Course');
            /** Relation: Lesson */
            CourseLesson = new DwItemRelationship('CourseLesson|DocumentLinkProcessingRunItem|CourseLessonId', 'CourseLesson', 'CourseLesson');
            /** Relation: Course Lesson Document Link */
            CourseLessonDocumentLink = new DwItemRelationship('CourseLessonDocumentLink|DocumentLinkProcessingRunItem|CourseLessonDocumentLinkId', 'CourseLessonDocumentLink', 'CourseLessonDocumentLink');
            /** Relation: Module */
            CourseModule = new DwItemRelationship('CourseModule|DocumentLinkProcessingRunItem|CourseModuleId', 'CourseModule', 'CourseModule');
            /** Relation: Document Link Processing Run */
            DocumentLinkProcessingRun = new DwItemRelationship('DocumentLinkProcessingRun|DocumentLinkProcessingRunItem|DocumentLinkProcessingRunId', 'DocumentLinkProcessingRun', 'DocumentLinkProcessingRun');
            /** Relation: Document Link Processing Run Item Status */
            DocumentLinkProcessingRunItemStatus = new DwItemRelationship('DocumentLinkProcessingRunItemStatus|DocumentLinkProcessingRunItem|DocumentLinkProcessingRunItemStatusId', 'DocumentLinkProcessingRunItemStatus', 'DocumentLinkProcessingRunItemStatus');
            /** Relation: Document Link Source Type */
            DocumentLinkSourceType = new DwItemRelationship('DocumentLinkSourceType|DocumentLinkProcessingRunItem|DocumentLinkSourceTypeId', 'DocumentLinkSourceType', 'DocumentLinkSourceType');
    };
export class DocumentLinkProcessingRunItemStatusMetaData implements DwItem2<DocumentLinkProcessingRunItemStatusEntity, DocumentLinkProcessingRunItemStatusMetaDataAttributes,DocumentLinkProcessingRunItemStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=471;
        this.ItemDetail.itemName='DocumentLinkProcessingRunItemStatus';
        this.ItemDetail.keyName='DocumentLinkProcessingRunItemStatusId';
    }

    CreateEntity(): DocumentLinkProcessingRunItemStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DocumentLinkProcessingRunItemStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DocumentLinkProcessingRunItemStatusEntity, DocumentLinkProcessingRunItemStatusMetaDataAttributes,DocumentLinkProcessingRunItemStatusMetaDataRelations>(query, this);
    }
     Attributes = new DocumentLinkProcessingRunItemStatusMetaDataAttributes();
     Relations = new DocumentLinkProcessingRunItemStatusMetaDataRelations();

}


export type DocumentLinkProcessingRunItemStatusQueryBuilder = DwQueryBuilderGen<DocumentLinkProcessingRunItemStatusEntity, DocumentLinkProcessingRunItemStatusMetaDataAttributes,DocumentLinkProcessingRunItemStatusMetaDataRelations>


export class DocumentLinkProcessingRunItemStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'DocumentLinkProcessingRunItemStatus';
    // Attributes
    DocumentLinkProcessingRunItemStatusId = new DwItemAttribute(this.i, 'DocumentLinkProcessingRunItemStatusId');
    DocumentLinkProcessingRunItemStatus = new DwItemAttribute(this.i, 'DocumentLinkProcessingRunItemStatus');
}

class DocumentLinkProcessingRunItemStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Document Link Processing Run Item */
            DocumentLinkProcessingRunItem = new DwItemRelationship('DocumentLinkProcessingRunItemStatus|DocumentLinkProcessingRunItem|DocumentLinkProcessingRunItemStatusId', 'DocumentLinkProcessingRunItem', 'DocumentLinkProcessingRunItem');
    };
export class DocumentLinkProcessingRunStatusMetaData implements DwItem2<DocumentLinkProcessingRunStatusEntity, DocumentLinkProcessingRunStatusMetaDataAttributes,DocumentLinkProcessingRunStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=472;
        this.ItemDetail.itemName='DocumentLinkProcessingRunStatus';
        this.ItemDetail.keyName='DocumentLinkProcessingRunStatusId';
    }

    CreateEntity(): DocumentLinkProcessingRunStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DocumentLinkProcessingRunStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DocumentLinkProcessingRunStatusEntity, DocumentLinkProcessingRunStatusMetaDataAttributes,DocumentLinkProcessingRunStatusMetaDataRelations>(query, this);
    }
     Attributes = new DocumentLinkProcessingRunStatusMetaDataAttributes();
     Relations = new DocumentLinkProcessingRunStatusMetaDataRelations();

}


export type DocumentLinkProcessingRunStatusQueryBuilder = DwQueryBuilderGen<DocumentLinkProcessingRunStatusEntity, DocumentLinkProcessingRunStatusMetaDataAttributes,DocumentLinkProcessingRunStatusMetaDataRelations>


export class DocumentLinkProcessingRunStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'DocumentLinkProcessingRunStatus';
    // Attributes
    DocumentLinkProcessingRunStatusId = new DwItemAttribute(this.i, 'DocumentLinkProcessingRunStatusId');
    DocumentLinkProcessingRunStatus = new DwItemAttribute(this.i, 'DocumentLinkProcessingRunStatus');
}

class DocumentLinkProcessingRunStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Document Link Processing Run */
            DocumentLinkProcessingRun = new DwItemRelationship('DocumentLinkProcessingRunStatus|DocumentLinkProcessingRun|DocumentLinkProcessingRunStatusId', 'DocumentLinkProcessingRun', 'DocumentLinkProcessingRun');
    };
export class DocumentLinkProcessingTriggerTypeMetaData implements DwItem2<DocumentLinkProcessingTriggerTypeEntity, DocumentLinkProcessingTriggerTypeMetaDataAttributes,DocumentLinkProcessingTriggerTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=470;
        this.ItemDetail.itemName='DocumentLinkProcessingTriggerType';
        this.ItemDetail.keyName='DocumentLinkProcessingTriggerTypeId';
    }

    CreateEntity(): DocumentLinkProcessingTriggerTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DocumentLinkProcessingTriggerTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DocumentLinkProcessingTriggerTypeEntity, DocumentLinkProcessingTriggerTypeMetaDataAttributes,DocumentLinkProcessingTriggerTypeMetaDataRelations>(query, this);
    }
     Attributes = new DocumentLinkProcessingTriggerTypeMetaDataAttributes();
     Relations = new DocumentLinkProcessingTriggerTypeMetaDataRelations();

}


export type DocumentLinkProcessingTriggerTypeQueryBuilder = DwQueryBuilderGen<DocumentLinkProcessingTriggerTypeEntity, DocumentLinkProcessingTriggerTypeMetaDataAttributes,DocumentLinkProcessingTriggerTypeMetaDataRelations>


export class DocumentLinkProcessingTriggerTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'DocumentLinkProcessingTriggerType';
    // Attributes
    DocumentLinkProcessingTriggerTypeId = new DwItemAttribute(this.i, 'DocumentLinkProcessingTriggerTypeId');
    DocumentLinkProcessingTriggerType = new DwItemAttribute(this.i, 'DocumentLinkProcessingTriggerType');
}

class DocumentLinkProcessingTriggerTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Document Link Processing Run */
            DocumentLinkProcessingRun = new DwItemRelationship('DocumentLinkProcessingTriggerType|DocumentLinkProcessingRun|DocumentLinkProcessingTriggerTypeId', 'DocumentLinkProcessingRun', 'DocumentLinkProcessingRun');
    };
export class DocumentLinkSourceTypeMetaData implements DwItem2<DocumentLinkSourceTypeEntity, DocumentLinkSourceTypeMetaDataAttributes,DocumentLinkSourceTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=473;
        this.ItemDetail.itemName='DocumentLinkSourceType';
        this.ItemDetail.keyName='DocumentLinkSourceTypeId';
    }

    CreateEntity(): DocumentLinkSourceTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DocumentLinkSourceTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DocumentLinkSourceTypeEntity, DocumentLinkSourceTypeMetaDataAttributes,DocumentLinkSourceTypeMetaDataRelations>(query, this);
    }
     Attributes = new DocumentLinkSourceTypeMetaDataAttributes();
     Relations = new DocumentLinkSourceTypeMetaDataRelations();

}


export type DocumentLinkSourceTypeQueryBuilder = DwQueryBuilderGen<DocumentLinkSourceTypeEntity, DocumentLinkSourceTypeMetaDataAttributes,DocumentLinkSourceTypeMetaDataRelations>


export class DocumentLinkSourceTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'DocumentLinkSourceType';
    // Attributes
    DocumentLinkSourceTypeId = new DwItemAttribute(this.i, 'DocumentLinkSourceTypeId');
    DocumentLinkSourceType = new DwItemAttribute(this.i, 'DocumentLinkSourceType');
}

class DocumentLinkSourceTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Document Link Processing Run Item */
            DocumentLinkProcessingRunItem = new DwItemRelationship('DocumentLinkSourceType|DocumentLinkProcessingRunItem|DocumentLinkSourceTypeId', 'DocumentLinkProcessingRunItem', 'DocumentLinkProcessingRunItem');
    };
export class DocumentOwnerTypeMetaData implements DwItem2<DocumentOwnerTypeEntity, DocumentOwnerTypeMetaDataAttributes,DocumentOwnerTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=383;
        this.ItemDetail.itemName='DocumentOwnerType';
        this.ItemDetail.keyName='DocumentOwnerTypeId';
    }

    CreateEntity(): DocumentOwnerTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DocumentOwnerTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DocumentOwnerTypeEntity, DocumentOwnerTypeMetaDataAttributes,DocumentOwnerTypeMetaDataRelations>(query, this);
    }
     Attributes = new DocumentOwnerTypeMetaDataAttributes();
     Relations = new DocumentOwnerTypeMetaDataRelations();

}


export type DocumentOwnerTypeQueryBuilder = DwQueryBuilderGen<DocumentOwnerTypeEntity, DocumentOwnerTypeMetaDataAttributes,DocumentOwnerTypeMetaDataRelations>


export class DocumentOwnerTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'DocumentOwnerType';
    // Attributes
    DocumentOwnerTypeId = new DwItemAttribute(this.i, 'DocumentOwnerTypeId');
    DocumentOwnerType = new DwItemAttribute(this.i, 'DocumentOwnerType');
}

class DocumentOwnerTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Document Folder - Document Ownership Type - Many */
            DocumentFolderByDocumentOwnershipTypeId = new DwItemRelationship('DocumentOwnerType|DocumentFolder|DocumentOwnershipTypeId', 'DocumentOwnershipTypeIdDocumentFolder', 'DocumentOwnershipTypeIdDocumentFolder');
            /** Relation: Document Item - Document Ownership Type - Many */
            DocumentItemByDocumentOwnershipTypeId = new DwItemRelationship('DocumentOwnerType|DocumentItem|DocumentOwnershipTypeId', 'DocumentOwnershipTypeIdDocumentItem', 'DocumentOwnershipTypeIdDocumentItem');
    };
export class DocumentPublicationMetaData implements DwItem2<DocumentPublicationEntity, DocumentPublicationMetaDataAttributes,DocumentPublicationMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=452;
        this.ItemDetail.itemName='DocumentPublication';
        this.ItemDetail.keyName='DocumentPublicationId';
    }

    CreateEntity(): DocumentPublicationEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DocumentPublicationQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DocumentPublicationEntity, DocumentPublicationMetaDataAttributes,DocumentPublicationMetaDataRelations>(query, this);
    }
     Attributes = new DocumentPublicationMetaDataAttributes();
     Relations = new DocumentPublicationMetaDataRelations();

}


export type DocumentPublicationQueryBuilder = DwQueryBuilderGen<DocumentPublicationEntity, DocumentPublicationMetaDataAttributes,DocumentPublicationMetaDataRelations>


export class DocumentPublicationMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'DocumentPublication';
    // Attributes
    DocumentPublicationId = new DwItemAttribute(this.i, 'DocumentPublicationId');
    DocumentItemId = new DwItemAttribute(this.i, 'DocumentItemId');
    DocumentPublicationTypeId = new DwItemAttribute(this.i, 'DocumentPublicationTypeId');
    PublicationCode = new DwItemAttribute(this.i, 'PublicationCode');
    PublicationName = new DwItemAttribute(this.i, 'PublicationName');
    ReferenceStatusId = new DwItemAttribute(this.i, 'ReferenceStatusId');
    CurrentDocumentVersionId = new DwItemAttribute(this.i, 'CurrentDocumentVersionId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    DocumentReferenceSourceId = new DwItemAttribute(this.i, 'DocumentReferenceSourceId');
}

class DocumentPublicationMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Document Item */
            DocumentItem = new DwItemRelationship('DocumentItem|DocumentPublication|DocumentItemId', 'DocumentItem', 'DocumentItem');
            /** Relation: Document Publication Type */
            DocumentPublicationType = new DwItemRelationship('DocumentPublicationType|DocumentPublication|DocumentPublicationTypeId', 'DocumentPublicationType', 'DocumentPublicationType');
            /** Relation: Document Reference Source */
            DocumentReferenceSource = new DwItemRelationship('DocumentReferenceSource|DocumentPublication|DocumentReferenceSourceId', 'DocumentReferenceSource', 'DocumentReferenceSource');
            /** Relation: Document Version - Current Document Version */
            DocumentVersionByCurrentDocumentVersionId = new DwItemRelationship('DocumentVersion|DocumentPublication|CurrentDocumentVersionId', 'CurrentDocumentVersion', 'CurrentDocumentVersion');
            /** Relation: Reference Status */
            ReferenceStatus = new DwItemRelationship('ReferenceStatus|DocumentPublication|ReferenceStatusId', 'ReferenceStatus', 'ReferenceStatus');
            /** Relation: Course Lesson Document Link Reference */
            CourseLessonDocumentLinkReference = new DwItemRelationship('DocumentPublication|CourseLessonDocumentLinkReference|DocumentPublicationId', 'CourseLessonDocumentLinkReference', 'CourseLessonDocumentLinkReference');
            /** Relation: Document Import Job */
            DocumentImportJob = new DwItemRelationship('DocumentPublication|DocumentImportJob|DocumentPublicationId', 'DocumentImportJob', 'DocumentImportJob');
            /** Relation: Document Link Processing Run */
            DocumentLinkProcessingRun = new DwItemRelationship('DocumentPublication|DocumentLinkProcessingRun|DocumentPublicationId', 'DocumentLinkProcessingRun', 'DocumentLinkProcessingRun');
            /** Relation: Document Version */
            DocumentVersion = new DwItemRelationship('DocumentPublication|DocumentVersion|DocumentPublicationId', 'DocumentVersion', 'DocumentVersion');
    };
export class DocumentPublicationTypeMetaData implements DwItem2<DocumentPublicationTypeEntity, DocumentPublicationTypeMetaDataAttributes,DocumentPublicationTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=458;
        this.ItemDetail.itemName='DocumentPublicationType';
        this.ItemDetail.keyName='DocumentPublicationTypeId';
    }

    CreateEntity(): DocumentPublicationTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DocumentPublicationTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DocumentPublicationTypeEntity, DocumentPublicationTypeMetaDataAttributes,DocumentPublicationTypeMetaDataRelations>(query, this);
    }
     Attributes = new DocumentPublicationTypeMetaDataAttributes();
     Relations = new DocumentPublicationTypeMetaDataRelations();

}


export type DocumentPublicationTypeQueryBuilder = DwQueryBuilderGen<DocumentPublicationTypeEntity, DocumentPublicationTypeMetaDataAttributes,DocumentPublicationTypeMetaDataRelations>


export class DocumentPublicationTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'DocumentPublicationType';
    // Attributes
    DocumentPublicationTypeId = new DwItemAttribute(this.i, 'DocumentPublicationTypeId');
    DocumentPublicationType = new DwItemAttribute(this.i, 'DocumentPublicationType');
}

class DocumentPublicationTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Document Publication */
            DocumentPublication = new DwItemRelationship('DocumentPublicationType|DocumentPublication|DocumentPublicationTypeId', 'DocumentPublication', 'DocumentPublication');
    };
export class DocumentReferenceSourceMetaData implements DwItem2<DocumentReferenceSourceEntity, DocumentReferenceSourceMetaDataAttributes,DocumentReferenceSourceMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=460;
        this.ItemDetail.itemName='DocumentReferenceSource';
        this.ItemDetail.keyName='DocumentReferenceSourceId';
    }

    CreateEntity(): DocumentReferenceSourceEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DocumentReferenceSourceQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DocumentReferenceSourceEntity, DocumentReferenceSourceMetaDataAttributes,DocumentReferenceSourceMetaDataRelations>(query, this);
    }
     Attributes = new DocumentReferenceSourceMetaDataAttributes();
     Relations = new DocumentReferenceSourceMetaDataRelations();

}


export type DocumentReferenceSourceQueryBuilder = DwQueryBuilderGen<DocumentReferenceSourceEntity, DocumentReferenceSourceMetaDataAttributes,DocumentReferenceSourceMetaDataRelations>


export class DocumentReferenceSourceMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'DocumentReferenceSource';
    // Attributes
    DocumentReferenceSourceId = new DwItemAttribute(this.i, 'DocumentReferenceSourceId');
    DocumentReferenceSource = new DwItemAttribute(this.i, 'DocumentReferenceSource');
}

class DocumentReferenceSourceMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Document Publication */
            DocumentPublication = new DwItemRelationship('DocumentReferenceSource|DocumentPublication|DocumentReferenceSourceId', 'DocumentPublication', 'DocumentPublication');
    };
export class DocumentSectionMetaData implements DwItem2<DocumentSectionEntity, DocumentSectionMetaDataAttributes,DocumentSectionMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=456;
        this.ItemDetail.itemName='DocumentSection';
        this.ItemDetail.keyName='DocumentSectionId';
    }

    CreateEntity(): DocumentSectionEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DocumentSectionQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DocumentSectionEntity, DocumentSectionMetaDataAttributes,DocumentSectionMetaDataRelations>(query, this);
    }
     Attributes = new DocumentSectionMetaDataAttributes();
     Relations = new DocumentSectionMetaDataRelations();

}


export type DocumentSectionQueryBuilder = DwQueryBuilderGen<DocumentSectionEntity, DocumentSectionMetaDataAttributes,DocumentSectionMetaDataRelations>


export class DocumentSectionMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'DocumentSection';
    // Attributes
    DocumentSectionId = new DwItemAttribute(this.i, 'DocumentSectionId');
    DocumentVersionId = new DwItemAttribute(this.i, 'DocumentVersionId');
    ParentDocumentSectionId = new DwItemAttribute(this.i, 'ParentDocumentSectionId');
    DocumentSectionTypeId = new DwItemAttribute(this.i, 'DocumentSectionTypeId');
    SectionKey = new DwItemAttribute(this.i, 'SectionKey');
    SectionSlug = new DwItemAttribute(this.i, 'SectionSlug');
    Label = new DwItemAttribute(this.i, 'Label');
    Title = new DwItemAttribute(this.i, 'Title');
    DisplayOrder = new DwItemAttribute(this.i, 'DisplayOrder');
    ReferenceStatusId = new DwItemAttribute(this.i, 'ReferenceStatusId');
    VectorReferenceId = new DwItemAttribute(this.i, 'VectorReferenceId');
}

class DocumentSectionMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Document Section Type */
            DocumentSectionType = new DwItemRelationship('DocumentSectionType|DocumentSection|DocumentSectionTypeId', 'DocumentSectionType', 'DocumentSectionType');
            /** Relation: Document Version */
            DocumentVersion = new DwItemRelationship('DocumentVersion|DocumentSection|DocumentVersionId', 'DocumentVersion', 'DocumentVersion');
            /** Relation: Document Section - Parent Document Section - One */
            DocumentSectionByParentDocumentSectionId = new DwItemRelationship('DocumentSection|DocumentSection|ParentDocumentSectionId', 'ParentDocumentSection', 'ParentDocumentSection');
            /** Relation: Reference Status */
            ReferenceStatus = new DwItemRelationship('ReferenceStatus|DocumentSection|ReferenceStatusId', 'ReferenceStatus', 'ReferenceStatus');
            /** Relation: Vector Reference */
            VectorReference = new DwItemRelationship('VectorReference|DocumentSection|VectorReferenceId', 'VectorReference', 'VectorReference');
            /** Relation: Course Lesson Document Link Reference */
            CourseLessonDocumentLinkReference = new DwItemRelationship('DocumentSection|CourseLessonDocumentLinkReference|DocumentSectionId', 'CourseLessonDocumentLinkReference', 'CourseLessonDocumentLinkReference');
            /** Relation: Document Anchor */
            DocumentAnchor = new DwItemRelationship('DocumentSection|DocumentAnchor|DocumentSectionId', 'DocumentAnchor', 'DocumentAnchor');
            /** Relation: Document Asset */
            DocumentAsset = new DwItemRelationship('DocumentSection|DocumentAsset|DocumentSectionId', 'DocumentAsset', 'DocumentAsset');
            /** Relation: Document Section Content */
            DocumentSectionContent = new DwItemRelationship('DocumentSection|DocumentSectionContent|DocumentSectionId', 'DocumentSectionContent', 'DocumentSectionContent');
            /** Relation: User Document Section Favorite - Original - Many */
            UserDocumentSectionFavoriteByOriginalDocumentSectionId = new DwItemRelationship('DocumentSection|UserDocumentSectionFavorite|OriginalDocumentSectionId', 'OriginalUserDocumentSectionFavorite', 'OriginalUserDocumentSectionFavorite');
    };
export class DocumentSectionContentMetaData implements DwItem2<DocumentSectionContentEntity, DocumentSectionContentMetaDataAttributes,DocumentSectionContentMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=455;
        this.ItemDetail.itemName='DocumentSectionContent';
        this.ItemDetail.keyName='DocumentSectionContentId';
    }

    CreateEntity(): DocumentSectionContentEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DocumentSectionContentQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DocumentSectionContentEntity, DocumentSectionContentMetaDataAttributes,DocumentSectionContentMetaDataRelations>(query, this);
    }
     Attributes = new DocumentSectionContentMetaDataAttributes();
     Relations = new DocumentSectionContentMetaDataRelations();

}


export type DocumentSectionContentQueryBuilder = DwQueryBuilderGen<DocumentSectionContentEntity, DocumentSectionContentMetaDataAttributes,DocumentSectionContentMetaDataRelations>


export class DocumentSectionContentMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'DocumentSectionContent';
    // Attributes
    DocumentSectionContentId = new DwItemAttribute(this.i, 'DocumentSectionContentId');
    DocumentSectionId = new DwItemAttribute(this.i, 'DocumentSectionId');
    DocumentContentFormatTypeId = new DwItemAttribute(this.i, 'DocumentContentFormatTypeId');
    BlockJson = new DwItemAttribute(this.i, 'BlockJson');
    PlainText = new DwItemAttribute(this.i, 'PlainText');
    ReferenceStatusId = new DwItemAttribute(this.i, 'ReferenceStatusId');
}

class DocumentSectionContentMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Document Content Format Type */
            DocumentContentFormatType = new DwItemRelationship('DocumentContentFormatType|DocumentSectionContent|DocumentContentFormatTypeId', 'DocumentContentFormatType', 'DocumentContentFormatType');
            /** Relation: Document Section */
            DocumentSection = new DwItemRelationship('DocumentSection|DocumentSectionContent|DocumentSectionId', 'DocumentSection', 'DocumentSection');
            /** Relation: Reference Status */
            ReferenceStatus = new DwItemRelationship('ReferenceStatus|DocumentSectionContent|ReferenceStatusId', 'ReferenceStatus', 'ReferenceStatus');
    };
export class DocumentSectionTypeMetaData implements DwItem2<DocumentSectionTypeEntity, DocumentSectionTypeMetaDataAttributes,DocumentSectionTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=448;
        this.ItemDetail.itemName='DocumentSectionType';
        this.ItemDetail.keyName='DocumentSectionTypeId';
    }

    CreateEntity(): DocumentSectionTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DocumentSectionTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DocumentSectionTypeEntity, DocumentSectionTypeMetaDataAttributes,DocumentSectionTypeMetaDataRelations>(query, this);
    }
     Attributes = new DocumentSectionTypeMetaDataAttributes();
     Relations = new DocumentSectionTypeMetaDataRelations();

}


export type DocumentSectionTypeQueryBuilder = DwQueryBuilderGen<DocumentSectionTypeEntity, DocumentSectionTypeMetaDataAttributes,DocumentSectionTypeMetaDataRelations>


export class DocumentSectionTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'DocumentSectionType';
    // Attributes
    DocumentSectionTypeId = new DwItemAttribute(this.i, 'DocumentSectionTypeId');
    DocumentSectionType = new DwItemAttribute(this.i, 'DocumentSectionType');
}

class DocumentSectionTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Document Section */
            DocumentSection = new DwItemRelationship('DocumentSectionType|DocumentSection|DocumentSectionTypeId', 'DocumentSection', 'DocumentSection');
    };
export class DocumentTypeMetaData implements DwItem2<DocumentTypeEntity, DocumentTypeMetaDataAttributes,DocumentTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=374;
        this.ItemDetail.itemName='DocumentType';
        this.ItemDetail.keyName='DocumentTypeId';
    }

    CreateEntity(): DocumentTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DocumentTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DocumentTypeEntity, DocumentTypeMetaDataAttributes,DocumentTypeMetaDataRelations>(query, this);
    }
     Attributes = new DocumentTypeMetaDataAttributes();
     Relations = new DocumentTypeMetaDataRelations();

}


export type DocumentTypeQueryBuilder = DwQueryBuilderGen<DocumentTypeEntity, DocumentTypeMetaDataAttributes,DocumentTypeMetaDataRelations>


export class DocumentTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'DocumentType';
    // Attributes
    DocumentTypeId = new DwItemAttribute(this.i, 'DocumentTypeId');
    DocumentType = new DwItemAttribute(this.i, 'DocumentType');
    UseEmbeddedMarkup = new DwItemAttribute(this.i, 'UseEmbeddedMarkup');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class DocumentTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Document Item */
            DocumentItem = new DwItemRelationship('DocumentType|DocumentItem|DocumentTypeId', 'DocumentItem', 'DocumentItem');
    };
export class DocumentVersionMetaData implements DwItem2<DocumentVersionEntity, DocumentVersionMetaDataAttributes,DocumentVersionMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=457;
        this.ItemDetail.itemName='DocumentVersion';
        this.ItemDetail.keyName='DocumentVersionId';
    }

    CreateEntity(): DocumentVersionEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DocumentVersionQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DocumentVersionEntity, DocumentVersionMetaDataAttributes,DocumentVersionMetaDataRelations>(query, this);
    }
     Attributes = new DocumentVersionMetaDataAttributes();
     Relations = new DocumentVersionMetaDataRelations();

}


export type DocumentVersionQueryBuilder = DwQueryBuilderGen<DocumentVersionEntity, DocumentVersionMetaDataAttributes,DocumentVersionMetaDataRelations>


export class DocumentVersionMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'DocumentVersion';
    // Attributes
    DocumentVersionId = new DwItemAttribute(this.i, 'DocumentVersionId');
    DocumentPublicationId = new DwItemAttribute(this.i, 'DocumentPublicationId');
    DocumentVersionTypeId = new DwItemAttribute(this.i, 'DocumentVersionTypeId');
    VersionLabel = new DwItemAttribute(this.i, 'VersionLabel');
    SourceVersion = new DwItemAttribute(this.i, 'SourceVersion');
    SourcePublishedDate = new DwItemAttribute(this.i, 'SourcePublishedDate');
    ReferenceStatusId = new DwItemAttribute(this.i, 'ReferenceStatusId');
    IsPublished = new DwItemAttribute(this.i, 'IsPublished');
    PublishedDateTime = new DwItemAttribute(this.i, 'PublishedDateTime');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class DocumentVersionMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Document Publication */
            DocumentPublication = new DwItemRelationship('DocumentPublication|DocumentVersion|DocumentPublicationId', 'DocumentPublication', 'DocumentPublication');
            /** Relation: Document Version Type */
            DocumentVersionType = new DwItemRelationship('DocumentVersionType|DocumentVersion|DocumentVersionTypeId', 'DocumentVersionType', 'DocumentVersionType');
            /** Relation: Reference Status */
            ReferenceStatus = new DwItemRelationship('ReferenceStatus|DocumentVersion|ReferenceStatusId', 'ReferenceStatus', 'ReferenceStatus');
            /** Relation: Course Lesson Document Link Reference */
            CourseLessonDocumentLinkReference = new DwItemRelationship('DocumentVersion|CourseLessonDocumentLinkReference|DocumentVersionId', 'CourseLessonDocumentLinkReference', 'CourseLessonDocumentLinkReference');
            /** Relation: Document Asset */
            DocumentAsset = new DwItemRelationship('DocumentVersion|DocumentAsset|DocumentVersionId', 'DocumentAsset', 'DocumentAsset');
            /** Relation: Document Import Job - Imported - Many */
            DocumentImportJobByImportedDocumentVersionId = new DwItemRelationship('DocumentVersion|DocumentImportJob|ImportedDocumentVersionId', 'ImportedDocumentImportJob', 'ImportedDocumentImportJob');
            /** Relation: Document Link Processing Run */
            DocumentLinkProcessingRun = new DwItemRelationship('DocumentVersion|DocumentLinkProcessingRun|DocumentVersionId', 'DocumentLinkProcessingRun', 'DocumentLinkProcessingRun');
            /** Relation: Document Publication - Current - Many */
            DocumentPublicationByCurrentDocumentVersionId = new DwItemRelationship('DocumentVersion|DocumentPublication|CurrentDocumentVersionId', 'CurrentDocumentPublication', 'CurrentDocumentPublication');
            /** Relation: Document Section */
            DocumentSection = new DwItemRelationship('DocumentVersion|DocumentSection|DocumentVersionId', 'DocumentSection', 'DocumentSection');
            /** Relation: User Document Section Favorite - Original - Many */
            UserDocumentSectionFavoriteByOriginalDocumentVersionId = new DwItemRelationship('DocumentVersion|UserDocumentSectionFavorite|OriginalDocumentVersionId', 'OriginalUserDocumentSectionFavorite', 'OriginalUserDocumentSectionFavorite');
    };
export class DocumentVersionTypeMetaData implements DwItem2<DocumentVersionTypeEntity, DocumentVersionTypeMetaDataAttributes,DocumentVersionTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=459;
        this.ItemDetail.itemName='DocumentVersionType';
        this.ItemDetail.keyName='DocumentVersionTypeId';
    }

    CreateEntity(): DocumentVersionTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DocumentVersionTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DocumentVersionTypeEntity, DocumentVersionTypeMetaDataAttributes,DocumentVersionTypeMetaDataRelations>(query, this);
    }
     Attributes = new DocumentVersionTypeMetaDataAttributes();
     Relations = new DocumentVersionTypeMetaDataRelations();

}


export type DocumentVersionTypeQueryBuilder = DwQueryBuilderGen<DocumentVersionTypeEntity, DocumentVersionTypeMetaDataAttributes,DocumentVersionTypeMetaDataRelations>


export class DocumentVersionTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'DocumentVersionType';
    // Attributes
    DocumentVersionTypeId = new DwItemAttribute(this.i, 'DocumentVersionTypeId');
    DocumentVersionType = new DwItemAttribute(this.i, 'DocumentVersionType');
}

class DocumentVersionTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Document Version */
            DocumentVersion = new DwItemRelationship('DocumentVersionType|DocumentVersion|DocumentVersionTypeId', 'DocumentVersion', 'DocumentVersion');
    };
export class FlightSchoolMetaData implements DwItem2<FlightSchoolEntity, FlightSchoolMetaDataAttributes,FlightSchoolMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=176;
        this.ItemDetail.itemName='FlightSchool';
        this.ItemDetail.keyName='FlightSchoolId';
    }

    CreateEntity(): FlightSchoolEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): FlightSchoolQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<FlightSchoolEntity, FlightSchoolMetaDataAttributes,FlightSchoolMetaDataRelations>(query, this);
    }
     Attributes = new FlightSchoolMetaDataAttributes();
     Relations = new FlightSchoolMetaDataRelations();

}


export type FlightSchoolQueryBuilder = DwQueryBuilderGen<FlightSchoolEntity, FlightSchoolMetaDataAttributes,FlightSchoolMetaDataRelations>


export class FlightSchoolMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'FlightSchool';
    // Attributes
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    FlightSchoolName = new DwItemAttribute(this.i, 'FlightSchoolName');
    FlightSchoolStatusId = new DwItemAttribute(this.i, 'FlightSchoolStatusId');
    NumberOfAircraft = new DwItemAttribute(this.i, 'NumberOfAircraft');
    Location = new DwItemAttribute(this.i, 'Location');
    NumberOfStudents = new DwItemAttribute(this.i, 'NumberOfStudents');
    PercentDiscount = new DwItemAttribute(this.i, 'PercentDiscount');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    IsDefaultFlightSchool = new DwItemAttribute(this.i, 'IsDefaultFlightSchool');
    FlightSchoolBrandingId = new DwItemAttribute(this.i, 'FlightSchoolBrandingId');
    ProfitSharingPercentageOverride = new DwItemAttribute(this.i, 'ProfitSharingPercentageOverride');
    IsMarketplaceEnabled = new DwItemAttribute(this.i, 'IsMarketplaceEnabled');
    PortalConfigId = new DwItemAttribute(this.i, 'PortalConfigId');
    ProfitSharingExcludeOnSchoolInvoices = new DwItemAttribute(this.i, 'ProfitSharingExcludeOnSchoolInvoices');
    IsAIModuleSummaryEnabled = new DwItemAttribute(this.i, 'IsAIModuleSummaryEnabled');
    UniqueId = new DwItemAttribute(this.i, 'UniqueId');
    DeferredCourseBillingEnabled = new DwItemAttribute(this.i, 'DeferredCourseBillingEnabled');
    StudentProfitSharingReductionEnabled = new DwItemAttribute(this.i, 'StudentProfitSharingReductionEnabled');
    UniversityBillingModeEnabled = new DwItemAttribute(this.i, 'UniversityBillingModeEnabled');
    DeferredInvoicePaymentTermsDays = new DwItemAttribute(this.i, 'DeferredInvoicePaymentTermsDays');
    InactiveStudentRemovalEnabled = new DwItemAttribute(this.i, 'InactiveStudentRemovalEnabled');
    InactiveStudentRemovalDays = new DwItemAttribute(this.i, 'InactiveStudentRemovalDays');
    BillingContactEmail = new DwItemAttribute(this.i, 'BillingContactEmail');
    BillingAddressId = new DwItemAttribute(this.i, 'BillingAddressId');
    RestrictRegistrationEmailDomains = new DwItemAttribute(this.i, 'RestrictRegistrationEmailDomains');
    AllowInstructorRegistrationRoleSelection = new DwItemAttribute(this.i, 'AllowInstructorRegistrationRoleSelection');
    DefaultTimeZoneId = new DwItemAttribute(this.i, 'DefaultTimeZoneId');
    IsTaxExempt = new DwItemAttribute(this.i, 'IsTaxExempt');
    SchoolBillingModeId = new DwItemAttribute(this.i, 'SchoolBillingModeId');
}

class FlightSchoolMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Address - Billing Address */
            AddressByBillingAddressId = new DwItemRelationship('Address|FlightSchool|BillingAddressId', 'BillingAddress', 'BillingAddress');
            /** Relation: Flight School Branding */
            FlightSchoolBranding = new DwItemRelationship('FlightSchoolBranding|FlightSchool|FlightSchoolBrandingId', 'FlightSchoolBranding', 'FlightSchoolBranding');
            /** Relation: Flight School Status */
            FlightSchoolStatus = new DwItemRelationship('FlightSchoolStatus|FlightSchool|FlightSchoolStatusId', 'FlightSchoolStatus', 'FlightSchoolStatus');
            /** Relation: School Billing Mode */
            SchoolBillingMode = new DwItemRelationship('SchoolBillingMode|FlightSchool|SchoolBillingModeId', 'SchoolBillingMode', 'SchoolBillingMode');
            /** Relation: Time Zone - Default Time Zone */
            TimeZoneByDefaultTimeZoneId = new DwItemRelationship('TimeZone|FlightSchool|DefaultTimeZoneId', 'DefaultTimeZoneIdTimeZone', 'DefaultTimeZoneIdTimeZone');
            /** Relation: Assignment */
            Assignment = new DwItemRelationship('CourseLesson|Assignment|CourseLessonId', 'Assignment', 'Assignment');
            /** Relation: Course Availability Notification */
            CourseAvailabilityNotification = new DwItemRelationship('FlightSchool|CourseAvailabilityNotification|FlightSchoolId', 'CourseAvailabilityNotification', 'CourseAvailabilityNotification');
            /** Relation: Course Purchase Reservation */
            CoursePurchaseReservation = new DwItemRelationship('FlightSchool|CoursePurchaseReservation|FlightSchoolId', 'CoursePurchaseReservation', 'CoursePurchaseReservation');
            /** Relation: Discount - Limit To - Many */
            DiscountByLimitToFlightSchoolId = new DwItemRelationship('FlightSchool|Discount|LimitToFlightSchoolId', 'LimitToDiscount', 'LimitToDiscount');
            /** Relation: Discount Usage Flight School */
            DiscountUsageFlightSchool = new DwItemRelationship('FlightSchool|DiscountUsageFlightSchool|FlightSchoolId', 'DiscountUsageFlightSchool', 'DiscountUsageFlightSchool');
            /** Relation: Document Folder */
            DocumentFolder = new DwItemRelationship('FlightSchool|DocumentFolder|FlightSchoolId', 'DocumentFolder', 'DocumentFolder');
            /** Relation: Document Item */
            DocumentItem = new DwItemRelationship('FlightSchool|DocumentItem|FlightSchoolId', 'DocumentItem', 'DocumentItem');
            /** Relation: Flight School Billing Contact */
            FlightSchoolBillingContact = new DwItemRelationship('FlightSchool|FlightSchoolBillingContact|FlightSchoolId', 'FlightSchoolBillingContact', 'FlightSchoolBillingContact');
            /** Relation: Flight School Course */
            FlightSchoolCourse = new DwItemRelationship('FlightSchool|FlightSchoolCourse|FlightSchoolId', 'FlightSchoolCourse', 'FlightSchoolCourse');
            /** Relation: Flight School Feature */
            FlightSchoolFeature = new DwItemRelationship('FlightSchool|FlightSchoolFeature|FlightSchoolId', 'FlightSchoolFeature', 'FlightSchoolFeature');
            /** Relation: Flight School Group */
            FlightSchoolGroup = new DwItemRelationship('FlightSchool|FlightSchoolGroup|FlightSchoolId', 'FlightSchoolGroup', 'FlightSchoolGroup');
            /** Relation: Flight School Instructor */
            FlightSchoolInstructor = new DwItemRelationship('FlightSchool|FlightSchoolInstructor|FlightSchoolId', 'FlightSchoolInstructor', 'FlightSchoolInstructor');
            /** Relation: Flight School Package */
            FlightSchoolPackage = new DwItemRelationship('FlightSchool|FlightSchoolPackage|FlightSchoolId', 'FlightSchoolPackage', 'FlightSchoolPackage');
            /** Relation: Flight School Registration Email Domain */
            FlightSchoolRegistrationEmailDomain = new DwItemRelationship('FlightSchool|FlightSchoolRegistrationEmailDomain|FlightSchoolId', 'FlightSchoolRegistrationEmailDomain', 'FlightSchoolRegistrationEmailDomain');
            /** Relation: Flight School Registration Link */
            FlightSchoolRegistrationLink = new DwItemRelationship('FlightSchool|FlightSchoolRegistrationLink|FlightSchoolId', 'FlightSchoolRegistrationLink', 'FlightSchoolRegistrationLink');
            /** Relation: Gamification Configuration */
            GamificationConfiguration = new DwItemRelationship('FlightSchool|GamificationConfiguration|FlightSchoolId', 'GamificationConfiguration', 'GamificationConfiguration');
            /** Relation: Instructor */
            Instructor = new DwItemRelationship('FlightSchool|Instructor|FlightSchoolId', 'Instructor', 'Instructor');
            /** Relation: Integration Organization */
            IntegrationOrganization = new DwItemRelationship('FlightSchool|IntegrationOrganization|FlightSchoolId', 'IntegrationOrganization', 'IntegrationOrganization');
            /** Relation: Invoice */
            Invoice = new DwItemRelationship('FlightSchool|Invoice|FlightSchoolId', 'Invoice', 'Invoice');
            /** Relation: Join Request */
            JoinRequest = new DwItemRelationship('FlightSchool|JoinRequest|FlightSchoolId', 'JoinRequest', 'JoinRequest');
            /** Relation: Join Request Course Purchase */
            JoinRequestCoursePurchase = new DwItemRelationship('FlightSchool|JoinRequestCoursePurchase|FlightSchoolId', 'JoinRequestCoursePurchase', 'JoinRequestCoursePurchase');
            /** Relation: Multiple Assign Flight School */
            MultipleAssignFlightSchool = new DwItemRelationship('FlightSchool|MultipleAssignFlightSchool|FlightSchoolId', 'MultipleAssignFlightSchool', 'MultipleAssignFlightSchool');
            /** Relation: Processor Config */
            ProcessorConfig = new DwItemRelationship('FlightSchool|ProcessorConfig|FlightSchoolId', 'ProcessorConfig', 'ProcessorConfig');
            /** Relation: Profit Share */
            ProfitShare = new DwItemRelationship('FlightSchool|ProfitShare|FlightSchoolId', 'ProfitShare', 'ProfitShare');
            /** Relation: Ro Flight School Course Package Count */
            RoFlightSchoolCoursePackageCount = new DwItemRelationship('FlightSchool|RoFlightSchoolCoursePackageCount', 'RoFlightSchoolCoursePackageCount', 'RoFlightSchoolCoursePackageCount');
            /** Relation: Ro Flight School Course Unique */
            RoFlightSchoolCourseUnique = new DwItemRelationship('FlightSchool|RoFlightSchoolCourseUnique', 'RoFlightSchoolCourseUnique', 'RoFlightSchoolCourseUnique');
            /** Relation: Ro Flight School Payment Info */
            RoFlightSchoolPaymentInfo = new DwItemRelationship('FlightSchool|RoFlightSchoolPaymentInfo|FlightSchoolId', 'RoFlightSchoolPaymentInfo', 'RoFlightSchoolPaymentInfo');
            /** Relation: Ro School Billing Details */
            RoSchoolBillingDetails = new DwItemRelationship('roSchoolBillingDetails|FlightSchool|FlightSchoolId', 'RoSchoolBillingDetails', 'RoSchoolBillingDetails');
            /** Relation: Ro School Invoices */
            RoSchoolInvoices = new DwItemRelationship('roSchoolInvoices|Invoices|FlightSchoolId', 'RoSchoolInvoices', 'RoSchoolInvoices');
            /** Relation: Ro School Payment Method */
            RoSchoolPaymentMethod = new DwItemRelationship('roSchoolPaymentMethod|FlightSchool|FlightSchoolId', 'RoSchoolPaymentMethod', 'RoSchoolPaymentMethod');
            /** Relation: Ro School Student Stats */
            RoSchoolStudentStats = new DwItemRelationship('FlightSchool|RoSchoolStudentStats|FlightSchoolId', 'RoSchoolStudentStats', 'RoSchoolStudentStats');
            /** Relation: Ro Student Course Detail */
            RoStudentCourseDetail = new DwItemRelationship('FlightSchool|RoStudentCourseDetail|FlightSchoolId', 'RoStudentCourseDetail', 'RoStudentCourseDetail');
            /** Relation: Ro Student School Course */
            RoStudentSchoolCourses = new DwItemRelationship('RoStudentSchoolCourse|FlightSchool|FlightSchoolId', 'RoStudentSchoolCourses', 'RoStudentSchoolCourses');
            /** Relation: School Billing Policy Period */
            SchoolBillingPolicyPeriod = new DwItemRelationship('FlightSchool|SchoolBillingPolicyPeriod|FlightSchoolId', 'SchoolBillingPolicyPeriod', 'SchoolBillingPolicyPeriod');
            /** Relation: Subscription */
            Subscription = new DwItemRelationship('FlightSchool|Subscription|FlightSchoolId', 'Subscription', 'Subscription');
            /** Relation: Subscription Course Tracking */
            SubscriptionCourseTracking = new DwItemRelationship('FlightSchool|SubscriptionCourseTracking|FlightSchoolId', 'SubscriptionCourseTracking', 'SubscriptionCourseTracking');
            /** Relation: Subscription Tier Flight School */
            SubscriptionTierFlightSchool = new DwItemRelationship('FlightSchool|SubscriptionTierFlightSchool|FlightSchoolId', 'SubscriptionTierFlightSchool', 'SubscriptionTierFlightSchool');
            /** Relation: User Detail */
            UserDetail = new DwItemRelationship('FlightSchool|UserDetail|FlightSchoolId', 'UserDetail', 'UserDetail');
    };
export class FlightSchoolBillingContactMetaData implements DwItem2<FlightSchoolBillingContactEntity, FlightSchoolBillingContactMetaDataAttributes,FlightSchoolBillingContactMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=475;
        this.ItemDetail.itemName='FlightSchoolBillingContact';
        this.ItemDetail.keyName='FlightSchoolBillingContactId';
    }

    CreateEntity(): FlightSchoolBillingContactEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): FlightSchoolBillingContactQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<FlightSchoolBillingContactEntity, FlightSchoolBillingContactMetaDataAttributes,FlightSchoolBillingContactMetaDataRelations>(query, this);
    }
     Attributes = new FlightSchoolBillingContactMetaDataAttributes();
     Relations = new FlightSchoolBillingContactMetaDataRelations();

}


export type FlightSchoolBillingContactQueryBuilder = DwQueryBuilderGen<FlightSchoolBillingContactEntity, FlightSchoolBillingContactMetaDataAttributes,FlightSchoolBillingContactMetaDataRelations>


export class FlightSchoolBillingContactMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'FlightSchoolBillingContact';
    // Attributes
    FlightSchoolBillingContactId = new DwItemAttribute(this.i, 'FlightSchoolBillingContactId');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    UserId = new DwItemAttribute(this.i, 'UserId');
    EmailAddress = new DwItemAttribute(this.i, 'EmailAddress');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class FlightSchoolBillingContactMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School */
            FlightSchool = new DwItemRelationship('FlightSchool|FlightSchoolBillingContact|FlightSchoolId', 'FlightSchool', 'FlightSchool');
            /** Relation: User */
            DwUser = new DwItemRelationship('dw_User|FlightSchoolBillingContact|UserId', 'DwUser', 'DwUser');
    };
export class FlightSchoolBrandingMetaData implements DwItem2<FlightSchoolBrandingEntity, FlightSchoolBrandingMetaDataAttributes,FlightSchoolBrandingMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=241;
        this.ItemDetail.itemName='FlightSchoolBranding';
        this.ItemDetail.keyName='FlightSchoolBrandingId';
    }

    CreateEntity(): FlightSchoolBrandingEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): FlightSchoolBrandingQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<FlightSchoolBrandingEntity, FlightSchoolBrandingMetaDataAttributes,FlightSchoolBrandingMetaDataRelations>(query, this);
    }
     Attributes = new FlightSchoolBrandingMetaDataAttributes();
     Relations = new FlightSchoolBrandingMetaDataRelations();

}


export type FlightSchoolBrandingQueryBuilder = DwQueryBuilderGen<FlightSchoolBrandingEntity, FlightSchoolBrandingMetaDataAttributes,FlightSchoolBrandingMetaDataRelations>


export class FlightSchoolBrandingMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'FlightSchoolBranding';
    // Attributes
    FlightSchoolBrandingId = new DwItemAttribute(this.i, 'FlightSchoolBrandingId');
    SubdomainSetupStatusId = new DwItemAttribute(this.i, 'SubdomainSetupStatusId');
    SubdomainTypeId = new DwItemAttribute(this.i, 'SubdomainTypeId');
    DomainName = new DwItemAttribute(this.i, 'DomainName');
    ThemeId = new DwItemAttribute(this.i, 'ThemeId');
    NavigationColorSetId = new DwItemAttribute(this.i, 'NavigationColorSetId');
    SidebarColorSetId = new DwItemAttribute(this.i, 'SidebarColorSetId');
    UseCustomColors = new DwItemAttribute(this.i, 'UseCustomColors');
    LoginColorSetId = new DwItemAttribute(this.i, 'LoginColorSetId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    DomainAutoJoinSchool = new DwItemAttribute(this.i, 'DomainAutoJoinSchool');
    UseCustomLoginMedia = new DwItemAttribute(this.i, 'UseCustomLoginMedia');
    StandardLoginMediaId = new DwItemAttribute(this.i, 'StandardLoginMediaId');
    CustomLoginMediaGroupId = new DwItemAttribute(this.i, 'CustomLoginMediaGroupId');
    MobileAppIconMediaId = new DwItemAttribute(this.i, 'MobileAppIconMediaId');
}

class FlightSchoolBrandingMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Media - Mobile App Icon Media */
            DwMediaByMobileAppIconMediaId = new DwItemRelationship('dw_Media|FlightSchoolBranding|MobileAppIconMediaId', 'MobileAppIconDwMedia', 'MobileAppIconDwMedia');
            /** Relation: Media Group - Custom Login Media Group */
            DwMediaGroupByCustomLoginMediaGroupId = new DwItemRelationship('dw_MediaGroup|FlightSchoolBranding|CustomLoginMediaGroupId', 'CustomLoginDwMediaGroup', 'CustomLoginDwMediaGroup');
            /** Relation: Standard Color Set - Navigation Color Set */
            StandardColorSetByNavigationColorSetId = new DwItemRelationship('StandardColorSet|FlightSchoolBranding|NavigationColorSetId', 'NavigationColorSetIdStandardColorSet', 'NavigationColorSetIdStandardColorSet');
            /** Relation: Standard Color Set - Sidebar Color Set */
            StandardColorSetBySidebarColorSetId = new DwItemRelationship('StandardColorSet|FlightSchoolBranding|SidebarColorSetId', 'SidebarColorSetIdStandardColorSet', 'SidebarColorSetIdStandardColorSet');
            /** Relation: Standard Color Set - Login Color Set */
            StandardColorSetByLoginColorSetId = new DwItemRelationship('StandardColorSet|FlightSchoolBranding|LoginColorSetId', 'LoginColorSetIdStandardColorSet', 'LoginColorSetIdStandardColorSet');
            /** Relation: Standard Login Media */
            StandardLoginMedia = new DwItemRelationship('StandardLoginMedia|FlightSchoolBranding|StandardLoginMediaId', 'StandardLoginMedia', 'StandardLoginMedia');
            /** Relation: Subdomain Setup Status */
            SubdomainSetupStatus = new DwItemRelationship('SubdomainSetupStatus|FlightSchoolBranding|SubdomainSetupStatusId', 'SubdomainSetupStatus', 'SubdomainSetupStatus');
            /** Relation: Subdomain Type */
            SubdomainType = new DwItemRelationship('SubdomainType|FlightSchoolBranding|SubdomainTypeId', 'SubdomainType', 'SubdomainType');
            /** Relation: Theme */
            DwTheme = new DwItemRelationship('dw_Theme|FlightSchoolBranding|ThemeId', 'DwTheme', 'DwTheme');
            /** Relation: Flight School */
            FlightSchool = new DwItemRelationship('FlightSchoolBranding|FlightSchool|FlightSchoolBrandingId', 'FlightSchool', 'FlightSchool');
    };
export class FlightSchoolCourseMetaData implements DwItem2<FlightSchoolCourseEntity, FlightSchoolCourseMetaDataAttributes,FlightSchoolCourseMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=177;
        this.ItemDetail.itemName='FlightSchoolCourse';
        this.ItemDetail.keyName='FlightSchoolCourseId';
    }

    CreateEntity(): FlightSchoolCourseEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): FlightSchoolCourseQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<FlightSchoolCourseEntity, FlightSchoolCourseMetaDataAttributes,FlightSchoolCourseMetaDataRelations>(query, this);
    }
     Attributes = new FlightSchoolCourseMetaDataAttributes();
     Relations = new FlightSchoolCourseMetaDataRelations();

}


export type FlightSchoolCourseQueryBuilder = DwQueryBuilderGen<FlightSchoolCourseEntity, FlightSchoolCourseMetaDataAttributes,FlightSchoolCourseMetaDataRelations>


export class FlightSchoolCourseMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'FlightSchoolCourse';
    // Attributes
    FlightSchoolCourseId = new DwItemAttribute(this.i, 'FlightSchoolCourseId');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    CourseId = new DwItemAttribute(this.i, 'CourseId');
    SchoolCoursePrice = new DwItemAttribute(this.i, 'SchoolCoursePrice');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class FlightSchoolCourseMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Course */
            Course = new DwItemRelationship('Course|FlightSchoolCourse|CourseId', 'Course', 'Course');
            /** Relation: Flight School */
            FlightSchool = new DwItemRelationship('FlightSchool|FlightSchoolCourse|FlightSchoolId', 'FlightSchool', 'FlightSchool');
    };
export class FlightSchoolFeatureMetaData implements DwItem2<FlightSchoolFeatureEntity, FlightSchoolFeatureMetaDataAttributes,FlightSchoolFeatureMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=376;
        this.ItemDetail.itemName='FlightSchoolFeature';
        this.ItemDetail.keyName='FlightSchoolFeatureId';
    }

    CreateEntity(): FlightSchoolFeatureEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): FlightSchoolFeatureQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<FlightSchoolFeatureEntity, FlightSchoolFeatureMetaDataAttributes,FlightSchoolFeatureMetaDataRelations>(query, this);
    }
     Attributes = new FlightSchoolFeatureMetaDataAttributes();
     Relations = new FlightSchoolFeatureMetaDataRelations();

}


export type FlightSchoolFeatureQueryBuilder = DwQueryBuilderGen<FlightSchoolFeatureEntity, FlightSchoolFeatureMetaDataAttributes,FlightSchoolFeatureMetaDataRelations>


export class FlightSchoolFeatureMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'FlightSchoolFeature';
    // Attributes
    FlightSchoolFeatureId = new DwItemAttribute(this.i, 'FlightSchoolFeatureId');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    SchoolFeatureId = new DwItemAttribute(this.i, 'SchoolFeatureId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class FlightSchoolFeatureMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School */
            FlightSchool = new DwItemRelationship('FlightSchool|FlightSchoolFeature|FlightSchoolId', 'FlightSchool', 'FlightSchool');
            /** Relation: School Feature */
            SchoolFeature = new DwItemRelationship('SchoolFeature|FlightSchoolFeature|SchoolFeatureId', 'SchoolFeature', 'SchoolFeature');
    };
export class FlightSchoolGroupMetaData implements DwItem2<FlightSchoolGroupEntity, FlightSchoolGroupMetaDataAttributes,FlightSchoolGroupMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=192;
        this.ItemDetail.itemName='FlightSchoolGroup';
        this.ItemDetail.keyName='FlightSchoolGroupId';
    }

    CreateEntity(): FlightSchoolGroupEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): FlightSchoolGroupQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<FlightSchoolGroupEntity, FlightSchoolGroupMetaDataAttributes,FlightSchoolGroupMetaDataRelations>(query, this);
    }
     Attributes = new FlightSchoolGroupMetaDataAttributes();
     Relations = new FlightSchoolGroupMetaDataRelations();

}


export type FlightSchoolGroupQueryBuilder = DwQueryBuilderGen<FlightSchoolGroupEntity, FlightSchoolGroupMetaDataAttributes,FlightSchoolGroupMetaDataRelations>


export class FlightSchoolGroupMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'FlightSchoolGroup';
    // Attributes
    FlightSchoolGroupId = new DwItemAttribute(this.i, 'FlightSchoolGroupId');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    GroupName = new DwItemAttribute(this.i, 'GroupName');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class FlightSchoolGroupMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School */
            FlightSchool = new DwItemRelationship('FlightSchool|FlightSchoolGroup|FlightSchoolId', 'FlightSchool', 'FlightSchool');
            /** Relation: Assignment */
            Assignment = new DwItemRelationship('FlightSchoolGroup|Assignment|FlightSchoolGroupId', 'Assignment', 'Assignment');
            /** Relation: Course Purchase */
            CoursePurchase = new DwItemRelationship('FlightSchoolGroup|CoursePurchase|FlightSchoolGroupId', 'CoursePurchase', 'CoursePurchase');
            /** Relation: Flight School Group Student */
            FlightSchoolGroupStudent = new DwItemRelationship('FlightSchoolGroup|FlightSchoolGroupStudent|FlightSchoolGroupId', 'FlightSchoolGroupStudent', 'FlightSchoolGroupStudent');
            /** Relation: Join Request */
            JoinRequest = new DwItemRelationship('FlightSchoolGroup|JoinRequest|FlightSchoolStudentGroupId', 'JoinRequest', 'JoinRequest');
    };
export class FlightSchoolGroupStudentMetaData implements DwItem2<FlightSchoolGroupStudentEntity, FlightSchoolGroupStudentMetaDataAttributes,FlightSchoolGroupStudentMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=193;
        this.ItemDetail.itemName='FlightSchoolGroupStudent';
        this.ItemDetail.keyName='FlightSchoolGroupStudentId';
    }

    CreateEntity(): FlightSchoolGroupStudentEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): FlightSchoolGroupStudentQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<FlightSchoolGroupStudentEntity, FlightSchoolGroupStudentMetaDataAttributes,FlightSchoolGroupStudentMetaDataRelations>(query, this);
    }
     Attributes = new FlightSchoolGroupStudentMetaDataAttributes();
     Relations = new FlightSchoolGroupStudentMetaDataRelations();

}


export type FlightSchoolGroupStudentQueryBuilder = DwQueryBuilderGen<FlightSchoolGroupStudentEntity, FlightSchoolGroupStudentMetaDataAttributes,FlightSchoolGroupStudentMetaDataRelations>


export class FlightSchoolGroupStudentMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'FlightSchoolGroupStudent';
    // Attributes
    FlightSchoolGroupStudentId = new DwItemAttribute(this.i, 'FlightSchoolGroupStudentId');
    FlightSchoolGroupId = new DwItemAttribute(this.i, 'FlightSchoolGroupId');
    StudentId = new DwItemAttribute(this.i, 'StudentId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class FlightSchoolGroupStudentMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School Group */
            FlightSchoolGroup = new DwItemRelationship('FlightSchoolGroup|FlightSchoolGroupStudent|FlightSchoolGroupId', 'FlightSchoolGroup', 'FlightSchoolGroup');
            /** Relation: Student */
            Student = new DwItemRelationship('Student|FlightSchoolGroupStudent|StudentId', 'Student', 'Student');
    };
export class FlightSchoolInstructorMetaData implements DwItem2<FlightSchoolInstructorEntity, FlightSchoolInstructorMetaDataAttributes,FlightSchoolInstructorMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=212;
        this.ItemDetail.itemName='FlightSchoolInstructor';
        this.ItemDetail.keyName='FlightSchoolInstructorId';
    }

    CreateEntity(): FlightSchoolInstructorEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): FlightSchoolInstructorQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<FlightSchoolInstructorEntity, FlightSchoolInstructorMetaDataAttributes,FlightSchoolInstructorMetaDataRelations>(query, this);
    }
     Attributes = new FlightSchoolInstructorMetaDataAttributes();
     Relations = new FlightSchoolInstructorMetaDataRelations();

}


export type FlightSchoolInstructorQueryBuilder = DwQueryBuilderGen<FlightSchoolInstructorEntity, FlightSchoolInstructorMetaDataAttributes,FlightSchoolInstructorMetaDataRelations>


export class FlightSchoolInstructorMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'FlightSchoolInstructor';
    // Attributes
    FlightSchoolInstructorId = new DwItemAttribute(this.i, 'FlightSchoolInstructorId');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    InstructorId = new DwItemAttribute(this.i, 'InstructorId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class FlightSchoolInstructorMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School */
            FlightSchool = new DwItemRelationship('FlightSchool|FlightSchoolInstructor|FlightSchoolId', 'FlightSchool', 'FlightSchool');
            /** Relation: Instructor */
            Instructor = new DwItemRelationship('Instructor|FlightSchoolInstructor|InstructorId', 'Instructor', 'Instructor');
    };
export class FlightSchoolPackageMetaData implements DwItem2<FlightSchoolPackageEntity, FlightSchoolPackageMetaDataAttributes,FlightSchoolPackageMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=180;
        this.ItemDetail.itemName='FlightSchoolPackage';
        this.ItemDetail.keyName='FlightSchoolPackageId';
    }

    CreateEntity(): FlightSchoolPackageEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): FlightSchoolPackageQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<FlightSchoolPackageEntity, FlightSchoolPackageMetaDataAttributes,FlightSchoolPackageMetaDataRelations>(query, this);
    }
     Attributes = new FlightSchoolPackageMetaDataAttributes();
     Relations = new FlightSchoolPackageMetaDataRelations();

}


export type FlightSchoolPackageQueryBuilder = DwQueryBuilderGen<FlightSchoolPackageEntity, FlightSchoolPackageMetaDataAttributes,FlightSchoolPackageMetaDataRelations>


export class FlightSchoolPackageMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'FlightSchoolPackage';
    // Attributes
    FlightSchoolPackageId = new DwItemAttribute(this.i, 'FlightSchoolPackageId');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    PackageId = new DwItemAttribute(this.i, 'PackageId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class FlightSchoolPackageMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School */
            FlightSchool = new DwItemRelationship('FlightSchool|FlightSchoolPackage|FlightSchoolId', 'FlightSchool', 'FlightSchool');
            /** Relation: Package */
            Package = new DwItemRelationship('Package|FlightSchoolPackage|PackageId', 'Package', 'Package');
    };
export class FlightSchoolPositionMetaData implements DwItem2<FlightSchoolPositionEntity, FlightSchoolPositionMetaDataAttributes,FlightSchoolPositionMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=415;
        this.ItemDetail.itemName='FlightSchoolPosition';
        this.ItemDetail.keyName='FlightSchoolPositionId';
    }

    CreateEntity(): FlightSchoolPositionEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): FlightSchoolPositionQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<FlightSchoolPositionEntity, FlightSchoolPositionMetaDataAttributes,FlightSchoolPositionMetaDataRelations>(query, this);
    }
     Attributes = new FlightSchoolPositionMetaDataAttributes();
     Relations = new FlightSchoolPositionMetaDataRelations();

}


export type FlightSchoolPositionQueryBuilder = DwQueryBuilderGen<FlightSchoolPositionEntity, FlightSchoolPositionMetaDataAttributes,FlightSchoolPositionMetaDataRelations>


export class FlightSchoolPositionMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'FlightSchoolPosition';
    // Attributes
    Description = new DwItemAttribute(this.i, 'Description');
    FlightSchoolPositionId = new DwItemAttribute(this.i, 'FlightSchoolPositionId');
    FlightSchoolPosition = new DwItemAttribute(this.i, 'FlightSchoolPosition');
    PositionOrder = new DwItemAttribute(this.i, 'PositionOrder');
    IsInstructor = new DwItemAttribute(this.i, 'IsInstructor');
}

class FlightSchoolPositionMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Student */
            Student = new DwItemRelationship('FlightSchoolPosistion|Student|FlightSchoolPositionId', 'Student', 'Student');
    };
export class FlightSchoolRegistrationEmailDomainMetaData implements DwItem2<FlightSchoolRegistrationEmailDomainEntity, FlightSchoolRegistrationEmailDomainMetaDataAttributes,FlightSchoolRegistrationEmailDomainMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=481;
        this.ItemDetail.itemName='FlightSchoolRegistrationEmailDomain';
        this.ItemDetail.keyName='FlightSchoolRegistrationEmailDomainId';
    }

    CreateEntity(): FlightSchoolRegistrationEmailDomainEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): FlightSchoolRegistrationEmailDomainQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<FlightSchoolRegistrationEmailDomainEntity, FlightSchoolRegistrationEmailDomainMetaDataAttributes,FlightSchoolRegistrationEmailDomainMetaDataRelations>(query, this);
    }
     Attributes = new FlightSchoolRegistrationEmailDomainMetaDataAttributes();
     Relations = new FlightSchoolRegistrationEmailDomainMetaDataRelations();

}


export type FlightSchoolRegistrationEmailDomainQueryBuilder = DwQueryBuilderGen<FlightSchoolRegistrationEmailDomainEntity, FlightSchoolRegistrationEmailDomainMetaDataAttributes,FlightSchoolRegistrationEmailDomainMetaDataRelations>


export class FlightSchoolRegistrationEmailDomainMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'FlightSchoolRegistrationEmailDomain';
    // Attributes
    FlightSchoolRegistrationEmailDomainId = new DwItemAttribute(this.i, 'FlightSchoolRegistrationEmailDomainId');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    EmailDomain = new DwItemAttribute(this.i, 'EmailDomain');
    Active = new DwItemAttribute(this.i, 'Active');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class FlightSchoolRegistrationEmailDomainMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School */
            FlightSchool = new DwItemRelationship('FlightSchool|FlightSchoolRegistrationEmailDomain|FlightSchoolId', 'FlightSchool', 'FlightSchool');
    };
export class FlightSchoolRegistrationLinkMetaData implements DwItem2<FlightSchoolRegistrationLinkEntity, FlightSchoolRegistrationLinkMetaDataAttributes,FlightSchoolRegistrationLinkMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=482;
        this.ItemDetail.itemName='FlightSchoolRegistrationLink';
        this.ItemDetail.keyName='FlightSchoolRegistrationLinkId';
    }

    CreateEntity(): FlightSchoolRegistrationLinkEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): FlightSchoolRegistrationLinkQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<FlightSchoolRegistrationLinkEntity, FlightSchoolRegistrationLinkMetaDataAttributes,FlightSchoolRegistrationLinkMetaDataRelations>(query, this);
    }
     Attributes = new FlightSchoolRegistrationLinkMetaDataAttributes();
     Relations = new FlightSchoolRegistrationLinkMetaDataRelations();

}


export type FlightSchoolRegistrationLinkQueryBuilder = DwQueryBuilderGen<FlightSchoolRegistrationLinkEntity, FlightSchoolRegistrationLinkMetaDataAttributes,FlightSchoolRegistrationLinkMetaDataRelations>


export class FlightSchoolRegistrationLinkMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'FlightSchoolRegistrationLink';
    // Attributes
    FlightSchoolRegistrationLinkId = new DwItemAttribute(this.i, 'FlightSchoolRegistrationLinkId');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    RegistrationToken = new DwItemAttribute(this.i, 'RegistrationToken');
    Active = new DwItemAttribute(this.i, 'Active');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    JoinRequestTypeId = new DwItemAttribute(this.i, 'JoinRequestTypeId');
}

class FlightSchoolRegistrationLinkMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School */
            FlightSchool = new DwItemRelationship('FlightSchool|FlightSchoolRegistrationLink|FlightSchoolId', 'FlightSchool', 'FlightSchool');
            /** Relation: Join Request Type */
            JoinRequestType = new DwItemRelationship('JoinRequestType|FlightSchoolRegistrationLink|JoinRequestTypeId', 'JoinRequestType', 'JoinRequestType');
    };
export class FlightSchoolStatusMetaData implements DwItem2<FlightSchoolStatusEntity, FlightSchoolStatusMetaDataAttributes,FlightSchoolStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=175;
        this.ItemDetail.itemName='FlightSchoolStatus';
        this.ItemDetail.keyName='FlightSchoolStatusId';
    }

    CreateEntity(): FlightSchoolStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): FlightSchoolStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<FlightSchoolStatusEntity, FlightSchoolStatusMetaDataAttributes,FlightSchoolStatusMetaDataRelations>(query, this);
    }
     Attributes = new FlightSchoolStatusMetaDataAttributes();
     Relations = new FlightSchoolStatusMetaDataRelations();

}


export type FlightSchoolStatusQueryBuilder = DwQueryBuilderGen<FlightSchoolStatusEntity, FlightSchoolStatusMetaDataAttributes,FlightSchoolStatusMetaDataRelations>


export class FlightSchoolStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'FlightSchoolStatus';
    // Attributes
    FlightSchoolStatusId = new DwItemAttribute(this.i, 'FlightSchoolStatusId');
    FlightSchoolStatus = new DwItemAttribute(this.i, 'FlightSchoolStatus');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class FlightSchoolStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School */
            FlightSchool = new DwItemRelationship('FlightSchoolStatus|FlightSchool|FlightSchoolStatusId', 'FlightSchool', 'FlightSchool');
    };
export class GamificationConfigurationMetaData implements DwItem2<GamificationConfigurationEntity, GamificationConfigurationMetaDataAttributes,GamificationConfigurationMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=494;
        this.ItemDetail.itemName='GamificationConfiguration';
        this.ItemDetail.keyName='GamificationConfigurationId';
    }

    CreateEntity(): GamificationConfigurationEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): GamificationConfigurationQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<GamificationConfigurationEntity, GamificationConfigurationMetaDataAttributes,GamificationConfigurationMetaDataRelations>(query, this);
    }
     Attributes = new GamificationConfigurationMetaDataAttributes();
     Relations = new GamificationConfigurationMetaDataRelations();

}


export type GamificationConfigurationQueryBuilder = DwQueryBuilderGen<GamificationConfigurationEntity, GamificationConfigurationMetaDataAttributes,GamificationConfigurationMetaDataRelations>


export class GamificationConfigurationMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'GamificationConfiguration';
    // Attributes
    GamificationConfigurationId = new DwItemAttribute(this.i, 'GamificationConfigurationId');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    WeatherDayGrantQuantity = new DwItemAttribute(this.i, 'WeatherDayGrantQuantity');
    WeatherDayGrantPeriodDays = new DwItemAttribute(this.i, 'WeatherDayGrantPeriodDays');
    WeatherDayMaximumBalance = new DwItemAttribute(this.i, 'WeatherDayMaximumBalance');
    WeatherDayAutoApply = new DwItemAttribute(this.i, 'WeatherDayAutoApply');
    WeekStartDay = new DwItemAttribute(this.i, 'WeekStartDay');
    ActiveLearningDailyCapSeconds = new DwItemAttribute(this.i, 'ActiveLearningDailyCapSeconds');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    DailyQuizAnswerReviewEnabled = new DwItemAttribute(this.i, 'DailyQuizAnswerReviewEnabled');
}

class GamificationConfigurationMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School */
            FlightSchool = new DwItemRelationship('FlightSchool|GamificationConfiguration|FlightSchoolId', 'FlightSchool', 'FlightSchool');
            /** Relation: Student Weather Day Transaction */
            StudentWeatherDayTransaction = new DwItemRelationship('GamificationConfiguration|StudentWeatherDayTransaction|GamificationConfigurationId', 'StudentWeatherDayTransaction', 'StudentWeatherDayTransaction');
    };
export class InstructorMetaData implements DwItem2<InstructorEntity, InstructorMetaDataAttributes,InstructorMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=211;
        this.ItemDetail.itemName='Instructor';
        this.ItemDetail.keyName='InstructorId';
    }

    CreateEntity(): InstructorEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): InstructorQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<InstructorEntity, InstructorMetaDataAttributes,InstructorMetaDataRelations>(query, this);
    }
     Attributes = new InstructorMetaDataAttributes();
     Relations = new InstructorMetaDataRelations();

}


export type InstructorQueryBuilder = DwQueryBuilderGen<InstructorEntity, InstructorMetaDataAttributes,InstructorMetaDataRelations>


export class InstructorMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Instructor';
    // Attributes
    InstructorId = new DwItemAttribute(this.i, 'InstructorId');
    UserId = new DwItemAttribute(this.i, 'UserId');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    InstructorStatusId = new DwItemAttribute(this.i, 'InstructorStatusId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class InstructorMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School */
            FlightSchool = new DwItemRelationship('FlightSchool|Instructor|FlightSchoolId', 'FlightSchool', 'FlightSchool');
            /** Relation: Instructor Status */
            InstructorStatus = new DwItemRelationship('InstructorStatus|Instructor|InstructorStatusId', 'InstructorStatus', 'InstructorStatus');
            /** Relation: User */
            DwUser = new DwItemRelationship('dw_User|Instructor|UserId', 'DwUser', 'DwUser');
            /** Relation: Assignment */
            Assignment = new DwItemRelationship('Instructor|Assignment|InstructorId', 'Assignment', 'Assignment');
            /** Relation: Flight School Instructor */
            FlightSchoolInstructor = new DwItemRelationship('Instructor|FlightSchoolInstructor|InstructorId', 'FlightSchoolInstructor', 'FlightSchoolInstructor');
            /** Relation: Instructor Student */
            InstructorStudent = new DwItemRelationship('Instructor|InstructorStudent|InstructorId', 'InstructorStudent', 'InstructorStudent');
            /** Relation: Ro Instructor Assignments Per Week */
            RoInstructorAssignmentsPerWeek = new DwItemRelationship('Instructor|RoInstructorAssignmentsPerWeek|InstructorId', 'RoInstructorAssignmentsPerWeek', 'RoInstructorAssignmentsPerWeek');
            /** Relation: Ro Student Course Instructor */
            RoStudentCourseInstructor = new DwItemRelationship('Instructor|RoStudentCourseInstructor|InstructorId', 'RoStudentCourseInstructor', 'RoStudentCourseInstructor');
            /** Relation: Student Course Lock Instructor */
            StudentCourseLockInstructor = new DwItemRelationship('Instructor|StudentCourseLockInstructor|InstructorId', 'StudentCourseLockInstructor', 'StudentCourseLockInstructor');
    };
export class InstructorStatusMetaData implements DwItem2<InstructorStatusEntity, InstructorStatusMetaDataAttributes,InstructorStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=218;
        this.ItemDetail.itemName='InstructorStatus';
        this.ItemDetail.keyName='InstructorStatusId';
    }

    CreateEntity(): InstructorStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): InstructorStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<InstructorStatusEntity, InstructorStatusMetaDataAttributes,InstructorStatusMetaDataRelations>(query, this);
    }
     Attributes = new InstructorStatusMetaDataAttributes();
     Relations = new InstructorStatusMetaDataRelations();

}


export type InstructorStatusQueryBuilder = DwQueryBuilderGen<InstructorStatusEntity, InstructorStatusMetaDataAttributes,InstructorStatusMetaDataRelations>


export class InstructorStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'InstructorStatus';
    // Attributes
    InstructorStatusId = new DwItemAttribute(this.i, 'InstructorStatusId');
    InstructorStatus = new DwItemAttribute(this.i, 'InstructorStatus');
}

class InstructorStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Instructor */
            Instructor = new DwItemRelationship('InstructorStatus|Instructor|InstructorStatusId', 'Instructor', 'Instructor');
    };
export class InstructorStudentMetaData implements DwItem2<InstructorStudentEntity, InstructorStudentMetaDataAttributes,InstructorStudentMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=213;
        this.ItemDetail.itemName='InstructorStudent';
        this.ItemDetail.keyName='InstructorStudentId';
    }

    CreateEntity(): InstructorStudentEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): InstructorStudentQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<InstructorStudentEntity, InstructorStudentMetaDataAttributes,InstructorStudentMetaDataRelations>(query, this);
    }
     Attributes = new InstructorStudentMetaDataAttributes();
     Relations = new InstructorStudentMetaDataRelations();

}


export type InstructorStudentQueryBuilder = DwQueryBuilderGen<InstructorStudentEntity, InstructorStudentMetaDataAttributes,InstructorStudentMetaDataRelations>


export class InstructorStudentMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'InstructorStudent';
    // Attributes
    InstructorStudentId = new DwItemAttribute(this.i, 'InstructorStudentId');
    InstructorId = new DwItemAttribute(this.i, 'InstructorId');
    StudentId = new DwItemAttribute(this.i, 'StudentId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class InstructorStudentMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Instructor */
            Instructor = new DwItemRelationship('Instructor|InstructorStudent|InstructorId', 'Instructor', 'Instructor');
            /** Relation: Student */
            Student = new DwItemRelationship('Student|InstructorStudent|StudentId', 'Student', 'Student');
            /** Relation: Ro School Course Enrollment Stats */
            RoSchoolCourseEnrollmentStatsByStudentId = new DwItemRelationship('InstructorStudent|RoSchoolCourseEnrollmentStats|StudentId', 'RoSchoolCourseEnrollmentStatsStudentId', 'RoSchoolCourseEnrollmentStatsStudentId');
    };
export class IntegrationCoursePurchaseMetaData implements DwItem2<IntegrationCoursePurchaseEntity, IntegrationCoursePurchaseMetaDataAttributes,IntegrationCoursePurchaseMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=289;
        this.ItemDetail.itemName='IntegrationCoursePurchase';
        this.ItemDetail.keyName='IntegrationCoursePurchaseId';
    }

    CreateEntity(): IntegrationCoursePurchaseEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): IntegrationCoursePurchaseQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<IntegrationCoursePurchaseEntity, IntegrationCoursePurchaseMetaDataAttributes,IntegrationCoursePurchaseMetaDataRelations>(query, this);
    }
     Attributes = new IntegrationCoursePurchaseMetaDataAttributes();
     Relations = new IntegrationCoursePurchaseMetaDataRelations();

}


export type IntegrationCoursePurchaseQueryBuilder = DwQueryBuilderGen<IntegrationCoursePurchaseEntity, IntegrationCoursePurchaseMetaDataAttributes,IntegrationCoursePurchaseMetaDataRelations>


export class IntegrationCoursePurchaseMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'IntegrationCoursePurchase';
    // Attributes
    IntegrationUserId = new DwItemAttribute(this.i, 'IntegrationUserId');
    IntegrationPurchaseReferenceKey = new DwItemAttribute(this.i, 'IntegrationPurchaseReferenceKey');
    CourseId = new DwItemAttribute(this.i, 'CourseId');
    StudentCourseId = new DwItemAttribute(this.i, 'StudentCourseId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    IntegrationCoursePurchaseRequestId = new DwItemAttribute(this.i, 'IntegrationCoursePurchaseRequestId');
    IntegrationCoursePurchaseId = new DwItemAttribute(this.i, 'IntegrationCoursePurchaseId');
}

class IntegrationCoursePurchaseMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Course */
            Course = new DwItemRelationship('Course|IntegrationCoursePurchase|CourseId', 'Course', 'Course');
            /** Relation: Integration Course Purchase Request */
            IntegrationCoursePurchaseRequest = new DwItemRelationship('IntegrationCoursePurchaseRequest|IntegrationCoursePurchase|IntegrationCoursePurchaseRequestId', 'IntegrationCoursePurchaseRequest', 'IntegrationCoursePurchaseRequest');
            /** Relation: Integration User */
            IntegrationUser = new DwItemRelationship('IntegrationUser|IntegrationCoursePurchase|IntegrationUserId', 'IntegrationUser', 'IntegrationUser');
            /** Relation: Student Course */
            StudentCourse = new DwItemRelationship('StudentCourse|IntegrationCoursePurchase|StudentCourseId', 'StudentCourse', 'StudentCourse');
    };
export class IntegrationCoursePurchaseRequestMetaData implements DwItem2<IntegrationCoursePurchaseRequestEntity, IntegrationCoursePurchaseRequestMetaDataAttributes,IntegrationCoursePurchaseRequestMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=365;
        this.ItemDetail.itemName='IntegrationCoursePurchaseRequest';
        this.ItemDetail.keyName='IntegrationCoursePurchaseRequestId';
    }

    CreateEntity(): IntegrationCoursePurchaseRequestEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): IntegrationCoursePurchaseRequestQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<IntegrationCoursePurchaseRequestEntity, IntegrationCoursePurchaseRequestMetaDataAttributes,IntegrationCoursePurchaseRequestMetaDataRelations>(query, this);
    }
     Attributes = new IntegrationCoursePurchaseRequestMetaDataAttributes();
     Relations = new IntegrationCoursePurchaseRequestMetaDataRelations();

}


export type IntegrationCoursePurchaseRequestQueryBuilder = DwQueryBuilderGen<IntegrationCoursePurchaseRequestEntity, IntegrationCoursePurchaseRequestMetaDataAttributes,IntegrationCoursePurchaseRequestMetaDataRelations>


export class IntegrationCoursePurchaseRequestMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'IntegrationCoursePurchaseRequest';
    // Attributes
    IntegrationCoursePurchaseRequestId = new DwItemAttribute(this.i, 'IntegrationCoursePurchaseRequestId');
    IntegrationOrganizationId = new DwItemAttribute(this.i, 'IntegrationOrganizationId');
    IntegrationCoursePurchaseRequestStatusId = new DwItemAttribute(this.i, 'IntegrationCoursePurchaseRequestStatusId');
    IntegrationUserId = new DwItemAttribute(this.i, 'IntegrationUserId');
    UserEmail = new DwItemAttribute(this.i, 'UserEmail');
    UserFullName = new DwItemAttribute(this.i, 'UserFullName');
    CourseId = new DwItemAttribute(this.i, 'CourseId');
    IntegrationPurchaseReferenceKey = new DwItemAttribute(this.i, 'IntegrationPurchaseReferenceKey');
    UserReferenceKey = new DwItemAttribute(this.i, 'UserReferenceKey');
    UserAlternateReferenceKey = new DwItemAttribute(this.i, 'UserAlternateReferenceKey');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class IntegrationCoursePurchaseRequestMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Course */
            Course = new DwItemRelationship('Course|IntegrationCoursePurchaseRequest|CourseId', 'Course', 'Course');
            /** Relation: Integration Course Purchase Request Status */
            IntegrationCoursePurchaseRequestStatus = new DwItemRelationship('IntegrationCoursePurchaseRequestStatus|IntegrationCoursePurchaseRequest|IntegrationCoursePurchaseRequestStatusId', 'IntegrationCoursePurchaseRequestStatus', 'IntegrationCoursePurchaseRequestStatus');
            /** Relation: Integration Organization */
            IntegrationOrganization = new DwItemRelationship('IntegrationOrganization|IntegrationCoursePurchaseRequest|IntegrationOrganizationId', 'IntegrationOrganization', 'IntegrationOrganization');
            /** Relation: Integration User */
            IntegrationUser = new DwItemRelationship('IntegrationUser|IntegrationCoursePurchaseRequest|IntegrationUserId', 'IntegrationUser', 'IntegrationUser');
            /** Relation: Integration Course Purchase */
            IntegrationCoursePurchase = new DwItemRelationship('IntegrationCoursePurchaseRequest|IntegrationCoursePurchase|IntegrationCoursePurchaseRequestId', 'IntegrationCoursePurchase', 'IntegrationCoursePurchase');
    };
export class IntegrationCoursePurchaseRequestStatusMetaData implements DwItem2<IntegrationCoursePurchaseRequestStatusEntity, IntegrationCoursePurchaseRequestStatusMetaDataAttributes,IntegrationCoursePurchaseRequestStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=366;
        this.ItemDetail.itemName='IntegrationCoursePurchaseRequestStatus';
        this.ItemDetail.keyName='IntegrationCoursePurchaseRequestStatusId';
    }

    CreateEntity(): IntegrationCoursePurchaseRequestStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): IntegrationCoursePurchaseRequestStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<IntegrationCoursePurchaseRequestStatusEntity, IntegrationCoursePurchaseRequestStatusMetaDataAttributes,IntegrationCoursePurchaseRequestStatusMetaDataRelations>(query, this);
    }
     Attributes = new IntegrationCoursePurchaseRequestStatusMetaDataAttributes();
     Relations = new IntegrationCoursePurchaseRequestStatusMetaDataRelations();

}


export type IntegrationCoursePurchaseRequestStatusQueryBuilder = DwQueryBuilderGen<IntegrationCoursePurchaseRequestStatusEntity, IntegrationCoursePurchaseRequestStatusMetaDataAttributes,IntegrationCoursePurchaseRequestStatusMetaDataRelations>


export class IntegrationCoursePurchaseRequestStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'IntegrationCoursePurchaseRequestStatus';
    // Attributes
    IntegrationCoursePurchaseRequestStatusId = new DwItemAttribute(this.i, 'IntegrationCoursePurchaseRequestStatusId');
    IntegrationCoursePurchaseRequestStatus = new DwItemAttribute(this.i, 'IntegrationCoursePurchaseRequestStatus');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class IntegrationCoursePurchaseRequestStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Integration Course Purchase Request */
            IntegrationCoursePurchaseRequest = new DwItemRelationship('IntegrationCoursePurchaseRequestStatus|IntegrationCoursePurchaseRequest|IntegrationCoursePurchaseRequestStatusId', 'IntegrationCoursePurchaseRequest', 'IntegrationCoursePurchaseRequest');
    };
export class IntegrationEventTypeMetaData implements DwItem2<IntegrationEventTypeEntity, IntegrationEventTypeMetaDataAttributes,IntegrationEventTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=310;
        this.ItemDetail.itemName='IntegrationEventType';
        this.ItemDetail.keyName='IntegrationEventTypeId';
    }

    CreateEntity(): IntegrationEventTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): IntegrationEventTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<IntegrationEventTypeEntity, IntegrationEventTypeMetaDataAttributes,IntegrationEventTypeMetaDataRelations>(query, this);
    }
     Attributes = new IntegrationEventTypeMetaDataAttributes();
     Relations = new IntegrationEventTypeMetaDataRelations();

}


export type IntegrationEventTypeQueryBuilder = DwQueryBuilderGen<IntegrationEventTypeEntity, IntegrationEventTypeMetaDataAttributes,IntegrationEventTypeMetaDataRelations>


export class IntegrationEventTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'IntegrationEventType';
    // Attributes
    IntegrationEventTypeId = new DwItemAttribute(this.i, 'IntegrationEventTypeId');
    IntegrationEventType = new DwItemAttribute(this.i, 'IntegrationEventType');
    IntegrationCode = new DwItemAttribute(this.i, 'IntegrationCode');
}

class IntegrationEventTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Integration User Event */
            IntegrationUserEvent = new DwItemRelationship('IntegrationEventType|IntegrationUserEvent|IntegrationEventTypeId', 'IntegrationUserEvent', 'IntegrationUserEvent');
    };
export class IntegrationOrganizationMetaData implements DwItem2<IntegrationOrganizationEntity, IntegrationOrganizationMetaDataAttributes,IntegrationOrganizationMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=277;
        this.ItemDetail.itemName='IntegrationOrganization';
        this.ItemDetail.keyName='IntegrationOrganizationId';
    }

    CreateEntity(): IntegrationOrganizationEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): IntegrationOrganizationQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<IntegrationOrganizationEntity, IntegrationOrganizationMetaDataAttributes,IntegrationOrganizationMetaDataRelations>(query, this);
    }
     Attributes = new IntegrationOrganizationMetaDataAttributes();
     Relations = new IntegrationOrganizationMetaDataRelations();

}


export type IntegrationOrganizationQueryBuilder = DwQueryBuilderGen<IntegrationOrganizationEntity, IntegrationOrganizationMetaDataAttributes,IntegrationOrganizationMetaDataRelations>


export class IntegrationOrganizationMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'IntegrationOrganization';
    // Attributes
    IntegrationOrganizationId = new DwItemAttribute(this.i, 'IntegrationOrganizationId');
    IntegrationSystemId = new DwItemAttribute(this.i, 'IntegrationSystemId');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    IntegrationOrganizationStatusId = new DwItemAttribute(this.i, 'IntegrationOrganizationStatusId');
    OrganizationReferenceKey = new DwItemAttribute(this.i, 'OrganizationReferenceKey');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class IntegrationOrganizationMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School */
            FlightSchool = new DwItemRelationship('FlightSchool|IntegrationOrganization|FlightSchoolId', 'FlightSchool', 'FlightSchool');
            /** Relation: Integration Organization Status */
            IntegrationOrganizationStatus = new DwItemRelationship('IntegrationOrganizationStatus|IntegrationOrganization|IntegrationOrganizationStatusId', 'IntegrationOrganizationStatus', 'IntegrationOrganizationStatus');
            /** Relation: Integration System */
            IntegrationSystem = new DwItemRelationship('IntegrationSystem|IntegrationOrganization|IntegrationSystemId', 'IntegrationSystem', 'IntegrationSystem');
            /** Relation: Integration Course Purchase Request */
            IntegrationCoursePurchaseRequest = new DwItemRelationship('IntegrationOrganization|IntegrationCoursePurchaseRequest|IntegrationOrganizationId', 'IntegrationCoursePurchaseRequest', 'IntegrationCoursePurchaseRequest');
            /** Relation: Integration User */
            IntegrationUser = new DwItemRelationship('IntegrationOrganization|IntegrationUser|IntegrationOrganizationId', 'IntegrationUser', 'IntegrationUser');
    };
export class IntegrationOrganizationStatusMetaData implements DwItem2<IntegrationOrganizationStatusEntity, IntegrationOrganizationStatusMetaDataAttributes,IntegrationOrganizationStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=275;
        this.ItemDetail.itemName='IntegrationOrganizationStatus';
        this.ItemDetail.keyName='IntegrationOrganizationStatusId';
    }

    CreateEntity(): IntegrationOrganizationStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): IntegrationOrganizationStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<IntegrationOrganizationStatusEntity, IntegrationOrganizationStatusMetaDataAttributes,IntegrationOrganizationStatusMetaDataRelations>(query, this);
    }
     Attributes = new IntegrationOrganizationStatusMetaDataAttributes();
     Relations = new IntegrationOrganizationStatusMetaDataRelations();

}


export type IntegrationOrganizationStatusQueryBuilder = DwQueryBuilderGen<IntegrationOrganizationStatusEntity, IntegrationOrganizationStatusMetaDataAttributes,IntegrationOrganizationStatusMetaDataRelations>


export class IntegrationOrganizationStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'IntegrationOrganizationStatus';
    // Attributes
    IntegrationOrganizationStatusId = new DwItemAttribute(this.i, 'IntegrationOrganizationStatusId');
    IntegrationOrganizationStatus = new DwItemAttribute(this.i, 'IntegrationOrganizationStatus');
}

class IntegrationOrganizationStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Integration Organization */
            IntegrationOrganization = new DwItemRelationship('IntegrationOrganizationStatus|IntegrationOrganization|IntegrationOrganizationStatusId', 'IntegrationOrganization', 'IntegrationOrganization');
    };
export class IntegrationSystemMetaData implements DwItem2<IntegrationSystemEntity, IntegrationSystemMetaDataAttributes,IntegrationSystemMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=274;
        this.ItemDetail.itemName='IntegrationSystem';
        this.ItemDetail.keyName='IntegrationSystemId';
    }

    CreateEntity(): IntegrationSystemEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): IntegrationSystemQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<IntegrationSystemEntity, IntegrationSystemMetaDataAttributes,IntegrationSystemMetaDataRelations>(query, this);
    }
     Attributes = new IntegrationSystemMetaDataAttributes();
     Relations = new IntegrationSystemMetaDataRelations();

}


export type IntegrationSystemQueryBuilder = DwQueryBuilderGen<IntegrationSystemEntity, IntegrationSystemMetaDataAttributes,IntegrationSystemMetaDataRelations>


export class IntegrationSystemMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'IntegrationSystem';
    // Attributes
    IntegrationSystemId = new DwItemAttribute(this.i, 'IntegrationSystemId');
    SystemName = new DwItemAttribute(this.i, 'SystemName');
    SystemUrl = new DwItemAttribute(this.i, 'SystemUrl');
    DomainName = new DwItemAttribute(this.i, 'DomainName');
    TrackEvents = new DwItemAttribute(this.i, 'TrackEvents');
    ApiRootUrl = new DwItemAttribute(this.i, 'ApiRootUrl');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class IntegrationSystemMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Integration Organization */
            IntegrationOrganization = new DwItemRelationship('IntegrationSystem|IntegrationOrganization|IntegrationSystemId', 'IntegrationOrganization', 'IntegrationOrganization');
            /** Relation: Integration System Course */
            IntegrationSystemCourse = new DwItemRelationship('IntegrationSystem|IntegrationSystemCourse|IntegrationSystemId', 'IntegrationSystemCourse', 'IntegrationSystemCourse');
    };
export class IntegrationSystemCourseMetaData implements DwItem2<IntegrationSystemCourseEntity, IntegrationSystemCourseMetaDataAttributes,IntegrationSystemCourseMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=312;
        this.ItemDetail.itemName='IntegrationSystemCourse';
        this.ItemDetail.keyName='IntegrationSystemCourseId';
    }

    CreateEntity(): IntegrationSystemCourseEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): IntegrationSystemCourseQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<IntegrationSystemCourseEntity, IntegrationSystemCourseMetaDataAttributes,IntegrationSystemCourseMetaDataRelations>(query, this);
    }
     Attributes = new IntegrationSystemCourseMetaDataAttributes();
     Relations = new IntegrationSystemCourseMetaDataRelations();

}


export type IntegrationSystemCourseQueryBuilder = DwQueryBuilderGen<IntegrationSystemCourseEntity, IntegrationSystemCourseMetaDataAttributes,IntegrationSystemCourseMetaDataRelations>


export class IntegrationSystemCourseMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'IntegrationSystemCourse';
    // Attributes
    IntegrationSystemCourseId = new DwItemAttribute(this.i, 'IntegrationSystemCourseId');
    IntegrationSystemId = new DwItemAttribute(this.i, 'IntegrationSystemId');
    CourseId = new DwItemAttribute(this.i, 'CourseId');
}

class IntegrationSystemCourseMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Course */
            Course = new DwItemRelationship('Course|IntegrationSystemCourse|CourseId', 'Course', 'Course');
            /** Relation: Integration System */
            IntegrationSystem = new DwItemRelationship('IntegrationSystem|IntegrationSystemCourse|IntegrationSystemId', 'IntegrationSystem', 'IntegrationSystem');
    };
export class IntegrationUserMetaData implements DwItem2<IntegrationUserEntity, IntegrationUserMetaDataAttributes,IntegrationUserMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=276;
        this.ItemDetail.itemName='IntegrationUser';
        this.ItemDetail.keyName='IntegrationUserId';
    }

    CreateEntity(): IntegrationUserEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): IntegrationUserQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<IntegrationUserEntity, IntegrationUserMetaDataAttributes,IntegrationUserMetaDataRelations>(query, this);
    }
     Attributes = new IntegrationUserMetaDataAttributes();
     Relations = new IntegrationUserMetaDataRelations();

}


export type IntegrationUserQueryBuilder = DwQueryBuilderGen<IntegrationUserEntity, IntegrationUserMetaDataAttributes,IntegrationUserMetaDataRelations>


export class IntegrationUserMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'IntegrationUser';
    // Attributes
    IntegrationUserId = new DwItemAttribute(this.i, 'IntegrationUserId');
    IntegrationOrganizationId = new DwItemAttribute(this.i, 'IntegrationOrganizationId');
    IntegrationUserStatusId = new DwItemAttribute(this.i, 'IntegrationUserStatusId');
    UserId = new DwItemAttribute(this.i, 'UserId');
    AuthenticationTokenKey = new DwItemAttribute(this.i, 'AuthenticationTokenKey');
    UserReferenceKey = new DwItemAttribute(this.i, 'UserReferenceKey');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    UserAlternateReferenceKey = new DwItemAttribute(this.i, 'UserAlternateReferenceKey');
}

class IntegrationUserMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Integration Organization */
            IntegrationOrganization = new DwItemRelationship('IntegrationOrganization|IntegrationUser|IntegrationOrganizationId', 'IntegrationOrganization', 'IntegrationOrganization');
            /** Relation: Integration User Status */
            IntegrationUserStatus = new DwItemRelationship('IntegrationUserStatus|IntegrationUser|IntegrationUserStatusId', 'IntegrationUserStatus', 'IntegrationUserStatus');
            /** Relation: User */
            DwUser = new DwItemRelationship('dw_User|IntegrationUser|UserId', 'DwUser', 'DwUser');
            /** Relation: Integration Course Purchase */
            IntegrationCoursePurchase = new DwItemRelationship('IntegrationUser|IntegrationCoursePurchase|IntegrationUserId', 'IntegrationCoursePurchase', 'IntegrationCoursePurchase');
            /** Relation: Integration Course Purchase Request */
            IntegrationCoursePurchaseRequest = new DwItemRelationship('IntegrationUser|IntegrationCoursePurchaseRequest|IntegrationUserId', 'IntegrationCoursePurchaseRequest', 'IntegrationCoursePurchaseRequest');
            /** Relation: Integration User Event */
            IntegrationUserEvent = new DwItemRelationship('IntegrationUser|IntegrationUserEvent|IntegrationUserId', 'IntegrationUserEvent', 'IntegrationUserEvent');
    };
export class IntegrationUserEventMetaData implements DwItem2<IntegrationUserEventEntity, IntegrationUserEventMetaDataAttributes,IntegrationUserEventMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=309;
        this.ItemDetail.itemName='IntegrationUserEvent';
        this.ItemDetail.keyName='IntegrationUserEventId';
    }

    CreateEntity(): IntegrationUserEventEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): IntegrationUserEventQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<IntegrationUserEventEntity, IntegrationUserEventMetaDataAttributes,IntegrationUserEventMetaDataRelations>(query, this);
    }
     Attributes = new IntegrationUserEventMetaDataAttributes();
     Relations = new IntegrationUserEventMetaDataRelations();

}


export type IntegrationUserEventQueryBuilder = DwQueryBuilderGen<IntegrationUserEventEntity, IntegrationUserEventMetaDataAttributes,IntegrationUserEventMetaDataRelations>


export class IntegrationUserEventMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'IntegrationUserEvent';
    // Attributes
    IntegrationUserEventId = new DwItemAttribute(this.i, 'IntegrationUserEventId');
    IntegrationUserId = new DwItemAttribute(this.i, 'IntegrationUserId');
    CourseId = new DwItemAttribute(this.i, 'CourseId');
    IntegrationEventTypeId = new DwItemAttribute(this.i, 'IntegrationEventTypeId');
    EventSentAttemptCount = new DwItemAttribute(this.i, 'EventSentAttemptCount');
    LastLogId = new DwItemAttribute(this.i, 'LastLogId');
    IntegrationUserEventStatusId = new DwItemAttribute(this.i, 'IntegrationUserEventStatusId');
    LastEventSendDateTime = new DwItemAttribute(this.i, 'LastEventSendDateTime');
    EventTimestamp = new DwItemAttribute(this.i, 'EventTimestamp');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    CousreLessonId = new DwItemAttribute(this.i, 'CousreLessonId');
}

class IntegrationUserEventMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Course */
            Course = new DwItemRelationship('Course|IntegrationUserEvent|CourseId', 'Course', 'Course');
            /** Relation: Lesson - Cousre Lesson */
            CourseLessonByCousreLessonId = new DwItemRelationship('CourseLesson|IntegrationUserEvent|CousreLessonId', 'CousreLessonIdCourseLesson', 'CousreLessonIdCourseLesson');
            /** Relation: Integration Event Type */
            IntegrationEventType = new DwItemRelationship('IntegrationEventType|IntegrationUserEvent|IntegrationEventTypeId', 'IntegrationEventType', 'IntegrationEventType');
            /** Relation: Integration User */
            IntegrationUser = new DwItemRelationship('IntegrationUser|IntegrationUserEvent|IntegrationUserId', 'IntegrationUser', 'IntegrationUser');
            /** Relation: Integration User Event Status */
            IntegrationUserEventStatus = new DwItemRelationship('IntegrationUserEventStatus|IntegrationUserEvent|IntegrationUserEventStatusId', 'IntegrationUserEventStatus', 'IntegrationUserEventStatus');
    };
export class IntegrationUserEventStatusMetaData implements DwItem2<IntegrationUserEventStatusEntity, IntegrationUserEventStatusMetaDataAttributes,IntegrationUserEventStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=311;
        this.ItemDetail.itemName='IntegrationUserEventStatus';
        this.ItemDetail.keyName='IntegrationUserEventStatusId';
    }

    CreateEntity(): IntegrationUserEventStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): IntegrationUserEventStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<IntegrationUserEventStatusEntity, IntegrationUserEventStatusMetaDataAttributes,IntegrationUserEventStatusMetaDataRelations>(query, this);
    }
     Attributes = new IntegrationUserEventStatusMetaDataAttributes();
     Relations = new IntegrationUserEventStatusMetaDataRelations();

}


export type IntegrationUserEventStatusQueryBuilder = DwQueryBuilderGen<IntegrationUserEventStatusEntity, IntegrationUserEventStatusMetaDataAttributes,IntegrationUserEventStatusMetaDataRelations>


export class IntegrationUserEventStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'IntegrationUserEventStatus';
    // Attributes
    IntegrationUserEventStatusId = new DwItemAttribute(this.i, 'IntegrationUserEventStatusId');
    IntegrationUserEventStatus = new DwItemAttribute(this.i, 'IntegrationUserEventStatus');
}

class IntegrationUserEventStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Integration User Event */
            IntegrationUserEvent = new DwItemRelationship('IntegrationUserEventStatus|IntegrationUserEvent|IntegrationUserEventStatusId', 'IntegrationUserEvent', 'IntegrationUserEvent');
    };
export class IntegrationUserStatusMetaData implements DwItem2<IntegrationUserStatusEntity, IntegrationUserStatusMetaDataAttributes,IntegrationUserStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=278;
        this.ItemDetail.itemName='IntegrationUserStatus';
        this.ItemDetail.keyName='IntegrationUserStatusId';
    }

    CreateEntity(): IntegrationUserStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): IntegrationUserStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<IntegrationUserStatusEntity, IntegrationUserStatusMetaDataAttributes,IntegrationUserStatusMetaDataRelations>(query, this);
    }
     Attributes = new IntegrationUserStatusMetaDataAttributes();
     Relations = new IntegrationUserStatusMetaDataRelations();

}


export type IntegrationUserStatusQueryBuilder = DwQueryBuilderGen<IntegrationUserStatusEntity, IntegrationUserStatusMetaDataAttributes,IntegrationUserStatusMetaDataRelations>


export class IntegrationUserStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'IntegrationUserStatus';
    // Attributes
    IntegrationUserStatusId = new DwItemAttribute(this.i, 'IntegrationUserStatusId');
    IntegrationUserStatus = new DwItemAttribute(this.i, 'IntegrationUserStatus');
}

class IntegrationUserStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Integration User */
            IntegrationUser = new DwItemRelationship('IntegrationUserStatus|IntegrationUser|IntegrationUserStatusId', 'IntegrationUser', 'IntegrationUser');
    };
export class InvoiceMetaData implements DwItem2<InvoiceEntity, InvoiceMetaDataAttributes,InvoiceMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=255;
        this.ItemDetail.itemName='Invoice';
        this.ItemDetail.keyName='InvoiceId';
    }

    CreateEntity(): InvoiceEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): InvoiceQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<InvoiceEntity, InvoiceMetaDataAttributes,InvoiceMetaDataRelations>(query, this);
    }
     Attributes = new InvoiceMetaDataAttributes();
     Relations = new InvoiceMetaDataRelations();

}


export type InvoiceQueryBuilder = DwQueryBuilderGen<InvoiceEntity, InvoiceMetaDataAttributes,InvoiceMetaDataRelations>


export class InvoiceMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Invoice';
    // Attributes
    InvoiceId = new DwItemAttribute(this.i, 'InvoiceId');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    ProcessorInvoiceId = new DwItemAttribute(this.i, 'ProcessorInvoiceId');
    InvoiceDate = new DwItemAttribute(this.i, 'InvoiceDate');
    InvoiceAmount = new DwItemAttribute(this.i, 'InvoiceAmount');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    InvoicePdfUrl = new DwItemAttribute(this.i, 'InvoicePdfUrl');
    InvoiceControlNumber = new DwItemAttribute(this.i, 'InvoiceControlNumber');
    InvoiceHostedUrl = new DwItemAttribute(this.i, 'InvoiceHostedUrl');
    InvoiceNumber = new DwItemAttribute(this.i, 'InvoiceNumber');
    UserId = new DwItemAttribute(this.i, 'UserId');
    InvoiceTypeId = new DwItemAttribute(this.i, 'InvoiceTypeId');
    InvoiceStatusId = new DwItemAttribute(this.i, 'InvoiceStatusId');
    FailureLogId = new DwItemAttribute(this.i, 'FailureLogId');
    TaxAmount = new DwItemAttribute(this.i, 'TaxAmount');
    PaidAmount = new DwItemAttribute(this.i, 'PaidAmount');
    LastInvoiceErrorLogId = new DwItemAttribute(this.i, 'LastInvoiceErrorLogId');
    InvoiceFinalAmount = new DwItemAttribute(this.i, 'InvoiceFinalAmount');
    PaymentPartyTypeId = new DwItemAttribute(this.i, 'PaymentPartyTypeId');
    PaymentMethodId = new DwItemAttribute(this.i, 'PaymentMethodId');
    InvoicePeriodStart = new DwItemAttribute(this.i, 'InvoicePeriodStart');
    InvoicePeriodEnd = new DwItemAttribute(this.i, 'InvoicePeriodEnd');
    StripeCheckoutSessionId = new DwItemAttribute(this.i, 'StripeCheckoutSessionId');
    StripeInvoiceRef = new DwItemAttribute(this.i, 'StripeInvoiceRef');
    InvoiceDueDate = new DwItemAttribute(this.i, 'InvoiceDueDate');
    InvoicePaymentTermsDays = new DwItemAttribute(this.i, 'InvoicePaymentTermsDays');
    InvoiceBillingEmail = new DwItemAttribute(this.i, 'InvoiceBillingEmail');
    InvoiceBillingTimeZone = new DwItemAttribute(this.i, 'InvoiceBillingTimeZone');
    InvoiceFinalizedDateTime = new DwItemAttribute(this.i, 'InvoiceFinalizedDateTime');
}

class InvoiceMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School */
            FlightSchool = new DwItemRelationship('FlightSchool|Invoice|FlightSchoolId', 'FlightSchool', 'FlightSchool');
            /** Relation: Invoice Error Log - Last Invoice Error Log */
            InvoiceErrorLogByLastInvoiceErrorLogId = new DwItemRelationship('InvoiceErrorLog|Invoice|LastInvoiceErrorLogId', 'LastInvoiceErrorLog', 'LastInvoiceErrorLog');
            /** Relation: Invoice Status */
            InvoiceStatus = new DwItemRelationship('InvoiceStatus|Invoice|InvoiceStatusId', 'InvoiceStatus', 'InvoiceStatus');
            /** Relation: Invoice Type */
            InvoiceType = new DwItemRelationship('InvoiceType|Invoice|InvoiceTypeId', 'InvoiceType', 'InvoiceType');
            /** Relation: Payment Method */
            PaymentMethod = new DwItemRelationship('PaymentMethod|Invoice|PaymentMethodId', 'PaymentMethod', 'PaymentMethod');
            /** Relation: Payment Party Type */
            PaymentPartyType = new DwItemRelationship('PaymentPartyType|Invoice|PaymentPartyTypeId', 'PaymentPartyType', 'PaymentPartyType');
            /** Relation: Stripe Checkout Session */
            StripeCheckoutSession = new DwItemRelationship('StripeCheckoutSession|Invoice|StripeCheckoutSessionId', 'StripeCheckoutSession', 'StripeCheckoutSession');
            /** Relation: User */
            DwUser = new DwItemRelationship('dw_User|Invoice|UserId', 'DwUser', 'DwUser');
            /** Relation: Course Purchase */
            CoursePurchase = new DwItemRelationship('Invoice|CoursePurchase|InvoiceId', 'CoursePurchase', 'CoursePurchase');
            /** Relation: Course Purchase Reservation */
            CoursePurchaseReservation = new DwItemRelationship('Invoice|CoursePurchaseReservation|InvoiceId', 'CoursePurchaseReservation', 'CoursePurchaseReservation');
            /** Relation: Invoice Error Log */
            InvoiceErrorLog = new DwItemRelationship('Invoice|InvoiceErrorLog|InvoiceId', 'InvoiceErrorLog', 'InvoiceErrorLog');
            /** Relation: Invoice Line */
            InvoiceLine = new DwItemRelationship('Invoice|InvoiceLine|InvoiceId', 'InvoiceLine', 'InvoiceLine');
            /** Relation: Invoice Refund */
            InvoiceRefund = new DwItemRelationship('Invoice|InvoiceRefund|InvoiceId', 'InvoiceRefund', 'InvoiceRefund');
            /** Relation: Join Request Course Purchase */
            JoinRequestCoursePurchase = new DwItemRelationship('Invoice|JoinRequestCoursePurchase|InvoiceId', 'JoinRequestCoursePurchase', 'JoinRequestCoursePurchase');
            /** Relation: Ro School Invoices */
            RoSchoolInvoices = new DwItemRelationship('Invoices|roSchoolInvoices|InvoiceId', 'RoSchoolInvoices', 'RoSchoolInvoices');
    };
export class InvoiceErrorCodeMetaData implements DwItem2<InvoiceErrorCodeEntity, InvoiceErrorCodeMetaDataAttributes,InvoiceErrorCodeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=299;
        this.ItemDetail.itemName='InvoiceErrorCode';
        this.ItemDetail.keyName='InvoiceErrorCodeId';
    }

    CreateEntity(): InvoiceErrorCodeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): InvoiceErrorCodeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<InvoiceErrorCodeEntity, InvoiceErrorCodeMetaDataAttributes,InvoiceErrorCodeMetaDataRelations>(query, this);
    }
     Attributes = new InvoiceErrorCodeMetaDataAttributes();
     Relations = new InvoiceErrorCodeMetaDataRelations();

}


export type InvoiceErrorCodeQueryBuilder = DwQueryBuilderGen<InvoiceErrorCodeEntity, InvoiceErrorCodeMetaDataAttributes,InvoiceErrorCodeMetaDataRelations>


export class InvoiceErrorCodeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'InvoiceErrorCode';
    // Attributes
    InvoiceErrorCodeId = new DwItemAttribute(this.i, 'InvoiceErrorCodeId');
    InvoiceErrorCode = new DwItemAttribute(this.i, 'InvoiceErrorCode');
    InvoiceErrorDescription = new DwItemAttribute(this.i, 'InvoiceErrorDescription');
    IsStripeError = new DwItemAttribute(this.i, 'IsStripeError');
    StripeErrorCode = new DwItemAttribute(this.i, 'StripeErrorCode');
    EndUserErrorDescription = new DwItemAttribute(this.i, 'EndUserErrorDescription');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class InvoiceErrorCodeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Invoice Error Log */
            InvoiceErrorLog = new DwItemRelationship('InvoiceErrorCode|InvoiceErrorLog|InvoiceErrorCodeId', 'InvoiceErrorLog', 'InvoiceErrorLog');
    };
export class InvoiceErrorLogMetaData implements DwItem2<InvoiceErrorLogEntity, InvoiceErrorLogMetaDataAttributes,InvoiceErrorLogMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=300;
        this.ItemDetail.itemName='InvoiceErrorLog';
        this.ItemDetail.keyName='InvoiceErrorLogId';
    }

    CreateEntity(): InvoiceErrorLogEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): InvoiceErrorLogQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<InvoiceErrorLogEntity, InvoiceErrorLogMetaDataAttributes,InvoiceErrorLogMetaDataRelations>(query, this);
    }
     Attributes = new InvoiceErrorLogMetaDataAttributes();
     Relations = new InvoiceErrorLogMetaDataRelations();

}


export type InvoiceErrorLogQueryBuilder = DwQueryBuilderGen<InvoiceErrorLogEntity, InvoiceErrorLogMetaDataAttributes,InvoiceErrorLogMetaDataRelations>


export class InvoiceErrorLogMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'InvoiceErrorLog';
    // Attributes
    InvoiceErrorLogId = new DwItemAttribute(this.i, 'InvoiceErrorLogId');
    InvoiceId = new DwItemAttribute(this.i, 'InvoiceId');
    LogId = new DwItemAttribute(this.i, 'LogId');
    InvoiceErrorCodeId = new DwItemAttribute(this.i, 'InvoiceErrorCodeId');
    StripeDetailedError = new DwItemAttribute(this.i, 'StripeDetailedError');
    StripErrorCode = new DwItemAttribute(this.i, 'StripErrorCode');
    StripeErrorType = new DwItemAttribute(this.i, 'StripeErrorType');
    StripErrorDeclinedCode = new DwItemAttribute(this.i, 'StripErrorDeclinedCode');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class InvoiceErrorLogMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Invoice */
            Invoice = new DwItemRelationship('Invoice|InvoiceErrorLog|InvoiceId', 'Invoice', 'Invoice');
            /** Relation: Invoice Error Code */
            InvoiceErrorCode = new DwItemRelationship('InvoiceErrorCode|InvoiceErrorLog|InvoiceErrorCodeId', 'InvoiceErrorCode', 'InvoiceErrorCode');
            /** Relation: Invoice - Last - Many */
            InvoiceByLastInvoiceErrorLogId = new DwItemRelationship('InvoiceErrorLog|Invoice|LastInvoiceErrorLogId', 'LastInvoice', 'LastInvoice');
    };
export class InvoiceLineMetaData implements DwItem2<InvoiceLineEntity, InvoiceLineMetaDataAttributes,InvoiceLineMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=256;
        this.ItemDetail.itemName='InvoiceLine';
        this.ItemDetail.keyName='InvoiceLineId';
    }

    CreateEntity(): InvoiceLineEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): InvoiceLineQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<InvoiceLineEntity, InvoiceLineMetaDataAttributes,InvoiceLineMetaDataRelations>(query, this);
    }
     Attributes = new InvoiceLineMetaDataAttributes();
     Relations = new InvoiceLineMetaDataRelations();

}


export type InvoiceLineQueryBuilder = DwQueryBuilderGen<InvoiceLineEntity, InvoiceLineMetaDataAttributes,InvoiceLineMetaDataRelations>


export class InvoiceLineMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'InvoiceLine';
    // Attributes
    InvoiceLineId = new DwItemAttribute(this.i, 'InvoiceLineId');
    InvoiceId = new DwItemAttribute(this.i, 'InvoiceId');
    Description = new DwItemAttribute(this.i, 'Description');
    Quantity = new DwItemAttribute(this.i, 'Quantity');
    ItemCost = new DwItemAttribute(this.i, 'ItemCost');
    TotalCost = new DwItemAttribute(this.i, 'TotalCost');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    SubscriptionId = new DwItemAttribute(this.i, 'SubscriptionId');
    DiscountId = new DwItemAttribute(this.i, 'DiscountId');
    ProductId = new DwItemAttribute(this.i, 'ProductId');
}

class InvoiceLineMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Discount */
            Discount = new DwItemRelationship('Discount|InvoiceLine|DiscountId', 'Discount', 'Discount');
            /** Relation: Invoice */
            Invoice = new DwItemRelationship('Invoice|InvoiceLine|InvoiceId', 'Invoice', 'Invoice');
            /** Relation: Product */
            Product = new DwItemRelationship('Product|InvoiceLine|ProductId', 'Product', 'Product');
            /** Relation: Subscription */
            Subscription = new DwItemRelationship('Subscription|InvoiceLine|SubscriptionId', 'Subscription', 'Subscription');
            /** Relation: Course Purchase Reservation Course */
            CoursePurchaseReservationCourse = new DwItemRelationship('InvoiceLine|CoursePurchaseReservationCourse|InvoiceLineId', 'CoursePurchaseReservationCourse', 'CoursePurchaseReservationCourse');
            /** Relation: Discount Usage Flight School */
            DiscountUsageFlightSchool = new DwItemRelationship('InvoiceLine|DiscountUsageFlightSchool|InvoiceLineId', 'DiscountUsageFlightSchool', 'DiscountUsageFlightSchool');
            /** Relation: Join Request Course Purchase */
            JoinRequestCoursePurchase = new DwItemRelationship('InvoiceLine|JoinRequestCoursePurchase|InvoiceLineId', 'JoinRequestCoursePurchase', 'JoinRequestCoursePurchase');
            /** Relation: Profit Share */
            ProfitShare = new DwItemRelationship('InvoiceLine|ProfitShare|InvoiceLineId', 'ProfitShare', 'ProfitShare');
    };
export class InvoiceLogMetaData implements DwItem2<InvoiceLogEntity, InvoiceLogMetaDataAttributes,InvoiceLogMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=257;
        this.ItemDetail.itemName='InvoiceLog';
        this.ItemDetail.keyName='InvoiceLogId';
    }

    CreateEntity(): InvoiceLogEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): InvoiceLogQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<InvoiceLogEntity, InvoiceLogMetaDataAttributes,InvoiceLogMetaDataRelations>(query, this);
    }
     Attributes = new InvoiceLogMetaDataAttributes();
     Relations = new InvoiceLogMetaDataRelations();

}


export type InvoiceLogQueryBuilder = DwQueryBuilderGen<InvoiceLogEntity, InvoiceLogMetaDataAttributes,InvoiceLogMetaDataRelations>


export class InvoiceLogMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'InvoiceLog';
    // Attributes
    InvoiceLogId = new DwItemAttribute(this.i, 'InvoiceLogId');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    InvoiceControlNumber = new DwItemAttribute(this.i, 'InvoiceControlNumber');
    Successful = new DwItemAttribute(this.i, 'Successful');
    Result = new DwItemAttribute(this.i, 'Result');
    ProcessorLogId = new DwItemAttribute(this.i, 'ProcessorLogId');
    LoggingServiceId = new DwItemAttribute(this.i, 'LoggingServiceId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class InvoiceLogMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Processor Log */
            ProcessorLog = new DwItemRelationship('ProcessorLog|InvoiceLog|ProcessorLogId', 'ProcessorLog', 'ProcessorLog');
    };
export class InvoiceRefundMetaData implements DwItem2<InvoiceRefundEntity, InvoiceRefundMetaDataAttributes,InvoiceRefundMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=381;
        this.ItemDetail.itemName='InvoiceRefund';
        this.ItemDetail.keyName='InvoiceRefundId';
    }

    CreateEntity(): InvoiceRefundEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): InvoiceRefundQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<InvoiceRefundEntity, InvoiceRefundMetaDataAttributes,InvoiceRefundMetaDataRelations>(query, this);
    }
     Attributes = new InvoiceRefundMetaDataAttributes();
     Relations = new InvoiceRefundMetaDataRelations();

}


export type InvoiceRefundQueryBuilder = DwQueryBuilderGen<InvoiceRefundEntity, InvoiceRefundMetaDataAttributes,InvoiceRefundMetaDataRelations>


export class InvoiceRefundMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'InvoiceRefund';
    // Attributes
    InvoiceRefundId = new DwItemAttribute(this.i, 'InvoiceRefundId');
    InvoiceId = new DwItemAttribute(this.i, 'InvoiceId');
    RefundDateTime = new DwItemAttribute(this.i, 'RefundDateTime');
    RefundAmount = new DwItemAttribute(this.i, 'RefundAmount');
    RefundReason = new DwItemAttribute(this.i, 'RefundReason');
    RefundPaymentRef = new DwItemAttribute(this.i, 'RefundPaymentRef');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class InvoiceRefundMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Invoice */
            Invoice = new DwItemRelationship('Invoice|InvoiceRefund|InvoiceId', 'Invoice', 'Invoice');
    };
export class InvoiceStatusMetaData implements DwItem2<InvoiceStatusEntity, InvoiceStatusMetaDataAttributes,InvoiceStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=298;
        this.ItemDetail.itemName='InvoiceStatus';
        this.ItemDetail.keyName='InvoiceStatusId';
    }

    CreateEntity(): InvoiceStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): InvoiceStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<InvoiceStatusEntity, InvoiceStatusMetaDataAttributes,InvoiceStatusMetaDataRelations>(query, this);
    }
     Attributes = new InvoiceStatusMetaDataAttributes();
     Relations = new InvoiceStatusMetaDataRelations();

}


export type InvoiceStatusQueryBuilder = DwQueryBuilderGen<InvoiceStatusEntity, InvoiceStatusMetaDataAttributes,InvoiceStatusMetaDataRelations>


export class InvoiceStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'InvoiceStatus';
    // Attributes
    InvoiceStatusId = new DwItemAttribute(this.i, 'InvoiceStatusId');
    InvoiceStatus = new DwItemAttribute(this.i, 'InvoiceStatus');
}

class InvoiceStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Invoice */
            Invoice = new DwItemRelationship('InvoiceStatus|Invoice|InvoiceStatusId', 'Invoice', 'Invoice');
    };
export class InvoiceTypeMetaData implements DwItem2<InvoiceTypeEntity, InvoiceTypeMetaDataAttributes,InvoiceTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=297;
        this.ItemDetail.itemName='InvoiceType';
        this.ItemDetail.keyName='InvoiceTypeId';
    }

    CreateEntity(): InvoiceTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): InvoiceTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<InvoiceTypeEntity, InvoiceTypeMetaDataAttributes,InvoiceTypeMetaDataRelations>(query, this);
    }
     Attributes = new InvoiceTypeMetaDataAttributes();
     Relations = new InvoiceTypeMetaDataRelations();

}


export type InvoiceTypeQueryBuilder = DwQueryBuilderGen<InvoiceTypeEntity, InvoiceTypeMetaDataAttributes,InvoiceTypeMetaDataRelations>


export class InvoiceTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'InvoiceType';
    // Attributes
    InvoiceTypeId = new DwItemAttribute(this.i, 'InvoiceTypeId');
    InvoiceType = new DwItemAttribute(this.i, 'InvoiceType');
}

class InvoiceTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Invoice */
            Invoice = new DwItemRelationship('InvoiceType|Invoice|InvoiceTypeId', 'Invoice', 'Invoice');
    };
export class JoinRequestMetaData implements DwItem2<JoinRequestEntity, JoinRequestMetaDataAttributes,JoinRequestMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=198;
        this.ItemDetail.itemName='JoinRequest';
        this.ItemDetail.keyName='JoinRequestId';
    }

    CreateEntity(): JoinRequestEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): JoinRequestQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<JoinRequestEntity, JoinRequestMetaDataAttributes,JoinRequestMetaDataRelations>(query, this);
    }
     Attributes = new JoinRequestMetaDataAttributes();
     Relations = new JoinRequestMetaDataRelations();

}


export type JoinRequestQueryBuilder = DwQueryBuilderGen<JoinRequestEntity, JoinRequestMetaDataAttributes,JoinRequestMetaDataRelations>


export class JoinRequestMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'JoinRequest';
    // Attributes
    JoinRequestId = new DwItemAttribute(this.i, 'JoinRequestId');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    JoinRequestTypeId = new DwItemAttribute(this.i, 'JoinRequestTypeId');
    MessageHtml = new DwItemAttribute(this.i, 'MessageHtml');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    UsePackage = new DwItemAttribute(this.i, 'UsePackage');
    CoursePackageId = new DwItemAttribute(this.i, 'CoursePackageId');
    JoinRequestStatusId = new DwItemAttribute(this.i, 'JoinRequestStatusId');
    AssignToGroup = new DwItemAttribute(this.i, 'AssignToGroup');
    FlightSchoolGroupId = new DwItemAttribute(this.i, 'FlightSchoolGroupId');
    DiscountCode = new DwItemAttribute(this.i, 'DiscountCode');
}

class JoinRequestMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School */
            FlightSchool = new DwItemRelationship('FlightSchool|JoinRequest|FlightSchoolId', 'FlightSchool', 'FlightSchool');
            /** Relation: Flight School Group */
            FlightSchoolGroup = new DwItemRelationship('FlightSchoolGroup|JoinRequest|FlightSchoolStudentGroupId', 'FlightSchoolGroup', 'FlightSchoolGroup');
            /** Relation: Join Request Status */
            JoinRequestStatus = new DwItemRelationship('JoinRequestStatus|JoinRequest|JoinRequestStatusId', 'JoinRequestStatus', 'JoinRequestStatus');
            /** Relation: Join Request Type */
            JoinRequestType = new DwItemRelationship('JoinRequestType|JoinRequest|JoinRequestTypeId', 'JoinRequestType', 'JoinRequestType');
            /** Relation: Package - Course Package */
            PackageByCoursePackageId = new DwItemRelationship('Package|JoinRequest|CoursePackageId', 'CoursePackage', 'CoursePackage');
            /** Relation: Join Request Course */
            JoinRequestCourse = new DwItemRelationship('JoinRequest|JoinRequestCourse|JoinRequestId', 'JoinRequestCourse', 'JoinRequestCourse');
            /** Relation: Join Request Course Purchase */
            JoinRequestCoursePurchase = new DwItemRelationship('JoinRequest|JoinRequestCoursePurchase|JoinRequestId', 'JoinRequestCoursePurchase', 'JoinRequestCoursePurchase');
            /** Relation: Join Request Email */
            JoinRequestEmail = new DwItemRelationship('JoinRequest|JoinRequestEmail|JoinRequestId', 'JoinRequestEmail', 'JoinRequestEmail');
    };
export class JoinRequestCourseMetaData implements DwItem2<JoinRequestCourseEntity, JoinRequestCourseMetaDataAttributes,JoinRequestCourseMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=202;
        this.ItemDetail.itemName='JoinRequestCourse';
        this.ItemDetail.keyName='JoinRequestCourseId';
    }

    CreateEntity(): JoinRequestCourseEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): JoinRequestCourseQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<JoinRequestCourseEntity, JoinRequestCourseMetaDataAttributes,JoinRequestCourseMetaDataRelations>(query, this);
    }
     Attributes = new JoinRequestCourseMetaDataAttributes();
     Relations = new JoinRequestCourseMetaDataRelations();

}


export type JoinRequestCourseQueryBuilder = DwQueryBuilderGen<JoinRequestCourseEntity, JoinRequestCourseMetaDataAttributes,JoinRequestCourseMetaDataRelations>


export class JoinRequestCourseMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'JoinRequestCourse';
    // Attributes
    JoinRequestCourseId = new DwItemAttribute(this.i, 'JoinRequestCourseId');
    JoinRequestId = new DwItemAttribute(this.i, 'JoinRequestId');
    CourseId = new DwItemAttribute(this.i, 'CourseId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class JoinRequestCourseMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Course */
            Course = new DwItemRelationship('Course|JoinRequestCourse|CourseId', 'Course', 'Course');
            /** Relation: Join Request */
            JoinRequest = new DwItemRelationship('JoinRequest|JoinRequestCourse|JoinRequestId', 'JoinRequest', 'JoinRequest');
    };
export class JoinRequestCourseFulfillmentStatusMetaData implements DwItem2<JoinRequestCourseFulfillmentStatusEntity, JoinRequestCourseFulfillmentStatusMetaDataAttributes,JoinRequestCourseFulfillmentStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=477;
        this.ItemDetail.itemName='JoinRequestCourseFulfillmentStatus';
        this.ItemDetail.keyName='JoinRequestCourseFulfillmentStatusId';
    }

    CreateEntity(): JoinRequestCourseFulfillmentStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): JoinRequestCourseFulfillmentStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<JoinRequestCourseFulfillmentStatusEntity, JoinRequestCourseFulfillmentStatusMetaDataAttributes,JoinRequestCourseFulfillmentStatusMetaDataRelations>(query, this);
    }
     Attributes = new JoinRequestCourseFulfillmentStatusMetaDataAttributes();
     Relations = new JoinRequestCourseFulfillmentStatusMetaDataRelations();

}


export type JoinRequestCourseFulfillmentStatusQueryBuilder = DwQueryBuilderGen<JoinRequestCourseFulfillmentStatusEntity, JoinRequestCourseFulfillmentStatusMetaDataAttributes,JoinRequestCourseFulfillmentStatusMetaDataRelations>


export class JoinRequestCourseFulfillmentStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'JoinRequestCourseFulfillmentStatus';
    // Attributes
    JoinRequestCourseFulfillmentStatusId = new DwItemAttribute(this.i, 'JoinRequestCourseFulfillmentStatusId');
    JoinRequestCourseFulfillmentStatus = new DwItemAttribute(this.i, 'JoinRequestCourseFulfillmentStatus');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class JoinRequestCourseFulfillmentStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Join Request Course Purchase */
            JoinRequestCoursePurchase = new DwItemRelationship('JoinRequestCourseFulfillmentStatus|JoinRequestCoursePurchase|JoinRequestCourseFulfillmentStatusId', 'JoinRequestCoursePurchase', 'JoinRequestCoursePurchase');
    };
export class JoinRequestCoursePurchaseMetaData implements DwItem2<JoinRequestCoursePurchaseEntity, JoinRequestCoursePurchaseMetaDataAttributes,JoinRequestCoursePurchaseMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=479;
        this.ItemDetail.itemName='JoinRequestCoursePurchase';
        this.ItemDetail.keyName='JoinRequestCoursePurchaseId';
    }

    CreateEntity(): JoinRequestCoursePurchaseEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): JoinRequestCoursePurchaseQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<JoinRequestCoursePurchaseEntity, JoinRequestCoursePurchaseMetaDataAttributes,JoinRequestCoursePurchaseMetaDataRelations>(query, this);
    }
     Attributes = new JoinRequestCoursePurchaseMetaDataAttributes();
     Relations = new JoinRequestCoursePurchaseMetaDataRelations();

}


export type JoinRequestCoursePurchaseQueryBuilder = DwQueryBuilderGen<JoinRequestCoursePurchaseEntity, JoinRequestCoursePurchaseMetaDataAttributes,JoinRequestCoursePurchaseMetaDataRelations>


export class JoinRequestCoursePurchaseMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'JoinRequestCoursePurchase';
    // Attributes
    JoinRequestCoursePurchaseId = new DwItemAttribute(this.i, 'JoinRequestCoursePurchaseId');
    JoinRequestId = new DwItemAttribute(this.i, 'JoinRequestId');
    JoinRequestEmailId = new DwItemAttribute(this.i, 'JoinRequestEmailId');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    EmailAddress = new DwItemAttribute(this.i, 'EmailAddress');
    NormalizedEmailAddress = new DwItemAttribute(this.i, 'NormalizedEmailAddress');
    CourseId = new DwItemAttribute(this.i, 'CourseId');
    CoursePackageId = new DwItemAttribute(this.i, 'CoursePackageId');
    ProductId = new DwItemAttribute(this.i, 'ProductId');
    InvoiceId = new DwItemAttribute(this.i, 'InvoiceId');
    InvoiceLineId = new DwItemAttribute(this.i, 'InvoiceLineId');
    UserId = new DwItemAttribute(this.i, 'UserId');
    StudentId = new DwItemAttribute(this.i, 'StudentId');
    StudentCourseId = new DwItemAttribute(this.i, 'StudentCourseId');
    JoinRequestCoursePurchaseStatusId = new DwItemAttribute(this.i, 'JoinRequestCoursePurchaseStatusId');
    JoinRequestCourseFulfillmentStatusId = new DwItemAttribute(this.i, 'JoinRequestCourseFulfillmentStatusId');
    IsLegacyBackfill = new DwItemAttribute(this.i, 'IsLegacyBackfill');
    PurchasedDateTime = new DwItemAttribute(this.i, 'PurchasedDateTime');
    FulfilledDateTime = new DwItemAttribute(this.i, 'FulfilledDateTime');
    LastAttemptDateTime = new DwItemAttribute(this.i, 'LastAttemptDateTime');
    LastErrorMessage = new DwItemAttribute(this.i, 'LastErrorMessage');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class JoinRequestCoursePurchaseMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Course */
            Course = new DwItemRelationship('Course|JoinRequestCoursePurchase|CourseId', 'Course', 'Course');
            /** Relation: Flight School */
            FlightSchool = new DwItemRelationship('FlightSchool|JoinRequestCoursePurchase|FlightSchoolId', 'FlightSchool', 'FlightSchool');
            /** Relation: Invoice */
            Invoice = new DwItemRelationship('Invoice|JoinRequestCoursePurchase|InvoiceId', 'Invoice', 'Invoice');
            /** Relation: Invoice Line */
            InvoiceLine = new DwItemRelationship('InvoiceLine|JoinRequestCoursePurchase|InvoiceLineId', 'InvoiceLine', 'InvoiceLine');
            /** Relation: Join Request */
            JoinRequest = new DwItemRelationship('JoinRequest|JoinRequestCoursePurchase|JoinRequestId', 'JoinRequest', 'JoinRequest');
            /** Relation: Join Request Course Fulfillment Status */
            JoinRequestCourseFulfillmentStatus = new DwItemRelationship('JoinRequestCourseFulfillmentStatus|JoinRequestCoursePurchase|JoinRequestCourseFulfillmentStatusId', 'JoinRequestCourseFulfillmentStatus', 'JoinRequestCourseFulfillmentStatus');
            /** Relation: Join Request Course Purchase Status */
            JoinRequestCoursePurchaseStatus = new DwItemRelationship('JoinRequestCoursePurchaseStatus|JoinRequestCoursePurchase|JoinRequestCoursePurchaseStatusId', 'JoinRequestCoursePurchaseStatus', 'JoinRequestCoursePurchaseStatus');
            /** Relation: Join Request Email */
            JoinRequestEmail = new DwItemRelationship('JoinRequestEmail|JoinRequestCoursePurchase|JoinRequestEmailId', 'JoinRequestEmail', 'JoinRequestEmail');
            /** Relation: Package - Course Package */
            PackageByCoursePackageId = new DwItemRelationship('Package|JoinRequestCoursePurchase|CoursePackageId', 'CoursePackage', 'CoursePackage');
            /** Relation: Product */
            Product = new DwItemRelationship('Product|JoinRequestCoursePurchase|ProductId', 'Product', 'Product');
            /** Relation: Student */
            Student = new DwItemRelationship('Student|JoinRequestCoursePurchase|StudentId', 'Student', 'Student');
            /** Relation: Student Course */
            StudentCourse = new DwItemRelationship('StudentCourse|JoinRequestCoursePurchase|StudentCourseId', 'StudentCourse', 'StudentCourse');
            /** Relation: User */
            DwUser = new DwItemRelationship('dw_User|JoinRequestCoursePurchase|UserId', 'DwUser', 'DwUser');
    };
export class JoinRequestCoursePurchaseStatusMetaData implements DwItem2<JoinRequestCoursePurchaseStatusEntity, JoinRequestCoursePurchaseStatusMetaDataAttributes,JoinRequestCoursePurchaseStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=478;
        this.ItemDetail.itemName='JoinRequestCoursePurchaseStatus';
        this.ItemDetail.keyName='JoinRequestCoursePurchaseStatusId';
    }

    CreateEntity(): JoinRequestCoursePurchaseStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): JoinRequestCoursePurchaseStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<JoinRequestCoursePurchaseStatusEntity, JoinRequestCoursePurchaseStatusMetaDataAttributes,JoinRequestCoursePurchaseStatusMetaDataRelations>(query, this);
    }
     Attributes = new JoinRequestCoursePurchaseStatusMetaDataAttributes();
     Relations = new JoinRequestCoursePurchaseStatusMetaDataRelations();

}


export type JoinRequestCoursePurchaseStatusQueryBuilder = DwQueryBuilderGen<JoinRequestCoursePurchaseStatusEntity, JoinRequestCoursePurchaseStatusMetaDataAttributes,JoinRequestCoursePurchaseStatusMetaDataRelations>


export class JoinRequestCoursePurchaseStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'JoinRequestCoursePurchaseStatus';
    // Attributes
    JoinRequestCoursePurchaseStatusId = new DwItemAttribute(this.i, 'JoinRequestCoursePurchaseStatusId');
    JoinRequestCoursePurchaseStatus = new DwItemAttribute(this.i, 'JoinRequestCoursePurchaseStatus');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class JoinRequestCoursePurchaseStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Join Request Course Purchase */
            JoinRequestCoursePurchase = new DwItemRelationship('JoinRequestCoursePurchaseStatus|JoinRequestCoursePurchase|JoinRequestCoursePurchaseStatusId', 'JoinRequestCoursePurchase', 'JoinRequestCoursePurchase');
    };
export class JoinRequestEmailMetaData implements DwItem2<JoinRequestEmailEntity, JoinRequestEmailMetaDataAttributes,JoinRequestEmailMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=197;
        this.ItemDetail.itemName='JoinRequestEmail';
        this.ItemDetail.keyName='JoinRequestEmailId';
    }

    CreateEntity(): JoinRequestEmailEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): JoinRequestEmailQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<JoinRequestEmailEntity, JoinRequestEmailMetaDataAttributes,JoinRequestEmailMetaDataRelations>(query, this);
    }
     Attributes = new JoinRequestEmailMetaDataAttributes();
     Relations = new JoinRequestEmailMetaDataRelations();

}


export type JoinRequestEmailQueryBuilder = DwQueryBuilderGen<JoinRequestEmailEntity, JoinRequestEmailMetaDataAttributes,JoinRequestEmailMetaDataRelations>


export class JoinRequestEmailMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'JoinRequestEmail';
    // Attributes
    JoinRequestEmailId = new DwItemAttribute(this.i, 'JoinRequestEmailId');
    JoinRequestId = new DwItemAttribute(this.i, 'JoinRequestId');
    EmailAddress = new DwItemAttribute(this.i, 'EmailAddress');
    Accepted = new DwItemAttribute(this.i, 'Accepted');
    UserId = new DwItemAttribute(this.i, 'UserId');
    AcceptedDateTime = new DwItemAttribute(this.i, 'AcceptedDateTime');
    LastResendRequestDateTime = new DwItemAttribute(this.i, 'LastResendRequestDateTime');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class JoinRequestEmailMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Join Request */
            JoinRequest = new DwItemRelationship('JoinRequest|JoinRequestEmail|JoinRequestId', 'JoinRequest', 'JoinRequest');
            /** Relation: User */
            DwUser = new DwItemRelationship('dw_User|JoinRequestEmail|UserId', 'DwUser', 'DwUser');
            /** Relation: Join Request Course Purchase */
            JoinRequestCoursePurchase = new DwItemRelationship('JoinRequestEmail|JoinRequestCoursePurchase|JoinRequestEmailId', 'JoinRequestCoursePurchase', 'JoinRequestCoursePurchase');
            /** Relation: Profit Share */
            ProfitShare = new DwItemRelationship('JoinRequestEmail|ProfitShare|JoinRequestEmailId', 'ProfitShare', 'ProfitShare');
    };
export class JoinRequestStatusMetaData implements DwItem2<JoinRequestStatusEntity, JoinRequestStatusMetaDataAttributes,JoinRequestStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=203;
        this.ItemDetail.itemName='JoinRequestStatus';
        this.ItemDetail.keyName='JoinRequestStatusId';
    }

    CreateEntity(): JoinRequestStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): JoinRequestStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<JoinRequestStatusEntity, JoinRequestStatusMetaDataAttributes,JoinRequestStatusMetaDataRelations>(query, this);
    }
     Attributes = new JoinRequestStatusMetaDataAttributes();
     Relations = new JoinRequestStatusMetaDataRelations();

}


export type JoinRequestStatusQueryBuilder = DwQueryBuilderGen<JoinRequestStatusEntity, JoinRequestStatusMetaDataAttributes,JoinRequestStatusMetaDataRelations>


export class JoinRequestStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'JoinRequestStatus';
    // Attributes
    JoinRequestStatusId = new DwItemAttribute(this.i, 'JoinRequestStatusId');
    JoinRequestStatus = new DwItemAttribute(this.i, 'JoinRequestStatus');
}

class JoinRequestStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Join Request */
            JoinRequest = new DwItemRelationship('JoinRequestStatus|JoinRequest|JoinRequestStatusId', 'JoinRequest', 'JoinRequest');
    };
export class JoinRequestTypeMetaData implements DwItem2<JoinRequestTypeEntity, JoinRequestTypeMetaDataAttributes,JoinRequestTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=201;
        this.ItemDetail.itemName='JoinRequestType';
        this.ItemDetail.keyName='JoinRequestTypeId';
    }

    CreateEntity(): JoinRequestTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): JoinRequestTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<JoinRequestTypeEntity, JoinRequestTypeMetaDataAttributes,JoinRequestTypeMetaDataRelations>(query, this);
    }
     Attributes = new JoinRequestTypeMetaDataAttributes();
     Relations = new JoinRequestTypeMetaDataRelations();

}


export type JoinRequestTypeQueryBuilder = DwQueryBuilderGen<JoinRequestTypeEntity, JoinRequestTypeMetaDataAttributes,JoinRequestTypeMetaDataRelations>


export class JoinRequestTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'JoinRequestType';
    // Attributes
    JoinRequestTypeId = new DwItemAttribute(this.i, 'JoinRequestTypeId');
    JoinRequestType = new DwItemAttribute(this.i, 'JoinRequestType');
    UserTypeId = new DwItemAttribute(this.i, 'UserTypeId');
    IncludeCourses = new DwItemAttribute(this.i, 'IncludeCourses');
    JobRequestTypeDescription = new DwItemAttribute(this.i, 'JobRequestTypeDescription');
}

class JoinRequestTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: User Type */
            DwUserType = new DwItemRelationship('dw_UserType|JoinRequestType|UserTypeId', 'DwUserType', 'DwUserType');
            /** Relation: Flight School Registration Link */
            FlightSchoolRegistrationLink = new DwItemRelationship('JoinRequestType|FlightSchoolRegistrationLink|JoinRequestTypeId', 'FlightSchoolRegistrationLink', 'FlightSchoolRegistrationLink');
            /** Relation: Join Request */
            JoinRequest = new DwItemRelationship('JoinRequestType|JoinRequest|JoinRequestTypeId', 'JoinRequest', 'JoinRequest');
            /** Relation: Join Request Type Role */
            JoinRequestTypeRole = new DwItemRelationship('JoinRequestType|JoinRequestTypeRole|JoinRequestTypeId', 'JoinRequestTypeRole', 'JoinRequestTypeRole');
            /** Relation: Join Request Type Subscription Role */
            JoinRequestTypeSubscriptionRole = new DwItemRelationship('JoinRequestType|JoinRequestTypeSubscriptionRole|JoinRequestTypeId', 'JoinRequestTypeSubscriptionRole', 'JoinRequestTypeSubscriptionRole');
    };
export class JoinRequestTypeRoleMetaData implements DwItem2<JoinRequestTypeRoleEntity, JoinRequestTypeRoleMetaDataAttributes,JoinRequestTypeRoleMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=200;
        this.ItemDetail.itemName='JoinRequestTypeRole';
        this.ItemDetail.keyName='JoinRequestTypeRoleId';
    }

    CreateEntity(): JoinRequestTypeRoleEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): JoinRequestTypeRoleQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<JoinRequestTypeRoleEntity, JoinRequestTypeRoleMetaDataAttributes,JoinRequestTypeRoleMetaDataRelations>(query, this);
    }
     Attributes = new JoinRequestTypeRoleMetaDataAttributes();
     Relations = new JoinRequestTypeRoleMetaDataRelations();

}


export type JoinRequestTypeRoleQueryBuilder = DwQueryBuilderGen<JoinRequestTypeRoleEntity, JoinRequestTypeRoleMetaDataAttributes,JoinRequestTypeRoleMetaDataRelations>


export class JoinRequestTypeRoleMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'JoinRequestTypeRole';
    // Attributes
    JoinRequestTypeRoleId = new DwItemAttribute(this.i, 'JoinRequestTypeRoleId');
    JoinRequestTypeId = new DwItemAttribute(this.i, 'JoinRequestTypeId');
    RoleId = new DwItemAttribute(this.i, 'RoleId');
}

class JoinRequestTypeRoleMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Join Request Type */
            JoinRequestType = new DwItemRelationship('JoinRequestType|JoinRequestTypeRole|JoinRequestTypeId', 'JoinRequestType', 'JoinRequestType');
            /** Relation: Role */
            DwRole = new DwItemRelationship('dw_Role|JoinRequestTypeRole|RoleId', 'DwRole', 'DwRole');
    };
export class JoinRequestTypeSubscriptionRoleMetaData implements DwItem2<JoinRequestTypeSubscriptionRoleEntity, JoinRequestTypeSubscriptionRoleMetaDataAttributes,JoinRequestTypeSubscriptionRoleMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=303;
        this.ItemDetail.itemName='JoinRequestTypeSubscriptionRole';
        this.ItemDetail.keyName='JoinRequestTypeSubscriptionRoleId';
    }

    CreateEntity(): JoinRequestTypeSubscriptionRoleEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): JoinRequestTypeSubscriptionRoleQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<JoinRequestTypeSubscriptionRoleEntity, JoinRequestTypeSubscriptionRoleMetaDataAttributes,JoinRequestTypeSubscriptionRoleMetaDataRelations>(query, this);
    }
     Attributes = new JoinRequestTypeSubscriptionRoleMetaDataAttributes();
     Relations = new JoinRequestTypeSubscriptionRoleMetaDataRelations();

}


export type JoinRequestTypeSubscriptionRoleQueryBuilder = DwQueryBuilderGen<JoinRequestTypeSubscriptionRoleEntity, JoinRequestTypeSubscriptionRoleMetaDataAttributes,JoinRequestTypeSubscriptionRoleMetaDataRelations>


export class JoinRequestTypeSubscriptionRoleMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'JoinRequestTypeSubscriptionRole';
    // Attributes
    JoinRequestTypeSubscriptionRoleId = new DwItemAttribute(this.i, 'JoinRequestTypeSubscriptionRoleId');
    JoinRequestTypeId = new DwItemAttribute(this.i, 'JoinRequestTypeId');
    SubscriptionRoleId = new DwItemAttribute(this.i, 'SubscriptionRoleId');
}

class JoinRequestTypeSubscriptionRoleMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Join Request Type */
            JoinRequestType = new DwItemRelationship('JoinRequestType|JoinRequestTypeSubscriptionRole|JoinRequestTypeId', 'JoinRequestType', 'JoinRequestType');
            /** Relation: Subscription Role */
            SubscriptionRole = new DwItemRelationship('SubscriptionRole|JoinRequestTypeSubscriptionRole|SubscriptionRoleId', 'SubscriptionRole', 'SubscriptionRole');
    };
export class LessonTypeMetaData implements DwItem2<LessonTypeEntity, LessonTypeMetaDataAttributes,LessonTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=154;
        this.ItemDetail.itemName='LessonType';
        this.ItemDetail.keyName='LessonTypeId';
    }

    CreateEntity(): LessonTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): LessonTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<LessonTypeEntity, LessonTypeMetaDataAttributes,LessonTypeMetaDataRelations>(query, this);
    }
     Attributes = new LessonTypeMetaDataAttributes();
     Relations = new LessonTypeMetaDataRelations();

}


export type LessonTypeQueryBuilder = DwQueryBuilderGen<LessonTypeEntity, LessonTypeMetaDataAttributes,LessonTypeMetaDataRelations>


export class LessonTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'LessonType';
    // Attributes
    LessonTypeId = new DwItemAttribute(this.i, 'LessonTypeId');
    LessonType = new DwItemAttribute(this.i, 'LessonType');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class LessonTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Lesson */
            CourseLesson = new DwItemRelationship('LessonType|CourseLesson|LessonTypeId', 'CourseLesson', 'CourseLesson');
    };
export class DwMediaMetaData implements DwItem2<DwMediaEntity, DwMediaMetaDataAttributes,DwMediaMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=74;
        this.ItemDetail.itemName='dw_Media';
        this.ItemDetail.keyName='MediaId';
    }

    CreateEntity(): DwMediaEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwMediaQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwMediaEntity, DwMediaMetaDataAttributes,DwMediaMetaDataRelations>(query, this);
    }
     Attributes = new DwMediaMetaDataAttributes();
     Relations = new DwMediaMetaDataRelations();

}


export type DwMediaQueryBuilder = DwQueryBuilderGen<DwMediaEntity, DwMediaMetaDataAttributes,DwMediaMetaDataRelations>


export class DwMediaMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_Media';
    // Attributes
    ContainerName = new DwItemAttribute(this.i, 'ContainerName');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    IsDeleted = new DwItemAttribute(this.i, 'IsDeleted');
    IsSecure = new DwItemAttribute(this.i, 'IsSecure');
    MediaFolderId = new DwItemAttribute(this.i, 'MediaFolderId');
    MediaGroupId = new DwItemAttribute(this.i, 'MediaGroupId');
    MediaId = new DwItemAttribute(this.i, 'MediaId');
    MediaName = new DwItemAttribute(this.i, 'MediaName');
    MediaStorageTypeId = new DwItemAttribute(this.i, 'MediaStorageTypeId');
    MediaTypeId = new DwItemAttribute(this.i, 'MediaTypeId');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class DwMediaMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Media Group */
            DwMediaGroup = new DwItemRelationship('dw_MediaGroup|dw_Media|MediaGroupId', 'DwMediaGroup', 'DwMediaGroup');
            /** Relation: Assignment */
            Assignment = new DwItemRelationship('dw_Media|Assignment|MediaId', 'Assignment', 'Assignment');
            /** Relation: Course - Course Image - Many */
            CourseByCourseImageMediaId = new DwItemRelationship('dw_Media|Course|CourseImageMediaId', 'CourseImageCourse', 'CourseImageCourse');
            /** Relation: Course Endorsement - Endorsement P D F - Many */
            CourseEndorsementByEndorsementPDFMediaId = new DwItemRelationship('dw_Media|CourseEndorsement|EndorsementPDFMediaId', 'EndorsementPDFCourseEndorsement', 'EndorsementPDFCourseEndorsement');
            /** Relation: Course Endorsement Student - Endorsement P D F - Many */
            CourseEndorsementStudentByEndorsementPDFMediaId = new DwItemRelationship('dw_Media|CourseEndorsementStudent|EndorsementPDFMediaId', 'EndorsementPDFCourseEndorsementStudent', 'EndorsementPDFCourseEndorsementStudent');
            /** Relation: Module - Module Image - Many */
            CourseModuleByModuleImageMediaId = new DwItemRelationship('dw_Media|CourseModule|ModuleImageMediaId', 'ModuleImageCourseModule', 'ModuleImageCourseModule');
            /** Relation: Document Asset */
            DocumentAsset = new DwItemRelationship('dw_Media|DocumentAsset|MediaId', 'DocumentAsset', 'DocumentAsset');
            /** Relation: Document Folder - Folder Icon - Many */
            DocumentFolderByFolderIconMediaId = new DwItemRelationship('dw_Media|DocumentFolder|FolderIconMediaId', 'FolderIconDocumentFolder', 'FolderIconDocumentFolder');
            /** Relation: Document Item */
            DocumentItem = new DwItemRelationship('dw_Media|DocumentItem|MediaId', 'DocumentItem', 'DocumentItem');
            /** Relation: Document Item - Card Icon - Many */
            DocumentItemByCardIconMediaId = new DwItemRelationship('dw_Media|DocumentItem|CardIconMediaId', 'CardIconDocumentItem', 'CardIconDocumentItem');
            /** Relation: Document Item - Extracted Image - Many */
            DocumentItemByExtractedImageMediaId = new DwItemRelationship('dw_Media|DocumentItem|ExtractedImageMediaId', 'ExtractedImageDocumentItem', 'ExtractedImageDocumentItem');
            /** Relation: Flight School Branding - Mobile App Icon - Many */
            FlightSchoolBrandingByMobileAppIconMediaId = new DwItemRelationship('dw_Media|FlightSchoolBranding|MobileAppIconMediaId', 'MobileAppIconFlightSchoolBranding', 'MobileAppIconFlightSchoolBranding');
            /** Relation: Ro Media */
            DwRoMedia = new DwItemRelationship('roMedia|Media|MediaId', 'DwroMedia', 'DwroMedia');
            /** Relation: Standard Login Media */
            StandardLoginMedia = new DwItemRelationship('dw_Media|StandardLoginMedia|MediaId', 'StandardLoginMedia', 'StandardLoginMedia');
            /** Relation: Theme - Alternate Logo - Many */
            DwThemeByAlternateLogoMediaId = new DwItemRelationship('dw_Media|dw_Theme|AlternateLogoMediaId', 'AlternateLogoDwTheme', 'AlternateLogoDwTheme');
            /** Relation: Theme - Logo - Many */
            DwThemeByLogoMediaId = new DwItemRelationship('dw_Media|dw_Theme|LogoMediaId', 'LogoDwTheme', 'LogoDwTheme');
            /** Relation: Theme - Logo Login - Many */
            DwThemeByLogoLoginMediaId = new DwItemRelationship('dw_Media|dw_Theme|LogoLoginMediaId', 'LogoLoginDwTheme', 'LogoLoginDwTheme');
            /** Relation: User - User Picture - Many */
            DwUserByUserPictureMediaId = new DwItemRelationship('dw_Media|dw_User|UserPictureMediaId', 'UserPictureDwUser', 'UserPictureDwUser');
            /** Relation: User - User Background - Many */
            DwUserByUserBackgroundMediaId = new DwItemRelationship('dw_Media|dw_User|UserBackgroundMediaId', 'UserBackgroundDwUser', 'UserBackgroundDwUser');
    };
export class DwMediaGroupMetaData implements DwItem2<DwMediaGroupEntity, DwMediaGroupMetaDataAttributes,DwMediaGroupMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=58;
        this.ItemDetail.itemName='dw_MediaGroup';
        this.ItemDetail.keyName='MediaGroupId';
    }

    CreateEntity(): DwMediaGroupEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwMediaGroupQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwMediaGroupEntity, DwMediaGroupMetaDataAttributes,DwMediaGroupMetaDataRelations>(query, this);
    }
     Attributes = new DwMediaGroupMetaDataAttributes();
     Relations = new DwMediaGroupMetaDataRelations();

}


export type DwMediaGroupQueryBuilder = DwQueryBuilderGen<DwMediaGroupEntity, DwMediaGroupMetaDataAttributes,DwMediaGroupMetaDataRelations>


export class DwMediaGroupMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_MediaGroup';
    // Attributes
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    GroupName = new DwItemAttribute(this.i, 'GroupName');
    IsGlobalGroup = new DwItemAttribute(this.i, 'IsGlobalGroup');
    IsSecure = new DwItemAttribute(this.i, 'IsSecure');
    MediaGroupId = new DwItemAttribute(this.i, 'MediaGroupId');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    PartyReferenceId = new DwItemAttribute(this.i, 'PartyReferenceId');
}

class DwMediaGroupMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School Branding - Custom Login - Many */
            FlightSchoolBrandingByCustomLoginMediaGroupId = new DwItemRelationship('dw_MediaGroup|FlightSchoolBranding|CustomLoginMediaGroupId', 'CustomLoginFlightSchoolBranding', 'CustomLoginFlightSchoolBranding');
            /** Relation: Media */
            DwMedia = new DwItemRelationship('dw_MediaGroup|dw_Media|MediaGroupId', 'DwMedia', 'DwMedia');
            /** Relation: Ro Media */
            DwRoMedia = new DwItemRelationship('MediaGroup_roMedia', 'DwroMedia', 'DwroMedia');
    };
export class DwMetaDataItemMetaData implements DwItem2<DwMetaDataItemEntity, DwMetaDataItemMetaDataAttributes,DwMetaDataItemMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=42;
        this.ItemDetail.itemName='dw_MetaDataItem';
        this.ItemDetail.keyName='MetaDataItemId';
    }

    CreateEntity(): DwMetaDataItemEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwMetaDataItemQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwMetaDataItemEntity, DwMetaDataItemMetaDataAttributes,DwMetaDataItemMetaDataRelations>(query, this);
    }
     Attributes = new DwMetaDataItemMetaDataAttributes();
     Relations = new DwMetaDataItemMetaDataRelations();

}


export type DwMetaDataItemQueryBuilder = DwQueryBuilderGen<DwMetaDataItemEntity, DwMetaDataItemMetaDataAttributes,DwMetaDataItemMetaDataRelations>


export class DwMetaDataItemMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_MetaDataItem';
    // Attributes
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    Display = new DwItemAttribute(this.i, 'Display');
    EnableHistory = new DwItemAttribute(this.i, 'EnableHistory');
    GenerateClientCode = new DwItemAttribute(this.i, 'GenerateClientCode');
    IsView = new DwItemAttribute(this.i, 'IsView');
    ItemName = new DwItemAttribute(this.i, 'ItemName');
    Layer = new DwItemAttribute(this.i, 'Layer');
    MetaDataDatabaseId = new DwItemAttribute(this.i, 'MetaDataDatabaseId');
    MetaDataEnvironmentOfRecordTypeId = new DwItemAttribute(this.i, 'MetaDataEnvironmentOfRecordTypeId');
    MetaDataGroupId = new DwItemAttribute(this.i, 'MetaDataGroupId');
    MetaDataItemId = new DwItemAttribute(this.i, 'MetaDataItemId');
    MetaDataItemStatusId = new DwItemAttribute(this.i, 'MetaDataItemStatusId');
    MetaDataItemTypeId = new DwItemAttribute(this.i, 'MetaDataItemTypeId');
    MetaDataSystemId = new DwItemAttribute(this.i, 'MetaDataSystemId');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    SchemaName = new DwItemAttribute(this.i, 'SchemaName');
    UniqueId = new DwItemAttribute(this.i, 'UniqueId');
    UniqueItemName = new DwItemAttribute(this.i, 'UniqueItemName');
}

class DwMetaDataItemMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: AI Processing Reference */
            AIProcessingReference = new DwItemRelationship('dw_MetaDataItem|AIProcessingReference|MetaDataItemId', 'AIProcessingReference', 'AIProcessingReference');
            /** Relation: Student Activity - Source - Many */
            StudentActivityBySourceMetaDataItemId = new DwItemRelationship('dw_MetaDataItem|StudentActivity|SourceMetaDataItemId', 'SourceStudentActivity', 'SourceStudentActivity');
            /** Relation: Student Activity - Related - Many */
            StudentActivityByRelatedMetaDataItemId = new DwItemRelationship('dw_MetaDataItem|StudentActivity|RelatedMetaDataItemId', 'RelatedStudentActivity', 'RelatedStudentActivity');
    };
export class MetricTypeMetaData implements DwItem2<MetricTypeEntity, MetricTypeMetaDataAttributes,MetricTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=495;
        this.ItemDetail.itemName='MetricType';
        this.ItemDetail.keyName='MetricTypeId';
    }

    CreateEntity(): MetricTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): MetricTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<MetricTypeEntity, MetricTypeMetaDataAttributes,MetricTypeMetaDataRelations>(query, this);
    }
     Attributes = new MetricTypeMetaDataAttributes();
     Relations = new MetricTypeMetaDataRelations();

}


export type MetricTypeQueryBuilder = DwQueryBuilderGen<MetricTypeEntity, MetricTypeMetaDataAttributes,MetricTypeMetaDataRelations>


export class MetricTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'MetricType';
    // Attributes
    MetricTypeId = new DwItemAttribute(this.i, 'MetricTypeId');
    MetricTypeKey = new DwItemAttribute(this.i, 'MetricTypeKey');
    MetricTypeName = new DwItemAttribute(this.i, 'MetricTypeName');
    ValueUnit = new DwItemAttribute(this.i, 'ValueUnit');
    SupportsGlobalScope = new DwItemAttribute(this.i, 'SupportsGlobalScope');
    SupportsCourseScope = new DwItemAttribute(this.i, 'SupportsCourseScope');
    Active = new DwItemAttribute(this.i, 'Active');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class MetricTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Achievement Tier */
            AchievementTier = new DwItemRelationship('MetricType|AchievementTier|MetricTypeId', 'AchievementTier', 'AchievementTier');
    };
export class ModificationHistoryMetaData implements DwItem2<ModificationHistoryEntity, ModificationHistoryMetaDataAttributes,ModificationHistoryMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=315;
        this.ItemDetail.itemName='ModificationHistory';
        this.ItemDetail.keyName='ModificationHistoryId';
    }

    CreateEntity(): ModificationHistoryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ModificationHistoryQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ModificationHistoryEntity, ModificationHistoryMetaDataAttributes,ModificationHistoryMetaDataRelations>(query, this);
    }
     Attributes = new ModificationHistoryMetaDataAttributes();
     Relations = new ModificationHistoryMetaDataRelations();

}


export type ModificationHistoryQueryBuilder = DwQueryBuilderGen<ModificationHistoryEntity, ModificationHistoryMetaDataAttributes,ModificationHistoryMetaDataRelations>


export class ModificationHistoryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ModificationHistory';
    // Attributes
    ModificationHistoryId = new DwItemAttribute(this.i, 'ModificationHistoryId');
    CourseId = new DwItemAttribute(this.i, 'CourseId');
    CourseChangeDateTime = new DwItemAttribute(this.i, 'CourseChangeDateTime');
    CourseChangeDetail = new DwItemAttribute(this.i, 'CourseChangeDetail');
    ModificationHistoryStatusId = new DwItemAttribute(this.i, 'ModificationHistoryStatusId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    LastLogId = new DwItemAttribute(this.i, 'LastLogId');
    StudentCoursesComplete = new DwItemAttribute(this.i, 'StudentCoursesComplete');
    StudentCoursesFailed = new DwItemAttribute(this.i, 'StudentCoursesFailed');
    StudentCoursesTotal = new DwItemAttribute(this.i, 'StudentCoursesTotal');
    PercentComplete = new DwItemAttribute(this.i, 'PercentComplete');
    TimeProcessingSeconds = new DwItemAttribute(this.i, 'TimeProcessingSeconds');
    ForceUpdate = new DwItemAttribute(this.i, 'ForceUpdate');
    StudentCoursesProcessed = new DwItemAttribute(this.i, 'StudentCoursesProcessed');
}

class ModificationHistoryMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Course */
            Course = new DwItemRelationship('Course|ModificationHistory|CourseId', 'Course', 'Course');
            /** Relation: Modification History Status */
            ModificationHistoryStatus = new DwItemRelationship('ModificationHistoryStatus|ModificationHistory|ModificationHistoryStatusId', 'ModificationHistoryStatus', 'ModificationHistoryStatus');
            /** Relation: Modification History Student */
            ModificationHistoryStudent = new DwItemRelationship('ModificationHistory|ModificationHistoryStudent|ModificationHistoryId', 'ModificationHistoryStudent', 'ModificationHistoryStudent');
    };
export class ModificationHistoryStatusMetaData implements DwItem2<ModificationHistoryStatusEntity, ModificationHistoryStatusMetaDataAttributes,ModificationHistoryStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=313;
        this.ItemDetail.itemName='ModificationHistoryStatus';
        this.ItemDetail.keyName='ModificationHistoryStatusId';
    }

    CreateEntity(): ModificationHistoryStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ModificationHistoryStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ModificationHistoryStatusEntity, ModificationHistoryStatusMetaDataAttributes,ModificationHistoryStatusMetaDataRelations>(query, this);
    }
     Attributes = new ModificationHistoryStatusMetaDataAttributes();
     Relations = new ModificationHistoryStatusMetaDataRelations();

}


export type ModificationHistoryStatusQueryBuilder = DwQueryBuilderGen<ModificationHistoryStatusEntity, ModificationHistoryStatusMetaDataAttributes,ModificationHistoryStatusMetaDataRelations>


export class ModificationHistoryStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ModificationHistoryStatus';
    // Attributes
    ModificationHistoryStatusId = new DwItemAttribute(this.i, 'ModificationHistoryStatusId');
    ModificationHistoryStatus = new DwItemAttribute(this.i, 'ModificationHistoryStatus');
}

class ModificationHistoryStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Modification History */
            ModificationHistory = new DwItemRelationship('ModificationHistoryStatus|ModificationHistory|ModificationHistoryStatusId', 'ModificationHistory', 'ModificationHistory');
    };
export class ModificationHistoryStudentMetaData implements DwItem2<ModificationHistoryStudentEntity, ModificationHistoryStudentMetaDataAttributes,ModificationHistoryStudentMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=314;
        this.ItemDetail.itemName='ModificationHistoryStudent';
        this.ItemDetail.keyName='ModificationHistoryStudentId';
    }

    CreateEntity(): ModificationHistoryStudentEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ModificationHistoryStudentQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ModificationHistoryStudentEntity, ModificationHistoryStudentMetaDataAttributes,ModificationHistoryStudentMetaDataRelations>(query, this);
    }
     Attributes = new ModificationHistoryStudentMetaDataAttributes();
     Relations = new ModificationHistoryStudentMetaDataRelations();

}


export type ModificationHistoryStudentQueryBuilder = DwQueryBuilderGen<ModificationHistoryStudentEntity, ModificationHistoryStudentMetaDataAttributes,ModificationHistoryStudentMetaDataRelations>


export class ModificationHistoryStudentMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ModificationHistoryStudent';
    // Attributes
    ModificationHistoryStudentId = new DwItemAttribute(this.i, 'ModificationHistoryStudentId');
    ModificationHistoryId = new DwItemAttribute(this.i, 'ModificationHistoryId');
    StudentCourseId = new DwItemAttribute(this.i, 'StudentCourseId');
    ModificationHistoryStudentStatusId = new DwItemAttribute(this.i, 'ModificationHistoryStudentStatusId');
    LastLogId = new DwItemAttribute(this.i, 'LastLogId');
    LastProcessedDateTime = new DwItemAttribute(this.i, 'LastProcessedDateTime');
    AttemptCount = new DwItemAttribute(this.i, 'AttemptCount');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    TimeProcessingSeconds = new DwItemAttribute(this.i, 'TimeProcessingSeconds');
}

class ModificationHistoryStudentMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Modification History */
            ModificationHistory = new DwItemRelationship('ModificationHistory|ModificationHistoryStudent|ModificationHistoryId', 'ModificationHistory', 'ModificationHistory');
            /** Relation: Modification History Student Status */
            ModificationHistoryStudentStatus = new DwItemRelationship('ModificationHistoryStudentStatus|ModificationHistoryStudent|ModificationHistoryStudentStatusId', 'ModificationHistoryStudentStatus', 'ModificationHistoryStudentStatus');
            /** Relation: Student Course */
            StudentCourse = new DwItemRelationship('StudentCourse|ModificationHistoryStudent|StudentCourseId', 'StudentCourse', 'StudentCourse');
    };
export class ModificationHistoryStudentStatusMetaData implements DwItem2<ModificationHistoryStudentStatusEntity, ModificationHistoryStudentStatusMetaDataAttributes,ModificationHistoryStudentStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=316;
        this.ItemDetail.itemName='ModificationHistoryStudentStatus';
        this.ItemDetail.keyName='ModificationHistoryStudentStatusId';
    }

    CreateEntity(): ModificationHistoryStudentStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ModificationHistoryStudentStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ModificationHistoryStudentStatusEntity, ModificationHistoryStudentStatusMetaDataAttributes,ModificationHistoryStudentStatusMetaDataRelations>(query, this);
    }
     Attributes = new ModificationHistoryStudentStatusMetaDataAttributes();
     Relations = new ModificationHistoryStudentStatusMetaDataRelations();

}


export type ModificationHistoryStudentStatusQueryBuilder = DwQueryBuilderGen<ModificationHistoryStudentStatusEntity, ModificationHistoryStudentStatusMetaDataAttributes,ModificationHistoryStudentStatusMetaDataRelations>


export class ModificationHistoryStudentStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ModificationHistoryStudentStatus';
    // Attributes
    ModificationHistoryStudentStatusId = new DwItemAttribute(this.i, 'ModificationHistoryStudentStatusId');
    ModificationHistoryStudentStatus = new DwItemAttribute(this.i, 'ModificationHistoryStudentStatus');
}

class ModificationHistoryStudentStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Modification History Student */
            ModificationHistoryStudent = new DwItemRelationship('ModificationHistoryStudentStatus|ModificationHistoryStudent|ModificationHistoryStudentStatusId', 'ModificationHistoryStudent', 'ModificationHistoryStudent');
    };
export class MultipleAssignMetaData implements DwItem2<MultipleAssignEntity, MultipleAssignMetaDataAttributes,MultipleAssignMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=306;
        this.ItemDetail.itemName='MultipleAssign';
        this.ItemDetail.keyName='MultipleAssignId';
    }

    CreateEntity(): MultipleAssignEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): MultipleAssignQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<MultipleAssignEntity, MultipleAssignMetaDataAttributes,MultipleAssignMetaDataRelations>(query, this);
    }
     Attributes = new MultipleAssignMetaDataAttributes();
     Relations = new MultipleAssignMetaDataRelations();

}


export type MultipleAssignQueryBuilder = DwQueryBuilderGen<MultipleAssignEntity, MultipleAssignMetaDataAttributes,MultipleAssignMetaDataRelations>


export class MultipleAssignMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'MultipleAssign';
    // Attributes
    MultipleAssignId = new DwItemAttribute(this.i, 'MultipleAssignId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class MultipleAssignMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Multiple Assign Course */
            MultipleAssignCourse = new DwItemRelationship('MultipleAssign|MultipleAssignCourse|MultipleAssignId', 'MultipleAssignCourse', 'MultipleAssignCourse');
            /** Relation: Multiple Assign Flight School */
            MultipleAssignFlightSchool = new DwItemRelationship('MultipleAssign|MultipleAssignFlightSchool|MultipleAssignId', 'MultipleAssignFlightSchool', 'MultipleAssignFlightSchool');
            /** Relation: Multiple Assign Package */
            MultipleAssignPackage = new DwItemRelationship('MultipleAssign|MultipleAssignPackage|MultipleAssignId', 'MultipleAssignPackage', 'MultipleAssignPackage');
    };
export class MultipleAssignCourseMetaData implements DwItem2<MultipleAssignCourseEntity, MultipleAssignCourseMetaDataAttributes,MultipleAssignCourseMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=308;
        this.ItemDetail.itemName='MultipleAssignCourse';
        this.ItemDetail.keyName='MultipleAssignCourseId';
    }

    CreateEntity(): MultipleAssignCourseEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): MultipleAssignCourseQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<MultipleAssignCourseEntity, MultipleAssignCourseMetaDataAttributes,MultipleAssignCourseMetaDataRelations>(query, this);
    }
     Attributes = new MultipleAssignCourseMetaDataAttributes();
     Relations = new MultipleAssignCourseMetaDataRelations();

}


export type MultipleAssignCourseQueryBuilder = DwQueryBuilderGen<MultipleAssignCourseEntity, MultipleAssignCourseMetaDataAttributes,MultipleAssignCourseMetaDataRelations>


export class MultipleAssignCourseMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'MultipleAssignCourse';
    // Attributes
    MultipleAssignCourseId = new DwItemAttribute(this.i, 'MultipleAssignCourseId');
    MultipleAssignId = new DwItemAttribute(this.i, 'MultipleAssignId');
    CourseId = new DwItemAttribute(this.i, 'CourseId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class MultipleAssignCourseMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Course */
            Course = new DwItemRelationship('Course|MultipleAssignCourse|CourseId', 'Course', 'Course');
            /** Relation: Multiple Assign */
            MultipleAssign = new DwItemRelationship('MultipleAssign|MultipleAssignCourse|MultipleAssignId', 'MultipleAssign', 'MultipleAssign');
    };
export class MultipleAssignFlightSchoolMetaData implements DwItem2<MultipleAssignFlightSchoolEntity, MultipleAssignFlightSchoolMetaDataAttributes,MultipleAssignFlightSchoolMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=305;
        this.ItemDetail.itemName='MultipleAssignFlightSchool';
        this.ItemDetail.keyName='MultipleAssignFlightSchoolId';
    }

    CreateEntity(): MultipleAssignFlightSchoolEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): MultipleAssignFlightSchoolQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<MultipleAssignFlightSchoolEntity, MultipleAssignFlightSchoolMetaDataAttributes,MultipleAssignFlightSchoolMetaDataRelations>(query, this);
    }
     Attributes = new MultipleAssignFlightSchoolMetaDataAttributes();
     Relations = new MultipleAssignFlightSchoolMetaDataRelations();

}


export type MultipleAssignFlightSchoolQueryBuilder = DwQueryBuilderGen<MultipleAssignFlightSchoolEntity, MultipleAssignFlightSchoolMetaDataAttributes,MultipleAssignFlightSchoolMetaDataRelations>


export class MultipleAssignFlightSchoolMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'MultipleAssignFlightSchool';
    // Attributes
    MultipleAssignFlightSchoolId = new DwItemAttribute(this.i, 'MultipleAssignFlightSchoolId');
    MultipleAssignId = new DwItemAttribute(this.i, 'MultipleAssignId');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class MultipleAssignFlightSchoolMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School */
            FlightSchool = new DwItemRelationship('FlightSchool|MultipleAssignFlightSchool|FlightSchoolId', 'FlightSchool', 'FlightSchool');
            /** Relation: Multiple Assign */
            MultipleAssign = new DwItemRelationship('MultipleAssign|MultipleAssignFlightSchool|MultipleAssignId', 'MultipleAssign', 'MultipleAssign');
    };
export class MultipleAssignPackageMetaData implements DwItem2<MultipleAssignPackageEntity, MultipleAssignPackageMetaDataAttributes,MultipleAssignPackageMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=307;
        this.ItemDetail.itemName='MultipleAssignPackage';
        this.ItemDetail.keyName='MultipleAssignPackageId';
    }

    CreateEntity(): MultipleAssignPackageEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): MultipleAssignPackageQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<MultipleAssignPackageEntity, MultipleAssignPackageMetaDataAttributes,MultipleAssignPackageMetaDataRelations>(query, this);
    }
     Attributes = new MultipleAssignPackageMetaDataAttributes();
     Relations = new MultipleAssignPackageMetaDataRelations();

}


export type MultipleAssignPackageQueryBuilder = DwQueryBuilderGen<MultipleAssignPackageEntity, MultipleAssignPackageMetaDataAttributes,MultipleAssignPackageMetaDataRelations>


export class MultipleAssignPackageMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'MultipleAssignPackage';
    // Attributes
    MultipleAssignPackageId = new DwItemAttribute(this.i, 'MultipleAssignPackageId');
    MultipleAssignId = new DwItemAttribute(this.i, 'MultipleAssignId');
    PackageId = new DwItemAttribute(this.i, 'PackageId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class MultipleAssignPackageMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Multiple Assign */
            MultipleAssign = new DwItemRelationship('MultipleAssign|MultipleAssignPackage|MultipleAssignId', 'MultipleAssign', 'MultipleAssign');
            /** Relation: Package */
            Package = new DwItemRelationship('Package|MultipleAssignPackage|PackageId', 'Package', 'Package');
    };
export class PackageMetaData implements DwItem2<PackageEntity, PackageMetaDataAttributes,PackageMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=183;
        this.ItemDetail.itemName='Package';
        this.ItemDetail.keyName='PackageId';
    }

    CreateEntity(): PackageEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): PackageQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<PackageEntity, PackageMetaDataAttributes,PackageMetaDataRelations>(query, this);
    }
     Attributes = new PackageMetaDataAttributes();
     Relations = new PackageMetaDataRelations();

}


export type PackageQueryBuilder = DwQueryBuilderGen<PackageEntity, PackageMetaDataAttributes,PackageMetaDataRelations>


export class PackageMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Package';
    // Attributes
    PackageId = new DwItemAttribute(this.i, 'PackageId');
    PackageName = new DwItemAttribute(this.i, 'PackageName');
    PackageDescription = new DwItemAttribute(this.i, 'PackageDescription');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    RetailPrice = new DwItemAttribute(this.i, 'RetailPrice');
    PackageMediaId = new DwItemAttribute(this.i, 'PackageMediaId');
}

class PackageMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Course Purchase Package */
            CoursePurchasePackage = new DwItemRelationship('Package|CoursePurchasePackage|PackageId', 'CoursePurchasePackage', 'CoursePurchasePackage');
            /** Relation: Course Purchase Reservation Course - Course - Many */
            CoursePurchaseReservationCourseByCoursePackageId = new DwItemRelationship('Package|CoursePurchaseReservationCourse|CoursePackageId', 'CourseCoursePurchaseReservationCourse', 'CourseCoursePurchaseReservationCourse');
            /** Relation: Discount Package */
            DiscountPackage = new DwItemRelationship('Package|DiscountPackage|PackageId', 'DiscountPackage', 'DiscountPackage');
            /** Relation: Flight School Package */
            FlightSchoolPackage = new DwItemRelationship('Package|FlightSchoolPackage|PackageId', 'FlightSchoolPackage', 'FlightSchoolPackage');
            /** Relation: Join Request - Course - Many */
            JoinRequestByCoursePackageId = new DwItemRelationship('Package|JoinRequest|CoursePackageId', 'CourseJoinRequest', 'CourseJoinRequest');
            /** Relation: Join Request Course Purchase - Course - Many */
            JoinRequestCoursePurchaseByCoursePackageId = new DwItemRelationship('Package|JoinRequestCoursePurchase|CoursePackageId', 'CourseJoinRequestCoursePurchase', 'CourseJoinRequestCoursePurchase');
            /** Relation: Multiple Assign Package */
            MultipleAssignPackage = new DwItemRelationship('Package|MultipleAssignPackage|PackageId', 'MultipleAssignPackage', 'MultipleAssignPackage');
            /** Relation: Package Course */
            PackageCourse = new DwItemRelationship('Package|PackageCourse|PackageId', 'PackageCourse', 'PackageCourse');
            /** Relation: Product */
            Product = new DwItemRelationship('Package|Product|PackageId', 'Product', 'Product');
    };
export class PackageCourseMetaData implements DwItem2<PackageCourseEntity, PackageCourseMetaDataAttributes,PackageCourseMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=182;
        this.ItemDetail.itemName='PackageCourse';
        this.ItemDetail.keyName='PackageCourseId';
    }

    CreateEntity(): PackageCourseEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): PackageCourseQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<PackageCourseEntity, PackageCourseMetaDataAttributes,PackageCourseMetaDataRelations>(query, this);
    }
     Attributes = new PackageCourseMetaDataAttributes();
     Relations = new PackageCourseMetaDataRelations();

}


export type PackageCourseQueryBuilder = DwQueryBuilderGen<PackageCourseEntity, PackageCourseMetaDataAttributes,PackageCourseMetaDataRelations>


export class PackageCourseMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'PackageCourse';
    // Attributes
    PackageCourseId = new DwItemAttribute(this.i, 'PackageCourseId');
    PackageId = new DwItemAttribute(this.i, 'PackageId');
    CourseId = new DwItemAttribute(this.i, 'CourseId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class PackageCourseMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Course */
            Course = new DwItemRelationship('Course|PackageCourse|CourseId', 'Course', 'Course');
            /** Relation: Package */
            Package = new DwItemRelationship('Package|PackageCourse|PackageId', 'Package', 'Package');
    };
export class PaymentEventMetaData implements DwItem2<PaymentEventEntity, PaymentEventMetaDataAttributes,PaymentEventMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=336;
        this.ItemDetail.itemName='PaymentEvent';
        this.ItemDetail.keyName='PaymentEventId';
    }

    CreateEntity(): PaymentEventEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): PaymentEventQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<PaymentEventEntity, PaymentEventMetaDataAttributes,PaymentEventMetaDataRelations>(query, this);
    }
     Attributes = new PaymentEventMetaDataAttributes();
     Relations = new PaymentEventMetaDataRelations();

}


export type PaymentEventQueryBuilder = DwQueryBuilderGen<PaymentEventEntity, PaymentEventMetaDataAttributes,PaymentEventMetaDataRelations>


export class PaymentEventMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'PaymentEvent';
    // Attributes
    PaymentEventId = new DwItemAttribute(this.i, 'PaymentEventId');
    PaymentEventSourceId = new DwItemAttribute(this.i, 'PaymentEventSourceId');
    PaymentEventTypeId = new DwItemAttribute(this.i, 'PaymentEventTypeId');
    PaymentEventStatusId = new DwItemAttribute(this.i, 'PaymentEventStatusId');
    PayloadJSON = new DwItemAttribute(this.i, 'PayloadJSON');
    EventSourceVersion = new DwItemAttribute(this.i, 'EventSourceVersion');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    PaymentEventDetailType = new DwItemAttribute(this.i, 'PaymentEventDetailType');
    LastErrorLogId = new DwItemAttribute(this.i, 'LastErrorLogId');
    PaymentEventKey = new DwItemAttribute(this.i, 'PaymentEventKey');
}

class PaymentEventMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Payment Event Source */
            PaymentEventSource = new DwItemRelationship('PaymentEventSource|PaymentEvent|PaymentEventSourceId', 'PaymentEventSource', 'PaymentEventSource');
            /** Relation: Payment Event Status */
            PaymentEventStatus = new DwItemRelationship('PaymentEventStatus|PaymentEvent|PaymentEventStatusId', 'PaymentEventStatus', 'PaymentEventStatus');
            /** Relation: Payment Event Type */
            PaymentEventType = new DwItemRelationship('PaymentEventType|PaymentEvent|PaymentEventTypeId', 'PaymentEventType', 'PaymentEventType');
            /** Relation: Stripe Checkout Session */
            StripeCheckoutSession = new DwItemRelationship('PaymentEvent|StripeCheckoutSession|PaymentEventId', 'StripeCheckoutSession', 'StripeCheckoutSession');
    };
export class PaymentEventSourceMetaData implements DwItem2<PaymentEventSourceEntity, PaymentEventSourceMetaDataAttributes,PaymentEventSourceMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=337;
        this.ItemDetail.itemName='PaymentEventSource';
        this.ItemDetail.keyName='PaymentEventSourceId';
    }

    CreateEntity(): PaymentEventSourceEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): PaymentEventSourceQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<PaymentEventSourceEntity, PaymentEventSourceMetaDataAttributes,PaymentEventSourceMetaDataRelations>(query, this);
    }
     Attributes = new PaymentEventSourceMetaDataAttributes();
     Relations = new PaymentEventSourceMetaDataRelations();

}


export type PaymentEventSourceQueryBuilder = DwQueryBuilderGen<PaymentEventSourceEntity, PaymentEventSourceMetaDataAttributes,PaymentEventSourceMetaDataRelations>


export class PaymentEventSourceMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'PaymentEventSource';
    // Attributes
    PaymentEventSourceId = new DwItemAttribute(this.i, 'PaymentEventSourceId');
    PaymentEventSource = new DwItemAttribute(this.i, 'PaymentEventSource');
}

class PaymentEventSourceMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Payment Event */
            PaymentEvent = new DwItemRelationship('PaymentEventSource|PaymentEvent|PaymentEventSourceId', 'PaymentEvent', 'PaymentEvent');
    };
export class PaymentEventStatusMetaData implements DwItem2<PaymentEventStatusEntity, PaymentEventStatusMetaDataAttributes,PaymentEventStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=335;
        this.ItemDetail.itemName='PaymentEventStatus';
        this.ItemDetail.keyName='PaymentEventStatusId';
    }

    CreateEntity(): PaymentEventStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): PaymentEventStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<PaymentEventStatusEntity, PaymentEventStatusMetaDataAttributes,PaymentEventStatusMetaDataRelations>(query, this);
    }
     Attributes = new PaymentEventStatusMetaDataAttributes();
     Relations = new PaymentEventStatusMetaDataRelations();

}


export type PaymentEventStatusQueryBuilder = DwQueryBuilderGen<PaymentEventStatusEntity, PaymentEventStatusMetaDataAttributes,PaymentEventStatusMetaDataRelations>


export class PaymentEventStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'PaymentEventStatus';
    // Attributes
    PaymentEventStatusId = new DwItemAttribute(this.i, 'PaymentEventStatusId');
    PaymentEventStatus = new DwItemAttribute(this.i, 'PaymentEventStatus');
}

class PaymentEventStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Payment Event */
            PaymentEvent = new DwItemRelationship('PaymentEventStatus|PaymentEvent|PaymentEventStatusId', 'PaymentEvent', 'PaymentEvent');
    };
export class PaymentEventTypeMetaData implements DwItem2<PaymentEventTypeEntity, PaymentEventTypeMetaDataAttributes,PaymentEventTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=338;
        this.ItemDetail.itemName='PaymentEventType';
        this.ItemDetail.keyName='PaymentEventTypeId';
    }

    CreateEntity(): PaymentEventTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): PaymentEventTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<PaymentEventTypeEntity, PaymentEventTypeMetaDataAttributes,PaymentEventTypeMetaDataRelations>(query, this);
    }
     Attributes = new PaymentEventTypeMetaDataAttributes();
     Relations = new PaymentEventTypeMetaDataRelations();

}


export type PaymentEventTypeQueryBuilder = DwQueryBuilderGen<PaymentEventTypeEntity, PaymentEventTypeMetaDataAttributes,PaymentEventTypeMetaDataRelations>


export class PaymentEventTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'PaymentEventType';
    // Attributes
    PaymentEventTypeId = new DwItemAttribute(this.i, 'PaymentEventTypeId');
    PaymentEventType = new DwItemAttribute(this.i, 'PaymentEventType');
}

class PaymentEventTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Payment Event */
            PaymentEvent = new DwItemRelationship('PaymentEventType|PaymentEvent|PaymentEventTypeId', 'PaymentEvent', 'PaymentEvent');
    };
export class PaymentMethodMetaData implements DwItem2<PaymentMethodEntity, PaymentMethodMetaDataAttributes,PaymentMethodMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=252;
        this.ItemDetail.itemName='PaymentMethod';
        this.ItemDetail.keyName='PaymentMethodId';
    }

    CreateEntity(): PaymentMethodEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): PaymentMethodQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<PaymentMethodEntity, PaymentMethodMetaDataAttributes,PaymentMethodMetaDataRelations>(query, this);
    }
     Attributes = new PaymentMethodMetaDataAttributes();
     Relations = new PaymentMethodMetaDataRelations();

}


export type PaymentMethodQueryBuilder = DwQueryBuilderGen<PaymentMethodEntity, PaymentMethodMetaDataAttributes,PaymentMethodMetaDataRelations>


export class PaymentMethodMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'PaymentMethod';
    // Attributes
    PaymentMethodId = new DwItemAttribute(this.i, 'PaymentMethodId');
    ProcessorConfigId = new DwItemAttribute(this.i, 'ProcessorConfigId');
    PaymentId = new DwItemAttribute(this.i, 'PaymentId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    IsDefault = new DwItemAttribute(this.i, 'IsDefault');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    ClientSecret = new DwItemAttribute(this.i, 'ClientSecret');
    SetupIntentId = new DwItemAttribute(this.i, 'SetupIntentId');
    BillingName = new DwItemAttribute(this.i, 'BillingName');
    BillingEmail = new DwItemAttribute(this.i, 'BillingEmail');
    DisplayName = new DwItemAttribute(this.i, 'DisplayName');
    BillingPostalCode = new DwItemAttribute(this.i, 'BillingPostalCode');
}

class PaymentMethodMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Processor Config */
            ProcessorConfig = new DwItemRelationship('ProcessorConfig|PaymentMethod|ProcessorConfigId', 'ProcessorConfig', 'ProcessorConfig');
            /** Relation: Invoice */
            Invoice = new DwItemRelationship('PaymentMethod|Invoice|PaymentMethodId', 'Invoice', 'Invoice');
    };
export class PaymentPartyTypeMetaData implements DwItem2<PaymentPartyTypeEntity, PaymentPartyTypeMetaDataAttributes,PaymentPartyTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=282;
        this.ItemDetail.itemName='PaymentPartyType';
        this.ItemDetail.keyName='PaymentPartyTypeId';
    }

    CreateEntity(): PaymentPartyTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): PaymentPartyTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<PaymentPartyTypeEntity, PaymentPartyTypeMetaDataAttributes,PaymentPartyTypeMetaDataRelations>(query, this);
    }
     Attributes = new PaymentPartyTypeMetaDataAttributes();
     Relations = new PaymentPartyTypeMetaDataRelations();

}


export type PaymentPartyTypeQueryBuilder = DwQueryBuilderGen<PaymentPartyTypeEntity, PaymentPartyTypeMetaDataAttributes,PaymentPartyTypeMetaDataRelations>


export class PaymentPartyTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'PaymentPartyType';
    // Attributes
    PaymentPartyTypeId = new DwItemAttribute(this.i, 'PaymentPartyTypeId');
    PaymentPartyType = new DwItemAttribute(this.i, 'PaymentPartyType');
}

class PaymentPartyTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Course Purchase */
            CoursePurchase = new DwItemRelationship('PaymentPartyType|CoursePurchase|PaymentPartyTypeId', 'CoursePurchase', 'CoursePurchase');
            /** Relation: Course Purchase Reservation */
            CoursePurchaseReservation = new DwItemRelationship('PaymentPartyType|CoursePurchaseReservation|PaymentPartyTypeId', 'CoursePurchaseReservation', 'CoursePurchaseReservation');
            /** Relation: Invoice */
            Invoice = new DwItemRelationship('PaymentPartyType|Invoice|PaymentPartyTypeId', 'Invoice', 'Invoice');
    };
export class PilotTypeMetaData implements DwItem2<PilotTypeEntity, PilotTypeMetaDataAttributes,PilotTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=414;
        this.ItemDetail.itemName='PilotType';
        this.ItemDetail.keyName='PilotTypeId';
    }

    CreateEntity(): PilotTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): PilotTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<PilotTypeEntity, PilotTypeMetaDataAttributes,PilotTypeMetaDataRelations>(query, this);
    }
     Attributes = new PilotTypeMetaDataAttributes();
     Relations = new PilotTypeMetaDataRelations();

}


export type PilotTypeQueryBuilder = DwQueryBuilderGen<PilotTypeEntity, PilotTypeMetaDataAttributes,PilotTypeMetaDataRelations>


export class PilotTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'PilotType';
    // Attributes
    PilotTypeId = new DwItemAttribute(this.i, 'PilotTypeId');
    PilotType = new DwItemAttribute(this.i, 'PilotType');
    Order = new DwItemAttribute(this.i, 'Order');
    RequireReferenceFields = new DwItemAttribute(this.i, 'RequireReferenceFields');
}

class PilotTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Student */
            Student = new DwItemRelationship('PilotType|Student|PilotTypeId', 'Student', 'Student');
    };
export class PostalCodeMetaData implements DwItem2<PostalCodeEntity, PostalCodeMetaDataAttributes,PostalCodeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=209;
        this.ItemDetail.itemName='PostalCode';
        this.ItemDetail.keyName='PostalCodeId';
    }

    CreateEntity(): PostalCodeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): PostalCodeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<PostalCodeEntity, PostalCodeMetaDataAttributes,PostalCodeMetaDataRelations>(query, this);
    }
     Attributes = new PostalCodeMetaDataAttributes();
     Relations = new PostalCodeMetaDataRelations();

}


export type PostalCodeQueryBuilder = DwQueryBuilderGen<PostalCodeEntity, PostalCodeMetaDataAttributes,PostalCodeMetaDataRelations>


export class PostalCodeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'PostalCode';
    // Attributes
    PostalCodeId = new DwItemAttribute(this.i, 'PostalCodeId');
    StateProvinceId = new DwItemAttribute(this.i, 'StateProvinceId');
    PostalCode = new DwItemAttribute(this.i, 'PostalCode');
    Plus4 = new DwItemAttribute(this.i, 'Plus4');
    City = new DwItemAttribute(this.i, 'City');
    County = new DwItemAttribute(this.i, 'County');
    AreaCode = new DwItemAttribute(this.i, 'AreaCode');
    Latitude = new DwItemAttribute(this.i, 'Latitude');
    Longitude = new DwItemAttribute(this.i, 'Longitude');
    GmtOffset = new DwItemAttribute(this.i, 'GmtOffset');
    ObservesDst = new DwItemAttribute(this.i, 'ObservesDst');
    IsMetropolitanArea = new DwItemAttribute(this.i, 'IsMetropolitanArea');
    TimeZoneId = new DwItemAttribute(this.i, 'TimeZoneId');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
}

class PostalCodeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: State Province */
            StateProvince = new DwItemRelationship('StateProvince|PostalCode|StateProvinceId', 'StateProvince', 'StateProvince');
            /** Relation: Time Zone - Timezone */
            TimeZoneByTimeZoneId = new DwItemRelationship('TimeZone|PostalCode|TimeZoneId', 'TimeZoneIdTimeZone', 'TimeZoneIdTimeZone');
    };
export class DwProcessDefinitionMetaData implements DwItem2<DwProcessDefinitionEntity, DwProcessDefinitionMetaDataAttributes,DwProcessDefinitionMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=109;
        this.ItemDetail.itemName='dw_ProcessDefinition';
        this.ItemDetail.keyName='ProcessDefinitionId';
    }

    CreateEntity(): DwProcessDefinitionEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwProcessDefinitionQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwProcessDefinitionEntity, DwProcessDefinitionMetaDataAttributes,DwProcessDefinitionMetaDataRelations>(query, this);
    }
     Attributes = new DwProcessDefinitionMetaDataAttributes();
     Relations = new DwProcessDefinitionMetaDataRelations();

}


export type DwProcessDefinitionQueryBuilder = DwQueryBuilderGen<DwProcessDefinitionEntity, DwProcessDefinitionMetaDataAttributes,DwProcessDefinitionMetaDataRelations>


export class DwProcessDefinitionMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_ProcessDefinition';
    // Attributes
    ConfigJSON = new DwItemAttribute(this.i, 'ConfigJSON');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    ProcessDefinitionId = new DwItemAttribute(this.i, 'ProcessDefinitionId');
    ProcessDescription = new DwItemAttribute(this.i, 'ProcessDescription');
    ProcessDisplay = new DwItemAttribute(this.i, 'ProcessDisplay');
    ProcessMeaning = new DwItemAttribute(this.i, 'ProcessMeaning');
    ProcessTypeId = new DwItemAttribute(this.i, 'ProcessTypeId');
}

class DwProcessDefinitionMetaDataRelations implements DwItemRelationshipCollection {
    };
export class ProcessorConfigMetaData implements DwItem2<ProcessorConfigEntity, ProcessorConfigMetaDataAttributes,ProcessorConfigMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=250;
        this.ItemDetail.itemName='ProcessorConfig';
        this.ItemDetail.keyName='ProcessorConfigId';
    }

    CreateEntity(): ProcessorConfigEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ProcessorConfigQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ProcessorConfigEntity, ProcessorConfigMetaDataAttributes,ProcessorConfigMetaDataRelations>(query, this);
    }
     Attributes = new ProcessorConfigMetaDataAttributes();
     Relations = new ProcessorConfigMetaDataRelations();

}


export type ProcessorConfigQueryBuilder = DwQueryBuilderGen<ProcessorConfigEntity, ProcessorConfigMetaDataAttributes,ProcessorConfigMetaDataRelations>


export class ProcessorConfigMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ProcessorConfig';
    // Attributes
    ProcessorConfigId = new DwItemAttribute(this.i, 'ProcessorConfigId');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    CustomerId = new DwItemAttribute(this.i, 'CustomerId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    UserId = new DwItemAttribute(this.i, 'UserId');
    PayoutAccountId = new DwItemAttribute(this.i, 'PayoutAccountId');
    DetailsSubmitted = new DwItemAttribute(this.i, 'DetailsSubmitted');
    ChargesEnabled = new DwItemAttribute(this.i, 'ChargesEnabled');
}

class ProcessorConfigMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School */
            FlightSchool = new DwItemRelationship('FlightSchool|ProcessorConfig|FlightSchoolId', 'FlightSchool', 'FlightSchool');
            /** Relation: User */
            DwUser = new DwItemRelationship('dw_User|ProcessorConfig|UserId', 'DwUser', 'DwUser');
            /** Relation: Payment Method */
            PaymentMethod = new DwItemRelationship('ProcessorConfig|PaymentMethod|ProcessorConfigId', 'PaymentMethod', 'PaymentMethod');
            /** Relation: Processor Config Customer History */
            ProcessorConfigCustomerHistory = new DwItemRelationship('ProcessorConfig|ProcessorConfigCustomerHistory|ProcessorConfigId', 'ProcessorConfigCustomerHistory', 'ProcessorConfigCustomerHistory');
            /** Relation: Ro School Payment Method */
            RoSchoolPaymentMethod = new DwItemRelationship('roSchoolPaymentMethod|ProcessConfig|ProcessorConfigId', 'RoSchoolPaymentMethod', 'RoSchoolPaymentMethod');
    };
export class ProcessorConfigCustomerHistoryMetaData implements DwItem2<ProcessorConfigCustomerHistoryEntity, ProcessorConfigCustomerHistoryMetaDataAttributes,ProcessorConfigCustomerHistoryMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=476;
        this.ItemDetail.itemName='ProcessorConfigCustomerHistory';
        this.ItemDetail.keyName='ProcessorConfigCustomerHistoryId';
    }

    CreateEntity(): ProcessorConfigCustomerHistoryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ProcessorConfigCustomerHistoryQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ProcessorConfigCustomerHistoryEntity, ProcessorConfigCustomerHistoryMetaDataAttributes,ProcessorConfigCustomerHistoryMetaDataRelations>(query, this);
    }
     Attributes = new ProcessorConfigCustomerHistoryMetaDataAttributes();
     Relations = new ProcessorConfigCustomerHistoryMetaDataRelations();

}


export type ProcessorConfigCustomerHistoryQueryBuilder = DwQueryBuilderGen<ProcessorConfigCustomerHistoryEntity, ProcessorConfigCustomerHistoryMetaDataAttributes,ProcessorConfigCustomerHistoryMetaDataRelations>


export class ProcessorConfigCustomerHistoryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ProcessorConfigCustomerHistory';
    // Attributes
    ProcessorConfigCustomerHistoryId = new DwItemAttribute(this.i, 'ProcessorConfigCustomerHistoryId');
    ProcessorConfigId = new DwItemAttribute(this.i, 'ProcessorConfigId');
    PreviousCustomerId = new DwItemAttribute(this.i, 'PreviousCustomerId');
    NewCustomerId = new DwItemAttribute(this.i, 'NewCustomerId');
    PaymentMethodsDeactivated = new DwItemAttribute(this.i, 'PaymentMethodsDeactivated');
    ChangedBy = new DwItemAttribute(this.i, 'ChangedBy');
    ChangedDateTime = new DwItemAttribute(this.i, 'ChangedDateTime');
}

class ProcessorConfigCustomerHistoryMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Processor Config */
            ProcessorConfig = new DwItemRelationship('ProcessorConfig|ProcessorConfigCustomerHistory|ProcessorConfigId', 'ProcessorConfig', 'ProcessorConfig');
            /** Relation: User - Changed By */
            DwUserByChangedBy = new DwItemRelationship('dw_User|ProcessorConfigCustomerHistory|ChangedBy', 'ChangedByDwUser', 'ChangedByDwUser');
    };
export class ProcessorLogMetaData implements DwItem2<ProcessorLogEntity, ProcessorLogMetaDataAttributes,ProcessorLogMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=258;
        this.ItemDetail.itemName='ProcessorLog';
        this.ItemDetail.keyName='ProcessorLogId';
    }

    CreateEntity(): ProcessorLogEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ProcessorLogQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ProcessorLogEntity, ProcessorLogMetaDataAttributes,ProcessorLogMetaDataRelations>(query, this);
    }
     Attributes = new ProcessorLogMetaDataAttributes();
     Relations = new ProcessorLogMetaDataRelations();

}


export type ProcessorLogQueryBuilder = DwQueryBuilderGen<ProcessorLogEntity, ProcessorLogMetaDataAttributes,ProcessorLogMetaDataRelations>


export class ProcessorLogMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ProcessorLog';
    // Attributes
    ProcessorLogId = new DwItemAttribute(this.i, 'ProcessorLogId');
    Severity = new DwItemAttribute(this.i, 'Severity');
    Item = new DwItemAttribute(this.i, 'Item');
    Activity = new DwItemAttribute(this.i, 'Activity');
    Description = new DwItemAttribute(this.i, 'Description');
    StripeErr = new DwItemAttribute(this.i, 'StripeErr');
    StripeErrDesc = new DwItemAttribute(this.i, 'StripeErrDesc');
    StripeErrCode = new DwItemAttribute(this.i, 'StripeErrCode');
    StripeErrMessage = new DwItemAttribute(this.i, 'StripeErrMessage');
    StripeErrType = new DwItemAttribute(this.i, 'StripeErrType');
    StripeErrDeclineCode = new DwItemAttribute(this.i, 'StripeErrDeclineCode');
    HttpCode = new DwItemAttribute(this.i, 'HttpCode');
    ProcessId1 = new DwItemAttribute(this.i, 'ProcessId1');
    ProcessId2 = new DwItemAttribute(this.i, 'ProcessId2');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class ProcessorLogMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Invoice Log */
            InvoiceLog = new DwItemRelationship('ProcessorLog|InvoiceLog|ProcessorLogId', 'InvoiceLog', 'InvoiceLog');
    };
export class ProductMetaData implements DwItem2<ProductEntity, ProductMetaDataAttributes,ProductMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=273;
        this.ItemDetail.itemName='Product';
        this.ItemDetail.keyName='ProductId';
    }

    CreateEntity(): ProductEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ProductQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ProductEntity, ProductMetaDataAttributes,ProductMetaDataRelations>(query, this);
    }
     Attributes = new ProductMetaDataAttributes();
     Relations = new ProductMetaDataRelations();

}


export type ProductQueryBuilder = DwQueryBuilderGen<ProductEntity, ProductMetaDataAttributes,ProductMetaDataRelations>


export class ProductMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Product';
    // Attributes
    ProductId = new DwItemAttribute(this.i, 'ProductId');
    CourseId = new DwItemAttribute(this.i, 'CourseId');
    PackageId = new DwItemAttribute(this.i, 'PackageId');
    SubscriptionTierId = new DwItemAttribute(this.i, 'SubscriptionTierId');
    RetailPrice = new DwItemAttribute(this.i, 'RetailPrice');
    StripeProductId = new DwItemAttribute(this.i, 'StripeProductId');
    StripPriceId = new DwItemAttribute(this.i, 'StripPriceId');
    ProductTypeId = new DwItemAttribute(this.i, 'ProductTypeId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    StripPaymentLinkId = new DwItemAttribute(this.i, 'StripPaymentLinkId');
    StripePaymentLinkUrl = new DwItemAttribute(this.i, 'StripePaymentLinkUrl');
}

class ProductMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Course */
            Course = new DwItemRelationship('Course|Product|CourseId', 'Course', 'Course');
            /** Relation: Package */
            Package = new DwItemRelationship('Package|Product|PackageId', 'Package', 'Package');
            /** Relation: Product Type */
            ProductType = new DwItemRelationship('ProductType|Product|ProductTypeId', 'ProductType', 'ProductType');
            /** Relation: Subscription Tier */
            SubscriptionTier = new DwItemRelationship('SubscriptionTier|Product|SubscriptionTierId', 'SubscriptionTier', 'SubscriptionTier');
            /** Relation: Invoice Line */
            InvoiceLine = new DwItemRelationship('Product|InvoiceLine|ProductId', 'InvoiceLine', 'InvoiceLine');
            /** Relation: Join Request Course Purchase */
            JoinRequestCoursePurchase = new DwItemRelationship('Product|JoinRequestCoursePurchase|ProductId', 'JoinRequestCoursePurchase', 'JoinRequestCoursePurchase');
            /** Relation: Product Payment Link */
            ProductPaymentLink = new DwItemRelationship('Product|ProductPaymentLink|ProductId', 'ProductPaymentLink', 'ProductPaymentLink');
            /** Relation: Profit Share */
            ProfitShare = new DwItemRelationship('Product|ProfitShare|ProductId', 'ProfitShare', 'ProfitShare');
            /** Relation: Ro Product */
            RoProduct = new DwItemRelationship('Product|roProduct|ProductId', 'RoProduct', 'RoProduct');
            /** Relation: Stripe Checkout Session Product */
            StripeCheckoutSessionProduct = new DwItemRelationship('Product|StripeCheckoutSessionProduct|ProductId', 'StripeCheckoutSessionProduct', 'StripeCheckoutSessionProduct');
    };
export class ProductPaymentLinkMetaData implements DwItem2<ProductPaymentLinkEntity, ProductPaymentLinkMetaDataAttributes,ProductPaymentLinkMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=368;
        this.ItemDetail.itemName='ProductPaymentLink';
        this.ItemDetail.keyName='ProductPaymentLinkId';
    }

    CreateEntity(): ProductPaymentLinkEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ProductPaymentLinkQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ProductPaymentLinkEntity, ProductPaymentLinkMetaDataAttributes,ProductPaymentLinkMetaDataRelations>(query, this);
    }
     Attributes = new ProductPaymentLinkMetaDataAttributes();
     Relations = new ProductPaymentLinkMetaDataRelations();

}


export type ProductPaymentLinkQueryBuilder = DwQueryBuilderGen<ProductPaymentLinkEntity, ProductPaymentLinkMetaDataAttributes,ProductPaymentLinkMetaDataRelations>


export class ProductPaymentLinkMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ProductPaymentLink';
    // Attributes
    ProductPaymentLinkId = new DwItemAttribute(this.i, 'ProductPaymentLinkId');
    ProductId = new DwItemAttribute(this.i, 'ProductId');
    StripePriceId = new DwItemAttribute(this.i, 'StripePriceId');
    StripePaymentLinkId = new DwItemAttribute(this.i, 'StripePaymentLinkId');
    StripePaymentLinkUrl = new DwItemAttribute(this.i, 'StripePaymentLinkUrl');
    ProductRetailPrice = new DwItemAttribute(this.i, 'ProductRetailPrice');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    StripeConfirmationUrl = new DwItemAttribute(this.i, 'StripeConfirmationUrl');
}

class ProductPaymentLinkMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Product */
            Product = new DwItemRelationship('Product|ProductPaymentLink|ProductId', 'Product', 'Product');
    };
export class ProductTypeMetaData implements DwItem2<ProductTypeEntity, ProductTypeMetaDataAttributes,ProductTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=279;
        this.ItemDetail.itemName='ProductType';
        this.ItemDetail.keyName='ProductTypeId';
    }

    CreateEntity(): ProductTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ProductTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ProductTypeEntity, ProductTypeMetaDataAttributes,ProductTypeMetaDataRelations>(query, this);
    }
     Attributes = new ProductTypeMetaDataAttributes();
     Relations = new ProductTypeMetaDataRelations();

}


export type ProductTypeQueryBuilder = DwQueryBuilderGen<ProductTypeEntity, ProductTypeMetaDataAttributes,ProductTypeMetaDataRelations>


export class ProductTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ProductType';
    // Attributes
    ProductTypeId = new DwItemAttribute(this.i, 'ProductTypeId');
    ProductType = new DwItemAttribute(this.i, 'ProductType');
}

class ProductTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Product */
            Product = new DwItemRelationship('ProductType|Product|ProductTypeId', 'Product', 'Product');
    };
export class ProfitShareMetaData implements DwItem2<ProfitShareEntity, ProfitShareMetaDataAttributes,ProfitShareMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=290;
        this.ItemDetail.itemName='ProfitShare';
        this.ItemDetail.keyName='ProfitShareId';
    }

    CreateEntity(): ProfitShareEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ProfitShareQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ProfitShareEntity, ProfitShareMetaDataAttributes,ProfitShareMetaDataRelations>(query, this);
    }
     Attributes = new ProfitShareMetaDataAttributes();
     Relations = new ProfitShareMetaDataRelations();

}


export type ProfitShareQueryBuilder = DwQueryBuilderGen<ProfitShareEntity, ProfitShareMetaDataAttributes,ProfitShareMetaDataRelations>


export class ProfitShareMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ProfitShare';
    // Attributes
    ProfitShareId = new DwItemAttribute(this.i, 'ProfitShareId');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    StudentId = new DwItemAttribute(this.i, 'StudentId');
    RetailPrice = new DwItemAttribute(this.i, 'RetailPrice');
    ProfitSharingPercentage = new DwItemAttribute(this.i, 'ProfitSharingPercentage');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    ProfitSharingAmount = new DwItemAttribute(this.i, 'ProfitSharingAmount');
    AffiliateUserId = new DwItemAttribute(this.i, 'AffiliateUserId');
    ProductId = new DwItemAttribute(this.i, 'ProductId');
    InvoiceLineId = new DwItemAttribute(this.i, 'InvoiceLineId');
    ProfitShareStatusId = new DwItemAttribute(this.i, 'ProfitShareStatusId');
    ProfitShareTypeId = new DwItemAttribute(this.i, 'ProfitShareTypeId');
    PaymentPartyTypeId = new DwItemAttribute(this.i, 'PaymentPartyTypeId');
    PaymentInvoiceLineId = new DwItemAttribute(this.i, 'PaymentInvoiceLineId');
    JoinRequestEmailId = new DwItemAttribute(this.i, 'JoinRequestEmailId');
}

class ProfitShareMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School */
            FlightSchool = new DwItemRelationship('FlightSchool|ProfitShare|FlightSchoolId', 'FlightSchool', 'FlightSchool');
            /** Relation: Invoice Line */
            InvoiceLine = new DwItemRelationship('InvoiceLine|ProfitShare|InvoiceLineId', 'InvoiceLine', 'InvoiceLine');
            /** Relation: Join Request Email */
            JoinRequestEmail = new DwItemRelationship('JoinRequestEmail|ProfitShare|JoinRequestEmailId', 'JoinRequestEmail', 'JoinRequestEmail');
            /** Relation: Product */
            Product = new DwItemRelationship('Product|ProfitShare|ProductId', 'Product', 'Product');
            /** Relation: Ro Product */
            RoProductByProductId = new DwItemRelationship('ProfitShare|roProduct|ProductId', 'RoProductProductId', 'RoProductProductId');
            /** Relation: Profit Share Status */
            ProfitShareStatus = new DwItemRelationship('ProfitShareStatus|ProfitShare|StatusId', 'ProfitShareStatus', 'ProfitShareStatus');
            /** Relation: Profit Share Type */
            ProfitShareType = new DwItemRelationship('ProfitShareType|ProfitShare|TypeId', 'ProfitShareType', 'ProfitShareType');
            /** Relation: Student */
            Student = new DwItemRelationship('Student|ProfitShare|StudentId', 'Student', 'Student');
            /** Relation: User - Affiliate User */
            DwUserByAffiliateUserId = new DwItemRelationship('dw_User|ProfitShare|AffiliateUserId', 'AffiliateDwUser', 'AffiliateDwUser');
    };
export class ProfitShareStatusMetaData implements DwItem2<ProfitShareStatusEntity, ProfitShareStatusMetaDataAttributes,ProfitShareStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=291;
        this.ItemDetail.itemName='ProfitShareStatus';
        this.ItemDetail.keyName='ProfitShareStatusId';
    }

    CreateEntity(): ProfitShareStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ProfitShareStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ProfitShareStatusEntity, ProfitShareStatusMetaDataAttributes,ProfitShareStatusMetaDataRelations>(query, this);
    }
     Attributes = new ProfitShareStatusMetaDataAttributes();
     Relations = new ProfitShareStatusMetaDataRelations();

}


export type ProfitShareStatusQueryBuilder = DwQueryBuilderGen<ProfitShareStatusEntity, ProfitShareStatusMetaDataAttributes,ProfitShareStatusMetaDataRelations>


export class ProfitShareStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ProfitShareStatus';
    // Attributes
    ProfitShareStatusId = new DwItemAttribute(this.i, 'ProfitShareStatusId');
    ProfitShareStatus = new DwItemAttribute(this.i, 'ProfitShareStatus');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class ProfitShareStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Profit Share */
            ProfitShare = new DwItemRelationship('ProfitShareStatus|ProfitShare|StatusId', 'ProfitShare', 'ProfitShare');
    };
export class ProfitShareTypeMetaData implements DwItem2<ProfitShareTypeEntity, ProfitShareTypeMetaDataAttributes,ProfitShareTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=292;
        this.ItemDetail.itemName='ProfitShareType';
        this.ItemDetail.keyName='ProfitShareTypeId';
    }

    CreateEntity(): ProfitShareTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ProfitShareTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ProfitShareTypeEntity, ProfitShareTypeMetaDataAttributes,ProfitShareTypeMetaDataRelations>(query, this);
    }
     Attributes = new ProfitShareTypeMetaDataAttributes();
     Relations = new ProfitShareTypeMetaDataRelations();

}


export type ProfitShareTypeQueryBuilder = DwQueryBuilderGen<ProfitShareTypeEntity, ProfitShareTypeMetaDataAttributes,ProfitShareTypeMetaDataRelations>


export class ProfitShareTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ProfitShareType';
    // Attributes
    ProfitShareTypeId = new DwItemAttribute(this.i, 'ProfitShareTypeId');
    ProfitShareType = new DwItemAttribute(this.i, 'ProfitShareType');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class ProfitShareTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Profit Share */
            ProfitShare = new DwItemRelationship('ProfitShareType|ProfitShare|TypeId', 'ProfitShare', 'ProfitShare');
    };
export class ProgramTypeMetaData implements DwItem2<ProgramTypeEntity, ProgramTypeMetaDataAttributes,ProgramTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=147;
        this.ItemDetail.itemName='ProgramType';
        this.ItemDetail.keyName='ProgramTypeId';
    }

    CreateEntity(): ProgramTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ProgramTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ProgramTypeEntity, ProgramTypeMetaDataAttributes,ProgramTypeMetaDataRelations>(query, this);
    }
     Attributes = new ProgramTypeMetaDataAttributes();
     Relations = new ProgramTypeMetaDataRelations();

}


export type ProgramTypeQueryBuilder = DwQueryBuilderGen<ProgramTypeEntity, ProgramTypeMetaDataAttributes,ProgramTypeMetaDataRelations>


export class ProgramTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ProgramType';
    // Attributes
    ProgramTypeId = new DwItemAttribute(this.i, 'ProgramTypeId');
    ProgramType = new DwItemAttribute(this.i, 'ProgramType');
    ProgramTypeDescription = new DwItemAttribute(this.i, 'ProgramTypeDescription');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class ProgramTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Course */
            Course = new DwItemRelationship('ProgramType|Course|ProgramTypeId', 'Course', 'Course');
    };
export class QuestionMetaData implements DwItem2<QuestionEntity, QuestionMetaDataAttributes,QuestionMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=138;
        this.ItemDetail.itemName='Question';
        this.ItemDetail.keyName='QuestionId';
    }

    CreateEntity(): QuestionEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): QuestionQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<QuestionEntity, QuestionMetaDataAttributes,QuestionMetaDataRelations>(query, this);
    }
     Attributes = new QuestionMetaDataAttributes();
     Relations = new QuestionMetaDataRelations();

}


export type QuestionQueryBuilder = DwQueryBuilderGen<QuestionEntity, QuestionMetaDataAttributes,QuestionMetaDataRelations>


export class QuestionMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Question';
    // Attributes
    QuestionName = new DwItemAttribute(this.i, 'QuestionName');
    Question = new DwItemAttribute(this.i, 'Question');
    QuestionImageMediaId = new DwItemAttribute(this.i, 'QuestionImageMediaId');
    CorrectAnswer = new DwItemAttribute(this.i, 'CorrectAnswer');
    CorrectAnswerNotes = new DwItemAttribute(this.i, 'CorrectAnswerNotes');
    CorrectAnswerImageMediaId = new DwItemAttribute(this.i, 'CorrectAnswerImageMediaId');
    QuestionTypeId = new DwItemAttribute(this.i, 'QuestionTypeId');
    QuestionId = new DwItemAttribute(this.i, 'QuestionId');
    UseRandomOrder = new DwItemAttribute(this.i, 'UseRandomOrder');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    CourseId = new DwItemAttribute(this.i, 'CourseId');
    CourseModuleId = new DwItemAttribute(this.i, 'CourseModuleId');
    QuestionStatusId = new DwItemAttribute(this.i, 'QuestionStatusId');
    QuestionAIProcessingStatusId = new DwItemAttribute(this.i, 'QuestionAIProcessingStatusId');
}

class QuestionMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Course */
            Course = new DwItemRelationship('Course|Question|CourseId', 'Course', 'Course');
            /** Relation: Module */
            CourseModule = new DwItemRelationship('CourseModule|Question|CourseModuleId', 'CourseModule', 'CourseModule');
            /** Relation: Ro Media - Question Image Media */
            DwRoMediaByQuestionImageMediaId = new DwItemRelationship('Question|RoMedia|QuestionImageMediaId', 'QuestionImageDwroMedia', 'QuestionImageDwroMedia');
            /** Relation: Ro Media - Correct Answer Image Media */
            DwRoMediaByCorrectAnswerImageMediaId = new DwItemRelationship('Question|RoMedia|CorrectAnswerImageMediaId', 'CorrectAnswerImageDwroMedia', 'CorrectAnswerImageDwroMedia');
            /** Relation: Question AI Processing Status */
            QuestionAIProcessingStatus = new DwItemRelationship('QuestionAIProcessingStatus|Question|QuestionAIProcessingStatusId', 'QuestionAIProcessingStatus', 'QuestionAIProcessingStatus');
            /** Relation: Question Status */
            QuestionStatus = new DwItemRelationship('QuestionStatus|Question|QuestionStatusId', 'QuestionStatus', 'QuestionStatus');
            /** Relation: Question Type */
            QuestionType = new DwItemRelationship('QuestionType|QuizQuestion|QuestionTypeId', 'QuestionType', 'QuestionType');
            /** Relation: Course Lesson Flag */
            CourseLessonFlag = new DwItemRelationship('Question|CourseLessonFlag|QuestionId', 'CourseLessonFlag', 'CourseLessonFlag');
            /** Relation: Question Answer */
            QuestionAnswer = new DwItemRelationship('Question|QuestionAnswer|QuestionId', 'QuestionAnswer', 'QuestionAnswer');
            /** Relation: Question Tag Link */
            QuestionTagLink = new DwItemRelationship('Question|QuestionTagLink|QuestionId', 'QuestionTagLink', 'QuestionTagLink');
            /** Relation: Quiz Question Link */
            QuizQuestionLink = new DwItemRelationship('Question|QuizQuestionLink|QuestionId', 'QuizQuestionLink', 'QuizQuestionLink');
            /** Relation: Quiz Result Question */
            QuizResultQuestion = new DwItemRelationship('Question|QuizResultQuestion|QuestionId', 'QuizResultQuestion', 'QuizResultQuestion');
    };
export class QuestionNotUsedMetaData implements DwItem2<QuestionNotUsedEntity, QuestionNotUsedMetaDataAttributes,QuestionNotUsedMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=168;
        this.ItemDetail.itemName='Question_NotUsed';
        this.ItemDetail.keyName='QuizQuestionId';
    }

    CreateEntity(): QuestionNotUsedEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): QuestionNotUsedQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<QuestionNotUsedEntity, QuestionNotUsedMetaDataAttributes,QuestionNotUsedMetaDataRelations>(query, this);
    }
     Attributes = new QuestionNotUsedMetaDataAttributes();
     Relations = new QuestionNotUsedMetaDataRelations();

}


export type QuestionNotUsedQueryBuilder = DwQueryBuilderGen<QuestionNotUsedEntity, QuestionNotUsedMetaDataAttributes,QuestionNotUsedMetaDataRelations>


export class QuestionNotUsedMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Question_NotUsed';
    // Attributes
    QuizQuestionId = new DwItemAttribute(this.i, 'QuizQuestionId');
    QuestionName = new DwItemAttribute(this.i, 'QuestionName');
    Question = new DwItemAttribute(this.i, 'Question');
    QuestionImageMediaId = new DwItemAttribute(this.i, 'QuestionImageMediaId');
    QuestionOrder = new DwItemAttribute(this.i, 'QuestionOrder');
    QuestionTypeId = new DwItemAttribute(this.i, 'QuestionTypeId');
    CorrectAnswer = new DwItemAttribute(this.i, 'CorrectAnswer');
    CorrectAnswerNotes = new DwItemAttribute(this.i, 'CorrectAnswerNotes');
    CorrectAnswerImageMediaId = new DwItemAttribute(this.i, 'CorrectAnswerImageMediaId');
    QuestionWeight = new DwItemAttribute(this.i, 'QuestionWeight');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class QuestionNotUsedMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Quiz Question Answer Not Used */
            QuizQuestionAnswerNotUsed = new DwItemRelationship('QuizQuestion|QuizQuestionAnswer|QuizQuestionId', 'QuizQuestionAnswerNotUsed', 'QuizQuestionAnswerNotUsed');
    };
export class QuestionAIProcessingStatusMetaData implements DwItem2<QuestionAIProcessingStatusEntity, QuestionAIProcessingStatusMetaDataAttributes,QuestionAIProcessingStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=371;
        this.ItemDetail.itemName='QuestionAIProcessingStatus';
        this.ItemDetail.keyName='QuestionAIProcessingStatusId';
    }

    CreateEntity(): QuestionAIProcessingStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): QuestionAIProcessingStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<QuestionAIProcessingStatusEntity, QuestionAIProcessingStatusMetaDataAttributes,QuestionAIProcessingStatusMetaDataRelations>(query, this);
    }
     Attributes = new QuestionAIProcessingStatusMetaDataAttributes();
     Relations = new QuestionAIProcessingStatusMetaDataRelations();

}


export type QuestionAIProcessingStatusQueryBuilder = DwQueryBuilderGen<QuestionAIProcessingStatusEntity, QuestionAIProcessingStatusMetaDataAttributes,QuestionAIProcessingStatusMetaDataRelations>


export class QuestionAIProcessingStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'QuestionAIProcessingStatus';
    // Attributes
    QuestionAIProcessingStatusId = new DwItemAttribute(this.i, 'QuestionAIProcessingStatusId');
    QuestionAIProcessingStatus = new DwItemAttribute(this.i, 'QuestionAIProcessingStatus');
}

class QuestionAIProcessingStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Question */
            Question = new DwItemRelationship('QuestionAIProcessingStatus|Question|QuestionAIProcessingStatusId', 'Question', 'Question');
    };
export class QuestionAnswerMetaData implements DwItem2<QuestionAnswerEntity, QuestionAnswerMetaDataAttributes,QuestionAnswerMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=172;
        this.ItemDetail.itemName='QuestionAnswer';
        this.ItemDetail.keyName='QuestionAnswerId';
    }

    CreateEntity(): QuestionAnswerEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): QuestionAnswerQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<QuestionAnswerEntity, QuestionAnswerMetaDataAttributes,QuestionAnswerMetaDataRelations>(query, this);
    }
     Attributes = new QuestionAnswerMetaDataAttributes();
     Relations = new QuestionAnswerMetaDataRelations();

}


export type QuestionAnswerQueryBuilder = DwQueryBuilderGen<QuestionAnswerEntity, QuestionAnswerMetaDataAttributes,QuestionAnswerMetaDataRelations>


export class QuestionAnswerMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'QuestionAnswer';
    // Attributes
    QuestionAnswerId = new DwItemAttribute(this.i, 'QuestionAnswerId');
    QuestionId = new DwItemAttribute(this.i, 'QuestionId');
    AnswerText = new DwItemAttribute(this.i, 'AnswerText');
    AnswerImageMediaId = new DwItemAttribute(this.i, 'AnswerImageMediaId');
    IsCorrectAnswer = new DwItemAttribute(this.i, 'IsCorrectAnswer');
    ExplanationText = new DwItemAttribute(this.i, 'ExplanationText');
    AnswerOrder = new DwItemAttribute(this.i, 'AnswerOrder');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class QuestionAnswerMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Question */
            Question = new DwItemRelationship('Question|QuestionAnswer|QuestionId', 'Question', 'Question');
            /** Relation: Question Answer AI Explanation */
            QuestionAnswerAIExplanation = new DwItemRelationship('QuestionAnswer|QuestionAnswerAIExplanation|QuestionAnswerId', 'QuestionAnswerAIExplanation', 'QuestionAnswerAIExplanation');
            /** Relation: Quiz Result Question */
            QuizResultQuestion = new DwItemRelationship('QuestionAnswer|QuizResultQuestion|QuestionAnswerId', 'QuizResultQuestion', 'QuizResultQuestion');
    };
export class QuestionAnswerAIExplanationMetaData implements DwItem2<QuestionAnswerAIExplanationEntity, QuestionAnswerAIExplanationMetaDataAttributes,QuestionAnswerAIExplanationMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=370;
        this.ItemDetail.itemName='QuestionAnswerAIExplanation';
        this.ItemDetail.keyName='QuestionAnswerAIExplanationId';
    }

    CreateEntity(): QuestionAnswerAIExplanationEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): QuestionAnswerAIExplanationQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<QuestionAnswerAIExplanationEntity, QuestionAnswerAIExplanationMetaDataAttributes,QuestionAnswerAIExplanationMetaDataRelations>(query, this);
    }
     Attributes = new QuestionAnswerAIExplanationMetaDataAttributes();
     Relations = new QuestionAnswerAIExplanationMetaDataRelations();

}


export type QuestionAnswerAIExplanationQueryBuilder = DwQueryBuilderGen<QuestionAnswerAIExplanationEntity, QuestionAnswerAIExplanationMetaDataAttributes,QuestionAnswerAIExplanationMetaDataRelations>


export class QuestionAnswerAIExplanationMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'QuestionAnswerAIExplanation';
    // Attributes
    QuestionAnswerAIExplanationId = new DwItemAttribute(this.i, 'QuestionAnswerAIExplanationId');
    QuestionAnswerId = new DwItemAttribute(this.i, 'QuestionAnswerId');
    ExplanationHtml = new DwItemAttribute(this.i, 'ExplanationHtml');
}

class QuestionAnswerAIExplanationMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Question Answer */
            QuestionAnswer = new DwItemRelationship('QuestionAnswer|QuestionAnswerAIExplanation|QuestionAnswerId', 'QuestionAnswer', 'QuestionAnswer');
    };
export class QuestionImportCharacterConversionMetaData implements DwItem2<QuestionImportCharacterConversionEntity, QuestionImportCharacterConversionMetaDataAttributes,QuestionImportCharacterConversionMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=210;
        this.ItemDetail.itemName='QuestionImportCharacterConversion';
        this.ItemDetail.keyName='QuestionImportCharacterConversionId';
    }

    CreateEntity(): QuestionImportCharacterConversionEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): QuestionImportCharacterConversionQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<QuestionImportCharacterConversionEntity, QuestionImportCharacterConversionMetaDataAttributes,QuestionImportCharacterConversionMetaDataRelations>(query, this);
    }
     Attributes = new QuestionImportCharacterConversionMetaDataAttributes();
     Relations = new QuestionImportCharacterConversionMetaDataRelations();

}


export type QuestionImportCharacterConversionQueryBuilder = DwQueryBuilderGen<QuestionImportCharacterConversionEntity, QuestionImportCharacterConversionMetaDataAttributes,QuestionImportCharacterConversionMetaDataRelations>


export class QuestionImportCharacterConversionMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'QuestionImportCharacterConversion';
    // Attributes
    QuestionImportCharacterConversionId = new DwItemAttribute(this.i, 'QuestionImportCharacterConversionId');
    AsciiValue = new DwItemAttribute(this.i, 'AsciiValue');
    RemoveValue = new DwItemAttribute(this.i, 'RemoveValue');
    ReplacementValue = new DwItemAttribute(this.i, 'ReplacementValue');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class QuestionImportCharacterConversionMetaDataRelations implements DwItemRelationshipCollection {
    };
export class QuestionStatusMetaData implements DwItem2<QuestionStatusEntity, QuestionStatusMetaDataAttributes,QuestionStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=184;
        this.ItemDetail.itemName='QuestionStatus';
        this.ItemDetail.keyName='QuestionStatusId';
    }

    CreateEntity(): QuestionStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): QuestionStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<QuestionStatusEntity, QuestionStatusMetaDataAttributes,QuestionStatusMetaDataRelations>(query, this);
    }
     Attributes = new QuestionStatusMetaDataAttributes();
     Relations = new QuestionStatusMetaDataRelations();

}


export type QuestionStatusQueryBuilder = DwQueryBuilderGen<QuestionStatusEntity, QuestionStatusMetaDataAttributes,QuestionStatusMetaDataRelations>


export class QuestionStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'QuestionStatus';
    // Attributes
    QuestionStatusId = new DwItemAttribute(this.i, 'QuestionStatusId');
    QuestionStatus = new DwItemAttribute(this.i, 'QuestionStatus');
}

class QuestionStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Question */
            Question = new DwItemRelationship('QuestionStatus|Question|QuestionStatusId', 'Question', 'Question');
    };
export class QuestionTagMetaData implements DwItem2<QuestionTagEntity, QuestionTagMetaDataAttributes,QuestionTagMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=169;
        this.ItemDetail.itemName='QuestionTag';
        this.ItemDetail.keyName='QuestionTagId';
    }

    CreateEntity(): QuestionTagEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): QuestionTagQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<QuestionTagEntity, QuestionTagMetaDataAttributes,QuestionTagMetaDataRelations>(query, this);
    }
     Attributes = new QuestionTagMetaDataAttributes();
     Relations = new QuestionTagMetaDataRelations();

}


export type QuestionTagQueryBuilder = DwQueryBuilderGen<QuestionTagEntity, QuestionTagMetaDataAttributes,QuestionTagMetaDataRelations>


export class QuestionTagMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'QuestionTag';
    // Attributes
    QuestionTagId = new DwItemAttribute(this.i, 'QuestionTagId');
    TagName = new DwItemAttribute(this.i, 'TagName');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class QuestionTagMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Question Tag Link */
            QuestionTagLink = new DwItemRelationship('QuestionTag|QuestionTagLink|QuestionTagId', 'QuestionTagLink', 'QuestionTagLink');
            /** Relation: Video Tag Link - Tag - Many */
            VideoTagLinkByTagId = new DwItemRelationship('QuestionTag|VideoTagLink|TagId', 'TagIdVideoTagLink', 'TagIdVideoTagLink');
    };
export class QuestionTagLinkMetaData implements DwItem2<QuestionTagLinkEntity, QuestionTagLinkMetaDataAttributes,QuestionTagLinkMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=170;
        this.ItemDetail.itemName='QuestionTagLink';
        this.ItemDetail.keyName='QuestionTagLinkd';
    }

    CreateEntity(): QuestionTagLinkEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): QuestionTagLinkQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<QuestionTagLinkEntity, QuestionTagLinkMetaDataAttributes,QuestionTagLinkMetaDataRelations>(query, this);
    }
     Attributes = new QuestionTagLinkMetaDataAttributes();
     Relations = new QuestionTagLinkMetaDataRelations();

}


export type QuestionTagLinkQueryBuilder = DwQueryBuilderGen<QuestionTagLinkEntity, QuestionTagLinkMetaDataAttributes,QuestionTagLinkMetaDataRelations>


export class QuestionTagLinkMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'QuestionTagLink';
    // Attributes
    QuestionTagLinkd = new DwItemAttribute(this.i, 'QuestionTagLinkd');
    QuestionId = new DwItemAttribute(this.i, 'QuestionId');
    QuestionTagId = new DwItemAttribute(this.i, 'QuestionTagId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class QuestionTagLinkMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Question */
            Question = new DwItemRelationship('Question|QuestionTagLink|QuestionId', 'Question', 'Question');
            /** Relation: Tag */
            QuestionTag = new DwItemRelationship('QuestionTag|QuestionTagLink|QuestionTagId', 'QuestionTag', 'QuestionTag');
    };
export class QuestionTypeMetaData implements DwItem2<QuestionTypeEntity, QuestionTypeMetaDataAttributes,QuestionTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=163;
        this.ItemDetail.itemName='QuestionType';
        this.ItemDetail.keyName='QuestionTypeId';
    }

    CreateEntity(): QuestionTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): QuestionTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<QuestionTypeEntity, QuestionTypeMetaDataAttributes,QuestionTypeMetaDataRelations>(query, this);
    }
     Attributes = new QuestionTypeMetaDataAttributes();
     Relations = new QuestionTypeMetaDataRelations();

}


export type QuestionTypeQueryBuilder = DwQueryBuilderGen<QuestionTypeEntity, QuestionTypeMetaDataAttributes,QuestionTypeMetaDataRelations>


export class QuestionTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'QuestionType';
    // Attributes
    QuestionTypeId = new DwItemAttribute(this.i, 'QuestionTypeId');
    QuestionType = new DwItemAttribute(this.i, 'QuestionType');
    ConfigureAnswers = new DwItemAttribute(this.i, 'ConfigureAnswers');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class QuestionTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Question */
            Question = new DwItemRelationship('QuestionType|QuizQuestion|QuestionTypeId', 'Question', 'Question');
    };
export class QuizMetaData implements DwItem2<QuizEntity, QuizMetaDataAttributes,QuizMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=137;
        this.ItemDetail.itemName='Quiz';
        this.ItemDetail.keyName='QuizId';
    }

    CreateEntity(): QuizEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): QuizQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<QuizEntity, QuizMetaDataAttributes,QuizMetaDataRelations>(query, this);
    }
     Attributes = new QuizMetaDataAttributes();
     Relations = new QuizMetaDataRelations();

}


export type QuizQueryBuilder = DwQueryBuilderGen<QuizEntity, QuizMetaDataAttributes,QuizMetaDataRelations>


export class QuizMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Quiz';
    // Attributes
    QuizId = new DwItemAttribute(this.i, 'QuizId');
    QuizName = new DwItemAttribute(this.i, 'QuizName');
    QuizTypeId = new DwItemAttribute(this.i, 'QuizTypeId');
    UseRandomOrder = new DwItemAttribute(this.i, 'UseRandomOrder');
    MaxQuestionsToShow = new DwItemAttribute(this.i, 'MaxQuestionsToShow');
    TimeLimitMinutes = new DwItemAttribute(this.i, 'TimeLimitMinutes');
    MaxAttempts = new DwItemAttribute(this.i, 'MaxAttempts');
    PassingPercent = new DwItemAttribute(this.i, 'PassingPercent');
    ShowAnswersOnFail = new DwItemAttribute(this.i, 'ShowAnswersOnFail');
    ShowAnswersOnPass = new DwItemAttribute(this.i, 'ShowAnswersOnPass');
    UseWeightedAnswers = new DwItemAttribute(this.i, 'UseWeightedAnswers');
    QuizDescription = new DwItemAttribute(this.i, 'QuizDescription');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    QuizStatusId = new DwItemAttribute(this.i, 'QuizStatusId');
}

class QuizMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Quiz Type */
            QuizType = new DwItemRelationship('QuizType|Quiz|QuizTypeId', 'QuizType', 'QuizType');
            /** Relation: Reference Status - Quiz Status */
            ReferenceStatusByQuizStatusId = new DwItemRelationship('ReferenceStatus|Quiz|QuizStatusId', 'QuizStatusIdReferenceStatus', 'QuizStatusIdReferenceStatus');
            /** Relation: Lesson */
            CourseLesson = new DwItemRelationship('Quiz|CourseLesson|QuizId', 'CourseLesson', 'CourseLesson');
            /** Relation: Course Lesson Flag */
            CourseLessonFlag = new DwItemRelationship('Quiz|CourseLessonFlag|QuizId', 'CourseLessonFlag', 'CourseLessonFlag');
            /** Relation: Quiz Question Link */
            QuizQuestionLink = new DwItemRelationship('Quiz|QuizQuestionLink|QuizId', 'QuizQuestionLink', 'QuizQuestionLink');
            /** Relation: Quiz Reference Quiz Link */
            QuizReferenceQuizLink = new DwItemRelationship('Quiz|QuizReferenceQuizLink|QuizId', 'QuizReferenceQuizLink', 'QuizReferenceQuizLink');
            /** Relation: Quiz Reference Quiz Link - Reference - Many */
            QuizReferenceQuizLinkByReferenceQuizId = new DwItemRelationship('Quiz|QuizReferenceQuizLink|ReferenceQuizId', 'ReferenceQuizReferenceQuizLink', 'ReferenceQuizReferenceQuizLink');
            /** Relation: Quiz Result */
            QuizResult = new DwItemRelationship('Quiz|QuizResult|QuizId', 'QuizResult', 'QuizResult');
    };
export class QuizOutcomeMetaData implements DwItem2<QuizOutcomeEntity, QuizOutcomeMetaDataAttributes,QuizOutcomeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=162;
        this.ItemDetail.itemName='QuizOutcome';
        this.ItemDetail.keyName='QuizOutcomeId';
    }

    CreateEntity(): QuizOutcomeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): QuizOutcomeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<QuizOutcomeEntity, QuizOutcomeMetaDataAttributes,QuizOutcomeMetaDataRelations>(query, this);
    }
     Attributes = new QuizOutcomeMetaDataAttributes();
     Relations = new QuizOutcomeMetaDataRelations();

}


export type QuizOutcomeQueryBuilder = DwQueryBuilderGen<QuizOutcomeEntity, QuizOutcomeMetaDataAttributes,QuizOutcomeMetaDataRelations>


export class QuizOutcomeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'QuizOutcome';
    // Attributes
    QuizOutcomeId = new DwItemAttribute(this.i, 'QuizOutcomeId');
    QuizOutcome = new DwItemAttribute(this.i, 'QuizOutcome');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class QuizOutcomeMetaDataRelations implements DwItemRelationshipCollection {
    };
export class QuizQuestionAnswerNotUsedMetaData implements DwItem2<QuizQuestionAnswerNotUsedEntity, QuizQuestionAnswerNotUsedMetaDataAttributes,QuizQuestionAnswerNotUsedMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=171;
        this.ItemDetail.itemName='QuizQuestionAnswer_NotUsed';
        this.ItemDetail.keyName='QuizQuestionAnswerId';
    }

    CreateEntity(): QuizQuestionAnswerNotUsedEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): QuizQuestionAnswerNotUsedQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<QuizQuestionAnswerNotUsedEntity, QuizQuestionAnswerNotUsedMetaDataAttributes,QuizQuestionAnswerNotUsedMetaDataRelations>(query, this);
    }
     Attributes = new QuizQuestionAnswerNotUsedMetaDataAttributes();
     Relations = new QuizQuestionAnswerNotUsedMetaDataRelations();

}


export type QuizQuestionAnswerNotUsedQueryBuilder = DwQueryBuilderGen<QuizQuestionAnswerNotUsedEntity, QuizQuestionAnswerNotUsedMetaDataAttributes,QuizQuestionAnswerNotUsedMetaDataRelations>


export class QuizQuestionAnswerNotUsedMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'QuizQuestionAnswer_NotUsed';
    // Attributes
    QuizQuestionAnswerId = new DwItemAttribute(this.i, 'QuizQuestionAnswerId');
    QuizQuestionId = new DwItemAttribute(this.i, 'QuizQuestionId');
    AnswerText = new DwItemAttribute(this.i, 'AnswerText');
    AnswerImageMediaId = new DwItemAttribute(this.i, 'AnswerImageMediaId');
    IsCorrectAnswer = new DwItemAttribute(this.i, 'IsCorrectAnswer');
    ExplanationText = new DwItemAttribute(this.i, 'ExplanationText');
    AnswerOrder = new DwItemAttribute(this.i, 'AnswerOrder');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class QuizQuestionAnswerNotUsedMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Question Not Used */
            QuestionNotUsed = new DwItemRelationship('QuizQuestion|QuizQuestionAnswer|QuizQuestionId', 'QuestionNotUsed', 'QuestionNotUsed');
    };
export class QuizQuestionLinkMetaData implements DwItem2<QuizQuestionLinkEntity, QuizQuestionLinkMetaDataAttributes,QuizQuestionLinkMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=167;
        this.ItemDetail.itemName='QuizQuestionLink';
        this.ItemDetail.keyName='QuizQuestionLinkId';
    }

    CreateEntity(): QuizQuestionLinkEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): QuizQuestionLinkQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<QuizQuestionLinkEntity, QuizQuestionLinkMetaDataAttributes,QuizQuestionLinkMetaDataRelations>(query, this);
    }
     Attributes = new QuizQuestionLinkMetaDataAttributes();
     Relations = new QuizQuestionLinkMetaDataRelations();

}


export type QuizQuestionLinkQueryBuilder = DwQueryBuilderGen<QuizQuestionLinkEntity, QuizQuestionLinkMetaDataAttributes,QuizQuestionLinkMetaDataRelations>


export class QuizQuestionLinkMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'QuizQuestionLink';
    // Attributes
    QuizId = new DwItemAttribute(this.i, 'QuizId');
    QuestionId = new DwItemAttribute(this.i, 'QuestionId');
    QuizQuestionLinkId = new DwItemAttribute(this.i, 'QuizQuestionLinkId');
    QuestionOrder = new DwItemAttribute(this.i, 'QuestionOrder');
    QuestionWeight = new DwItemAttribute(this.i, 'QuestionWeight');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    IsDeleted = new DwItemAttribute(this.i, 'IsDeleted');
}

class QuizQuestionLinkMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Question */
            Question = new DwItemRelationship('Question|QuizQuestionLink|QuestionId', 'Question', 'Question');
            /** Relation: Quiz */
            Quiz = new DwItemRelationship('Quiz|QuizQuestionLink|QuizId', 'Quiz', 'Quiz');
            /** Relation: Quiz Result Question - Source - Many */
            QuizResultQuestionBySourceQuizQuestionLinkId = new DwItemRelationship('QuizQuestionLink|QuizResultQuestion|SourceQuizQuestionLinkId', 'SourceQuizResultQuestion', 'SourceQuizResultQuestion');
    };
export class QuizReferenceQuizLinkMetaData implements DwItem2<QuizReferenceQuizLinkEntity, QuizReferenceQuizLinkMetaDataAttributes,QuizReferenceQuizLinkMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=214;
        this.ItemDetail.itemName='QuizReferenceQuizLink';
        this.ItemDetail.keyName='QuizReferenceQuizLinkId';
    }

    CreateEntity(): QuizReferenceQuizLinkEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): QuizReferenceQuizLinkQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<QuizReferenceQuizLinkEntity, QuizReferenceQuizLinkMetaDataAttributes,QuizReferenceQuizLinkMetaDataRelations>(query, this);
    }
     Attributes = new QuizReferenceQuizLinkMetaDataAttributes();
     Relations = new QuizReferenceQuizLinkMetaDataRelations();

}


export type QuizReferenceQuizLinkQueryBuilder = DwQueryBuilderGen<QuizReferenceQuizLinkEntity, QuizReferenceQuizLinkMetaDataAttributes,QuizReferenceQuizLinkMetaDataRelations>


export class QuizReferenceQuizLinkMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'QuizReferenceQuizLink';
    // Attributes
    QuizReferenceQuizLinkId = new DwItemAttribute(this.i, 'QuizReferenceQuizLinkId');
    QuizId = new DwItemAttribute(this.i, 'QuizId');
    ReferenceQuizId = new DwItemAttribute(this.i, 'ReferenceQuizId');
    QuizWeight = new DwItemAttribute(this.i, 'QuizWeight');
    RequireCompletion = new DwItemAttribute(this.i, 'RequireCompletion');
    PrioritizeMissedQuestions = new DwItemAttribute(this.i, 'PrioritizeMissedQuestions');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class QuizReferenceQuizLinkMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Quiz */
            Quiz = new DwItemRelationship('Quiz|QuizReferenceQuizLink|QuizId', 'Quiz', 'Quiz');
            /** Relation: Quiz - Reference Quiz */
            QuizByReferenceQuizId = new DwItemRelationship('Quiz|QuizReferenceQuizLink|ReferenceQuizId', 'ReferenceQuiz', 'ReferenceQuiz');
    };
export class QuizResultMetaData implements DwItem2<QuizResultEntity, QuizResultMetaDataAttributes,QuizResultMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=140;
        this.ItemDetail.itemName='QuizResult';
        this.ItemDetail.keyName='QuizResultId';
    }

    CreateEntity(): QuizResultEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): QuizResultQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<QuizResultEntity, QuizResultMetaDataAttributes,QuizResultMetaDataRelations>(query, this);
    }
     Attributes = new QuizResultMetaDataAttributes();
     Relations = new QuizResultMetaDataRelations();

}


export type QuizResultQueryBuilder = DwQueryBuilderGen<QuizResultEntity, QuizResultMetaDataAttributes,QuizResultMetaDataRelations>


export class QuizResultMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'QuizResult';
    // Attributes
    QuizResultId = new DwItemAttribute(this.i, 'QuizResultId');
    QuizId = new DwItemAttribute(this.i, 'QuizId');
    IsComplete = new DwItemAttribute(this.i, 'IsComplete');
    CompletedQuestions = new DwItemAttribute(this.i, 'CompletedQuestions');
    TotalQuestions = new DwItemAttribute(this.i, 'TotalQuestions');
    QuizScore = new DwItemAttribute(this.i, 'QuizScore');
    PerfectScore = new DwItemAttribute(this.i, 'PerfectScore');
    QuizStartDateTime = new DwItemAttribute(this.i, 'QuizStartDateTime');
    QuizStopDateTime = new DwItemAttribute(this.i, 'QuizStopDateTime');
    PercentageScore = new DwItemAttribute(this.i, 'PercentageScore');
    QuizResultStatusId = new DwItemAttribute(this.i, 'QuizResultStatusId');
    TotalTimeSeconds = new DwItemAttribute(this.i, 'TotalTimeSeconds');
    CorrectQuestions = new DwItemAttribute(this.i, 'CorrectQuestions');
    StudentCourseId = new DwItemAttribute(this.i, 'StudentCourseId');
    CourseLessonProgressId = new DwItemAttribute(this.i, 'CourseLessonProgressId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    ProgressReset = new DwItemAttribute(this.i, 'ProgressReset');
    QuizResultTypeId = new DwItemAttribute(this.i, 'QuizResultTypeId');
    DailyQuizId = new DwItemAttribute(this.i, 'DailyQuizId');
    AttemptNumber = new DwItemAttribute(this.i, 'AttemptNumber');
}

class QuizResultMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Course Lesson Progress */
            CourseLessonProgress = new DwItemRelationship('CourseLessonProgress|QuizResult|CourseLessonProgressId', 'CourseLessonProgress', 'CourseLessonProgress');
            /** Relation: Daily Quiz */
            DailyQuiz = new DwItemRelationship('DailyQuiz|QuizResult|DailyQuizId', 'DailyQuiz', 'DailyQuiz');
            /** Relation: Quiz */
            Quiz = new DwItemRelationship('Quiz|QuizResult|QuizId', 'Quiz', 'Quiz');
            /** Relation: Quiz Result Status */
            QuizResultStatus = new DwItemRelationship('QuizResultStatus|QuizResult|QuizResultStatusId', 'QuizResultStatus', 'QuizResultStatus');
            /** Relation: Quiz Result Type */
            QuizResultType = new DwItemRelationship('QuizResultType|QuizResult|QuizResultTypeId', 'QuizResultType', 'QuizResultType');
            /** Relation: Student Course */
            StudentCourse = new DwItemRelationship('StudentCourse|QuizResult|StudentCourseId', 'StudentCourse', 'StudentCourse');
            /** Relation: Course Lesson Progress - Best - Many */
            CourseLessonProgressByBestQuizResultId = new DwItemRelationship('QuizResult|CourseLessonProgress|BestQuizResultId', 'BestCourseLessonProgress', 'BestCourseLessonProgress');
            /** Relation: Course Lesson Session */
            CourseLessonSession = new DwItemRelationship('QuizResult|CourseLessonSession|QuizResultId', 'CourseLessonSession', 'CourseLessonSession');
            /** Relation: Daily Quiz - Best - Many */
            DailyQuizByBestQuizResultId = new DwItemRelationship('QuizResult|DailyQuiz|BestQuizResultId', 'BestDailyQuiz', 'BestDailyQuiz');
            /** Relation: Quiz Result Question */
            QuizResultQuestion = new DwItemRelationship('QuizResult|QuizResultQuestion|QuizResultId', 'QuizResultQuestion', 'QuizResultQuestion');
            /** Relation: Student Gamification Day - Daily - Many */
            StudentGamificationDayByDailyQuizResultId = new DwItemRelationship('QuizResult|StudentGamificationDay|DailyQuizResultId', 'DailyStudentGamificationDay', 'DailyStudentGamificationDay');
    };
export class QuizResultQuestionMetaData implements DwItem2<QuizResultQuestionEntity, QuizResultQuestionMetaDataAttributes,QuizResultQuestionMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=141;
        this.ItemDetail.itemName='QuizResultQuestion';
        this.ItemDetail.keyName='QuizResultQuestionId';
    }

    CreateEntity(): QuizResultQuestionEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): QuizResultQuestionQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<QuizResultQuestionEntity, QuizResultQuestionMetaDataAttributes,QuizResultQuestionMetaDataRelations>(query, this);
    }
     Attributes = new QuizResultQuestionMetaDataAttributes();
     Relations = new QuizResultQuestionMetaDataRelations();

}


export type QuizResultQuestionQueryBuilder = DwQueryBuilderGen<QuizResultQuestionEntity, QuizResultQuestionMetaDataAttributes,QuizResultQuestionMetaDataRelations>


export class QuizResultQuestionMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'QuizResultQuestion';
    // Attributes
    QuizResultQuestionId = new DwItemAttribute(this.i, 'QuizResultQuestionId');
    QuizResultId = new DwItemAttribute(this.i, 'QuizResultId');
    AnswerValue = new DwItemAttribute(this.i, 'AnswerValue');
    IsCorrect = new DwItemAttribute(this.i, 'IsCorrect');
    QuestionStartDateTime = new DwItemAttribute(this.i, 'QuestionStartDateTime');
    QuestionEndDateTime = new DwItemAttribute(this.i, 'QuestionEndDateTime');
    QuestionId = new DwItemAttribute(this.i, 'QuestionId');
    QuestionAnswerId = new DwItemAttribute(this.i, 'QuestionAnswerId');
    TotalTimeSeconds = new DwItemAttribute(this.i, 'TotalTimeSeconds');
    IsAnswered = new DwItemAttribute(this.i, 'IsAnswered');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    QuestionOrder = new DwItemAttribute(this.i, 'QuestionOrder');
    SourceQuizQuestionLinkId = new DwItemAttribute(this.i, 'SourceQuizQuestionLinkId');
}

class QuizResultQuestionMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Question */
            Question = new DwItemRelationship('Question|QuizResultQuestion|QuestionId', 'Question', 'Question');
            /** Relation: Question Answer */
            QuestionAnswer = new DwItemRelationship('QuestionAnswer|QuizResultQuestion|QuestionAnswerId', 'QuestionAnswer', 'QuestionAnswer');
            /** Relation: Quiz Question Link - Source Quiz Question Link */
            QuizQuestionLinkBySourceQuizQuestionLinkId = new DwItemRelationship('QuizQuestionLink|QuizResultQuestion|SourceQuizQuestionLinkId', 'SourceQuizQuestionLink', 'SourceQuizQuestionLink');
            /** Relation: Quiz Result */
            QuizResult = new DwItemRelationship('QuizResult|QuizResultQuestion|QuizResultId', 'QuizResult', 'QuizResult');
    };
export class QuizResultStatusMetaData implements DwItem2<QuizResultStatusEntity, QuizResultStatusMetaDataAttributes,QuizResultStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=173;
        this.ItemDetail.itemName='QuizResultStatus';
        this.ItemDetail.keyName='QuizResultStatusId';
    }

    CreateEntity(): QuizResultStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): QuizResultStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<QuizResultStatusEntity, QuizResultStatusMetaDataAttributes,QuizResultStatusMetaDataRelations>(query, this);
    }
     Attributes = new QuizResultStatusMetaDataAttributes();
     Relations = new QuizResultStatusMetaDataRelations();

}


export type QuizResultStatusQueryBuilder = DwQueryBuilderGen<QuizResultStatusEntity, QuizResultStatusMetaDataAttributes,QuizResultStatusMetaDataRelations>


export class QuizResultStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'QuizResultStatus';
    // Attributes
    QuizResultStatusId = new DwItemAttribute(this.i, 'QuizResultStatusId');
    QuizResultStatus = new DwItemAttribute(this.i, 'QuizResultStatus');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class QuizResultStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Quiz Result */
            QuizResult = new DwItemRelationship('QuizResultStatus|QuizResult|QuizResultStatusId', 'QuizResult', 'QuizResult');
    };
export class QuizResultTypeMetaData implements DwItem2<QuizResultTypeEntity, QuizResultTypeMetaDataAttributes,QuizResultTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=485;
        this.ItemDetail.itemName='QuizResultType';
        this.ItemDetail.keyName='QuizResultTypeId';
    }

    CreateEntity(): QuizResultTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): QuizResultTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<QuizResultTypeEntity, QuizResultTypeMetaDataAttributes,QuizResultTypeMetaDataRelations>(query, this);
    }
     Attributes = new QuizResultTypeMetaDataAttributes();
     Relations = new QuizResultTypeMetaDataRelations();

}


export type QuizResultTypeQueryBuilder = DwQueryBuilderGen<QuizResultTypeEntity, QuizResultTypeMetaDataAttributes,QuizResultTypeMetaDataRelations>


export class QuizResultTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'QuizResultType';
    // Attributes
    QuizResultTypeId = new DwItemAttribute(this.i, 'QuizResultTypeId');
    QuizResultType = new DwItemAttribute(this.i, 'QuizResultType');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class QuizResultTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Quiz Result */
            QuizResult = new DwItemRelationship('QuizResultType|QuizResult|QuizResultTypeId', 'QuizResult', 'QuizResult');
    };
export class QuizTypeMetaData implements DwItem2<QuizTypeEntity, QuizTypeMetaDataAttributes,QuizTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=161;
        this.ItemDetail.itemName='QuizType';
        this.ItemDetail.keyName='QuizTypeId';
    }

    CreateEntity(): QuizTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): QuizTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<QuizTypeEntity, QuizTypeMetaDataAttributes,QuizTypeMetaDataRelations>(query, this);
    }
     Attributes = new QuizTypeMetaDataAttributes();
     Relations = new QuizTypeMetaDataRelations();

}


export type QuizTypeQueryBuilder = DwQueryBuilderGen<QuizTypeEntity, QuizTypeMetaDataAttributes,QuizTypeMetaDataRelations>


export class QuizTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'QuizType';
    // Attributes
    QuizTypeId = new DwItemAttribute(this.i, 'QuizTypeId');
    QuizType = new DwItemAttribute(this.i, 'QuizType');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    ShowQuizReferences = new DwItemAttribute(this.i, 'ShowQuizReferences');
}

class QuizTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Quiz */
            Quiz = new DwItemRelationship('QuizType|Quiz|QuizTypeId', 'Quiz', 'Quiz');
    };
export class ReferenceImageMetaData implements DwItem2<ReferenceImageEntity, ReferenceImageMetaDataAttributes,ReferenceImageMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=228;
        this.ItemDetail.itemName='ReferenceImage';
        this.ItemDetail.keyName='ReferenceImageId';
    }

    CreateEntity(): ReferenceImageEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ReferenceImageQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ReferenceImageEntity, ReferenceImageMetaDataAttributes,ReferenceImageMetaDataRelations>(query, this);
    }
     Attributes = new ReferenceImageMetaDataAttributes();
     Relations = new ReferenceImageMetaDataRelations();

}


export type ReferenceImageQueryBuilder = DwQueryBuilderGen<ReferenceImageEntity, ReferenceImageMetaDataAttributes,ReferenceImageMetaDataRelations>


export class ReferenceImageMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ReferenceImage';
    // Attributes
    ReferenceImageId = new DwItemAttribute(this.i, 'ReferenceImageId');
    ReferenceImageName = new DwItemAttribute(this.i, 'ReferenceImageName');
    ImageMediaId = new DwItemAttribute(this.i, 'ImageMediaId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class ReferenceImageMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Course Endorsement Template Field */
            CourseEndorsementTemplateField = new DwItemRelationship('ReferenceImage|CourseEndorsementTemplateField|ReferenceImageId', 'CourseEndorsementTemplateField', 'CourseEndorsementTemplateField');
    };
export class ReferenceStatusMetaData implements DwItem2<ReferenceStatusEntity, ReferenceStatusMetaDataAttributes,ReferenceStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=233;
        this.ItemDetail.itemName='ReferenceStatus';
        this.ItemDetail.keyName='ReferenceStatusId';
    }

    CreateEntity(): ReferenceStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ReferenceStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ReferenceStatusEntity, ReferenceStatusMetaDataAttributes,ReferenceStatusMetaDataRelations>(query, this);
    }
     Attributes = new ReferenceStatusMetaDataAttributes();
     Relations = new ReferenceStatusMetaDataRelations();

}


export type ReferenceStatusQueryBuilder = DwQueryBuilderGen<ReferenceStatusEntity, ReferenceStatusMetaDataAttributes,ReferenceStatusMetaDataRelations>


export class ReferenceStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ReferenceStatus';
    // Attributes
    ReferenceStatusId = new DwItemAttribute(this.i, 'ReferenceStatusId');
    ReferenceStatus = new DwItemAttribute(this.i, 'ReferenceStatus');
}

class ReferenceStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Course - Course Status - Many */
            CourseByCourseStatusId = new DwItemRelationship('ReferenceStatus|Course|CourseStatusId', 'CourseStatusIdCourse', 'CourseStatusIdCourse');
            /** Relation: Course Document Item - Course Document Item Status - Many */
            CourseDocumentItemByCourseDocumentItemStatusId = new DwItemRelationship('ReferenceStatus|CourseDocumentItem|CourseDocumentItemStatusId', 'CourseDocumentItemStatusIdCourseDocumentItem', 'CourseDocumentItemStatusIdCourseDocumentItem');
            /** Relation: Course Endorsement Student - Course Endorsement Student Status - Many */
            CourseEndorsementStudentByCourseEndorsementStudentStatusId = new DwItemRelationship('ReferenceStatus|CourseEndorsementStudent|CourseEndorsementStutudentStatusId', 'CourseEndorsementStudentStatusIdCourseEndorsementStudent', 'CourseEndorsementStudentStatusIdCourseEndorsementStudent');
            /** Relation: Lesson - Lesson Status - Many */
            CourseLessonByLessonStatusId = new DwItemRelationship('ReferenceStatus|CourseLesson|LessonStatusId', 'LessonStatusIdCourseLesson', 'LessonStatusIdCourseLesson');
            /** Relation: Course Lesson Document Link - Course Lesson Document Link Status - Many */
            CourseLessonDocumentLinkByCourseLessonDocumentLinkStatusId = new DwItemRelationship('ReferenceStatus|CourseLessonDocumentLink|CourseLessonDocumentLinkStatusId', 'CourseLessonDocumentLinkStatusIdCourseLessonDocumentLink', 'CourseLessonDocumentLinkStatusIdCourseLessonDocumentLink');
            /** Relation: Course Lesson Document Link Reference */
            CourseLessonDocumentLinkReference = new DwItemRelationship('ReferenceStatus|CourseLessonDocumentLinkReference|ReferenceStatusId', 'CourseLessonDocumentLinkReference', 'CourseLessonDocumentLinkReference');
            /** Relation: Course Lesson Progress - Lesson Progress Status - Many */
            CourseLessonProgressByLessonProgressStatusId = new DwItemRelationship('ReferenceStatus|CourseLessonProgress|LessonProgressStatusId', 'LessonProgressStatusIdCourseLessonProgress', 'LessonProgressStatusIdCourseLessonProgress');
            /** Relation: Course Lesson Session - Lesson Session Status - Many */
            CourseLessonSessionByLessonSessionStatusId = new DwItemRelationship('ReferenceStatus|CourseLessonSession|LessonSessionStatusId', 'LessonSessionStatusIdCourseLessonSession', 'LessonSessionStatusIdCourseLessonSession');
            /** Relation: Module - Module Status - Many */
            CourseModuleByModuleStatusId = new DwItemRelationship('ReferenceStatus|CourseModule|ModuleStatusId', 'ModuleStatusIdCourseModule', 'ModuleStatusIdCourseModule');
            /** Relation: Course Module Document Item - Course Module Document Item Status - Many */
            CourseModuleDocumentItemByCourseModuleDocumentItemStatusId = new DwItemRelationship('ReferenceStatus|CourseModuleDocumentItem|CourseModuleDocumentItemStatusId', 'CourseModuleDocumentItemStatusIdCourseModuleDocumentItem', 'CourseModuleDocumentItemStatusIdCourseModuleDocumentItem');
            /** Relation: Course Module Progress - Module Progress Status - Many */
            CourseModuleProgressByModuleProgressStatusId = new DwItemRelationship('ReferenceStatus|CourseModuleProgress|ModuleProgressStatusId', 'ModuleProgressStatusIdCourseModuleProgress', 'ModuleProgressStatusIdCourseModuleProgress');
            /** Relation: Document Anchor */
            DocumentAnchor = new DwItemRelationship('ReferenceStatus|DocumentAnchor|ReferenceStatusId', 'DocumentAnchor', 'DocumentAnchor');
            /** Relation: Document Asset */
            DocumentAsset = new DwItemRelationship('ReferenceStatus|DocumentAsset|ReferenceStatusId', 'DocumentAsset', 'DocumentAsset');
            /** Relation: Document Publication */
            DocumentPublication = new DwItemRelationship('ReferenceStatus|DocumentPublication|ReferenceStatusId', 'DocumentPublication', 'DocumentPublication');
            /** Relation: Document Section */
            DocumentSection = new DwItemRelationship('ReferenceStatus|DocumentSection|ReferenceStatusId', 'DocumentSection', 'DocumentSection');
            /** Relation: Document Section Content */
            DocumentSectionContent = new DwItemRelationship('ReferenceStatus|DocumentSectionContent|ReferenceStatusId', 'DocumentSectionContent', 'DocumentSectionContent');
            /** Relation: Document Version */
            DocumentVersion = new DwItemRelationship('ReferenceStatus|DocumentVersion|ReferenceStatusId', 'DocumentVersion', 'DocumentVersion');
            /** Relation: Quiz - Quiz Status - Many */
            QuizByQuizStatusId = new DwItemRelationship('ReferenceStatus|Quiz|QuizStatusId', 'QuizStatusIdQuiz', 'QuizStatusIdQuiz');
            /** Relation: Standard Login Media */
            StandardLoginMedia = new DwItemRelationship('ReferenceStatus|StandardLoginMedia|ReferenceStatusId', 'StandardLoginMedia', 'StandardLoginMedia');
            /** Relation: Student Course - Student Course Status - Many */
            StudentCourseByStudentCourseStatusId = new DwItemRelationship('ReferenceStatus|StudentCourse|StudentCourseStatusId', 'StudentCourseStatusIdStudentCourse', 'StudentCourseStatusIdStudentCourse');
            /** Relation: User Document Section Favorite */
            UserDocumentSectionFavorite = new DwItemRelationship('ReferenceStatus|UserDocumentSectionFavorite|ReferenceStatusId', 'UserDocumentSectionFavorite', 'UserDocumentSectionFavorite');
    };
export class RoAcsWrittenMissedCodeStatsMetaData implements DwItem2<RoAcsWrittenMissedCodeStatsEntity, RoAcsWrittenMissedCodeStatsMetaDataAttributes,RoAcsWrittenMissedCodeStatsMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=397;
        this.ItemDetail.itemName='roAcsWrittenMissedCodeStats';
        this.ItemDetail.keyName='AcsWrittenResultId';
    }

    CreateEntity(): RoAcsWrittenMissedCodeStatsEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoAcsWrittenMissedCodeStatsQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoAcsWrittenMissedCodeStatsEntity, RoAcsWrittenMissedCodeStatsMetaDataAttributes,RoAcsWrittenMissedCodeStatsMetaDataRelations>(query, this);
    }
     Attributes = new RoAcsWrittenMissedCodeStatsMetaDataAttributes();
     Relations = new RoAcsWrittenMissedCodeStatsMetaDataRelations();

}


export type RoAcsWrittenMissedCodeStatsQueryBuilder = DwQueryBuilderGen<RoAcsWrittenMissedCodeStatsEntity, RoAcsWrittenMissedCodeStatsMetaDataAttributes,RoAcsWrittenMissedCodeStatsMetaDataRelations>


export class RoAcsWrittenMissedCodeStatsMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roAcsWrittenMissedCodeStats';
    // Attributes
    AcsWrittenResultId = new DwItemAttribute(this.i, 'AcsWrittenResultId');
    AllCodesCount = new DwItemAttribute(this.i, 'AllCodesCount');
    MatchedCodeCount = new DwItemAttribute(this.i, 'MatchedCodeCount');
    UnMatchedCodesCount = new DwItemAttribute(this.i, 'UnMatchedCodesCount');
}

class RoAcsWrittenMissedCodeStatsMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Acs Written Result */
            AcsWrittenResult = new DwItemRelationship('AcsWrittenResult_RoAcsWrittenMissedCodeStats_AcsWrittenResultId', 'AcsWrittenResult', 'AcsWrittenResult');
    };
export class RoAssignmentDetailMetaData implements DwItem2<RoAssignmentDetailEntity, RoAssignmentDetailMetaDataAttributes,RoAssignmentDetailMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=379;
        this.ItemDetail.itemName='roAssignmentDetail';
        this.ItemDetail.keyName='';
    }

    CreateEntity(): RoAssignmentDetailEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoAssignmentDetailQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoAssignmentDetailEntity, RoAssignmentDetailMetaDataAttributes,RoAssignmentDetailMetaDataRelations>(query, this);
    }
     Attributes = new RoAssignmentDetailMetaDataAttributes();
     Relations = new RoAssignmentDetailMetaDataRelations();

}


export type RoAssignmentDetailQueryBuilder = DwQueryBuilderGen<RoAssignmentDetailEntity, RoAssignmentDetailMetaDataAttributes,RoAssignmentDetailMetaDataRelations>


export class RoAssignmentDetailMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roAssignmentDetail';
    // Attributes
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    AssignedDateTime = new DwItemAttribute(this.i, 'AssignedDateTime');
    DueDateTime = new DwItemAttribute(this.i, 'DueDateTime');
    CompletedDateTime = new DwItemAttribute(this.i, 'CompletedDateTime');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    AssignmentStatusId = new DwItemAttribute(this.i, 'AssignmentStatusId');
    InstructorId = new DwItemAttribute(this.i, 'InstructorId');
    StudentId = new DwItemAttribute(this.i, 'StudentId');
    PercentComplete = new DwItemAttribute(this.i, 'PercentComplete');
    StudentCompletedDateTime = new DwItemAttribute(this.i, 'StudentCompletedDateTime');
    Acknowledged = new DwItemAttribute(this.i, 'Acknowledged');
    AcknowledgedDateTime = new DwItemAttribute(this.i, 'AcknowledgedDateTime');
}

class RoAssignmentDetailMetaDataRelations implements DwItemRelationshipCollection {
    };
export class RoAssignmentResetLessonImpactMetaData implements DwItem2<RoAssignmentResetLessonImpactEntity, RoAssignmentResetLessonImpactMetaDataAttributes,RoAssignmentResetLessonImpactMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=499;
        this.ItemDetail.itemName='roAssignmentResetLessonImpact';
        this.ItemDetail.keyName='';
    }

    CreateEntity(): RoAssignmentResetLessonImpactEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoAssignmentResetLessonImpactQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoAssignmentResetLessonImpactEntity, RoAssignmentResetLessonImpactMetaDataAttributes,RoAssignmentResetLessonImpactMetaDataRelations>(query, this);
    }
     Attributes = new RoAssignmentResetLessonImpactMetaDataAttributes();
     Relations = new RoAssignmentResetLessonImpactMetaDataRelations();

}


export type RoAssignmentResetLessonImpactQueryBuilder = DwQueryBuilderGen<RoAssignmentResetLessonImpactEntity, RoAssignmentResetLessonImpactMetaDataAttributes,RoAssignmentResetLessonImpactMetaDataRelations>


export class RoAssignmentResetLessonImpactMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roAssignmentResetLessonImpact';
    // Attributes
    CourseLessonProgressId = new DwItemAttribute(this.i, 'CourseLessonProgressId');
    StudentId = new DwItemAttribute(this.i, 'StudentId');
    StudentCourseId = new DwItemAttribute(this.i, 'StudentCourseId');
    CourseId = new DwItemAttribute(this.i, 'CourseId');
    CourseModuleId = new DwItemAttribute(this.i, 'CourseModuleId');
    CourseLessonId = new DwItemAttribute(this.i, 'CourseLessonId');
    HasProgress = new DwItemAttribute(this.i, 'HasProgress');
    StudentCount = new DwItemAttribute(this.i, 'StudentCount');
    Completed = new DwItemAttribute(this.i, 'Completed');
    CompletedStudentCount = new DwItemAttribute(this.i, 'CompletedStudentCount');
    PassedQuizCount = new DwItemAttribute(this.i, 'PassedQuizCount');
}

class RoAssignmentResetLessonImpactMetaDataRelations implements DwItemRelationshipCollection {
    };
export class RoAssignmentResetStudentImpactMetaData implements DwItem2<RoAssignmentResetStudentImpactEntity, RoAssignmentResetStudentImpactMetaDataAttributes,RoAssignmentResetStudentImpactMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=500;
        this.ItemDetail.itemName='roAssignmentResetStudentImpact';
        this.ItemDetail.keyName='';
    }

    CreateEntity(): RoAssignmentResetStudentImpactEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoAssignmentResetStudentImpactQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoAssignmentResetStudentImpactEntity, RoAssignmentResetStudentImpactMetaDataAttributes,RoAssignmentResetStudentImpactMetaDataRelations>(query, this);
    }
     Attributes = new RoAssignmentResetStudentImpactMetaDataAttributes();
     Relations = new RoAssignmentResetStudentImpactMetaDataRelations();

}


export type RoAssignmentResetStudentImpactQueryBuilder = DwQueryBuilderGen<RoAssignmentResetStudentImpactEntity, RoAssignmentResetStudentImpactMetaDataAttributes,RoAssignmentResetStudentImpactMetaDataRelations>


export class RoAssignmentResetStudentImpactMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roAssignmentResetStudentImpact';
    // Attributes
    CourseLessonProgressId = new DwItemAttribute(this.i, 'CourseLessonProgressId');
    StudentId = new DwItemAttribute(this.i, 'StudentId');
    UserId = new DwItemAttribute(this.i, 'UserId');
    DisplayName = new DwItemAttribute(this.i, 'DisplayName');
    StudentCourseId = new DwItemAttribute(this.i, 'StudentCourseId');
    CourseId = new DwItemAttribute(this.i, 'CourseId');
    CourseModuleId = new DwItemAttribute(this.i, 'CourseModuleId');
    CourseLessonId = new DwItemAttribute(this.i, 'CourseLessonId');
    Completed = new DwItemAttribute(this.i, 'Completed');
    PassedQuizCount = new DwItemAttribute(this.i, 'PassedQuizCount');
}

class RoAssignmentResetStudentImpactMetaDataRelations implements DwItemRelationshipCollection {
    };
export class RoAssignmentStudentCompletedDetailsMetaData implements DwItem2<RoAssignmentStudentCompletedDetailsEntity, RoAssignmentStudentCompletedDetailsMetaDataAttributes,RoAssignmentStudentCompletedDetailsMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=229;
        this.ItemDetail.itemName='roAssignmentStudentCompletedDetails';
        this.ItemDetail.keyName='';
    }

    CreateEntity(): RoAssignmentStudentCompletedDetailsEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoAssignmentStudentCompletedDetailsQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoAssignmentStudentCompletedDetailsEntity, RoAssignmentStudentCompletedDetailsMetaDataAttributes,RoAssignmentStudentCompletedDetailsMetaDataRelations>(query, this);
    }
     Attributes = new RoAssignmentStudentCompletedDetailsMetaDataAttributes();
     Relations = new RoAssignmentStudentCompletedDetailsMetaDataRelations();

}


export type RoAssignmentStudentCompletedDetailsQueryBuilder = DwQueryBuilderGen<RoAssignmentStudentCompletedDetailsEntity, RoAssignmentStudentCompletedDetailsMetaDataAttributes,RoAssignmentStudentCompletedDetailsMetaDataRelations>


export class RoAssignmentStudentCompletedDetailsMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roAssignmentStudentCompletedDetails';
    // Attributes
    AssignmentStudentId = new DwItemAttribute(this.i, 'AssignmentStudentId');
    AssignmentId = new DwItemAttribute(this.i, 'AssignmentId');
    CompletedOnTime = new DwItemAttribute(this.i, 'CompletedOnTime');
}

class RoAssignmentStudentCompletedDetailsMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Assignment Student */
            AssignmentStudent = new DwItemRelationship('AssignmentStudent|RoAssignmentStudent|AssignmentStudentId', 'AssignmentStudent', 'AssignmentStudent');
    };
export class RoAssignmentStudentCourseLessonProgressMetaData implements DwItem2<RoAssignmentStudentCourseLessonProgressEntity, RoAssignmentStudentCourseLessonProgressMetaDataAttributes,RoAssignmentStudentCourseLessonProgressMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=196;
        this.ItemDetail.itemName='roAssignmentStudentCourseLessonProgress';
        this.ItemDetail.keyName='CourseLessonProgressId';
    }

    CreateEntity(): RoAssignmentStudentCourseLessonProgressEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoAssignmentStudentCourseLessonProgressQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoAssignmentStudentCourseLessonProgressEntity, RoAssignmentStudentCourseLessonProgressMetaDataAttributes,RoAssignmentStudentCourseLessonProgressMetaDataRelations>(query, this);
    }
     Attributes = new RoAssignmentStudentCourseLessonProgressMetaDataAttributes();
     Relations = new RoAssignmentStudentCourseLessonProgressMetaDataRelations();

}


export type RoAssignmentStudentCourseLessonProgressQueryBuilder = DwQueryBuilderGen<RoAssignmentStudentCourseLessonProgressEntity, RoAssignmentStudentCourseLessonProgressMetaDataAttributes,RoAssignmentStudentCourseLessonProgressMetaDataRelations>


export class RoAssignmentStudentCourseLessonProgressMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roAssignmentStudentCourseLessonProgress';
    // Attributes
    AssignmentStudentId = new DwItemAttribute(this.i, 'AssignmentStudentId');
    StudentId = new DwItemAttribute(this.i, 'StudentId');
    CourseLessonId = new DwItemAttribute(this.i, 'CourseLessonId');
    CourseLessonProgressId = new DwItemAttribute(this.i, 'CourseLessonProgressId');
    LessonComplete = new DwItemAttribute(this.i, 'LessonComplete');
    PercentComplete = new DwItemAttribute(this.i, 'PercentComplete');
    UserId = new DwItemAttribute(this.i, 'UserId');
    AssignmentId = new DwItemAttribute(this.i, 'assignmentId');
    LessonName = new DwItemAttribute(this.i, 'LessonName');
    CourseModuleId = new DwItemAttribute(this.i, 'CourseModuleId');
    ModuleName = new DwItemAttribute(this.i, 'ModuleName');
    CourseId = new DwItemAttribute(this.i, 'CourseId');
    CourseName = new DwItemAttribute(this.i, 'CourseName');
    LessonOrder = new DwItemAttribute(this.i, 'LessonOrder');
    ModuleOrder = new DwItemAttribute(this.i, 'ModuleOrder');
    StudentCourseId = new DwItemAttribute(this.i, 'StudentCourseId');
    StudentCourseStatusId = new DwItemAttribute(this.i, 'StudentCourseStatusId');
    CourseModuleProgressId = new DwItemAttribute(this.i, 'CourseModuleProgressId');
    ModuleProgressStatusId = new DwItemAttribute(this.i, 'ModuleProgressStatusId');
    LessonProgressStatusId = new DwItemAttribute(this.i, 'LessonProgressStatusId');
    AssignmentStudentCourseLessonProgressId = new DwItemAttribute(this.i, 'AssignmentStudentCourseLessonProgressId');
}

class RoAssignmentStudentCourseLessonProgressMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Assignment - Assignment */
            AssignmentByassignmentId = new DwItemRelationship('Assignment|RoAssignmentStudentCourseLessonProgress', 'AssignmentIdAssignment', 'AssignmentIdAssignment');
            /** Relation: Assignment Student */
            AssignmentStudent = new DwItemRelationship('AssignmentStudent|RoAssignmentStudentCourseLessonProgress', 'AssignmentStudent', 'AssignmentStudent');
            /** Relation: Lesson */
            CourseLesson = new DwItemRelationship('Lesson|RoAssignmentStudentCourseLessonProgress', 'CourseLesson', 'CourseLesson');
            /** Relation: Course Lesson Progress */
            CourseLessonProgress = new DwItemRelationship('CourseLessonProgress|RoAssignmentStudentCourseLessonProgress', 'CourseLessonProgress', 'CourseLessonProgress');
    };
export class RoAssignmentStudentStatMetaData implements DwItem2<RoAssignmentStudentStatEntity, RoAssignmentStudentStatMetaDataAttributes,RoAssignmentStudentStatMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=395;
        this.ItemDetail.itemName='roAssignmentStudentStat';
        this.ItemDetail.keyName='';
    }

    CreateEntity(): RoAssignmentStudentStatEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoAssignmentStudentStatQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoAssignmentStudentStatEntity, RoAssignmentStudentStatMetaDataAttributes,RoAssignmentStudentStatMetaDataRelations>(query, this);
    }
     Attributes = new RoAssignmentStudentStatMetaDataAttributes();
     Relations = new RoAssignmentStudentStatMetaDataRelations();

}


export type RoAssignmentStudentStatQueryBuilder = DwQueryBuilderGen<RoAssignmentStudentStatEntity, RoAssignmentStudentStatMetaDataAttributes,RoAssignmentStudentStatMetaDataRelations>


export class RoAssignmentStudentStatMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roAssignmentStudentStat';
    // Attributes
    AssignmentId = new DwItemAttribute(this.i, 'AssignmentId');
    StudentCount = new DwItemAttribute(this.i, 'StudentCount');
    StudentPastDueCount = new DwItemAttribute(this.i, 'StudentPastDueCount');
    StudentCompleteCount = new DwItemAttribute(this.i, 'StudentCompleteCount');
    StudentActiveCount = new DwItemAttribute(this.i, 'StudentActiveCount');
    StudentIncompleteCount = new DwItemAttribute(this.i, 'StudentIncompleteCount');
    CompletedPercent = new DwItemAttribute(this.i, 'CompletedPercent');
    PastDuePercent = new DwItemAttribute(this.i, 'PastDuePercent');
    ActivePercent = new DwItemAttribute(this.i, 'ActivePercent');
    IncompletePercent = new DwItemAttribute(this.i, 'IncompletePercent');
}

class RoAssignmentStudentStatMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Assignment */
            Assignment = new DwItemRelationship('Assignment|RoAssignmentStudentStat|AssignmentId', 'Assignment', 'Assignment');
    };
export class RoCompletedInvoicesMetaData implements DwItem2<RoCompletedInvoicesEntity, RoCompletedInvoicesMetaDataAttributes,RoCompletedInvoicesMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=260;
        this.ItemDetail.itemName='roCompletedInvoices';
        this.ItemDetail.keyName='';
    }

    CreateEntity(): RoCompletedInvoicesEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoCompletedInvoicesQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoCompletedInvoicesEntity, RoCompletedInvoicesMetaDataAttributes,RoCompletedInvoicesMetaDataRelations>(query, this);
    }
     Attributes = new RoCompletedInvoicesMetaDataAttributes();
     Relations = new RoCompletedInvoicesMetaDataRelations();

}


export type RoCompletedInvoicesQueryBuilder = DwQueryBuilderGen<RoCompletedInvoicesEntity, RoCompletedInvoicesMetaDataAttributes,RoCompletedInvoicesMetaDataRelations>


export class RoCompletedInvoicesMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roCompletedInvoices';
    // Attributes
    InvoiceControlNumber = new DwItemAttribute(this.i, 'InvoiceControlNumber');
}

class RoCompletedInvoicesMetaDataRelations implements DwItemRelationshipCollection {
    };
export class RoCourseEndorsementStudentActiveMetaData implements DwItem2<RoCourseEndorsementStudentActiveEntity, RoCourseEndorsementStudentActiveMetaDataAttributes,RoCourseEndorsementStudentActiveMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=396;
        this.ItemDetail.itemName='roCourseEndorsementStudentActive';
        this.ItemDetail.keyName='';
    }

    CreateEntity(): RoCourseEndorsementStudentActiveEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoCourseEndorsementStudentActiveQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoCourseEndorsementStudentActiveEntity, RoCourseEndorsementStudentActiveMetaDataAttributes,RoCourseEndorsementStudentActiveMetaDataRelations>(query, this);
    }
     Attributes = new RoCourseEndorsementStudentActiveMetaDataAttributes();
     Relations = new RoCourseEndorsementStudentActiveMetaDataRelations();

}


export type RoCourseEndorsementStudentActiveQueryBuilder = DwQueryBuilderGen<RoCourseEndorsementStudentActiveEntity, RoCourseEndorsementStudentActiveMetaDataAttributes,RoCourseEndorsementStudentActiveMetaDataRelations>


export class RoCourseEndorsementStudentActiveMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roCourseEndorsementStudentActive';
    // Attributes
    CourseEndorsementStudentId = new DwItemAttribute(this.i, 'CourseEndorsementStudentId');
    CourseEndorsementId = new DwItemAttribute(this.i, 'CourseEndorsementId');
    StudentCourseId = new DwItemAttribute(this.i, 'StudentCourseId');
    CompletionDateTime = new DwItemAttribute(this.i, 'CompletionDateTime');
    ExpirationDateTime = new DwItemAttribute(this.i, 'ExpirationDateTime');
    EndorsementPDFMediaId = new DwItemAttribute(this.i, 'EndorsementPDFMediaId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    CourseEndorsementStudentStatusId = new DwItemAttribute(this.i, 'CourseEndorsementStudentStatusId');
    UniqueColumn = new DwItemAttribute(this.i, 'UniqueColumn');
}

class RoCourseEndorsementStudentActiveMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Student Course */
            StudentCourse = new DwItemRelationship('StudentCourse|RoCourseEndorsementStudentActive|StudentCourseId', 'StudentCourse', 'StudentCourse');
    };
export class RoCourseModuleLessonMetaData implements DwItem2<RoCourseModuleLessonEntity, RoCourseModuleLessonMetaDataAttributes,RoCourseModuleLessonMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=464;
        this.ItemDetail.itemName='roCourseModuleLesson';
        this.ItemDetail.keyName='';
    }

    CreateEntity(): RoCourseModuleLessonEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoCourseModuleLessonQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoCourseModuleLessonEntity, RoCourseModuleLessonMetaDataAttributes,RoCourseModuleLessonMetaDataRelations>(query, this);
    }
     Attributes = new RoCourseModuleLessonMetaDataAttributes();
     Relations = new RoCourseModuleLessonMetaDataRelations();

}


export type RoCourseModuleLessonQueryBuilder = DwQueryBuilderGen<RoCourseModuleLessonEntity, RoCourseModuleLessonMetaDataAttributes,RoCourseModuleLessonMetaDataRelations>


export class RoCourseModuleLessonMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roCourseModuleLesson';
    // Attributes
    CourseId = new DwItemAttribute(this.i, 'CourseId');
    CourseName = new DwItemAttribute(this.i, 'CourseName');
    CourseModuleId = new DwItemAttribute(this.i, 'CourseModuleId');
    ModuleName = new DwItemAttribute(this.i, 'ModuleName');
    ModuleOrder = new DwItemAttribute(this.i, 'ModuleOrder');
    CourseLessonId = new DwItemAttribute(this.i, 'CourseLessonId');
    LessonName = new DwItemAttribute(this.i, 'LessonName');
    LessonOrder = new DwItemAttribute(this.i, 'LessonOrder');
    QuizId = new DwItemAttribute(this.i, 'QuizId');
    LessonTypeId = new DwItemAttribute(this.i, 'LessonTypeId');
    VideoId = new DwItemAttribute(this.i, 'VideoId');
}

class RoCourseModuleLessonMetaDataRelations implements DwItemRelationshipCollection {
    };
export class RoFlightSchoolAdminsMetaData implements DwItem2<RoFlightSchoolAdminsEntity, RoFlightSchoolAdminsMetaDataAttributes,RoFlightSchoolAdminsMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=286;
        this.ItemDetail.itemName='roFlightSchoolAdmins';
        this.ItemDetail.keyName='';
    }

    CreateEntity(): RoFlightSchoolAdminsEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoFlightSchoolAdminsQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoFlightSchoolAdminsEntity, RoFlightSchoolAdminsMetaDataAttributes,RoFlightSchoolAdminsMetaDataRelations>(query, this);
    }
     Attributes = new RoFlightSchoolAdminsMetaDataAttributes();
     Relations = new RoFlightSchoolAdminsMetaDataRelations();

}


export type RoFlightSchoolAdminsQueryBuilder = DwQueryBuilderGen<RoFlightSchoolAdminsEntity, RoFlightSchoolAdminsMetaDataAttributes,RoFlightSchoolAdminsMetaDataRelations>


export class RoFlightSchoolAdminsMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roFlightSchoolAdmins';
    // Attributes
    UserId = new DwItemAttribute(this.i, 'UserId');
    UserDetailId = new DwItemAttribute(this.i, 'UserDetailId');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    Email = new DwItemAttribute(this.i, 'Email');
    FirstName = new DwItemAttribute(this.i, 'FirstName');
    LastName = new DwItemAttribute(this.i, 'LastName');
}

class RoFlightSchoolAdminsMetaDataRelations implements DwItemRelationshipCollection {
    };
export class RoFlightSchoolCoursePackageCountMetaData implements DwItem2<RoFlightSchoolCoursePackageCountEntity, RoFlightSchoolCoursePackageCountMetaDataAttributes,RoFlightSchoolCoursePackageCountMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=304;
        this.ItemDetail.itemName='roFlightSchoolCoursePackageCount';
        this.ItemDetail.keyName='';
    }

    CreateEntity(): RoFlightSchoolCoursePackageCountEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoFlightSchoolCoursePackageCountQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoFlightSchoolCoursePackageCountEntity, RoFlightSchoolCoursePackageCountMetaDataAttributes,RoFlightSchoolCoursePackageCountMetaDataRelations>(query, this);
    }
     Attributes = new RoFlightSchoolCoursePackageCountMetaDataAttributes();
     Relations = new RoFlightSchoolCoursePackageCountMetaDataRelations();

}


export type RoFlightSchoolCoursePackageCountQueryBuilder = DwQueryBuilderGen<RoFlightSchoolCoursePackageCountEntity, RoFlightSchoolCoursePackageCountMetaDataAttributes,RoFlightSchoolCoursePackageCountMetaDataRelations>


export class RoFlightSchoolCoursePackageCountMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roFlightSchoolCoursePackageCount';
    // Attributes
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    FlightSchoolName = new DwItemAttribute(this.i, 'FlightSchoolName');
    CourseCount = new DwItemAttribute(this.i, 'CourseCount');
    PackageCount = new DwItemAttribute(this.i, 'PackageCount');
}

class RoFlightSchoolCoursePackageCountMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School */
            FlightSchool = new DwItemRelationship('FlightSchool|RoFlightSchoolCoursePackageCount', 'FlightSchool', 'FlightSchool');
    };
export class RoFlightSchoolCourseUniqueMetaData implements DwItem2<RoFlightSchoolCourseUniqueEntity, RoFlightSchoolCourseUniqueMetaDataAttributes,RoFlightSchoolCourseUniqueMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=194;
        this.ItemDetail.itemName='roFlightSchoolCourseUnique';
        this.ItemDetail.keyName='FlightSchoolId';
    }

    CreateEntity(): RoFlightSchoolCourseUniqueEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoFlightSchoolCourseUniqueQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoFlightSchoolCourseUniqueEntity, RoFlightSchoolCourseUniqueMetaDataAttributes,RoFlightSchoolCourseUniqueMetaDataRelations>(query, this);
    }
     Attributes = new RoFlightSchoolCourseUniqueMetaDataAttributes();
     Relations = new RoFlightSchoolCourseUniqueMetaDataRelations();

}


export type RoFlightSchoolCourseUniqueQueryBuilder = DwQueryBuilderGen<RoFlightSchoolCourseUniqueEntity, RoFlightSchoolCourseUniqueMetaDataAttributes,RoFlightSchoolCourseUniqueMetaDataRelations>


export class RoFlightSchoolCourseUniqueMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roFlightSchoolCourseUnique';
    // Attributes
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    CourseId = new DwItemAttribute(this.i, 'CourseId');
}

class RoFlightSchoolCourseUniqueMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Course */
            Course = new DwItemRelationship('Course|RoFlightSchoolCourseUnique', 'Course', 'Course');
            /** Relation: Flight School */
            FlightSchool = new DwItemRelationship('FlightSchool|RoFlightSchoolCourseUnique', 'FlightSchool', 'FlightSchool');
    };
export class RoFlightSchoolPaymentInfoMetaData implements DwItem2<RoFlightSchoolPaymentInfoEntity, RoFlightSchoolPaymentInfoMetaDataAttributes,RoFlightSchoolPaymentInfoMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=410;
        this.ItemDetail.itemName='roFlightSchoolPaymentInfo';
        this.ItemDetail.keyName='';
    }

    CreateEntity(): RoFlightSchoolPaymentInfoEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoFlightSchoolPaymentInfoQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoFlightSchoolPaymentInfoEntity, RoFlightSchoolPaymentInfoMetaDataAttributes,RoFlightSchoolPaymentInfoMetaDataRelations>(query, this);
    }
     Attributes = new RoFlightSchoolPaymentInfoMetaDataAttributes();
     Relations = new RoFlightSchoolPaymentInfoMetaDataRelations();

}


export type RoFlightSchoolPaymentInfoQueryBuilder = DwQueryBuilderGen<RoFlightSchoolPaymentInfoEntity, RoFlightSchoolPaymentInfoMetaDataAttributes,RoFlightSchoolPaymentInfoMetaDataRelations>


export class RoFlightSchoolPaymentInfoMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roFlightSchoolPaymentInfo';
    // Attributes
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    ProcessorConfigId = new DwItemAttribute(this.i, 'ProcessorConfigId');
    ProcessorConfigIsActive = new DwItemAttribute(this.i, 'ProcessorConfigIsActive');
    DefaultPaymentMethodId = new DwItemAttribute(this.i, 'DefaultPaymentMethodId');
    PaymentMethodDisplayName = new DwItemAttribute(this.i, 'PaymentMethodDisplayName');
    PaymentMethodIsActive = new DwItemAttribute(this.i, 'PaymentMethodIsActive');
    PaymentMethodIsDefault = new DwItemAttribute(this.i, 'PaymentMethodIsDefault');
    HasDefaultPaymentMethod = new DwItemAttribute(this.i, 'HasDefaultPaymentMethod');
}

class RoFlightSchoolPaymentInfoMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School */
            FlightSchool = new DwItemRelationship('FlightSchool|RoFlightSchoolPaymentInfo|FlightSchoolId', 'FlightSchool', 'FlightSchool');
    };
export class RoInstructorAssignmentsPerWeekMetaData implements DwItem2<RoInstructorAssignmentsPerWeekEntity, RoInstructorAssignmentsPerWeekMetaDataAttributes,RoInstructorAssignmentsPerWeekMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=387;
        this.ItemDetail.itemName='roInstructorAssignmentsPerWeek';
        this.ItemDetail.keyName='';
    }

    CreateEntity(): RoInstructorAssignmentsPerWeekEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoInstructorAssignmentsPerWeekQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoInstructorAssignmentsPerWeekEntity, RoInstructorAssignmentsPerWeekMetaDataAttributes,RoInstructorAssignmentsPerWeekMetaDataRelations>(query, this);
    }
     Attributes = new RoInstructorAssignmentsPerWeekMetaDataAttributes();
     Relations = new RoInstructorAssignmentsPerWeekMetaDataRelations();

}


export type RoInstructorAssignmentsPerWeekQueryBuilder = DwQueryBuilderGen<RoInstructorAssignmentsPerWeekEntity, RoInstructorAssignmentsPerWeekMetaDataAttributes,RoInstructorAssignmentsPerWeekMetaDataRelations>


export class RoInstructorAssignmentsPerWeekMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roInstructorAssignmentsPerWeek';
    // Attributes
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    InstructorId = new DwItemAttribute(this.i, 'InstructorId');
    Week = new DwItemAttribute(this.i, 'Week');
    AssignedWeekEndingDate = new DwItemAttribute(this.i, 'AssignedWeekEndingDate');
    AssignmentCount = new DwItemAttribute(this.i, 'AssignmentCount');
    CourseId = new DwItemAttribute(this.i, 'CourseId');
}

class RoInstructorAssignmentsPerWeekMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Instructor */
            Instructor = new DwItemRelationship('Instructor|RoInstructorAssignmentsPerWeek|InstructorId', 'Instructor', 'Instructor');
    };
export class RoIntegationCouresPurchaseMetaData implements DwItem2<RoIntegationCouresPurchaseEntity, RoIntegationCouresPurchaseMetaDataAttributes,RoIntegationCouresPurchaseMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=367;
        this.ItemDetail.itemName='RoIntegationCouresPurchase';
        this.ItemDetail.keyName='IntegrationCoursePurchaseKey';
    }

    CreateEntity(): RoIntegationCouresPurchaseEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoIntegationCouresPurchaseQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoIntegationCouresPurchaseEntity, RoIntegationCouresPurchaseMetaDataAttributes,RoIntegationCouresPurchaseMetaDataRelations>(query, this);
    }
     Attributes = new RoIntegationCouresPurchaseMetaDataAttributes();
     Relations = new RoIntegationCouresPurchaseMetaDataRelations();

}


export type RoIntegationCouresPurchaseQueryBuilder = DwQueryBuilderGen<RoIntegationCouresPurchaseEntity, RoIntegationCouresPurchaseMetaDataAttributes,RoIntegationCouresPurchaseMetaDataRelations>


export class RoIntegationCouresPurchaseMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'RoIntegationCouresPurchase';
    // Attributes
    IntegrationCoursePurchaseKey = new DwItemAttribute(this.i, 'IntegrationCoursePurchaseKey');
    RecordType = new DwItemAttribute(this.i, 'RecordType');
    PurchaseStatusId = new DwItemAttribute(this.i, 'PurchaseStatusId');
    CourseId = new DwItemAttribute(this.i, 'CourseId');
    IntegrationOrganizationId = new DwItemAttribute(this.i, 'IntegrationOrganizationId');
    UserFullName = new DwItemAttribute(this.i, 'UserFullName');
    UserEmail = new DwItemAttribute(this.i, 'UserEmail');
    RecordKey = new DwItemAttribute(this.i, 'RecordKey');
    HasRequest = new DwItemAttribute(this.i, 'HasRequest');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class RoIntegationCouresPurchaseMetaDataRelations implements DwItemRelationshipCollection {
    };
export class DwRoleMetaData implements DwItem2<DwRoleEntity, DwRoleMetaDataAttributes,DwRoleMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=41;
        this.ItemDetail.itemName='dw_Role';
        this.ItemDetail.keyName='RoleId';
    }

    CreateEntity(): DwRoleEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwRoleQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwRoleEntity, DwRoleMetaDataAttributes,DwRoleMetaDataRelations>(query, this);
    }
     Attributes = new DwRoleMetaDataAttributes();
     Relations = new DwRoleMetaDataRelations();

}


export type DwRoleQueryBuilder = DwQueryBuilderGen<DwRoleEntity, DwRoleMetaDataAttributes,DwRoleMetaDataRelations>


export class DwRoleMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_Role';
    // Attributes
    ApplicationId = new DwItemAttribute(this.i, 'ApplicationId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    IsBuiltIn = new DwItemAttribute(this.i, 'IsBuiltIn');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    RoleDisplay = new DwItemAttribute(this.i, 'RoleDisplay');
    RoleId = new DwItemAttribute(this.i, 'RoleId');
    RoleMeaning = new DwItemAttribute(this.i, 'RoleMeaning');
    UniqueId = new DwItemAttribute(this.i, 'UniqueId');
}

class DwRoleMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Join Request Type Role */
            JoinRequestTypeRole = new DwItemRelationship('dw_Role|JoinRequestTypeRole|RoleId', 'JoinRequestTypeRole', 'JoinRequestTypeRole');
            /** Relation: Subscription Role - Devware - Many */
            SubscriptionRoleByDevwareRoleId = new DwItemRelationship('dw_Role|SubscriptionRole|DevwareRoleId', 'DevwareSubscriptionRole', 'DevwareSubscriptionRole');
            /** Relation: User Role */
            DwUserRole = new DwItemRelationship('dw_Role|dw_UserRole|RoleId', 'DwUserRole', 'DwUserRole');
    };
export class RoLessonQuizStatsMetaData implements DwItem2<RoLessonQuizStatsEntity, RoLessonQuizStatsMetaDataAttributes,RoLessonQuizStatsMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=388;
        this.ItemDetail.itemName='roLessonQuizStats';
        this.ItemDetail.keyName='';
    }

    CreateEntity(): RoLessonQuizStatsEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoLessonQuizStatsQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoLessonQuizStatsEntity, RoLessonQuizStatsMetaDataAttributes,RoLessonQuizStatsMetaDataRelations>(query, this);
    }
     Attributes = new RoLessonQuizStatsMetaDataAttributes();
     Relations = new RoLessonQuizStatsMetaDataRelations();

}


export type RoLessonQuizStatsQueryBuilder = DwQueryBuilderGen<RoLessonQuizStatsEntity, RoLessonQuizStatsMetaDataAttributes,RoLessonQuizStatsMetaDataRelations>


export class RoLessonQuizStatsMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roLessonQuizStats';
    // Attributes
    StudentId = new DwItemAttribute(this.i, 'StudentId');
    UserId = new DwItemAttribute(this.i, 'UserId');
    StudentName = new DwItemAttribute(this.i, 'StudentName');
    FirstName = new DwItemAttribute(this.i, 'FirstName');
    LastName = new DwItemAttribute(this.i, 'LastName');
    MediaPath = new DwItemAttribute(this.i, 'MediaPath');
    StudentCourseId = new DwItemAttribute(this.i, 'StudentCourseId');
    LastActivityDateTime = new DwItemAttribute(this.i, 'LastActivityDateTime');
    PercentComplete = new DwItemAttribute(this.i, 'PercentComplete');
    TotalTimeSeconds = new DwItemAttribute(this.i, 'TotalTimeSeconds');
    CompletedDateTime = new DwItemAttribute(this.i, 'CompletedDateTime');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    FirstActivityDateTime = new DwItemAttribute(this.i, 'FirstActivityDateTime');
    CourseId = new DwItemAttribute(this.i, 'CourseId');
    CourseName = new DwItemAttribute(this.i, 'CourseName');
    CourseModuleId = new DwItemAttribute(this.i, 'CourseModuleId');
    ModuleName = new DwItemAttribute(this.i, 'ModuleName');
    SessionStartDateTime = new DwItemAttribute(this.i, 'SessionStartDateTime');
    SessionEndDateTime = new DwItemAttribute(this.i, 'SessionEndDateTime');
    CourseLessonId = new DwItemAttribute(this.i, 'CourseLessonId');
    LessonName = new DwItemAttribute(this.i, 'LessonName');
    LessonCompleted = new DwItemAttribute(this.i, 'LessonCompleted');
    PercentageScore = new DwItemAttribute(this.i, 'PercentageScore');
    QuizResultStatusId = new DwItemAttribute(this.i, 'QuizResultStatusId');
    ProgressReset = new DwItemAttribute(this.i, 'ProgressReset');
    QuizPassed = new DwItemAttribute(this.i, 'QuizPassed');
    QuizFailed = new DwItemAttribute(this.i, 'QuizFailed');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    FlightSchoolName = new DwItemAttribute(this.i, 'FlightSchoolName');
    CourseTotalTimeSeconds = new DwItemAttribute(this.i, 'CourseTotalTimeSeconds');
    SessionTimeSeconds = new DwItemAttribute(this.i, 'SessionTimeSeconds');
}

class RoLessonQuizStatsMetaDataRelations implements DwItemRelationshipCollection {
    };
export class DwRoMediaMetaData implements DwItem2<DwRoMediaEntity, DwRoMediaMetaDataAttributes,DwRoMediaMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=71;
        this.ItemDetail.itemName='dw_roMedia';
        this.ItemDetail.keyName='MediaId';
    }

    CreateEntity(): DwRoMediaEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwRoMediaQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwRoMediaEntity, DwRoMediaMetaDataAttributes,DwRoMediaMetaDataRelations>(query, this);
    }
     Attributes = new DwRoMediaMetaDataAttributes();
     Relations = new DwRoMediaMetaDataRelations();

}


export type DwRoMediaQueryBuilder = DwQueryBuilderGen<DwRoMediaEntity, DwRoMediaMetaDataAttributes,DwRoMediaMetaDataRelations>


export class DwRoMediaMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_roMedia';
    // Attributes
    ContainerName = new DwItemAttribute(this.i, 'ContainerName');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    FileName = new DwItemAttribute(this.i, 'FileName');
    ImageHeight = new DwItemAttribute(this.i, 'ImageHeight');
    ImageWidth = new DwItemAttribute(this.i, 'ImageWidth');
    IsDeleted = new DwItemAttribute(this.i, 'IsDeleted');
    IsSecure = new DwItemAttribute(this.i, 'IsSecure');
    MediaDetailKey = new DwItemAttribute(this.i, 'MediaDetailKey');
    MediaFolderId = new DwItemAttribute(this.i, 'MediaFolderId');
    MediaGroupId = new DwItemAttribute(this.i, 'MediaGroupId');
    MediaId = new DwItemAttribute(this.i, 'MediaId');
    MediaName = new DwItemAttribute(this.i, 'MediaName');
    MediaPath = new DwItemAttribute(this.i, 'MediaPath');
    MediaSizeType = new DwItemAttribute(this.i, 'MediaSizeType');
    MediaSizeTypeId = new DwItemAttribute(this.i, 'MediaSizeTypeId');
    MediaTypeId = new DwItemAttribute(this.i, 'MediaTypeId');
    SizeInBytes = new DwItemAttribute(this.i, 'SizeInBytes');
    Version = new DwItemAttribute(this.i, 'Version');
}

class DwRoMediaMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Media */
            DwMedia = new DwItemRelationship('roMedia|Media|MediaId', 'DwMedia', 'DwMedia');
            /** Relation: Media Group */
            DwMediaGroup = new DwItemRelationship('MediaGroup_roMedia', 'DwMediaGroup', 'DwMediaGroup');
            /** Relation: Course - Media - Many */
            CourseByCourseImageMediaId = new DwItemRelationship('Course|roMedia', 'CourseImageCourse', 'CourseImageCourse');
            /** Relation: Lesson - Media - Many */
            CourseLessonByLessonImageMediaId = new DwItemRelationship('RoMedia|CourseLesson|LessonImageMediaId', 'LessonImageCourseLesson', 'LessonImageCourseLesson');
            /** Relation: Module - Media - Many */
            CourseModuleByModuleImageMediaId = new DwItemRelationship('CourseModule|roMedia', 'ModuleImageCourseModule', 'ModuleImageCourseModule');
            /** Relation: Question - Media - Many */
            QuestionByQuestionImageMediaId = new DwItemRelationship('Question|RoMedia|QuestionImageMediaId', 'QuestionImageQuestion', 'QuestionImageQuestion');
            /** Relation: Question - Media - Many */
            QuestionByCorrectAnswerImageMediaId = new DwItemRelationship('Question|RoMedia|CorrectAnswerImageMediaId', 'CorrectAnswerImageQuestion', 'CorrectAnswerImageQuestion');
            /** Relation: Standard Login Media */
            StandardLoginMedia = new DwItemRelationship('StandardLoginMedia_roMedia', 'StandardLoginMedia', 'StandardLoginMedia');
    };
export class RoModuleLessonMaxOrderMetaData implements DwItem2<RoModuleLessonMaxOrderEntity, RoModuleLessonMaxOrderMetaDataAttributes,RoModuleLessonMaxOrderMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=164;
        this.ItemDetail.itemName='roModuleLessonMaxOrder';
        this.ItemDetail.keyName='';
    }

    CreateEntity(): RoModuleLessonMaxOrderEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoModuleLessonMaxOrderQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoModuleLessonMaxOrderEntity, RoModuleLessonMaxOrderMetaDataAttributes,RoModuleLessonMaxOrderMetaDataRelations>(query, this);
    }
     Attributes = new RoModuleLessonMaxOrderMetaDataAttributes();
     Relations = new RoModuleLessonMaxOrderMetaDataRelations();

}


export type RoModuleLessonMaxOrderQueryBuilder = DwQueryBuilderGen<RoModuleLessonMaxOrderEntity, RoModuleLessonMaxOrderMetaDataAttributes,RoModuleLessonMaxOrderMetaDataRelations>


export class RoModuleLessonMaxOrderMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roModuleLessonMaxOrder';
    // Attributes
    CourseId = new DwItemAttribute(this.i, 'CourseId');
    CourseName = new DwItemAttribute(this.i, 'CourseName');
    CourseModuleId = new DwItemAttribute(this.i, 'CourseModuleId');
    ModuleName = new DwItemAttribute(this.i, 'ModuleName');
    ModuleMaxOrder = new DwItemAttribute(this.i, 'ModuleMaxOrder');
    LessonMaxOrder = new DwItemAttribute(this.i, 'LessonMaxOrder');
}

class RoModuleLessonMaxOrderMetaDataRelations implements DwItemRelationshipCollection {
    };
export class RoPostLoginSummaryMetaData implements DwItem2<RoPostLoginSummaryEntity, RoPostLoginSummaryMetaDataAttributes,RoPostLoginSummaryMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=488;
        this.ItemDetail.itemName='roPostLoginSummary';
        this.ItemDetail.keyName='UserId';
    }

    CreateEntity(): RoPostLoginSummaryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoPostLoginSummaryQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoPostLoginSummaryEntity, RoPostLoginSummaryMetaDataAttributes,RoPostLoginSummaryMetaDataRelations>(query, this);
    }
     Attributes = new RoPostLoginSummaryMetaDataAttributes();
     Relations = new RoPostLoginSummaryMetaDataRelations();

}


export type RoPostLoginSummaryQueryBuilder = DwQueryBuilderGen<RoPostLoginSummaryEntity, RoPostLoginSummaryMetaDataAttributes,RoPostLoginSummaryMetaDataRelations>


export class RoPostLoginSummaryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roPostLoginSummary';
    // Attributes
    UserId = new DwItemAttribute(this.i, 'UserId');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    StudentId = new DwItemAttribute(this.i, 'StudentId');
    OnboardingVersion = new DwItemAttribute(this.i, 'OnboardingVersion');
    IsStudent = new DwItemAttribute(this.i, 'IsStudent');
    IsInstructor = new DwItemAttribute(this.i, 'IsInstructor');
    IsLeadInstructor = new DwItemAttribute(this.i, 'IsLeadInstructor');
    IsFlightSchoolAdmin = new DwItemAttribute(this.i, 'IsFlightSchoolAdmin');
    IsFlightSchool = new DwItemAttribute(this.i, 'IsFlightSchool');
    PendingTermsCount = new DwItemAttribute(this.i, 'PendingTermsCount');
    PendingDocumentCount = new DwItemAttribute(this.i, 'PendingDocumentCount');
    PendingAssignmentCount = new DwItemAttribute(this.i, 'PendingAssignmentCount');
}

class RoPostLoginSummaryMetaDataRelations implements DwItemRelationshipCollection {
    };
export class RoProductMetaData implements DwItem2<RoProductEntity, RoProductMetaDataAttributes,RoProductMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=283;
        this.ItemDetail.itemName='roProduct';
        this.ItemDetail.keyName='';
    }

    CreateEntity(): RoProductEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoProductQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoProductEntity, RoProductMetaDataAttributes,RoProductMetaDataRelations>(query, this);
    }
     Attributes = new RoProductMetaDataAttributes();
     Relations = new RoProductMetaDataRelations();

}


export type RoProductQueryBuilder = DwQueryBuilderGen<RoProductEntity, RoProductMetaDataAttributes,RoProductMetaDataRelations>


export class RoProductMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roProduct';
    // Attributes
    ProductName = new DwItemAttribute(this.i, 'ProductName');
    ProductId = new DwItemAttribute(this.i, 'ProductId');
    CourseId = new DwItemAttribute(this.i, 'CourseId');
    PackageId = new DwItemAttribute(this.i, 'PackageId');
    SubscriptionTierId = new DwItemAttribute(this.i, 'SubscriptionTierId');
    RetailPrice = new DwItemAttribute(this.i, 'RetailPrice');
    StripeProductId = new DwItemAttribute(this.i, 'StripeProductId');
    StripPriceId = new DwItemAttribute(this.i, 'StripPriceId');
    ProductTypeId = new DwItemAttribute(this.i, 'ProductTypeId');
    MediaPath = new DwItemAttribute(this.i, 'MediaPath');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class RoProductMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Product */
            Product = new DwItemRelationship('Product|roProduct|ProductId', 'Product', 'Product');
            /** Relation: Profit Share */
            ProfitShareByProductId = new DwItemRelationship('ProfitShare|roProduct|ProductId', 'ProfitShareProductId', 'ProfitShareProductId');
    };
export class RoSchoolAssignmentStatsMetaData implements DwItem2<RoSchoolAssignmentStatsEntity, RoSchoolAssignmentStatsMetaDataAttributes,RoSchoolAssignmentStatsMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=386;
        this.ItemDetail.itemName='roSchoolAssignmentStats';
        this.ItemDetail.keyName='';
    }

    CreateEntity(): RoSchoolAssignmentStatsEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoSchoolAssignmentStatsQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoSchoolAssignmentStatsEntity, RoSchoolAssignmentStatsMetaDataAttributes,RoSchoolAssignmentStatsMetaDataRelations>(query, this);
    }
     Attributes = new RoSchoolAssignmentStatsMetaDataAttributes();
     Relations = new RoSchoolAssignmentStatsMetaDataRelations();

}


export type RoSchoolAssignmentStatsQueryBuilder = DwQueryBuilderGen<RoSchoolAssignmentStatsEntity, RoSchoolAssignmentStatsMetaDataAttributes,RoSchoolAssignmentStatsMetaDataRelations>


export class RoSchoolAssignmentStatsMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roSchoolAssignmentStats';
    // Attributes
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    FlightSchoolName = new DwItemAttribute(this.i, 'FlightSchoolName');
    CourseId = new DwItemAttribute(this.i, 'CourseId');
    CourseName = new DwItemAttribute(this.i, 'CourseName');
    AssignmentId = new DwItemAttribute(this.i, 'AssignmentId');
    AssignmentCreatedDateTime = new DwItemAttribute(this.i, 'AssignmentCreatedDateTime');
    DueDateTime = new DwItemAttribute(this.i, 'DueDateTime');
    AssignmentStatusId = new DwItemAttribute(this.i, 'AssignmentStatusId');
    AssignmentPastDue = new DwItemAttribute(this.i, 'AssignmentPastDue');
}

class RoSchoolAssignmentStatsMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Assignment Student */
            AssignmentStudentByAssignmentId = new DwItemRelationship('AssignmentStudent|RoSchoolAssignmentStat|AssignmentId', 'AssignmentStudentAssignmentId', 'AssignmentStudentAssignmentId');
            /** Relation: Ro School Course Enrollment Stats */
            RoSchoolCourseEnrollmentStats = new DwItemRelationship('RoSchoolCourseEnrollmentStats|RoSchoolAssignmentStats|FlightSchoolId', 'RoSchoolCourseEnrollmentStats', 'RoSchoolCourseEnrollmentStats');
    };
export class RoSchoolBillingDetailsMetaData implements DwItem2<RoSchoolBillingDetailsEntity, RoSchoolBillingDetailsMetaDataAttributes,RoSchoolBillingDetailsMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=269;
        this.ItemDetail.itemName='roSchoolBillingDetails';
        this.ItemDetail.keyName='FlightSchoolId';
    }

    CreateEntity(): RoSchoolBillingDetailsEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoSchoolBillingDetailsQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoSchoolBillingDetailsEntity, RoSchoolBillingDetailsMetaDataAttributes,RoSchoolBillingDetailsMetaDataRelations>(query, this);
    }
     Attributes = new RoSchoolBillingDetailsMetaDataAttributes();
     Relations = new RoSchoolBillingDetailsMetaDataRelations();

}


export type RoSchoolBillingDetailsQueryBuilder = DwQueryBuilderGen<RoSchoolBillingDetailsEntity, RoSchoolBillingDetailsMetaDataAttributes,RoSchoolBillingDetailsMetaDataRelations>


export class RoSchoolBillingDetailsMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roSchoolBillingDetails';
    // Attributes
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    School = new DwItemAttribute(this.i, 'School');
    SchoolStatus = new DwItemAttribute(this.i, 'SchoolStatus');
    Tier = new DwItemAttribute(this.i, 'Tier');
    ProfitSharingRate = new DwItemAttribute(this.i, 'ProfitSharingRate');
    Count = new DwItemAttribute(this.i, 'Count');
    SubscriptionRoleId = new DwItemAttribute(this.i, 'SubscriptionRoleId');
    Role = new DwItemAttribute(this.i, 'Role');
    ProfitSharingAmountCurrentMonth = new DwItemAttribute(this.i, 'ProfitSharingAmountCurrentMonth');
    CurrentMonthShort = new DwItemAttribute(this.i, 'CurrentMonthShort');
    CurrentMonthLong = new DwItemAttribute(this.i, 'CurrentMonthLong');
}

class RoSchoolBillingDetailsMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School */
            FlightSchool = new DwItemRelationship('roSchoolBillingDetails|FlightSchool|FlightSchoolId', 'FlightSchool', 'FlightSchool');
            /** Relation: Subscription - Tier */
            SubscriptionByTier = new DwItemRelationship('roSchoolBillingDetails|SubscriptionTier|SubscriptionTierId', 'TierSubscription', 'TierSubscription');
            /** Relation: Subscription Role */
            SubscriptionRole = new DwItemRelationship('roSchoolBillingDetails|SubscriptionRole|SubscriptionRoled', 'SubscriptionRole', 'SubscriptionRole');
    };
export class RoSchoolCourseEnrollmentStatsMetaData implements DwItem2<RoSchoolCourseEnrollmentStatsEntity, RoSchoolCourseEnrollmentStatsMetaDataAttributes,RoSchoolCourseEnrollmentStatsMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=385;
        this.ItemDetail.itemName='roSchoolCourseEnrollmentStats';
        this.ItemDetail.keyName='StudentCourseId';
    }

    CreateEntity(): RoSchoolCourseEnrollmentStatsEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoSchoolCourseEnrollmentStatsQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoSchoolCourseEnrollmentStatsEntity, RoSchoolCourseEnrollmentStatsMetaDataAttributes,RoSchoolCourseEnrollmentStatsMetaDataRelations>(query, this);
    }
     Attributes = new RoSchoolCourseEnrollmentStatsMetaDataAttributes();
     Relations = new RoSchoolCourseEnrollmentStatsMetaDataRelations();

}


export type RoSchoolCourseEnrollmentStatsQueryBuilder = DwQueryBuilderGen<RoSchoolCourseEnrollmentStatsEntity, RoSchoolCourseEnrollmentStatsMetaDataAttributes,RoSchoolCourseEnrollmentStatsMetaDataRelations>


export class RoSchoolCourseEnrollmentStatsMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roSchoolCourseEnrollmentStats';
    // Attributes
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    FlightSchoolName = new DwItemAttribute(this.i, 'FlightSchoolName');
    CourseId = new DwItemAttribute(this.i, 'CourseId');
    CourseName = new DwItemAttribute(this.i, 'CourseName');
    StudentId = new DwItemAttribute(this.i, 'StudentId');
    UserId = new DwItemAttribute(this.i, 'UserId');
    StudentName = new DwItemAttribute(this.i, 'StudentName');
    LastActivityDateTime = new DwItemAttribute(this.i, 'LastActivityDateTime');
    PercentComplete = new DwItemAttribute(this.i, 'PercentComplete');
    TotalTimeSeconds = new DwItemAttribute(this.i, 'TotalTimeSeconds');
    CompletedDateTime = new DwItemAttribute(this.i, 'CompletedDateTime');
    FirstActivityDateTime = new DwItemAttribute(this.i, 'FirstActivityDateTime');
    ActiveStudent = new DwItemAttribute(this.i, 'ActiveStudent');
    IsComplete = new DwItemAttribute(this.i, 'IsComplete');
    InProgressTotalTimeSeconds = new DwItemAttribute(this.i, 'InProgressTotalTimeSeconds');
    CompletedTotalTimeSeconds = new DwItemAttribute(this.i, 'CompletedTotalTimeSeconds');
    InProgressPercentComplete = new DwItemAttribute(this.i, 'InProgressPercentComplete');
    AcsTestPassedFirstTime = new DwItemAttribute(this.i, 'AcsTestPassedFirstTime');
    AcsTestUploaded = new DwItemAttribute(this.i, 'AcsTestUploaded');
    AcsTestPassed = new DwItemAttribute(this.i, 'AcsTestPassed');
    AcsAwaitingUpload = new DwItemAttribute(this.i, 'AcsAwaitingUpload');
    PastDueAssignments = new DwItemAttribute(this.i, 'PastDueAssignments');
    ProgressDaysLearningLastActivity = new DwItemAttribute(this.i, 'ProgressDaysLearningLastActivity');
    ProgressPercentPerDayLastActivity = new DwItemAttribute(this.i, 'ProgressPercentPerDayLastActivity');
    LearningTimePerDayLastActivity = new DwItemAttribute(this.i, 'LearningTimePerDayLastActivity');
    ProgressDaysLearningNow = new DwItemAttribute(this.i, 'ProgressDaysLearningNow');
    ProgressPercentPerDayNow = new DwItemAttribute(this.i, 'ProgressPercentPerDayNow');
    LearningTimePerDayNow = new DwItemAttribute(this.i, 'LearningTimePerDayNow');
    FirstName = new DwItemAttribute(this.i, 'FirstName');
    LastName = new DwItemAttribute(this.i, 'LastName');
    MediaPath = new DwItemAttribute(this.i, 'MediaPath');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    StudentCourseId = new DwItemAttribute(this.i, 'StudentCourseId');
    AcsTestAverageScore = new DwItemAttribute(this.i, 'AcsTestAverageScore');
    HideInReporting = new DwItemAttribute(this.i, 'HideInReporting');
}

class RoSchoolCourseEnrollmentStatsMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Instructor Student */
            InstructorStudentByStudentId = new DwItemRelationship('InstructorStudent|RoSchoolCourseEnrollmentStats|StudentId', 'InstructorStudentStudentId', 'InstructorStudentStudentId');
            /** Relation: Student Course Lock Instructor */
            StudentCourseLockInstructorByStudentCourseId = new DwItemRelationship('StudentCourseLockInstructor|RoSchoolCourseEnrollmentStats', 'StudentCourseLockInstructorStudentCourseId', 'StudentCourseLockInstructorStudentCourseId');
            /** Relation: Ro School Assignment Stats */
            RoSchoolAssignmentStats = new DwItemRelationship('RoSchoolCourseEnrollmentStats|RoSchoolAssignmentStats|FlightSchoolId', 'RoSchoolAssignmentStats', 'RoSchoolAssignmentStats');
            /** Relation: Ro Student Course Instructor */
            RoStudentCourseInstructor = new DwItemRelationship('RoStudentCourseEnrollmentStats|RoStudentCourseInstructor|StudentCourseId', 'RoStudentCourseInstructor', 'RoStudentCourseInstructor');
    };
export class RoSchoolInvoicesMetaData implements DwItem2<RoSchoolInvoicesEntity, RoSchoolInvoicesMetaDataAttributes,RoSchoolInvoicesMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=259;
        this.ItemDetail.itemName='roSchoolInvoices';
        this.ItemDetail.keyName='RelatedInvoiceId';
    }

    CreateEntity(): RoSchoolInvoicesEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoSchoolInvoicesQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoSchoolInvoicesEntity, RoSchoolInvoicesMetaDataAttributes,RoSchoolInvoicesMetaDataRelations>(query, this);
    }
     Attributes = new RoSchoolInvoicesMetaDataAttributes();
     Relations = new RoSchoolInvoicesMetaDataRelations();

}


export type RoSchoolInvoicesQueryBuilder = DwQueryBuilderGen<RoSchoolInvoicesEntity, RoSchoolInvoicesMetaDataAttributes,RoSchoolInvoicesMetaDataRelations>


export class RoSchoolInvoicesMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roSchoolInvoices';
    // Attributes
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    InvoiceId = new DwItemAttribute(this.i, 'InvoiceId');
    InvoiceDate = new DwItemAttribute(this.i, 'InvoiceDate');
    InvoiceAmount = new DwItemAttribute(this.i, 'InvoiceAmount');
    InvoiceControlNumber = new DwItemAttribute(this.i, 'InvoiceControlNumber');
    RelatedInvoiceId = new DwItemAttribute(this.i, 'RelatedInvoiceId');
}

class RoSchoolInvoicesMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School */
            FlightSchool = new DwItemRelationship('roSchoolInvoices|Invoices|FlightSchoolId', 'FlightSchool', 'FlightSchool');
            /** Relation: Invoice */
            Invoice = new DwItemRelationship('Invoices|roSchoolInvoices|InvoiceId', 'Invoice', 'Invoice');
    };
export class RoSchoolPaymentMethodMetaData implements DwItem2<RoSchoolPaymentMethodEntity, RoSchoolPaymentMethodMetaDataAttributes,RoSchoolPaymentMethodMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=270;
        this.ItemDetail.itemName='roSchoolPaymentMethod';
        this.ItemDetail.keyName='PaymentMethodId';
    }

    CreateEntity(): RoSchoolPaymentMethodEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoSchoolPaymentMethodQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoSchoolPaymentMethodEntity, RoSchoolPaymentMethodMetaDataAttributes,RoSchoolPaymentMethodMetaDataRelations>(query, this);
    }
     Attributes = new RoSchoolPaymentMethodMetaDataAttributes();
     Relations = new RoSchoolPaymentMethodMetaDataRelations();

}


export type RoSchoolPaymentMethodQueryBuilder = DwQueryBuilderGen<RoSchoolPaymentMethodEntity, RoSchoolPaymentMethodMetaDataAttributes,RoSchoolPaymentMethodMetaDataRelations>


export class RoSchoolPaymentMethodMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roSchoolPaymentMethod';
    // Attributes
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    ProcessorConfigId = new DwItemAttribute(this.i, 'ProcessorConfigId');
    Displayname = new DwItemAttribute(this.i, 'Displayname');
    PaymentMethodId = new DwItemAttribute(this.i, 'PaymentMethodId');
    PaymentId = new DwItemAttribute(this.i, 'PaymentId');
    SetupIntentId = new DwItemAttribute(this.i, 'SetupIntentId');
    BillingName = new DwItemAttribute(this.i, 'BillingName');
    BillingEmail = new DwItemAttribute(this.i, 'BillingEmail');
    IsDefault = new DwItemAttribute(this.i, 'IsDefault');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    BillingPostalCode = new DwItemAttribute(this.i, 'BillingPostalCode');
    ProcessConfigActive = new DwItemAttribute(this.i, 'ProcessConfigActive');
}

class RoSchoolPaymentMethodMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School */
            FlightSchool = new DwItemRelationship('roSchoolPaymentMethod|FlightSchool|FlightSchoolId', 'FlightSchool', 'FlightSchool');
            /** Relation: Processor Config */
            ProcessorConfig = new DwItemRelationship('roSchoolPaymentMethod|ProcessConfig|ProcessorConfigId', 'ProcessorConfig', 'ProcessorConfig');
    };
export class RoSchoolStudentStatsMetaData implements DwItem2<RoSchoolStudentStatsEntity, RoSchoolStudentStatsMetaDataAttributes,RoSchoolStudentStatsMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=378;
        this.ItemDetail.itemName='roSchoolStudentStats';
        this.ItemDetail.keyName='FlightSchoolId';
    }

    CreateEntity(): RoSchoolStudentStatsEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoSchoolStudentStatsQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoSchoolStudentStatsEntity, RoSchoolStudentStatsMetaDataAttributes,RoSchoolStudentStatsMetaDataRelations>(query, this);
    }
     Attributes = new RoSchoolStudentStatsMetaDataAttributes();
     Relations = new RoSchoolStudentStatsMetaDataRelations();

}


export type RoSchoolStudentStatsQueryBuilder = DwQueryBuilderGen<RoSchoolStudentStatsEntity, RoSchoolStudentStatsMetaDataAttributes,RoSchoolStudentStatsMetaDataRelations>


export class RoSchoolStudentStatsMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roSchoolStudentStats';
    // Attributes
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    FlightSchoolName = new DwItemAttribute(this.i, 'FlightSchoolName');
    EnrolledCount = new DwItemAttribute(this.i, 'EnrolledCount');
    EndorsedCount = new DwItemAttribute(this.i, 'EndorsedCount');
    AssignmentsThisWeekCount = new DwItemAttribute(this.i, 'AssignmentsThisWeekCount');
    AssignmentPastDueCount = new DwItemAttribute(this.i, 'AssignmentPastDueCount');
}

class RoSchoolStudentStatsMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School */
            FlightSchool = new DwItemRelationship('FlightSchool|RoSchoolStudentStats|FlightSchoolId', 'FlightSchool', 'FlightSchool');
    };
export class RoSchoolSubscriptionMetaData implements DwItem2<RoSchoolSubscriptionEntity, RoSchoolSubscriptionMetaDataAttributes,RoSchoolSubscriptionMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=268;
        this.ItemDetail.itemName='roSchoolSubscription';
        this.ItemDetail.keyName='';
    }

    CreateEntity(): RoSchoolSubscriptionEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoSchoolSubscriptionQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoSchoolSubscriptionEntity, RoSchoolSubscriptionMetaDataAttributes,RoSchoolSubscriptionMetaDataRelations>(query, this);
    }
     Attributes = new RoSchoolSubscriptionMetaDataAttributes();
     Relations = new RoSchoolSubscriptionMetaDataRelations();

}


export type RoSchoolSubscriptionQueryBuilder = DwQueryBuilderGen<RoSchoolSubscriptionEntity, RoSchoolSubscriptionMetaDataAttributes,RoSchoolSubscriptionMetaDataRelations>


export class RoSchoolSubscriptionMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roSchoolSubscription';
    // Attributes
    SubscriptionId = new DwItemAttribute(this.i, 'SubscriptionId');
    SubscriptionTierId = new DwItemAttribute(this.i, 'SubscriptionTierId');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    EffectiveStartDate = new DwItemAttribute(this.i, 'EffectiveStartDate');
    EffectiveEndDate = new DwItemAttribute(this.i, 'EffectiveEndDate');
    SubscriptionStatus = new DwItemAttribute(this.i, 'SubscriptionStatus');
    PendingSubscriptionId = new DwItemAttribute(this.i, 'PendingSubscriptionId');
    PendingSubscriptionTierId = new DwItemAttribute(this.i, 'PendingSubscriptionTierId');
    Pending = new DwItemAttribute(this.i, 'Pending');
    PreviousSubscriptionId = new DwItemAttribute(this.i, 'PreviousSubscriptionId');
    PreviousSubscriptionTierId = new DwItemAttribute(this.i, 'PreviousSubscriptionTierId');
}

class RoSchoolSubscriptionMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Subscription - Pending Subscription */
            SubscriptionByPendingSubscriptionId = new DwItemRelationship('roSchoolSubscription|Subscription|PendingSubscriptionId', 'PendingSubscription', 'PendingSubscription');
            /** Relation: Subscription */
            Subscription = new DwItemRelationship('roSchoolSubscription|Subscription|SubscriptionId', 'Subscription', 'Subscription');
            /** Relation: Subscription - Previous Subscription */
            SubscriptionByPreviousSubscriptionId = new DwItemRelationship('roSchoolSubscription|Subscription|PreviousSubscriptionId', 'PreviousSubscription', 'PreviousSubscription');
    };
export class RoStudentCourseAcsTestResultDetailMetaData implements DwItem2<RoStudentCourseAcsTestResultDetailEntity, RoStudentCourseAcsTestResultDetailMetaDataAttributes,RoStudentCourseAcsTestResultDetailMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=350;
        this.ItemDetail.itemName='RoStudentCourseAcsTestResultDetail';
        this.ItemDetail.keyName='';
    }

    CreateEntity(): RoStudentCourseAcsTestResultDetailEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoStudentCourseAcsTestResultDetailQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoStudentCourseAcsTestResultDetailEntity, RoStudentCourseAcsTestResultDetailMetaDataAttributes,RoStudentCourseAcsTestResultDetailMetaDataRelations>(query, this);
    }
     Attributes = new RoStudentCourseAcsTestResultDetailMetaDataAttributes();
     Relations = new RoStudentCourseAcsTestResultDetailMetaDataRelations();

}


export type RoStudentCourseAcsTestResultDetailQueryBuilder = DwQueryBuilderGen<RoStudentCourseAcsTestResultDetailEntity, RoStudentCourseAcsTestResultDetailMetaDataAttributes,RoStudentCourseAcsTestResultDetailMetaDataRelations>


export class RoStudentCourseAcsTestResultDetailMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'RoStudentCourseAcsTestResultDetail';
    // Attributes
    StudentCourseId = new DwItemAttribute(this.i, 'StudentCourseId');
    ACSTestResultCount = new DwItemAttribute(this.i, 'ACSTestResultCount');
    PassedAny = new DwItemAttribute(this.i, 'PassedAny');
    FailedAny = new DwItemAttribute(this.i, 'FailedAny');
}

class RoStudentCourseAcsTestResultDetailMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Student Course */
            StudentCourse = new DwItemRelationship('StudentCourse|RoStudentCourseAcsTestResultDetail|StudentCourseId', 'StudentCourse', 'StudentCourse');
    };
export class RoStudentCourseDetailMetaData implements DwItem2<RoStudentCourseDetailEntity, RoStudentCourseDetailMetaDataAttributes,RoStudentCourseDetailMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=380;
        this.ItemDetail.itemName='roStudentCourseDetail';
        this.ItemDetail.keyName='StudentCourseId';
    }

    CreateEntity(): RoStudentCourseDetailEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoStudentCourseDetailQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoStudentCourseDetailEntity, RoStudentCourseDetailMetaDataAttributes,RoStudentCourseDetailMetaDataRelations>(query, this);
    }
     Attributes = new RoStudentCourseDetailMetaDataAttributes();
     Relations = new RoStudentCourseDetailMetaDataRelations();

}


export type RoStudentCourseDetailQueryBuilder = DwQueryBuilderGen<RoStudentCourseDetailEntity, RoStudentCourseDetailMetaDataAttributes,RoStudentCourseDetailMetaDataRelations>


export class RoStudentCourseDetailMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roStudentCourseDetail';
    // Attributes
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    FlightSchoolName = new DwItemAttribute(this.i, 'FlightSchoolName');
    UserId = new DwItemAttribute(this.i, 'UserId');
    StudentName = new DwItemAttribute(this.i, 'StudentName');
    LastLoginDateTime = new DwItemAttribute(this.i, 'LastLoginDateTime');
    UserPictureMediaPath = new DwItemAttribute(this.i, 'UserPictureMediaPath');
    ImageWidth = new DwItemAttribute(this.i, 'ImageWidth');
    ImageHeight = new DwItemAttribute(this.i, 'ImageHeight');
    StudentId = new DwItemAttribute(this.i, 'StudentId');
    StudentCourseId = new DwItemAttribute(this.i, 'StudentCourseId');
    StudentCourseStatusId = new DwItemAttribute(this.i, 'StudentCourseStatusId');
    CourseId = new DwItemAttribute(this.i, 'CourseId');
    CourseName = new DwItemAttribute(this.i, 'CourseName');
    PercentComplete = new DwItemAttribute(this.i, 'PercentComplete');
    LastActivityDateTime = new DwItemAttribute(this.i, 'LastActivityDateTime');
    FirstActivityDateTime = new DwItemAttribute(this.i, 'FirstActivityDateTime');
    ModulesCount = new DwItemAttribute(this.i, 'ModulesCount');
    ModulesCompleted = new DwItemAttribute(this.i, 'ModulesCompleted');
    LessonCount = new DwItemAttribute(this.i, 'LessonCount');
    LessonsCompleted = new DwItemAttribute(this.i, 'LessonsCompleted');
    TotalTimeSeconds = new DwItemAttribute(this.i, 'TotalTimeSeconds');
    TotalVideoTimeSeconds = new DwItemAttribute(this.i, 'TotalVideoTimeSeconds');
    TotalQuizTimeSeconds = new DwItemAttribute(this.i, 'TotalQuizTimeSeconds');
    CompletedDateTime = new DwItemAttribute(this.i, 'CompletedDateTime');
    IsEndorsed = new DwItemAttribute(this.i, 'IsEndorsed');
    IsStudent = new DwItemAttribute(this.i, 'IsStudent');
    IsInstructor = new DwItemAttribute(this.i, 'IsInstructor');
    IsFlightSchoolAdmin = new DwItemAttribute(this.i, 'IsFlightSchoolAdmin');
    IsFlightSchool = new DwItemAttribute(this.i, 'IsFlightSchool');
}

class RoStudentCourseDetailMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School */
            FlightSchool = new DwItemRelationship('FlightSchool|RoStudentCourseDetail|FlightSchoolId', 'FlightSchool', 'FlightSchool');
    };
export class RoStudentCourseInstructorMetaData implements DwItem2<RoStudentCourseInstructorEntity, RoStudentCourseInstructorMetaDataAttributes,RoStudentCourseInstructorMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=394;
        this.ItemDetail.itemName='roStudentCourseInstructor';
        this.ItemDetail.keyName='';
    }

    CreateEntity(): RoStudentCourseInstructorEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoStudentCourseInstructorQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoStudentCourseInstructorEntity, RoStudentCourseInstructorMetaDataAttributes,RoStudentCourseInstructorMetaDataRelations>(query, this);
    }
     Attributes = new RoStudentCourseInstructorMetaDataAttributes();
     Relations = new RoStudentCourseInstructorMetaDataRelations();

}


export type RoStudentCourseInstructorQueryBuilder = DwQueryBuilderGen<RoStudentCourseInstructorEntity, RoStudentCourseInstructorMetaDataAttributes,RoStudentCourseInstructorMetaDataRelations>


export class RoStudentCourseInstructorMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roStudentCourseInstructor';
    // Attributes
    StudentCourseId = new DwItemAttribute(this.i, 'StudentCourseId');
    InstructorId = new DwItemAttribute(this.i, 'InstructorId');
}

class RoStudentCourseInstructorMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Instructor */
            Instructor = new DwItemRelationship('Instructor|RoStudentCourseInstructor|InstructorId', 'Instructor', 'Instructor');
            /** Relation: Student Course */
            StudentCourse = new DwItemRelationship('StudentCourse|RoStudentCourseInstructor|StudentCourseId', 'StudentCourse', 'StudentCourse');
            /** Relation: Ro School Course Enrollment Stats */
            RoSchoolCourseEnrollmentStats = new DwItemRelationship('RoStudentCourseEnrollmentStats|RoStudentCourseInstructor|StudentCourseId', 'RoSchoolCourseEnrollmentStats', 'RoSchoolCourseEnrollmentStats');
    };
export class RoStudentCourseProgressMismatchMetaData implements DwItem2<RoStudentCourseProgressMismatchEntity, RoStudentCourseProgressMismatchMetaDataAttributes,RoStudentCourseProgressMismatchMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=369;
        this.ItemDetail.itemName='roStudentCourseProgressMismatch';
        this.ItemDetail.keyName='';
    }

    CreateEntity(): RoStudentCourseProgressMismatchEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoStudentCourseProgressMismatchQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoStudentCourseProgressMismatchEntity, RoStudentCourseProgressMismatchMetaDataAttributes,RoStudentCourseProgressMismatchMetaDataRelations>(query, this);
    }
     Attributes = new RoStudentCourseProgressMismatchMetaDataAttributes();
     Relations = new RoStudentCourseProgressMismatchMetaDataRelations();

}


export type RoStudentCourseProgressMismatchQueryBuilder = DwQueryBuilderGen<RoStudentCourseProgressMismatchEntity, RoStudentCourseProgressMismatchMetaDataAttributes,RoStudentCourseProgressMismatchMetaDataRelations>


export class RoStudentCourseProgressMismatchMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roStudentCourseProgressMismatch';
    // Attributes
    StudentCourseId = new DwItemAttribute(this.i, 'StudentCourseId');
    LessonsCompleted = new DwItemAttribute(this.i, 'LessonsCompleted');
    LessonCount = new DwItemAttribute(this.i, 'LessonCount');
    LessonCompleteActual = new DwItemAttribute(this.i, 'LessonCompleteActual');
    LessonCountActual = new DwItemAttribute(this.i, 'LessonCountActual');
    ModulesCompleted = new DwItemAttribute(this.i, 'ModulesCompleted');
    ModulesCount = new DwItemAttribute(this.i, 'ModulesCount');
    ModuleCount = new DwItemAttribute(this.i, 'ModuleCount');
}

class RoStudentCourseProgressMismatchMetaDataRelations implements DwItemRelationshipCollection {
    };
export class RoStudentOverviewDetailsMetaData implements DwItem2<RoStudentOverviewDetailsEntity, RoStudentOverviewDetailsMetaDataAttributes,RoStudentOverviewDetailsMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=461;
        this.ItemDetail.itemName='roStudentOverviewDetails';
        this.ItemDetail.keyName='UserId';
    }

    CreateEntity(): RoStudentOverviewDetailsEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoStudentOverviewDetailsQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoStudentOverviewDetailsEntity, RoStudentOverviewDetailsMetaDataAttributes,RoStudentOverviewDetailsMetaDataRelations>(query, this);
    }
     Attributes = new RoStudentOverviewDetailsMetaDataAttributes();
     Relations = new RoStudentOverviewDetailsMetaDataRelations();

}


export type RoStudentOverviewDetailsQueryBuilder = DwQueryBuilderGen<RoStudentOverviewDetailsEntity, RoStudentOverviewDetailsMetaDataAttributes,RoStudentOverviewDetailsMetaDataRelations>


export class RoStudentOverviewDetailsMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roStudentOverviewDetails';
    // Attributes
    StudentId = new DwItemAttribute(this.i, 'StudentId');
    UserId = new DwItemAttribute(this.i, 'UserId');
    FullName = new DwItemAttribute(this.i, 'FullName');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    FlightSchoolName = new DwItemAttribute(this.i, 'FlightSchoolName');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    LastLoginDateTime = new DwItemAttribute(this.i, 'LastLoginDateTime');
    HighestRole = new DwItemAttribute(this.i, 'HighestRole');
    OverallProgressPercent = new DwItemAttribute(this.i, 'OverallProgressPercent');
    ActiveAssignments = new DwItemAttribute(this.i, 'ActiveAssignments');
    CompletedActiveAssignments = new DwItemAttribute(this.i, 'CompletedActiveAssignments');
    OverdueActiveAssignments = new DwItemAttribute(this.i, 'OverdueActiveAssignments');
}

class RoStudentOverviewDetailsMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: User */
            DwUser = new DwItemRelationship('User|RoStudentOverviewDetails|UserId', 'DwUser', 'DwUser');
    };
export class RoStudentPaymentMethodMetaData implements DwItem2<RoStudentPaymentMethodEntity, RoStudentPaymentMethodMetaDataAttributes,RoStudentPaymentMethodMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=295;
        this.ItemDetail.itemName='roStudentPaymentMethod';
        this.ItemDetail.keyName='PaymentMethodId';
    }

    CreateEntity(): RoStudentPaymentMethodEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoStudentPaymentMethodQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoStudentPaymentMethodEntity, RoStudentPaymentMethodMetaDataAttributes,RoStudentPaymentMethodMetaDataRelations>(query, this);
    }
     Attributes = new RoStudentPaymentMethodMetaDataAttributes();
     Relations = new RoStudentPaymentMethodMetaDataRelations();

}


export type RoStudentPaymentMethodQueryBuilder = DwQueryBuilderGen<RoStudentPaymentMethodEntity, RoStudentPaymentMethodMetaDataAttributes,RoStudentPaymentMethodMetaDataRelations>


export class RoStudentPaymentMethodMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roStudentPaymentMethod';
    // Attributes
    UserId = new DwItemAttribute(this.i, 'UserId');
    ProcessorConfigId = new DwItemAttribute(this.i, 'ProcessorConfigId');
    DisplayName = new DwItemAttribute(this.i, 'DisplayName');
    PaymentMethodId = new DwItemAttribute(this.i, 'PaymentMethodId');
    PaymentId = new DwItemAttribute(this.i, 'PaymentId');
    SetupIntentId = new DwItemAttribute(this.i, 'SetupIntentId');
    BillingName = new DwItemAttribute(this.i, 'BillingName');
    BillingEmail = new DwItemAttribute(this.i, 'BillingEmail');
    IsDefault = new DwItemAttribute(this.i, 'IsDefault');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    BillingPostalCode = new DwItemAttribute(this.i, 'BillingPostalCode');
    ProcessConfigActive = new DwItemAttribute(this.i, 'ProcessConfigActive');
}

class RoStudentPaymentMethodMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: User */
            DwUser = new DwItemRelationship('RoStudentPaymentMethod|User|UserId', 'DwUser', 'DwUser');
    };
export class RoStudentSchoolCoursesMetaData implements DwItem2<RoStudentSchoolCoursesEntity, RoStudentSchoolCoursesMetaDataAttributes,RoStudentSchoolCoursesMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=271;
        this.ItemDetail.itemName='roStudentSchoolCourses';
        this.ItemDetail.keyName='StudentCourseId';
    }

    CreateEntity(): RoStudentSchoolCoursesEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoStudentSchoolCoursesQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoStudentSchoolCoursesEntity, RoStudentSchoolCoursesMetaDataAttributes,RoStudentSchoolCoursesMetaDataRelations>(query, this);
    }
     Attributes = new RoStudentSchoolCoursesMetaDataAttributes();
     Relations = new RoStudentSchoolCoursesMetaDataRelations();

}


export type RoStudentSchoolCoursesQueryBuilder = DwQueryBuilderGen<RoStudentSchoolCoursesEntity, RoStudentSchoolCoursesMetaDataAttributes,RoStudentSchoolCoursesMetaDataRelations>


export class RoStudentSchoolCoursesMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roStudentSchoolCourses';
    // Attributes
    StudentId = new DwItemAttribute(this.i, 'StudentId');
    StudentCourseId = new DwItemAttribute(this.i, 'StudentCourseId');
    CourseId = new DwItemAttribute(this.i, 'CourseId');
    CourseName = new DwItemAttribute(this.i, 'CourseName');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    StudentName = new DwItemAttribute(this.i, 'StudentName');
    UserId = new DwItemAttribute(this.i, 'UserId');
}

class RoStudentSchoolCoursesMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Course */
            Course = new DwItemRelationship('RoStudentSchoolCourse|Course|CourseId', 'Course', 'Course');
            /** Relation: Flight School */
            FlightSchool = new DwItemRelationship('RoStudentSchoolCourse|FlightSchool|FlightSchoolId', 'FlightSchool', 'FlightSchool');
            /** Relation: Student */
            Student = new DwItemRelationship('RoStudentSchoolCourses|Student|StudentId', 'Student', 'Student');
            /** Relation: Student Course */
            StudentCourse = new DwItemRelationship('RoStudentSchoolCourse|StudentCourse|StudentCourseId', 'StudentCourse', 'StudentCourse');
            /** Relation: User */
            DwUser = new DwItemRelationship('RoStudentSchoolCourse|User|UserId', 'DwUser', 'DwUser');
    };
export class RoUserRoleDetailMetaData implements DwItem2<RoUserRoleDetailEntity, RoUserRoleDetailMetaDataAttributes,RoUserRoleDetailMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=219;
        this.ItemDetail.itemName='roUserRoleDetail';
        this.ItemDetail.keyName='UserId';
    }

    CreateEntity(): RoUserRoleDetailEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoUserRoleDetailQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoUserRoleDetailEntity, RoUserRoleDetailMetaDataAttributes,RoUserRoleDetailMetaDataRelations>(query, this);
    }
     Attributes = new RoUserRoleDetailMetaDataAttributes();
     Relations = new RoUserRoleDetailMetaDataRelations();

}


export type RoUserRoleDetailQueryBuilder = DwQueryBuilderGen<RoUserRoleDetailEntity, RoUserRoleDetailMetaDataAttributes,RoUserRoleDetailMetaDataRelations>


export class RoUserRoleDetailMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roUserRoleDetail';
    // Attributes
    UserId = new DwItemAttribute(this.i, 'UserId');
    IsStudent = new DwItemAttribute(this.i, 'IsStudent');
    IsInstructor = new DwItemAttribute(this.i, 'IsInstructor');
    IsLeadInstructor = new DwItemAttribute(this.i, 'IsLeadInstructor');
    IsFlightSchoolAdmin = new DwItemAttribute(this.i, 'IsFlightSchoolAdmin');
    IsFlightSchool = new DwItemAttribute(this.i, 'IsFlightSchool');
}

class RoUserRoleDetailMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: User */
            DwUser = new DwItemRelationship('RoUserRoleDetail|User|UserId', 'DwUser', 'DwUser');
    };
export class RptInvoiceProductDetailMetaData implements DwItem2<RptInvoiceProductDetailEntity, RptInvoiceProductDetailMetaDataAttributes,RptInvoiceProductDetailMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=301;
        this.ItemDetail.itemName='rptInvoiceProductDetail';
        this.ItemDetail.keyName='InvoiceLineId';
    }

    CreateEntity(): RptInvoiceProductDetailEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RptInvoiceProductDetailQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RptInvoiceProductDetailEntity, RptInvoiceProductDetailMetaDataAttributes,RptInvoiceProductDetailMetaDataRelations>(query, this);
    }
     Attributes = new RptInvoiceProductDetailMetaDataAttributes();
     Relations = new RptInvoiceProductDetailMetaDataRelations();

}


export type RptInvoiceProductDetailQueryBuilder = DwQueryBuilderGen<RptInvoiceProductDetailEntity, RptInvoiceProductDetailMetaDataAttributes,RptInvoiceProductDetailMetaDataRelations>


export class RptInvoiceProductDetailMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'rptInvoiceProductDetail';
    // Attributes
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    UserId = new DwItemAttribute(this.i, 'UserId');
    InvoiceStatusId = new DwItemAttribute(this.i, 'InvoiceStatusId');
    InvoiceId = new DwItemAttribute(this.i, 'InvoiceId');
    InvoiceNumber = new DwItemAttribute(this.i, 'InvoiceNumber');
    InvoiceStatus = new DwItemAttribute(this.i, 'InvoiceStatus');
    InvoiceTypeId = new DwItemAttribute(this.i, 'InvoiceTypeId');
    InvoiceType = new DwItemAttribute(this.i, 'InvoiceType');
    ProductId = new DwItemAttribute(this.i, 'ProductId');
    ProductName = new DwItemAttribute(this.i, 'ProductName');
    ProductTypeId = new DwItemAttribute(this.i, 'ProductTypeId');
    ProductType = new DwItemAttribute(this.i, 'ProductType');
    CourseId = new DwItemAttribute(this.i, 'CourseId');
    PackageId = new DwItemAttribute(this.i, 'PackageId');
    SubscriptionTierId = new DwItemAttribute(this.i, 'SubscriptionTierId');
    ItemCost = new DwItemAttribute(this.i, 'ItemCost');
    Quantity = new DwItemAttribute(this.i, 'Quantity');
    TotalCost = new DwItemAttribute(this.i, 'TotalCost');
    InvoiceLineId = new DwItemAttribute(this.i, 'InvoiceLineId');
    FlightSchoolName = new DwItemAttribute(this.i, 'FlightSchoolName');
    InvoiceDate = new DwItemAttribute(this.i, 'InvoiceDate');
    PaymentPartyTypeId = new DwItemAttribute(this.i, 'PaymentPartyTypeId');
    PaymentPartyType = new DwItemAttribute(this.i, 'PaymentPartyType');
    StudentName = new DwItemAttribute(this.i, 'StudentName');
}

class RptInvoiceProductDetailMetaDataRelations implements DwItemRelationshipCollection {
    };
export class RptProfitShareMetaData implements DwItem2<RptProfitShareEntity, RptProfitShareMetaDataAttributes,RptProfitShareMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=302;
        this.ItemDetail.itemName='rptProfitShare';
        this.ItemDetail.keyName='ProfitShareId';
    }

    CreateEntity(): RptProfitShareEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RptProfitShareQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RptProfitShareEntity, RptProfitShareMetaDataAttributes,RptProfitShareMetaDataRelations>(query, this);
    }
     Attributes = new RptProfitShareMetaDataAttributes();
     Relations = new RptProfitShareMetaDataRelations();

}


export type RptProfitShareQueryBuilder = DwQueryBuilderGen<RptProfitShareEntity, RptProfitShareMetaDataAttributes,RptProfitShareMetaDataRelations>


export class RptProfitShareMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'rptProfitShare';
    // Attributes
    ProfitShareId = new DwItemAttribute(this.i, 'ProfitShareId');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    FlightSchoolName = new DwItemAttribute(this.i, 'FlightSchoolName');
    StudentId = new DwItemAttribute(this.i, 'StudentId');
    StudentName = new DwItemAttribute(this.i, 'StudentName');
    ProductId = new DwItemAttribute(this.i, 'ProductId');
    ProductName = new DwItemAttribute(this.i, 'ProductName');
    ProductTypeId = new DwItemAttribute(this.i, 'ProductTypeId');
    ProductType = new DwItemAttribute(this.i, 'ProductType');
    CourseId = new DwItemAttribute(this.i, 'CourseId');
    PackageId = new DwItemAttribute(this.i, 'PackageId');
    SubscriptionTierId = new DwItemAttribute(this.i, 'SubscriptionTierId');
    RetailPrice = new DwItemAttribute(this.i, 'RetailPrice');
    ProfitSharingPercentage = new DwItemAttribute(this.i, 'ProfitSharingPercentage');
    ProfitSharingAmount = new DwItemAttribute(this.i, 'ProfitSharingAmount');
    ProfitShareStatusId = new DwItemAttribute(this.i, 'ProfitShareStatusId');
    ProfitShareStatus = new DwItemAttribute(this.i, 'ProfitShareStatus');
    ProfitShareTypeId = new DwItemAttribute(this.i, 'ProfitShareTypeId');
    ProfitShareType = new DwItemAttribute(this.i, 'ProfitShareType');
    InvoiceLineId = new DwItemAttribute(this.i, 'InvoiceLineId');
    InvoiceId = new DwItemAttribute(this.i, 'InvoiceId');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    PaymentPartyTypeId = new DwItemAttribute(this.i, 'PaymentPartyTypeId');
    PaymentPartyType = new DwItemAttribute(this.i, 'PaymentPartyType');
    Month = new DwItemAttribute(this.i, 'Month');
    Year = new DwItemAttribute(this.i, 'Year');
}

class RptProfitShareMetaDataRelations implements DwItemRelationshipCollection {
    };
export class SchoolBillingModeMetaData implements DwItem2<SchoolBillingModeEntity, SchoolBillingModeMetaDataAttributes,SchoolBillingModeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=506;
        this.ItemDetail.itemName='SchoolBillingMode';
        this.ItemDetail.keyName='SchoolBillingModeId';
    }

    CreateEntity(): SchoolBillingModeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): SchoolBillingModeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<SchoolBillingModeEntity, SchoolBillingModeMetaDataAttributes,SchoolBillingModeMetaDataRelations>(query, this);
    }
     Attributes = new SchoolBillingModeMetaDataAttributes();
     Relations = new SchoolBillingModeMetaDataRelations();

}


export type SchoolBillingModeQueryBuilder = DwQueryBuilderGen<SchoolBillingModeEntity, SchoolBillingModeMetaDataAttributes,SchoolBillingModeMetaDataRelations>


export class SchoolBillingModeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'SchoolBillingMode';
    // Attributes
    SchoolBillingModeId = new DwItemAttribute(this.i, 'SchoolBillingModeId');
    SchoolBillingMode = new DwItemAttribute(this.i, 'SchoolBillingMode');
    SchoolBillingModeDescription = new DwItemAttribute(this.i, 'SchoolBillingModeDescription');
    DeferredCoursePurchases = new DwItemAttribute(this.i, 'DeferredCoursePurchases');
    DeferredSubscriptionBilling = new DwItemAttribute(this.i, 'DeferredSubscriptionBilling');
    UsesPaymentTerms = new DwItemAttribute(this.i, 'UsesPaymentTerms');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class SchoolBillingModeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School */
            FlightSchool = new DwItemRelationship('SchoolBillingMode|FlightSchool|SchoolBillingModeId', 'FlightSchool', 'FlightSchool');
            /** Relation: School Billing Policy Period */
            SchoolBillingPolicyPeriod = new DwItemRelationship('SchoolBillingMode|SchoolBillingPolicyPeriod|SchoolBillingModeId', 'SchoolBillingPolicyPeriod', 'SchoolBillingPolicyPeriod');
    };
export class SchoolBillingPolicyPeriodMetaData implements DwItem2<SchoolBillingPolicyPeriodEntity, SchoolBillingPolicyPeriodMetaDataAttributes,SchoolBillingPolicyPeriodMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=504;
        this.ItemDetail.itemName='SchoolBillingPolicyPeriod';
        this.ItemDetail.keyName='SchoolBillingPolicyPeriodId';
    }

    CreateEntity(): SchoolBillingPolicyPeriodEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): SchoolBillingPolicyPeriodQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<SchoolBillingPolicyPeriodEntity, SchoolBillingPolicyPeriodMetaDataAttributes,SchoolBillingPolicyPeriodMetaDataRelations>(query, this);
    }
     Attributes = new SchoolBillingPolicyPeriodMetaDataAttributes();
     Relations = new SchoolBillingPolicyPeriodMetaDataRelations();

}


export type SchoolBillingPolicyPeriodQueryBuilder = DwQueryBuilderGen<SchoolBillingPolicyPeriodEntity, SchoolBillingPolicyPeriodMetaDataAttributes,SchoolBillingPolicyPeriodMetaDataRelations>


export class SchoolBillingPolicyPeriodMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'SchoolBillingPolicyPeriod';
    // Attributes
    SchoolBillingPolicyPeriodId = new DwItemAttribute(this.i, 'SchoolBillingPolicyPeriodId');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    EffectiveStartDate = new DwItemAttribute(this.i, 'EffectiveStartDate');
    EffectiveEndDate = new DwItemAttribute(this.i, 'EffectiveEndDate');
    BillingTimeZone = new DwItemAttribute(this.i, 'BillingTimeZone');
    ReviewNotes = new DwItemAttribute(this.i, 'ReviewNotes');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    SchoolBillingModeId = new DwItemAttribute(this.i, 'SchoolBillingModeId');
}

class SchoolBillingPolicyPeriodMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School */
            FlightSchool = new DwItemRelationship('FlightSchool|SchoolBillingPolicyPeriod|FlightSchoolId', 'FlightSchool', 'FlightSchool');
            /** Relation: School Billing Mode */
            SchoolBillingMode = new DwItemRelationship('SchoolBillingMode|SchoolBillingPolicyPeriod|SchoolBillingModeId', 'SchoolBillingMode', 'SchoolBillingMode');
    };
export class SchoolFeatureMetaData implements DwItem2<SchoolFeatureEntity, SchoolFeatureMetaDataAttributes,SchoolFeatureMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=377;
        this.ItemDetail.itemName='SchoolFeature';
        this.ItemDetail.keyName='SchoolFeatureId';
    }

    CreateEntity(): SchoolFeatureEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): SchoolFeatureQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<SchoolFeatureEntity, SchoolFeatureMetaDataAttributes,SchoolFeatureMetaDataRelations>(query, this);
    }
     Attributes = new SchoolFeatureMetaDataAttributes();
     Relations = new SchoolFeatureMetaDataRelations();

}


export type SchoolFeatureQueryBuilder = DwQueryBuilderGen<SchoolFeatureEntity, SchoolFeatureMetaDataAttributes,SchoolFeatureMetaDataRelations>


export class SchoolFeatureMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'SchoolFeature';
    // Attributes
    SchoolFeatureId = new DwItemAttribute(this.i, 'SchoolFeatureId');
    SchoolFeature = new DwItemAttribute(this.i, 'SchoolFeature');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    IsDefault = new DwItemAttribute(this.i, 'IsDefault');
}

class SchoolFeatureMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School Feature */
            FlightSchoolFeature = new DwItemRelationship('SchoolFeature|FlightSchoolFeature|SchoolFeatureId', 'FlightSchoolFeature', 'FlightSchoolFeature');
    };
export class StandardColorSetMetaData implements DwItem2<StandardColorSetEntity, StandardColorSetMetaDataAttributes,StandardColorSetMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=251;
        this.ItemDetail.itemName='StandardColorSet';
        this.ItemDetail.keyName='StandardColorSetId';
    }

    CreateEntity(): StandardColorSetEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): StandardColorSetQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<StandardColorSetEntity, StandardColorSetMetaDataAttributes,StandardColorSetMetaDataRelations>(query, this);
    }
     Attributes = new StandardColorSetMetaDataAttributes();
     Relations = new StandardColorSetMetaDataRelations();

}


export type StandardColorSetQueryBuilder = DwQueryBuilderGen<StandardColorSetEntity, StandardColorSetMetaDataAttributes,StandardColorSetMetaDataRelations>


export class StandardColorSetMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'StandardColorSet';
    // Attributes
    StandardColorSetId = new DwItemAttribute(this.i, 'StandardColorSetId');
    ForegroundColor = new DwItemAttribute(this.i, 'ForegroundColor');
    BackgroundColor = new DwItemAttribute(this.i, 'BackgroundColor');
    ColorSetName = new DwItemAttribute(this.i, 'ColorSetName');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class StandardColorSetMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School Branding - Navigation Color Set - Many */
            FlightSchoolBrandingByNavigationColorSetId = new DwItemRelationship('StandardColorSet|FlightSchoolBranding|NavigationColorSetId', 'NavigationColorSetIdFlightSchoolBranding', 'NavigationColorSetIdFlightSchoolBranding');
            /** Relation: Flight School Branding - Sidebar Color Set - Many */
            FlightSchoolBrandingBySidebarColorSetId = new DwItemRelationship('StandardColorSet|FlightSchoolBranding|SidebarColorSetId', 'SidebarColorSetIdFlightSchoolBranding', 'SidebarColorSetIdFlightSchoolBranding');
            /** Relation: Flight School Branding - Login Color Set - Many */
            FlightSchoolBrandingByLoginColorSetId = new DwItemRelationship('StandardColorSet|FlightSchoolBranding|LoginColorSetId', 'LoginColorSetIdFlightSchoolBranding', 'LoginColorSetIdFlightSchoolBranding');
    };
export class StandardLoginMediaMetaData implements DwItem2<StandardLoginMediaEntity, StandardLoginMediaMetaDataAttributes,StandardLoginMediaMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=444;
        this.ItemDetail.itemName='StandardLoginMedia';
        this.ItemDetail.keyName='StandardLoginMediaId';
    }

    CreateEntity(): StandardLoginMediaEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): StandardLoginMediaQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<StandardLoginMediaEntity, StandardLoginMediaMetaDataAttributes,StandardLoginMediaMetaDataRelations>(query, this);
    }
     Attributes = new StandardLoginMediaMetaDataAttributes();
     Relations = new StandardLoginMediaMetaDataRelations();

}


export type StandardLoginMediaQueryBuilder = DwQueryBuilderGen<StandardLoginMediaEntity, StandardLoginMediaMetaDataAttributes,StandardLoginMediaMetaDataRelations>


export class StandardLoginMediaMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'StandardLoginMedia';
    // Attributes
    StandardLoginMediaId = new DwItemAttribute(this.i, 'StandardLoginMediaId');
    LoginMediaName = new DwItemAttribute(this.i, 'LoginMediaName');
    MediaId = new DwItemAttribute(this.i, 'MediaId');
    ReferenceStatusId = new DwItemAttribute(this.i, 'ReferenceStatusId');
    IsDefault = new DwItemAttribute(this.i, 'IsDefault');
}

class StandardLoginMediaMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Ro Media */
            DwRoMedia = new DwItemRelationship('StandardLoginMedia_roMedia', 'DwroMedia', 'DwroMedia');
            /** Relation: Media */
            DwMedia = new DwItemRelationship('dw_Media|StandardLoginMedia|MediaId', 'DwMedia', 'DwMedia');
            /** Relation: Reference Status */
            ReferenceStatus = new DwItemRelationship('ReferenceStatus|StandardLoginMedia|ReferenceStatusId', 'ReferenceStatus', 'ReferenceStatus');
            /** Relation: Flight School Branding */
            FlightSchoolBranding = new DwItemRelationship('StandardLoginMedia|FlightSchoolBranding|StandardLoginMediaId', 'FlightSchoolBranding', 'FlightSchoolBranding');
    };
export class StateProvinceMetaData implements DwItem2<StateProvinceEntity, StateProvinceMetaDataAttributes,StateProvinceMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=206;
        this.ItemDetail.itemName='StateProvince';
        this.ItemDetail.keyName='StateProvinceId';
    }

    CreateEntity(): StateProvinceEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): StateProvinceQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<StateProvinceEntity, StateProvinceMetaDataAttributes,StateProvinceMetaDataRelations>(query, this);
    }
     Attributes = new StateProvinceMetaDataAttributes();
     Relations = new StateProvinceMetaDataRelations();

}


export type StateProvinceQueryBuilder = DwQueryBuilderGen<StateProvinceEntity, StateProvinceMetaDataAttributes,StateProvinceMetaDataRelations>


export class StateProvinceMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'StateProvince';
    // Attributes
    StateProvinceId = new DwItemAttribute(this.i, 'StateProvinceId');
    CountryId = new DwItemAttribute(this.i, 'CountryId');
    StateProvinceName = new DwItemAttribute(this.i, 'StateProvinceName');
    StateProvinceShortName = new DwItemAttribute(this.i, 'StateProvinceShortName');
    StateCode = new DwItemAttribute(this.i, 'StateCode');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
}

class StateProvinceMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Country */
            Country = new DwItemRelationship('Country|StateProvince|CountryId', 'Country', 'Country');
            /** Relation: Address */
            Address = new DwItemRelationship('StateProvince|Address|StateProvinceId', 'Address', 'Address');
            /** Relation: Postal Code */
            PostalCode = new DwItemRelationship('StateProvince|PostalCode|StateProvinceId', 'PostalCode', 'PostalCode');
    };
export class StripeCheckoutSessionMetaData implements DwItem2<StripeCheckoutSessionEntity, StripeCheckoutSessionMetaDataAttributes,StripeCheckoutSessionMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=345;
        this.ItemDetail.itemName='StripeCheckoutSession';
        this.ItemDetail.keyName='StripeCheckoutSessionId';
    }

    CreateEntity(): StripeCheckoutSessionEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): StripeCheckoutSessionQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<StripeCheckoutSessionEntity, StripeCheckoutSessionMetaDataAttributes,StripeCheckoutSessionMetaDataRelations>(query, this);
    }
     Attributes = new StripeCheckoutSessionMetaDataAttributes();
     Relations = new StripeCheckoutSessionMetaDataRelations();

}


export type StripeCheckoutSessionQueryBuilder = DwQueryBuilderGen<StripeCheckoutSessionEntity, StripeCheckoutSessionMetaDataAttributes,StripeCheckoutSessionMetaDataRelations>


export class StripeCheckoutSessionMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'StripeCheckoutSession';
    // Attributes
    StripeCheckoutSessionId = new DwItemAttribute(this.i, 'StripeCheckoutSessionId');
    PaymentEventId = new DwItemAttribute(this.i, 'PaymentEventId');
    SessionCompletedDateTime = new DwItemAttribute(this.i, 'SessionCompletedDateTime');
    PaymentLinkId = new DwItemAttribute(this.i, 'PaymentLinkId');
    CustomerName = new DwItemAttribute(this.i, 'CustomerName');
    CustomerEmail = new DwItemAttribute(this.i, 'CustomerEmail');
    CustomerAddressId = new DwItemAttribute(this.i, 'CustomerAddressId');
    SubtotalAmount = new DwItemAttribute(this.i, 'SubtotalAmount');
    DiscountAmount = new DwItemAttribute(this.i, 'DiscountAmount');
    DiscountId = new DwItemAttribute(this.i, 'DiscountId');
    TaxAmount = new DwItemAttribute(this.i, 'TaxAmount');
    PaidAmount = new DwItemAttribute(this.i, 'PaidAmount');
    StripeCustomerId = new DwItemAttribute(this.i, 'StripeCustomerId');
    LastLogId = new DwItemAttribute(this.i, 'LastLogId');
    StripeSessionId = new DwItemAttribute(this.i, 'StripeSessionId');
    StripeCheckoutSessionStatusId = new DwItemAttribute(this.i, 'StripeCheckoutSessionStatusId');
    ProductsDescription = new DwItemAttribute(this.i, 'ProductsDescription');
}

class StripeCheckoutSessionMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Address - Customer Address */
            AddressByCustomerAddressId = new DwItemRelationship('Address|StripeCheckoutSession|CustomerAddressId', 'CustomerAddress', 'CustomerAddress');
            /** Relation: Discount */
            Discount = new DwItemRelationship('Discount|StripeCheckoutSession|DiscountId', 'Discount', 'Discount');
            /** Relation: Payment Event */
            PaymentEvent = new DwItemRelationship('PaymentEvent|StripeCheckoutSession|PaymentEventId', 'PaymentEvent', 'PaymentEvent');
            /** Relation: Stripe Checkout Session Status */
            StripeCheckoutSessionStatus = new DwItemRelationship('StripeCheckoutSessionStatus|StripeCheckoutSession|StripCheckoutSessionStatusId', 'StripeCheckoutSessionStatus', 'StripeCheckoutSessionStatus');
            /** Relation: Course Purchase */
            CoursePurchase = new DwItemRelationship('StripeCheckoutSession|CoursePurchase|StripeCheckoutSessionId', 'CoursePurchase', 'CoursePurchase');
            /** Relation: Invoice */
            Invoice = new DwItemRelationship('StripeCheckoutSession|Invoice|StripeCheckoutSessionId', 'Invoice', 'Invoice');
            /** Relation: Stripe Checkout Session Product */
            StripeCheckoutSessionProduct = new DwItemRelationship('StripeCheckoutSession|StripeCheckoutSessionProduct|StripeCheckoutSessionId', 'StripeCheckoutSessionProduct', 'StripeCheckoutSessionProduct');
    };
export class StripeCheckoutSessionProductMetaData implements DwItem2<StripeCheckoutSessionProductEntity, StripeCheckoutSessionProductMetaDataAttributes,StripeCheckoutSessionProductMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=344;
        this.ItemDetail.itemName='StripeCheckoutSessionProduct';
        this.ItemDetail.keyName='StripeCheckoutSessionProductId';
    }

    CreateEntity(): StripeCheckoutSessionProductEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): StripeCheckoutSessionProductQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<StripeCheckoutSessionProductEntity, StripeCheckoutSessionProductMetaDataAttributes,StripeCheckoutSessionProductMetaDataRelations>(query, this);
    }
     Attributes = new StripeCheckoutSessionProductMetaDataAttributes();
     Relations = new StripeCheckoutSessionProductMetaDataRelations();

}


export type StripeCheckoutSessionProductQueryBuilder = DwQueryBuilderGen<StripeCheckoutSessionProductEntity, StripeCheckoutSessionProductMetaDataAttributes,StripeCheckoutSessionProductMetaDataRelations>


export class StripeCheckoutSessionProductMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'StripeCheckoutSessionProduct';
    // Attributes
    StripeCheckoutSessionProductId = new DwItemAttribute(this.i, 'StripeCheckoutSessionProductId');
    StripeCheckoutSessionId = new DwItemAttribute(this.i, 'StripeCheckoutSessionId');
    ProductId = new DwItemAttribute(this.i, 'ProductId');
}

class StripeCheckoutSessionProductMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Product */
            Product = new DwItemRelationship('Product|StripeCheckoutSessionProduct|ProductId', 'Product', 'Product');
            /** Relation: Stripe Checkout Session */
            StripeCheckoutSession = new DwItemRelationship('StripeCheckoutSession|StripeCheckoutSessionProduct|StripeCheckoutSessionId', 'StripeCheckoutSession', 'StripeCheckoutSession');
    };
export class StripeCheckoutSessionStatusMetaData implements DwItem2<StripeCheckoutSessionStatusEntity, StripeCheckoutSessionStatusMetaDataAttributes,StripeCheckoutSessionStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=343;
        this.ItemDetail.itemName='StripeCheckoutSessionStatus';
        this.ItemDetail.keyName='StripeCheckoutSessionStatusId';
    }

    CreateEntity(): StripeCheckoutSessionStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): StripeCheckoutSessionStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<StripeCheckoutSessionStatusEntity, StripeCheckoutSessionStatusMetaDataAttributes,StripeCheckoutSessionStatusMetaDataRelations>(query, this);
    }
     Attributes = new StripeCheckoutSessionStatusMetaDataAttributes();
     Relations = new StripeCheckoutSessionStatusMetaDataRelations();

}


export type StripeCheckoutSessionStatusQueryBuilder = DwQueryBuilderGen<StripeCheckoutSessionStatusEntity, StripeCheckoutSessionStatusMetaDataAttributes,StripeCheckoutSessionStatusMetaDataRelations>


export class StripeCheckoutSessionStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'StripeCheckoutSessionStatus';
    // Attributes
    StripeCheckoutSessionStatusId = new DwItemAttribute(this.i, 'StripeCheckoutSessionStatusId');
    StripeCheckoutSessionStatus = new DwItemAttribute(this.i, 'StripeCheckoutSessionStatus');
}

class StripeCheckoutSessionStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Stripe Checkout Session */
            StripeCheckoutSession = new DwItemRelationship('StripeCheckoutSessionStatus|StripeCheckoutSession|StripCheckoutSessionStatusId', 'StripeCheckoutSession', 'StripeCheckoutSession');
    };
export class StudentMetaData implements DwItem2<StudentEntity, StudentMetaDataAttributes,StudentMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=144;
        this.ItemDetail.itemName='Student';
        this.ItemDetail.keyName='StudentId';
    }

    CreateEntity(): StudentEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): StudentQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<StudentEntity, StudentMetaDataAttributes,StudentMetaDataRelations>(query, this);
    }
     Attributes = new StudentMetaDataAttributes();
     Relations = new StudentMetaDataRelations();

}


export type StudentQueryBuilder = DwQueryBuilderGen<StudentEntity, StudentMetaDataAttributes,StudentMetaDataRelations>


export class StudentMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Student';
    // Attributes
    StudentId = new DwItemAttribute(this.i, 'StudentId');
    UserId = new DwItemAttribute(this.i, 'UserId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    AddressId = new DwItemAttribute(this.i, 'AddressId');
    PilotCertificateNumber = new DwItemAttribute(this.i, 'PilotCertificateNumber');
    CitizenshipCountryId = new DwItemAttribute(this.i, 'CitizenshipCountryId');
    BirthDate = new DwItemAttribute(this.i, 'BirthDate');
    PilotTypeId = new DwItemAttribute(this.i, 'PilotTypeId');
    FlightSchoolPositionId = new DwItemAttribute(this.i, 'FlightSchoolPositionId');
    AcquisitionSourceId = new DwItemAttribute(this.i, 'AcquisitionSourceId');
    AcquisitionSourceOther = new DwItemAttribute(this.i, 'AcquisitionSourceOther');
    InstructorCertifcateNumber = new DwItemAttribute(this.i, 'InstructorCertifcateNumber');
    StudentCode = new DwItemAttribute(this.i, 'StudentCode');
    AviationGoalId = new DwItemAttribute(this.i, 'AviationGoalId');
    TimeZoneId = new DwItemAttribute(this.i, 'TimeZoneId');
}

class StudentMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Acquisition Source */
            AcquisitionSource = new DwItemRelationship('AcquisitionSource|Student|AcquisitionSourceId', 'AcquisitionSource', 'AcquisitionSource');
            /** Relation: Address */
            Address = new DwItemRelationship('Address|Student|AddressId', 'Address', 'Address');
            /** Relation: Aviation Goal */
            AviationGoal = new DwItemRelationship('AviationGoal|Student|AviationGoalId', 'AviationGoal', 'AviationGoal');
            /** Relation: Country - Citizenship Country */
            CountryByCitizenshipCountryId = new DwItemRelationship('Country|Student|CitizenshipCountryId', 'CitizenshipCountry', 'CitizenshipCountry');
            /** Relation: Flight School Position */
            FlightSchoolPosition = new DwItemRelationship('FlightSchoolPosistion|Student|FlightSchoolPositionId', 'FlightSchoolPosition', 'FlightSchoolPosition');
            /** Relation: Pilot Type */
            PilotType = new DwItemRelationship('PilotType|Student|PilotTypeId', 'PilotType', 'PilotType');
            /** Relation: Time Zone - Timezone */
            TimeZoneByTimeZoneId = new DwItemRelationship('TimeZone|Student|TimeZoneId', 'TimeZoneIdTimeZone', 'TimeZoneIdTimeZone');
            /** Relation: User */
            DwUser = new DwItemRelationship('dw_User|Student|UserId', 'DwUser', 'DwUser');
            /** Relation: Assignment Student */
            AssignmentStudent = new DwItemRelationship('Student|AssignmentStudent|StudentId', 'AssignmentStudent', 'AssignmentStudent');
            /** Relation: Course Purchase Reservation Course */
            CoursePurchaseReservationCourse = new DwItemRelationship('Student|CoursePurchaseReservationCourse|StudentId', 'CoursePurchaseReservationCourse', 'CoursePurchaseReservationCourse');
            /** Relation: Course Purchase Student */
            CoursePurchaseStudent = new DwItemRelationship('Student|CoursePurchaseStudent|StudentId', 'CoursePurchaseStudent', 'CoursePurchaseStudent');
            /** Relation: Daily Quiz */
            DailyQuiz = new DwItemRelationship('Student|DailyQuiz|StudentId', 'DailyQuiz', 'DailyQuiz');
            /** Relation: Document Item Acknowledgement */
            DocumentItemAcknowledgement = new DwItemRelationship('Student|DocumentItemAcknowledgement|StudentId', 'DocumentItemAcknowledgement', 'DocumentItemAcknowledgement');
            /** Relation: Flight School Group Student */
            FlightSchoolGroupStudent = new DwItemRelationship('Student|FlightSchoolGroupStudent|StudentId', 'FlightSchoolGroupStudent', 'FlightSchoolGroupStudent');
            /** Relation: Instructor Student */
            InstructorStudent = new DwItemRelationship('Student|InstructorStudent|StudentId', 'InstructorStudent', 'InstructorStudent');
            /** Relation: Join Request Course Purchase */
            JoinRequestCoursePurchase = new DwItemRelationship('Student|JoinRequestCoursePurchase|StudentId', 'JoinRequestCoursePurchase', 'JoinRequestCoursePurchase');
            /** Relation: Profit Share */
            ProfitShare = new DwItemRelationship('Student|ProfitShare|StudentId', 'ProfitShare', 'ProfitShare');
            /** Relation: Ro Student School Course */
            RoStudentSchoolCourses = new DwItemRelationship('RoStudentSchoolCourses|Student|StudentId', 'RoStudentSchoolCourses', 'RoStudentSchoolCourses');
            /** Relation: Student Achievement */
            StudentAchievement = new DwItemRelationship('Student|StudentAchievement|StudentId', 'StudentAchievement', 'StudentAchievement');
            /** Relation: Student Activity */
            StudentActivity = new DwItemRelationship('Student|StudentActivity|StudentId', 'StudentActivity', 'StudentActivity');
            /** Relation: Student Course */
            StudentCourse = new DwItemRelationship('Student|StudentCourse|StudentId', 'StudentCourse', 'StudentCourse');
            /** Relation: Student Gamification Day */
            StudentGamificationDay = new DwItemRelationship('Student|StudentGamificationDay|StudentId', 'StudentGamificationDay', 'StudentGamificationDay');
            /** Relation: Student Gamification Summary */
            StudentGamificationSummary = new DwItemRelationship('Student|StudentGamificationSummary|StudentId', 'StudentGamificationSummary', 'StudentGamificationSummary');
            /** Relation: Student Lesson Progress Event */
            StudentLessonProgressEvent = new DwItemRelationship('Student|StudentLessonProgressEvent|StudentId', 'StudentLessonProgressEvent', 'StudentLessonProgressEvent');
            /** Relation: Student Progress Reset Event */
            StudentProgressResetEvent = new DwItemRelationship('Student|StudentProgressResetEvent|StudentId', 'StudentProgressResetEvent', 'StudentProgressResetEvent');
            /** Relation: Student Weather Day Transaction */
            StudentWeatherDayTransaction = new DwItemRelationship('Student|StudentWeatherDayTransaction|StudentId', 'StudentWeatherDayTransaction', 'StudentWeatherDayTransaction');
            /** Relation: Subscription Course Tracking */
            SubscriptionCourseTracking = new DwItemRelationship('Student|SubscriptionCourseTracking|StudentId', 'SubscriptionCourseTracking', 'SubscriptionCourseTracking');
    };
export class StudentAchievementMetaData implements DwItem2<StudentAchievementEntity, StudentAchievementMetaDataAttributes,StudentAchievementMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=493;
        this.ItemDetail.itemName='StudentAchievement';
        this.ItemDetail.keyName='StudentAchievementId';
    }

    CreateEntity(): StudentAchievementEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): StudentAchievementQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<StudentAchievementEntity, StudentAchievementMetaDataAttributes,StudentAchievementMetaDataRelations>(query, this);
    }
     Attributes = new StudentAchievementMetaDataAttributes();
     Relations = new StudentAchievementMetaDataRelations();

}


export type StudentAchievementQueryBuilder = DwQueryBuilderGen<StudentAchievementEntity, StudentAchievementMetaDataAttributes,StudentAchievementMetaDataRelations>


export class StudentAchievementMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'StudentAchievement';
    // Attributes
    StudentAchievementId = new DwItemAttribute(this.i, 'StudentAchievementId');
    StudentId = new DwItemAttribute(this.i, 'StudentId');
    AchievementDefinitionId = new DwItemAttribute(this.i, 'AchievementDefinitionId');
    StudentCourseId = new DwItemAttribute(this.i, 'StudentCourseId');
    CurrentMetricValue = new DwItemAttribute(this.i, 'CurrentMetricValue');
    CurrentAchievementTierId = new DwItemAttribute(this.i, 'CurrentAchievementTierId');
    NextAchievementTierId = new DwItemAttribute(this.i, 'NextAchievementTierId');
    NextThreshold = new DwItemAttribute(this.i, 'NextThreshold');
    ProgressPercent = new DwItemAttribute(this.i, 'ProgressPercent');
    LastCalculatedDateTime = new DwItemAttribute(this.i, 'LastCalculatedDateTime');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class StudentAchievementMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Achievement Definition */
            AchievementDefinition = new DwItemRelationship('AchievementDefinition|StudentAchievement|AchievementDefinitionId', 'AchievementDefinition', 'AchievementDefinition');
            /** Relation: Achievement Tier - Current Achievement Tier */
            AchievementTierByCurrentAchievementTierId = new DwItemRelationship('AchievementTier|StudentAchievement|CurrentAchievementTierId', 'CurrentAchievementTier', 'CurrentAchievementTier');
            /** Relation: Achievement Tier - Next Achievement Tier */
            AchievementTierByNextAchievementTierId = new DwItemRelationship('AchievementTier|StudentAchievement|NextAchievementTierId', 'NextAchievementTier', 'NextAchievementTier');
            /** Relation: Student */
            Student = new DwItemRelationship('Student|StudentAchievement|StudentId', 'Student', 'Student');
            /** Relation: Student Course */
            StudentCourse = new DwItemRelationship('StudentCourse|StudentAchievement|StudentCourseId', 'StudentCourse', 'StudentCourse');
            /** Relation: Student Achievement Award */
            StudentAchievementAward = new DwItemRelationship('StudentAchievement|StudentAchievementAward|StudentAchievementId', 'StudentAchievementAward', 'StudentAchievementAward');
    };
export class StudentAchievementAwardMetaData implements DwItem2<StudentAchievementAwardEntity, StudentAchievementAwardMetaDataAttributes,StudentAchievementAwardMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=490;
        this.ItemDetail.itemName='StudentAchievementAward';
        this.ItemDetail.keyName='StudentAchievementAwardId';
    }

    CreateEntity(): StudentAchievementAwardEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): StudentAchievementAwardQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<StudentAchievementAwardEntity, StudentAchievementAwardMetaDataAttributes,StudentAchievementAwardMetaDataRelations>(query, this);
    }
     Attributes = new StudentAchievementAwardMetaDataAttributes();
     Relations = new StudentAchievementAwardMetaDataRelations();

}


export type StudentAchievementAwardQueryBuilder = DwQueryBuilderGen<StudentAchievementAwardEntity, StudentAchievementAwardMetaDataAttributes,StudentAchievementAwardMetaDataRelations>


export class StudentAchievementAwardMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'StudentAchievementAward';
    // Attributes
    StudentAchievementAwardId = new DwItemAttribute(this.i, 'StudentAchievementAwardId');
    StudentAchievementId = new DwItemAttribute(this.i, 'StudentAchievementId');
    AchievementTierId = new DwItemAttribute(this.i, 'AchievementTierId');
    EarnedDateTime = new DwItemAttribute(this.i, 'EarnedDateTime');
    CalculationContext = new DwItemAttribute(this.i, 'CalculationContext');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
}

class StudentAchievementAwardMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Achievement Tier */
            AchievementTier = new DwItemRelationship('AchievementTier|StudentAchievementAward|AchievementTierId', 'AchievementTier', 'AchievementTier');
            /** Relation: Student Achievement */
            StudentAchievement = new DwItemRelationship('StudentAchievement|StudentAchievementAward|StudentAchievementId', 'StudentAchievement', 'StudentAchievement');
    };
export class StudentActivityMetaData implements DwItem2<StudentActivityEntity, StudentActivityMetaDataAttributes,StudentActivityMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=463;
        this.ItemDetail.itemName='StudentActivity';
        this.ItemDetail.keyName='StudentActivityId';
    }

    CreateEntity(): StudentActivityEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): StudentActivityQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<StudentActivityEntity, StudentActivityMetaDataAttributes,StudentActivityMetaDataRelations>(query, this);
    }
     Attributes = new StudentActivityMetaDataAttributes();
     Relations = new StudentActivityMetaDataRelations();

}


export type StudentActivityQueryBuilder = DwQueryBuilderGen<StudentActivityEntity, StudentActivityMetaDataAttributes,StudentActivityMetaDataRelations>


export class StudentActivityMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'StudentActivity';
    // Attributes
    StudentActivityId = new DwItemAttribute(this.i, 'StudentActivityId');
    StudentId = new DwItemAttribute(this.i, 'StudentId');
    StudentActivityTypeId = new DwItemAttribute(this.i, 'StudentActivityTypeId');
    ActivityDateTime = new DwItemAttribute(this.i, 'ActivityDateTime');
    ActorUserId = new DwItemAttribute(this.i, 'ActorUserId');
    ActorDisplayName = new DwItemAttribute(this.i, 'ActorDisplayName');
    ActorRoleName = new DwItemAttribute(this.i, 'ActorRoleName');
    ActivityTitle = new DwItemAttribute(this.i, 'ActivityTitle');
    ActivityDetail = new DwItemAttribute(this.i, 'ActivityDetail');
    OldValueText = new DwItemAttribute(this.i, 'OldValueText');
    NewValueText = new DwItemAttribute(this.i, 'NewValueText');
    SourceMetaDataItemId = new DwItemAttribute(this.i, 'SourceMetaDataItemId');
    SourceKeyValue = new DwItemAttribute(this.i, 'SourceKeyValue');
    RelatedMetaDataItemId = new DwItemAttribute(this.i, 'RelatedMetaDataItemId');
    RelatedKeyValue = new DwItemAttribute(this.i, 'RelatedKeyValue');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    CourseAssignmentSourceTypeId = new DwItemAttribute(this.i, 'CourseAssignmentSourceTypeId');
    StudentAcknowledgedDateTime = new DwItemAttribute(this.i, 'StudentAcknowledgedDateTime');
}

class StudentActivityMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Course Assignment Source Type */
            CourseAssignmentSourceType = new DwItemRelationship('CourseAssignmentSourceType|StudentActivity|CourseAssignmentSourceTypeId', 'CourseAssignmentSourceType', 'CourseAssignmentSourceType');
            /** Relation: Meta Data Item - Source Meta Data Item */
            DwMetaDataItemBySourceMetaDataItemId = new DwItemRelationship('dw_MetaDataItem|StudentActivity|SourceMetaDataItemId', 'SourceDwMetaDataItem', 'SourceDwMetaDataItem');
            /** Relation: Meta Data Item - Related Meta Data Item */
            DwMetaDataItemByRelatedMetaDataItemId = new DwItemRelationship('dw_MetaDataItem|StudentActivity|RelatedMetaDataItemId', 'RelatedDwMetaDataItem', 'RelatedDwMetaDataItem');
            /** Relation: Student */
            Student = new DwItemRelationship('Student|StudentActivity|StudentId', 'Student', 'Student');
            /** Relation: Student Activity Type */
            StudentActivityType = new DwItemRelationship('StudentActivityType|StudentActivity|StudentActivityTypeId', 'StudentActivityType', 'StudentActivityType');
            /** Relation: User - Actor User */
            DwUserByActorUserId = new DwItemRelationship('dw_User|StudentActivity|ActorUserId', 'ActorDwUser', 'ActorDwUser');
    };
export class StudentActivityTypeMetaData implements DwItem2<StudentActivityTypeEntity, StudentActivityTypeMetaDataAttributes,StudentActivityTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=462;
        this.ItemDetail.itemName='StudentActivityType';
        this.ItemDetail.keyName='StudentActivityTypeId';
    }

    CreateEntity(): StudentActivityTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): StudentActivityTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<StudentActivityTypeEntity, StudentActivityTypeMetaDataAttributes,StudentActivityTypeMetaDataRelations>(query, this);
    }
     Attributes = new StudentActivityTypeMetaDataAttributes();
     Relations = new StudentActivityTypeMetaDataRelations();

}


export type StudentActivityTypeQueryBuilder = DwQueryBuilderGen<StudentActivityTypeEntity, StudentActivityTypeMetaDataAttributes,StudentActivityTypeMetaDataRelations>


export class StudentActivityTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'StudentActivityType';
    // Attributes
    StudentActivityTypeId = new DwItemAttribute(this.i, 'StudentActivityTypeId');
    ActivityTypeKey = new DwItemAttribute(this.i, 'ActivityTypeKey');
    ActivityTypeName = new DwItemAttribute(this.i, 'ActivityTypeName');
    ActivityCssClass = new DwItemAttribute(this.i, 'ActivityCssClass');
    SortOrder = new DwItemAttribute(this.i, 'SortOrder');
    Active = new DwItemAttribute(this.i, 'Active');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class StudentActivityTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Student Activity */
            StudentActivity = new DwItemRelationship('StudentActivityType|StudentActivity|StudentActivityTypeId', 'StudentActivity', 'StudentActivity');
    };
export class StudentCourseMetaData implements DwItem2<StudentCourseEntity, StudentCourseMetaDataAttributes,StudentCourseMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=165;
        this.ItemDetail.itemName='StudentCourse';
        this.ItemDetail.keyName='StudentCourseId';
    }

    CreateEntity(): StudentCourseEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): StudentCourseQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<StudentCourseEntity, StudentCourseMetaDataAttributes,StudentCourseMetaDataRelations>(query, this);
    }
     Attributes = new StudentCourseMetaDataAttributes();
     Relations = new StudentCourseMetaDataRelations();

}


export type StudentCourseQueryBuilder = DwQueryBuilderGen<StudentCourseEntity, StudentCourseMetaDataAttributes,StudentCourseMetaDataRelations>


export class StudentCourseMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'StudentCourse';
    // Attributes
    StudentCourseId = new DwItemAttribute(this.i, 'StudentCourseId');
    StudentId = new DwItemAttribute(this.i, 'StudentId');
    CourseId = new DwItemAttribute(this.i, 'CourseId');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    PercentComplete = new DwItemAttribute(this.i, 'PercentComplete');
    ModulesCompleted = new DwItemAttribute(this.i, 'ModulesCompleted');
    ModulesCount = new DwItemAttribute(this.i, 'ModulesCount');
    LastActivityDateTime = new DwItemAttribute(this.i, 'LastActivityDateTime');
    LessonsCompleted = new DwItemAttribute(this.i, 'LessonsCompleted');
    LessonCount = new DwItemAttribute(this.i, 'LessonCount');
    TotalTimeSeconds = new DwItemAttribute(this.i, 'TotalTimeSeconds');
    FirstActivityDateTime = new DwItemAttribute(this.i, 'FirstActivityDateTime');
    CompletedDateTime = new DwItemAttribute(this.i, 'CompletedDateTime');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    StudentCourseStatusId = new DwItemAttribute(this.i, 'StudentCourseStatusId');
    IsEndorsed = new DwItemAttribute(this.i, 'IsEndorsed');
    TotalVideoTimeSeconds = new DwItemAttribute(this.i, 'TotalVideoTimeSeconds');
    TotalQuizTimeSeconds = new DwItemAttribute(this.i, 'TotalQuizTimeSeconds');
    NextCourseLessonId = new DwItemAttribute(this.i, 'NextCourseLessonId');
    AcsTestPassedFirstTime = new DwItemAttribute(this.i, 'AcsTestPassedFirstTime');
    AcsTestUploaded = new DwItemAttribute(this.i, 'AcsTestUploaded');
    AcsTestPassed = new DwItemAttribute(this.i, 'AcsTestPassed');
    HideInReporting = new DwItemAttribute(this.i, 'HideInReporting');
    AcsTestLastScore = new DwItemAttribute(this.i, 'AcsTestLastScore');
    StudentCourseProgressStatusId = new DwItemAttribute(this.i, 'StudentCourseProgressStatusId');
}

class StudentCourseMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Course */
            Course = new DwItemRelationship('Course|StudentCourse|CourseId', 'Course', 'Course');
            /** Relation: Lesson - Next Course Lesson */
            CourseLessonByNextCourseLessonId = new DwItemRelationship('CourseLesson|StudentCourse|NextCourseLessonId', 'NextCourseLesson', 'NextCourseLesson');
            /** Relation: Reference Status - Student Course Status */
            ReferenceStatusByStudentCourseStatusId = new DwItemRelationship('ReferenceStatus|StudentCourse|StudentCourseStatusId', 'StudentCourseStatusIdReferenceStatus', 'StudentCourseStatusIdReferenceStatus');
            /** Relation: Student */
            Student = new DwItemRelationship('Student|StudentCourse|StudentId', 'Student', 'Student');
            /** Relation: Student Course Progress Status */
            StudentCourseProgressStatus = new DwItemRelationship('StudentCourseProgressStatus|StudentCourse|StudentCourseProgressStatusId', 'StudentCourseProgressStatus', 'StudentCourseProgressStatus');
            /** Relation: Acs Written Result */
            AcsWrittenResult = new DwItemRelationship('StudentCourse|AcsWrittenResult|StudentCourseId', 'AcsWrittenResult', 'AcsWrittenResult');
            /** Relation: AI Prompt Request - T - Many */
            AIPromptRequestByStudentCoursetId = new DwItemRelationship('StudentCourse|AIPromptRequest|StudenCoursetId', 'StudentCoursetIdAIPromptRequest', 'StudentCoursetIdAIPromptRequest');
            /** Relation: Course Endorsement Student */
            CourseEndorsementStudent = new DwItemRelationship('StudentCourse|CourseEndorsementStudent|StudentCourseId', 'CourseEndorsementStudent', 'CourseEndorsementStudent');
            /** Relation: Course Module Progress */
            CourseModuleProgress = new DwItemRelationship('StudentCourse|CourseModuleProgress|StudentCourseId', 'CourseModuleProgress', 'CourseModuleProgress');
            /** Relation: Course Purchase Reservation Course */
            CoursePurchaseReservationCourse = new DwItemRelationship('StudentCourse|CoursePurchaseReservationCourse|StudentCourseId', 'CoursePurchaseReservationCourse', 'CoursePurchaseReservationCourse');
            /** Relation: Daily Quiz */
            DailyQuiz = new DwItemRelationship('StudentCourse|DailyQuiz|StudentCourseId', 'DailyQuiz', 'DailyQuiz');
            /** Relation: Integration Course Purchase */
            IntegrationCoursePurchase = new DwItemRelationship('StudentCourse|IntegrationCoursePurchase|StudentCourseId', 'IntegrationCoursePurchase', 'IntegrationCoursePurchase');
            /** Relation: Join Request Course Purchase */
            JoinRequestCoursePurchase = new DwItemRelationship('StudentCourse|JoinRequestCoursePurchase|StudentCourseId', 'JoinRequestCoursePurchase', 'JoinRequestCoursePurchase');
            /** Relation: Modification History Student */
            ModificationHistoryStudent = new DwItemRelationship('StudentCourse|ModificationHistoryStudent|StudentCourseId', 'ModificationHistoryStudent', 'ModificationHistoryStudent');
            /** Relation: Quiz Result */
            QuizResult = new DwItemRelationship('StudentCourse|QuizResult|StudentCourseId', 'QuizResult', 'QuizResult');
            /** Relation: Ro Course Endorsement Student Active */
            RoCourseEndorsementStudentActive = new DwItemRelationship('StudentCourse|RoCourseEndorsementStudentActive|StudentCourseId', 'RoCourseEndorsementStudentActive', 'RoCourseEndorsementStudentActive');
            /** Relation: Ro Student Course Acs Test Result Detail */
            RoStudentCourseAcsTestResultDetail = new DwItemRelationship('StudentCourse|RoStudentCourseAcsTestResultDetail|StudentCourseId', 'RoStudentCourseAcsTestResultDetail', 'RoStudentCourseAcsTestResultDetail');
            /** Relation: Ro Student Course Instructor */
            RoStudentCourseInstructor = new DwItemRelationship('StudentCourse|RoStudentCourseInstructor|StudentCourseId', 'RoStudentCourseInstructor', 'RoStudentCourseInstructor');
            /** Relation: Ro Student School Course */
            RoStudentSchoolCourses = new DwItemRelationship('RoStudentSchoolCourse|StudentCourse|StudentCourseId', 'RoStudentSchoolCourses', 'RoStudentSchoolCourses');
            /** Relation: Student Achievement */
            StudentAchievement = new DwItemRelationship('StudentCourse|StudentAchievement|StudentCourseId', 'StudentAchievement', 'StudentAchievement');
            /** Relation: Student Course Lock Instructor */
            StudentCourseLockInstructor = new DwItemRelationship('StudentCourse|StudentCourseLockInstructor|StudentCourseId', 'StudentCourseLockInstructor', 'StudentCourseLockInstructor');
            /** Relation: Student Module Summary */
            StudentModuleSummary = new DwItemRelationship('StudentCourse|StudentModuleSummary|StudentCourseId', 'StudentModuleSummary', 'StudentModuleSummary');
            /** Relation: Student Progress Reset Event */
            StudentProgressResetEvent = new DwItemRelationship('StudentCourse|StudentProgressResetEvent|StudentCourseId', 'StudentProgressResetEvent', 'StudentProgressResetEvent');
            /** Relation: Subscription Course Tracking */
            SubscriptionCourseTracking = new DwItemRelationship('StudentCourse|SubscriptionCourseTracking|StudentCourseId', 'SubscriptionCourseTracking', 'SubscriptionCourseTracking');
    };
export class StudentCourseLockInstructorMetaData implements DwItem2<StudentCourseLockInstructorEntity, StudentCourseLockInstructorMetaDataAttributes,StudentCourseLockInstructorMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=393;
        this.ItemDetail.itemName='StudentCourseLockInstructor';
        this.ItemDetail.keyName='StudentCourseLockInstructorId';
    }

    CreateEntity(): StudentCourseLockInstructorEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): StudentCourseLockInstructorQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<StudentCourseLockInstructorEntity, StudentCourseLockInstructorMetaDataAttributes,StudentCourseLockInstructorMetaDataRelations>(query, this);
    }
     Attributes = new StudentCourseLockInstructorMetaDataAttributes();
     Relations = new StudentCourseLockInstructorMetaDataRelations();

}


export type StudentCourseLockInstructorQueryBuilder = DwQueryBuilderGen<StudentCourseLockInstructorEntity, StudentCourseLockInstructorMetaDataAttributes,StudentCourseLockInstructorMetaDataRelations>


export class StudentCourseLockInstructorMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'StudentCourseLockInstructor';
    // Attributes
    StudentCourseLockInstructorId = new DwItemAttribute(this.i, 'StudentCourseLockInstructorId');
    StudentCourseId = new DwItemAttribute(this.i, 'StudentCourseId');
    InstructorId = new DwItemAttribute(this.i, 'InstructorId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class StudentCourseLockInstructorMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Instructor */
            Instructor = new DwItemRelationship('Instructor|StudentCourseLockInstructor|InstructorId', 'Instructor', 'Instructor');
            /** Relation: Student Course */
            StudentCourse = new DwItemRelationship('StudentCourse|StudentCourseLockInstructor|StudentCourseId', 'StudentCourse', 'StudentCourse');
            /** Relation: Ro School Course Enrollment Stats */
            RoSchoolCourseEnrollmentStatsByStudentCourseId = new DwItemRelationship('StudentCourseLockInstructor|RoSchoolCourseEnrollmentStats', 'RoSchoolCourseEnrollmentStatsStudentCourseId', 'RoSchoolCourseEnrollmentStatsStudentCourseId');
    };
export class StudentCourseProgressStatusMetaData implements DwItem2<StudentCourseProgressStatusEntity, StudentCourseProgressStatusMetaDataAttributes,StudentCourseProgressStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=467;
        this.ItemDetail.itemName='StudentCourseProgressStatus';
        this.ItemDetail.keyName='StudentCourseProgressStatusId';
    }

    CreateEntity(): StudentCourseProgressStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): StudentCourseProgressStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<StudentCourseProgressStatusEntity, StudentCourseProgressStatusMetaDataAttributes,StudentCourseProgressStatusMetaDataRelations>(query, this);
    }
     Attributes = new StudentCourseProgressStatusMetaDataAttributes();
     Relations = new StudentCourseProgressStatusMetaDataRelations();

}


export type StudentCourseProgressStatusQueryBuilder = DwQueryBuilderGen<StudentCourseProgressStatusEntity, StudentCourseProgressStatusMetaDataAttributes,StudentCourseProgressStatusMetaDataRelations>


export class StudentCourseProgressStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'StudentCourseProgressStatus';
    // Attributes
    StudentCourseProgressStatusId = new DwItemAttribute(this.i, 'StudentCourseProgressStatusId');
    ProgressStatusKey = new DwItemAttribute(this.i, 'ProgressStatusKey');
    ProgressStatusName = new DwItemAttribute(this.i, 'ProgressStatusName');
    ProgressStatusCssClass = new DwItemAttribute(this.i, 'ProgressStatusCssClass');
    SortOrder = new DwItemAttribute(this.i, 'SortOrder');
    Active = new DwItemAttribute(this.i, 'Active');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class StudentCourseProgressStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Student Course */
            StudentCourse = new DwItemRelationship('StudentCourseProgressStatus|StudentCourse|StudentCourseProgressStatusId', 'StudentCourse', 'StudentCourse');
    };
export class StudentGamificationDayMetaData implements DwItem2<StudentGamificationDayEntity, StudentGamificationDayMetaDataAttributes,StudentGamificationDayMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=498;
        this.ItemDetail.itemName='StudentGamificationDay';
        this.ItemDetail.keyName='StudentGamificationDayId';
    }

    CreateEntity(): StudentGamificationDayEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): StudentGamificationDayQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<StudentGamificationDayEntity, StudentGamificationDayMetaDataAttributes,StudentGamificationDayMetaDataRelations>(query, this);
    }
     Attributes = new StudentGamificationDayMetaDataAttributes();
     Relations = new StudentGamificationDayMetaDataRelations();

}


export type StudentGamificationDayQueryBuilder = DwQueryBuilderGen<StudentGamificationDayEntity, StudentGamificationDayMetaDataAttributes,StudentGamificationDayMetaDataRelations>


export class StudentGamificationDayMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'StudentGamificationDay';
    // Attributes
    StudentGamificationDayId = new DwItemAttribute(this.i, 'StudentGamificationDayId');
    StudentId = new DwItemAttribute(this.i, 'StudentId');
    ActivityDate = new DwItemAttribute(this.i, 'ActivityDate');
    TimeZoneId = new DwItemAttribute(this.i, 'TimeZoneId');
    AppliedUtcOffsetMinutes = new DwItemAttribute(this.i, 'AppliedUtcOffsetMinutes');
    HasActualActivity = new DwItemAttribute(this.i, 'HasActualActivity');
    CompletedLessonCount = new DwItemAttribute(this.i, 'CompletedLessonCount');
    VerifiedActiveTimeSeconds = new DwItemAttribute(this.i, 'VerifiedActiveTimeSeconds');
    CountedActiveTimeSeconds = new DwItemAttribute(this.i, 'CountedActiveTimeSeconds');
    DailyQuizCompleted = new DwItemAttribute(this.i, 'DailyQuizCompleted');
    DailyQuizCorrectAnswerCount = new DwItemAttribute(this.i, 'DailyQuizCorrectAnswerCount');
    DailyQuizResultId = new DwItemAttribute(this.i, 'DailyQuizResultId');
    WeatherDayApplied = new DwItemAttribute(this.i, 'WeatherDayApplied');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    RecalculatedDateTime = new DwItemAttribute(this.i, 'RecalculatedDateTime');
}

class StudentGamificationDayMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Quiz Result - Daily Quiz Result */
            QuizResultByDailyQuizResultId = new DwItemRelationship('QuizResult|StudentGamificationDay|DailyQuizResultId', 'DailyQuizResult', 'DailyQuizResult');
            /** Relation: Student */
            Student = new DwItemRelationship('Student|StudentGamificationDay|StudentId', 'Student', 'Student');
            /** Relation: Time Zone - Timezone */
            TimeZoneByTimeZoneId = new DwItemRelationship('TimeZone|StudentGamificationDay|TimeZoneId', 'TimeZoneIdTimeZone', 'TimeZoneIdTimeZone');
            /** Relation: Student Weather Day Transaction */
            StudentWeatherDayTransaction = new DwItemRelationship('StudentGamificationDay|StudentWeatherDayTransaction|StudentGamificationDayId', 'StudentWeatherDayTransaction', 'StudentWeatherDayTransaction');
    };
export class StudentGamificationSummaryMetaData implements DwItem2<StudentGamificationSummaryEntity, StudentGamificationSummaryMetaDataAttributes,StudentGamificationSummaryMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=492;
        this.ItemDetail.itemName='StudentGamificationSummary';
        this.ItemDetail.keyName='StudentGamificationSummaryId';
    }

    CreateEntity(): StudentGamificationSummaryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): StudentGamificationSummaryQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<StudentGamificationSummaryEntity, StudentGamificationSummaryMetaDataAttributes,StudentGamificationSummaryMetaDataRelations>(query, this);
    }
     Attributes = new StudentGamificationSummaryMetaDataAttributes();
     Relations = new StudentGamificationSummaryMetaDataRelations();

}


export type StudentGamificationSummaryQueryBuilder = DwQueryBuilderGen<StudentGamificationSummaryEntity, StudentGamificationSummaryMetaDataAttributes,StudentGamificationSummaryMetaDataRelations>


export class StudentGamificationSummaryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'StudentGamificationSummary';
    // Attributes
    StudentId = new DwItemAttribute(this.i, 'StudentId');
    CurrentProtectedStreakDays = new DwItemAttribute(this.i, 'CurrentProtectedStreakDays');
    LongestProtectedStreakDays = new DwItemAttribute(this.i, 'LongestProtectedStreakDays');
    WeatherDayBalance = new DwItemAttribute(this.i, 'WeatherDayBalance');
    LastActualActivityDate = new DwItemAttribute(this.i, 'LastActualActivityDate');
    LastCoveredActivityDate = new DwItemAttribute(this.i, 'LastCoveredActivityDate');
    LastWeatherDayGrantDate = new DwItemAttribute(this.i, 'LastWeatherDayGrantDate');
    TimeZoneId = new DwItemAttribute(this.i, 'TimeZoneId');
    LastRecalculatedDateTime = new DwItemAttribute(this.i, 'LastRecalculatedDateTime');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    StudentGamificationSummaryId = new DwItemAttribute(this.i, 'StudentGamificationSummaryId');
}

class StudentGamificationSummaryMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Student */
            Student = new DwItemRelationship('Student|StudentGamificationSummary|StudentId', 'Student', 'Student');
            /** Relation: Time Zone - Timezone */
            TimeZoneByTimeZoneId = new DwItemRelationship('TimeZone|StudentGamificationSummary|TimeZoneId', 'TimeZoneIdTimeZone', 'TimeZoneIdTimeZone');
    };
export class StudentLessonProgressEventMetaData implements DwItem2<StudentLessonProgressEventEntity, StudentLessonProgressEventMetaDataAttributes,StudentLessonProgressEventMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=503;
        this.ItemDetail.itemName='StudentLessonProgressEvent';
        this.ItemDetail.keyName='StudentLessonProgressEventId';
    }

    CreateEntity(): StudentLessonProgressEventEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): StudentLessonProgressEventQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<StudentLessonProgressEventEntity, StudentLessonProgressEventMetaDataAttributes,StudentLessonProgressEventMetaDataRelations>(query, this);
    }
     Attributes = new StudentLessonProgressEventMetaDataAttributes();
     Relations = new StudentLessonProgressEventMetaDataRelations();

}


export type StudentLessonProgressEventQueryBuilder = DwQueryBuilderGen<StudentLessonProgressEventEntity, StudentLessonProgressEventMetaDataAttributes,StudentLessonProgressEventMetaDataRelations>


export class StudentLessonProgressEventMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'StudentLessonProgressEvent';
    // Attributes
    StudentLessonProgressEventId = new DwItemAttribute(this.i, 'StudentLessonProgressEventId');
    StudentId = new DwItemAttribute(this.i, 'StudentId');
    DeviceInstallationId = new DwItemAttribute(this.i, 'DeviceInstallationId');
    EventId = new DwItemAttribute(this.i, 'EventId');
    ClientSequence = new DwItemAttribute(this.i, 'ClientSequence');
    EventType = new DwItemAttribute(this.i, 'EventType');
    OccurredAtUtc = new DwItemAttribute(this.i, 'OccurredAtUtc');
    ProcessingState = new DwItemAttribute(this.i, 'ProcessingState');
    ProcessedAtUtc = new DwItemAttribute(this.i, 'ProcessedAtUtc');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class StudentLessonProgressEventMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Student */
            Student = new DwItemRelationship('Student|StudentLessonProgressEvent|StudentId', 'Student', 'Student');
    };
export class StudentModuleSummaryMetaData implements DwItem2<StudentModuleSummaryEntity, StudentModuleSummaryMetaDataAttributes,StudentModuleSummaryMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=351;
        this.ItemDetail.itemName='StudentModuleSummary';
        this.ItemDetail.keyName='StudentModuleSummaryId';
    }

    CreateEntity(): StudentModuleSummaryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): StudentModuleSummaryQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<StudentModuleSummaryEntity, StudentModuleSummaryMetaDataAttributes,StudentModuleSummaryMetaDataRelations>(query, this);
    }
     Attributes = new StudentModuleSummaryMetaDataAttributes();
     Relations = new StudentModuleSummaryMetaDataRelations();

}


export type StudentModuleSummaryQueryBuilder = DwQueryBuilderGen<StudentModuleSummaryEntity, StudentModuleSummaryMetaDataAttributes,StudentModuleSummaryMetaDataRelations>


export class StudentModuleSummaryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'StudentModuleSummary';
    // Attributes
    StudentModuleSummaryId = new DwItemAttribute(this.i, 'StudentModuleSummaryId');
    StudentCourseId = new DwItemAttribute(this.i, 'StudentCourseId');
    CourseModuleId = new DwItemAttribute(this.i, 'CourseModuleId');
    ModuleSummaryHtml = new DwItemAttribute(this.i, 'ModuleSummaryHtml');
    StudentModuleSummaryStatusId = new DwItemAttribute(this.i, 'StudentModuleSummaryStatusId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    CourseModuleProgressId = new DwItemAttribute(this.i, 'CourseModuleProgressId');
}

class StudentModuleSummaryMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Module */
            CourseModule = new DwItemRelationship('CourseModule|StudentModuleSummary|CourseModuleId', 'CourseModule', 'CourseModule');
            /** Relation: Course Module Progress */
            CourseModuleProgress = new DwItemRelationship('CourseModuleProgress|StudentModuleSummary|CourseModuleProgressId', 'CourseModuleProgress', 'CourseModuleProgress');
            /** Relation: Student Course */
            StudentCourse = new DwItemRelationship('StudentCourse|StudentModuleSummary|StudentCourseId', 'StudentCourse', 'StudentCourse');
            /** Relation: Student Module Summary Status */
            StudentModuleSummaryStatus = new DwItemRelationship('StudentModuleSummaryStatus|StudentModuleSummary|StudentModuleSummaryStatusId', 'StudentModuleSummaryStatus', 'StudentModuleSummaryStatus');
    };
export class StudentModuleSummaryStatusMetaData implements DwItem2<StudentModuleSummaryStatusEntity, StudentModuleSummaryStatusMetaDataAttributes,StudentModuleSummaryStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=352;
        this.ItemDetail.itemName='StudentModuleSummaryStatus';
        this.ItemDetail.keyName='StudentModuleSummaryStatusId';
    }

    CreateEntity(): StudentModuleSummaryStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): StudentModuleSummaryStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<StudentModuleSummaryStatusEntity, StudentModuleSummaryStatusMetaDataAttributes,StudentModuleSummaryStatusMetaDataRelations>(query, this);
    }
     Attributes = new StudentModuleSummaryStatusMetaDataAttributes();
     Relations = new StudentModuleSummaryStatusMetaDataRelations();

}


export type StudentModuleSummaryStatusQueryBuilder = DwQueryBuilderGen<StudentModuleSummaryStatusEntity, StudentModuleSummaryStatusMetaDataAttributes,StudentModuleSummaryStatusMetaDataRelations>


export class StudentModuleSummaryStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'StudentModuleSummaryStatus';
    // Attributes
    StudentModuleSummaryStatusId = new DwItemAttribute(this.i, 'StudentModuleSummaryStatusId');
    StudentModuleSummaryStatus = new DwItemAttribute(this.i, 'StudentModuleSummaryStatus');
}

class StudentModuleSummaryStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Student Module Summary */
            StudentModuleSummary = new DwItemRelationship('StudentModuleSummaryStatus|StudentModuleSummary|StudentModuleSummaryStatusId', 'StudentModuleSummary', 'StudentModuleSummary');
    };
export class StudentProgressResetEventMetaData implements DwItem2<StudentProgressResetEventEntity, StudentProgressResetEventMetaDataAttributes,StudentProgressResetEventMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=487;
        this.ItemDetail.itemName='StudentProgressResetEvent';
        this.ItemDetail.keyName='StudentProgressResetEventId';
    }

    CreateEntity(): StudentProgressResetEventEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): StudentProgressResetEventQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<StudentProgressResetEventEntity, StudentProgressResetEventMetaDataAttributes,StudentProgressResetEventMetaDataRelations>(query, this);
    }
     Attributes = new StudentProgressResetEventMetaDataAttributes();
     Relations = new StudentProgressResetEventMetaDataRelations();

}


export type StudentProgressResetEventQueryBuilder = DwQueryBuilderGen<StudentProgressResetEventEntity, StudentProgressResetEventMetaDataAttributes,StudentProgressResetEventMetaDataRelations>


export class StudentProgressResetEventMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'StudentProgressResetEvent';
    // Attributes
    StudentProgressResetEventId = new DwItemAttribute(this.i, 'StudentProgressResetEventId');
    ResetBatchId = new DwItemAttribute(this.i, 'ResetBatchId');
    StudentId = new DwItemAttribute(this.i, 'StudentId');
    StudentCourseId = new DwItemAttribute(this.i, 'StudentCourseId');
    CourseId = new DwItemAttribute(this.i, 'CourseId');
    AssignmentId = new DwItemAttribute(this.i, 'AssignmentId');
    AssignmentStudentId = new DwItemAttribute(this.i, 'AssignmentStudentId');
    ResetSourceType = new DwItemAttribute(this.i, 'ResetSourceType');
    ResetReason = new DwItemAttribute(this.i, 'ResetReason');
    ResetDateTime = new DwItemAttribute(this.i, 'ResetDateTime');
    ResetByUserId = new DwItemAttribute(this.i, 'ResetByUserId');
    ResetByDisplayName = new DwItemAttribute(this.i, 'ResetByDisplayName');
    AffectedModuleCount = new DwItemAttribute(this.i, 'AffectedModuleCount');
    AffectedLessonCount = new DwItemAttribute(this.i, 'AffectedLessonCount');
    CompletedLessonCount = new DwItemAttribute(this.i, 'CompletedLessonCount');
    PassedQuizCount = new DwItemAttribute(this.i, 'PassedQuizCount');
    SnapshotVersion = new DwItemAttribute(this.i, 'SnapshotVersion');
    ResetSnapshotJson = new DwItemAttribute(this.i, 'ResetSnapshotJson');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
}

class StudentProgressResetEventMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Assignment */
            Assignment = new DwItemRelationship('Assignment|StudentProgressResetEvent|AssignmentId', 'Assignment', 'Assignment');
            /** Relation: Assignment Student */
            AssignmentStudent = new DwItemRelationship('AssignmentStudent|StudentProgressResetEvent|AssignmentStudentId', 'AssignmentStudent', 'AssignmentStudent');
            /** Relation: Course */
            Course = new DwItemRelationship('Course|StudentProgressResetEvent|CourseId', 'Course', 'Course');
            /** Relation: Student */
            Student = new DwItemRelationship('Student|StudentProgressResetEvent|StudentId', 'Student', 'Student');
            /** Relation: Student Course */
            StudentCourse = new DwItemRelationship('StudentCourse|StudentProgressResetEvent|StudentCourseId', 'StudentCourse', 'StudentCourse');
            /** Relation: User - Reset By User */
            DwUserByResetByUserId = new DwItemRelationship('dw_User|StudentProgressResetEvent|ResetByUserId', 'ResetByDwUser', 'ResetByDwUser');
    };
export class StudentWeatherDayTransactionMetaData implements DwItem2<StudentWeatherDayTransactionEntity, StudentWeatherDayTransactionMetaDataAttributes,StudentWeatherDayTransactionMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=491;
        this.ItemDetail.itemName='StudentWeatherDayTransaction';
        this.ItemDetail.keyName='StudentWeatherDayTransactionId';
    }

    CreateEntity(): StudentWeatherDayTransactionEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): StudentWeatherDayTransactionQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<StudentWeatherDayTransactionEntity, StudentWeatherDayTransactionMetaDataAttributes,StudentWeatherDayTransactionMetaDataRelations>(query, this);
    }
     Attributes = new StudentWeatherDayTransactionMetaDataAttributes();
     Relations = new StudentWeatherDayTransactionMetaDataRelations();

}


export type StudentWeatherDayTransactionQueryBuilder = DwQueryBuilderGen<StudentWeatherDayTransactionEntity, StudentWeatherDayTransactionMetaDataAttributes,StudentWeatherDayTransactionMetaDataRelations>


export class StudentWeatherDayTransactionMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'StudentWeatherDayTransaction';
    // Attributes
    StudentWeatherDayTransactionId = new DwItemAttribute(this.i, 'StudentWeatherDayTransactionId');
    StudentId = new DwItemAttribute(this.i, 'StudentId');
    TransactionType = new DwItemAttribute(this.i, 'TransactionType');
    Quantity = new DwItemAttribute(this.i, 'Quantity');
    EffectiveDate = new DwItemAttribute(this.i, 'EffectiveDate');
    GrantPeriodStartDate = new DwItemAttribute(this.i, 'GrantPeriodStartDate');
    StudentGamificationDayId = new DwItemAttribute(this.i, 'StudentGamificationDayId');
    GamificationConfigurationId = new DwItemAttribute(this.i, 'GamificationConfigurationId');
    CalculationContext = new DwItemAttribute(this.i, 'CalculationContext');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
}

class StudentWeatherDayTransactionMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Gamification Configuration */
            GamificationConfiguration = new DwItemRelationship('GamificationConfiguration|StudentWeatherDayTransaction|GamificationConfigurationId', 'GamificationConfiguration', 'GamificationConfiguration');
            /** Relation: Student */
            Student = new DwItemRelationship('Student|StudentWeatherDayTransaction|StudentId', 'Student', 'Student');
            /** Relation: Student Gamification Day */
            StudentGamificationDay = new DwItemRelationship('StudentGamificationDay|StudentWeatherDayTransaction|StudentGamificationDayId', 'StudentGamificationDay', 'StudentGamificationDay');
    };
export class SubdomainSetupStatusMetaData implements DwItem2<SubdomainSetupStatusEntity, SubdomainSetupStatusMetaDataAttributes,SubdomainSetupStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=240;
        this.ItemDetail.itemName='SubdomainSetupStatus';
        this.ItemDetail.keyName='SubdomainSetupStatusId';
    }

    CreateEntity(): SubdomainSetupStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): SubdomainSetupStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<SubdomainSetupStatusEntity, SubdomainSetupStatusMetaDataAttributes,SubdomainSetupStatusMetaDataRelations>(query, this);
    }
     Attributes = new SubdomainSetupStatusMetaDataAttributes();
     Relations = new SubdomainSetupStatusMetaDataRelations();

}


export type SubdomainSetupStatusQueryBuilder = DwQueryBuilderGen<SubdomainSetupStatusEntity, SubdomainSetupStatusMetaDataAttributes,SubdomainSetupStatusMetaDataRelations>


export class SubdomainSetupStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'SubdomainSetupStatus';
    // Attributes
    SubdomainSetupStatusId = new DwItemAttribute(this.i, 'SubdomainSetupStatusId');
    SubdomainSetupStatus = new DwItemAttribute(this.i, 'SubdomainSetupStatus');
}

class SubdomainSetupStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School Branding */
            FlightSchoolBranding = new DwItemRelationship('SubdomainSetupStatus|FlightSchoolBranding|SubdomainSetupStatusId', 'FlightSchoolBranding', 'FlightSchoolBranding');
    };
export class SubdomainTypeMetaData implements DwItem2<SubdomainTypeEntity, SubdomainTypeMetaDataAttributes,SubdomainTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=239;
        this.ItemDetail.itemName='SubdomainType';
        this.ItemDetail.keyName='SubdomainTypeId';
    }

    CreateEntity(): SubdomainTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): SubdomainTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<SubdomainTypeEntity, SubdomainTypeMetaDataAttributes,SubdomainTypeMetaDataRelations>(query, this);
    }
     Attributes = new SubdomainTypeMetaDataAttributes();
     Relations = new SubdomainTypeMetaDataRelations();

}


export type SubdomainTypeQueryBuilder = DwQueryBuilderGen<SubdomainTypeEntity, SubdomainTypeMetaDataAttributes,SubdomainTypeMetaDataRelations>


export class SubdomainTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'SubdomainType';
    // Attributes
    SubdomainTypeId = new DwItemAttribute(this.i, 'SubdomainTypeId');
    SubdomainType = new DwItemAttribute(this.i, 'SubdomainType');
}

class SubdomainTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School Branding */
            FlightSchoolBranding = new DwItemRelationship('SubdomainType|FlightSchoolBranding|SubdomainTypeId', 'FlightSchoolBranding', 'FlightSchoolBranding');
    };
export class SubscriptionMetaData implements DwItem2<SubscriptionEntity, SubscriptionMetaDataAttributes,SubscriptionMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=244;
        this.ItemDetail.itemName='Subscription';
        this.ItemDetail.keyName='SubscriptionId';
    }

    CreateEntity(): SubscriptionEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): SubscriptionQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<SubscriptionEntity, SubscriptionMetaDataAttributes,SubscriptionMetaDataRelations>(query, this);
    }
     Attributes = new SubscriptionMetaDataAttributes();
     Relations = new SubscriptionMetaDataRelations();

}


export type SubscriptionQueryBuilder = DwQueryBuilderGen<SubscriptionEntity, SubscriptionMetaDataAttributes,SubscriptionMetaDataRelations>


export class SubscriptionMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Subscription';
    // Attributes
    SubscriptionId = new DwItemAttribute(this.i, 'SubscriptionId');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    SubscriptionTierId = new DwItemAttribute(this.i, 'SubscriptionTierId');
    SubscriptionStatusId = new DwItemAttribute(this.i, 'SubscriptionStatusId');
    EffectiveStartDate = new DwItemAttribute(this.i, 'EffectiveStartDate');
    EffectiveEndDate = new DwItemAttribute(this.i, 'EffectiveEndDate');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    Pending = new DwItemAttribute(this.i, 'Pending');
    DiscountId = new DwItemAttribute(this.i, 'DiscountId');
    FirstInvoiceDateTime = new DwItemAttribute(this.i, 'FirstInvoiceDateTime');
    LastInvoiceDateTime = new DwItemAttribute(this.i, 'LastInvoiceDateTime');
    NextInvoiceDateTime = new DwItemAttribute(this.i, 'NextInvoiceDateTime');
    DiscountAppliedDate = new DwItemAttribute(this.i, 'DiscountAppliedDate');
    DiscountExpirationDate = new DwItemAttribute(this.i, 'DiscountExpirationDate');
}

class SubscriptionMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Discount */
            Discount = new DwItemRelationship('Discount|Subscription|DiscountId', 'Discount', 'Discount');
            /** Relation: Flight School */
            FlightSchool = new DwItemRelationship('FlightSchool|Subscription|FlightSchoolId', 'FlightSchool', 'FlightSchool');
            /** Relation: Subscription Status */
            SubscriptionStatus = new DwItemRelationship('SubscriptionStatus|Subscription|SubscriptionStatusId', 'SubscriptionStatus', 'SubscriptionStatus');
            /** Relation: Subscription Tier */
            SubscriptionTier = new DwItemRelationship('SubscriptionTier|Subscription|SubscriptionTierId', 'SubscriptionTier', 'SubscriptionTier');
            /** Relation: Invoice Line */
            InvoiceLine = new DwItemRelationship('Subscription|InvoiceLine|SubscriptionId', 'InvoiceLine', 'InvoiceLine');
            /** Relation: Ro School Billing Details - Tier */
            RoSchoolBillingDetailsByTier = new DwItemRelationship('roSchoolBillingDetails|SubscriptionTier|SubscriptionTierId', 'TierRoSchoolBillingDetails', 'TierRoSchoolBillingDetails');
            /** Relation: Ro School Subscription - Pending */
            RoSchoolSubscriptionByPendingSubscriptionId = new DwItemRelationship('roSchoolSubscription|Subscription|PendingSubscriptionId', 'PendingRoSchoolSubscription', 'PendingRoSchoolSubscription');
            /** Relation: Ro School Subscription */
            RoSchoolSubscription = new DwItemRelationship('roSchoolSubscription|Subscription|SubscriptionId', 'RoSchoolSubscription', 'RoSchoolSubscription');
            /** Relation: Ro School Subscription - Previous */
            RoSchoolSubscriptionByPreviousSubscriptionId = new DwItemRelationship('roSchoolSubscription|Subscription|PreviousSubscriptionId', 'PreviousRoSchoolSubscription', 'PreviousRoSchoolSubscription');
            /** Relation: Subscription Course Tracking */
            SubscriptionCourseTracking = new DwItemRelationship('Subscription|SubscriptionCourseTracking|SubscriptionId', 'SubscriptionCourseTracking', 'SubscriptionCourseTracking');
            /** Relation: Subscription Role Tracking */
            SubscriptionRoleTracking = new DwItemRelationship('Subscription|SubscriptionRoleTracking|SubscriptionId', 'SubscriptionRoleTracking', 'SubscriptionRoleTracking');
    };
export class SubscriptionCourseTrackingMetaData implements DwItem2<SubscriptionCourseTrackingEntity, SubscriptionCourseTrackingMetaDataAttributes,SubscriptionCourseTrackingMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=501;
        this.ItemDetail.itemName='SubscriptionCourseTracking';
        this.ItemDetail.keyName='SubscriptionCourseTrackingId';
    }

    CreateEntity(): SubscriptionCourseTrackingEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): SubscriptionCourseTrackingQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<SubscriptionCourseTrackingEntity, SubscriptionCourseTrackingMetaDataAttributes,SubscriptionCourseTrackingMetaDataRelations>(query, this);
    }
     Attributes = new SubscriptionCourseTrackingMetaDataAttributes();
     Relations = new SubscriptionCourseTrackingMetaDataRelations();

}


export type SubscriptionCourseTrackingQueryBuilder = DwQueryBuilderGen<SubscriptionCourseTrackingEntity, SubscriptionCourseTrackingMetaDataAttributes,SubscriptionCourseTrackingMetaDataRelations>


export class SubscriptionCourseTrackingMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'SubscriptionCourseTracking';
    // Attributes
    SubscriptionCourseTrackingId = new DwItemAttribute(this.i, 'SubscriptionCourseTrackingId');
    StudentCourseId = new DwItemAttribute(this.i, 'StudentCourseId');
    StudentId = new DwItemAttribute(this.i, 'StudentId');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    SubscriptionId = new DwItemAttribute(this.i, 'SubscriptionId');
    SubscriptionRoleId = new DwItemAttribute(this.i, 'SubscriptionRoleId');
    CourseId = new DwItemAttribute(this.i, 'CourseId');
    GrantedDateTime = new DwItemAttribute(this.i, 'GrantedDateTime');
    Revoked = new DwItemAttribute(this.i, 'Revoked');
    RevokedDateTime = new DwItemAttribute(this.i, 'RevokedDateTime');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class SubscriptionCourseTrackingMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Course */
            Course = new DwItemRelationship('Course|SubscriptionCourseTracking|CourseId', 'Course', 'Course');
            /** Relation: Flight School */
            FlightSchool = new DwItemRelationship('FlightSchool|SubscriptionCourseTracking|FlightSchoolId', 'FlightSchool', 'FlightSchool');
            /** Relation: Student */
            Student = new DwItemRelationship('Student|SubscriptionCourseTracking|StudentId', 'Student', 'Student');
            /** Relation: Student Course */
            StudentCourse = new DwItemRelationship('StudentCourse|SubscriptionCourseTracking|StudentCourseId', 'StudentCourse', 'StudentCourse');
            /** Relation: Subscription */
            Subscription = new DwItemRelationship('Subscription|SubscriptionCourseTracking|SubscriptionId', 'Subscription', 'Subscription');
            /** Relation: Subscription Role */
            SubscriptionRole = new DwItemRelationship('SubscriptionRole|SubscriptionCourseTracking|SubscriptionRoleId', 'SubscriptionRole', 'SubscriptionRole');
    };
export class SubscriptionFeatureMetaData implements DwItem2<SubscriptionFeatureEntity, SubscriptionFeatureMetaDataAttributes,SubscriptionFeatureMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=287;
        this.ItemDetail.itemName='SubscriptionFeature';
        this.ItemDetail.keyName='SubscriptionFeatureId';
    }

    CreateEntity(): SubscriptionFeatureEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): SubscriptionFeatureQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<SubscriptionFeatureEntity, SubscriptionFeatureMetaDataAttributes,SubscriptionFeatureMetaDataRelations>(query, this);
    }
     Attributes = new SubscriptionFeatureMetaDataAttributes();
     Relations = new SubscriptionFeatureMetaDataRelations();

}


export type SubscriptionFeatureQueryBuilder = DwQueryBuilderGen<SubscriptionFeatureEntity, SubscriptionFeatureMetaDataAttributes,SubscriptionFeatureMetaDataRelations>


export class SubscriptionFeatureMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'SubscriptionFeature';
    // Attributes
    SubscriptionFeatureId = new DwItemAttribute(this.i, 'SubscriptionFeatureId');
    SubscriptionFeature = new DwItemAttribute(this.i, 'SubscriptionFeature');
    FeatureKey = new DwItemAttribute(this.i, 'FeatureKey');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class SubscriptionFeatureMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Subscription Tier Feature */
            SubscriptionTierFeature = new DwItemRelationship('SubscriptionFeature|SubscriptionTierFeature|SubscriptionFeatureId', 'SubscriptionTierFeature', 'SubscriptionTierFeature');
    };
export class SubscriptionRoleMetaData implements DwItem2<SubscriptionRoleEntity, SubscriptionRoleMetaDataAttributes,SubscriptionRoleMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=246;
        this.ItemDetail.itemName='SubscriptionRole';
        this.ItemDetail.keyName='SubscriptionRoleId';
    }

    CreateEntity(): SubscriptionRoleEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): SubscriptionRoleQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<SubscriptionRoleEntity, SubscriptionRoleMetaDataAttributes,SubscriptionRoleMetaDataRelations>(query, this);
    }
     Attributes = new SubscriptionRoleMetaDataAttributes();
     Relations = new SubscriptionRoleMetaDataRelations();

}


export type SubscriptionRoleQueryBuilder = DwQueryBuilderGen<SubscriptionRoleEntity, SubscriptionRoleMetaDataAttributes,SubscriptionRoleMetaDataRelations>


export class SubscriptionRoleMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'SubscriptionRole';
    // Attributes
    SubscriptionRoleId = new DwItemAttribute(this.i, 'SubscriptionRoleId');
    SubscriptionRole = new DwItemAttribute(this.i, 'SubscriptionRole');
    DevwareRoleId = new DwItemAttribute(this.i, 'DevwareRoleId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    ProductId = new DwItemAttribute(this.i, 'ProductId');
}

class SubscriptionRoleMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Role - Devware Role */
            DwRoleByDevwareRoleId = new DwItemRelationship('dw_Role|SubscriptionRole|DevwareRoleId', 'DevwareDwRole', 'DevwareDwRole');
            /** Relation: Discount Subscription Role */
            DiscountSubscriptionRole = new DwItemRelationship('SubscriptionRole|DiscountSubscriptionRole|SubscriptionRoleId', 'DiscountSubscriptionRole', 'DiscountSubscriptionRole');
            /** Relation: Join Request Type Subscription Role */
            JoinRequestTypeSubscriptionRole = new DwItemRelationship('SubscriptionRole|JoinRequestTypeSubscriptionRole|SubscriptionRoleId', 'JoinRequestTypeSubscriptionRole', 'JoinRequestTypeSubscriptionRole');
            /** Relation: Ro School Billing Details */
            RoSchoolBillingDetails = new DwItemRelationship('roSchoolBillingDetails|SubscriptionRole|SubscriptionRoled', 'RoSchoolBillingDetails', 'RoSchoolBillingDetails');
            /** Relation: Subscription Course Tracking */
            SubscriptionCourseTracking = new DwItemRelationship('SubscriptionRole|SubscriptionCourseTracking|SubscriptionRoleId', 'SubscriptionCourseTracking', 'SubscriptionCourseTracking');
            /** Relation: Subscription Role Tracking */
            SubscriptionRoleTracking = new DwItemRelationship('SubscriptionRole|SubscriptionRoleTracking|SubscriptionRoleId', 'SubscriptionRoleTracking', 'SubscriptionRoleTracking');
            /** Relation: Subscription Tier Role */
            SubscriptionTierRole = new DwItemRelationship('SubscriptionRole|SubscriptionTierRole|SubscriptionRoleId', 'SubscriptionTierRole', 'SubscriptionTierRole');
            /** Relation: User Subscription Role */
            UserSubscriptionRole = new DwItemRelationship('SubscriptionRole|UserSubscriptionRole|SubscriptionRoleId', 'UserSubscriptionRole', 'UserSubscriptionRole');
    };
export class SubscriptionRoleTrackingMetaData implements DwItem2<SubscriptionRoleTrackingEntity, SubscriptionRoleTrackingMetaDataAttributes,SubscriptionRoleTrackingMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=249;
        this.ItemDetail.itemName='SubscriptionRoleTracking';
        this.ItemDetail.keyName='SubscriptionRoleTrackingId';
    }

    CreateEntity(): SubscriptionRoleTrackingEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): SubscriptionRoleTrackingQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<SubscriptionRoleTrackingEntity, SubscriptionRoleTrackingMetaDataAttributes,SubscriptionRoleTrackingMetaDataRelations>(query, this);
    }
     Attributes = new SubscriptionRoleTrackingMetaDataAttributes();
     Relations = new SubscriptionRoleTrackingMetaDataRelations();

}


export type SubscriptionRoleTrackingQueryBuilder = DwQueryBuilderGen<SubscriptionRoleTrackingEntity, SubscriptionRoleTrackingMetaDataAttributes,SubscriptionRoleTrackingMetaDataRelations>


export class SubscriptionRoleTrackingMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'SubscriptionRoleTracking';
    // Attributes
    SubscriptionRoleTrackingId = new DwItemAttribute(this.i, 'SubscriptionRoleTrackingId');
    SubscriptionId = new DwItemAttribute(this.i, 'SubscriptionId');
    SubscriptionRoleId = new DwItemAttribute(this.i, 'SubscriptionRoleId');
    StartDate = new DwItemAttribute(this.i, 'StartDate');
    EndDate = new DwItemAttribute(this.i, 'EndDate');
    MinCount = new DwItemAttribute(this.i, 'MinCount');
    MinCountDate = new DwItemAttribute(this.i, 'MinCountDate');
    MaxCount = new DwItemAttribute(this.i, 'MaxCount');
    MaxCountDate = new DwItemAttribute(this.i, 'MaxCountDate');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    InvoiceMonth = new DwItemAttribute(this.i, 'InvoiceMonth');
    InvoiceYear = new DwItemAttribute(this.i, 'InvoiceYear');
}

class SubscriptionRoleTrackingMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Subscription */
            Subscription = new DwItemRelationship('Subscription|SubscriptionRoleTracking|SubscriptionId', 'Subscription', 'Subscription');
            /** Relation: Subscription Role */
            SubscriptionRole = new DwItemRelationship('SubscriptionRole|SubscriptionRoleTracking|SubscriptionRoleId', 'SubscriptionRole', 'SubscriptionRole');
    };
export class SubscriptionStatusMetaData implements DwItem2<SubscriptionStatusEntity, SubscriptionStatusMetaDataAttributes,SubscriptionStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=245;
        this.ItemDetail.itemName='SubscriptionStatus';
        this.ItemDetail.keyName='SubscriptionStatusId';
    }

    CreateEntity(): SubscriptionStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): SubscriptionStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<SubscriptionStatusEntity, SubscriptionStatusMetaDataAttributes,SubscriptionStatusMetaDataRelations>(query, this);
    }
     Attributes = new SubscriptionStatusMetaDataAttributes();
     Relations = new SubscriptionStatusMetaDataRelations();

}


export type SubscriptionStatusQueryBuilder = DwQueryBuilderGen<SubscriptionStatusEntity, SubscriptionStatusMetaDataAttributes,SubscriptionStatusMetaDataRelations>


export class SubscriptionStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'SubscriptionStatus';
    // Attributes
    SubscriptionStatusId = new DwItemAttribute(this.i, 'SubscriptionStatusId');
    SubscriptionStatus = new DwItemAttribute(this.i, 'SubscriptionStatus');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class SubscriptionStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Subscription */
            Subscription = new DwItemRelationship('SubscriptionStatus|Subscription|SubscriptionStatusId', 'Subscription', 'Subscription');
    };
export class SubscriptionTierMetaData implements DwItem2<SubscriptionTierEntity, SubscriptionTierMetaDataAttributes,SubscriptionTierMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=242;
        this.ItemDetail.itemName='SubscriptionTier';
        this.ItemDetail.keyName='SubscriptionTierId';
    }

    CreateEntity(): SubscriptionTierEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): SubscriptionTierQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<SubscriptionTierEntity, SubscriptionTierMetaDataAttributes,SubscriptionTierMetaDataRelations>(query, this);
    }
     Attributes = new SubscriptionTierMetaDataAttributes();
     Relations = new SubscriptionTierMetaDataRelations();

}


export type SubscriptionTierQueryBuilder = DwQueryBuilderGen<SubscriptionTierEntity, SubscriptionTierMetaDataAttributes,SubscriptionTierMetaDataRelations>


export class SubscriptionTierMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'SubscriptionTier';
    // Attributes
    SubscriptionTierId = new DwItemAttribute(this.i, 'SubscriptionTierId');
    SubscriptionTierName = new DwItemAttribute(this.i, 'SubscriptionTierName');
    SubscriptionTierStatusId = new DwItemAttribute(this.i, 'SubscriptionTierStatusId');
    EffectiveStartDate = new DwItemAttribute(this.i, 'EffectiveStartDate');
    EffectiveEndDate = new DwItemAttribute(this.i, 'EffectiveEndDate');
    PlatformMonthlyCost = new DwItemAttribute(this.i, 'PlatformMonthlyCost');
    ProfitSharingPercentage = new DwItemAttribute(this.i, 'ProfitSharingPercentage');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    ProductId = new DwItemAttribute(this.i, 'ProductId');
    PriceId = new DwItemAttribute(this.i, 'PriceId');
    Description = new DwItemAttribute(this.i, 'Description');
    IsDefaultTier = new DwItemAttribute(this.i, 'IsDefaultTier');
    SubscriptionTierOrder = new DwItemAttribute(this.i, 'SubscriptionTierOrder');
    LimitToSchools = new DwItemAttribute(this.i, 'LimitToSchools');
}

class SubscriptionTierMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Subscription Tier Status */
            SubscriptionTierStatus = new DwItemRelationship('SubscriptionTierStatus|SubscriptionTier|SubscriptionTierStatusId', 'SubscriptionTierStatus', 'SubscriptionTierStatus');
            /** Relation: Discount */
            Discount = new DwItemRelationship('SubscriptionTier|Discount|SubscriptionTierId', 'Discount', 'Discount');
            /** Relation: Product */
            Product = new DwItemRelationship('SubscriptionTier|Product|SubscriptionTierId', 'Product', 'Product');
            /** Relation: Subscription */
            Subscription = new DwItemRelationship('SubscriptionTier|Subscription|SubscriptionTierId', 'Subscription', 'Subscription');
            /** Relation: Subscription Tier Benefit */
            SubscriptionTierBenefit = new DwItemRelationship('SubscriptionTier|SubscriptionTierBenefit|SubscriptionTierId', 'SubscriptionTierBenefit', 'SubscriptionTierBenefit');
            /** Relation: Subscription Tier Feature */
            SubscriptionTierFeature = new DwItemRelationship('SubscriptionTier|SubscriptionTierFeature|SubscriptionTierId', 'SubscriptionTierFeature', 'SubscriptionTierFeature');
            /** Relation: Subscription Tier Flight School */
            SubscriptionTierFlightSchool = new DwItemRelationship('SubscriptionTier|SubscriptionTierFlightSchool|SubscriptionTierId', 'SubscriptionTierFlightSchool', 'SubscriptionTierFlightSchool');
            /** Relation: Subscription Tier Role */
            SubscriptionTierRole = new DwItemRelationship('SubscriptionTier|SubscriptionTierRole|SubscriptionTierId', 'SubscriptionTierRole', 'SubscriptionTierRole');
    };
export class SubscriptionTierBenefitMetaData implements DwItem2<SubscriptionTierBenefitEntity, SubscriptionTierBenefitMetaDataAttributes,SubscriptionTierBenefitMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=267;
        this.ItemDetail.itemName='SubscriptionTierBenefit';
        this.ItemDetail.keyName='SubscriptionTierBenefitId';
    }

    CreateEntity(): SubscriptionTierBenefitEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): SubscriptionTierBenefitQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<SubscriptionTierBenefitEntity, SubscriptionTierBenefitMetaDataAttributes,SubscriptionTierBenefitMetaDataRelations>(query, this);
    }
     Attributes = new SubscriptionTierBenefitMetaDataAttributes();
     Relations = new SubscriptionTierBenefitMetaDataRelations();

}


export type SubscriptionTierBenefitQueryBuilder = DwQueryBuilderGen<SubscriptionTierBenefitEntity, SubscriptionTierBenefitMetaDataAttributes,SubscriptionTierBenefitMetaDataRelations>


export class SubscriptionTierBenefitMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'SubscriptionTierBenefit';
    // Attributes
    SubscriptionTierBenefitId = new DwItemAttribute(this.i, 'SubscriptionTierBenefitId');
    SubscriptionTierId = new DwItemAttribute(this.i, 'SubscriptionTierId');
    BenefitDescription = new DwItemAttribute(this.i, 'BenefitDescription');
    Display = new DwItemAttribute(this.i, 'Display');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class SubscriptionTierBenefitMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Subscription Tier */
            SubscriptionTier = new DwItemRelationship('SubscriptionTier|SubscriptionTierBenefit|SubscriptionTierId', 'SubscriptionTier', 'SubscriptionTier');
    };
export class SubscriptionTierFeatureMetaData implements DwItem2<SubscriptionTierFeatureEntity, SubscriptionTierFeatureMetaDataAttributes,SubscriptionTierFeatureMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=288;
        this.ItemDetail.itemName='SubscriptionTierFeature';
        this.ItemDetail.keyName='SubscriptionTierFeatureId';
    }

    CreateEntity(): SubscriptionTierFeatureEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): SubscriptionTierFeatureQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<SubscriptionTierFeatureEntity, SubscriptionTierFeatureMetaDataAttributes,SubscriptionTierFeatureMetaDataRelations>(query, this);
    }
     Attributes = new SubscriptionTierFeatureMetaDataAttributes();
     Relations = new SubscriptionTierFeatureMetaDataRelations();

}


export type SubscriptionTierFeatureQueryBuilder = DwQueryBuilderGen<SubscriptionTierFeatureEntity, SubscriptionTierFeatureMetaDataAttributes,SubscriptionTierFeatureMetaDataRelations>


export class SubscriptionTierFeatureMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'SubscriptionTierFeature';
    // Attributes
    SubscriptionTierFeatureId = new DwItemAttribute(this.i, 'SubscriptionTierFeatureId');
    SubscriptionTierId = new DwItemAttribute(this.i, 'SubscriptionTierId');
    SubscriptionFeatureId = new DwItemAttribute(this.i, 'SubscriptionFeatureId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class SubscriptionTierFeatureMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Subscription Feature */
            SubscriptionFeature = new DwItemRelationship('SubscriptionFeature|SubscriptionTierFeature|SubscriptionFeatureId', 'SubscriptionFeature', 'SubscriptionFeature');
            /** Relation: Subscription Tier */
            SubscriptionTier = new DwItemRelationship('SubscriptionTier|SubscriptionTierFeature|SubscriptionTierId', 'SubscriptionTier', 'SubscriptionTier');
    };
export class SubscriptionTierFlightSchoolMetaData implements DwItem2<SubscriptionTierFlightSchoolEntity, SubscriptionTierFlightSchoolMetaDataAttributes,SubscriptionTierFlightSchoolMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=502;
        this.ItemDetail.itemName='SubscriptionTierFlightSchool';
        this.ItemDetail.keyName='SubscriptionTierFlightSchoolId';
    }

    CreateEntity(): SubscriptionTierFlightSchoolEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): SubscriptionTierFlightSchoolQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<SubscriptionTierFlightSchoolEntity, SubscriptionTierFlightSchoolMetaDataAttributes,SubscriptionTierFlightSchoolMetaDataRelations>(query, this);
    }
     Attributes = new SubscriptionTierFlightSchoolMetaDataAttributes();
     Relations = new SubscriptionTierFlightSchoolMetaDataRelations();

}


export type SubscriptionTierFlightSchoolQueryBuilder = DwQueryBuilderGen<SubscriptionTierFlightSchoolEntity, SubscriptionTierFlightSchoolMetaDataAttributes,SubscriptionTierFlightSchoolMetaDataRelations>


export class SubscriptionTierFlightSchoolMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'SubscriptionTierFlightSchool';
    // Attributes
    SubscriptionTierFlightSchoolId = new DwItemAttribute(this.i, 'SubscriptionTierFlightSchoolId');
    SubscriptionTierId = new DwItemAttribute(this.i, 'SubscriptionTierId');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class SubscriptionTierFlightSchoolMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School */
            FlightSchool = new DwItemRelationship('FlightSchool|SubscriptionTierFlightSchool|FlightSchoolId', 'FlightSchool', 'FlightSchool');
            /** Relation: Subscription Tier */
            SubscriptionTier = new DwItemRelationship('SubscriptionTier|SubscriptionTierFlightSchool|SubscriptionTierId', 'SubscriptionTier', 'SubscriptionTier');
    };
export class SubscriptionTierRoleMetaData implements DwItem2<SubscriptionTierRoleEntity, SubscriptionTierRoleMetaDataAttributes,SubscriptionTierRoleMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=247;
        this.ItemDetail.itemName='SubscriptionTierRole';
        this.ItemDetail.keyName='SubscriptionTierRoleId';
    }

    CreateEntity(): SubscriptionTierRoleEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): SubscriptionTierRoleQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<SubscriptionTierRoleEntity, SubscriptionTierRoleMetaDataAttributes,SubscriptionTierRoleMetaDataRelations>(query, this);
    }
     Attributes = new SubscriptionTierRoleMetaDataAttributes();
     Relations = new SubscriptionTierRoleMetaDataRelations();

}


export type SubscriptionTierRoleQueryBuilder = DwQueryBuilderGen<SubscriptionTierRoleEntity, SubscriptionTierRoleMetaDataAttributes,SubscriptionTierRoleMetaDataRelations>


export class SubscriptionTierRoleMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'SubscriptionTierRole';
    // Attributes
    SubscriptionTierRoleId = new DwItemAttribute(this.i, 'SubscriptionTierRoleId');
    SubscriptionTierId = new DwItemAttribute(this.i, 'SubscriptionTierId');
    SubscriptionRoleId = new DwItemAttribute(this.i, 'SubscriptionRoleId');
    MonthlyCost = new DwItemAttribute(this.i, 'MonthlyCost');
    MinimumBilled = new DwItemAttribute(this.i, 'MinimumBilled');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    PriceId = new DwItemAttribute(this.i, 'PriceId');
}

class SubscriptionTierRoleMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Subscription Role */
            SubscriptionRole = new DwItemRelationship('SubscriptionRole|SubscriptionTierRole|SubscriptionRoleId', 'SubscriptionRole', 'SubscriptionRole');
            /** Relation: Subscription Tier */
            SubscriptionTier = new DwItemRelationship('SubscriptionTier|SubscriptionTierRole|SubscriptionTierId', 'SubscriptionTier', 'SubscriptionTier');
    };
export class SubscriptionTierStatusMetaData implements DwItem2<SubscriptionTierStatusEntity, SubscriptionTierStatusMetaDataAttributes,SubscriptionTierStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=243;
        this.ItemDetail.itemName='SubscriptionTierStatus';
        this.ItemDetail.keyName='SubscriptionTierStatusId';
    }

    CreateEntity(): SubscriptionTierStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): SubscriptionTierStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<SubscriptionTierStatusEntity, SubscriptionTierStatusMetaDataAttributes,SubscriptionTierStatusMetaDataRelations>(query, this);
    }
     Attributes = new SubscriptionTierStatusMetaDataAttributes();
     Relations = new SubscriptionTierStatusMetaDataRelations();

}


export type SubscriptionTierStatusQueryBuilder = DwQueryBuilderGen<SubscriptionTierStatusEntity, SubscriptionTierStatusMetaDataAttributes,SubscriptionTierStatusMetaDataRelations>


export class SubscriptionTierStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'SubscriptionTierStatus';
    // Attributes
    SubscriptionTierStatusId = new DwItemAttribute(this.i, 'SubscriptionTierStatusId');
    SubscriptionTierStatus = new DwItemAttribute(this.i, 'SubscriptionTierStatus');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class SubscriptionTierStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Subscription Tier */
            SubscriptionTier = new DwItemRelationship('SubscriptionTierStatus|SubscriptionTier|SubscriptionTierStatusId', 'SubscriptionTier', 'SubscriptionTier');
    };
export class TemplateFieldAlignmentMetaData implements DwItem2<TemplateFieldAlignmentEntity, TemplateFieldAlignmentMetaDataAttributes,TemplateFieldAlignmentMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=227;
        this.ItemDetail.itemName='TemplateFieldAlignment';
        this.ItemDetail.keyName='TemplateFieldAlignmentId';
    }

    CreateEntity(): TemplateFieldAlignmentEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): TemplateFieldAlignmentQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<TemplateFieldAlignmentEntity, TemplateFieldAlignmentMetaDataAttributes,TemplateFieldAlignmentMetaDataRelations>(query, this);
    }
     Attributes = new TemplateFieldAlignmentMetaDataAttributes();
     Relations = new TemplateFieldAlignmentMetaDataRelations();

}


export type TemplateFieldAlignmentQueryBuilder = DwQueryBuilderGen<TemplateFieldAlignmentEntity, TemplateFieldAlignmentMetaDataAttributes,TemplateFieldAlignmentMetaDataRelations>


export class TemplateFieldAlignmentMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'TemplateFieldAlignment';
    // Attributes
    TemplateFieldAlignmentId = new DwItemAttribute(this.i, 'TemplateFieldAlignmentId');
    AlignmentDisplay = new DwItemAttribute(this.i, 'AlignmentDisplay');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class TemplateFieldAlignmentMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Course Endorsement Template Field */
            CourseEndorsementTemplateField = new DwItemRelationship('TemplateFieldAlignment|CourseEndorsementTemplateField|TemplateFieldAlignmentId', 'CourseEndorsementTemplateField', 'CourseEndorsementTemplateField');
    };
export class TemplateFieldTypeMetaData implements DwItem2<TemplateFieldTypeEntity, TemplateFieldTypeMetaDataAttributes,TemplateFieldTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=225;
        this.ItemDetail.itemName='TemplateFieldType';
        this.ItemDetail.keyName='TemplateFieldTypeId';
    }

    CreateEntity(): TemplateFieldTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): TemplateFieldTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<TemplateFieldTypeEntity, TemplateFieldTypeMetaDataAttributes,TemplateFieldTypeMetaDataRelations>(query, this);
    }
     Attributes = new TemplateFieldTypeMetaDataAttributes();
     Relations = new TemplateFieldTypeMetaDataRelations();

}


export type TemplateFieldTypeQueryBuilder = DwQueryBuilderGen<TemplateFieldTypeEntity, TemplateFieldTypeMetaDataAttributes,TemplateFieldTypeMetaDataRelations>


export class TemplateFieldTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'TemplateFieldType';
    // Attributes
    TemplateFieldTypeId = new DwItemAttribute(this.i, 'TemplateFieldTypeId');
    FieldType = new DwItemAttribute(this.i, 'FieldType');
}

class TemplateFieldTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Course Endorsement Template Field */
            CourseEndorsementTemplateField = new DwItemRelationship('TemplateFieldType|CourseEndorsementTemplateField|TemplateFieldTypeId', 'CourseEndorsementTemplateField', 'CourseEndorsementTemplateField');
    };
export class TemplateFontStyleMetaData implements DwItem2<TemplateFontStyleEntity, TemplateFontStyleMetaDataAttributes,TemplateFontStyleMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=226;
        this.ItemDetail.itemName='TemplateFontStyle';
        this.ItemDetail.keyName='TemplateFontStyleId';
    }

    CreateEntity(): TemplateFontStyleEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): TemplateFontStyleQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<TemplateFontStyleEntity, TemplateFontStyleMetaDataAttributes,TemplateFontStyleMetaDataRelations>(query, this);
    }
     Attributes = new TemplateFontStyleMetaDataAttributes();
     Relations = new TemplateFontStyleMetaDataRelations();

}


export type TemplateFontStyleQueryBuilder = DwQueryBuilderGen<TemplateFontStyleEntity, TemplateFontStyleMetaDataAttributes,TemplateFontStyleMetaDataRelations>


export class TemplateFontStyleMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'TemplateFontStyle';
    // Attributes
    TemplateFontStyleId = new DwItemAttribute(this.i, 'TemplateFontStyleId');
    StyleName = new DwItemAttribute(this.i, 'StyleName');
    FontFamily = new DwItemAttribute(this.i, 'FontFamily');
    FontSize = new DwItemAttribute(this.i, 'FontSize');
    IsBold = new DwItemAttribute(this.i, 'IsBold');
    IsItalics = new DwItemAttribute(this.i, 'IsItalics');
    Color = new DwItemAttribute(this.i, 'Color');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class TemplateFontStyleMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Course Endorsement Template Field */
            CourseEndorsementTemplateField = new DwItemRelationship('TemplateFontStyle|CourseEndorsementTemplateField|TemplateFontStyleId', 'CourseEndorsementTemplateField', 'CourseEndorsementTemplateField');
    };
export class DwThemeMetaData implements DwItem2<DwThemeEntity, DwThemeMetaDataAttributes,DwThemeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=235;
        this.ItemDetail.itemName='dw_Theme';
        this.ItemDetail.keyName='ThemeId';
    }

    CreateEntity(): DwThemeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwThemeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwThemeEntity, DwThemeMetaDataAttributes,DwThemeMetaDataRelations>(query, this);
    }
     Attributes = new DwThemeMetaDataAttributes();
     Relations = new DwThemeMetaDataRelations();

}


export type DwThemeQueryBuilder = DwQueryBuilderGen<DwThemeEntity, DwThemeMetaDataAttributes,DwThemeMetaDataRelations>


export class DwThemeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_Theme';
    // Attributes
    ThemeId = new DwItemAttribute(this.i, 'ThemeId');
    ThemeName = new DwItemAttribute(this.i, 'ThemeName');
    IsDefault = new DwItemAttribute(this.i, 'IsDefault');
    LogoMediaId = new DwItemAttribute(this.i, 'LogoMediaId');
    LogoWidth = new DwItemAttribute(this.i, 'LogoWidth');
    LogoHeight = new DwItemAttribute(this.i, 'LogoHeight');
    AlternateLogoMediaId = new DwItemAttribute(this.i, 'AlternateLogoMediaId');
    AlternateLogoWidth = new DwItemAttribute(this.i, 'AlternateLogoWidth');
    AlternateLogoHeight = new DwItemAttribute(this.i, 'AlternateLogoHeight');
    LogoLoginMediaId = new DwItemAttribute(this.i, 'LogoLoginMediaId');
    LogoLoginWidth = new DwItemAttribute(this.i, 'LogoLoginWidth');
    LogoLoginHeight = new DwItemAttribute(this.i, 'LogoLoginHeight');
}

class DwThemeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Media - Alternate Logo Media */
            DwMediaByAlternateLogoMediaId = new DwItemRelationship('dw_Media|dw_Theme|AlternateLogoMediaId', 'AlternateLogoDwMedia', 'AlternateLogoDwMedia');
            /** Relation: Media - Logo Media */
            DwMediaByLogoMediaId = new DwItemRelationship('dw_Media|dw_Theme|LogoMediaId', 'LogoDwMedia', 'LogoDwMedia');
            /** Relation: Media - Logo Login Media */
            DwMediaByLogoLoginMediaId = new DwItemRelationship('dw_Media|dw_Theme|LogoLoginMediaId', 'LogoLoginDwMedia', 'LogoLoginDwMedia');
            /** Relation: Flight School Branding */
            FlightSchoolBranding = new DwItemRelationship('dw_Theme|FlightSchoolBranding|ThemeId', 'FlightSchoolBranding', 'FlightSchoolBranding');
            /** Relation: Theme Property */
            DwThemeProperty = new DwItemRelationship('dw_Theme|dw_ThemeProperty|ThemeId', 'DwThemeProperty', 'DwThemeProperty');
    };
export class DwThemePropertyMetaData implements DwItem2<DwThemePropertyEntity, DwThemePropertyMetaDataAttributes,DwThemePropertyMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=236;
        this.ItemDetail.itemName='dw_ThemeProperty';
        this.ItemDetail.keyName='ThemePropertyId';
    }

    CreateEntity(): DwThemePropertyEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwThemePropertyQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwThemePropertyEntity, DwThemePropertyMetaDataAttributes,DwThemePropertyMetaDataRelations>(query, this);
    }
     Attributes = new DwThemePropertyMetaDataAttributes();
     Relations = new DwThemePropertyMetaDataRelations();

}


export type DwThemePropertyQueryBuilder = DwQueryBuilderGen<DwThemePropertyEntity, DwThemePropertyMetaDataAttributes,DwThemePropertyMetaDataRelations>


export class DwThemePropertyMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_ThemeProperty';
    // Attributes
    ThemePropertyId = new DwItemAttribute(this.i, 'ThemePropertyId');
    ThemeId = new DwItemAttribute(this.i, 'ThemeId');
    ThemePropertyDefinitionId = new DwItemAttribute(this.i, 'ThemePropertyDefinitionId');
    PropertyValue = new DwItemAttribute(this.i, 'PropertyValue');
}

class DwThemePropertyMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Theme */
            DwTheme = new DwItemRelationship('dw_Theme|dw_ThemeProperty|ThemeId', 'DwTheme', 'DwTheme');
            /** Relation: Theme Property Definition */
            DwThemePropertyDefinition = new DwItemRelationship('dw_ThemePropertyDefinition|dw_ThemeProperty|ThemePropertyDefinitionId', 'DwThemePropertyDefinition', 'DwThemePropertyDefinition');
    };
export class DwThemePropertyDefinitionMetaData implements DwItem2<DwThemePropertyDefinitionEntity, DwThemePropertyDefinitionMetaDataAttributes,DwThemePropertyDefinitionMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=237;
        this.ItemDetail.itemName='dw_ThemePropertyDefinition';
        this.ItemDetail.keyName='ThemePropertyDefinitionId';
    }

    CreateEntity(): DwThemePropertyDefinitionEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwThemePropertyDefinitionQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwThemePropertyDefinitionEntity, DwThemePropertyDefinitionMetaDataAttributes,DwThemePropertyDefinitionMetaDataRelations>(query, this);
    }
     Attributes = new DwThemePropertyDefinitionMetaDataAttributes();
     Relations = new DwThemePropertyDefinitionMetaDataRelations();

}


export type DwThemePropertyDefinitionQueryBuilder = DwQueryBuilderGen<DwThemePropertyDefinitionEntity, DwThemePropertyDefinitionMetaDataAttributes,DwThemePropertyDefinitionMetaDataRelations>


export class DwThemePropertyDefinitionMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_ThemePropertyDefinition';
    // Attributes
    ThemePropertyDefinitionId = new DwItemAttribute(this.i, 'ThemePropertyDefinitionId');
    PropertyDisplay = new DwItemAttribute(this.i, 'PropertyDisplay');
    PropertyName = new DwItemAttribute(this.i, 'PropertyName');
    ThemePropertyTypeId = new DwItemAttribute(this.i, 'ThemePropertyTypeId');
}

class DwThemePropertyDefinitionMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Theme Property Type */
            DwThemePropertyType = new DwItemRelationship('dw_ThemePropertyType|dw_ThemePropertyDefinition|ThemePropertyTypeId', 'DwThemePropertyType', 'DwThemePropertyType');
            /** Relation: Theme Property */
            DwThemeProperty = new DwItemRelationship('dw_ThemePropertyDefinition|dw_ThemeProperty|ThemePropertyDefinitionId', 'DwThemeProperty', 'DwThemeProperty');
    };
export class DwThemePropertyTypeMetaData implements DwItem2<DwThemePropertyTypeEntity, DwThemePropertyTypeMetaDataAttributes,DwThemePropertyTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=238;
        this.ItemDetail.itemName='dw_ThemePropertyType';
        this.ItemDetail.keyName='ThemePropertyTypeId';
    }

    CreateEntity(): DwThemePropertyTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwThemePropertyTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwThemePropertyTypeEntity, DwThemePropertyTypeMetaDataAttributes,DwThemePropertyTypeMetaDataRelations>(query, this);
    }
     Attributes = new DwThemePropertyTypeMetaDataAttributes();
     Relations = new DwThemePropertyTypeMetaDataRelations();

}


export type DwThemePropertyTypeQueryBuilder = DwQueryBuilderGen<DwThemePropertyTypeEntity, DwThemePropertyTypeMetaDataAttributes,DwThemePropertyTypeMetaDataRelations>


export class DwThemePropertyTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_ThemePropertyType';
    // Attributes
    ThemePropertyTypeId = new DwItemAttribute(this.i, 'ThemePropertyTypeId');
    PropertyType = new DwItemAttribute(this.i, 'PropertyType');
}

class DwThemePropertyTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Theme Property Definition */
            DwThemePropertyDefinition = new DwItemRelationship('dw_ThemePropertyType|dw_ThemePropertyDefinition|ThemePropertyTypeId', 'DwThemePropertyDefinition', 'DwThemePropertyDefinition');
    };
export class TimeZoneMetaData implements DwItem2<TimeZoneEntity, TimeZoneMetaDataAttributes,TimeZoneMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=207;
        this.ItemDetail.itemName='TimeZone';
        this.ItemDetail.keyName='TimezoneId';
    }

    CreateEntity(): TimeZoneEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): TimeZoneQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<TimeZoneEntity, TimeZoneMetaDataAttributes,TimeZoneMetaDataRelations>(query, this);
    }
     Attributes = new TimeZoneMetaDataAttributes();
     Relations = new TimeZoneMetaDataRelations();

}


export type TimeZoneQueryBuilder = DwQueryBuilderGen<TimeZoneEntity, TimeZoneMetaDataAttributes,TimeZoneMetaDataRelations>


export class TimeZoneMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'TimeZone';
    // Attributes
    TimezoneId = new DwItemAttribute(this.i, 'TimezoneId');
    TimezoneName = new DwItemAttribute(this.i, 'TimezoneName');
    TimezoneShortName = new DwItemAttribute(this.i, 'TimezoneShortName');
    GmtOffSet = new DwItemAttribute(this.i, 'GmtOffSet');
    TimeZoneDescription = new DwItemAttribute(this.i, 'TimeZoneDescription');
    IANAIdentifier = new DwItemAttribute(this.i, 'IANAIdentifier');
    DotNetBCLIdentifier = new DwItemAttribute(this.i, 'DotNetBCLIdentifier');
}

class TimeZoneMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Address */
            Address = new DwItemRelationship('TimeZone|Address|TimezoneId', 'Address', 'Address');
            /** Relation: Flight School - Default - Many */
            FlightSchoolByDefaultTimeZoneId = new DwItemRelationship('TimeZone|FlightSchool|DefaultTimeZoneId', 'DefaultTimeZoneIdFlightSchool', 'DefaultTimeZoneIdFlightSchool');
            /** Relation: Postal Code - Many */
            PostalCodeByTimeZoneId = new DwItemRelationship('TimeZone|PostalCode|TimeZoneId', 'TimeZoneIdPostalCode', 'TimeZoneIdPostalCode');
            /** Relation: Student - Many */
            StudentByTimeZoneId = new DwItemRelationship('TimeZone|Student|TimeZoneId', 'TimeZoneIdStudent', 'TimeZoneIdStudent');
            /** Relation: Student Gamification Day - Many */
            StudentGamificationDayByTimeZoneId = new DwItemRelationship('TimeZone|StudentGamificationDay|TimeZoneId', 'TimeZoneIdStudentGamificationDay', 'TimeZoneIdStudentGamificationDay');
            /** Relation: Student Gamification Summary - Many */
            StudentGamificationSummaryByTimeZoneId = new DwItemRelationship('TimeZone|StudentGamificationSummary|TimeZoneId', 'TimeZoneIdStudentGamificationSummary', 'TimeZoneIdStudentGamificationSummary');
    };
export class DwUserMetaData implements DwItem2<DwUserEntity, DwUserMetaDataAttributes,DwUserMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=46;
        this.ItemDetail.itemName='dw_User';
        this.ItemDetail.keyName='UserId';
    }

    CreateEntity(): DwUserEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwUserQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwUserEntity, DwUserMetaDataAttributes,DwUserMetaDataRelations>(query, this);
    }
     Attributes = new DwUserMetaDataAttributes();
     Relations = new DwUserMetaDataRelations();

}


export type DwUserQueryBuilder = DwQueryBuilderGen<DwUserEntity, DwUserMetaDataAttributes,DwUserMetaDataRelations>


export class DwUserMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_User';
    // Attributes
    AlternateName = new DwItemAttribute(this.i, 'AlternateName');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    Email = new DwItemAttribute(this.i, 'Email');
    FirstName = new DwItemAttribute(this.i, 'FirstName');
    ForcePasswordChange = new DwItemAttribute(this.i, 'ForcePasswordChange');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    IsEmailVerified = new DwItemAttribute(this.i, 'IsEmailVerified');
    IsTwoFactorAuthenticationEnabled = new DwItemAttribute(this.i, 'IsTwoFactorAuthenticationEnabled');
    LastLoginDateTime = new DwItemAttribute(this.i, 'LastLoginDateTime');
    LastName = new DwItemAttribute(this.i, 'LastName');
    LastPasswordChangeDateTime = new DwItemAttribute(this.i, 'LastPasswordChangeDateTime');
    MobilePhone = new DwItemAttribute(this.i, 'MobilePhone');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    OrganizationId = new DwItemAttribute(this.i, 'OrganizationId');
    PartyReferenceId = new DwItemAttribute(this.i, 'PartyReferenceId');
    TwoFactorAuthenticationTypeId = new DwItemAttribute(this.i, 'TwoFactorAuthenticationTypeId');
    UserBackgroundMediaId = new DwItemAttribute(this.i, 'UserBackgroundMediaId');
    UserId = new DwItemAttribute(this.i, 'UserId');
    UserKey = new DwItemAttribute(this.i, 'UserKey');
    UserName = new DwItemAttribute(this.i, 'UserName');
    UserPictureMediaId = new DwItemAttribute(this.i, 'UserPictureMediaId');
    UserTypeId = new DwItemAttribute(this.i, 'UserTypeId');
    Password = new DwItemAttribute(this.i, 'Password');
}

class DwUserMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Media - User Picture Media */
            DwMediaByUserPictureMediaId = new DwItemRelationship('dw_Media|dw_User|UserPictureMediaId', 'UserPictureDwMedia', 'UserPictureDwMedia');
            /** Relation: Media - User Background Media */
            DwMediaByUserBackgroundMediaId = new DwItemRelationship('dw_Media|dw_User|UserBackgroundMediaId', 'UserBackgroundDwMedia', 'UserBackgroundDwMedia');
            /** Relation: User Type */
            DwUserType = new DwItemRelationship('dw_UserType|dw_User|UserTypeId', 'DwUserType', 'DwUserType');
            /** Relation: Course Availability Notification */
            CourseAvailabilityNotification = new DwItemRelationship('dw_User|CourseAvailabilityNotification|UserId', 'CourseAvailabilityNotification', 'CourseAvailabilityNotification');
            /** Relation: Course Lesson Flag - Modified By - Many */
            CourseLessonFlagByModifiedBy = new DwItemRelationship('dw_User|CourseLessonFlag|ModifiedBy', 'ModifiedByCourseLessonFlag', 'ModifiedByCourseLessonFlag');
            /** Relation: Course Lesson Flag - Created By - Many */
            CourseLessonFlagByCreatedBy = new DwItemRelationship('dw_User|CourseLessonFlag|CreatedBy', 'CreatedByCourseLessonFlag', 'CreatedByCourseLessonFlag');
            /** Relation: Course Purchase Reservation Course */
            CoursePurchaseReservationCourse = new DwItemRelationship('dw_User|CoursePurchaseReservationCourse|UserId', 'CoursePurchaseReservationCourse', 'CoursePurchaseReservationCourse');
            /** Relation: Discount - Limit To - Many */
            DiscountByLimitToUserId = new DwItemRelationship('dw_User|Discount|LimitToUserId', 'LimitToDiscount', 'LimitToDiscount');
            /** Relation: Discount Usage User */
            DiscountUsageUser = new DwItemRelationship('dw_User|DiscountUsageUser|UserId', 'DiscountUsageUser', 'DiscountUsageUser');
            /** Relation: Flight School Billing Contact */
            FlightSchoolBillingContact = new DwItemRelationship('dw_User|FlightSchoolBillingContact|UserId', 'FlightSchoolBillingContact', 'FlightSchoolBillingContact');
            /** Relation: Instructor */
            Instructor = new DwItemRelationship('dw_User|Instructor|UserId', 'Instructor', 'Instructor');
            /** Relation: Integration User */
            IntegrationUser = new DwItemRelationship('dw_User|IntegrationUser|UserId', 'IntegrationUser', 'IntegrationUser');
            /** Relation: Invoice */
            Invoice = new DwItemRelationship('dw_User|Invoice|UserId', 'Invoice', 'Invoice');
            /** Relation: Join Request Course Purchase */
            JoinRequestCoursePurchase = new DwItemRelationship('dw_User|JoinRequestCoursePurchase|UserId', 'JoinRequestCoursePurchase', 'JoinRequestCoursePurchase');
            /** Relation: Join Request Email */
            JoinRequestEmail = new DwItemRelationship('dw_User|JoinRequestEmail|UserId', 'JoinRequestEmail', 'JoinRequestEmail');
            /** Relation: Processor Config */
            ProcessorConfig = new DwItemRelationship('dw_User|ProcessorConfig|UserId', 'ProcessorConfig', 'ProcessorConfig');
            /** Relation: Processor Config Customer History - Changed By - Many */
            ProcessorConfigCustomerHistoryByChangedBy = new DwItemRelationship('dw_User|ProcessorConfigCustomerHistory|ChangedBy', 'ChangedByProcessorConfigCustomerHistory', 'ChangedByProcessorConfigCustomerHistory');
            /** Relation: Profit Share - Affiliate - Many */
            ProfitShareByAffiliateUserId = new DwItemRelationship('dw_User|ProfitShare|AffiliateUserId', 'AffiliateProfitShare', 'AffiliateProfitShare');
            /** Relation: Ro Student Overview Details */
            RoStudentOverviewDetails = new DwItemRelationship('User|RoStudentOverviewDetails|UserId', 'RoStudentOverviewDetails', 'RoStudentOverviewDetails');
            /** Relation: Ro Student Payment Method */
            RoStudentPaymentMethod = new DwItemRelationship('RoStudentPaymentMethod|User|UserId', 'RoStudentPaymentMethod', 'RoStudentPaymentMethod');
            /** Relation: Ro Student School Course */
            RoStudentSchoolCourses = new DwItemRelationship('RoStudentSchoolCourse|User|UserId', 'RoStudentSchoolCourses', 'RoStudentSchoolCourses');
            /** Relation: Ro User Role Detail */
            RoUserRoleDetail = new DwItemRelationship('RoUserRoleDetail|User|UserId', 'RoUserRoleDetail', 'RoUserRoleDetail');
            /** Relation: Student */
            Student = new DwItemRelationship('dw_User|Student|UserId', 'Student', 'Student');
            /** Relation: Student Activity - Actor - Many */
            StudentActivityByActorUserId = new DwItemRelationship('dw_User|StudentActivity|ActorUserId', 'ActorStudentActivity', 'ActorStudentActivity');
            /** Relation: Student Progress Reset Event - Reset By - Many */
            StudentProgressResetEventByResetByUserId = new DwItemRelationship('dw_User|StudentProgressResetEvent|ResetByUserId', 'ResetByStudentProgressResetEvent', 'ResetByStudentProgressResetEvent');
            /** Relation: User Detail */
            UserDetail = new DwItemRelationship('dw_User|UserDetail|UserId', 'UserDetail', 'UserDetail');
            /** Relation: User Document Section Favorite */
            UserDocumentSectionFavorite = new DwItemRelationship('dw_User|UserDocumentSectionFavorite|UserId', 'UserDocumentSectionFavorite', 'UserDocumentSectionFavorite');
            /** Relation: User Role */
            DwUserRole = new DwItemRelationship('dw_User|dw_UserRole|UserId', 'DwUserRole', 'DwUserRole');
            /** Relation: User Subscription Role */
            UserSubscriptionRole = new DwItemRelationship('dw_User|UserSubscriptionRole|UserId', 'UserSubscriptionRole', 'UserSubscriptionRole');
    };
export class UserDetailMetaData implements DwItem2<UserDetailEntity, UserDetailMetaDataAttributes,UserDetailMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=217;
        this.ItemDetail.itemName='UserDetail';
        this.ItemDetail.keyName='UserDetailId';
    }

    CreateEntity(): UserDetailEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): UserDetailQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<UserDetailEntity, UserDetailMetaDataAttributes,UserDetailMetaDataRelations>(query, this);
    }
     Attributes = new UserDetailMetaDataAttributes();
     Relations = new UserDetailMetaDataRelations();

}


export type UserDetailQueryBuilder = DwQueryBuilderGen<UserDetailEntity, UserDetailMetaDataAttributes,UserDetailMetaDataRelations>


export class UserDetailMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'UserDetail';
    // Attributes
    UserDetailId = new DwItemAttribute(this.i, 'UserDetailId');
    UserId = new DwItemAttribute(this.i, 'UserId');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    PortalConfigId = new DwItemAttribute(this.i, 'PortalConfigId');
    OnboardingVersion = new DwItemAttribute(this.i, 'OnboardingVersion');
}

class UserDetailMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Flight School */
            FlightSchool = new DwItemRelationship('FlightSchool|UserDetail|FlightSchoolId', 'FlightSchool', 'FlightSchool');
            /** Relation: User */
            DwUser = new DwItemRelationship('dw_User|UserDetail|UserId', 'DwUser', 'DwUser');
    };
export class UserDocumentSectionFavoriteMetaData implements DwItem2<UserDocumentSectionFavoriteEntity, UserDocumentSectionFavoriteMetaDataAttributes,UserDocumentSectionFavoriteMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=466;
        this.ItemDetail.itemName='UserDocumentSectionFavorite';
        this.ItemDetail.keyName='UserDocumentSectionFavoriteId';
    }

    CreateEntity(): UserDocumentSectionFavoriteEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): UserDocumentSectionFavoriteQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<UserDocumentSectionFavoriteEntity, UserDocumentSectionFavoriteMetaDataAttributes,UserDocumentSectionFavoriteMetaDataRelations>(query, this);
    }
     Attributes = new UserDocumentSectionFavoriteMetaDataAttributes();
     Relations = new UserDocumentSectionFavoriteMetaDataRelations();

}


export type UserDocumentSectionFavoriteQueryBuilder = DwQueryBuilderGen<UserDocumentSectionFavoriteEntity, UserDocumentSectionFavoriteMetaDataAttributes,UserDocumentSectionFavoriteMetaDataRelations>


export class UserDocumentSectionFavoriteMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'UserDocumentSectionFavorite';
    // Attributes
    UserDocumentSectionFavoriteId = new DwItemAttribute(this.i, 'UserDocumentSectionFavoriteId');
    UserId = new DwItemAttribute(this.i, 'UserId');
    DocumentItemId = new DwItemAttribute(this.i, 'DocumentItemId');
    SectionReferenceKey = new DwItemAttribute(this.i, 'SectionReferenceKey');
    ReferenceLocatorText = new DwItemAttribute(this.i, 'ReferenceLocatorText');
    OriginalDocumentVersionId = new DwItemAttribute(this.i, 'OriginalDocumentVersionId');
    OriginalDocumentSectionId = new DwItemAttribute(this.i, 'OriginalDocumentSectionId');
    ReferenceStatusId = new DwItemAttribute(this.i, 'ReferenceStatusId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class UserDocumentSectionFavoriteMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Document Item */
            DocumentItem = new DwItemRelationship('DocumentItem|UserDocumentSectionFavorite|DocumentItemId', 'DocumentItem', 'DocumentItem');
            /** Relation: Document Section - Original Document Section */
            DocumentSectionByOriginalDocumentSectionId = new DwItemRelationship('DocumentSection|UserDocumentSectionFavorite|OriginalDocumentSectionId', 'OriginalDocumentSection', 'OriginalDocumentSection');
            /** Relation: Document Version - Original Document Version */
            DocumentVersionByOriginalDocumentVersionId = new DwItemRelationship('DocumentVersion|UserDocumentSectionFavorite|OriginalDocumentVersionId', 'OriginalDocumentVersion', 'OriginalDocumentVersion');
            /** Relation: Reference Status */
            ReferenceStatus = new DwItemRelationship('ReferenceStatus|UserDocumentSectionFavorite|ReferenceStatusId', 'ReferenceStatus', 'ReferenceStatus');
            /** Relation: User */
            DwUser = new DwItemRelationship('dw_User|UserDocumentSectionFavorite|UserId', 'DwUser', 'DwUser');
    };
export class DwUserRoleMetaData implements DwItem2<DwUserRoleEntity, DwUserRoleMetaDataAttributes,DwUserRoleMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=43;
        this.ItemDetail.itemName='dw_UserRole';
        this.ItemDetail.keyName='UserRoleId';
    }

    CreateEntity(): DwUserRoleEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwUserRoleQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwUserRoleEntity, DwUserRoleMetaDataAttributes,DwUserRoleMetaDataRelations>(query, this);
    }
     Attributes = new DwUserRoleMetaDataAttributes();
     Relations = new DwUserRoleMetaDataRelations();

}


export type DwUserRoleQueryBuilder = DwQueryBuilderGen<DwUserRoleEntity, DwUserRoleMetaDataAttributes,DwUserRoleMetaDataRelations>


export class DwUserRoleMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_UserRole';
    // Attributes
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    RoleId = new DwItemAttribute(this.i, 'RoleId');
    UserId = new DwItemAttribute(this.i, 'UserId');
    UserRoleId = new DwItemAttribute(this.i, 'UserRoleId');
}

class DwUserRoleMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Role */
            DwRole = new DwItemRelationship('dw_Role|dw_UserRole|RoleId', 'DwRole', 'DwRole');
            /** Relation: User */
            DwUser = new DwItemRelationship('dw_User|dw_UserRole|UserId', 'DwUser', 'DwUser');
    };
export class UserSubscriptionRoleMetaData implements DwItem2<UserSubscriptionRoleEntity, UserSubscriptionRoleMetaDataAttributes,UserSubscriptionRoleMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=248;
        this.ItemDetail.itemName='UserSubscriptionRole';
        this.ItemDetail.keyName='UserSubscriptionRoleId';
    }

    CreateEntity(): UserSubscriptionRoleEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): UserSubscriptionRoleQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<UserSubscriptionRoleEntity, UserSubscriptionRoleMetaDataAttributes,UserSubscriptionRoleMetaDataRelations>(query, this);
    }
     Attributes = new UserSubscriptionRoleMetaDataAttributes();
     Relations = new UserSubscriptionRoleMetaDataRelations();

}


export type UserSubscriptionRoleQueryBuilder = DwQueryBuilderGen<UserSubscriptionRoleEntity, UserSubscriptionRoleMetaDataAttributes,UserSubscriptionRoleMetaDataRelations>


export class UserSubscriptionRoleMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'UserSubscriptionRole';
    // Attributes
    UserSubscriptionRoleId = new DwItemAttribute(this.i, 'UserSubscriptionRoleId');
    UserId = new DwItemAttribute(this.i, 'UserId');
    SubscriptionRoleId = new DwItemAttribute(this.i, 'SubscriptionRoleId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class UserSubscriptionRoleMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Subscription Role */
            SubscriptionRole = new DwItemRelationship('SubscriptionRole|UserSubscriptionRole|SubscriptionRoleId', 'SubscriptionRole', 'SubscriptionRole');
            /** Relation: User */
            DwUser = new DwItemRelationship('dw_User|UserSubscriptionRole|UserId', 'DwUser', 'DwUser');
    };
export class DwUserTypeMetaData implements DwItem2<DwUserTypeEntity, DwUserTypeMetaDataAttributes,DwUserTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=133;
        this.ItemDetail.itemName='dw_UserType';
        this.ItemDetail.keyName='UserTypeId';
    }

    CreateEntity(): DwUserTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DwUserTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DwUserTypeEntity, DwUserTypeMetaDataAttributes,DwUserTypeMetaDataRelations>(query, this);
    }
     Attributes = new DwUserTypeMetaDataAttributes();
     Relations = new DwUserTypeMetaDataRelations();

}


export type DwUserTypeQueryBuilder = DwQueryBuilderGen<DwUserTypeEntity, DwUserTypeMetaDataAttributes,DwUserTypeMetaDataRelations>


export class DwUserTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_UserType';
    // Attributes
    ShowOnRegistration = new DwItemAttribute(this.i, 'ShowOnRegistration');
    UserTypeClasses = new DwItemAttribute(this.i, 'UserTypeClasses');
    UserTypeDescription = new DwItemAttribute(this.i, 'UserTypeDescription');
    UserTypeDisplay = new DwItemAttribute(this.i, 'UserTypeDisplay');
    UserTypeId = new DwItemAttribute(this.i, 'UserTypeId');
    UserTypeOrder = new DwItemAttribute(this.i, 'UserTypeOrder');
}

class DwUserTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Join Request Type */
            JoinRequestType = new DwItemRelationship('dw_UserType|JoinRequestType|UserTypeId', 'JoinRequestType', 'JoinRequestType');
            /** Relation: User */
            DwUser = new DwItemRelationship('dw_UserType|dw_User|UserTypeId', 'DwUser', 'DwUser');
    };
export class VectorProviderMetaData implements DwItem2<VectorProviderEntity, VectorProviderMetaDataAttributes,VectorProviderMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=406;
        this.ItemDetail.itemName='VectorProvider';
        this.ItemDetail.keyName='VectorProviderId';
    }

    CreateEntity(): VectorProviderEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): VectorProviderQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<VectorProviderEntity, VectorProviderMetaDataAttributes,VectorProviderMetaDataRelations>(query, this);
    }
     Attributes = new VectorProviderMetaDataAttributes();
     Relations = new VectorProviderMetaDataRelations();

}


export type VectorProviderQueryBuilder = DwQueryBuilderGen<VectorProviderEntity, VectorProviderMetaDataAttributes,VectorProviderMetaDataRelations>


export class VectorProviderMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'VectorProvider';
    // Attributes
    VectorProviderId = new DwItemAttribute(this.i, 'VectorProviderId');
    ProviderName = new DwItemAttribute(this.i, 'ProviderName');
    ProviderType = new DwItemAttribute(this.i, 'ProviderType');
    EnvironmentKey = new DwItemAttribute(this.i, 'EnvironmentKey');
    DisplayName = new DwItemAttribute(this.i, 'DisplayName');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
}

class VectorProviderMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Vector Reference */
            VectorReference = new DwItemRelationship('VectorProvider|VectorReference|VectorProviderId', 'VectorReference', 'VectorReference');
    };
export class VectorReferenceMetaData implements DwItem2<VectorReferenceEntity, VectorReferenceMetaDataAttributes,VectorReferenceMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=405;
        this.ItemDetail.itemName='VectorReference';
        this.ItemDetail.keyName='VectorReferenceId';
    }

    CreateEntity(): VectorReferenceEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): VectorReferenceQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<VectorReferenceEntity, VectorReferenceMetaDataAttributes,VectorReferenceMetaDataRelations>(query, this);
    }
     Attributes = new VectorReferenceMetaDataAttributes();
     Relations = new VectorReferenceMetaDataRelations();

}


export type VectorReferenceQueryBuilder = DwQueryBuilderGen<VectorReferenceEntity, VectorReferenceMetaDataAttributes,VectorReferenceMetaDataRelations>


export class VectorReferenceMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'VectorReference';
    // Attributes
    VectorReferenceId = new DwItemAttribute(this.i, 'VectorReferenceId');
    VectorProviderId = new DwItemAttribute(this.i, 'VectorProviderId');
    MetaDataItemId = new DwItemAttribute(this.i, 'MetaDataItemId');
    KeyValue = new DwItemAttribute(this.i, 'KeyValue');
    VectorNamespace = new DwItemAttribute(this.i, 'VectorNamespace');
    VectorId = new DwItemAttribute(this.i, 'VectorId');
    EmbeddingModel = new DwItemAttribute(this.i, 'EmbeddingModel');
    EmbeddingDimensions = new DwItemAttribute(this.i, 'EmbeddingDimensions');
    IndexedDateTime = new DwItemAttribute(this.i, 'IndexedDateTime');
    LastIndexedHash = new DwItemAttribute(this.i, 'LastIndexedHash');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
}

class VectorReferenceMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Vector Provider */
            VectorProvider = new DwItemRelationship('VectorProvider|VectorReference|VectorProviderId', 'VectorProvider', 'VectorProvider');
            /** Relation: Document Item Chunk */
            DocumentItemChunk = new DwItemRelationship('VectorReference|DocumentItemChunk|VectorReferenceId', 'DocumentItemChunk', 'DocumentItemChunk');
            /** Relation: Document Section */
            DocumentSection = new DwItemRelationship('VectorReference|DocumentSection|VectorReferenceId', 'DocumentSection', 'DocumentSection');
    };
export class VideoMetaData implements DwItem2<VideoEntity, VideoMetaDataAttributes,VideoMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=156;
        this.ItemDetail.itemName='Video';
        this.ItemDetail.keyName='VideoId';
    }

    CreateEntity(): VideoEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): VideoQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<VideoEntity, VideoMetaDataAttributes,VideoMetaDataRelations>(query, this);
    }
     Attributes = new VideoMetaDataAttributes();
     Relations = new VideoMetaDataRelations();

}


export type VideoQueryBuilder = DwQueryBuilderGen<VideoEntity, VideoMetaDataAttributes,VideoMetaDataRelations>


export class VideoMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Video';
    // Attributes
    VideoId = new DwItemAttribute(this.i, 'VideoId');
    VideoName = new DwItemAttribute(this.i, 'VideoName');
    VideoLibraryId = new DwItemAttribute(this.i, 'VideoLibraryId');
    VideoKey = new DwItemAttribute(this.i, 'VideoKey');
    DirectPlayUrl = new DwItemAttribute(this.i, 'DirectPlayUrl');
    ThumbnailUrl = new DwItemAttribute(this.i, 'ThumbnailUrl');
    VideoStreamingProviderId = new DwItemAttribute(this.i, 'VideoStreamingProviderId');
    VideoStatusId = new DwItemAttribute(this.i, 'VideoStatusId');
    VideoSizeBytes = new DwItemAttribute(this.i, 'VideoSizeBytes');
    VideoDurationSeconds = new DwItemAttribute(this.i, 'VideoDurationSeconds');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    AllowMp4 = new DwItemAttribute(this.i, 'AllowMp4');
    IsPrivateVideo = new DwItemAttribute(this.i, 'IsPrivateVideo');
    OriginalFileName = new DwItemAttribute(this.i, 'OriginalFileName');
    VideoDescription = new DwItemAttribute(this.i, 'VideoDescription');
    VideoProcessingStatusId = new DwItemAttribute(this.i, 'VideoProcessingStatusId');
    LastVideoProcessingStatusUpdate = new DwItemAttribute(this.i, 'LastVideoProcessingStatusUpdate');
}

class VideoMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Video Library */
            VideoLibrary = new DwItemRelationship('VideoLibrary|Video|VideoLibraryId', 'VideoLibrary', 'VideoLibrary');
            /** Relation: Video Processing Status */
            VideoProcessingStatus = new DwItemRelationship('VideoProcessingStatus|Video|VideoProcessingStatusId', 'VideoProcessingStatus', 'VideoProcessingStatus');
            /** Relation: Video Status */
            VideoStatus = new DwItemRelationship('VideoStatus|Video|VideoStatusId', 'VideoStatus', 'VideoStatus');
            /** Relation: Video Streaming Provider */
            VideoStreamingProvider = new DwItemRelationship('VideoStreamingProvider|Video|VideoStreamingProviderId', 'VideoStreamingProvider', 'VideoStreamingProvider');
            /** Relation: Lesson */
            CourseLesson = new DwItemRelationship('Video|CourseLesson|VideoId', 'CourseLesson', 'CourseLesson');
            /** Relation: Video History */
            VideoHistory = new DwItemRelationship('Video|VideoHistory|VideoId', 'VideoHistory', 'VideoHistory');
            /** Relation: Video Tag Link */
            VideoTagLink = new DwItemRelationship('Video|VideoTagLink|VideoId', 'VideoTagLink', 'VideoTagLink');
    };
export class VideoHistoryMetaData implements DwItem2<VideoHistoryEntity, VideoHistoryMetaDataAttributes,VideoHistoryMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=216;
        this.ItemDetail.itemName='VideoHistory';
        this.ItemDetail.keyName='VideoHistoryId';
    }

    CreateEntity(): VideoHistoryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): VideoHistoryQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<VideoHistoryEntity, VideoHistoryMetaDataAttributes,VideoHistoryMetaDataRelations>(query, this);
    }
     Attributes = new VideoHistoryMetaDataAttributes();
     Relations = new VideoHistoryMetaDataRelations();

}


export type VideoHistoryQueryBuilder = DwQueryBuilderGen<VideoHistoryEntity, VideoHistoryMetaDataAttributes,VideoHistoryMetaDataRelations>


export class VideoHistoryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'VideoHistory';
    // Attributes
    VideoHistoryId = new DwItemAttribute(this.i, 'VideoHistoryId');
    VideoId = new DwItemAttribute(this.i, 'VideoId');
    VideoKey = new DwItemAttribute(this.i, 'VideoKey');
    DirectPlayUrl = new DwItemAttribute(this.i, 'DirectPlayUrl');
    ThumbnailUrl = new DwItemAttribute(this.i, 'ThumbnailUrl');
    VideoSizeBytes = new DwItemAttribute(this.i, 'VideoSizeBytes');
    VideoDurationSeconds = new DwItemAttribute(this.i, 'VideoDurationSeconds');
    AllowMp4 = new DwItemAttribute(this.i, 'AllowMp4');
    IsPrivateVideo = new DwItemAttribute(this.i, 'IsPrivateVideo');
    OriginalFileName = new DwItemAttribute(this.i, 'OriginalFileName');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class VideoHistoryMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Video */
            Video = new DwItemRelationship('Video|VideoHistory|VideoId', 'Video', 'Video');
    };
export class VideoLibraryMetaData implements DwItem2<VideoLibraryEntity, VideoLibraryMetaDataAttributes,VideoLibraryMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=158;
        this.ItemDetail.itemName='VideoLibrary';
        this.ItemDetail.keyName='VideoLibraryId';
    }

    CreateEntity(): VideoLibraryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): VideoLibraryQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<VideoLibraryEntity, VideoLibraryMetaDataAttributes,VideoLibraryMetaDataRelations>(query, this);
    }
     Attributes = new VideoLibraryMetaDataAttributes();
     Relations = new VideoLibraryMetaDataRelations();

}


export type VideoLibraryQueryBuilder = DwQueryBuilderGen<VideoLibraryEntity, VideoLibraryMetaDataAttributes,VideoLibraryMetaDataRelations>


export class VideoLibraryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'VideoLibrary';
    // Attributes
    VideoLibraryId = new DwItemAttribute(this.i, 'VideoLibraryId');
    VideoLibraryName = new DwItemAttribute(this.i, 'VideoLibraryName');
    VideoLibraryKey = new DwItemAttribute(this.i, 'VideoLibraryKey');
    VideoStreamingProviderId = new DwItemAttribute(this.i, 'VideoStreamingProviderId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    PlaybackConfigKey = new DwItemAttribute(this.i, 'PlaybackConfigKey');
    AuthenticatedPlaybackEnabled = new DwItemAttribute(this.i, 'AuthenticatedPlaybackEnabled');
    PlaybackConfigRevision = new DwItemAttribute(this.i, 'PlaybackConfigRevision');
    VideoPlaybackAuthenticationModeId = new DwItemAttribute(this.i, 'VideoPlaybackAuthenticationModeId');
}

class VideoLibraryMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Video Playback Authentication Mode */
            VideoPlaybackAuthenticationMode = new DwItemRelationship('VideoPlaybackAuthenticationMode|VideoLibrary|VideoPlaybackAuthenticationModeId', 'VideoPlaybackAuthenticationMode', 'VideoPlaybackAuthenticationMode');
            /** Relation: Video Streaming Provider */
            VideoStreamingProvider = new DwItemRelationship('VideoStreamingProvider|VideoLibrary|VideoStreamingProviderId', 'VideoStreamingProvider', 'VideoStreamingProvider');
            /** Relation: Video */
            Video = new DwItemRelationship('VideoLibrary|Video|VideoLibraryId', 'Video', 'Video');
    };
export class VideoPlaybackAuthenticationModeMetaData implements DwItem2<VideoPlaybackAuthenticationModeEntity, VideoPlaybackAuthenticationModeMetaDataAttributes,VideoPlaybackAuthenticationModeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=489;
        this.ItemDetail.itemName='VideoPlaybackAuthenticationMode';
        this.ItemDetail.keyName='VideoPlaybackAuthenticationModeId';
    }

    CreateEntity(): VideoPlaybackAuthenticationModeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): VideoPlaybackAuthenticationModeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<VideoPlaybackAuthenticationModeEntity, VideoPlaybackAuthenticationModeMetaDataAttributes,VideoPlaybackAuthenticationModeMetaDataRelations>(query, this);
    }
     Attributes = new VideoPlaybackAuthenticationModeMetaDataAttributes();
     Relations = new VideoPlaybackAuthenticationModeMetaDataRelations();

}


export type VideoPlaybackAuthenticationModeQueryBuilder = DwQueryBuilderGen<VideoPlaybackAuthenticationModeEntity, VideoPlaybackAuthenticationModeMetaDataAttributes,VideoPlaybackAuthenticationModeMetaDataRelations>


export class VideoPlaybackAuthenticationModeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'VideoPlaybackAuthenticationMode';
    // Attributes
    VideoPlaybackAuthenticationModeId = new DwItemAttribute(this.i, 'VideoPlaybackAuthenticationModeId');
    VideoPlaybackAuthenticationMode = new DwItemAttribute(this.i, 'VideoPlaybackAuthenticationMode');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class VideoPlaybackAuthenticationModeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Video Library */
            VideoLibrary = new DwItemRelationship('VideoPlaybackAuthenticationMode|VideoLibrary|VideoPlaybackAuthenticationModeId', 'VideoLibrary', 'VideoLibrary');
    };
export class VideoProcessingStatusMetaData implements DwItem2<VideoProcessingStatusEntity, VideoProcessingStatusMetaDataAttributes,VideoProcessingStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=409;
        this.ItemDetail.itemName='VideoProcessingStatus';
        this.ItemDetail.keyName='VideoProcessingStatusId';
    }

    CreateEntity(): VideoProcessingStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): VideoProcessingStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<VideoProcessingStatusEntity, VideoProcessingStatusMetaDataAttributes,VideoProcessingStatusMetaDataRelations>(query, this);
    }
     Attributes = new VideoProcessingStatusMetaDataAttributes();
     Relations = new VideoProcessingStatusMetaDataRelations();

}


export type VideoProcessingStatusQueryBuilder = DwQueryBuilderGen<VideoProcessingStatusEntity, VideoProcessingStatusMetaDataAttributes,VideoProcessingStatusMetaDataRelations>


export class VideoProcessingStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'VideoProcessingStatus';
    // Attributes
    VideoProcessingStatusId = new DwItemAttribute(this.i, 'VideoProcessingStatusId');
    VideoProcessingStatus = new DwItemAttribute(this.i, 'VideoProcessingStatus');
}

class VideoProcessingStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Video */
            Video = new DwItemRelationship('VideoProcessingStatus|Video|VideoProcessingStatusId', 'Video', 'Video');
    };
export class VideoStatusMetaData implements DwItem2<VideoStatusEntity, VideoStatusMetaDataAttributes,VideoStatusMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=174;
        this.ItemDetail.itemName='VideoStatus';
        this.ItemDetail.keyName='VideoStatusId';
    }

    CreateEntity(): VideoStatusEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): VideoStatusQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<VideoStatusEntity, VideoStatusMetaDataAttributes,VideoStatusMetaDataRelations>(query, this);
    }
     Attributes = new VideoStatusMetaDataAttributes();
     Relations = new VideoStatusMetaDataRelations();

}


export type VideoStatusQueryBuilder = DwQueryBuilderGen<VideoStatusEntity, VideoStatusMetaDataAttributes,VideoStatusMetaDataRelations>


export class VideoStatusMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'VideoStatus';
    // Attributes
    VideoStatusId = new DwItemAttribute(this.i, 'VideoStatusId');
    VideoStatus = new DwItemAttribute(this.i, 'VideoStatus');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class VideoStatusMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Video */
            Video = new DwItemRelationship('VideoStatus|Video|VideoStatusId', 'Video', 'Video');
    };
export class VideoStreamingProviderMetaData implements DwItem2<VideoStreamingProviderEntity, VideoStreamingProviderMetaDataAttributes,VideoStreamingProviderMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=159;
        this.ItemDetail.itemName='VideoStreamingProvider';
        this.ItemDetail.keyName='VideoStreamingProviderId';
    }

    CreateEntity(): VideoStreamingProviderEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): VideoStreamingProviderQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<VideoStreamingProviderEntity, VideoStreamingProviderMetaDataAttributes,VideoStreamingProviderMetaDataRelations>(query, this);
    }
     Attributes = new VideoStreamingProviderMetaDataAttributes();
     Relations = new VideoStreamingProviderMetaDataRelations();

}


export type VideoStreamingProviderQueryBuilder = DwQueryBuilderGen<VideoStreamingProviderEntity, VideoStreamingProviderMetaDataAttributes,VideoStreamingProviderMetaDataRelations>


export class VideoStreamingProviderMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'VideoStreamingProvider';
    // Attributes
    VideoStreamingProviderId = new DwItemAttribute(this.i, 'VideoStreamingProviderId');
    ProviderName = new DwItemAttribute(this.i, 'ProviderName');
    ProviderManagementUrl = new DwItemAttribute(this.i, 'ProviderManagementUrl');
    AutoPlay = new DwItemAttribute(this.i, 'AutoPlay');
    ContinueFromLastPosition = new DwItemAttribute(this.i, 'ContinueFromLastPosition');
    AllowSeek = new DwItemAttribute(this.i, 'AllowSeek');
    SeekThreshholdSeconds = new DwItemAttribute(this.i, 'SeekThreshholdSeconds');
    PreloadVideo = new DwItemAttribute(this.i, 'PreloadVideo');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    AllowMp4Default = new DwItemAttribute(this.i, 'AllowMp4Default');
    IsPrivateVideoDefault = new DwItemAttribute(this.i, 'IsPrivateVideoDefault');
}

class VideoStreamingProviderMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Video */
            Video = new DwItemRelationship('VideoStreamingProvider|Video|VideoStreamingProviderId', 'Video', 'Video');
            /** Relation: Video Library */
            VideoLibrary = new DwItemRelationship('VideoStreamingProvider|VideoLibrary|VideoStreamingProviderId', 'VideoLibrary', 'VideoLibrary');
    };
export class VideoTagLinkMetaData implements DwItem2<VideoTagLinkEntity, VideoTagLinkMetaDataAttributes,VideoTagLinkMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=215;
        this.ItemDetail.itemName='VideoTagLink';
        this.ItemDetail.keyName='VideoTagLink';
    }

    CreateEntity(): VideoTagLinkEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): VideoTagLinkQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<VideoTagLinkEntity, VideoTagLinkMetaDataAttributes,VideoTagLinkMetaDataRelations>(query, this);
    }
     Attributes = new VideoTagLinkMetaDataAttributes();
     Relations = new VideoTagLinkMetaDataRelations();

}


export type VideoTagLinkQueryBuilder = DwQueryBuilderGen<VideoTagLinkEntity, VideoTagLinkMetaDataAttributes,VideoTagLinkMetaDataRelations>


export class VideoTagLinkMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'VideoTagLink';
    // Attributes
    VideoTagLink = new DwItemAttribute(this.i, 'VideoTagLink');
    VideoId = new DwItemAttribute(this.i, 'VideoId');
    TagId = new DwItemAttribute(this.i, 'TagId');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
}

class VideoTagLinkMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Tag - Question Tag */
            QuestionTagByTagId = new DwItemRelationship('QuestionTag|VideoTagLink|TagId', 'TagIdQuestionTag', 'TagIdQuestionTag');
            /** Relation: Video */
            Video = new DwItemRelationship('Video|VideoTagLink|VideoId', 'Video', 'Video');
    };
// Generated Query Classes for MetaData Service
export class CourseListForStudentQueryMetaData implements DwItem2<CourseListForStudentQueryEntity, CourseListForStudentQueryMetaDataAttributes,CourseMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Course_List-_For_Student';

    constructor() {
        this.ItemDetail.itemId=145;
        this.ItemDetail.itemName='Course';
        this.ItemDetail.keyName='CourseId';
    }

    CreateEntity(): CourseListForStudentQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): CourseListForStudentQueryBuilder {
        return new DwQueryBuilderGen<CourseListForStudentQueryEntity, CourseListForStudentQueryMetaDataAttributes,CourseMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<CourseListForStudentQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: CourseListForStudentQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<CourseListForStudentQueryEntity, CourseListForStudentQueryMetaDataAttributes,CourseMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new CourseListForStudentQueryMetaDataAttributes();
     Relations = new CourseMetaDataRelations();

}


export type CourseListForStudentQueryBuilder = DwQueryBuilderGen<CourseListForStudentQueryEntity, CourseListForStudentQueryMetaDataAttributes,CourseMetaDataRelations>


export class CourseListForStudentQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Course';
    // Attributes
    CourseId = new DwItemAttribute(this.i, 'CourseId');
    CourseName = new DwItemAttribute(this.i, 'CourseName');
    CourseDescription = new DwItemAttribute(this.i, 'CourseDescription');
    CourseTypeId = new DwItemAttribute(this.i, 'CourseTypeId');
    CourseImageMediaId = new DwItemAttribute(this.i, 'CourseImageMediaId');
    CourseNotes = new DwItemAttribute(this.i, 'CourseNotes');
    AircraftTypeId = new DwItemAttribute(this.i, 'AircraftTypeId');
    AvionicsType = new DwItemAttribute(this.i, 'AvionicsType');
    ProgramTypeId = new DwItemAttribute(this.i, 'ProgramTypeId');
    RetailPrice = new DwItemAttribute(this.i, 'RetailPrice');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    CourseStatusId = new DwItemAttribute(this.i, 'CourseStatusId');
    TotalCourseTimeSeconds = new DwItemAttribute(this.i, 'TotalCourseTimeSeconds');
    TotalCourseVideoTimeSeconds = new DwItemAttribute(this.i, 'TotalCourseVideoTimeSeconds');
    TotalCourseQuizTimeSeconds = new DwItemAttribute(this.i, 'TotalCourseQuizTimeSeconds');
    CourseKey = new DwItemAttribute(this.i, 'CourseKey');
    DefaultSchoolCourse = new DwItemAttribute(this.i, 'DefaultSchoolCourse');
    AcsTestId = new DwItemAttribute(this.i, 'AcsTestId');
    CourseOrder = new DwItemAttribute(this.i, 'CourseOrder');
    ModulePrefixOverride = new DwItemAttribute(this.i, 'ModulePrefixOverride');
    ComingSoon = new DwItemAttribute(this.i, 'ComingSoon');
    StudentCourseStudentCourseId = new DwItemAttribute('StudentCourse', 'StudentCourseStudentCourseId');
    StudentCourseStudentId = new DwItemAttribute('StudentCourse', 'StudentCourseStudentId');
    StudentCourseCourseId = new DwItemAttribute('StudentCourse', 'StudentCourseCourseId');
    StudentCourseIsActive = new DwItemAttribute('StudentCourse', 'StudentCourseIsActive');
    StudentCoursePercentComplete = new DwItemAttribute('StudentCourse', 'StudentCoursePercentComplete');
    StudentCourseModulesCompleted = new DwItemAttribute('StudentCourse', 'StudentCourseModulesCompleted');
    StudentCourseModulesCount = new DwItemAttribute('StudentCourse', 'StudentCourseModulesCount');
    StudentCourseLastActivityDateTime = new DwItemAttribute('StudentCourse', 'StudentCourseLastActivityDateTime');
    StudentCourseIsEndorsed = new DwItemAttribute('StudentCourse', 'StudentCourseIsEndorsed');
    StudentCourseStudentCourseStatusId = new DwItemAttribute('StudentCourse', 'StudentCourseStudentCourseStatusId');
    StudentUserId = new DwItemAttribute('Student', 'StudentUserId');
    AcsTestResultCount = new DwItemAttribute('RoStudentCourseAcsTestResultDetail', 'AcsTestResultCount');
    AcsTestResultsPassedAny = new DwItemAttribute('RoStudentCourseAcsTestResultDetail', 'AcsTestResultsPassedAny');
    AcsTestResultsFailedAny = new DwItemAttribute('RoStudentCourseAcsTestResultDetail', 'AcsTestResultsFailedAny');
    CourseEndorsementStudentCourseEndorsementStudentId = new DwItemAttribute('roCourseEndorsementStudentActive', 'CourseEndorsementStudentCourseEndorsementStudentId');
    CourseEndorsementStudentCourseEndorsementId = new DwItemAttribute('roCourseEndorsementStudentActive', 'CourseEndorsementStudentCourseEndorsementId');
    CourseEndorsementStudentCompletionDateTime = new DwItemAttribute('roCourseEndorsementStudentActive', 'CourseEndorsementStudentCompletionDateTime');
    CourseEndorsementStudentExpirationDateTime = new DwItemAttribute('roCourseEndorsementStudentActive', 'CourseEndorsementStudentExpirationDateTime');
    CourseEndorsementStudentEndorsementPDFMediaId = new DwItemAttribute('roCourseEndorsementStudentActive', 'CourseEndorsementStudentEndorsementPDFMediaId');
    NextCourseLessonCourseLessonId = new DwItemAttribute('CourseLesson', 'NextCourseLessonCourseLessonId');
    NextCourseLessonLessonName = new DwItemAttribute('CourseLesson', 'NextCourseLessonLessonName');
    CourseModuleCourseModuleId = new DwItemAttribute('CourseModule', 'CourseModuleCourseModuleId');
    CourseModuleCourseId = new DwItemAttribute('CourseModule', 'CourseModuleCourseId');
    MediaImageHeight = new DwItemAttribute('dw_roMedia', 'MediaImageHeight');
    MediaImageWidth = new DwItemAttribute('dw_roMedia', 'MediaImageWidth');
    MediaMediaPath = new DwItemAttribute('dw_roMedia', 'MediaMediaPath');
}
export class ModuleListForStudentQueryMetaData implements DwItem2<ModuleListForStudentQueryEntity, ModuleListForStudentQueryMetaDataAttributes,CourseModuleMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Module_List-For_Student';

    constructor() {
        this.ItemDetail.itemId=152;
        this.ItemDetail.itemName='CourseModule';
        this.ItemDetail.keyName='CourseModuleId';
    }

    CreateEntity(): ModuleListForStudentQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): ModuleListForStudentQueryBuilder {
        return new DwQueryBuilderGen<ModuleListForStudentQueryEntity, ModuleListForStudentQueryMetaDataAttributes,CourseModuleMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<ModuleListForStudentQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: ModuleListForStudentQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<ModuleListForStudentQueryEntity, ModuleListForStudentQueryMetaDataAttributes,CourseModuleMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new ModuleListForStudentQueryMetaDataAttributes();
     Relations = new CourseModuleMetaDataRelations();

}


export type ModuleListForStudentQueryBuilder = DwQueryBuilderGen<ModuleListForStudentQueryEntity, ModuleListForStudentQueryMetaDataAttributes,CourseModuleMetaDataRelations>


export class ModuleListForStudentQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CourseModule';
    // Attributes
    CourseModuleId = new DwItemAttribute(this.i, 'CourseModuleId');
    CourseId = new DwItemAttribute(this.i, 'CourseId');
    CourseIdDisplay = new DwItemAttribute(this.i, 'CourseIdDisplay');
    ModuleName = new DwItemAttribute(this.i, 'ModuleName');
    ModuleDescription = new DwItemAttribute(this.i, 'ModuleDescription');
    ModuleImageMediaId = new DwItemAttribute(this.i, 'ModuleImageMediaId');
    ModuleImageMediaIdDisplay = new DwItemAttribute(this.i, 'ModuleImageMediaIdDisplay');
    ModuleOrder = new DwItemAttribute(this.i, 'ModuleOrder');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedByDisplay = new DwItemAttribute(this.i, 'CreatedByDisplay');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedByDisplay = new DwItemAttribute(this.i, 'ModifiedByDisplay');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    ModuleStatusId = new DwItemAttribute(this.i, 'ModuleStatusId');
    ModuleStatusIdDisplay = new DwItemAttribute(this.i, 'ModuleStatusIdDisplay');
    TotalModuleTimeSeconds = new DwItemAttribute(this.i, 'TotalModuleTimeSeconds');
    TotalModuleVideoTimeSeconds = new DwItemAttribute(this.i, 'TotalModuleVideoTimeSeconds');
    TotalModuleQuizTimeSeconds = new DwItemAttribute(this.i, 'TotalModuleQuizTimeSeconds');
    AIOverviewHtml = new DwItemAttribute(this.i, 'AIOverviewHtml');
    AIKeyConceptText = new DwItemAttribute(this.i, 'AIKeyConceptText');
    AIProcessingReferenceId = new DwItemAttribute(this.i, 'AIProcessingReferenceId');
    AIProcessingReferenceIdDisplay = new DwItemAttribute(this.i, 'AIProcessingReferenceIdDisplay');
    ModuleBasicName = new DwItemAttribute(this.i, 'ModuleBasicName');
    DisableDocumentLinking = new DwItemAttribute(this.i, 'DisableDocumentLinking');
    CourseModuleProgressCourseModuleProgressId = new DwItemAttribute('CourseModuleProgress', 'CourseModuleProgressCourseModuleProgressId');
    CourseModuleProgressPercentComplete = new DwItemAttribute('CourseModuleProgress', 'CourseModuleProgressPercentComplete');
    CourseModuleProgressLessonsCompleted = new DwItemAttribute('CourseModuleProgress', 'CourseModuleProgressLessonsCompleted');
    CourseModuleProgressLessonsCount = new DwItemAttribute('CourseModuleProgress', 'CourseModuleProgressLessonsCount');
    CourseModuleProgressLastActivityDateTime = new DwItemAttribute('CourseModuleProgress', 'CourseModuleProgressLastActivityDateTime');
    CourseModuleProgressTotalTimeSeconds = new DwItemAttribute('CourseModuleProgress', 'CourseModuleProgressTotalTimeSeconds');
    CourseModuleProgressFirstActivityDateTime = new DwItemAttribute('CourseModuleProgress', 'CourseModuleProgressFirstActivityDateTime');
    CourseModuleProgressCompletedDateTime = new DwItemAttribute('CourseModuleProgress', 'CourseModuleProgressCompletedDateTime');
    StudentCourseIsActive = new DwItemAttribute('StudentCourse', 'StudentCourseIsActive');
    StudentStudentId = new DwItemAttribute('Student', 'StudentStudentId');
    StudentUserId = new DwItemAttribute('Student', 'StudentUserId');
    StudentUserIdDisplay = new DwItemAttribute('Student', 'StudentUserIdDisplay');
    CourseImageMediaPath = new DwItemAttribute('dw_roMedia', 'CourseImageMediaPath');
    AIPromptRequestAIPromptRequestId = new DwItemAttribute('AIPromptRequest', 'AIPromptRequestAIPromptRequestId');
    AIPromptRequestAIPromptRequestStatusId = new DwItemAttribute('AIPromptRequest', 'AIPromptRequestAIPromptRequestStatusId');
    AIPromptRequestAIPromptRequestStatusIdDisplay = new DwItemAttribute('AIPromptRequest', 'AIPromptRequestAIPromptRequestStatusIdDisplay');
    MediaImageWidth = new DwItemAttribute('dw_roMedia', 'MediaImageWidth');
    MediaImageHeight = new DwItemAttribute('dw_roMedia', 'MediaImageHeight');
    MediaMediaPath = new DwItemAttribute('dw_roMedia', 'MediaMediaPath');
}
export class LessonListForStudentQueryMetaData implements DwItem2<LessonListForStudentQueryEntity, LessonListForStudentQueryMetaDataAttributes,CourseLessonMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Lesson_List-For_Student';

    constructor() {
        this.ItemDetail.itemId=153;
        this.ItemDetail.itemName='CourseLesson';
        this.ItemDetail.keyName='CourseLessonId';
    }

    CreateEntity(): LessonListForStudentQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): LessonListForStudentQueryBuilder {
        return new DwQueryBuilderGen<LessonListForStudentQueryEntity, LessonListForStudentQueryMetaDataAttributes,CourseLessonMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<LessonListForStudentQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: LessonListForStudentQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<LessonListForStudentQueryEntity, LessonListForStudentQueryMetaDataAttributes,CourseLessonMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new LessonListForStudentQueryMetaDataAttributes();
     Relations = new CourseLessonMetaDataRelations();

}


export type LessonListForStudentQueryBuilder = DwQueryBuilderGen<LessonListForStudentQueryEntity, LessonListForStudentQueryMetaDataAttributes,CourseLessonMetaDataRelations>


export class LessonListForStudentQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CourseLesson';
    // Attributes
    CourseLessonId = new DwItemAttribute(this.i, 'CourseLessonId');
    CourseModuleId = new DwItemAttribute(this.i, 'CourseModuleId');
    CourseModuleIdDisplay = new DwItemAttribute(this.i, 'CourseModuleIdDisplay');
    LessonName = new DwItemAttribute(this.i, 'LessonName');
    LessonDescription = new DwItemAttribute(this.i, 'LessonDescription');
    LessonTypeId = new DwItemAttribute(this.i, 'LessonTypeId');
    LessonTypeIdDisplay = new DwItemAttribute(this.i, 'LessonTypeIdDisplay');
    VideoId = new DwItemAttribute(this.i, 'VideoId');
    VideoIdDisplay = new DwItemAttribute(this.i, 'VideoIdDisplay');
    QuizId = new DwItemAttribute(this.i, 'QuizId');
    QuizIdDisplay = new DwItemAttribute(this.i, 'QuizIdDisplay');
    LessonOrder = new DwItemAttribute(this.i, 'LessonOrder');
    LessonImageMediaId = new DwItemAttribute(this.i, 'LessonImageMediaId');
    LessonImageMediaIdDisplay = new DwItemAttribute(this.i, 'LessonImageMediaIdDisplay');
    IsPreview = new DwItemAttribute(this.i, 'IsPreview');
    CourseLessonProgressCourseLessonProgressId = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressCourseLessonProgressId');
    CourseLessonProgressLessonComplete = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressLessonComplete');
    CourseLessonProgressVideoFurthestTimeSeconds = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressVideoFurthestTimeSeconds');
    CourseLessonProgressBestQuizResultId = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressBestQuizResultId');
    CourseLessonProgressBestQuizResultIdDisplay = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressBestQuizResultIdDisplay');
    CourseLessonProgressLastActivityDateTime = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressLastActivityDateTime');
    CourseLessonProgressPercentComplete = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressPercentComplete');
    CourseLessonProgressTotalTimeSeconds = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressTotalTimeSeconds');
    CourseLessonProgressFirstActivityDateTime = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressFirstActivityDateTime');
    CourseLessonProgressCompletedDateTime = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressCompletedDateTime');
    CourseLessonProgressCourseLessonId = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressCourseLessonId');
    CourseLessonProgressCourseLessonIdDisplay = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressCourseLessonIdDisplay');
    CourseLessonProgressLessonProgressStatusId = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressLessonProgressStatusId');
    CourseLessonProgressLessonProgressStatusIdDisplay = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressLessonProgressStatusIdDisplay');
    CourseLessonProgressCourseModuleProgressId = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressCourseModuleProgressId');
    CourseLessonProgressCourseModuleProgressIdDisplay = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressCourseModuleProgressIdDisplay');
    CourseLessonProgressCreatedBy = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressCreatedBy');
    CourseLessonProgressCreatedByDisplay = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressCreatedByDisplay');
    CourseLessonProgressCreatedDateTime = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressCreatedDateTime');
    CourseLessonProgressModifiedBy = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressModifiedBy');
    CourseLessonProgressModifiedByDisplay = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressModifiedByDisplay');
    CourseLessonProgressModifiedDateTime = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressModifiedDateTime');
    CourseModuleProgressCourseModuleId = new DwItemAttribute('CourseModuleProgress', 'CourseModuleProgressCourseModuleId');
    CourseModuleProgressCourseModuleIdDisplay = new DwItemAttribute('CourseModuleProgress', 'CourseModuleProgressCourseModuleIdDisplay');
    StudentCourseCourseId = new DwItemAttribute('StudentCourse', 'StudentCourseCourseId');
    StudentCourseCourseIdDisplay = new DwItemAttribute('StudentCourse', 'StudentCourseCourseIdDisplay');
    StudentCourseIsActive = new DwItemAttribute('StudentCourse', 'StudentCourseIsActive');
    StudentStudentId = new DwItemAttribute('Student', 'StudentStudentId');
    StudentUserId = new DwItemAttribute('Student', 'StudentUserId');
    StudentUserIdDisplay = new DwItemAttribute('Student', 'StudentUserIdDisplay');
    CourseImageMediaPath = new DwItemAttribute('dw_roMedia', 'CourseImageMediaPath');
    CourseModuleCourseId = new DwItemAttribute('CourseModule', 'CourseModuleCourseId');
    CourseModuleCourseIdDisplay = new DwItemAttribute('CourseModule', 'CourseModuleCourseIdDisplay');
    ModuleImageMediaPath = new DwItemAttribute('dw_roMedia', 'ModuleImageMediaPath');
    VideoThumbnailUrl = new DwItemAttribute('Video', 'VideoThumbnailUrl');
    VideoVideoName = new DwItemAttribute('Video', 'VideoVideoName');
    LessonImageDwroMediaMediaPath = new DwItemAttribute('dw_roMedia', 'LessonImageDwroMediaMediaPath');
}
export class StudentCourseProgressQueryMetaData implements DwItem2<StudentCourseProgressQueryEntity, StudentCourseProgressQueryMetaDataAttributes,StudentMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Student-Course_Progress';

    constructor() {
        this.ItemDetail.itemId=144;
        this.ItemDetail.itemName='Student';
        this.ItemDetail.keyName='StudentId';
    }

    CreateEntity(): StudentCourseProgressQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): StudentCourseProgressQueryBuilder {
        return new DwQueryBuilderGen<StudentCourseProgressQueryEntity, StudentCourseProgressQueryMetaDataAttributes,StudentMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<StudentCourseProgressQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: StudentCourseProgressQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<StudentCourseProgressQueryEntity, StudentCourseProgressQueryMetaDataAttributes,StudentMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new StudentCourseProgressQueryMetaDataAttributes();
     Relations = new StudentMetaDataRelations();

}


export type StudentCourseProgressQueryBuilder = DwQueryBuilderGen<StudentCourseProgressQueryEntity, StudentCourseProgressQueryMetaDataAttributes,StudentMetaDataRelations>


export class StudentCourseProgressQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Student';
    // Attributes
    StudentId = new DwItemAttribute(this.i, 'StudentId');
    UserId = new DwItemAttribute(this.i, 'UserId');
    UserIdDisplay = new DwItemAttribute(this.i, 'UserIdDisplay');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedByDisplay = new DwItemAttribute(this.i, 'CreatedByDisplay');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedByDisplay = new DwItemAttribute(this.i, 'ModifiedByDisplay');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    AddressId = new DwItemAttribute(this.i, 'AddressId');
    AddressIdDisplay = new DwItemAttribute(this.i, 'AddressIdDisplay');
    PilotCertificateNumber = new DwItemAttribute(this.i, 'PilotCertificateNumber');
    CitizenshipCountryId = new DwItemAttribute(this.i, 'CitizenshipCountryId');
    CitizenshipCountryIdDisplay = new DwItemAttribute(this.i, 'CitizenshipCountryIdDisplay');
    BirthDate = new DwItemAttribute(this.i, 'BirthDate');
    PilotTypeId = new DwItemAttribute(this.i, 'PilotTypeId');
    PilotTypeIdDisplay = new DwItemAttribute(this.i, 'PilotTypeIdDisplay');
    FlightSchoolPositionId = new DwItemAttribute(this.i, 'FlightSchoolPositionId');
    FlightSchoolPositionIdDisplay = new DwItemAttribute(this.i, 'FlightSchoolPositionIdDisplay');
    AcquisitionSourceId = new DwItemAttribute(this.i, 'AcquisitionSourceId');
    AcquisitionSourceIdDisplay = new DwItemAttribute(this.i, 'AcquisitionSourceIdDisplay');
    AcquisitionSourceOther = new DwItemAttribute(this.i, 'AcquisitionSourceOther');
    InstructorCertifcateNumber = new DwItemAttribute(this.i, 'InstructorCertifcateNumber');
    StudentCode = new DwItemAttribute(this.i, 'StudentCode');
    AviationGoalId = new DwItemAttribute(this.i, 'AviationGoalId');
    AviationGoalIdDisplay = new DwItemAttribute(this.i, 'AviationGoalIdDisplay');
    TimeZoneId = new DwItemAttribute(this.i, 'TimeZoneId');
    TimeZoneIdDisplay = new DwItemAttribute(this.i, 'TimeZoneIdDisplay');
    StudentCourseStudentCourseId = new DwItemAttribute('StudentCourse', 'StudentCourseStudentCourseId');
    StudentCourseIsActive = new DwItemAttribute('StudentCourse', 'StudentCourseIsActive');
    StudentCoursePercentComplete = new DwItemAttribute('StudentCourse', 'StudentCoursePercentComplete');
    StudentCourseModulesCompleted = new DwItemAttribute('StudentCourse', 'StudentCourseModulesCompleted');
    StudentCourseModulesCount = new DwItemAttribute('StudentCourse', 'StudentCourseModulesCount');
    StudentCourseLastActivityDateTime = new DwItemAttribute('StudentCourse', 'StudentCourseLastActivityDateTime');
    StudentCourseLessonsCompleted = new DwItemAttribute('StudentCourse', 'StudentCourseLessonsCompleted');
    StudentCourseLessonCount = new DwItemAttribute('StudentCourse', 'StudentCourseLessonCount');
    StudentCourseTotalTimeSeconds = new DwItemAttribute('StudentCourse', 'StudentCourseTotalTimeSeconds');
    StudentCourseStudentId = new DwItemAttribute('StudentCourse', 'StudentCourseStudentId');
    StudentCourseStudentIdDisplay = new DwItemAttribute('StudentCourse', 'StudentCourseStudentIdDisplay');
    StudentCourseCourseId = new DwItemAttribute('StudentCourse', 'StudentCourseCourseId');
    StudentCourseCourseIdDisplay = new DwItemAttribute('StudentCourse', 'StudentCourseCourseIdDisplay');
    StudentCourseFirstActivityDateTime = new DwItemAttribute('StudentCourse', 'StudentCourseFirstActivityDateTime');
    StudentCourseCompletedDateTime = new DwItemAttribute('StudentCourse', 'StudentCourseCompletedDateTime');
    StudentCourseIsEndorsed = new DwItemAttribute('StudentCourse', 'StudentCourseIsEndorsed');
    StudentCourseStudentCourseProgressStatusId = new DwItemAttribute('StudentCourse', 'StudentCourseStudentCourseProgressStatusId');
    StudentCourseStudentCourseProgressStatusIdDisplay = new DwItemAttribute('StudentCourse', 'StudentCourseStudentCourseProgressStatusIdDisplay');
    CourseCourseId = new DwItemAttribute('Course', 'CourseCourseId');
    CourseCourseName = new DwItemAttribute('Course', 'CourseCourseName');
    CourseCourseDescription = new DwItemAttribute('Course', 'CourseCourseDescription');
    CourseCourseStatusId = new DwItemAttribute('Course', 'CourseCourseStatusId');
    CourseCourseStatusIdDisplay = new DwItemAttribute('Course', 'CourseCourseStatusIdDisplay');
    CourseImageDwroMediaMediaPath = new DwItemAttribute('dw_roMedia', 'CourseImageDwroMediaMediaPath');
    CourseEndorsementStudentCompletionDateTime = new DwItemAttribute('roCourseEndorsementStudentActive', 'CourseEndorsementStudentCompletionDateTime');
    CourseEndorsementStudentExpirationDateTime = new DwItemAttribute('roCourseEndorsementStudentActive', 'CourseEndorsementStudentExpirationDateTime');
    AcsTestResultsACSTestResultCount = new DwItemAttribute('RoStudentCourseAcsTestResultDetail', 'AcsTestResultsACSTestResultCount');
    AcsTestResultsPassedAny = new DwItemAttribute('RoStudentCourseAcsTestResultDetail', 'AcsTestResultsPassedAny');
    AcsTestResultsFailedAny = new DwItemAttribute('RoStudentCourseAcsTestResultDetail', 'AcsTestResultsFailedAny');
    UserDetailFlightSchoolId = new DwItemAttribute('UserDetail', 'UserDetailFlightSchoolId');
    UserDetailFlightSchoolIdDisplay = new DwItemAttribute('UserDetail', 'UserDetailFlightSchoolIdDisplay');
    UserDetailUserDetailId = new DwItemAttribute('UserDetail', 'UserDetailUserDetailId');
}
export class StudentModuleProgressQueryMetaData implements DwItem2<StudentModuleProgressQueryEntity, StudentModuleProgressQueryMetaDataAttributes,CourseModuleProgressMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Student-Module_Progress';

    constructor() {
        this.ItemDetail.itemId=134;
        this.ItemDetail.itemName='CourseModuleProgress';
        this.ItemDetail.keyName='CourseModuleProgressId';
    }

    CreateEntity(): StudentModuleProgressQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): StudentModuleProgressQueryBuilder {
        return new DwQueryBuilderGen<StudentModuleProgressQueryEntity, StudentModuleProgressQueryMetaDataAttributes,CourseModuleProgressMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<StudentModuleProgressQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: StudentModuleProgressQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<StudentModuleProgressQueryEntity, StudentModuleProgressQueryMetaDataAttributes,CourseModuleProgressMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new StudentModuleProgressQueryMetaDataAttributes();
     Relations = new CourseModuleProgressMetaDataRelations();

}


export type StudentModuleProgressQueryBuilder = DwQueryBuilderGen<StudentModuleProgressQueryEntity, StudentModuleProgressQueryMetaDataAttributes,CourseModuleProgressMetaDataRelations>


export class StudentModuleProgressQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CourseModuleProgress';
    // Attributes
    CourseModuleProgressId = new DwItemAttribute(this.i, 'CourseModuleProgressId');
    CourseModuleId = new DwItemAttribute(this.i, 'CourseModuleId');
    CourseModuleIdDisplay = new DwItemAttribute(this.i, 'CourseModuleIdDisplay');
    PercentComplete = new DwItemAttribute(this.i, 'PercentComplete');
    LessonsCompleted = new DwItemAttribute(this.i, 'LessonsCompleted');
    LessonsCount = new DwItemAttribute(this.i, 'LessonsCount');
    StudentCourseId = new DwItemAttribute(this.i, 'StudentCourseId');
    StudentCourseIdDisplay = new DwItemAttribute(this.i, 'StudentCourseIdDisplay');
    LastActivityDateTime = new DwItemAttribute(this.i, 'LastActivityDateTime');
    TotalTimeSeconds = new DwItemAttribute(this.i, 'TotalTimeSeconds');
    FirstActivityDateTime = new DwItemAttribute(this.i, 'FirstActivityDateTime');
    CompletedDateTime = new DwItemAttribute(this.i, 'CompletedDateTime');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedByDisplay = new DwItemAttribute(this.i, 'CreatedByDisplay');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedByDisplay = new DwItemAttribute(this.i, 'ModifiedByDisplay');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    ModuleProgressStatusId = new DwItemAttribute(this.i, 'ModuleProgressStatusId');
    ModuleProgressStatusIdDisplay = new DwItemAttribute(this.i, 'ModuleProgressStatusIdDisplay');
    TotalVideoTimeSeconds = new DwItemAttribute(this.i, 'TotalVideoTimeSeconds');
    TotalQuizTimeSeconds = new DwItemAttribute(this.i, 'TotalQuizTimeSeconds');
    AISummaryLastProcessedDateTime = new DwItemAttribute(this.i, 'AISummaryLastProcessedDateTime');
    AIPromptRequestId = new DwItemAttribute(this.i, 'AIPromptRequestId');
    AIPromptRequestIdDisplay = new DwItemAttribute(this.i, 'AIPromptRequestIdDisplay');
    CourseModuleModuleOrder = new DwItemAttribute('CourseModule', 'CourseModuleModuleOrder');
    CourseModuleModuleName = new DwItemAttribute('CourseModule', 'CourseModuleModuleName');
    ImageMediaPath = new DwItemAttribute('dw_roMedia', 'ImageMediaPath');
    CourseImageMediaPath = new DwItemAttribute('dw_roMedia', 'CourseImageMediaPath');
    AIPromptRequestResult = new DwItemAttribute('AIPromptRequest', 'AIPromptRequestResult');
    AIPromptRequestAIPromptRequestStatusId = new DwItemAttribute('AIPromptRequest', 'AIPromptRequestAIPromptRequestStatusId');
    AIPromptRequestAIPromptRequestStatusIdDisplay = new DwItemAttribute('AIPromptRequest', 'AIPromptRequestAIPromptRequestStatusIdDisplay');
    AIPromptRequestLastLogId = new DwItemAttribute('AIPromptRequest', 'AIPromptRequestLastLogId');
    AIPromptRequestLastLogIdDisplay = new DwItemAttribute('AIPromptRequest', 'AIPromptRequestLastLogIdDisplay');
}
export class StudentLessonProgressQueryMetaData implements DwItem2<StudentLessonProgressQueryEntity, StudentLessonProgressQueryMetaDataAttributes,CourseLessonProgressMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Student-Lesson_Progress';

    constructor() {
        this.ItemDetail.itemId=135;
        this.ItemDetail.itemName='CourseLessonProgress';
        this.ItemDetail.keyName='CourseLessonProgressId';
    }

    CreateEntity(): StudentLessonProgressQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): StudentLessonProgressQueryBuilder {
        return new DwQueryBuilderGen<StudentLessonProgressQueryEntity, StudentLessonProgressQueryMetaDataAttributes,CourseLessonProgressMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<StudentLessonProgressQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: StudentLessonProgressQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<StudentLessonProgressQueryEntity, StudentLessonProgressQueryMetaDataAttributes,CourseLessonProgressMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new StudentLessonProgressQueryMetaDataAttributes();
     Relations = new CourseLessonProgressMetaDataRelations();

}


export type StudentLessonProgressQueryBuilder = DwQueryBuilderGen<StudentLessonProgressQueryEntity, StudentLessonProgressQueryMetaDataAttributes,CourseLessonProgressMetaDataRelations>


export class StudentLessonProgressQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CourseLessonProgress';
    // Attributes
    CourseLessonProgressId = new DwItemAttribute(this.i, 'CourseLessonProgressId');
    CourseLessonId = new DwItemAttribute(this.i, 'CourseLessonId');
    CourseLessonIdDisplay = new DwItemAttribute(this.i, 'CourseLessonIdDisplay');
    CourseModuleProgressId = new DwItemAttribute(this.i, 'CourseModuleProgressId');
    CourseModuleProgressIdDisplay = new DwItemAttribute(this.i, 'CourseModuleProgressIdDisplay');
    LessonComplete = new DwItemAttribute(this.i, 'LessonComplete');
    VideoFurthestTimeSeconds = new DwItemAttribute(this.i, 'VideoFurthestTimeSeconds');
    BestQuizResultId = new DwItemAttribute(this.i, 'BestQuizResultId');
    BestQuizResultIdDisplay = new DwItemAttribute(this.i, 'BestQuizResultIdDisplay');
    LastActivityDateTime = new DwItemAttribute(this.i, 'LastActivityDateTime');
    LessonNotes = new DwItemAttribute(this.i, 'LessonNotes');
    PercentComplete = new DwItemAttribute(this.i, 'PercentComplete');
    TotalTimeSeconds = new DwItemAttribute(this.i, 'TotalTimeSeconds');
    FirstActivityDateTime = new DwItemAttribute(this.i, 'FirstActivityDateTime');
    CompletedDateTime = new DwItemAttribute(this.i, 'CompletedDateTime');
    SessionCount = new DwItemAttribute(this.i, 'SessionCount');
    CourseLessonLessonName = new DwItemAttribute('CourseLesson', 'CourseLessonLessonName');
    CourseLessonLessonDescription = new DwItemAttribute('CourseLesson', 'CourseLessonLessonDescription');
    CourseLessonLessonTypeId = new DwItemAttribute('CourseLesson', 'CourseLessonLessonTypeId');
    CourseLessonLessonTypeIdDisplay = new DwItemAttribute('CourseLesson', 'CourseLessonLessonTypeIdDisplay');
    CourseLessonLessonOrder = new DwItemAttribute('CourseLesson', 'CourseLessonLessonOrder');
    CourseLessonVideoId = new DwItemAttribute('CourseLesson', 'CourseLessonVideoId');
    CourseLessonVideoIdDisplay = new DwItemAttribute('CourseLesson', 'CourseLessonVideoIdDisplay');
    CourseLessonQuizId = new DwItemAttribute('CourseLesson', 'CourseLessonQuizId');
    CourseLessonQuizIdDisplay = new DwItemAttribute('CourseLesson', 'CourseLessonQuizIdDisplay');
    LessonImageDwroMediaMediaPath = new DwItemAttribute('dw_roMedia', 'LessonImageDwroMediaMediaPath');
    VideoThumbnailUrl = new DwItemAttribute('Video', 'VideoThumbnailUrl');
    BestQuizResultPercentageScore = new DwItemAttribute('QuizResult', 'BestQuizResultPercentageScore');
    BestQuizResultQuizResultStatusId = new DwItemAttribute('QuizResult', 'BestQuizResultQuizResultStatusId');
    BestQuizResultQuizResultStatusIdDisplay = new DwItemAttribute('QuizResult', 'BestQuizResultQuizResultStatusIdDisplay');
    CourseModuleProgressStudentCourseId = new DwItemAttribute('CourseModuleProgress', 'CourseModuleProgressStudentCourseId');
    CourseModuleProgressStudentCourseIdDisplay = new DwItemAttribute('CourseModuleProgress', 'CourseModuleProgressStudentCourseIdDisplay');
    CourseModuleProgressCourseModuleId = new DwItemAttribute('CourseModuleProgress', 'CourseModuleProgressCourseModuleId');
    CourseModuleProgressCourseModuleIdDisplay = new DwItemAttribute('CourseModuleProgress', 'CourseModuleProgressCourseModuleIdDisplay');
    StudentCourseCourseId = new DwItemAttribute('StudentCourse', 'StudentCourseCourseId');
    StudentCourseCourseIdDisplay = new DwItemAttribute('StudentCourse', 'StudentCourseCourseIdDisplay');
    StudentCourseStudentId = new DwItemAttribute('StudentCourse', 'StudentCourseStudentId');
    StudentCourseStudentIdDisplay = new DwItemAttribute('StudentCourse', 'StudentCourseStudentIdDisplay');
    StudentUserId = new DwItemAttribute('Student', 'StudentUserId');
    StudentUserIdDisplay = new DwItemAttribute('Student', 'StudentUserIdDisplay');
    CourseImageMediaPath = new DwItemAttribute('dw_roMedia', 'CourseImageMediaPath');
    ModuleImageMediaPath = new DwItemAttribute('dw_roMedia', 'ModuleImageMediaPath');
}
export class StudentLesssonProgressNoCountQueryMetaData implements DwItem2<StudentLesssonProgressNoCountQueryEntity, StudentLesssonProgressNoCountQueryMetaDataAttributes,CourseLessonProgressMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Student-Lessson_Progress-NoCount';

    constructor() {
        this.ItemDetail.itemId=135;
        this.ItemDetail.itemName='CourseLessonProgress';
        this.ItemDetail.keyName='CourseLessonProgressId';
    }

    CreateEntity(): StudentLesssonProgressNoCountQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): StudentLesssonProgressNoCountQueryBuilder {
        return new DwQueryBuilderGen<StudentLesssonProgressNoCountQueryEntity, StudentLesssonProgressNoCountQueryMetaDataAttributes,CourseLessonProgressMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<StudentLesssonProgressNoCountQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: StudentLesssonProgressNoCountQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<StudentLesssonProgressNoCountQueryEntity, StudentLesssonProgressNoCountQueryMetaDataAttributes,CourseLessonProgressMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new StudentLesssonProgressNoCountQueryMetaDataAttributes();
     Relations = new CourseLessonProgressMetaDataRelations();

}


export type StudentLesssonProgressNoCountQueryBuilder = DwQueryBuilderGen<StudentLesssonProgressNoCountQueryEntity, StudentLesssonProgressNoCountQueryMetaDataAttributes,CourseLessonProgressMetaDataRelations>


export class StudentLesssonProgressNoCountQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CourseLessonProgress';
    // Attributes
    CourseLessonProgressId = new DwItemAttribute(this.i, 'CourseLessonProgressId');
    CourseLessonId = new DwItemAttribute(this.i, 'CourseLessonId');
    CourseLessonIdDisplay = new DwItemAttribute(this.i, 'CourseLessonIdDisplay');
    CourseModuleProgressId = new DwItemAttribute(this.i, 'CourseModuleProgressId');
    CourseModuleProgressIdDisplay = new DwItemAttribute(this.i, 'CourseModuleProgressIdDisplay');
    LessonComplete = new DwItemAttribute(this.i, 'LessonComplete');
    VideoFurthestTimeSeconds = new DwItemAttribute(this.i, 'VideoFurthestTimeSeconds');
    BestQuizResultId = new DwItemAttribute(this.i, 'BestQuizResultId');
    BestQuizResultIdDisplay = new DwItemAttribute(this.i, 'BestQuizResultIdDisplay');
    LastActivityDateTime = new DwItemAttribute(this.i, 'LastActivityDateTime');
    LessonNotes = new DwItemAttribute(this.i, 'LessonNotes');
    PercentComplete = new DwItemAttribute(this.i, 'PercentComplete');
    TotalTimeSeconds = new DwItemAttribute(this.i, 'TotalTimeSeconds');
    FirstActivityDateTime = new DwItemAttribute(this.i, 'FirstActivityDateTime');
    CompletedDateTime = new DwItemAttribute(this.i, 'CompletedDateTime');
    CourseLessonLessonName = new DwItemAttribute('CourseLesson', 'CourseLessonLessonName');
    CourseLessonLessonDescription = new DwItemAttribute('CourseLesson', 'CourseLessonLessonDescription');
    CourseLessonLessonTypeId = new DwItemAttribute('CourseLesson', 'CourseLessonLessonTypeId');
    CourseLessonLessonTypeIdDisplay = new DwItemAttribute('CourseLesson', 'CourseLessonLessonTypeIdDisplay');
    CourseLessonLessonOrder = new DwItemAttribute('CourseLesson', 'CourseLessonLessonOrder');
    CourseLessonVideoId = new DwItemAttribute('CourseLesson', 'CourseLessonVideoId');
    CourseLessonVideoIdDisplay = new DwItemAttribute('CourseLesson', 'CourseLessonVideoIdDisplay');
    CourseLessonQuizId = new DwItemAttribute('CourseLesson', 'CourseLessonQuizId');
    CourseLessonQuizIdDisplay = new DwItemAttribute('CourseLesson', 'CourseLessonQuizIdDisplay');
    LessonImageDwroMediaMediaPath = new DwItemAttribute('dw_roMedia', 'LessonImageDwroMediaMediaPath');
    VideoThumbnailUrl = new DwItemAttribute('Video', 'VideoThumbnailUrl');
    BestQuizResultPercentageScore = new DwItemAttribute('QuizResult', 'BestQuizResultPercentageScore');
    BestQuizResultQuizResultStatusId = new DwItemAttribute('QuizResult', 'BestQuizResultQuizResultStatusId');
    BestQuizResultQuizResultStatusIdDisplay = new DwItemAttribute('QuizResult', 'BestQuizResultQuizResultStatusIdDisplay');
    CourseModuleProgressStudentCourseId = new DwItemAttribute('CourseModuleProgress', 'CourseModuleProgressStudentCourseId');
    CourseModuleProgressStudentCourseIdDisplay = new DwItemAttribute('CourseModuleProgress', 'CourseModuleProgressStudentCourseIdDisplay');
    CourseModuleProgressCourseModuleId = new DwItemAttribute('CourseModuleProgress', 'CourseModuleProgressCourseModuleId');
    CourseModuleProgressCourseModuleIdDisplay = new DwItemAttribute('CourseModuleProgress', 'CourseModuleProgressCourseModuleIdDisplay');
    StudentCourseCourseId = new DwItemAttribute('StudentCourse', 'StudentCourseCourseId');
    StudentCourseCourseIdDisplay = new DwItemAttribute('StudentCourse', 'StudentCourseCourseIdDisplay');
    StudentCourseStudentId = new DwItemAttribute('StudentCourse', 'StudentCourseStudentId');
    StudentCourseStudentIdDisplay = new DwItemAttribute('StudentCourse', 'StudentCourseStudentIdDisplay');
    StudentUserId = new DwItemAttribute('Student', 'StudentUserId');
    StudentUserIdDisplay = new DwItemAttribute('Student', 'StudentUserIdDisplay');
    CourseImageMediaPath = new DwItemAttribute('dw_roMedia', 'CourseImageMediaPath');
    CourseModuleModuleName = new DwItemAttribute('CourseModule', 'CourseModuleModuleName');
    CourseModuleModuleOrder = new DwItemAttribute('CourseModule', 'CourseModuleModuleOrder');
    ModuleImageMediaPath = new DwItemAttribute('dw_roMedia', 'ModuleImageMediaPath');
}
export class StudentCourseProgressByStudentCourseQueryMetaData implements DwItem2<StudentCourseProgressByStudentCourseQueryEntity, StudentCourseProgressByStudentCourseQueryMetaDataAttributes,StudentCourseMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Student-Course_Progress-by-student-course';

    constructor() {
        this.ItemDetail.itemId=165;
        this.ItemDetail.itemName='StudentCourse';
        this.ItemDetail.keyName='StudentCourseId';
    }

    CreateEntity(): StudentCourseProgressByStudentCourseQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): StudentCourseProgressByStudentCourseQueryBuilder {
        return new DwQueryBuilderGen<StudentCourseProgressByStudentCourseQueryEntity, StudentCourseProgressByStudentCourseQueryMetaDataAttributes,StudentCourseMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<StudentCourseProgressByStudentCourseQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: StudentCourseProgressByStudentCourseQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<StudentCourseProgressByStudentCourseQueryEntity, StudentCourseProgressByStudentCourseQueryMetaDataAttributes,StudentCourseMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new StudentCourseProgressByStudentCourseQueryMetaDataAttributes();
     Relations = new StudentCourseMetaDataRelations();

}


export type StudentCourseProgressByStudentCourseQueryBuilder = DwQueryBuilderGen<StudentCourseProgressByStudentCourseQueryEntity, StudentCourseProgressByStudentCourseQueryMetaDataAttributes,StudentCourseMetaDataRelations>


export class StudentCourseProgressByStudentCourseQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'StudentCourse';
    // Attributes
    StudentCourseId = new DwItemAttribute(this.i, 'StudentCourseId');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    PercentComplete = new DwItemAttribute(this.i, 'PercentComplete');
    ModulesCompleted = new DwItemAttribute(this.i, 'ModulesCompleted');
    ModulesCount = new DwItemAttribute(this.i, 'ModulesCount');
    LastActivityDateTime = new DwItemAttribute(this.i, 'LastActivityDateTime');
    LessonsCompleted = new DwItemAttribute(this.i, 'LessonsCompleted');
    LessonCount = new DwItemAttribute(this.i, 'LessonCount');
    TotalTimeSeconds = new DwItemAttribute(this.i, 'TotalTimeSeconds');
    StudentId = new DwItemAttribute(this.i, 'StudentId');
    StudentIdDisplay = new DwItemAttribute(this.i, 'StudentIdDisplay');
    CourseId = new DwItemAttribute(this.i, 'CourseId');
    CourseIdDisplay = new DwItemAttribute(this.i, 'CourseIdDisplay');
    FirstActivityDateTime = new DwItemAttribute(this.i, 'FirstActivityDateTime');
    CompletedDateTime = new DwItemAttribute(this.i, 'CompletedDateTime');
    StudentStudentId = new DwItemAttribute('Student', 'StudentStudentId');
    StudentUserId = new DwItemAttribute('Student', 'StudentUserId');
    StudentUserIdDisplay = new DwItemAttribute('Student', 'StudentUserIdDisplay');
    StudentCreatedBy = new DwItemAttribute('Student', 'StudentCreatedBy');
    StudentCreatedByDisplay = new DwItemAttribute('Student', 'StudentCreatedByDisplay');
    StudentCreatedDateTime = new DwItemAttribute('Student', 'StudentCreatedDateTime');
    StudentModifiedBy = new DwItemAttribute('Student', 'StudentModifiedBy');
    StudentModifiedByDisplay = new DwItemAttribute('Student', 'StudentModifiedByDisplay');
    StudentModifiedDateTime = new DwItemAttribute('Student', 'StudentModifiedDateTime');
    UserDetailFlightSchoolId = new DwItemAttribute('UserDetail', 'UserDetailFlightSchoolId');
    UserDetailFlightSchoolIdDisplay = new DwItemAttribute('UserDetail', 'UserDetailFlightSchoolIdDisplay');
}
export class StudentModuleLessonActivityQueryMetaData implements DwItem2<StudentModuleLessonActivityQueryEntity, StudentModuleLessonActivityQueryMetaDataAttributes,CourseModuleProgressMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Student-Module/Lesson_Activity';

    constructor() {
        this.ItemDetail.itemId=134;
        this.ItemDetail.itemName='CourseModuleProgress';
        this.ItemDetail.keyName='CourseModuleProgressId';
    }

    CreateEntity(): StudentModuleLessonActivityQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): StudentModuleLessonActivityQueryBuilder {
        return new DwQueryBuilderGen<StudentModuleLessonActivityQueryEntity, StudentModuleLessonActivityQueryMetaDataAttributes,CourseModuleProgressMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<StudentModuleLessonActivityQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: StudentModuleLessonActivityQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<StudentModuleLessonActivityQueryEntity, StudentModuleLessonActivityQueryMetaDataAttributes,CourseModuleProgressMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new StudentModuleLessonActivityQueryMetaDataAttributes();
     Relations = new CourseModuleProgressMetaDataRelations();

}


export type StudentModuleLessonActivityQueryBuilder = DwQueryBuilderGen<StudentModuleLessonActivityQueryEntity, StudentModuleLessonActivityQueryMetaDataAttributes,CourseModuleProgressMetaDataRelations>


export class StudentModuleLessonActivityQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CourseModuleProgress';
    // Attributes
    CourseModuleId = new DwItemAttribute(this.i, 'CourseModuleId');
    CourseModuleIdDisplay = new DwItemAttribute(this.i, 'CourseModuleIdDisplay');
    CourseLessonProgressCourseLessonId = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressCourseLessonId');
    CourseLessonProgressCourseLessonIdDisplay = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressCourseLessonIdDisplay');
    CourseLessonProgressLessonComplete = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressLessonComplete');
    CourseLessonProgressVideoFurthestTimeSeconds = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressVideoFurthestTimeSeconds');
    CourseLessonProgressBestQuizResultId = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressBestQuizResultId');
    CourseLessonProgressBestQuizResultIdDisplay = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressBestQuizResultIdDisplay');
    CourseLessonProgressLastActivityDateTime = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressLastActivityDateTime');
    CourseLessonProgressPercentComplete = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressPercentComplete');
    CourseLessonProgressTotalTimeSeconds = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressTotalTimeSeconds');
    CourseLessonProgressFirstActivityDateTime = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressFirstActivityDateTime');
    CourseLessonProgressCompletedDateTime = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressCompletedDateTime');
    CourseLessonSessionCourseLessonSessionId = new DwItemAttribute('CourseLessonSession', 'CourseLessonSessionCourseLessonSessionId');
    CourseLessonSessionCourseLessonProgressId = new DwItemAttribute('CourseLessonSession', 'CourseLessonSessionCourseLessonProgressId');
    CourseLessonSessionCourseLessonProgressIdDisplay = new DwItemAttribute('CourseLessonSession', 'CourseLessonSessionCourseLessonProgressIdDisplay');
    CourseLessonSessionLessonCompleted = new DwItemAttribute('CourseLessonSession', 'CourseLessonSessionLessonCompleted');
    CourseLessonSessionVideoId = new DwItemAttribute('CourseLessonSession', 'CourseLessonSessionVideoId');
    CourseLessonSessionVideoFurthestTimeSeconds = new DwItemAttribute('CourseLessonSession', 'CourseLessonSessionVideoFurthestTimeSeconds');
    CourseLessonSessionQuizResultId = new DwItemAttribute('CourseLessonSession', 'CourseLessonSessionQuizResultId');
    CourseLessonSessionQuizResultIdDisplay = new DwItemAttribute('CourseLessonSession', 'CourseLessonSessionQuizResultIdDisplay');
    CourseLessonSessionSessionStartDateTime = new DwItemAttribute('CourseLessonSession', 'CourseLessonSessionSessionStartDateTime');
    CourseLessonSessionSessionEndDateTime = new DwItemAttribute('CourseLessonSession', 'CourseLessonSessionSessionEndDateTime');
    CourseLessonSessionTotalTimeSeconds = new DwItemAttribute('CourseLessonSession', 'CourseLessonSessionTotalTimeSeconds');
    QuizResultCompletedQuestions = new DwItemAttribute('QuizResult', 'QuizResultCompletedQuestions');
    QuizResultTotalQuestions = new DwItemAttribute('QuizResult', 'QuizResultTotalQuestions');
    QuizResultQuizScore = new DwItemAttribute('QuizResult', 'QuizResultQuizScore');
    QuizResultPerfectScore = new DwItemAttribute('QuizResult', 'QuizResultPerfectScore');
    QuizResultPercentageScore = new DwItemAttribute('QuizResult', 'QuizResultPercentageScore');
    QuizResultQuizResultStatusId = new DwItemAttribute('QuizResult', 'QuizResultQuizResultStatusId');
    QuizResultQuizResultStatusIdDisplay = new DwItemAttribute('QuizResult', 'QuizResultQuizResultStatusIdDisplay');
    QuizResultQuizId = new DwItemAttribute('QuizResult', 'QuizResultQuizId');
    QuizResultQuizIdDisplay = new DwItemAttribute('QuizResult', 'QuizResultQuizIdDisplay');
    QuizResultQuizResultId = new DwItemAttribute('QuizResult', 'QuizResultQuizResultId');
    QuizResultProgressReset = new DwItemAttribute('QuizResult', 'QuizResultProgressReset');
}
export class FlightSchoolGroupWithStudentCourseDetailQueryMetaData implements DwItem2<FlightSchoolGroupWithStudentCourseDetailQueryEntity, FlightSchoolGroupWithStudentCourseDetailQueryMetaDataAttributes,FlightSchoolGroupMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Flight_School_Group_with_StudentCourse_Detail';

    constructor() {
        this.ItemDetail.itemId=192;
        this.ItemDetail.itemName='FlightSchoolGroup';
        this.ItemDetail.keyName='FlightSchoolGroupId';
    }

    CreateEntity(): FlightSchoolGroupWithStudentCourseDetailQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): FlightSchoolGroupWithStudentCourseDetailQueryBuilder {
        return new DwQueryBuilderGen<FlightSchoolGroupWithStudentCourseDetailQueryEntity, FlightSchoolGroupWithStudentCourseDetailQueryMetaDataAttributes,FlightSchoolGroupMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<FlightSchoolGroupWithStudentCourseDetailQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: FlightSchoolGroupWithStudentCourseDetailQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<FlightSchoolGroupWithStudentCourseDetailQueryEntity, FlightSchoolGroupWithStudentCourseDetailQueryMetaDataAttributes,FlightSchoolGroupMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new FlightSchoolGroupWithStudentCourseDetailQueryMetaDataAttributes();
     Relations = new FlightSchoolGroupMetaDataRelations();

}


export type FlightSchoolGroupWithStudentCourseDetailQueryBuilder = DwQueryBuilderGen<FlightSchoolGroupWithStudentCourseDetailQueryEntity, FlightSchoolGroupWithStudentCourseDetailQueryMetaDataAttributes,FlightSchoolGroupMetaDataRelations>


export class FlightSchoolGroupWithStudentCourseDetailQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'FlightSchoolGroup';
    // Attributes
    FlightSchoolGroupId = new DwItemAttribute(this.i, 'FlightSchoolGroupId');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    FlightSchoolIdDisplay = new DwItemAttribute(this.i, 'FlightSchoolIdDisplay');
    GroupName = new DwItemAttribute(this.i, 'GroupName');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedByDisplay = new DwItemAttribute(this.i, 'CreatedByDisplay');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedByDisplay = new DwItemAttribute(this.i, 'ModifiedByDisplay');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    FlightSchoolGroupStudentStudentId = new DwItemAttribute('FlightSchoolGroupStudent', 'FlightSchoolGroupStudentStudentId');
    FlightSchoolGroupStudentStudentIdDisplay = new DwItemAttribute('FlightSchoolGroupStudent', 'FlightSchoolGroupStudentStudentIdDisplay');
    FlightSchoolGroupStudentFlightSchoolGroupStudentId = new DwItemAttribute('FlightSchoolGroupStudent', 'FlightSchoolGroupStudentFlightSchoolGroupStudentId');
    StudentStudentId = new DwItemAttribute('Student', 'StudentStudentId');
    StudentUserId = new DwItemAttribute('Student', 'StudentUserId');
    StudentUserIdDisplay = new DwItemAttribute('Student', 'StudentUserIdDisplay');
    StudentCourseStudentCourseId = new DwItemAttribute('StudentCourse', 'StudentCourseStudentCourseId');
    StudentCourseCourseId = new DwItemAttribute('StudentCourse', 'StudentCourseCourseId');
    StudentCourseCourseIdDisplay = new DwItemAttribute('StudentCourse', 'StudentCourseCourseIdDisplay');
    StudentCourseIsActive = new DwItemAttribute('StudentCourse', 'StudentCourseIsActive');
    UserDetailUserDetailId = new DwItemAttribute('UserDetail', 'UserDetailUserDetailId');
    UserDetailFlightSchoolId = new DwItemAttribute('UserDetail', 'UserDetailFlightSchoolId');
    UserDetailFlightSchoolIdDisplay = new DwItemAttribute('UserDetail', 'UserDetailFlightSchoolIdDisplay');
}
export class AssignmentStudentLessonSessonGridQueryMetaData implements DwItem2<AssignmentStudentLessonSessonGridQueryEntity, AssignmentStudentLessonSessonGridQueryMetaDataAttributes,AssignmentStudentMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Assignment_Student-Lesson_Sesson_Grid';

    constructor() {
        this.ItemDetail.itemId=191;
        this.ItemDetail.itemName='AssignmentStudent';
        this.ItemDetail.keyName='AssignmentStudentId';
    }

    CreateEntity(): AssignmentStudentLessonSessonGridQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): AssignmentStudentLessonSessonGridQueryBuilder {
        return new DwQueryBuilderGen<AssignmentStudentLessonSessonGridQueryEntity, AssignmentStudentLessonSessonGridQueryMetaDataAttributes,AssignmentStudentMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<AssignmentStudentLessonSessonGridQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: AssignmentStudentLessonSessonGridQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<AssignmentStudentLessonSessonGridQueryEntity, AssignmentStudentLessonSessonGridQueryMetaDataAttributes,AssignmentStudentMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new AssignmentStudentLessonSessonGridQueryMetaDataAttributes();
     Relations = new AssignmentStudentMetaDataRelations();

}


export type AssignmentStudentLessonSessonGridQueryBuilder = DwQueryBuilderGen<AssignmentStudentLessonSessonGridQueryEntity, AssignmentStudentLessonSessonGridQueryMetaDataAttributes,AssignmentStudentMetaDataRelations>


export class AssignmentStudentLessonSessonGridQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AssignmentStudent';
    // Attributes
    AssignmentStudentId = new DwItemAttribute(this.i, 'AssignmentStudentId');
    AssignmentId = new DwItemAttribute(this.i, 'AssignmentId');
    AssignmentIdDisplay = new DwItemAttribute(this.i, 'AssignmentIdDisplay');
    StudentId = new DwItemAttribute(this.i, 'StudentId');
    StudentIdDisplay = new DwItemAttribute(this.i, 'StudentIdDisplay');
    PercentComplete = new DwItemAttribute(this.i, 'PercentComplete');
    CompletedDateTime = new DwItemAttribute(this.i, 'CompletedDateTime');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedByDisplay = new DwItemAttribute(this.i, 'CreatedByDisplay');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedByDisplay = new DwItemAttribute(this.i, 'ModifiedByDisplay');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    Acknowledged = new DwItemAttribute(this.i, 'Acknowledged');
    AcknowledgedDateTime = new DwItemAttribute(this.i, 'AcknowledgedDateTime');
    AiPromptRequestId = new DwItemAttribute(this.i, 'AiPromptRequestId');
    AiPromptRequestIdDisplay = new DwItemAttribute(this.i, 'AiPromptRequestIdDisplay');
    ShowAISummary = new DwItemAttribute(this.i, 'ShowAISummary');
    StudentUserId = new DwItemAttribute('Student', 'StudentUserId');
    StudentUserIdDisplay = new DwItemAttribute('Student', 'StudentUserIdDisplay');
    RoAssignmentStudentCourseLessonProgressStudentId = new DwItemAttribute('roAssignmentStudentCourseLessonProgress', 'RoAssignmentStudentCourseLessonProgressStudentId');
    CourseLessonProgressBestQuizResultId = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressBestQuizResultId');
    CourseLessonProgressBestQuizResultIdDisplay = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressBestQuizResultIdDisplay');
    CourseLessonProgressCompletedDateTime = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressCompletedDateTime');
    CourseLessonProgressCourseLessonId = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressCourseLessonId');
    CourseLessonProgressCourseLessonIdDisplay = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressCourseLessonIdDisplay');
    CourseLessonProgressCourseLessonProgressId = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressCourseLessonProgressId');
    CourseLessonProgressCourseModuleProgressId = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressCourseModuleProgressId');
    CourseLessonProgressCourseModuleProgressIdDisplay = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressCourseModuleProgressIdDisplay');
    CourseLessonProgressCreatedBy = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressCreatedBy');
    CourseLessonProgressCreatedByDisplay = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressCreatedByDisplay');
    CourseLessonProgressCreatedDateTime = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressCreatedDateTime');
    CourseLessonProgressFirstActivityDateTime = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressFirstActivityDateTime');
    CourseLessonProgressLastActivityDateTime = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressLastActivityDateTime');
    CourseLessonProgressLessonComplete = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressLessonComplete');
    CourseLessonProgressLessonNotes = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressLessonNotes');
    CourseLessonProgressModifiedBy = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressModifiedBy');
    CourseLessonProgressModifiedByDisplay = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressModifiedByDisplay');
    CourseLessonProgressModifiedDateTime = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressModifiedDateTime');
    CourseLessonProgressPercentComplete = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressPercentComplete');
    CourseLessonProgressTotalTimeSeconds = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressTotalTimeSeconds');
    CourseLessonProgressVideoFurthestTimeSeconds = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressVideoFurthestTimeSeconds');
    SessionCourseLessonSessionId = new DwItemAttribute('CourseLessonSession', 'SessionCourseLessonSessionId');
    SessionCourseLessonProgressId = new DwItemAttribute('CourseLessonSession', 'SessionCourseLessonProgressId');
    SessionCourseLessonProgressIdDisplay = new DwItemAttribute('CourseLessonSession', 'SessionCourseLessonProgressIdDisplay');
    SessionLessonCompleted = new DwItemAttribute('CourseLessonSession', 'SessionLessonCompleted');
    SessionVideoId = new DwItemAttribute('CourseLessonSession', 'SessionVideoId');
    SessionVideoFurthestTimeSeconds = new DwItemAttribute('CourseLessonSession', 'SessionVideoFurthestTimeSeconds');
    SessionQuizResultId = new DwItemAttribute('CourseLessonSession', 'SessionQuizResultId');
    SessionQuizResultIdDisplay = new DwItemAttribute('CourseLessonSession', 'SessionQuizResultIdDisplay');
    SessionSessionStartDateTime = new DwItemAttribute('CourseLessonSession', 'SessionSessionStartDateTime');
    SessionSessionEndDateTime = new DwItemAttribute('CourseLessonSession', 'SessionSessionEndDateTime');
    SessionTotalTimeSeconds = new DwItemAttribute('CourseLessonSession', 'SessionTotalTimeSeconds');
    SessionCreatedBy = new DwItemAttribute('CourseLessonSession', 'SessionCreatedBy');
    SessionCreatedByDisplay = new DwItemAttribute('CourseLessonSession', 'SessionCreatedByDisplay');
    SessionCreatedDateTime = new DwItemAttribute('CourseLessonSession', 'SessionCreatedDateTime');
    SessionModifiedBy = new DwItemAttribute('CourseLessonSession', 'SessionModifiedBy');
    SessionModifiedByDisplay = new DwItemAttribute('CourseLessonSession', 'SessionModifiedByDisplay');
    SessionModifiedDateTime = new DwItemAttribute('CourseLessonSession', 'SessionModifiedDateTime');
    QuizResultQuizResultId = new DwItemAttribute('QuizResult', 'QuizResultQuizResultId');
    QuizResultQuizId = new DwItemAttribute('QuizResult', 'QuizResultQuizId');
    QuizResultQuizIdDisplay = new DwItemAttribute('QuizResult', 'QuizResultQuizIdDisplay');
    QuizResultQuizScore = new DwItemAttribute('QuizResult', 'QuizResultQuizScore');
    QuizResultPercentageScore = new DwItemAttribute('QuizResult', 'QuizResultPercentageScore');
    QuizResultQuizResultStatusId = new DwItemAttribute('QuizResult', 'QuizResultQuizResultStatusId');
    QuizResultQuizResultStatusIdDisplay = new DwItemAttribute('QuizResult', 'QuizResultQuizResultStatusIdDisplay');
    CourseLessonLessonName = new DwItemAttribute('CourseLesson', 'CourseLessonLessonName');
    CourseLessonCourseModuleId = new DwItemAttribute('CourseLesson', 'CourseLessonCourseModuleId');
    CourseLessonCourseModuleIdDisplay = new DwItemAttribute('CourseLesson', 'CourseLessonCourseModuleIdDisplay');
}
export class AssignmentLessonWithProgressForStudentQueryMetaData implements DwItem2<AssignmentLessonWithProgressForStudentQueryEntity, AssignmentLessonWithProgressForStudentQueryMetaDataAttributes,AssignmentCourseLessonMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Assignment_Lesson_with_Progress-For_Student';

    constructor() {
        this.ItemDetail.itemId=195;
        this.ItemDetail.itemName='AssignmentCourseLesson';
        this.ItemDetail.keyName='AssignmentCourseLessonId';
    }

    CreateEntity(): AssignmentLessonWithProgressForStudentQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): AssignmentLessonWithProgressForStudentQueryBuilder {
        return new DwQueryBuilderGen<AssignmentLessonWithProgressForStudentQueryEntity, AssignmentLessonWithProgressForStudentQueryMetaDataAttributes,AssignmentCourseLessonMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<AssignmentLessonWithProgressForStudentQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: AssignmentLessonWithProgressForStudentQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<AssignmentLessonWithProgressForStudentQueryEntity, AssignmentLessonWithProgressForStudentQueryMetaDataAttributes,AssignmentCourseLessonMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new AssignmentLessonWithProgressForStudentQueryMetaDataAttributes();
     Relations = new AssignmentCourseLessonMetaDataRelations();

}


export type AssignmentLessonWithProgressForStudentQueryBuilder = DwQueryBuilderGen<AssignmentLessonWithProgressForStudentQueryEntity, AssignmentLessonWithProgressForStudentQueryMetaDataAttributes,AssignmentCourseLessonMetaDataRelations>


export class AssignmentLessonWithProgressForStudentQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AssignmentCourseLesson';
    // Attributes
    AssignmentCourseLessonId = new DwItemAttribute(this.i, 'AssignmentCourseLessonId');
    AssignmentId = new DwItemAttribute(this.i, 'AssignmentId');
    AssignmentIdDisplay = new DwItemAttribute(this.i, 'AssignmentIdDisplay');
    CourseLessonId = new DwItemAttribute(this.i, 'CourseLessonId');
    CourseLessonIdDisplay = new DwItemAttribute(this.i, 'CourseLessonIdDisplay');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedByDisplay = new DwItemAttribute(this.i, 'CreatedByDisplay');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedByDisplay = new DwItemAttribute(this.i, 'ModifiedByDisplay');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    AssignmentAssignmentDescription = new DwItemAttribute('Assignment', 'AssignmentAssignmentDescription');
    AssignmentAssignmentStatusId = new DwItemAttribute('Assignment', 'AssignmentAssignmentStatusId');
    AssignmentAssignmentStatusIdDisplay = new DwItemAttribute('Assignment', 'AssignmentAssignmentStatusIdDisplay');
    AssignmentAssignedDateTime = new DwItemAttribute('Assignment', 'AssignmentAssignedDateTime');
    AssignmentDueDateTime = new DwItemAttribute('Assignment', 'AssignmentDueDateTime');
    AssignmentCourseId = new DwItemAttribute('Assignment', 'AssignmentCourseId');
    AssignmentCourseIdDisplay = new DwItemAttribute('Assignment', 'AssignmentCourseIdDisplay');
    AssignmentStudentAssignmentStudentId = new DwItemAttribute('AssignmentStudent', 'AssignmentStudentAssignmentStudentId');
    AssignmentStudentStudentId = new DwItemAttribute('AssignmentStudent', 'AssignmentStudentStudentId');
    AssignmentStudentStudentIdDisplay = new DwItemAttribute('AssignmentStudent', 'AssignmentStudentStudentIdDisplay');
    AssignmentStudentPercentComplete = new DwItemAttribute('AssignmentStudent', 'AssignmentStudentPercentComplete');
    AssignmentStudentCompletedDateTime = new DwItemAttribute('AssignmentStudent', 'AssignmentStudentCompletedDateTime');
    StudentUserId = new DwItemAttribute('Student', 'StudentUserId');
    StudentUserIdDisplay = new DwItemAttribute('Student', 'StudentUserIdDisplay');
    CourseLessonLessonName = new DwItemAttribute('CourseLesson', 'CourseLessonLessonName');
    CourseLessonCourseModuleId = new DwItemAttribute('CourseLesson', 'CourseLessonCourseModuleId');
    CourseLessonCourseModuleIdDisplay = new DwItemAttribute('CourseLesson', 'CourseLessonCourseModuleIdDisplay');
    CourseLessonLessonTypeId = new DwItemAttribute('CourseLesson', 'CourseLessonLessonTypeId');
    CourseLessonLessonTypeIdDisplay = new DwItemAttribute('CourseLesson', 'CourseLessonLessonTypeIdDisplay');
    CourseLessonLessonOrder = new DwItemAttribute('CourseLesson', 'CourseLessonLessonOrder');
    CourseLessonProgressCourseLessonId = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressCourseLessonId');
    CourseLessonProgressCourseLessonIdDisplay = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressCourseLessonIdDisplay');
    CourseLessonProgressLessonComplete = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressLessonComplete');
    CourseLessonProgressVideoFurthestTimeSeconds = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressVideoFurthestTimeSeconds');
    CourseLessonProgressBestQuizResultId = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressBestQuizResultId');
    CourseLessonProgressBestQuizResultIdDisplay = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressBestQuizResultIdDisplay');
    CourseLessonProgressPercentComplete = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressPercentComplete');
    CourseLessonProgressLastActivityDateTime = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressLastActivityDateTime');
    CourseModuleProgressCourseModuleProgressId = new DwItemAttribute('CourseModuleProgress', 'CourseModuleProgressCourseModuleProgressId');
    CourseModuleProgressCourseModuleId = new DwItemAttribute('CourseModuleProgress', 'CourseModuleProgressCourseModuleId');
    CourseModuleProgressCourseModuleIdDisplay = new DwItemAttribute('CourseModuleProgress', 'CourseModuleProgressCourseModuleIdDisplay');
    CourseModuleProgressStudentCourseId = new DwItemAttribute('CourseModuleProgress', 'CourseModuleProgressStudentCourseId');
    CourseModuleProgressStudentCourseIdDisplay = new DwItemAttribute('CourseModuleProgress', 'CourseModuleProgressStudentCourseIdDisplay');
    StudentCourseStudentId = new DwItemAttribute('StudentCourse', 'StudentCourseStudentId');
    StudentCourseStudentIdDisplay = new DwItemAttribute('StudentCourse', 'StudentCourseStudentIdDisplay');
    StudentFromProgressUserId = new DwItemAttribute('Student', 'StudentFromProgressUserId');
    StudentFromProgressUserIdDisplay = new DwItemAttribute('Student', 'StudentFromProgressUserIdDisplay');
    CourseModuleModuleName = new DwItemAttribute('CourseModule', 'CourseModuleModuleName');
    CourseModuleModuleOrder = new DwItemAttribute('CourseModule', 'CourseModuleModuleOrder');
    CourseModuleCourseModuleId = new DwItemAttribute('CourseModule', 'CourseModuleCourseModuleId');
    CourseModuleCourseId = new DwItemAttribute('CourseModule', 'CourseModuleCourseId');
    CourseModuleCourseIdDisplay = new DwItemAttribute('CourseModule', 'CourseModuleCourseIdDisplay');
}
export class AssignmentByStudentQueryMetaData implements DwItem2<AssignmentByStudentQueryEntity, AssignmentByStudentQueryMetaDataAttributes,AssignmentMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Assignment-By_Student';

    constructor() {
        this.ItemDetail.itemId=188;
        this.ItemDetail.itemName='Assignment';
        this.ItemDetail.keyName='AssignmentId';
    }

    CreateEntity(): AssignmentByStudentQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): AssignmentByStudentQueryBuilder {
        return new DwQueryBuilderGen<AssignmentByStudentQueryEntity, AssignmentByStudentQueryMetaDataAttributes,AssignmentMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<AssignmentByStudentQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: AssignmentByStudentQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<AssignmentByStudentQueryEntity, AssignmentByStudentQueryMetaDataAttributes,AssignmentMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new AssignmentByStudentQueryMetaDataAttributes();
     Relations = new AssignmentMetaDataRelations();

}


export type AssignmentByStudentQueryBuilder = DwQueryBuilderGen<AssignmentByStudentQueryEntity, AssignmentByStudentQueryMetaDataAttributes,AssignmentMetaDataRelations>


export class AssignmentByStudentQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Assignment';
    // Attributes
    AssignmentId = new DwItemAttribute(this.i, 'AssignmentId');
    CourseId = new DwItemAttribute(this.i, 'CourseId');
    CourseIdDisplay = new DwItemAttribute(this.i, 'CourseIdDisplay');
    AssignmentDescription = new DwItemAttribute(this.i, 'AssignmentDescription');
    AssignmentTypeId = new DwItemAttribute(this.i, 'AssignmentTypeId');
    AssignmentTypeIdDisplay = new DwItemAttribute(this.i, 'AssignmentTypeIdDisplay');
    AssignmentStatusId = new DwItemAttribute(this.i, 'AssignmentStatusId');
    AssignmentStatusIdDisplay = new DwItemAttribute(this.i, 'AssignmentStatusIdDisplay');
    AssignmentLinkUrl = new DwItemAttribute(this.i, 'AssignmentLinkUrl');
    MediaId = new DwItemAttribute(this.i, 'MediaId');
    DueDateTime = new DwItemAttribute(this.i, 'DueDateTime');
    FlightSchoolGroupId = new DwItemAttribute(this.i, 'FlightSchoolGroupId');
    FlightSchoolGroupIdDisplay = new DwItemAttribute(this.i, 'FlightSchoolGroupIdDisplay');
    AssignedDateTime = new DwItemAttribute(this.i, 'AssignedDateTime');
    CompletedDateTime = new DwItemAttribute(this.i, 'CompletedDateTime');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    FlightSchoolIdDisplay = new DwItemAttribute(this.i, 'FlightSchoolIdDisplay');
    ResetLessonProgress = new DwItemAttribute(this.i, 'ResetLessonProgress');
    UseGroupAssignment = new DwItemAttribute(this.i, 'UseGroupAssignment');
    InstructorId = new DwItemAttribute(this.i, 'InstructorId');
    InstructorIdDisplay = new DwItemAttribute(this.i, 'InstructorIdDisplay');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedByDisplay = new DwItemAttribute(this.i, 'CreatedByDisplay');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedByDisplay = new DwItemAttribute(this.i, 'ModifiedByDisplay');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    AssignmentStudentAssignmentStudentId = new DwItemAttribute('AssignmentStudent', 'AssignmentStudentAssignmentStudentId');
    AssignmentStudentPercentComplete = new DwItemAttribute('AssignmentStudent', 'AssignmentStudentPercentComplete');
    AssignmentStudentCompletedDateTime = new DwItemAttribute('AssignmentStudent', 'AssignmentStudentCompletedDateTime');
    StudentUserId = new DwItemAttribute('Student', 'StudentUserId');
    StudentUserIdDisplay = new DwItemAttribute('Student', 'StudentUserIdDisplay');
    StudentStudentId = new DwItemAttribute('Student', 'StudentStudentId');
}
export class AssignmentStudentLessonProgressListQueryMetaData implements DwItem2<AssignmentStudentLessonProgressListQueryEntity, AssignmentStudentLessonProgressListQueryMetaDataAttributes,RoAssignmentStudentCourseLessonProgressMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Assignment_Student-Lesson_Progress-_List';

    constructor() {
        this.ItemDetail.itemId=196;
        this.ItemDetail.itemName='roAssignmentStudentCourseLessonProgress';
        this.ItemDetail.keyName='CourseLessonProgressId';
    }

    CreateEntity(): AssignmentStudentLessonProgressListQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): AssignmentStudentLessonProgressListQueryBuilder {
        return new DwQueryBuilderGen<AssignmentStudentLessonProgressListQueryEntity, AssignmentStudentLessonProgressListQueryMetaDataAttributes,RoAssignmentStudentCourseLessonProgressMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<AssignmentStudentLessonProgressListQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: AssignmentStudentLessonProgressListQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<AssignmentStudentLessonProgressListQueryEntity, AssignmentStudentLessonProgressListQueryMetaDataAttributes,RoAssignmentStudentCourseLessonProgressMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new AssignmentStudentLessonProgressListQueryMetaDataAttributes();
     Relations = new RoAssignmentStudentCourseLessonProgressMetaDataRelations();

}


export type AssignmentStudentLessonProgressListQueryBuilder = DwQueryBuilderGen<AssignmentStudentLessonProgressListQueryEntity, AssignmentStudentLessonProgressListQueryMetaDataAttributes,RoAssignmentStudentCourseLessonProgressMetaDataRelations>


export class AssignmentStudentLessonProgressListQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roAssignmentStudentCourseLessonProgress';
    // Attributes
    AssignmentStudentId = new DwItemAttribute(this.i, 'AssignmentStudentId');
    AssignmentStudentIdDisplay = new DwItemAttribute(this.i, 'AssignmentStudentIdDisplay');
    StudentId = new DwItemAttribute(this.i, 'StudentId');
    CourseLessonId = new DwItemAttribute(this.i, 'CourseLessonId');
    CourseLessonIdDisplay = new DwItemAttribute(this.i, 'CourseLessonIdDisplay');
    CourseLessonProgressId = new DwItemAttribute(this.i, 'CourseLessonProgressId');
    AssignmentStudentAssignmentStudentId = new DwItemAttribute('AssignmentStudent', 'AssignmentStudentAssignmentStudentId');
    AssignmentStudentAssignmentId = new DwItemAttribute('AssignmentStudent', 'AssignmentStudentAssignmentId');
    AssignmentStudentAssignmentIdDisplay = new DwItemAttribute('AssignmentStudent', 'AssignmentStudentAssignmentIdDisplay');
    AssignmentStudentStudentId = new DwItemAttribute('AssignmentStudent', 'AssignmentStudentStudentId');
    AssignmentStudentStudentIdDisplay = new DwItemAttribute('AssignmentStudent', 'AssignmentStudentStudentIdDisplay');
    AssignmentStudentPercentComplete = new DwItemAttribute('AssignmentStudent', 'AssignmentStudentPercentComplete');
    AssignmentStudentCompletedDateTime = new DwItemAttribute('AssignmentStudent', 'AssignmentStudentCompletedDateTime');
    CourseLessonProgressLessonComplete = new DwItemAttribute('CourseLessonProgress', 'CourseLessonProgressLessonComplete');
    CourseLessonCourseLessonId = new DwItemAttribute('CourseLesson', 'CourseLessonCourseLessonId');
    CourseLessonCourseModuleId = new DwItemAttribute('CourseLesson', 'CourseLessonCourseModuleId');
    CourseLessonCourseModuleIdDisplay = new DwItemAttribute('CourseLesson', 'CourseLessonCourseModuleIdDisplay');
    CourseLessonLessonName = new DwItemAttribute('CourseLesson', 'CourseLessonLessonName');
    CourseLessonLessonDescription = new DwItemAttribute('CourseLesson', 'CourseLessonLessonDescription');
    CourseLessonLessonTypeId = new DwItemAttribute('CourseLesson', 'CourseLessonLessonTypeId');
    CourseLessonLessonTypeIdDisplay = new DwItemAttribute('CourseLesson', 'CourseLessonLessonTypeIdDisplay');
    CourseLessonVideoId = new DwItemAttribute('CourseLesson', 'CourseLessonVideoId');
    CourseLessonVideoIdDisplay = new DwItemAttribute('CourseLesson', 'CourseLessonVideoIdDisplay');
    CourseLessonQuizId = new DwItemAttribute('CourseLesson', 'CourseLessonQuizId');
    CourseLessonQuizIdDisplay = new DwItemAttribute('CourseLesson', 'CourseLessonQuizIdDisplay');
    CourseLessonLessonOrder = new DwItemAttribute('CourseLesson', 'CourseLessonLessonOrder');
    LessonImageDwroMediaMediaPath = new DwItemAttribute('dw_roMedia', 'LessonImageDwroMediaMediaPath');
}
export class StudentByInstructorQueryMetaData implements DwItem2<StudentByInstructorQueryEntity, StudentByInstructorQueryMetaDataAttributes,StudentMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Student_By_Instructor';

    constructor() {
        this.ItemDetail.itemId=144;
        this.ItemDetail.itemName='Student';
        this.ItemDetail.keyName='StudentId';
    }

    CreateEntity(): StudentByInstructorQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): StudentByInstructorQueryBuilder {
        return new DwQueryBuilderGen<StudentByInstructorQueryEntity, StudentByInstructorQueryMetaDataAttributes,StudentMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<StudentByInstructorQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: StudentByInstructorQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<StudentByInstructorQueryEntity, StudentByInstructorQueryMetaDataAttributes,StudentMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new StudentByInstructorQueryMetaDataAttributes();
     Relations = new StudentMetaDataRelations();

}


export type StudentByInstructorQueryBuilder = DwQueryBuilderGen<StudentByInstructorQueryEntity, StudentByInstructorQueryMetaDataAttributes,StudentMetaDataRelations>


export class StudentByInstructorQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Student';
    // Attributes
    StudentId = new DwItemAttribute(this.i, 'StudentId');
    UserId = new DwItemAttribute(this.i, 'UserId');
    UserIdDisplay = new DwItemAttribute(this.i, 'UserIdDisplay');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedByDisplay = new DwItemAttribute(this.i, 'CreatedByDisplay');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedByDisplay = new DwItemAttribute(this.i, 'ModifiedByDisplay');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    AddressId = new DwItemAttribute(this.i, 'AddressId');
    AddressIdDisplay = new DwItemAttribute(this.i, 'AddressIdDisplay');
    PilotCertificateNumber = new DwItemAttribute(this.i, 'PilotCertificateNumber');
    CitizenshipCountryId = new DwItemAttribute(this.i, 'CitizenshipCountryId');
    CitizenshipCountryIdDisplay = new DwItemAttribute(this.i, 'CitizenshipCountryIdDisplay');
    BirthDate = new DwItemAttribute(this.i, 'BirthDate');
    PilotTypeId = new DwItemAttribute(this.i, 'PilotTypeId');
    PilotTypeIdDisplay = new DwItemAttribute(this.i, 'PilotTypeIdDisplay');
    FlightSchoolPositionId = new DwItemAttribute(this.i, 'FlightSchoolPositionId');
    FlightSchoolPositionIdDisplay = new DwItemAttribute(this.i, 'FlightSchoolPositionIdDisplay');
    AcquisitionSourceId = new DwItemAttribute(this.i, 'AcquisitionSourceId');
    AcquisitionSourceIdDisplay = new DwItemAttribute(this.i, 'AcquisitionSourceIdDisplay');
    AcquisitionSourceOther = new DwItemAttribute(this.i, 'AcquisitionSourceOther');
    InstructorCertifcateNumber = new DwItemAttribute(this.i, 'InstructorCertifcateNumber');
    StudentCode = new DwItemAttribute(this.i, 'StudentCode');
    AviationGoalId = new DwItemAttribute(this.i, 'AviationGoalId');
    AviationGoalIdDisplay = new DwItemAttribute(this.i, 'AviationGoalIdDisplay');
    TimeZoneId = new DwItemAttribute(this.i, 'TimeZoneId');
    TimeZoneIdDisplay = new DwItemAttribute(this.i, 'TimeZoneIdDisplay');
    DwUserFirstName = new DwItemAttribute('dw_User', 'DwUserFirstName');
    DwUserLastName = new DwItemAttribute('dw_User', 'DwUserLastName');
    DwUserEmail = new DwItemAttribute('dw_User', 'DwUserEmail');
    DwroMediaMediaPath = new DwItemAttribute('dw_roMedia', 'DwroMediaMediaPath');
    UserDetailUserDetailId = new DwItemAttribute('UserDetail', 'UserDetailUserDetailId');
    UserDetailFlightSchoolId = new DwItemAttribute('UserDetail', 'UserDetailFlightSchoolId');
    UserDetailFlightSchoolIdDisplay = new DwItemAttribute('UserDetail', 'UserDetailFlightSchoolIdDisplay');
    InstructorStudentInstructorId = new DwItemAttribute('InstructorStudent', 'InstructorStudentInstructorId');
    InstructorStudentInstructorIdDisplay = new DwItemAttribute('InstructorStudent', 'InstructorStudentInstructorIdDisplay');
    InstructorStudentInstructorStudentId = new DwItemAttribute('InstructorStudent', 'InstructorStudentInstructorStudentId');
    InstructorInstructorId = new DwItemAttribute('Instructor', 'InstructorInstructorId');
    InstructorUserId = new DwItemAttribute('Instructor', 'InstructorUserId');
    InstructorUserIdDisplay = new DwItemAttribute('Instructor', 'InstructorUserIdDisplay');
}
export class StudentBySchoolQueryMetaData implements DwItem2<StudentBySchoolQueryEntity, StudentBySchoolQueryMetaDataAttributes,StudentMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Student-By_School';

    constructor() {
        this.ItemDetail.itemId=144;
        this.ItemDetail.itemName='Student';
        this.ItemDetail.keyName='StudentId';
    }

    CreateEntity(): StudentBySchoolQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): StudentBySchoolQueryBuilder {
        return new DwQueryBuilderGen<StudentBySchoolQueryEntity, StudentBySchoolQueryMetaDataAttributes,StudentMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<StudentBySchoolQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: StudentBySchoolQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<StudentBySchoolQueryEntity, StudentBySchoolQueryMetaDataAttributes,StudentMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new StudentBySchoolQueryMetaDataAttributes();
     Relations = new StudentMetaDataRelations();

}


export type StudentBySchoolQueryBuilder = DwQueryBuilderGen<StudentBySchoolQueryEntity, StudentBySchoolQueryMetaDataAttributes,StudentMetaDataRelations>


export class StudentBySchoolQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Student';
    // Attributes
    StudentId = new DwItemAttribute(this.i, 'StudentId');
    UserId = new DwItemAttribute(this.i, 'UserId');
    UserIdDisplay = new DwItemAttribute(this.i, 'UserIdDisplay');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedByDisplay = new DwItemAttribute(this.i, 'CreatedByDisplay');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedByDisplay = new DwItemAttribute(this.i, 'ModifiedByDisplay');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    AddressId = new DwItemAttribute(this.i, 'AddressId');
    AddressIdDisplay = new DwItemAttribute(this.i, 'AddressIdDisplay');
    PilotCertificateNumber = new DwItemAttribute(this.i, 'PilotCertificateNumber');
    CitizenshipCountryId = new DwItemAttribute(this.i, 'CitizenshipCountryId');
    CitizenshipCountryIdDisplay = new DwItemAttribute(this.i, 'CitizenshipCountryIdDisplay');
    BirthDate = new DwItemAttribute(this.i, 'BirthDate');
    PilotTypeId = new DwItemAttribute(this.i, 'PilotTypeId');
    PilotTypeIdDisplay = new DwItemAttribute(this.i, 'PilotTypeIdDisplay');
    FlightSchoolPositionId = new DwItemAttribute(this.i, 'FlightSchoolPositionId');
    FlightSchoolPositionIdDisplay = new DwItemAttribute(this.i, 'FlightSchoolPositionIdDisplay');
    AcquisitionSourceId = new DwItemAttribute(this.i, 'AcquisitionSourceId');
    AcquisitionSourceIdDisplay = new DwItemAttribute(this.i, 'AcquisitionSourceIdDisplay');
    AcquisitionSourceOther = new DwItemAttribute(this.i, 'AcquisitionSourceOther');
    InstructorCertifcateNumber = new DwItemAttribute(this.i, 'InstructorCertifcateNumber');
    StudentCode = new DwItemAttribute(this.i, 'StudentCode');
    AviationGoalId = new DwItemAttribute(this.i, 'AviationGoalId');
    AviationGoalIdDisplay = new DwItemAttribute(this.i, 'AviationGoalIdDisplay');
    TimeZoneId = new DwItemAttribute(this.i, 'TimeZoneId');
    TimeZoneIdDisplay = new DwItemAttribute(this.i, 'TimeZoneIdDisplay');
    DwUserFirstName = new DwItemAttribute('dw_User', 'DwUserFirstName');
    DwUserLastName = new DwItemAttribute('dw_User', 'DwUserLastName');
    DwroMediaMediaPath = new DwItemAttribute('dw_roMedia', 'DwroMediaMediaPath');
    UserDetailUserDetailId = new DwItemAttribute('UserDetail', 'UserDetailUserDetailId');
    UserDetailFlightSchoolId = new DwItemAttribute('UserDetail', 'UserDetailFlightSchoolId');
    UserDetailFlightSchoolIdDisplay = new DwItemAttribute('UserDetail', 'UserDetailFlightSchoolIdDisplay');
}
export class StudentCourseForContextQueryMetaData implements DwItem2<StudentCourseForContextQueryEntity, StudentCourseForContextQueryMetaDataAttributes,StudentCourseMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Student_Course-For_Context';

    constructor() {
        this.ItemDetail.itemId=165;
        this.ItemDetail.itemName='StudentCourse';
        this.ItemDetail.keyName='StudentCourseId';
    }

    CreateEntity(): StudentCourseForContextQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): StudentCourseForContextQueryBuilder {
        return new DwQueryBuilderGen<StudentCourseForContextQueryEntity, StudentCourseForContextQueryMetaDataAttributes,StudentCourseMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<StudentCourseForContextQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: StudentCourseForContextQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<StudentCourseForContextQueryEntity, StudentCourseForContextQueryMetaDataAttributes,StudentCourseMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new StudentCourseForContextQueryMetaDataAttributes();
     Relations = new StudentCourseMetaDataRelations();

}


export type StudentCourseForContextQueryBuilder = DwQueryBuilderGen<StudentCourseForContextQueryEntity, StudentCourseForContextQueryMetaDataAttributes,StudentCourseMetaDataRelations>


export class StudentCourseForContextQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'StudentCourse';
    // Attributes
    StudentCourseId = new DwItemAttribute(this.i, 'StudentCourseId');
    StudentId = new DwItemAttribute(this.i, 'StudentId');
    StudentIdDisplay = new DwItemAttribute(this.i, 'StudentIdDisplay');
    CourseId = new DwItemAttribute(this.i, 'CourseId');
    CourseIdDisplay = new DwItemAttribute(this.i, 'CourseIdDisplay');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    LastActivityDateTime = new DwItemAttribute(this.i, 'LastActivityDateTime');
    CompletedDateTime = new DwItemAttribute(this.i, 'CompletedDateTime');
    StudentCourseStatusId = new DwItemAttribute(this.i, 'StudentCourseStatusId');
    StudentCourseStatusIdDisplay = new DwItemAttribute(this.i, 'StudentCourseStatusIdDisplay');
    IsEndorsed = new DwItemAttribute(this.i, 'IsEndorsed');
    TotalVideoTimeSeconds = new DwItemAttribute(this.i, 'TotalVideoTimeSeconds');
    TotalQuizTimeSeconds = new DwItemAttribute(this.i, 'TotalQuizTimeSeconds');
    PercentComplete = new DwItemAttribute(this.i, 'PercentComplete');
    ModulesCompleted = new DwItemAttribute(this.i, 'ModulesCompleted');
    ModulesCount = new DwItemAttribute(this.i, 'ModulesCount');
    LessonsCompleted = new DwItemAttribute(this.i, 'LessonsCompleted');
    LessonCount = new DwItemAttribute(this.i, 'LessonCount');
    AcsTestPassedFirstTime = new DwItemAttribute(this.i, 'AcsTestPassedFirstTime');
    AcsTestPassed = new DwItemAttribute(this.i, 'AcsTestPassed');
    AcsTestUploaded = new DwItemAttribute(this.i, 'AcsTestUploaded');
    StudentUserId = new DwItemAttribute('Student', 'StudentUserId');
    StudentUserIdDisplay = new DwItemAttribute('Student', 'StudentUserIdDisplay');
    StudentStudentId = new DwItemAttribute('Student', 'StudentStudentId');
    CourseCourseId = new DwItemAttribute('Course', 'CourseCourseId');
    CourseCourseName = new DwItemAttribute('Course', 'CourseCourseName');
    CourseAcsTestId = new DwItemAttribute('Course', 'CourseAcsTestId');
    CourseAcsTestIdDisplay = new DwItemAttribute('Course', 'CourseAcsTestIdDisplay');
    RoStudentCourseAcsTestResultDetailACSTestResultCount = new DwItemAttribute('RoStudentCourseAcsTestResultDetail', 'RoStudentCourseAcsTestResultDetailACSTestResultCount');
    RoStudentCourseAcsTestResultDetailFailedAny = new DwItemAttribute('RoStudentCourseAcsTestResultDetail', 'RoStudentCourseAcsTestResultDetailFailedAny');
    RoStudentCourseAcsTestResultDetailPassedAny = new DwItemAttribute('RoStudentCourseAcsTestResultDetail', 'RoStudentCourseAcsTestResultDetailPassedAny');
    CourseEndorsementStudentCourseEndorsementStudentId = new DwItemAttribute('roCourseEndorsementStudentActive', 'CourseEndorsementStudentCourseEndorsementStudentId');
    CourseEndorsementStudentCourseEndorsementId = new DwItemAttribute('roCourseEndorsementStudentActive', 'CourseEndorsementStudentCourseEndorsementId');
    CourseEndorsementStudentStudentCourseId = new DwItemAttribute('roCourseEndorsementStudentActive', 'CourseEndorsementStudentStudentCourseId');
    CourseEndorsementStudentStudentCourseIdDisplay = new DwItemAttribute('roCourseEndorsementStudentActive', 'CourseEndorsementStudentStudentCourseIdDisplay');
    CourseEndorsementStudentCompletionDateTime = new DwItemAttribute('roCourseEndorsementStudentActive', 'CourseEndorsementStudentCompletionDateTime');
    CourseEndorsementStudentExpirationDateTime = new DwItemAttribute('roCourseEndorsementStudentActive', 'CourseEndorsementStudentExpirationDateTime');
    CourseEndorsementStudentEndorsementPDFMediaId = new DwItemAttribute('roCourseEndorsementStudentActive', 'CourseEndorsementStudentEndorsementPDFMediaId');
    CourseEndorsementStudentCourseEndorsementStudentStatusId = new DwItemAttribute('roCourseEndorsementStudentActive', 'CourseEndorsementStudentCourseEndorsementStudentStatusId');
}
export class JoinRequestDetailsGridQueryMetaData implements DwItem2<JoinRequestDetailsGridQueryEntity, JoinRequestDetailsGridQueryMetaDataAttributes,JoinRequestMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Join_Request-Details-Grid';

    constructor() {
        this.ItemDetail.itemId=198;
        this.ItemDetail.itemName='JoinRequest';
        this.ItemDetail.keyName='JoinRequestId';
    }

    CreateEntity(): JoinRequestDetailsGridQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): JoinRequestDetailsGridQueryBuilder {
        return new DwQueryBuilderGen<JoinRequestDetailsGridQueryEntity, JoinRequestDetailsGridQueryMetaDataAttributes,JoinRequestMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<JoinRequestDetailsGridQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: JoinRequestDetailsGridQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<JoinRequestDetailsGridQueryEntity, JoinRequestDetailsGridQueryMetaDataAttributes,JoinRequestMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new JoinRequestDetailsGridQueryMetaDataAttributes();
     Relations = new JoinRequestMetaDataRelations();

}


export type JoinRequestDetailsGridQueryBuilder = DwQueryBuilderGen<JoinRequestDetailsGridQueryEntity, JoinRequestDetailsGridQueryMetaDataAttributes,JoinRequestMetaDataRelations>


export class JoinRequestDetailsGridQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'JoinRequest';
    // Attributes
    JoinRequestId = new DwItemAttribute(this.i, 'JoinRequestId');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    FlightSchoolIdDisplay = new DwItemAttribute(this.i, 'FlightSchoolIdDisplay');
    JoinRequestTypeId = new DwItemAttribute(this.i, 'JoinRequestTypeId');
    JoinRequestTypeIdDisplay = new DwItemAttribute(this.i, 'JoinRequestTypeIdDisplay');
    MessageHtml = new DwItemAttribute(this.i, 'MessageHtml');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedByDisplay = new DwItemAttribute(this.i, 'CreatedByDisplay');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedByDisplay = new DwItemAttribute(this.i, 'ModifiedByDisplay');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    UsePackage = new DwItemAttribute(this.i, 'UsePackage');
    CoursePackageId = new DwItemAttribute(this.i, 'CoursePackageId');
    CoursePackageIdDisplay = new DwItemAttribute(this.i, 'CoursePackageIdDisplay');
    JoinRequestStatusId = new DwItemAttribute(this.i, 'JoinRequestStatusId');
    JoinRequestStatusIdDisplay = new DwItemAttribute(this.i, 'JoinRequestStatusIdDisplay');
    AssignToGroup = new DwItemAttribute(this.i, 'AssignToGroup');
    FlightSchoolGroupId = new DwItemAttribute(this.i, 'FlightSchoolGroupId');
    FlightSchoolGroupIdDisplay = new DwItemAttribute(this.i, 'FlightSchoolGroupIdDisplay');
    DiscountCode = new DwItemAttribute(this.i, 'DiscountCode');
    JoinRequestEmailEmailAddress = new DwItemAttribute('JoinRequestEmail', 'JoinRequestEmailEmailAddress');
    JoinRequestEmailAccepted = new DwItemAttribute('JoinRequestEmail', 'JoinRequestEmailAccepted');
    JoinRequestEmailUserId = new DwItemAttribute('JoinRequestEmail', 'JoinRequestEmailUserId');
    JoinRequestEmailUserIdDisplay = new DwItemAttribute('JoinRequestEmail', 'JoinRequestEmailUserIdDisplay');
    JoinRequestEmailAcceptedDateTime = new DwItemAttribute('JoinRequestEmail', 'JoinRequestEmailAcceptedDateTime');
    JoinRequestEmailLastResendRequestDateTime = new DwItemAttribute('JoinRequestEmail', 'JoinRequestEmailLastResendRequestDateTime');
    JoinRequestEmailJoinRequestEmailId = new DwItemAttribute('JoinRequestEmail', 'JoinRequestEmailJoinRequestEmailId');
    JoinRequestEmailJoinRequestId = new DwItemAttribute('JoinRequestEmail', 'JoinRequestEmailJoinRequestId');
    JoinRequestEmailJoinRequestIdDisplay = new DwItemAttribute('JoinRequestEmail', 'JoinRequestEmailJoinRequestIdDisplay');
}
export class CourseListForStudentMarketplaceQueryMetaData implements DwItem2<CourseListForStudentMarketplaceQueryEntity, CourseListForStudentMarketplaceQueryMetaDataAttributes,CourseMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Course_List_For_Student_Marketplace';

    constructor() {
        this.ItemDetail.itemId=145;
        this.ItemDetail.itemName='Course';
        this.ItemDetail.keyName='CourseId';
    }

    CreateEntity(): CourseListForStudentMarketplaceQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): CourseListForStudentMarketplaceQueryBuilder {
        return new DwQueryBuilderGen<CourseListForStudentMarketplaceQueryEntity, CourseListForStudentMarketplaceQueryMetaDataAttributes,CourseMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<CourseListForStudentMarketplaceQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: CourseListForStudentMarketplaceQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<CourseListForStudentMarketplaceQueryEntity, CourseListForStudentMarketplaceQueryMetaDataAttributes,CourseMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new CourseListForStudentMarketplaceQueryMetaDataAttributes();
     Relations = new CourseMetaDataRelations();

}


export type CourseListForStudentMarketplaceQueryBuilder = DwQueryBuilderGen<CourseListForStudentMarketplaceQueryEntity, CourseListForStudentMarketplaceQueryMetaDataAttributes,CourseMetaDataRelations>


export class CourseListForStudentMarketplaceQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Course';
    // Attributes
    CourseId = new DwItemAttribute(this.i, 'CourseId');
    CourseName = new DwItemAttribute(this.i, 'CourseName');
    CourseDescription = new DwItemAttribute(this.i, 'CourseDescription');
    CourseTypeId = new DwItemAttribute(this.i, 'CourseTypeId');
    CourseTypeIdDisplay = new DwItemAttribute(this.i, 'CourseTypeIdDisplay');
    CourseImageMediaId = new DwItemAttribute(this.i, 'CourseImageMediaId');
    CourseImageMediaIdDisplay = new DwItemAttribute(this.i, 'CourseImageMediaIdDisplay');
    CourseNotes = new DwItemAttribute(this.i, 'CourseNotes');
    AircraftTypeId = new DwItemAttribute(this.i, 'AircraftTypeId');
    AircraftTypeIdDisplay = new DwItemAttribute(this.i, 'AircraftTypeIdDisplay');
    AvionicsType = new DwItemAttribute(this.i, 'AvionicsType');
    ProgramTypeId = new DwItemAttribute(this.i, 'ProgramTypeId');
    ProgramTypeIdDisplay = new DwItemAttribute(this.i, 'ProgramTypeIdDisplay');
    RetailPrice = new DwItemAttribute(this.i, 'RetailPrice');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedByDisplay = new DwItemAttribute(this.i, 'CreatedByDisplay');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedByDisplay = new DwItemAttribute(this.i, 'ModifiedByDisplay');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    CourseStatusId = new DwItemAttribute(this.i, 'CourseStatusId');
    CourseStatusIdDisplay = new DwItemAttribute(this.i, 'CourseStatusIdDisplay');
    TotalCourseTimeSeconds = new DwItemAttribute(this.i, 'TotalCourseTimeSeconds');
    TotalCourseVideoTimeSeconds = new DwItemAttribute(this.i, 'TotalCourseVideoTimeSeconds');
    TotalCourseQuizTimeSeconds = new DwItemAttribute(this.i, 'TotalCourseQuizTimeSeconds');
    CourseKey = new DwItemAttribute(this.i, 'CourseKey');
    DefaultSchoolCourse = new DwItemAttribute(this.i, 'DefaultSchoolCourse');
    AcsTestId = new DwItemAttribute(this.i, 'AcsTestId');
    AcsTestIdDisplay = new DwItemAttribute(this.i, 'AcsTestIdDisplay');
    CourseOrder = new DwItemAttribute(this.i, 'CourseOrder');
    ModulePrefixOverride = new DwItemAttribute(this.i, 'ModulePrefixOverride');
    ComingSoon = new DwItemAttribute(this.i, 'ComingSoon');
    MediaImageHeight = new DwItemAttribute('dw_roMedia', 'MediaImageHeight');
    MediaImageWidth = new DwItemAttribute('dw_roMedia', 'MediaImageWidth');
    MediaMediaPath = new DwItemAttribute('dw_roMedia', 'MediaMediaPath');
    RoStudentSchoolCoursesFlightSchoolId = new DwItemAttribute('roStudentSchoolCourses', 'RoStudentSchoolCoursesFlightSchoolId');
    RoStudentSchoolCoursesFlightSchoolIdDisplay = new DwItemAttribute('roStudentSchoolCourses', 'RoStudentSchoolCoursesFlightSchoolIdDisplay');
    RoStudentSchoolCoursesCourseName = new DwItemAttribute('roStudentSchoolCourses', 'RoStudentSchoolCoursesCourseName');
    RoStudentSchoolCoursesStudentName = new DwItemAttribute('roStudentSchoolCourses', 'RoStudentSchoolCoursesStudentName');
    RoStudentSchoolCoursesUserId = new DwItemAttribute('roStudentSchoolCourses', 'RoStudentSchoolCoursesUserId');
    RoStudentSchoolCoursesUserIdDisplay = new DwItemAttribute('roStudentSchoolCourses', 'RoStudentSchoolCoursesUserIdDisplay');
    RoStudentSchoolCoursesStudentCourseId = new DwItemAttribute('roStudentSchoolCourses', 'RoStudentSchoolCoursesStudentCourseId');
    RoStudentSchoolCoursesCourseId = new DwItemAttribute('roStudentSchoolCourses', 'RoStudentSchoolCoursesCourseId');
    RoStudentSchoolCoursesCourseIdDisplay = new DwItemAttribute('roStudentSchoolCourses', 'RoStudentSchoolCoursesCourseIdDisplay');
    RoStudentSchoolCoursesStudentId = new DwItemAttribute('roStudentSchoolCourses', 'RoStudentSchoolCoursesStudentId');
    RoStudentSchoolCoursesStudentIdDisplay = new DwItemAttribute('roStudentSchoolCourses', 'RoStudentSchoolCoursesStudentIdDisplay');
    StudentCourseStudentCourseId = new DwItemAttribute('StudentCourse', 'StudentCourseStudentCourseId');
    StudentCourseStudentId = new DwItemAttribute('StudentCourse', 'StudentCourseStudentId');
    StudentCourseStudentIdDisplay = new DwItemAttribute('StudentCourse', 'StudentCourseStudentIdDisplay');
    StudentCourseCourseId = new DwItemAttribute('StudentCourse', 'StudentCourseCourseId');
    StudentCourseCourseIdDisplay = new DwItemAttribute('StudentCourse', 'StudentCourseCourseIdDisplay');
    StudentCourseIsActive = new DwItemAttribute('StudentCourse', 'StudentCourseIsActive');
    StudentCoursePercentComplete = new DwItemAttribute('StudentCourse', 'StudentCoursePercentComplete');
    StudentCourseModulesCompleted = new DwItemAttribute('StudentCourse', 'StudentCourseModulesCompleted');
    StudentCourseModulesCount = new DwItemAttribute('StudentCourse', 'StudentCourseModulesCount');
    StudentCourseLastActivityDateTime = new DwItemAttribute('StudentCourse', 'StudentCourseLastActivityDateTime');
    StudentCourseLessonsCompleted = new DwItemAttribute('StudentCourse', 'StudentCourseLessonsCompleted');
    StudentCourseLessonCount = new DwItemAttribute('StudentCourse', 'StudentCourseLessonCount');
    StudentCourseTotalTimeSeconds = new DwItemAttribute('StudentCourse', 'StudentCourseTotalTimeSeconds');
    StudentCourseFirstActivityDateTime = new DwItemAttribute('StudentCourse', 'StudentCourseFirstActivityDateTime');
    StudentCourseCompletedDateTime = new DwItemAttribute('StudentCourse', 'StudentCourseCompletedDateTime');
    StudentCourseStudentCourseStatusId = new DwItemAttribute('StudentCourse', 'StudentCourseStudentCourseStatusId');
    StudentCourseStudentCourseStatusIdDisplay = new DwItemAttribute('StudentCourse', 'StudentCourseStudentCourseStatusIdDisplay');
    StudentCourseIsEndorsed = new DwItemAttribute('StudentCourse', 'StudentCourseIsEndorsed');
    ResultCount = new DwItemAttribute('RoStudentCourseAcsTestResultDetail', 'ResultCount');
    AcsTestResultsPassedAny = new DwItemAttribute('RoStudentCourseAcsTestResultDetail', 'AcsTestResultsPassedAny');
    AcsTestResultsFailedAny = new DwItemAttribute('RoStudentCourseAcsTestResultDetail', 'AcsTestResultsFailedAny');
    CourseEndorsementStudentCourseEndorsementStudentId = new DwItemAttribute('roCourseEndorsementStudentActive', 'CourseEndorsementStudentCourseEndorsementStudentId');
    CourseEndorsementStudentCourseEndorsementId = new DwItemAttribute('roCourseEndorsementStudentActive', 'CourseEndorsementStudentCourseEndorsementId');
    CourseEndorsementStudentCompletionDateTime = new DwItemAttribute('roCourseEndorsementStudentActive', 'CourseEndorsementStudentCompletionDateTime');
    CourseEndorsementStudentExpirationDateTime = new DwItemAttribute('roCourseEndorsementStudentActive', 'CourseEndorsementStudentExpirationDateTime');
    CourseEndorsementStudentEndorsementPDFMediaId = new DwItemAttribute('roCourseEndorsementStudentActive', 'CourseEndorsementStudentEndorsementPDFMediaId');
    ProductProductId = new DwItemAttribute('Product', 'ProductProductId');
    ProductProductTypeId = new DwItemAttribute('Product', 'ProductProductTypeId');
    ProductProductTypeIdDisplay = new DwItemAttribute('Product', 'ProductProductTypeIdDisplay');
    ProductRetailPrice = new DwItemAttribute('Product', 'ProductRetailPrice');
}
export class StudentCourseForAssignmentQueryMetaData implements DwItem2<StudentCourseForAssignmentQueryEntity, StudentCourseForAssignmentQueryMetaDataAttributes,StudentCourseMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'StudentCourse_ForAssignment';

    constructor() {
        this.ItemDetail.itemId=165;
        this.ItemDetail.itemName='StudentCourse';
        this.ItemDetail.keyName='StudentCourseId';
    }

    CreateEntity(): StudentCourseForAssignmentQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): StudentCourseForAssignmentQueryBuilder {
        return new DwQueryBuilderGen<StudentCourseForAssignmentQueryEntity, StudentCourseForAssignmentQueryMetaDataAttributes,StudentCourseMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<StudentCourseForAssignmentQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: StudentCourseForAssignmentQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<StudentCourseForAssignmentQueryEntity, StudentCourseForAssignmentQueryMetaDataAttributes,StudentCourseMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new StudentCourseForAssignmentQueryMetaDataAttributes();
     Relations = new StudentCourseMetaDataRelations();

}


export type StudentCourseForAssignmentQueryBuilder = DwQueryBuilderGen<StudentCourseForAssignmentQueryEntity, StudentCourseForAssignmentQueryMetaDataAttributes,StudentCourseMetaDataRelations>


export class StudentCourseForAssignmentQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'StudentCourse';
    // Attributes
    StudentCourseId = new DwItemAttribute(this.i, 'StudentCourseId');
    StudentId = new DwItemAttribute(this.i, 'StudentId');
    StudentIdDisplay = new DwItemAttribute(this.i, 'StudentIdDisplay');
    CourseId = new DwItemAttribute(this.i, 'CourseId');
    CourseIdDisplay = new DwItemAttribute(this.i, 'CourseIdDisplay');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    PercentComplete = new DwItemAttribute(this.i, 'PercentComplete');
    CourseCourseId = new DwItemAttribute('Course', 'CourseCourseId');
    CourseCourseName = new DwItemAttribute('Course', 'CourseCourseName');
    StudentUserId = new DwItemAttribute('Student', 'StudentUserId');
    StudentUserIdDisplay = new DwItemAttribute('Student', 'StudentUserIdDisplay');
}
export class ProfitSharingTotalsBySchoolQueryMetaData implements DwItem2<ProfitSharingTotalsBySchoolQueryEntity, ProfitSharingTotalsBySchoolQueryMetaDataAttributes,RptProfitShareMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Profit_Sharing-Totals_By_School';

    constructor() {
        this.ItemDetail.itemId=302;
        this.ItemDetail.itemName='rptProfitShare';
        this.ItemDetail.keyName='ProfitShareId';
    }

    CreateEntity(): ProfitSharingTotalsBySchoolQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): ProfitSharingTotalsBySchoolQueryBuilder {
        return new DwQueryBuilderGen<ProfitSharingTotalsBySchoolQueryEntity, ProfitSharingTotalsBySchoolQueryMetaDataAttributes,RptProfitShareMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<ProfitSharingTotalsBySchoolQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: ProfitSharingTotalsBySchoolQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<ProfitSharingTotalsBySchoolQueryEntity, ProfitSharingTotalsBySchoolQueryMetaDataAttributes,RptProfitShareMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new ProfitSharingTotalsBySchoolQueryMetaDataAttributes();
     Relations = new RptProfitShareMetaDataRelations();

}


export type ProfitSharingTotalsBySchoolQueryBuilder = DwQueryBuilderGen<ProfitSharingTotalsBySchoolQueryEntity, ProfitSharingTotalsBySchoolQueryMetaDataAttributes,RptProfitShareMetaDataRelations>


export class ProfitSharingTotalsBySchoolQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'rptProfitShare';
    // Attributes
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    FlightSchoolName = new DwItemAttribute(this.i, 'FlightSchoolName');
    Year = new DwItemAttribute(this.i, 'Year');
    Month = new DwItemAttribute(this.i, 'Month');
    ProfitShareTypeId = new DwItemAttribute(this.i, 'ProfitShareTypeId');
    ProfitShareType = new DwItemAttribute(this.i, 'ProfitShareType');
    Sum = new DwItemAttribute(this.i, 'Sum');
}
export class SubscriptionTierActiveQueryMetaData implements DwItem2<SubscriptionTierActiveQueryEntity, SubscriptionTierActiveQueryMetaDataAttributes,SubscriptionTierMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Subscription_Tier-Active';

    constructor() {
        this.ItemDetail.itemId=242;
        this.ItemDetail.itemName='SubscriptionTier';
        this.ItemDetail.keyName='SubscriptionTierId';
    }

    CreateEntity(): SubscriptionTierActiveQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): SubscriptionTierActiveQueryBuilder {
        return new DwQueryBuilderGen<SubscriptionTierActiveQueryEntity, SubscriptionTierActiveQueryMetaDataAttributes,SubscriptionTierMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<SubscriptionTierActiveQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: SubscriptionTierActiveQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<SubscriptionTierActiveQueryEntity, SubscriptionTierActiveQueryMetaDataAttributes,SubscriptionTierMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new SubscriptionTierActiveQueryMetaDataAttributes();
     Relations = new SubscriptionTierMetaDataRelations();

}


export type SubscriptionTierActiveQueryBuilder = DwQueryBuilderGen<SubscriptionTierActiveQueryEntity, SubscriptionTierActiveQueryMetaDataAttributes,SubscriptionTierMetaDataRelations>


export class SubscriptionTierActiveQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'SubscriptionTier';
    // Attributes
    SubscriptionTierId = new DwItemAttribute(this.i, 'SubscriptionTierId');
    SubscriptionTierName = new DwItemAttribute(this.i, 'SubscriptionTierName');
    SubscriptionTierStatusId = new DwItemAttribute(this.i, 'SubscriptionTierStatusId');
    SubscriptionTierStatusIdDisplay = new DwItemAttribute(this.i, 'SubscriptionTierStatusIdDisplay');
    EffectiveStartDate = new DwItemAttribute(this.i, 'EffectiveStartDate');
    EffectiveEndDate = new DwItemAttribute(this.i, 'EffectiveEndDate');
    PlatformMonthlyCost = new DwItemAttribute(this.i, 'PlatformMonthlyCost');
    ProfitSharingPercentage = new DwItemAttribute(this.i, 'ProfitSharingPercentage');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedByDisplay = new DwItemAttribute(this.i, 'CreatedByDisplay');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedByDisplay = new DwItemAttribute(this.i, 'ModifiedByDisplay');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    ProductId = new DwItemAttribute(this.i, 'ProductId');
    PriceId = new DwItemAttribute(this.i, 'PriceId');
    Description = new DwItemAttribute(this.i, 'Description');
    IsDefaultTier = new DwItemAttribute(this.i, 'IsDefaultTier');
    SubscriptionTierOrder = new DwItemAttribute(this.i, 'SubscriptionTierOrder');
    LimitToSchools = new DwItemAttribute(this.i, 'LimitToSchools');
}
export class SubscriptionDetailsQueryMetaData implements DwItem2<SubscriptionDetailsQueryEntity, SubscriptionDetailsQueryMetaDataAttributes,SubscriptionMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Subscription_Details';

    constructor() {
        this.ItemDetail.itemId=244;
        this.ItemDetail.itemName='Subscription';
        this.ItemDetail.keyName='SubscriptionId';
    }

    CreateEntity(): SubscriptionDetailsQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): SubscriptionDetailsQueryBuilder {
        return new DwQueryBuilderGen<SubscriptionDetailsQueryEntity, SubscriptionDetailsQueryMetaDataAttributes,SubscriptionMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<SubscriptionDetailsQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: SubscriptionDetailsQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<SubscriptionDetailsQueryEntity, SubscriptionDetailsQueryMetaDataAttributes,SubscriptionMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new SubscriptionDetailsQueryMetaDataAttributes();
     Relations = new SubscriptionMetaDataRelations();

}


export type SubscriptionDetailsQueryBuilder = DwQueryBuilderGen<SubscriptionDetailsQueryEntity, SubscriptionDetailsQueryMetaDataAttributes,SubscriptionMetaDataRelations>


export class SubscriptionDetailsQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Subscription';
    // Attributes
    SubscriptionId = new DwItemAttribute(this.i, 'SubscriptionId');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    FlightSchoolIdDisplay = new DwItemAttribute(this.i, 'FlightSchoolIdDisplay');
    SubscriptionTierId = new DwItemAttribute(this.i, 'SubscriptionTierId');
    SubscriptionTierIdDisplay = new DwItemAttribute(this.i, 'SubscriptionTierIdDisplay');
    SubscriptionStatusId = new DwItemAttribute(this.i, 'SubscriptionStatusId');
    SubscriptionStatusIdDisplay = new DwItemAttribute(this.i, 'SubscriptionStatusIdDisplay');
    EffectiveStartDate = new DwItemAttribute(this.i, 'EffectiveStartDate');
    EffectiveEndDate = new DwItemAttribute(this.i, 'EffectiveEndDate');
    FirstInvoiceDateTime = new DwItemAttribute(this.i, 'FirstInvoiceDateTime');
    LastInvoiceDateTime = new DwItemAttribute(this.i, 'LastInvoiceDateTime');
    NextInvoiceDateTime = new DwItemAttribute(this.i, 'NextInvoiceDateTime');
    DiscountAppliedDate = new DwItemAttribute(this.i, 'DiscountAppliedDate');
    DiscountExpirationDate = new DwItemAttribute(this.i, 'DiscountExpirationDate');
    DiscountDiscountCode = new DwItemAttribute('Discount', 'DiscountDiscountCode');
}
export class CourseModuleProgressWithAISummaryQueryMetaData implements DwItem2<CourseModuleProgressWithAISummaryQueryEntity, CourseModuleProgressWithAISummaryQueryMetaDataAttributes,CourseModuleProgressMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Course_Module_Progress-With_AI_Summary';

    constructor() {
        this.ItemDetail.itemId=134;
        this.ItemDetail.itemName='CourseModuleProgress';
        this.ItemDetail.keyName='CourseModuleProgressId';
    }

    CreateEntity(): CourseModuleProgressWithAISummaryQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): CourseModuleProgressWithAISummaryQueryBuilder {
        return new DwQueryBuilderGen<CourseModuleProgressWithAISummaryQueryEntity, CourseModuleProgressWithAISummaryQueryMetaDataAttributes,CourseModuleProgressMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<CourseModuleProgressWithAISummaryQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: CourseModuleProgressWithAISummaryQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<CourseModuleProgressWithAISummaryQueryEntity, CourseModuleProgressWithAISummaryQueryMetaDataAttributes,CourseModuleProgressMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new CourseModuleProgressWithAISummaryQueryMetaDataAttributes();
     Relations = new CourseModuleProgressMetaDataRelations();

}


export type CourseModuleProgressWithAISummaryQueryBuilder = DwQueryBuilderGen<CourseModuleProgressWithAISummaryQueryEntity, CourseModuleProgressWithAISummaryQueryMetaDataAttributes,CourseModuleProgressMetaDataRelations>


export class CourseModuleProgressWithAISummaryQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CourseModuleProgress';
    // Attributes
    CourseModuleProgressId = new DwItemAttribute(this.i, 'CourseModuleProgressId');
    StudentCourseId = new DwItemAttribute(this.i, 'StudentCourseId');
    StudentCourseIdDisplay = new DwItemAttribute(this.i, 'StudentCourseIdDisplay');
    CourseModuleId = new DwItemAttribute(this.i, 'CourseModuleId');
    CourseModuleIdDisplay = new DwItemAttribute(this.i, 'CourseModuleIdDisplay');
    LessonsCount = new DwItemAttribute(this.i, 'LessonsCount');
    LessonsCompleted = new DwItemAttribute(this.i, 'LessonsCompleted');
    PercentComplete = new DwItemAttribute(this.i, 'PercentComplete');
    LastActivityDateTime = new DwItemAttribute(this.i, 'LastActivityDateTime');
    FirstActivityDateTime = new DwItemAttribute(this.i, 'FirstActivityDateTime');
    CompletedDateTime = new DwItemAttribute(this.i, 'CompletedDateTime');
    TotalTimeSeconds = new DwItemAttribute(this.i, 'TotalTimeSeconds');
    TotalVideoTimeSeconds = new DwItemAttribute(this.i, 'TotalVideoTimeSeconds');
    TotalQuizTimeSeconds = new DwItemAttribute(this.i, 'TotalQuizTimeSeconds');
    ModuleProgressStatusId = new DwItemAttribute(this.i, 'ModuleProgressStatusId');
    ModuleProgressStatusIdDisplay = new DwItemAttribute(this.i, 'ModuleProgressStatusIdDisplay');
    AIPromptRequestAIPromptRequestId = new DwItemAttribute('AIPromptRequest', 'AIPromptRequestAIPromptRequestId');
    AIPromptRequestResult = new DwItemAttribute('AIPromptRequest', 'AIPromptRequestResult');
    AIPromptRequestAIPromptRequestStatusId = new DwItemAttribute('AIPromptRequest', 'AIPromptRequestAIPromptRequestStatusId');
    AIPromptRequestAIPromptRequestStatusIdDisplay = new DwItemAttribute('AIPromptRequest', 'AIPromptRequestAIPromptRequestStatusIdDisplay');
    StudentCourseStudentCourseId = new DwItemAttribute('StudentCourse', 'StudentCourseStudentCourseId');
    StudentStudentId = new DwItemAttribute('Student', 'StudentStudentId');
    StudentUserId = new DwItemAttribute('Student', 'StudentUserId');
    StudentUserIdDisplay = new DwItemAttribute('Student', 'StudentUserIdDisplay');
    DwUserFirstName = new DwItemAttribute('dw_User', 'DwUserFirstName');
    DwUserLastName = new DwItemAttribute('dw_User', 'DwUserLastName');
    DwUserEmail = new DwItemAttribute('dw_User', 'DwUserEmail');
}
export class AssignmentStudentAcknowledgementsQueryMetaData implements DwItem2<AssignmentStudentAcknowledgementsQueryEntity, AssignmentStudentAcknowledgementsQueryMetaDataAttributes,AssignmentStudentMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Assignment_Student-Acknowledgements';

    constructor() {
        this.ItemDetail.itemId=191;
        this.ItemDetail.itemName='AssignmentStudent';
        this.ItemDetail.keyName='AssignmentStudentId';
    }

    CreateEntity(): AssignmentStudentAcknowledgementsQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): AssignmentStudentAcknowledgementsQueryBuilder {
        return new DwQueryBuilderGen<AssignmentStudentAcknowledgementsQueryEntity, AssignmentStudentAcknowledgementsQueryMetaDataAttributes,AssignmentStudentMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<AssignmentStudentAcknowledgementsQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: AssignmentStudentAcknowledgementsQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<AssignmentStudentAcknowledgementsQueryEntity, AssignmentStudentAcknowledgementsQueryMetaDataAttributes,AssignmentStudentMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new AssignmentStudentAcknowledgementsQueryMetaDataAttributes();
     Relations = new AssignmentStudentMetaDataRelations();

}


export type AssignmentStudentAcknowledgementsQueryBuilder = DwQueryBuilderGen<AssignmentStudentAcknowledgementsQueryEntity, AssignmentStudentAcknowledgementsQueryMetaDataAttributes,AssignmentStudentMetaDataRelations>


export class AssignmentStudentAcknowledgementsQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AssignmentStudent';
    // Attributes
    AssignmentStudentId = new DwItemAttribute(this.i, 'AssignmentStudentId');
    AssignmentId = new DwItemAttribute(this.i, 'AssignmentId');
    AssignmentIdDisplay = new DwItemAttribute(this.i, 'AssignmentIdDisplay');
    StudentId = new DwItemAttribute(this.i, 'StudentId');
    StudentIdDisplay = new DwItemAttribute(this.i, 'StudentIdDisplay');
    PercentComplete = new DwItemAttribute(this.i, 'PercentComplete');
    CompletedDateTime = new DwItemAttribute(this.i, 'CompletedDateTime');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedByDisplay = new DwItemAttribute(this.i, 'CreatedByDisplay');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedByDisplay = new DwItemAttribute(this.i, 'ModifiedByDisplay');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    Acknowledged = new DwItemAttribute(this.i, 'Acknowledged');
    AcknowledgedDateTime = new DwItemAttribute(this.i, 'AcknowledgedDateTime');
    AiPromptRequestId = new DwItemAttribute(this.i, 'AiPromptRequestId');
    AiPromptRequestIdDisplay = new DwItemAttribute(this.i, 'AiPromptRequestIdDisplay');
    ShowAISummary = new DwItemAttribute(this.i, 'ShowAISummary');
    StudentStudentId = new DwItemAttribute('Student', 'StudentStudentId');
    StudentUserId = new DwItemAttribute('Student', 'StudentUserId');
    StudentUserIdDisplay = new DwItemAttribute('Student', 'StudentUserIdDisplay');
    AssignmentAssignmentId = new DwItemAttribute('Assignment', 'AssignmentAssignmentId');
    AssignmentCourseId = new DwItemAttribute('Assignment', 'AssignmentCourseId');
    AssignmentCourseIdDisplay = new DwItemAttribute('Assignment', 'AssignmentCourseIdDisplay');
    AssignmentAssignmentDescription = new DwItemAttribute('Assignment', 'AssignmentAssignmentDescription');
    AssignmentAssignmentStatusId = new DwItemAttribute('Assignment', 'AssignmentAssignmentStatusId');
    AssignmentAssignmentStatusIdDisplay = new DwItemAttribute('Assignment', 'AssignmentAssignmentStatusIdDisplay');
    AssignmentDueDateTime = new DwItemAttribute('Assignment', 'AssignmentDueDateTime');
    AssignmentAssignedDateTime = new DwItemAttribute('Assignment', 'AssignmentAssignedDateTime');
    AssignmentInstructorId = new DwItemAttribute('Assignment', 'AssignmentInstructorId');
    AssignmentInstructorIdDisplay = new DwItemAttribute('Assignment', 'AssignmentInstructorIdDisplay');
}
export class DocumentItemsListQueryMetaData implements DwItem2<DocumentItemsListQueryEntity, DocumentItemsListQueryMetaDataAttributes,DocumentItemMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Document_Items-List';

    constructor() {
        this.ItemDetail.itemId=373;
        this.ItemDetail.itemName='DocumentItem';
        this.ItemDetail.keyName='DocumentItemId';
    }

    CreateEntity(): DocumentItemsListQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): DocumentItemsListQueryBuilder {
        return new DwQueryBuilderGen<DocumentItemsListQueryEntity, DocumentItemsListQueryMetaDataAttributes,DocumentItemMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<DocumentItemsListQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: DocumentItemsListQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<DocumentItemsListQueryEntity, DocumentItemsListQueryMetaDataAttributes,DocumentItemMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new DocumentItemsListQueryMetaDataAttributes();
     Relations = new DocumentItemMetaDataRelations();

}


export type DocumentItemsListQueryBuilder = DwQueryBuilderGen<DocumentItemsListQueryEntity, DocumentItemsListQueryMetaDataAttributes,DocumentItemMetaDataRelations>


export class DocumentItemsListQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'DocumentItem';
    // Attributes
    DocumentItemId = new DwItemAttribute(this.i, 'DocumentItemId');
    DocumentGroupId = new DwItemAttribute(this.i, 'DocumentGroupId');
    DocumentGroupIdDisplay = new DwItemAttribute(this.i, 'DocumentGroupIdDisplay');
    DocumentItemName = new DwItemAttribute(this.i, 'DocumentItemName');
    MediaId = new DwItemAttribute(this.i, 'MediaId');
    MediaIdDisplay = new DwItemAttribute(this.i, 'MediaIdDisplay');
    CardIconMediaId = new DwItemAttribute(this.i, 'CardIconMediaId');
    CardIconMediaIdDisplay = new DwItemAttribute(this.i, 'CardIconMediaIdDisplay');
    DocumentTypeId = new DwItemAttribute(this.i, 'DocumentTypeId');
    DocumentTypeIdDisplay = new DwItemAttribute(this.i, 'DocumentTypeIdDisplay');
    DocumentItemStatusId = new DwItemAttribute(this.i, 'DocumentItemStatusId');
    DocumentItemStatusIdDisplay = new DwItemAttribute(this.i, 'DocumentItemStatusIdDisplay');
    EmbeddedMarkup = new DwItemAttribute(this.i, 'EmbeddedMarkup');
    ExtractedImageMediaId = new DwItemAttribute(this.i, 'ExtractedImageMediaId');
    ExtractedImageMediaIdDisplay = new DwItemAttribute(this.i, 'ExtractedImageMediaIdDisplay');
    UseCustomCardIcon = new DwItemAttribute(this.i, 'UseCustomCardIcon');
    DocumentOwnershipTypeId = new DwItemAttribute(this.i, 'DocumentOwnershipTypeId');
    DocumentOwnershipTypeIdDisplay = new DwItemAttribute(this.i, 'DocumentOwnershipTypeIdDisplay');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    FlightSchoolIdDisplay = new DwItemAttribute(this.i, 'FlightSchoolIdDisplay');
    ParentDocumentFolderId = new DwItemAttribute(this.i, 'ParentDocumentFolderId');
    ParentDocumentFolderIdDisplay = new DwItemAttribute(this.i, 'ParentDocumentFolderIdDisplay');
    RequireStudentAcknowledgement = new DwItemAttribute(this.i, 'RequireStudentAcknowledgement');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedByDisplay = new DwItemAttribute(this.i, 'CreatedByDisplay');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedByDisplay = new DwItemAttribute(this.i, 'ModifiedByDisplay');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    AiProcessingReferenceId = new DwItemAttribute(this.i, 'AiProcessingReferenceId');
    DocumentFileHash = new DwItemAttribute(this.i, 'DocumentFileHash');
    DocumentAiComplete = new DwItemAttribute(this.i, 'DocumentAiComplete');
    DocumentAiProcessingStatusId = new DwItemAttribute(this.i, 'DocumentAiProcessingStatusId');
    DocumentAiProcessingStatusIdDisplay = new DwItemAttribute(this.i, 'DocumentAiProcessingStatusIdDisplay');
    DocumentAiProcessingProgressText = new DwItemAttribute(this.i, 'DocumentAiProcessingProgressText');
    DocumentAiProcessingErrorText = new DwItemAttribute(this.i, 'DocumentAiProcessingErrorText');
    DocumentAiProcessingStartDateTime = new DwItemAttribute(this.i, 'DocumentAiProcessingStartDateTime');
    DocumentAiProcessingCompletedDateTime = new DwItemAttribute(this.i, 'DocumentAiProcessingCompletedDateTime');
    DocumentAiProcessingLastUpdatedDateTime = new DwItemAttribute(this.i, 'DocumentAiProcessingLastUpdatedDateTime');
    DocumentAiProcessingEstimatedCompletedDateTime = new DwItemAttribute(this.i, 'DocumentAiProcessingEstimatedCompletedDateTime');
    DocumentAiProcessingTotalChunkCount = new DwItemAttribute(this.i, 'DocumentAiProcessingTotalChunkCount');
    DocumentAiProcessingProcessedChunkCount = new DwItemAttribute(this.i, 'DocumentAiProcessingProcessedChunkCount');
    DocumentAiProcessingFailedChunkCount = new DwItemAttribute(this.i, 'DocumentAiProcessingFailedChunkCount');
    DocumentAiProcessingTotalModuleLinkCount = new DwItemAttribute(this.i, 'DocumentAiProcessingTotalModuleLinkCount');
    DocumentAiProcessingProcessedModuleLinkCount = new DwItemAttribute(this.i, 'DocumentAiProcessingProcessedModuleLinkCount');
    DocumentAiProcessingFailedModuleLinkCount = new DwItemAttribute(this.i, 'DocumentAiProcessingFailedModuleLinkCount');
    DocumentGroupDocumentGroupName = new DwItemAttribute('DocumentGroup', 'DocumentGroupDocumentGroupName');
    DocumentGroupIsDefault = new DwItemAttribute('DocumentGroup', 'DocumentGroupIsDefault');
    DocumentTypeDocumentType = new DwItemAttribute('DocumentType', 'DocumentTypeDocumentType');
    DocumentTypeUseEmbeddedMarkup = new DwItemAttribute('DocumentType', 'DocumentTypeUseEmbeddedMarkup');
    DocumentTypeDocumentTypeId = new DwItemAttribute('DocumentType', 'DocumentTypeDocumentTypeId');
    MediaImageHeight = new DwItemAttribute('dw_roMedia', 'MediaImageHeight');
    MediaImageWidth = new DwItemAttribute('dw_roMedia', 'MediaImageWidth');
    MediaMediaPath = new DwItemAttribute('dw_roMedia', 'MediaMediaPath');
    ExtractedMediaImageHeight = new DwItemAttribute('dw_roMedia', 'ExtractedMediaImageHeight');
    ExtractedMediaImageWidth = new DwItemAttribute('dw_roMedia', 'ExtractedMediaImageWidth');
    ExtractedMediaMediaPath = new DwItemAttribute('dw_roMedia', 'ExtractedMediaMediaPath');
}
export class FlightSchoolReportsCourseCountsQueryMetaData implements DwItem2<FlightSchoolReportsCourseCountsQueryEntity, FlightSchoolReportsCourseCountsQueryMetaDataAttributes,RoStudentCourseDetailMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Flight_School_Reports-Course_Counts';

    constructor() {
        this.ItemDetail.itemId=380;
        this.ItemDetail.itemName='roStudentCourseDetail';
        this.ItemDetail.keyName='StudentCourseId';
    }

    CreateEntity(): FlightSchoolReportsCourseCountsQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): FlightSchoolReportsCourseCountsQueryBuilder {
        return new DwQueryBuilderGen<FlightSchoolReportsCourseCountsQueryEntity, FlightSchoolReportsCourseCountsQueryMetaDataAttributes,RoStudentCourseDetailMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<FlightSchoolReportsCourseCountsQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: FlightSchoolReportsCourseCountsQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<FlightSchoolReportsCourseCountsQueryEntity, FlightSchoolReportsCourseCountsQueryMetaDataAttributes,RoStudentCourseDetailMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new FlightSchoolReportsCourseCountsQueryMetaDataAttributes();
     Relations = new RoStudentCourseDetailMetaDataRelations();

}


export type FlightSchoolReportsCourseCountsQueryBuilder = DwQueryBuilderGen<FlightSchoolReportsCourseCountsQueryEntity, FlightSchoolReportsCourseCountsQueryMetaDataAttributes,RoStudentCourseDetailMetaDataRelations>


export class FlightSchoolReportsCourseCountsQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roStudentCourseDetail';
    // Attributes
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    FlightSchoolName = new DwItemAttribute(this.i, 'FlightSchoolName');
    CourseId = new DwItemAttribute(this.i, 'CourseId');
    CourseName = new DwItemAttribute(this.i, 'CourseName');
    Count = new DwItemAttribute(this.i, 'Count');
}
export class InstructorLeaderboardQueryMetaData implements DwItem2<InstructorLeaderboardQueryEntity, InstructorLeaderboardQueryMetaDataAttributes,InstructorMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Instructor_Leaderboard';

    constructor() {
        this.ItemDetail.itemId=211;
        this.ItemDetail.itemName='Instructor';
        this.ItemDetail.keyName='InstructorId';
    }

    CreateEntity(): InstructorLeaderboardQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): InstructorLeaderboardQueryBuilder {
        return new DwQueryBuilderGen<InstructorLeaderboardQueryEntity, InstructorLeaderboardQueryMetaDataAttributes,InstructorMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<InstructorLeaderboardQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: InstructorLeaderboardQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<InstructorLeaderboardQueryEntity, InstructorLeaderboardQueryMetaDataAttributes,InstructorMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new InstructorLeaderboardQueryMetaDataAttributes();
     Relations = new InstructorMetaDataRelations();

}


export type InstructorLeaderboardQueryBuilder = DwQueryBuilderGen<InstructorLeaderboardQueryEntity, InstructorLeaderboardQueryMetaDataAttributes,InstructorMetaDataRelations>


export class InstructorLeaderboardQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Instructor';
    // Attributes
    InstructorId = new DwItemAttribute(this.i, 'InstructorId');
    UserId = new DwItemAttribute(this.i, 'UserId');
    UserIdDisplay = new DwItemAttribute(this.i, 'UserIdDisplay');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    FlightSchoolIdDisplay = new DwItemAttribute(this.i, 'FlightSchoolIdDisplay');
    InstructorStatusId = new DwItemAttribute(this.i, 'InstructorStatusId');
    InstructorStatusIdDisplay = new DwItemAttribute(this.i, 'InstructorStatusIdDisplay');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedByDisplay = new DwItemAttribute(this.i, 'CreatedByDisplay');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedByDisplay = new DwItemAttribute(this.i, 'ModifiedByDisplay');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    InstructorUserFirstName = new DwItemAttribute('dw_User', 'InstructorUserFirstName');
    InstructorUserLastName = new DwItemAttribute('dw_User', 'InstructorUserLastName');
    InstructorUserIsActive = new DwItemAttribute('dw_User', 'InstructorUserIsActive');
    DwroMediaMediaPath = new DwItemAttribute('dw_roMedia', 'DwroMediaMediaPath');
    StudentStatFlightSchoolId = new DwItemAttribute('roSchoolCourseEnrollmentStats', 'StudentStatFlightSchoolId');
    StudentStatFlightSchoolName = new DwItemAttribute('roSchoolCourseEnrollmentStats', 'StudentStatFlightSchoolName');
    StudentStatCourseId = new DwItemAttribute('roSchoolCourseEnrollmentStats', 'StudentStatCourseId');
    StudentStatCourseName = new DwItemAttribute('roSchoolCourseEnrollmentStats', 'StudentStatCourseName');
    StudentStatStudentId = new DwItemAttribute('roSchoolCourseEnrollmentStats', 'StudentStatStudentId');
    StudentStatStudentIdDisplay = new DwItemAttribute('roSchoolCourseEnrollmentStats', 'StudentStatStudentIdDisplay');
    StudentStatUserId = new DwItemAttribute('roSchoolCourseEnrollmentStats', 'StudentStatUserId');
    StudentStatStudentName = new DwItemAttribute('roSchoolCourseEnrollmentStats', 'StudentStatStudentName');
    StudentStatLastActivityDateTime = new DwItemAttribute('roSchoolCourseEnrollmentStats', 'StudentStatLastActivityDateTime');
    StudentStatPercentComplete = new DwItemAttribute('roSchoolCourseEnrollmentStats', 'StudentStatPercentComplete');
    StudentStatTotalTimeSeconds = new DwItemAttribute('roSchoolCourseEnrollmentStats', 'StudentStatTotalTimeSeconds');
    StudentStatCompletedDateTime = new DwItemAttribute('roSchoolCourseEnrollmentStats', 'StudentStatCompletedDateTime');
    StudentStatFirstActivityDateTime = new DwItemAttribute('roSchoolCourseEnrollmentStats', 'StudentStatFirstActivityDateTime');
    StudentStatActiveStudent = new DwItemAttribute('roSchoolCourseEnrollmentStats', 'StudentStatActiveStudent');
    StudentStatIsComplete = new DwItemAttribute('roSchoolCourseEnrollmentStats', 'StudentStatIsComplete');
    StudentStatInProgressTotalTimeSeconds = new DwItemAttribute('roSchoolCourseEnrollmentStats', 'StudentStatInProgressTotalTimeSeconds');
    StudentStatCompletedTotalTimeSeconds = new DwItemAttribute('roSchoolCourseEnrollmentStats', 'StudentStatCompletedTotalTimeSeconds');
    StudentStatInProgressPercentComplete = new DwItemAttribute('roSchoolCourseEnrollmentStats', 'StudentStatInProgressPercentComplete');
    StudentStatAcsTestPassedFirstTime = new DwItemAttribute('roSchoolCourseEnrollmentStats', 'StudentStatAcsTestPassedFirstTime');
    StudentStatAcsTestUploaded = new DwItemAttribute('roSchoolCourseEnrollmentStats', 'StudentStatAcsTestUploaded');
    StudentStatAcsTestPassed = new DwItemAttribute('roSchoolCourseEnrollmentStats', 'StudentStatAcsTestPassed');
    StudentStatAcsAwaitingUpload = new DwItemAttribute('roSchoolCourseEnrollmentStats', 'StudentStatAcsAwaitingUpload');
    StudentStatPastDueAssignments = new DwItemAttribute('roSchoolCourseEnrollmentStats', 'StudentStatPastDueAssignments');
    StudentStatProgressDaysLearningLastActivity = new DwItemAttribute('roSchoolCourseEnrollmentStats', 'StudentStatProgressDaysLearningLastActivity');
    StudentStatProgressPercentPerDayLastActivity = new DwItemAttribute('roSchoolCourseEnrollmentStats', 'StudentStatProgressPercentPerDayLastActivity');
    StudentStatLearningTimePerDayLastActivity = new DwItemAttribute('roSchoolCourseEnrollmentStats', 'StudentStatLearningTimePerDayLastActivity');
    StudentStatProgressDaysLearningNow = new DwItemAttribute('roSchoolCourseEnrollmentStats', 'StudentStatProgressDaysLearningNow');
    StudentStatProgressPercentPerDayNow = new DwItemAttribute('roSchoolCourseEnrollmentStats', 'StudentStatProgressPercentPerDayNow');
    StudentStatLearningTimePerDayNow = new DwItemAttribute('roSchoolCourseEnrollmentStats', 'StudentStatLearningTimePerDayNow');
    StudentStatFirstName = new DwItemAttribute('roSchoolCourseEnrollmentStats', 'StudentStatFirstName');
    StudentStatLastName = new DwItemAttribute('roSchoolCourseEnrollmentStats', 'StudentStatLastName');
    StudentStatMediaPath = new DwItemAttribute('roSchoolCourseEnrollmentStats', 'StudentStatMediaPath');
    StudentStatCreatedDateTime = new DwItemAttribute('roSchoolCourseEnrollmentStats', 'StudentStatCreatedDateTime');
    StudentStatStudentCourseId = new DwItemAttribute('roSchoolCourseEnrollmentStats', 'StudentStatStudentCourseId');
    StudentStatAcsTestAverageScore = new DwItemAttribute('roSchoolCourseEnrollmentStats', 'StudentStatAcsTestAverageScore');
    StudentStatHideInReporting = new DwItemAttribute('roSchoolCourseEnrollmentStats', 'StudentStatHideInReporting');
}
export class UsersManageUsersCourseProgressGridQueryMetaData implements DwItem2<UsersManageUsersCourseProgressGridQueryEntity, UsersManageUsersCourseProgressGridQueryMetaDataAttributes,DwUserMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Users-Manage-Users-Course-Progress-Grid';

    constructor() {
        this.ItemDetail.itemId=46;
        this.ItemDetail.itemName='dw_User';
        this.ItemDetail.keyName='UserId';
    }

    CreateEntity(): UsersManageUsersCourseProgressGridQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): UsersManageUsersCourseProgressGridQueryBuilder {
        return new DwQueryBuilderGen<UsersManageUsersCourseProgressGridQueryEntity, UsersManageUsersCourseProgressGridQueryMetaDataAttributes,DwUserMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<UsersManageUsersCourseProgressGridQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: UsersManageUsersCourseProgressGridQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<UsersManageUsersCourseProgressGridQueryEntity, UsersManageUsersCourseProgressGridQueryMetaDataAttributes,DwUserMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new UsersManageUsersCourseProgressGridQueryMetaDataAttributes();
     Relations = new DwUserMetaDataRelations();

}


export type UsersManageUsersCourseProgressGridQueryBuilder = DwQueryBuilderGen<UsersManageUsersCourseProgressGridQueryEntity, UsersManageUsersCourseProgressGridQueryMetaDataAttributes,DwUserMetaDataRelations>


export class UsersManageUsersCourseProgressGridQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_User';
    // Attributes
    AlternateName = new DwItemAttribute(this.i, 'AlternateName');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedByDisplay = new DwItemAttribute(this.i, 'CreatedByDisplay');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    Email = new DwItemAttribute(this.i, 'Email');
    FirstName = new DwItemAttribute(this.i, 'FirstName');
    ForcePasswordChange = new DwItemAttribute(this.i, 'ForcePasswordChange');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    IsEmailVerified = new DwItemAttribute(this.i, 'IsEmailVerified');
    IsTwoFactorAuthenticationEnabled = new DwItemAttribute(this.i, 'IsTwoFactorAuthenticationEnabled');
    LastLoginDateTime = new DwItemAttribute(this.i, 'LastLoginDateTime');
    LastName = new DwItemAttribute(this.i, 'LastName');
    LastPasswordChangeDateTime = new DwItemAttribute(this.i, 'LastPasswordChangeDateTime');
    MobilePhone = new DwItemAttribute(this.i, 'MobilePhone');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedByDisplay = new DwItemAttribute(this.i, 'ModifiedByDisplay');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    OrganizationId = new DwItemAttribute(this.i, 'OrganizationId');
    OrganizationIdDisplay = new DwItemAttribute(this.i, 'OrganizationIdDisplay');
    PartyReferenceId = new DwItemAttribute(this.i, 'PartyReferenceId');
    PartyReferenceIdDisplay = new DwItemAttribute(this.i, 'PartyReferenceIdDisplay');
    TwoFactorAuthenticationTypeId = new DwItemAttribute(this.i, 'TwoFactorAuthenticationTypeId');
    TwoFactorAuthenticationTypeIdDisplay = new DwItemAttribute(this.i, 'TwoFactorAuthenticationTypeIdDisplay');
    UserBackgroundMediaId = new DwItemAttribute(this.i, 'UserBackgroundMediaId');
    UserBackgroundMediaIdDisplay = new DwItemAttribute(this.i, 'UserBackgroundMediaIdDisplay');
    UserId = new DwItemAttribute(this.i, 'UserId');
    UserKey = new DwItemAttribute(this.i, 'UserKey');
    UserName = new DwItemAttribute(this.i, 'UserName');
    UserPictureMediaId = new DwItemAttribute(this.i, 'UserPictureMediaId');
    UserPictureMediaIdDisplay = new DwItemAttribute(this.i, 'UserPictureMediaIdDisplay');
    UserTypeId = new DwItemAttribute(this.i, 'UserTypeId');
    UserTypeIdDisplay = new DwItemAttribute(this.i, 'UserTypeIdDisplay');
    Password = new DwItemAttribute(this.i, 'Password');
    Roles = new DwItemAttribute(this.i, 'Roles');
    UserDetailUserDetailId = new DwItemAttribute('UserDetail', 'UserDetailUserDetailId');
    UserDetailFlightSchoolId = new DwItemAttribute('UserDetail', 'UserDetailFlightSchoolId');
    UserDetailFlightSchoolIdDisplay = new DwItemAttribute('UserDetail', 'UserDetailFlightSchoolIdDisplay');
    UserDetailUserId = new DwItemAttribute('UserDetail', 'UserDetailUserId');
    UserDetailUserIdDisplay = new DwItemAttribute('UserDetail', 'UserDetailUserIdDisplay');
    StudentStudentId = new DwItemAttribute('Student', 'StudentStudentId');
    Groups = new DwItemAttribute('Student', 'Groups');
    Courses = new DwItemAttribute('Student', 'Courses');
    AssignmentInstructor = new DwItemAttribute('Student', 'AssignmentInstructor');
    StudentCourseStudentCourseId = new DwItemAttribute('StudentCourse', 'StudentCourseStudentCourseId');
    StudentCourseStudentId = new DwItemAttribute('StudentCourse', 'StudentCourseStudentId');
    StudentCourseStudentIdDisplay = new DwItemAttribute('StudentCourse', 'StudentCourseStudentIdDisplay');
    StudentCourseCourseId = new DwItemAttribute('StudentCourse', 'StudentCourseCourseId');
    StudentCourseCourseIdDisplay = new DwItemAttribute('StudentCourse', 'StudentCourseCourseIdDisplay');
    StudentCourseIsActive = new DwItemAttribute('StudentCourse', 'StudentCourseIsActive');
    StudentCoursePercentComplete = new DwItemAttribute('StudentCourse', 'StudentCoursePercentComplete');
    StudentCourseModulesCompleted = new DwItemAttribute('StudentCourse', 'StudentCourseModulesCompleted');
    StudentCourseModulesCount = new DwItemAttribute('StudentCourse', 'StudentCourseModulesCount');
    StudentCourseLastActivityDateTime = new DwItemAttribute('StudentCourse', 'StudentCourseLastActivityDateTime');
    StudentCourseLessonsCompleted = new DwItemAttribute('StudentCourse', 'StudentCourseLessonsCompleted');
    StudentCourseLessonCount = new DwItemAttribute('StudentCourse', 'StudentCourseLessonCount');
    StudentCourseTotalTimeSeconds = new DwItemAttribute('StudentCourse', 'StudentCourseTotalTimeSeconds');
    StudentCourseFirstActivityDateTime = new DwItemAttribute('StudentCourse', 'StudentCourseFirstActivityDateTime');
    StudentCourseCompletedDateTime = new DwItemAttribute('StudentCourse', 'StudentCourseCompletedDateTime');
    StudentCourseCreatedBy = new DwItemAttribute('StudentCourse', 'StudentCourseCreatedBy');
    StudentCourseCreatedByDisplay = new DwItemAttribute('StudentCourse', 'StudentCourseCreatedByDisplay');
    StudentCourseCreatedDateTime = new DwItemAttribute('StudentCourse', 'StudentCourseCreatedDateTime');
    StudentCourseModifiedBy = new DwItemAttribute('StudentCourse', 'StudentCourseModifiedBy');
    StudentCourseModifiedByDisplay = new DwItemAttribute('StudentCourse', 'StudentCourseModifiedByDisplay');
    StudentCourseModifiedDateTime = new DwItemAttribute('StudentCourse', 'StudentCourseModifiedDateTime');
    StudentCourseStudentCourseStatusId = new DwItemAttribute('StudentCourse', 'StudentCourseStudentCourseStatusId');
    StudentCourseStudentCourseStatusIdDisplay = new DwItemAttribute('StudentCourse', 'StudentCourseStudentCourseStatusIdDisplay');
    StudentCourseIsEndorsed = new DwItemAttribute('StudentCourse', 'StudentCourseIsEndorsed');
    StudentCourseTotalVideoTimeSeconds = new DwItemAttribute('StudentCourse', 'StudentCourseTotalVideoTimeSeconds');
    StudentCourseTotalQuizTimeSeconds = new DwItemAttribute('StudentCourse', 'StudentCourseTotalQuizTimeSeconds');
    StudentCourseNextCourseLessonId = new DwItemAttribute('StudentCourse', 'StudentCourseNextCourseLessonId');
    StudentCourseNextCourseLessonIdDisplay = new DwItemAttribute('StudentCourse', 'StudentCourseNextCourseLessonIdDisplay');
    StudentCourseAcsTestPassedFirstTime = new DwItemAttribute('StudentCourse', 'StudentCourseAcsTestPassedFirstTime');
    StudentCourseAcsTestUploaded = new DwItemAttribute('StudentCourse', 'StudentCourseAcsTestUploaded');
    StudentCourseAcsTestPassed = new DwItemAttribute('StudentCourse', 'StudentCourseAcsTestPassed');
    StudentCourseHideInReporting = new DwItemAttribute('StudentCourse', 'StudentCourseHideInReporting');
    StudentCourseAcsTestLastScore = new DwItemAttribute('StudentCourse', 'StudentCourseAcsTestLastScore');
    StudentCourseProgressStatusStudentCourseProgressStatusId = new DwItemAttribute('StudentCourseProgressStatus', 'StudentCourseProgressStatusStudentCourseProgressStatusId');
    StudentCourseProgressStatusProgressStatusKey = new DwItemAttribute('StudentCourseProgressStatus', 'StudentCourseProgressStatusProgressStatusKey');
    StudentCourseProgressStatusProgressStatusName = new DwItemAttribute('StudentCourseProgressStatus', 'StudentCourseProgressStatusProgressStatusName');
    StudentCourseProgressStatusProgressStatusCssClass = new DwItemAttribute('StudentCourseProgressStatus', 'StudentCourseProgressStatusProgressStatusCssClass');
    StudentCourseProgressStatusSortOrder = new DwItemAttribute('StudentCourseProgressStatus', 'StudentCourseProgressStatusSortOrder');
    DwroMediaMediaPath = new DwItemAttribute('dw_roMedia', 'DwroMediaMediaPath');
    RoUserRoleDetailIsStudent = new DwItemAttribute('roUserRoleDetail', 'RoUserRoleDetailIsStudent');
    RoUserRoleDetailIsInstructor = new DwItemAttribute('roUserRoleDetail', 'RoUserRoleDetailIsInstructor');
    RoUserRoleDetailIsLeadInstructor = new DwItemAttribute('roUserRoleDetail', 'RoUserRoleDetailIsLeadInstructor');
    RoUserRoleDetailIsFlightSchoolAdmin = new DwItemAttribute('roUserRoleDetail', 'RoUserRoleDetailIsFlightSchoolAdmin');
    RoUserRoleDetailIsFlightSchool = new DwItemAttribute('roUserRoleDetail', 'RoUserRoleDetailIsFlightSchool');
}
export class DocumentItemStudentAcknowledgementQueryMetaData implements DwItem2<DocumentItemStudentAcknowledgementQueryEntity, DocumentItemStudentAcknowledgementQueryMetaDataAttributes,DocumentItemMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Document_Item-Student_Acknowledgement';

    constructor() {
        this.ItemDetail.itemId=373;
        this.ItemDetail.itemName='DocumentItem';
        this.ItemDetail.keyName='DocumentItemId';
    }

    CreateEntity(): DocumentItemStudentAcknowledgementQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): DocumentItemStudentAcknowledgementQueryBuilder {
        return new DwQueryBuilderGen<DocumentItemStudentAcknowledgementQueryEntity, DocumentItemStudentAcknowledgementQueryMetaDataAttributes,DocumentItemMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<DocumentItemStudentAcknowledgementQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: DocumentItemStudentAcknowledgementQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<DocumentItemStudentAcknowledgementQueryEntity, DocumentItemStudentAcknowledgementQueryMetaDataAttributes,DocumentItemMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new DocumentItemStudentAcknowledgementQueryMetaDataAttributes();
     Relations = new DocumentItemMetaDataRelations();

}


export type DocumentItemStudentAcknowledgementQueryBuilder = DwQueryBuilderGen<DocumentItemStudentAcknowledgementQueryEntity, DocumentItemStudentAcknowledgementQueryMetaDataAttributes,DocumentItemMetaDataRelations>


export class DocumentItemStudentAcknowledgementQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'DocumentItem';
    // Attributes
    DocumentItemId = new DwItemAttribute(this.i, 'DocumentItemId');
    DocumentGroupId = new DwItemAttribute(this.i, 'DocumentGroupId');
    DocumentGroupIdDisplay = new DwItemAttribute(this.i, 'DocumentGroupIdDisplay');
    DocumentItemName = new DwItemAttribute(this.i, 'DocumentItemName');
    MediaId = new DwItemAttribute(this.i, 'MediaId');
    MediaIdDisplay = new DwItemAttribute(this.i, 'MediaIdDisplay');
    CardIconMediaId = new DwItemAttribute(this.i, 'CardIconMediaId');
    CardIconMediaIdDisplay = new DwItemAttribute(this.i, 'CardIconMediaIdDisplay');
    DocumentTypeId = new DwItemAttribute(this.i, 'DocumentTypeId');
    DocumentTypeIdDisplay = new DwItemAttribute(this.i, 'DocumentTypeIdDisplay');
    DocumentItemStatusId = new DwItemAttribute(this.i, 'DocumentItemStatusId');
    DocumentItemStatusIdDisplay = new DwItemAttribute(this.i, 'DocumentItemStatusIdDisplay');
    EmbeddedMarkup = new DwItemAttribute(this.i, 'EmbeddedMarkup');
    ExtractedImageMediaId = new DwItemAttribute(this.i, 'ExtractedImageMediaId');
    ExtractedImageMediaIdDisplay = new DwItemAttribute(this.i, 'ExtractedImageMediaIdDisplay');
    UseCustomCardIcon = new DwItemAttribute(this.i, 'UseCustomCardIcon');
    DocumentOwnershipTypeId = new DwItemAttribute(this.i, 'DocumentOwnershipTypeId');
    DocumentOwnershipTypeIdDisplay = new DwItemAttribute(this.i, 'DocumentOwnershipTypeIdDisplay');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    FlightSchoolIdDisplay = new DwItemAttribute(this.i, 'FlightSchoolIdDisplay');
    ParentDocumentFolderId = new DwItemAttribute(this.i, 'ParentDocumentFolderId');
    ParentDocumentFolderIdDisplay = new DwItemAttribute(this.i, 'ParentDocumentFolderIdDisplay');
    RequireStudentAcknowledgement = new DwItemAttribute(this.i, 'RequireStudentAcknowledgement');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedByDisplay = new DwItemAttribute(this.i, 'CreatedByDisplay');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedByDisplay = new DwItemAttribute(this.i, 'ModifiedByDisplay');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    AiProcessingReferenceId = new DwItemAttribute(this.i, 'AiProcessingReferenceId');
    DocumentFileHash = new DwItemAttribute(this.i, 'DocumentFileHash');
    DocumentAiComplete = new DwItemAttribute(this.i, 'DocumentAiComplete');
    DocumentAiProcessingStatusId = new DwItemAttribute(this.i, 'DocumentAiProcessingStatusId');
    DocumentAiProcessingStatusIdDisplay = new DwItemAttribute(this.i, 'DocumentAiProcessingStatusIdDisplay');
    DocumentAiProcessingProgressText = new DwItemAttribute(this.i, 'DocumentAiProcessingProgressText');
    DocumentAiProcessingErrorText = new DwItemAttribute(this.i, 'DocumentAiProcessingErrorText');
    DocumentAiProcessingStartDateTime = new DwItemAttribute(this.i, 'DocumentAiProcessingStartDateTime');
    DocumentAiProcessingCompletedDateTime = new DwItemAttribute(this.i, 'DocumentAiProcessingCompletedDateTime');
    DocumentAiProcessingLastUpdatedDateTime = new DwItemAttribute(this.i, 'DocumentAiProcessingLastUpdatedDateTime');
    DocumentAiProcessingEstimatedCompletedDateTime = new DwItemAttribute(this.i, 'DocumentAiProcessingEstimatedCompletedDateTime');
    DocumentAiProcessingTotalChunkCount = new DwItemAttribute(this.i, 'DocumentAiProcessingTotalChunkCount');
    DocumentAiProcessingProcessedChunkCount = new DwItemAttribute(this.i, 'DocumentAiProcessingProcessedChunkCount');
    DocumentAiProcessingFailedChunkCount = new DwItemAttribute(this.i, 'DocumentAiProcessingFailedChunkCount');
    DocumentAiProcessingTotalModuleLinkCount = new DwItemAttribute(this.i, 'DocumentAiProcessingTotalModuleLinkCount');
    DocumentAiProcessingProcessedModuleLinkCount = new DwItemAttribute(this.i, 'DocumentAiProcessingProcessedModuleLinkCount');
    DocumentAiProcessingFailedModuleLinkCount = new DwItemAttribute(this.i, 'DocumentAiProcessingFailedModuleLinkCount');
    DocumentItemAcknowledgementStudentId = new DwItemAttribute('DocumentItemAcknowledgement', 'DocumentItemAcknowledgementStudentId');
    DocumentItemAcknowledgementStudentIdDisplay = new DwItemAttribute('DocumentItemAcknowledgement', 'DocumentItemAcknowledgementStudentIdDisplay');
    DocumentItemAcknowledgementAcknowledgedDateTime = new DwItemAttribute('DocumentItemAcknowledgement', 'DocumentItemAcknowledgementAcknowledgedDateTime');
    DocumentItemAcknowledgementDocumentItemId = new DwItemAttribute('DocumentItemAcknowledgement', 'DocumentItemAcknowledgementDocumentItemId');
    DocumentItemAcknowledgementDocumentItemIdDisplay = new DwItemAttribute('DocumentItemAcknowledgement', 'DocumentItemAcknowledgementDocumentItemIdDisplay');
    DocumentItemAcknowledgementDocumentItemAcknowledgementId = new DwItemAttribute('DocumentItemAcknowledgement', 'DocumentItemAcknowledgementDocumentItemAcknowledgementId');
}
export class ManageUsersQueryMetaData implements DwItem2<ManageUsersQueryEntity, ManageUsersQueryMetaDataAttributes,DwUserMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Manage_Users';

    constructor() {
        this.ItemDetail.itemId=46;
        this.ItemDetail.itemName='dw_User';
        this.ItemDetail.keyName='UserId';
    }

    CreateEntity(): ManageUsersQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): ManageUsersQueryBuilder {
        return new DwQueryBuilderGen<ManageUsersQueryEntity, ManageUsersQueryMetaDataAttributes,DwUserMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<ManageUsersQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: ManageUsersQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<ManageUsersQueryEntity, ManageUsersQueryMetaDataAttributes,DwUserMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new ManageUsersQueryMetaDataAttributes();
     Relations = new DwUserMetaDataRelations();

}


export type ManageUsersQueryBuilder = DwQueryBuilderGen<ManageUsersQueryEntity, ManageUsersQueryMetaDataAttributes,DwUserMetaDataRelations>


export class ManageUsersQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'dw_User';
    // Attributes
    AlternateName = new DwItemAttribute(this.i, 'AlternateName');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedByDisplay = new DwItemAttribute(this.i, 'CreatedByDisplay');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    Email = new DwItemAttribute(this.i, 'Email');
    FirstName = new DwItemAttribute(this.i, 'FirstName');
    ForcePasswordChange = new DwItemAttribute(this.i, 'ForcePasswordChange');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    IsEmailVerified = new DwItemAttribute(this.i, 'IsEmailVerified');
    IsTwoFactorAuthenticationEnabled = new DwItemAttribute(this.i, 'IsTwoFactorAuthenticationEnabled');
    LastLoginDateTime = new DwItemAttribute(this.i, 'LastLoginDateTime');
    LastName = new DwItemAttribute(this.i, 'LastName');
    LastPasswordChangeDateTime = new DwItemAttribute(this.i, 'LastPasswordChangeDateTime');
    MobilePhone = new DwItemAttribute(this.i, 'MobilePhone');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedByDisplay = new DwItemAttribute(this.i, 'ModifiedByDisplay');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    OrganizationId = new DwItemAttribute(this.i, 'OrganizationId');
    OrganizationIdDisplay = new DwItemAttribute(this.i, 'OrganizationIdDisplay');
    PartyReferenceId = new DwItemAttribute(this.i, 'PartyReferenceId');
    PartyReferenceIdDisplay = new DwItemAttribute(this.i, 'PartyReferenceIdDisplay');
    TwoFactorAuthenticationTypeId = new DwItemAttribute(this.i, 'TwoFactorAuthenticationTypeId');
    TwoFactorAuthenticationTypeIdDisplay = new DwItemAttribute(this.i, 'TwoFactorAuthenticationTypeIdDisplay');
    UserBackgroundMediaId = new DwItemAttribute(this.i, 'UserBackgroundMediaId');
    UserBackgroundMediaIdDisplay = new DwItemAttribute(this.i, 'UserBackgroundMediaIdDisplay');
    UserId = new DwItemAttribute(this.i, 'UserId');
    UserKey = new DwItemAttribute(this.i, 'UserKey');
    UserName = new DwItemAttribute(this.i, 'UserName');
    UserPictureMediaId = new DwItemAttribute(this.i, 'UserPictureMediaId');
    UserPictureMediaIdDisplay = new DwItemAttribute(this.i, 'UserPictureMediaIdDisplay');
    UserTypeId = new DwItemAttribute(this.i, 'UserTypeId');
    UserTypeIdDisplay = new DwItemAttribute(this.i, 'UserTypeIdDisplay');
    Password = new DwItemAttribute(this.i, 'Password');
    Roles = new DwItemAttribute(this.i, 'Roles');
    UserFullName = new DwItemAttribute(this.i, 'UserFullName');
    UserDetailUserDetailId = new DwItemAttribute('UserDetail', 'UserDetailUserDetailId');
    UserDetailFlightSchoolId = new DwItemAttribute('UserDetail', 'UserDetailFlightSchoolId');
    UserDetailFlightSchoolIdDisplay = new DwItemAttribute('UserDetail', 'UserDetailFlightSchoolIdDisplay');
    UserDetailUserId = new DwItemAttribute('UserDetail', 'UserDetailUserId');
    UserDetailUserIdDisplay = new DwItemAttribute('UserDetail', 'UserDetailUserIdDisplay');
    StudentStudentId = new DwItemAttribute('Student', 'StudentStudentId');
    Groups = new DwItemAttribute('Student', 'Groups');
    Courses = new DwItemAttribute('Student', 'Courses');
    AssignmentInstructor = new DwItemAttribute('Student', 'AssignmentInstructor');
    DwroMediaMediaPath = new DwItemAttribute('dw_roMedia', 'DwroMediaMediaPath');
    RoUserRoleDetailIsStudent = new DwItemAttribute('roUserRoleDetail', 'RoUserRoleDetailIsStudent');
    RoUserRoleDetailIsInstructor = new DwItemAttribute('roUserRoleDetail', 'RoUserRoleDetailIsInstructor');
    RoUserRoleDetailIsLeadInstructor = new DwItemAttribute('roUserRoleDetail', 'RoUserRoleDetailIsLeadInstructor');
    RoUserRoleDetailIsFlightSchoolAdmin = new DwItemAttribute('roUserRoleDetail', 'RoUserRoleDetailIsFlightSchoolAdmin');
    RoUserRoleDetailIsFlightSchool = new DwItemAttribute('roUserRoleDetail', 'RoUserRoleDetailIsFlightSchool');
}
export class AssignmentStudentGridQueryMetaData implements DwItem2<AssignmentStudentGridQueryEntity, AssignmentStudentGridQueryMetaDataAttributes,AssignmentStudentMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Assignment_Student-Grid';

    constructor() {
        this.ItemDetail.itemId=191;
        this.ItemDetail.itemName='AssignmentStudent';
        this.ItemDetail.keyName='AssignmentStudentId';
    }

    CreateEntity(): AssignmentStudentGridQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): AssignmentStudentGridQueryBuilder {
        return new DwQueryBuilderGen<AssignmentStudentGridQueryEntity, AssignmentStudentGridQueryMetaDataAttributes,AssignmentStudentMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<AssignmentStudentGridQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: AssignmentStudentGridQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<AssignmentStudentGridQueryEntity, AssignmentStudentGridQueryMetaDataAttributes,AssignmentStudentMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new AssignmentStudentGridQueryMetaDataAttributes();
     Relations = new AssignmentStudentMetaDataRelations();

}


export type AssignmentStudentGridQueryBuilder = DwQueryBuilderGen<AssignmentStudentGridQueryEntity, AssignmentStudentGridQueryMetaDataAttributes,AssignmentStudentMetaDataRelations>


export class AssignmentStudentGridQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'AssignmentStudent';
    // Attributes
    AssignmentStudentId = new DwItemAttribute(this.i, 'AssignmentStudentId');
    AssignmentId = new DwItemAttribute(this.i, 'AssignmentId');
    AssignmentIdDisplay = new DwItemAttribute(this.i, 'AssignmentIdDisplay');
    StudentId = new DwItemAttribute(this.i, 'StudentId');
    StudentIdDisplay = new DwItemAttribute(this.i, 'StudentIdDisplay');
    PercentComplete = new DwItemAttribute(this.i, 'PercentComplete');
    CompletedDateTime = new DwItemAttribute(this.i, 'CompletedDateTime');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedByDisplay = new DwItemAttribute(this.i, 'CreatedByDisplay');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedByDisplay = new DwItemAttribute(this.i, 'ModifiedByDisplay');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    Acknowledged = new DwItemAttribute(this.i, 'Acknowledged');
    AcknowledgedDateTime = new DwItemAttribute(this.i, 'AcknowledgedDateTime');
    AiPromptRequestId = new DwItemAttribute(this.i, 'AiPromptRequestId');
    AiPromptRequestIdDisplay = new DwItemAttribute(this.i, 'AiPromptRequestIdDisplay');
    ShowAISummary = new DwItemAttribute(this.i, 'ShowAISummary');
    AssignmentAssignmentId = new DwItemAttribute('Assignment', 'AssignmentAssignmentId');
    AssignmentCourseId = new DwItemAttribute('Assignment', 'AssignmentCourseId');
    AssignmentCourseIdDisplay = new DwItemAttribute('Assignment', 'AssignmentCourseIdDisplay');
    AssignmentAssignmentDescription = new DwItemAttribute('Assignment', 'AssignmentAssignmentDescription');
    AssignmentAssignedDateTime = new DwItemAttribute('Assignment', 'AssignmentAssignedDateTime');
    AssignmentDueDateTime = new DwItemAttribute('Assignment', 'AssignmentDueDateTime');
    AssignmentCompletedDateTime = new DwItemAttribute('Assignment', 'AssignmentCompletedDateTime');
    AssignmentAssignmentTypeId = new DwItemAttribute('Assignment', 'AssignmentAssignmentTypeId');
    AssignmentAssignmentTypeIdDisplay = new DwItemAttribute('Assignment', 'AssignmentAssignmentTypeIdDisplay');
    AssignmentAssignmentStatusId = new DwItemAttribute('Assignment', 'AssignmentAssignmentStatusId');
    AssignmentAssignmentStatusIdDisplay = new DwItemAttribute('Assignment', 'AssignmentAssignmentStatusIdDisplay');
    AssignmentAssignmentLinkUrl = new DwItemAttribute('Assignment', 'AssignmentAssignmentLinkUrl');
    AssignmentFlightSchoolGroupId = new DwItemAttribute('Assignment', 'AssignmentFlightSchoolGroupId');
    AssignmentFlightSchoolGroupIdDisplay = new DwItemAttribute('Assignment', 'AssignmentFlightSchoolGroupIdDisplay');
    AssignmentFlightSchoolId = new DwItemAttribute('Assignment', 'AssignmentFlightSchoolId');
    AssignmentFlightSchoolIdDisplay = new DwItemAttribute('Assignment', 'AssignmentFlightSchoolIdDisplay');
    Lessons = new DwItemAttribute('Assignment', 'Lessons');
    RoAssignmentStudentCompletedDetailsCompletedOnTime = new DwItemAttribute('roAssignmentStudentCompletedDetails', 'RoAssignmentStudentCompletedDetailsCompletedOnTime');
}
export class AssignmentWithStudentGridQueryMetaData implements DwItem2<AssignmentWithStudentGridQueryEntity, AssignmentWithStudentGridQueryMetaDataAttributes,AssignmentMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Assignment-With_Student-Grid';

    constructor() {
        this.ItemDetail.itemId=188;
        this.ItemDetail.itemName='Assignment';
        this.ItemDetail.keyName='AssignmentId';
    }

    CreateEntity(): AssignmentWithStudentGridQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): AssignmentWithStudentGridQueryBuilder {
        return new DwQueryBuilderGen<AssignmentWithStudentGridQueryEntity, AssignmentWithStudentGridQueryMetaDataAttributes,AssignmentMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<AssignmentWithStudentGridQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: AssignmentWithStudentGridQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<AssignmentWithStudentGridQueryEntity, AssignmentWithStudentGridQueryMetaDataAttributes,AssignmentMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new AssignmentWithStudentGridQueryMetaDataAttributes();
     Relations = new AssignmentMetaDataRelations();

}


export type AssignmentWithStudentGridQueryBuilder = DwQueryBuilderGen<AssignmentWithStudentGridQueryEntity, AssignmentWithStudentGridQueryMetaDataAttributes,AssignmentMetaDataRelations>


export class AssignmentWithStudentGridQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Assignment';
    // Attributes
    AssignmentId = new DwItemAttribute(this.i, 'AssignmentId');
    CourseId = new DwItemAttribute(this.i, 'CourseId');
    CourseIdDisplay = new DwItemAttribute(this.i, 'CourseIdDisplay');
    AssignmentDescription = new DwItemAttribute(this.i, 'AssignmentDescription');
    AssignmentTypeId = new DwItemAttribute(this.i, 'AssignmentTypeId');
    AssignmentTypeIdDisplay = new DwItemAttribute(this.i, 'AssignmentTypeIdDisplay');
    AssignmentStatusId = new DwItemAttribute(this.i, 'AssignmentStatusId');
    AssignmentStatusIdDisplay = new DwItemAttribute(this.i, 'AssignmentStatusIdDisplay');
    AssignmentLinkUrl = new DwItemAttribute(this.i, 'AssignmentLinkUrl');
    MediaId = new DwItemAttribute(this.i, 'MediaId');
    DueDateTime = new DwItemAttribute(this.i, 'DueDateTime');
    FlightSchoolGroupId = new DwItemAttribute(this.i, 'FlightSchoolGroupId');
    FlightSchoolGroupIdDisplay = new DwItemAttribute(this.i, 'FlightSchoolGroupIdDisplay');
    AssignedDateTime = new DwItemAttribute(this.i, 'AssignedDateTime');
    CompletedDateTime = new DwItemAttribute(this.i, 'CompletedDateTime');
    FlightSchoolId = new DwItemAttribute(this.i, 'FlightSchoolId');
    FlightSchoolIdDisplay = new DwItemAttribute(this.i, 'FlightSchoolIdDisplay');
    ResetLessonProgress = new DwItemAttribute(this.i, 'ResetLessonProgress');
    UseGroupAssignment = new DwItemAttribute(this.i, 'UseGroupAssignment');
    InstructorId = new DwItemAttribute(this.i, 'InstructorId');
    InstructorIdDisplay = new DwItemAttribute(this.i, 'InstructorIdDisplay');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    CreatedByDisplay = new DwItemAttribute(this.i, 'CreatedByDisplay');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    ModifiedByDisplay = new DwItemAttribute(this.i, 'ModifiedByDisplay');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    Students = new DwItemAttribute(this.i, 'Students');
    RoAssignmentStudentStatActivePercent = new DwItemAttribute('roAssignmentStudentStat', 'RoAssignmentStudentStatActivePercent');
    RoAssignmentStudentStatAssignmentId = new DwItemAttribute('roAssignmentStudentStat', 'RoAssignmentStudentStatAssignmentId');
    RoAssignmentStudentStatAssignmentIdDisplay = new DwItemAttribute('roAssignmentStudentStat', 'RoAssignmentStudentStatAssignmentIdDisplay');
    RoAssignmentStudentStatCompletedPercent = new DwItemAttribute('roAssignmentStudentStat', 'RoAssignmentStudentStatCompletedPercent');
    RoAssignmentStudentStatIncompletePercent = new DwItemAttribute('roAssignmentStudentStat', 'RoAssignmentStudentStatIncompletePercent');
    RoAssignmentStudentStatPastDuePercent = new DwItemAttribute('roAssignmentStudentStat', 'RoAssignmentStudentStatPastDuePercent');
    RoAssignmentStudentStatStudentActiveCount = new DwItemAttribute('roAssignmentStudentStat', 'RoAssignmentStudentStatStudentActiveCount');
    RoAssignmentStudentStatStudentCompleteCount = new DwItemAttribute('roAssignmentStudentStat', 'RoAssignmentStudentStatStudentCompleteCount');
    RoAssignmentStudentStatStudentCount = new DwItemAttribute('roAssignmentStudentStat', 'RoAssignmentStudentStatStudentCount');
    RoAssignmentStudentStatStudentIncompleteCount = new DwItemAttribute('roAssignmentStudentStat', 'RoAssignmentStudentStatStudentIncompleteCount');
    RoAssignmentStudentStatStudentPastDueCount = new DwItemAttribute('roAssignmentStudentStat', 'RoAssignmentStudentStatStudentPastDueCount');
}
export class CourseModuleDocumentWithAIProcessingStatusQueryMetaData implements DwItem2<CourseModuleDocumentWithAIProcessingStatusQueryEntity, CourseModuleDocumentWithAIProcessingStatusQueryMetaDataAttributes,CourseModuleDocumentItemMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Course_Module_Document-With_AI_Processing_Status';

    constructor() {
        this.ItemDetail.itemId=404;
        this.ItemDetail.itemName='CourseModuleDocumentItem';
        this.ItemDetail.keyName='CourseModuleDocumentItemId';
    }

    CreateEntity(): CourseModuleDocumentWithAIProcessingStatusQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): CourseModuleDocumentWithAIProcessingStatusQueryBuilder {
        return new DwQueryBuilderGen<CourseModuleDocumentWithAIProcessingStatusQueryEntity, CourseModuleDocumentWithAIProcessingStatusQueryMetaDataAttributes,CourseModuleDocumentItemMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<CourseModuleDocumentWithAIProcessingStatusQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: CourseModuleDocumentWithAIProcessingStatusQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<CourseModuleDocumentWithAIProcessingStatusQueryEntity, CourseModuleDocumentWithAIProcessingStatusQueryMetaDataAttributes,CourseModuleDocumentItemMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new CourseModuleDocumentWithAIProcessingStatusQueryMetaDataAttributes();
     Relations = new CourseModuleDocumentItemMetaDataRelations();

}


export type CourseModuleDocumentWithAIProcessingStatusQueryBuilder = DwQueryBuilderGen<CourseModuleDocumentWithAIProcessingStatusQueryEntity, CourseModuleDocumentWithAIProcessingStatusQueryMetaDataAttributes,CourseModuleDocumentItemMetaDataRelations>


export class CourseModuleDocumentWithAIProcessingStatusQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CourseModuleDocumentItem';
    // Attributes
    CourseModuleDocumentItemId = new DwItemAttribute(this.i, 'CourseModuleDocumentItemId');
    CourseModuleId = new DwItemAttribute(this.i, 'CourseModuleId');
    CourseModuleIdDisplay = new DwItemAttribute(this.i, 'CourseModuleIdDisplay');
    CourseDocumentItemId = new DwItemAttribute(this.i, 'CourseDocumentItemId');
    CourseDocumentItemIdDisplay = new DwItemAttribute(this.i, 'CourseDocumentItemIdDisplay');
    AiProcessingReferenceId = new DwItemAttribute(this.i, 'AiProcessingReferenceId');
    AiProcessingReferenceIdDisplay = new DwItemAttribute(this.i, 'AiProcessingReferenceIdDisplay');
    CourseModuleDocumentItemStatusId = new DwItemAttribute(this.i, 'CourseModuleDocumentItemStatusId');
    CourseModuleDocumentItemStatusIdDisplay = new DwItemAttribute(this.i, 'CourseModuleDocumentItemStatusIdDisplay');
    AiProcessingReferenceIdAIProcessingReferenceAIProcessingStatusId = new DwItemAttribute('AIProcessingReference', 'AiProcessingReferenceIdAIProcessingReferenceAIProcessingStatusId');
    AiProcessingReferenceIdAIProcessingReferenceAIProcessingStatusIdDisplay = new DwItemAttribute('AIProcessingReference', 'AiProcessingReferenceIdAIProcessingReferenceAIProcessingStatusIdDisplay');
}
export class StandardLoginMediaWithMediaPathQueryMetaData implements DwItem2<StandardLoginMediaWithMediaPathQueryEntity, StandardLoginMediaWithMediaPathQueryMetaDataAttributes,StandardLoginMediaMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Standard_Login_Media-with_Media_Path';

    constructor() {
        this.ItemDetail.itemId=444;
        this.ItemDetail.itemName='StandardLoginMedia';
        this.ItemDetail.keyName='StandardLoginMediaId';
    }

    CreateEntity(): StandardLoginMediaWithMediaPathQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): StandardLoginMediaWithMediaPathQueryBuilder {
        return new DwQueryBuilderGen<StandardLoginMediaWithMediaPathQueryEntity, StandardLoginMediaWithMediaPathQueryMetaDataAttributes,StandardLoginMediaMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<StandardLoginMediaWithMediaPathQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: StandardLoginMediaWithMediaPathQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<StandardLoginMediaWithMediaPathQueryEntity, StandardLoginMediaWithMediaPathQueryMetaDataAttributes,StandardLoginMediaMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new StandardLoginMediaWithMediaPathQueryMetaDataAttributes();
     Relations = new StandardLoginMediaMetaDataRelations();

}


export type StandardLoginMediaWithMediaPathQueryBuilder = DwQueryBuilderGen<StandardLoginMediaWithMediaPathQueryEntity, StandardLoginMediaWithMediaPathQueryMetaDataAttributes,StandardLoginMediaMetaDataRelations>


export class StandardLoginMediaWithMediaPathQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'StandardLoginMedia';
    // Attributes
    StandardLoginMediaId = new DwItemAttribute(this.i, 'StandardLoginMediaId');
    LoginMediaName = new DwItemAttribute(this.i, 'LoginMediaName');
    MediaId = new DwItemAttribute(this.i, 'MediaId');
    ReferenceStatusId = new DwItemAttribute(this.i, 'ReferenceStatusId');
    IsDefault = new DwItemAttribute(this.i, 'IsDefault');
    DwroMediaMediaName = new DwItemAttribute('dw_roMedia', 'DwroMediaMediaName');
    DwroMediaMediaPath = new DwItemAttribute('dw_roMedia', 'DwroMediaMediaPath');
    DwroMediaImageWidth = new DwItemAttribute('dw_roMedia', 'DwroMediaImageWidth');
    DwroMediaImageHeight = new DwItemAttribute('dw_roMedia', 'DwroMediaImageHeight');
}


// Generated Query Classes for MetaData Service

class MetaDataQueries {
    CourseListForStudent : CourseListForStudentQueryMetaData = new CourseListForStudentQueryMetaData();
    ModuleListForStudent : ModuleListForStudentQueryMetaData = new ModuleListForStudentQueryMetaData();
    LessonListForStudent : LessonListForStudentQueryMetaData = new LessonListForStudentQueryMetaData();
    StudentCourseProgress : StudentCourseProgressQueryMetaData = new StudentCourseProgressQueryMetaData();
    StudentModuleProgress : StudentModuleProgressQueryMetaData = new StudentModuleProgressQueryMetaData();
    StudentLessonProgress : StudentLessonProgressQueryMetaData = new StudentLessonProgressQueryMetaData();
    StudentLesssonProgressNoCount : StudentLesssonProgressNoCountQueryMetaData = new StudentLesssonProgressNoCountQueryMetaData();
    StudentCourseProgressByStudentCourse : StudentCourseProgressByStudentCourseQueryMetaData = new StudentCourseProgressByStudentCourseQueryMetaData();
    StudentModuleLessonActivity : StudentModuleLessonActivityQueryMetaData = new StudentModuleLessonActivityQueryMetaData();
    FlightSchoolGroupWithStudentCourseDetail : FlightSchoolGroupWithStudentCourseDetailQueryMetaData = new FlightSchoolGroupWithStudentCourseDetailQueryMetaData();
    AssignmentStudentLessonSessonGrid : AssignmentStudentLessonSessonGridQueryMetaData = new AssignmentStudentLessonSessonGridQueryMetaData();
    AssignmentLessonWithProgressForStudent : AssignmentLessonWithProgressForStudentQueryMetaData = new AssignmentLessonWithProgressForStudentQueryMetaData();
    AssignmentByStudent : AssignmentByStudentQueryMetaData = new AssignmentByStudentQueryMetaData();
    AssignmentStudentLessonProgressList : AssignmentStudentLessonProgressListQueryMetaData = new AssignmentStudentLessonProgressListQueryMetaData();
    StudentByInstructor : StudentByInstructorQueryMetaData = new StudentByInstructorQueryMetaData();
    StudentBySchool : StudentBySchoolQueryMetaData = new StudentBySchoolQueryMetaData();
    StudentCourseForContext : StudentCourseForContextQueryMetaData = new StudentCourseForContextQueryMetaData();
    JoinRequestDetailsGrid : JoinRequestDetailsGridQueryMetaData = new JoinRequestDetailsGridQueryMetaData();
    CourseListForStudentMarketplace : CourseListForStudentMarketplaceQueryMetaData = new CourseListForStudentMarketplaceQueryMetaData();
    StudentCourseForAssignment : StudentCourseForAssignmentQueryMetaData = new StudentCourseForAssignmentQueryMetaData();
    ProfitSharingTotalsBySchool : ProfitSharingTotalsBySchoolQueryMetaData = new ProfitSharingTotalsBySchoolQueryMetaData();
    SubscriptionTierActive : SubscriptionTierActiveQueryMetaData = new SubscriptionTierActiveQueryMetaData();
    SubscriptionDetails : SubscriptionDetailsQueryMetaData = new SubscriptionDetailsQueryMetaData();
    CourseModuleProgressWithAISummary : CourseModuleProgressWithAISummaryQueryMetaData = new CourseModuleProgressWithAISummaryQueryMetaData();
    AssignmentStudentAcknowledgements : AssignmentStudentAcknowledgementsQueryMetaData = new AssignmentStudentAcknowledgementsQueryMetaData();
    DocumentItemsList : DocumentItemsListQueryMetaData = new DocumentItemsListQueryMetaData();
    FlightSchoolReportsCourseCounts : FlightSchoolReportsCourseCountsQueryMetaData = new FlightSchoolReportsCourseCountsQueryMetaData();
    InstructorLeaderboard : InstructorLeaderboardQueryMetaData = new InstructorLeaderboardQueryMetaData();
    UsersManageUsersCourseProgressGrid : UsersManageUsersCourseProgressGridQueryMetaData = new UsersManageUsersCourseProgressGridQueryMetaData();
    DocumentItemStudentAcknowledgement : DocumentItemStudentAcknowledgementQueryMetaData = new DocumentItemStudentAcknowledgementQueryMetaData();
    ManageUsers : ManageUsersQueryMetaData = new ManageUsersQueryMetaData();
    AssignmentStudentGrid : AssignmentStudentGridQueryMetaData = new AssignmentStudentGridQueryMetaData();
    AssignmentWithStudentGrid : AssignmentWithStudentGridQueryMetaData = new AssignmentWithStudentGridQueryMetaData();
    CourseModuleDocumentWithAIProcessingStatus : CourseModuleDocumentWithAIProcessingStatusQueryMetaData = new CourseModuleDocumentWithAIProcessingStatusQueryMetaData();
    StandardLoginMediaWithMediaPath : StandardLoginMediaWithMediaPathQueryMetaData = new StandardLoginMediaWithMediaPathQueryMetaData();
}

export class AppMetaData {

    static AchievementDefinition : AchievementDefinitionMetaData = new AchievementDefinitionMetaData();
    static AchievementTier : AchievementTierMetaData = new AchievementTierMetaData();
    static AcquisitionSource : AcquisitionSourceMetaData = new AcquisitionSourceMetaData();
    static AcsAreaOfOperation : AcsAreaOfOperationMetaData = new AcsAreaOfOperationMetaData();
    static AcsAreaOfOperationTask : AcsAreaOfOperationTaskMetaData = new AcsAreaOfOperationTaskMetaData();
    static AcsCode : AcsCodeMetaData = new AcsCodeMetaData();
    static AcsCodeType : AcsCodeTypeMetaData = new AcsCodeTypeMetaData();
    static AcsTaskMultiAssign : AcsTaskMultiAssignMetaData = new AcsTaskMultiAssignMetaData();
    static AcsTaskMultiAssignLesson : AcsTaskMultiAssignLessonMetaData = new AcsTaskMultiAssignLessonMetaData();
    static AcsTaskMultiAssignTask : AcsTaskMultiAssignTaskMetaData = new AcsTaskMultiAssignTaskMetaData();
    static AcsTest : AcsTestMetaData = new AcsTestMetaData();
    static AcsTestStatus : AcsTestStatusMetaData = new AcsTestStatusMetaData();
    static AcsWrittenResult : AcsWrittenResultMetaData = new AcsWrittenResultMetaData();
    static AcsWrittenResultMissedCode : AcsWrittenResultMissedCodeMetaData = new AcsWrittenResultMissedCodeMetaData();
    static AcsWrittenTestStatus : AcsWrittenTestStatusMetaData = new AcsWrittenTestStatusMetaData();
    static Address : AddressMetaData = new AddressMetaData();
    static AiProcessConfig : AiProcessConfigMetaData = new AiProcessConfigMetaData();
    static AIProcessingReference : AIProcessingReferenceMetaData = new AIProcessingReferenceMetaData();
    static AIProcessingReferenceStatus : AIProcessingReferenceStatusMetaData = new AIProcessingReferenceStatusMetaData();
    static AIPromptModel : AIPromptModelMetaData = new AIPromptModelMetaData();
    static AIPromptRequest : AIPromptRequestMetaData = new AIPromptRequestMetaData();
    static AIPromptRequestStatus : AIPromptRequestStatusMetaData = new AIPromptRequestStatusMetaData();
    static AiPromptRequestType : AiPromptRequestTypeMetaData = new AiPromptRequestTypeMetaData();
    static AIPromptResultType : AIPromptResultTypeMetaData = new AIPromptResultTypeMetaData();
    static AIPromptSetup : AIPromptSetupMetaData = new AIPromptSetupMetaData();
    static AiPromptSetupStatus : AiPromptSetupStatusMetaData = new AiPromptSetupStatusMetaData();
    static AIPromptTokenType : AIPromptTokenTypeMetaData = new AIPromptTokenTypeMetaData();
    static AIPromptType : AIPromptTypeMetaData = new AIPromptTypeMetaData();
    static AircraftType : AircraftTypeMetaData = new AircraftTypeMetaData();
    static Airport : AirportMetaData = new AirportMetaData();
    static Assignment : AssignmentMetaData = new AssignmentMetaData();
    static AssignmentCourseLesson : AssignmentCourseLessonMetaData = new AssignmentCourseLessonMetaData();
    static AssignmentStatus : AssignmentStatusMetaData = new AssignmentStatusMetaData();
    static AssignmentStudent : AssignmentStudentMetaData = new AssignmentStudentMetaData();
    static AssignmentType : AssignmentTypeMetaData = new AssignmentTypeMetaData();
    static AviationGoal : AviationGoalMetaData = new AviationGoalMetaData();
    static Country : CountryMetaData = new CountryMetaData();
    static Course : CourseMetaData = new CourseMetaData();
    static CourseAssignmentSourceType : CourseAssignmentSourceTypeMetaData = new CourseAssignmentSourceTypeMetaData();
    static CourseAvailabilityNotification : CourseAvailabilityNotificationMetaData = new CourseAvailabilityNotificationMetaData();
    static CourseDocumentItem : CourseDocumentItemMetaData = new CourseDocumentItemMetaData();
    static CourseDocumentProcessingStatus : CourseDocumentProcessingStatusMetaData = new CourseDocumentProcessingStatusMetaData();
    static CourseEndorsement : CourseEndorsementMetaData = new CourseEndorsementMetaData();
    static CourseEndorsementLesson : CourseEndorsementLessonMetaData = new CourseEndorsementLessonMetaData();
    static CourseEndorsementStudent : CourseEndorsementStudentMetaData = new CourseEndorsementStudentMetaData();
    static CourseEndorsementTemplate : CourseEndorsementTemplateMetaData = new CourseEndorsementTemplateMetaData();
    static CourseEndorsementTemplateField : CourseEndorsementTemplateFieldMetaData = new CourseEndorsementTemplateFieldMetaData();
    static CourseLesson : CourseLessonMetaData = new CourseLessonMetaData();
    static CourseLessonAcsTask : CourseLessonAcsTaskMetaData = new CourseLessonAcsTaskMetaData();
    static CourseLessonDocumentLink : CourseLessonDocumentLinkMetaData = new CourseLessonDocumentLinkMetaData();
    static CourseLessonDocumentLinkReference : CourseLessonDocumentLinkReferenceMetaData = new CourseLessonDocumentLinkReferenceMetaData();
    static CourseLessonFlag : CourseLessonFlagMetaData = new CourseLessonFlagMetaData();
    static CourseLessonFlagStatus : CourseLessonFlagStatusMetaData = new CourseLessonFlagStatusMetaData();
    static CourseLessonFlagType : CourseLessonFlagTypeMetaData = new CourseLessonFlagTypeMetaData();
    static CourseLessonProgress : CourseLessonProgressMetaData = new CourseLessonProgressMetaData();
    static CourseLessonSession : CourseLessonSessionMetaData = new CourseLessonSessionMetaData();
    static CourseModificationHistory : CourseModificationHistoryMetaData = new CourseModificationHistoryMetaData();
    static CourseModule : CourseModuleMetaData = new CourseModuleMetaData();
    static CourseModuleDocumentItem : CourseModuleDocumentItemMetaData = new CourseModuleDocumentItemMetaData();
    static CourseModuleProgress : CourseModuleProgressMetaData = new CourseModuleProgressMetaData();
    static CoursePurchase : CoursePurchaseMetaData = new CoursePurchaseMetaData();
    static CoursePurchaseBillingAttempt : CoursePurchaseBillingAttemptMetaData = new CoursePurchaseBillingAttemptMetaData();
    static CoursePurchaseBillingAttemptStatus : CoursePurchaseBillingAttemptStatusMetaData = new CoursePurchaseBillingAttemptStatusMetaData();
    static CoursePurchaseCourse : CoursePurchaseCourseMetaData = new CoursePurchaseCourseMetaData();
    static CoursePurchasePackage : CoursePurchasePackageMetaData = new CoursePurchasePackageMetaData();
    static CoursePurchaseReservation : CoursePurchaseReservationMetaData = new CoursePurchaseReservationMetaData();
    static CoursePurchaseReservationCourse : CoursePurchaseReservationCourseMetaData = new CoursePurchaseReservationCourseMetaData();
    static CoursePurchaseReservationStatus : CoursePurchaseReservationStatusMetaData = new CoursePurchaseReservationStatusMetaData();
    static CoursePurchaseStudent : CoursePurchaseStudentMetaData = new CoursePurchaseStudentMetaData();
    static CourseType : CourseTypeMetaData = new CourseTypeMetaData();
    static DailyQuiz : DailyQuizMetaData = new DailyQuizMetaData();
    static Discount : DiscountMetaData = new DiscountMetaData();
    static DiscountCourse : DiscountCourseMetaData = new DiscountCourseMetaData();
    static DiscountPackage : DiscountPackageMetaData = new DiscountPackageMetaData();
    static DiscountSubscriptionRole : DiscountSubscriptionRoleMetaData = new DiscountSubscriptionRoleMetaData();
    static DiscountUsageFlightSchool : DiscountUsageFlightSchoolMetaData = new DiscountUsageFlightSchoolMetaData();
    static DiscountUsageUser : DiscountUsageUserMetaData = new DiscountUsageUserMetaData();
    static DocumentAiProcessingStatus : DocumentAiProcessingStatusMetaData = new DocumentAiProcessingStatusMetaData();
    static DocumentAnchor : DocumentAnchorMetaData = new DocumentAnchorMetaData();
    static DocumentAnchorType : DocumentAnchorTypeMetaData = new DocumentAnchorTypeMetaData();
    static DocumentAsset : DocumentAssetMetaData = new DocumentAssetMetaData();
    static DocumentAssetType : DocumentAssetTypeMetaData = new DocumentAssetTypeMetaData();
    static DocumentChangeLogType : DocumentChangeLogTypeMetaData = new DocumentChangeLogTypeMetaData();
    static DocumentContentFormatType : DocumentContentFormatTypeMetaData = new DocumentContentFormatTypeMetaData();
    static DocumentFolder : DocumentFolderMetaData = new DocumentFolderMetaData();
    static DocumentFolderChangeLog : DocumentFolderChangeLogMetaData = new DocumentFolderChangeLogMetaData();
    static DocumentGroup : DocumentGroupMetaData = new DocumentGroupMetaData();
    static DocumentImportJob : DocumentImportJobMetaData = new DocumentImportJobMetaData();
    static DocumentImportJobStatus : DocumentImportJobStatusMetaData = new DocumentImportJobStatusMetaData();
    static DocumentImportJobType : DocumentImportJobTypeMetaData = new DocumentImportJobTypeMetaData();
    static DocumentItem : DocumentItemMetaData = new DocumentItemMetaData();
    static DocumentItemAcknowledgement : DocumentItemAcknowledgementMetaData = new DocumentItemAcknowledgementMetaData();
    static DocumentItemChangeLog : DocumentItemChangeLogMetaData = new DocumentItemChangeLogMetaData();
    static DocumentItemChunk : DocumentItemChunkMetaData = new DocumentItemChunkMetaData();
    static DocumentItemChunkContentType : DocumentItemChunkContentTypeMetaData = new DocumentItemChunkContentTypeMetaData();
    static DocumentItemPage : DocumentItemPageMetaData = new DocumentItemPageMetaData();
    static DocumentItemStatus : DocumentItemStatusMetaData = new DocumentItemStatusMetaData();
    static DocumentLinkProcessingRun : DocumentLinkProcessingRunMetaData = new DocumentLinkProcessingRunMetaData();
    static DocumentLinkProcessingRunItem : DocumentLinkProcessingRunItemMetaData = new DocumentLinkProcessingRunItemMetaData();
    static DocumentLinkProcessingRunItemStatus : DocumentLinkProcessingRunItemStatusMetaData = new DocumentLinkProcessingRunItemStatusMetaData();
    static DocumentLinkProcessingRunStatus : DocumentLinkProcessingRunStatusMetaData = new DocumentLinkProcessingRunStatusMetaData();
    static DocumentLinkProcessingTriggerType : DocumentLinkProcessingTriggerTypeMetaData = new DocumentLinkProcessingTriggerTypeMetaData();
    static DocumentLinkSourceType : DocumentLinkSourceTypeMetaData = new DocumentLinkSourceTypeMetaData();
    static DocumentOwnerType : DocumentOwnerTypeMetaData = new DocumentOwnerTypeMetaData();
    static DocumentPublication : DocumentPublicationMetaData = new DocumentPublicationMetaData();
    static DocumentPublicationType : DocumentPublicationTypeMetaData = new DocumentPublicationTypeMetaData();
    static DocumentReferenceSource : DocumentReferenceSourceMetaData = new DocumentReferenceSourceMetaData();
    static DocumentSection : DocumentSectionMetaData = new DocumentSectionMetaData();
    static DocumentSectionContent : DocumentSectionContentMetaData = new DocumentSectionContentMetaData();
    static DocumentSectionType : DocumentSectionTypeMetaData = new DocumentSectionTypeMetaData();
    static DocumentType : DocumentTypeMetaData = new DocumentTypeMetaData();
    static DocumentVersion : DocumentVersionMetaData = new DocumentVersionMetaData();
    static DocumentVersionType : DocumentVersionTypeMetaData = new DocumentVersionTypeMetaData();
    static FlightSchool : FlightSchoolMetaData = new FlightSchoolMetaData();
    static FlightSchoolBillingContact : FlightSchoolBillingContactMetaData = new FlightSchoolBillingContactMetaData();
    static FlightSchoolBranding : FlightSchoolBrandingMetaData = new FlightSchoolBrandingMetaData();
    static FlightSchoolCourse : FlightSchoolCourseMetaData = new FlightSchoolCourseMetaData();
    static FlightSchoolFeature : FlightSchoolFeatureMetaData = new FlightSchoolFeatureMetaData();
    static FlightSchoolGroup : FlightSchoolGroupMetaData = new FlightSchoolGroupMetaData();
    static FlightSchoolGroupStudent : FlightSchoolGroupStudentMetaData = new FlightSchoolGroupStudentMetaData();
    static FlightSchoolInstructor : FlightSchoolInstructorMetaData = new FlightSchoolInstructorMetaData();
    static FlightSchoolPackage : FlightSchoolPackageMetaData = new FlightSchoolPackageMetaData();
    static FlightSchoolPosition : FlightSchoolPositionMetaData = new FlightSchoolPositionMetaData();
    static FlightSchoolRegistrationEmailDomain : FlightSchoolRegistrationEmailDomainMetaData = new FlightSchoolRegistrationEmailDomainMetaData();
    static FlightSchoolRegistrationLink : FlightSchoolRegistrationLinkMetaData = new FlightSchoolRegistrationLinkMetaData();
    static FlightSchoolStatus : FlightSchoolStatusMetaData = new FlightSchoolStatusMetaData();
    static GamificationConfiguration : GamificationConfigurationMetaData = new GamificationConfigurationMetaData();
    static Instructor : InstructorMetaData = new InstructorMetaData();
    static InstructorStatus : InstructorStatusMetaData = new InstructorStatusMetaData();
    static InstructorStudent : InstructorStudentMetaData = new InstructorStudentMetaData();
    static IntegrationCoursePurchase : IntegrationCoursePurchaseMetaData = new IntegrationCoursePurchaseMetaData();
    static IntegrationCoursePurchaseRequest : IntegrationCoursePurchaseRequestMetaData = new IntegrationCoursePurchaseRequestMetaData();
    static IntegrationCoursePurchaseRequestStatus : IntegrationCoursePurchaseRequestStatusMetaData = new IntegrationCoursePurchaseRequestStatusMetaData();
    static IntegrationEventType : IntegrationEventTypeMetaData = new IntegrationEventTypeMetaData();
    static IntegrationOrganization : IntegrationOrganizationMetaData = new IntegrationOrganizationMetaData();
    static IntegrationOrganizationStatus : IntegrationOrganizationStatusMetaData = new IntegrationOrganizationStatusMetaData();
    static IntegrationSystem : IntegrationSystemMetaData = new IntegrationSystemMetaData();
    static IntegrationSystemCourse : IntegrationSystemCourseMetaData = new IntegrationSystemCourseMetaData();
    static IntegrationUser : IntegrationUserMetaData = new IntegrationUserMetaData();
    static IntegrationUserEvent : IntegrationUserEventMetaData = new IntegrationUserEventMetaData();
    static IntegrationUserEventStatus : IntegrationUserEventStatusMetaData = new IntegrationUserEventStatusMetaData();
    static IntegrationUserStatus : IntegrationUserStatusMetaData = new IntegrationUserStatusMetaData();
    static Invoice : InvoiceMetaData = new InvoiceMetaData();
    static InvoiceErrorCode : InvoiceErrorCodeMetaData = new InvoiceErrorCodeMetaData();
    static InvoiceErrorLog : InvoiceErrorLogMetaData = new InvoiceErrorLogMetaData();
    static InvoiceLine : InvoiceLineMetaData = new InvoiceLineMetaData();
    static InvoiceLog : InvoiceLogMetaData = new InvoiceLogMetaData();
    static InvoiceRefund : InvoiceRefundMetaData = new InvoiceRefundMetaData();
    static InvoiceStatus : InvoiceStatusMetaData = new InvoiceStatusMetaData();
    static InvoiceType : InvoiceTypeMetaData = new InvoiceTypeMetaData();
    static JoinRequest : JoinRequestMetaData = new JoinRequestMetaData();
    static JoinRequestCourse : JoinRequestCourseMetaData = new JoinRequestCourseMetaData();
    static JoinRequestCourseFulfillmentStatus : JoinRequestCourseFulfillmentStatusMetaData = new JoinRequestCourseFulfillmentStatusMetaData();
    static JoinRequestCoursePurchase : JoinRequestCoursePurchaseMetaData = new JoinRequestCoursePurchaseMetaData();
    static JoinRequestCoursePurchaseStatus : JoinRequestCoursePurchaseStatusMetaData = new JoinRequestCoursePurchaseStatusMetaData();
    static JoinRequestEmail : JoinRequestEmailMetaData = new JoinRequestEmailMetaData();
    static JoinRequestStatus : JoinRequestStatusMetaData = new JoinRequestStatusMetaData();
    static JoinRequestType : JoinRequestTypeMetaData = new JoinRequestTypeMetaData();
    static JoinRequestTypeRole : JoinRequestTypeRoleMetaData = new JoinRequestTypeRoleMetaData();
    static JoinRequestTypeSubscriptionRole : JoinRequestTypeSubscriptionRoleMetaData = new JoinRequestTypeSubscriptionRoleMetaData();
    static LessonType : LessonTypeMetaData = new LessonTypeMetaData();
    static DwMedia : DwMediaMetaData = new DwMediaMetaData();
    static DwMediaGroup : DwMediaGroupMetaData = new DwMediaGroupMetaData();
    static DwMetaDataItem : DwMetaDataItemMetaData = new DwMetaDataItemMetaData();
    static MetricType : MetricTypeMetaData = new MetricTypeMetaData();
    static ModificationHistory : ModificationHistoryMetaData = new ModificationHistoryMetaData();
    static ModificationHistoryStatus : ModificationHistoryStatusMetaData = new ModificationHistoryStatusMetaData();
    static ModificationHistoryStudent : ModificationHistoryStudentMetaData = new ModificationHistoryStudentMetaData();
    static ModificationHistoryStudentStatus : ModificationHistoryStudentStatusMetaData = new ModificationHistoryStudentStatusMetaData();
    static MultipleAssign : MultipleAssignMetaData = new MultipleAssignMetaData();
    static MultipleAssignCourse : MultipleAssignCourseMetaData = new MultipleAssignCourseMetaData();
    static MultipleAssignFlightSchool : MultipleAssignFlightSchoolMetaData = new MultipleAssignFlightSchoolMetaData();
    static MultipleAssignPackage : MultipleAssignPackageMetaData = new MultipleAssignPackageMetaData();
    static Package : PackageMetaData = new PackageMetaData();
    static PackageCourse : PackageCourseMetaData = new PackageCourseMetaData();
    static PaymentEvent : PaymentEventMetaData = new PaymentEventMetaData();
    static PaymentEventSource : PaymentEventSourceMetaData = new PaymentEventSourceMetaData();
    static PaymentEventStatus : PaymentEventStatusMetaData = new PaymentEventStatusMetaData();
    static PaymentEventType : PaymentEventTypeMetaData = new PaymentEventTypeMetaData();
    static PaymentMethod : PaymentMethodMetaData = new PaymentMethodMetaData();
    static PaymentPartyType : PaymentPartyTypeMetaData = new PaymentPartyTypeMetaData();
    static PilotType : PilotTypeMetaData = new PilotTypeMetaData();
    static PostalCode : PostalCodeMetaData = new PostalCodeMetaData();
    static DwProcessDefinition : DwProcessDefinitionMetaData = new DwProcessDefinitionMetaData();
    static ProcessorConfig : ProcessorConfigMetaData = new ProcessorConfigMetaData();
    static ProcessorConfigCustomerHistory : ProcessorConfigCustomerHistoryMetaData = new ProcessorConfigCustomerHistoryMetaData();
    static ProcessorLog : ProcessorLogMetaData = new ProcessorLogMetaData();
    static Product : ProductMetaData = new ProductMetaData();
    static ProductPaymentLink : ProductPaymentLinkMetaData = new ProductPaymentLinkMetaData();
    static ProductType : ProductTypeMetaData = new ProductTypeMetaData();
    static ProfitShare : ProfitShareMetaData = new ProfitShareMetaData();
    static ProfitShareStatus : ProfitShareStatusMetaData = new ProfitShareStatusMetaData();
    static ProfitShareType : ProfitShareTypeMetaData = new ProfitShareTypeMetaData();
    static ProgramType : ProgramTypeMetaData = new ProgramTypeMetaData();
    static Question : QuestionMetaData = new QuestionMetaData();
    static QuestionNotUsed : QuestionNotUsedMetaData = new QuestionNotUsedMetaData();
    static QuestionAIProcessingStatus : QuestionAIProcessingStatusMetaData = new QuestionAIProcessingStatusMetaData();
    static QuestionAnswer : QuestionAnswerMetaData = new QuestionAnswerMetaData();
    static QuestionAnswerAIExplanation : QuestionAnswerAIExplanationMetaData = new QuestionAnswerAIExplanationMetaData();
    static QuestionImportCharacterConversion : QuestionImportCharacterConversionMetaData = new QuestionImportCharacterConversionMetaData();
    static QuestionStatus : QuestionStatusMetaData = new QuestionStatusMetaData();
    static QuestionTag : QuestionTagMetaData = new QuestionTagMetaData();
    static QuestionTagLink : QuestionTagLinkMetaData = new QuestionTagLinkMetaData();
    static QuestionType : QuestionTypeMetaData = new QuestionTypeMetaData();
    static Quiz : QuizMetaData = new QuizMetaData();
    static QuizOutcome : QuizOutcomeMetaData = new QuizOutcomeMetaData();
    static QuizQuestionAnswerNotUsed : QuizQuestionAnswerNotUsedMetaData = new QuizQuestionAnswerNotUsedMetaData();
    static QuizQuestionLink : QuizQuestionLinkMetaData = new QuizQuestionLinkMetaData();
    static QuizReferenceQuizLink : QuizReferenceQuizLinkMetaData = new QuizReferenceQuizLinkMetaData();
    static QuizResult : QuizResultMetaData = new QuizResultMetaData();
    static QuizResultQuestion : QuizResultQuestionMetaData = new QuizResultQuestionMetaData();
    static QuizResultStatus : QuizResultStatusMetaData = new QuizResultStatusMetaData();
    static QuizResultType : QuizResultTypeMetaData = new QuizResultTypeMetaData();
    static QuizType : QuizTypeMetaData = new QuizTypeMetaData();
    static ReferenceImage : ReferenceImageMetaData = new ReferenceImageMetaData();
    static ReferenceStatus : ReferenceStatusMetaData = new ReferenceStatusMetaData();
    static RoAcsWrittenMissedCodeStats : RoAcsWrittenMissedCodeStatsMetaData = new RoAcsWrittenMissedCodeStatsMetaData();
    static RoAssignmentDetail : RoAssignmentDetailMetaData = new RoAssignmentDetailMetaData();
    static RoAssignmentResetLessonImpact : RoAssignmentResetLessonImpactMetaData = new RoAssignmentResetLessonImpactMetaData();
    static RoAssignmentResetStudentImpact : RoAssignmentResetStudentImpactMetaData = new RoAssignmentResetStudentImpactMetaData();
    static RoAssignmentStudentCompletedDetails : RoAssignmentStudentCompletedDetailsMetaData = new RoAssignmentStudentCompletedDetailsMetaData();
    static RoAssignmentStudentCourseLessonProgress : RoAssignmentStudentCourseLessonProgressMetaData = new RoAssignmentStudentCourseLessonProgressMetaData();
    static RoAssignmentStudentStat : RoAssignmentStudentStatMetaData = new RoAssignmentStudentStatMetaData();
    static RoCompletedInvoices : RoCompletedInvoicesMetaData = new RoCompletedInvoicesMetaData();
    static RoCourseEndorsementStudentActive : RoCourseEndorsementStudentActiveMetaData = new RoCourseEndorsementStudentActiveMetaData();
    static RoCourseModuleLesson : RoCourseModuleLessonMetaData = new RoCourseModuleLessonMetaData();
    static RoFlightSchoolAdmins : RoFlightSchoolAdminsMetaData = new RoFlightSchoolAdminsMetaData();
    static RoFlightSchoolCoursePackageCount : RoFlightSchoolCoursePackageCountMetaData = new RoFlightSchoolCoursePackageCountMetaData();
    static RoFlightSchoolCourseUnique : RoFlightSchoolCourseUniqueMetaData = new RoFlightSchoolCourseUniqueMetaData();
    static RoFlightSchoolPaymentInfo : RoFlightSchoolPaymentInfoMetaData = new RoFlightSchoolPaymentInfoMetaData();
    static RoInstructorAssignmentsPerWeek : RoInstructorAssignmentsPerWeekMetaData = new RoInstructorAssignmentsPerWeekMetaData();
    static RoIntegationCouresPurchase : RoIntegationCouresPurchaseMetaData = new RoIntegationCouresPurchaseMetaData();
    static DwRole : DwRoleMetaData = new DwRoleMetaData();
    static RoLessonQuizStats : RoLessonQuizStatsMetaData = new RoLessonQuizStatsMetaData();
    static DwRoMedia : DwRoMediaMetaData = new DwRoMediaMetaData();
    static RoModuleLessonMaxOrder : RoModuleLessonMaxOrderMetaData = new RoModuleLessonMaxOrderMetaData();
    static RoPostLoginSummary : RoPostLoginSummaryMetaData = new RoPostLoginSummaryMetaData();
    static RoProduct : RoProductMetaData = new RoProductMetaData();
    static RoSchoolAssignmentStats : RoSchoolAssignmentStatsMetaData = new RoSchoolAssignmentStatsMetaData();
    static RoSchoolBillingDetails : RoSchoolBillingDetailsMetaData = new RoSchoolBillingDetailsMetaData();
    static RoSchoolCourseEnrollmentStats : RoSchoolCourseEnrollmentStatsMetaData = new RoSchoolCourseEnrollmentStatsMetaData();
    static RoSchoolInvoices : RoSchoolInvoicesMetaData = new RoSchoolInvoicesMetaData();
    static RoSchoolPaymentMethod : RoSchoolPaymentMethodMetaData = new RoSchoolPaymentMethodMetaData();
    static RoSchoolStudentStats : RoSchoolStudentStatsMetaData = new RoSchoolStudentStatsMetaData();
    static RoSchoolSubscription : RoSchoolSubscriptionMetaData = new RoSchoolSubscriptionMetaData();
    static RoStudentCourseAcsTestResultDetail : RoStudentCourseAcsTestResultDetailMetaData = new RoStudentCourseAcsTestResultDetailMetaData();
    static RoStudentCourseDetail : RoStudentCourseDetailMetaData = new RoStudentCourseDetailMetaData();
    static RoStudentCourseInstructor : RoStudentCourseInstructorMetaData = new RoStudentCourseInstructorMetaData();
    static RoStudentCourseProgressMismatch : RoStudentCourseProgressMismatchMetaData = new RoStudentCourseProgressMismatchMetaData();
    static RoStudentOverviewDetails : RoStudentOverviewDetailsMetaData = new RoStudentOverviewDetailsMetaData();
    static RoStudentPaymentMethod : RoStudentPaymentMethodMetaData = new RoStudentPaymentMethodMetaData();
    static RoStudentSchoolCourses : RoStudentSchoolCoursesMetaData = new RoStudentSchoolCoursesMetaData();
    static RoUserRoleDetail : RoUserRoleDetailMetaData = new RoUserRoleDetailMetaData();
    static RptInvoiceProductDetail : RptInvoiceProductDetailMetaData = new RptInvoiceProductDetailMetaData();
    static RptProfitShare : RptProfitShareMetaData = new RptProfitShareMetaData();
    static SchoolBillingMode : SchoolBillingModeMetaData = new SchoolBillingModeMetaData();
    static SchoolBillingPolicyPeriod : SchoolBillingPolicyPeriodMetaData = new SchoolBillingPolicyPeriodMetaData();
    static SchoolFeature : SchoolFeatureMetaData = new SchoolFeatureMetaData();
    static StandardColorSet : StandardColorSetMetaData = new StandardColorSetMetaData();
    static StandardLoginMedia : StandardLoginMediaMetaData = new StandardLoginMediaMetaData();
    static StateProvince : StateProvinceMetaData = new StateProvinceMetaData();
    static StripeCheckoutSession : StripeCheckoutSessionMetaData = new StripeCheckoutSessionMetaData();
    static StripeCheckoutSessionProduct : StripeCheckoutSessionProductMetaData = new StripeCheckoutSessionProductMetaData();
    static StripeCheckoutSessionStatus : StripeCheckoutSessionStatusMetaData = new StripeCheckoutSessionStatusMetaData();
    static Student : StudentMetaData = new StudentMetaData();
    static StudentAchievement : StudentAchievementMetaData = new StudentAchievementMetaData();
    static StudentAchievementAward : StudentAchievementAwardMetaData = new StudentAchievementAwardMetaData();
    static StudentActivity : StudentActivityMetaData = new StudentActivityMetaData();
    static StudentActivityType : StudentActivityTypeMetaData = new StudentActivityTypeMetaData();
    static StudentCourse : StudentCourseMetaData = new StudentCourseMetaData();
    static StudentCourseLockInstructor : StudentCourseLockInstructorMetaData = new StudentCourseLockInstructorMetaData();
    static StudentCourseProgressStatus : StudentCourseProgressStatusMetaData = new StudentCourseProgressStatusMetaData();
    static StudentGamificationDay : StudentGamificationDayMetaData = new StudentGamificationDayMetaData();
    static StudentGamificationSummary : StudentGamificationSummaryMetaData = new StudentGamificationSummaryMetaData();
    static StudentLessonProgressEvent : StudentLessonProgressEventMetaData = new StudentLessonProgressEventMetaData();
    static StudentModuleSummary : StudentModuleSummaryMetaData = new StudentModuleSummaryMetaData();
    static StudentModuleSummaryStatus : StudentModuleSummaryStatusMetaData = new StudentModuleSummaryStatusMetaData();
    static StudentProgressResetEvent : StudentProgressResetEventMetaData = new StudentProgressResetEventMetaData();
    static StudentWeatherDayTransaction : StudentWeatherDayTransactionMetaData = new StudentWeatherDayTransactionMetaData();
    static SubdomainSetupStatus : SubdomainSetupStatusMetaData = new SubdomainSetupStatusMetaData();
    static SubdomainType : SubdomainTypeMetaData = new SubdomainTypeMetaData();
    static Subscription : SubscriptionMetaData = new SubscriptionMetaData();
    static SubscriptionCourseTracking : SubscriptionCourseTrackingMetaData = new SubscriptionCourseTrackingMetaData();
    static SubscriptionFeature : SubscriptionFeatureMetaData = new SubscriptionFeatureMetaData();
    static SubscriptionRole : SubscriptionRoleMetaData = new SubscriptionRoleMetaData();
    static SubscriptionRoleTracking : SubscriptionRoleTrackingMetaData = new SubscriptionRoleTrackingMetaData();
    static SubscriptionStatus : SubscriptionStatusMetaData = new SubscriptionStatusMetaData();
    static SubscriptionTier : SubscriptionTierMetaData = new SubscriptionTierMetaData();
    static SubscriptionTierBenefit : SubscriptionTierBenefitMetaData = new SubscriptionTierBenefitMetaData();
    static SubscriptionTierFeature : SubscriptionTierFeatureMetaData = new SubscriptionTierFeatureMetaData();
    static SubscriptionTierFlightSchool : SubscriptionTierFlightSchoolMetaData = new SubscriptionTierFlightSchoolMetaData();
    static SubscriptionTierRole : SubscriptionTierRoleMetaData = new SubscriptionTierRoleMetaData();
    static SubscriptionTierStatus : SubscriptionTierStatusMetaData = new SubscriptionTierStatusMetaData();
    static TemplateFieldAlignment : TemplateFieldAlignmentMetaData = new TemplateFieldAlignmentMetaData();
    static TemplateFieldType : TemplateFieldTypeMetaData = new TemplateFieldTypeMetaData();
    static TemplateFontStyle : TemplateFontStyleMetaData = new TemplateFontStyleMetaData();
    static DwTheme : DwThemeMetaData = new DwThemeMetaData();
    static DwThemeProperty : DwThemePropertyMetaData = new DwThemePropertyMetaData();
    static DwThemePropertyDefinition : DwThemePropertyDefinitionMetaData = new DwThemePropertyDefinitionMetaData();
    static DwThemePropertyType : DwThemePropertyTypeMetaData = new DwThemePropertyTypeMetaData();
    static TimeZone : TimeZoneMetaData = new TimeZoneMetaData();
    static DwUser : DwUserMetaData = new DwUserMetaData();
    static UserDetail : UserDetailMetaData = new UserDetailMetaData();
    static UserDocumentSectionFavorite : UserDocumentSectionFavoriteMetaData = new UserDocumentSectionFavoriteMetaData();
    static DwUserRole : DwUserRoleMetaData = new DwUserRoleMetaData();
    static UserSubscriptionRole : UserSubscriptionRoleMetaData = new UserSubscriptionRoleMetaData();
    static DwUserType : DwUserTypeMetaData = new DwUserTypeMetaData();
    static VectorProvider : VectorProviderMetaData = new VectorProviderMetaData();
    static VectorReference : VectorReferenceMetaData = new VectorReferenceMetaData();
    static Video : VideoMetaData = new VideoMetaData();
    static VideoHistory : VideoHistoryMetaData = new VideoHistoryMetaData();
    static VideoLibrary : VideoLibraryMetaData = new VideoLibraryMetaData();
    static VideoPlaybackAuthenticationMode : VideoPlaybackAuthenticationModeMetaData = new VideoPlaybackAuthenticationModeMetaData();
    static VideoProcessingStatus : VideoProcessingStatusMetaData = new VideoProcessingStatusMetaData();
    static VideoStatus : VideoStatusMetaData = new VideoStatusMetaData();
    static VideoStreamingProvider : VideoStreamingProviderMetaData = new VideoStreamingProviderMetaData();
    static VideoTagLink : VideoTagLinkMetaData = new VideoTagLinkMetaData();
    static Queries = new MetaDataQueries();
}
// Generated Entity Interfaces
export interface AchievementDefinitionEntity extends DwOrmData {
    // Attributes
    AchievementDefinitionId?: number;
    AchievementKey?: string;
    AchievementName?: string;
    AchievementDescription?: string;
    ScopeType?: string;
    IconCssClass?: string;
    DisplayOrder?: number;
    Active?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
    AchievementTier? : AchievementTierEntity[];
    StudentAchievement? : StudentAchievementEntity[];
}

export interface AchievementTierEntity extends DwOrmData {
    // Attributes
    AchievementTierId?: number;
    AchievementDefinitionId?: number;
    TierOrder?: number;
    TierKey?: string;
    MetricTypeId?: number;
    Threshold?: number;
    RequirementText?: string;
    Active?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    AchievementDefinitionIdDisplay?: string;
    MetricTypeIdDisplay?: string;

    // Relations
    AchievementDefinition? : AchievementDefinitionEntity;
    MetricType? : MetricTypeEntity;
    CurrentStudentAchievement? : StudentAchievementEntity[];
    NextStudentAchievement? : StudentAchievementEntity[];
    StudentAchievementAward? : StudentAchievementAwardEntity[];
}

export interface AcquisitionSourceEntity extends DwOrmData {
    // Attributes
    AcquisitionSourceId?: number;
    AcquisitionSource?: string;
    Order?: number;


    // Relations
    Student? : StudentEntity[];
}

export interface AcsAreaOfOperationEntity extends DwOrmData {
    // Attributes
    AcsAreaOfOperationId?: number;
    AcsTestId?: number;
    AreaOfOperationName?: string;
    AreaOfOperationOrder?: number;
    AreaOfOperationCode?: string;
    AcsTestPortionId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    AcsTestIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    AcsTest? : AcsTestEntity;
    AcsAreaOfOperationTask? : AcsAreaOfOperationTaskEntity[];
}

export interface AcsAreaOfOperationTaskEntity extends DwOrmData {
    // Attributes
    AcsAreaOfOperationTaskId?: number;
    AcsAreaOfOperationId?: number;
    TaskName?: string;
    TaskOrder?: number;
    TaskCode?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    AcsAreaOfOperationIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    AcsAreaOfOperation? : AcsAreaOfOperationEntity;
    AcsCode? : AcsCodeEntity[];
    AcsTaskMultiAssignTask? : AcsTaskMultiAssignTaskEntity[];
    CourseLessonAcsTask? : CourseLessonAcsTaskEntity[];
}

export interface AcsCodeEntity extends DwOrmData {
    // Attributes
    AcsCodeId?: number;
    AcsAreaOfOperationTaskId?: number;
    AscCodeTypeId?: number;
    AcsCode?: string;
    AscCodeDescription?: string;
    AcsCodeOrder?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    AcsAreaOfOperationTaskIdDisplay?: string;
    AscCodeTypeIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    AcsAreaOfOperationTask? : AcsAreaOfOperationTaskEntity;
    AscCodeTypeIdAcsCodeType? : AcsCodeTypeEntity;
    AcsWrittenResultMissedCode? : AcsWrittenResultMissedCodeEntity[];
}

export interface AcsCodeTypeEntity extends DwOrmData {
    // Attributes
    AcsCodeTypeId?: number;
    AcsCodeTypeName?: string;
    AcsCodeTypeShortName?: string;


    // Relations
    AscCodeTypeIdAcsCode? : AcsCodeEntity[];
}

export interface AcsTaskMultiAssignEntity extends DwOrmData {
    // Attributes
    AcsTaskMultiAssignId?: number;
    CourseId?: number;
    ReplaceExistingTasks?: boolean;

    // Display Attributes
    CourseIdDisplay?: string;

    // Relations
    Course? : CourseEntity;
    AcsTaskMultiAssigsnIdAcsTaskMultiAssignLesson? : AcsTaskMultiAssignLessonEntity[];
    AcsTaskMultiAssignTask? : AcsTaskMultiAssignTaskEntity[];
}

export interface AcsTaskMultiAssignLessonEntity extends DwOrmData {
    // Attributes
    AcsTaskMultiAssignLessonId?: number;
    AcsTaskMultiAssigsnId?: number;
    CourseLessonId?: number;

    // Display Attributes
    AcsTaskMultiAssigsnIdDisplay?: string;
    CourseLessonIdDisplay?: string;

    // Relations
    AcsTaskMultiAssigsnIdAcsTaskMultiAssign? : AcsTaskMultiAssignEntity;
    CourseLesson? : CourseLessonEntity;
}

export interface AcsTaskMultiAssignTaskEntity extends DwOrmData {
    // Attributes
    AcsTaskMultiAssignTaskId?: number;
    AcsTaskMultiAssignId?: number;
    AcsAreaOfOperationTaskId?: number;

    // Display Attributes
    AcsTaskMultiAssignIdDisplay?: string;
    AcsAreaOfOperationTaskIdDisplay?: string;

    // Relations
    AcsAreaOfOperationTask? : AcsAreaOfOperationTaskEntity;
    AcsTaskMultiAssign? : AcsTaskMultiAssignEntity;
}

export interface AcsTestEntity extends DwOrmData {
    // Attributes
    AcsTestId?: number;
    TestName?: string;
    TestDescription?: string;
    CheckRideGroupId?: number;
    TestCode?: string;
    TestExpirationDate?: string;
    AcsTestStatusId?: number;
    AcsTestPdfMediaId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    ACSTestOfficialName?: string;

    // Display Attributes
    AcsTestStatusIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    AcsTestStatus? : AcsTestStatusEntity;
    AcsAreaOfOperation? : AcsAreaOfOperationEntity[];
    AcsWrittenResult? : AcsWrittenResultEntity[];
    Course? : CourseEntity[];
}

export interface AcsTestStatusEntity extends DwOrmData {
    // Attributes
    AcsTestStatusId?: number;
    AcsTestStatus?: string;


    // Relations
    AcsTest? : AcsTestEntity[];
}

export interface AcsWrittenResultEntity extends DwOrmData {
    // Attributes
    AcsWrittenResultId?: number;
    TestResultMediaId?: number;
    StudentName?: string;
    FaaTrackingNumber?: string;
    ExamName?: string;
    ExamDate?: string;
    Score?: number;
    Grade?: string;
    ExpirationDate?: string;
    ExamIdCode?: string;
    ExamSiteIdCode?: string;
    Passed?: boolean;
    Take?: number;
    AcsTestId?: number;
    AcsWrittenTestStatusId?: number;
    StudentCourseId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    LastLogId?: number;
    AssignmentId?: number;

    // Display Attributes
    AcsTestIdDisplay?: string;
    AcsWrittenTestStatusIdDisplay?: string;
    StudentCourseIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    LastLogIdDisplay?: string;

    // Relations
    AcsTest? : AcsTestEntity;
    AcsWrittenTestStatus? : AcsWrittenTestStatusEntity;
    StudentCourse? : StudentCourseEntity;
    AcsWrittenResultMissedCode? : AcsWrittenResultMissedCodeEntity[];
    RoAcsWrittenMissedCodeStats? : RoAcsWrittenMissedCodeStatsEntity[];
}

export interface AcsWrittenResultMissedCodeEntity extends DwOrmData {
    // Attributes
    AcsWrittenResultMissedCode?: number;
    AcsWrittenResultId?: number;
    MissedCode?: string;
    AcsCodeId?: number;

    // Display Attributes
    AcsWrittenResultIdDisplay?: string;
    AcsCodeIdDisplay?: string;

    // Relations
    AcsCode? : AcsCodeEntity;
    AcsWrittenResult? : AcsWrittenResultEntity;
}

export interface AcsWrittenTestStatusEntity extends DwOrmData {
    // Attributes
    AcsWrittenTestStatusId?: number;
    AcsWrittenTestStatus?: string;


    // Relations
    AcsWrittenResult? : AcsWrittenResultEntity[];
}

export interface AddressEntity extends DwOrmData {
    // Attributes
    AddressId?: number;
    StreetAddress1?: string;
    StreetAddress2?: string;
    City?: string;
    StateProvinceId?: number;
    CountryId?: number;
    CountyName?: string;
    PostalCode?: string;
    PostalCodePlus4?: string;
    Phone?: string;
    Fax?: string;
    Latitude?: number;
    Longitude?: number;
    CreatedDateTime?: string;
    CreatedBy?: number;
    ModifiedDateTime?: string;
    ModifiedBy?: number;
    TimezoneId?: number;
    ObservesDst?: boolean;

    // Display Attributes
    StateProvinceIdDisplay?: string;
    CountryIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    TimezoneIdDisplay?: string;

    // Relations
    Country? : CountryEntity;
    StateProvince? : StateProvinceEntity;
    TimeZone? : TimeZoneEntity;
    AirportAirport? : AirportEntity[];
    BillingFlightSchool? : FlightSchoolEntity[];
    CustomerStripeCheckoutSession? : StripeCheckoutSessionEntity[];
    Student? : StudentEntity[];
}

export interface AiProcessConfigEntity extends DwOrmData {
    // Attributes
    AiProcessConfigId?: number;
    ProcessName?: string;
    AiPromptSetupId?: number;
    IsEnabled?: boolean;
    LimitConfigJSON?: string;
    LimitValue1?: number;
    LimitValue2?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    AiPromptSetupIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    AiPromptSetupIdAIPromptSetup? : AIPromptSetupEntity;
}

export interface AIProcessingReferenceEntity extends DwOrmData {
    // Attributes
    AIProcessingReferenceId?: number;
    MetaDataItemId?: number;
    KeyValue?: number;
    AIProcessingStatusId?: number;
    LastAIPromptRequestId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    ProcessingGroupKey?: string;
    ProcessingOrder?: number;

    // Display Attributes
    MetaDataItemIdDisplay?: string;
    AIProcessingStatusIdDisplay?: string;
    LastAIPromptRequestIdDisplay?: string;

    // Relations
    AIProcessingStatusIdAIProcessingReferenceStatus? : AIProcessingReferenceStatusEntity;
    LastAIPromptRequest? : AIPromptRequestEntity;
    DwMetaDataItem? : DwMetaDataItemEntity;
    CourseDocumentItem? : CourseDocumentItemEntity[];
    CourseLesson? : CourseLessonEntity[];
    CourseModule? : CourseModuleEntity[];
    AiProcessingReferenceIdCourseModuleDocumentItem? : CourseModuleDocumentItemEntity[];
    DocumentItemChunk? : DocumentItemChunkEntity[];
    DocumentLinkProcessingRunItem? : DocumentLinkProcessingRunItemEntity[];
}

export interface AIProcessingReferenceStatusEntity extends DwOrmData {
    // Attributes
    AIProcessingReferenceStatusId?: number;
    AIProcessingReferenceStatus?: string;


    // Relations
    AIProcessingStatusIdAIProcessingReference? : AIProcessingReferenceEntity[];
}

export interface AIPromptModelEntity extends DwOrmData {
    // Attributes
    AIPromptModelId?: number;
    AIPromptModel?: string;
    ModelCode?: string;
    InputTokenCostPerMil?: number;
    InputCachedTokenCostPerMil?: number;
    OutputTokenCostPerMil?: number;


    // Relations
    AIPromptSetup? : AIPromptSetupEntity[];
}

export interface AIPromptRequestEntity extends DwOrmData {
    // Attributes
    AIPromptRequestId?: number;
    Result?: string;
    CourseId?: number;
    CourseModuleId?: number;
    CourseLessonId?: number;
    IncludeCourseData?: boolean;
    IncludeStudentProgressData?: boolean;
    IncludeQuizMissedQuestionData?: boolean;
    SystemPromptAcutal?: string;
    UserPromptActual?: string;
    AIPromptSetupId?: number;
    AIPromptRequestStatusId?: number;
    InputTokens?: number;
    InputCachedTokens?: number;
    OutputTokens?: number;
    TotalCost?: number;
    StudentCoursetId?: number;
    UsePromptTokens?: boolean;
    ProcessingTimeSeconds?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    LastLogId?: number;
    AssignmentStudentId?: number;

    // Display Attributes
    CourseIdDisplay?: string;
    CourseModuleIdDisplay?: string;
    CourseLessonIdDisplay?: string;
    AIPromptSetupIdDisplay?: string;
    AIPromptRequestStatusIdDisplay?: string;
    StudentCoursetIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    LastLogIdDisplay?: string;
    AssignmentStudentIdDisplay?: string;

    // Relations
    AIPromptRequestStatus? : AIPromptRequestStatusEntity;
    AIPromptSetup? : AIPromptSetupEntity;
    AssignmentStudent? : AssignmentStudentEntity;
    Course? : CourseEntity;
    CourseLesson? : CourseLessonEntity;
    CourseModule? : CourseModuleEntity;
    StudentCoursetIdStudentCourse? : StudentCourseEntity;
    LastAIProcessingReference? : AIProcessingReferenceEntity[];
    AiPromptRequestIdAssignmentStudent? : AssignmentStudentEntity[];
    CourseModuleProgress? : CourseModuleProgressEntity;
}

export interface AIPromptRequestStatusEntity extends DwOrmData {
    // Attributes
    AIPromptRequestStatusId?: number;
    AIPromptRequestStatus?: string;


    // Relations
    AIPromptRequest? : AIPromptRequestEntity[];
}

export interface AiPromptRequestTypeEntity extends DwOrmData {
    // Attributes
    AiPromptRequestTypeId?: number;
    AiPromptRequestType?: string;


    // Relations
}

export interface AIPromptResultTypeEntity extends DwOrmData {
    // Attributes
    AIPromptResultTypeId?: number;
    AIPromptResultType?: string;


    // Relations
    AIPromptSetup? : AIPromptSetupEntity[];
}

export interface AIPromptSetupEntity extends DwOrmData {
    // Attributes
    AIPromptSetupId?: number;
    AiPromptTypeId?: number;
    AIPromptModelId?: number;
    AIPromptSetupStatusId?: number;
    SystemPrompt?: string;
    UserPrompt?: string;
    AIPromptResultTypeId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    PromptName?: string;

    // Display Attributes
    AiPromptTypeIdDisplay?: string;
    AIPromptModelIdDisplay?: string;
    AIPromptSetupStatusIdDisplay?: string;
    AIPromptResultTypeIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    AIPromptModel? : AIPromptModelEntity;
    AIPromptResultType? : AIPromptResultTypeEntity;
    AIPromptSetupStatusIdAiPromptSetupStatus? : AiPromptSetupStatusEntity;
    AiPromptTypeIdAIPromptType? : AIPromptTypeEntity;
    AiPromptSetupIdAiProcessConfig? : AiProcessConfigEntity[];
    AIPromptRequest? : AIPromptRequestEntity[];
}

export interface AiPromptSetupStatusEntity extends DwOrmData {
    // Attributes
    AiPromptSetupStatusId?: number;
    AiPromptSetupStatus?: string;


    // Relations
    AIPromptSetupStatusIdAIPromptSetup? : AIPromptSetupEntity[];
}

export interface AIPromptTokenTypeEntity extends DwOrmData {
    // Attributes
    AiPromptTokenTypeId?: number;
    AiPromptToken?: string;
    AiPromptTokenDescription?: string;


    // Relations
}

export interface AIPromptTypeEntity extends DwOrmData {
    // Attributes
    AIPromptTypeId?: number;
    AIPromptType?: string;


    // Relations
    AiPromptTypeIdAIPromptSetup? : AIPromptSetupEntity[];
}

export interface AircraftTypeEntity extends DwOrmData {
    // Attributes
    AircraftTypeId?: number;
    AircraftType?: string;
    AircraftTypeDescription?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    Course? : CourseEntity[];
}

export interface AirportEntity extends DwOrmData {
    // Attributes
    AirportId?: number;
    AviationAuthorityId?: number;
    AirportName?: string;
    AirportCode?: string;
    AirportAddressId?: number;
    Elevation?: number;
    OwnershipCode?: string;
    IsActive?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    AirportAddressIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    AirportAddress? : AddressEntity;
}

export interface AssignmentEntity extends DwOrmData {
    // Attributes
    AssignmentId?: number;
    CourseId?: number;
    AssignmentDescription?: string;
    AssignmentTypeId?: number;
    AssignmentStatusId?: number;
    AssignmentLinkUrl?: string;
    MediaId?: number;
    DueDateTime?: string;
    FlightSchoolGroupId?: number;
    AssignedDateTime?: string;
    CompletedDateTime?: string;
    FlightSchoolId?: number;
    ResetLessonProgress?: boolean;
    UseGroupAssignment?: boolean;
    InstructorId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    CourseIdDisplay?: string;
    AssignmentTypeIdDisplay?: string;
    AssignmentStatusIdDisplay?: string;
    FlightSchoolGroupIdDisplay?: string;
    FlightSchoolIdDisplay?: string;
    InstructorIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    AssignmentStatus? : AssignmentStatusEntity;
    AssignmentType? : AssignmentTypeEntity;
    Course? : CourseEntity;
    FlightSchool? : FlightSchoolEntity;
    FlightSchoolGroup? : FlightSchoolGroupEntity;
    Instructor? : InstructorEntity;
    DwMedia? : DwMediaEntity;
    AssignmentCourseLesson? : AssignmentCourseLessonEntity[];
    AssignmentStudent? : AssignmentStudentEntity[];
    AssignmentIdRoAssignmentStudentCourseLessonProgress? : RoAssignmentStudentCourseLessonProgressEntity[];
    RoAssignmentStudentStat? : RoAssignmentStudentStatEntity[];
    StudentProgressResetEvent? : StudentProgressResetEventEntity[];
}

export interface AssignmentCourseLessonEntity extends DwOrmData {
    // Attributes
    AssignmentCourseLessonId?: number;
    AssignmentId?: number;
    CourseLessonId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    AssignmentIdDisplay?: string;
    CourseLessonIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    Assignment? : AssignmentEntity;
    CourseLesson? : CourseLessonEntity;
}

export interface AssignmentStatusEntity extends DwOrmData {
    // Attributes
    AssignmentStatusId?: number;
    AssignmentStatus?: string;


    // Relations
    Assignment? : AssignmentEntity[];
}

export interface AssignmentStudentEntity extends DwOrmData {
    // Attributes
    AssignmentStudentId?: number;
    AssignmentId?: number;
    StudentId?: number;
    PercentComplete?: number;
    CompletedDateTime?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    Acknowledged?: boolean;
    AcknowledgedDateTime?: string;
    AiPromptRequestId?: number;
    ShowAISummary?: boolean;

    // Display Attributes
    AssignmentIdDisplay?: string;
    StudentIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    AiPromptRequestIdDisplay?: string;

    // Relations
    AiPromptRequestIdAIPromptRequest? : AIPromptRequestEntity;
    Assignment? : AssignmentEntity;
    Student? : StudentEntity;
    AIPromptRequest? : AIPromptRequestEntity[];
    RoAssignmentStudentCompletedDetails? : RoAssignmentStudentCompletedDetailsEntity;
    RoAssignmentStudentCourseLessonProgress? : RoAssignmentStudentCourseLessonProgressEntity[];
    RoSchoolAssignmentStatsAssignmentId? : RoSchoolAssignmentStatsEntity[];
    StudentProgressResetEvent? : StudentProgressResetEventEntity[];
}

export interface AssignmentTypeEntity extends DwOrmData {
    // Attributes
    AssignmentTypeId?: number;
    AssignmentType?: string;


    // Relations
    Assignment? : AssignmentEntity[];
}

export interface AviationGoalEntity extends DwOrmData {
    // Attributes
    AviationGoalId?: number;
    AviationGoal?: string;
    GoalOrder?: number;


    // Relations
    Student? : StudentEntity[];
}

export interface CountryEntity extends DwOrmData {
    // Attributes
    CountryId?: number;
    CountryName?: string;
    CountryShortName?: string;
    CreatedDateTime?: string;
    CreatedBy?: number;
    ModifiedDateTime?: string;
    ModifiedBy?: number;
    SortFirst?: boolean;

    // Display Attributes
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    Address? : AddressEntity[];
    StateProvince? : StateProvinceEntity[];
    CitizenshipStudent? : StudentEntity[];
}

export interface CourseEntity extends DwOrmData {
    // Attributes
    CourseId?: number;
    CourseName?: string;
    CourseDescription?: string;
    CourseTypeId?: number;
    CourseImageMediaId?: number;
    CourseNotes?: string;
    AircraftTypeId?: number;
    AvionicsType?: string;
    ProgramTypeId?: number;
    RetailPrice?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    CourseStatusId?: number;
    TotalCourseTimeSeconds?: number;
    TotalCourseVideoTimeSeconds?: number;
    TotalCourseQuizTimeSeconds?: number;
    CourseKey?: string;
    DefaultSchoolCourse?: boolean;
    AcsTestId?: number;
    CourseOrder?: number;
    ModulePrefixOverride?: string;
    ComingSoon?: boolean;

    // Display Attributes
    CourseTypeIdDisplay?: string;
    CourseImageMediaIdDisplay?: string;
    AircraftTypeIdDisplay?: string;
    ProgramTypeIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    CourseStatusIdDisplay?: string;
    AcsTestIdDisplay?: string;

    // Relations
    AcsTest? : AcsTestEntity;
    AircraftType? : AircraftTypeEntity;
    CourseType? : CourseTypeEntity;
    CourseImageDwMedia? : DwMediaEntity;
    CourseImageDwroMedia? : DwRoMediaEntity;
    ProgramType? : ProgramTypeEntity;
    CourseStatusIdReferenceStatus? : ReferenceStatusEntity;
    AcsTaskMultiAssign? : AcsTaskMultiAssignEntity[];
    AIPromptRequest? : AIPromptRequestEntity[];
    Assignment? : AssignmentEntity[];
    CourseAvailabilityNotification? : CourseAvailabilityNotificationEntity[];
    CourseDocumentItem? : CourseDocumentItemEntity[];
    CourseEndorsement? : CourseEndorsementEntity;
    CourseLessonFlag? : CourseLessonFlagEntity[];
    CourseModificationHistory? : CourseModificationHistoryEntity[];
    CourseModule? : CourseModuleEntity[];
    CoursePurchaseCourse? : CoursePurchaseCourseEntity[];
    CoursePurchaseReservationCourse? : CoursePurchaseReservationCourseEntity[];
    DiscountCourse? : DiscountCourseEntity[];
    DocumentLinkProcessingRun? : DocumentLinkProcessingRunEntity[];
    DocumentLinkProcessingRunItem? : DocumentLinkProcessingRunItemEntity[];
    FlightSchoolCourse? : FlightSchoolCourseEntity[];
    IntegrationCoursePurchase? : IntegrationCoursePurchaseEntity[];
    IntegrationCoursePurchaseRequest? : IntegrationCoursePurchaseRequestEntity[];
    IntegrationSystemCourse? : IntegrationSystemCourseEntity[];
    IntegrationUserEvent? : IntegrationUserEventEntity[];
    JoinRequestCourse? : JoinRequestCourseEntity[];
    JoinRequestCoursePurchase? : JoinRequestCoursePurchaseEntity[];
    ModificationHistory? : ModificationHistoryEntity[];
    MultipleAssignCourse? : MultipleAssignCourseEntity[];
    PackageCourse? : PackageCourseEntity[];
    Product? : ProductEntity;
    Question? : QuestionEntity[];
    RoFlightSchoolCourseUnique? : RoFlightSchoolCourseUniqueEntity[];
    RoStudentSchoolCourses? : RoStudentSchoolCoursesEntity[];
    StudentCourse? : StudentCourseEntity[];
    StudentProgressResetEvent? : StudentProgressResetEventEntity[];
    SubscriptionCourseTracking? : SubscriptionCourseTrackingEntity[];
}

export interface CourseAssignmentSourceTypeEntity extends DwOrmData {
    // Attributes
    CourseAssignmentSourceTypeId?: number;
    CourseAssignmentSourceType?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
    StudentActivity? : StudentActivityEntity[];
}

export interface CourseAvailabilityNotificationEntity extends DwOrmData {
    // Attributes
    CourseAvailabilityNotificationId?: number;
    CourseId?: number;
    UserId?: number;
    FlightSchoolId?: number;
    IsActive?: boolean;
    RequestedDateTime?: string;
    CancelledDateTime?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    CourseAvailableDateTime?: string;

    // Display Attributes
    CourseIdDisplay?: string;
    UserIdDisplay?: string;
    FlightSchoolIdDisplay?: string;

    // Relations
    Course? : CourseEntity;
    FlightSchool? : FlightSchoolEntity;
    DwUser? : DwUserEntity;
}

export interface CourseDocumentItemEntity extends DwOrmData {
    // Attributes
    CourseDocumentItemId?: number;
    DocumentItemId?: number;
    AIProcessingReferenceId?: number;
    CourseId?: number;
    CourseDocumentProcessingStatusId?: number;
    CourseDocumentProcessingProgressText?: string;
    CourseDocumentProcessingErrorText?: string;
    CourseDocumentProcessingStartDateTime?: string;
    CourseDocumentProcessingCompletedDateTime?: string;
    CourseDocumentProcessingLastUpdatedDateTime?: string;
    CourseDocumentProcessingEstimatedCompletedDateTime?: string;
    CourseDocumentProcessingTotalModuleCount?: number;
    CourseDocumentProcessingProcessedModuleCount?: number;
    CourseDocumentProcessingFailedModuleCount?: number;
    CourseDocumentItemStatusId?: number;

    // Display Attributes
    DocumentItemIdDisplay?: string;
    AIProcessingReferenceIdDisplay?: string;
    CourseIdDisplay?: string;
    CourseDocumentProcessingStatusIdDisplay?: string;
    CourseDocumentItemStatusIdDisplay?: string;

    // Relations
    AIProcessingReference? : AIProcessingReferenceEntity;
    Course? : CourseEntity;
    CourseDocumentProcessingStatus? : CourseDocumentProcessingStatusEntity;
    DocumentItem? : DocumentItemEntity;
    CourseDocumentItemStatusIdReferenceStatus? : ReferenceStatusEntity;
    CourseModuleDocumentItem? : CourseModuleDocumentItemEntity[];
}

export interface CourseDocumentProcessingStatusEntity extends DwOrmData {
    // Attributes
    CourseDocumentProcessingStatusId?: number;
    CourseDocumentProcessingStatus?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
    CourseDocumentItem? : CourseDocumentItemEntity[];
}

export interface CourseEndorsementEntity extends DwOrmData {
    // Attributes
    CourseEndorsementId?: number;
    CourseId?: number;
    EndorsementName?: string;
    ExpirationPeriodDays?: number;
    EndorsementPDFMediaId?: number;
    EndorsementDescription?: string;
    CourseEndorsementTemplateId?: number;
    RequireAllLessonsComplete?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    IsEndorsementEnabled?: boolean;
    RequireCourseFinalComplete?: boolean;

    // Display Attributes
    CourseIdDisplay?: string;
    EndorsementPDFMediaIdDisplay?: string;
    CourseEndorsementTemplateIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    Course? : CourseEntity;
    CourseEndorsementTemplate? : CourseEndorsementTemplateEntity;
    EndorsementPDFDwMedia? : DwMediaEntity;
    CourseEndorsementLesson? : CourseEndorsementLessonEntity[];
    CourseEndorsementStudent? : CourseEndorsementStudentEntity[];
}

export interface CourseEndorsementLessonEntity extends DwOrmData {
    // Attributes
    CourseEndorsementLessonId?: number;
    CourseEndorsementId?: number;
    CourseLessonId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    CourseEndorsementIdDisplay?: string;
    CourseLessonIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    CourseEndorsement? : CourseEndorsementEntity;
    CourseLesson? : CourseLessonEntity;
}

export interface CourseEndorsementStudentEntity extends DwOrmData {
    // Attributes
    CourseEndorsementStudentId?: number;
    CourseEndorsementId?: number;
    StudentCourseId?: number;
    CompletionDateTime?: string;
    ExpirationDateTime?: string;
    EndorsementPDFMediaId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    CourseEndorsementStudentStatusId?: number;

    // Display Attributes
    CourseEndorsementIdDisplay?: string;
    StudentCourseIdDisplay?: string;
    EndorsementPDFMediaIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    CourseEndorsementStudentStatusIdDisplay?: string;

    // Relations
    CourseEndorsement? : CourseEndorsementEntity;
    EndorsementPDFDwMedia? : DwMediaEntity;
    CourseEndorsementStudentStatusIdReferenceStatus? : ReferenceStatusEntity;
    StudentCourse? : StudentCourseEntity;
}

export interface CourseEndorsementTemplateEntity extends DwOrmData {
    // Attributes
    CourseEndorsementTemplateId?: number;
    TemplateName?: string;
    TemplatePDFMediaId?: number;
    OverlayPDFMediaId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    CourseEndorsement? : CourseEndorsementEntity[];
    CourseEndorsementTemplateField? : CourseEndorsementTemplateFieldEntity[];
}

export interface CourseEndorsementTemplateFieldEntity extends DwOrmData {
    // Attributes
    CourseEndorsementTemplateFieldId?: number;
    CourseEndorsementTemplateId?: number;
    TemplateFieldTypeId?: number;
    TemplateFieldDefaultValue?: string;
    MetaDataAttributeId?: number;
    TopPosition?: number;
    LeftPosition?: number;
    RightPosition?: number;
    Height?: number;
    TemplateFontStyleId?: number;
    TemplateFieldAlignmentId?: number;
    ReferenceImageId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    CourseEndorsementTemplateIdDisplay?: string;
    TemplateFieldTypeIdDisplay?: string;
    MetaDataAttributeIdDisplay?: string;
    TemplateFontStyleIdDisplay?: string;
    TemplateFieldAlignmentIdDisplay?: string;
    ReferenceImageIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    CourseEndorsementTemplate? : CourseEndorsementTemplateEntity;
    ReferenceImage? : ReferenceImageEntity;
    TemplateFieldAlignment? : TemplateFieldAlignmentEntity;
    TemplateFieldType? : TemplateFieldTypeEntity;
    TemplateFontStyle? : TemplateFontStyleEntity;
}

export interface CourseLessonEntity extends DwOrmData {
    // Attributes
    CourseLessonId?: number;
    CourseModuleId?: number;
    LessonName?: string;
    LessonDescription?: string;
    LessonTypeId?: number;
    VideoId?: number;
    QuizId?: number;
    LessonOrder?: number;
    LessonImageMediaId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    LessonReferebcePdfMediaId?: number;
    LessonReferenceNotes?: string;
    LessonStatusId?: number;
    DocumentItemId?: number;
    IsPreview?: boolean;
    AIOverviewHtml?: string;
    AIKeyConceptText?: string;
    AIProcessingReferenceId?: number;
    LessonBasicName?: string;

    // Display Attributes
    CourseModuleIdDisplay?: string;
    LessonTypeIdDisplay?: string;
    VideoIdDisplay?: string;
    QuizIdDisplay?: string;
    LessonImageMediaIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    LessonStatusIdDisplay?: string;
    DocumentItemIdDisplay?: string;
    AIProcessingReferenceIdDisplay?: string;

    // Relations
    AIProcessingReference? : AIProcessingReferenceEntity;
    CourseModule? : CourseModuleEntity;
    DocumentItem? : DocumentItemEntity;
    LessonType? : LessonTypeEntity;
    LessonImageDwroMedia? : DwRoMediaEntity;
    Quiz? : QuizEntity;
    LessonStatusIdReferenceStatus? : ReferenceStatusEntity;
    Video? : VideoEntity;
    AcsTaskMultiAssignLesson? : AcsTaskMultiAssignLessonEntity[];
    AIPromptRequest? : AIPromptRequestEntity[];
    AssignmentCourseLesson? : AssignmentCourseLessonEntity[];
    CourseEndorsementLesson? : CourseEndorsementLessonEntity[];
    CourseLessonAcsTask? : CourseLessonAcsTaskEntity[];
    CourseLessonDocumentLink? : CourseLessonDocumentLinkEntity[];
    CourseLessonFlag? : CourseLessonFlagEntity[];
    CourseLessonProgress? : CourseLessonProgressEntity[];
    DocumentLinkProcessingRunItem? : DocumentLinkProcessingRunItemEntity[];
    CousreLessonIdIntegrationUserEvent? : IntegrationUserEventEntity[];
    RoAssignmentStudentCourseLessonProgress? : RoAssignmentStudentCourseLessonProgressEntity[];
    NextStudentCourse? : StudentCourseEntity[];
}

export interface CourseLessonAcsTaskEntity extends DwOrmData {
    // Attributes
    CourseLessonAcsTaskId?: number;
    CourseLessonId?: number;
    AcsAreaOfOperationTaskId?: number;

    // Display Attributes
    CourseLessonIdDisplay?: string;
    AcsAreaOfOperationTaskIdDisplay?: string;

    // Relations
    AcsAreaOfOperationTask? : AcsAreaOfOperationTaskEntity;
    CourseLesson? : CourseLessonEntity;
}

export interface CourseLessonDocumentLinkEntity extends DwOrmData {
    // Attributes
    CourseLessonDocumentLinkId?: number;
    CourseLessonId?: number;
    DocumentItemId?: number;
    PageNumbers?: string;
    FirstPageNumber?: number;
    AIConfidence?: string;
    AIMatchReason?: string;
    AISupportingChunkIds?: string;
    CourseLessonDocumentLinkStatusId?: number;
    ReferenceSummaryText?: string;

    // Display Attributes
    CourseLessonIdDisplay?: string;
    DocumentItemIdDisplay?: string;
    CourseLessonDocumentLinkStatusIdDisplay?: string;

    // Relations
    CourseLesson? : CourseLessonEntity;
    DocumentItem? : DocumentItemEntity;
    CourseLessonDocumentLinkStatusIdReferenceStatus? : ReferenceStatusEntity;
    CourseLessonDocumentLinkReference? : CourseLessonDocumentLinkReferenceEntity[];
    DocumentLinkProcessingRunItem? : DocumentLinkProcessingRunItemEntity[];
}

export interface CourseLessonDocumentLinkReferenceEntity extends DwOrmData {
    // Attributes
    CourseLessonDocumentLinkReferenceId?: number;
    CourseLessonDocumentLinkId?: number;
    DocumentPublicationId?: number;
    DocumentVersionId?: number;
    DocumentSectionId?: number;
    DocumentAnchorId?: number;
    ReferenceLocatorText?: string;
    DisplayOrder?: number;
    ReferenceStatusId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    CourseLessonDocumentLinkIdDisplay?: string;
    DocumentPublicationIdDisplay?: string;
    DocumentVersionIdDisplay?: string;
    DocumentSectionIdDisplay?: string;
    DocumentAnchorIdDisplay?: string;
    ReferenceStatusIdDisplay?: string;

    // Relations
    CourseLessonDocumentLink? : CourseLessonDocumentLinkEntity;
    DocumentAnchor? : DocumentAnchorEntity;
    DocumentPublication? : DocumentPublicationEntity;
    DocumentSection? : DocumentSectionEntity;
    DocumentVersion? : DocumentVersionEntity;
    ReferenceStatus? : ReferenceStatusEntity;
}

export interface CourseLessonFlagEntity extends DwOrmData {
    // Attributes
    CourseLessonFlagId?: number;
    CourseLessonId?: number;
    QuizId?: number;
    QuestionId?: number;
    FlagComment?: string;
    CourseLessonFlagStatusId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    CourseLessonFlagTypeId?: number;
    CourseId?: number;

    // Display Attributes
    CourseLessonIdDisplay?: string;
    QuizIdDisplay?: string;
    QuestionIdDisplay?: string;
    CourseLessonFlagStatusIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    CourseLessonFlagTypeIdDisplay?: string;
    CourseIdDisplay?: string;

    // Relations
    Course? : CourseEntity;
    CourseLesson? : CourseLessonEntity;
    CourseLessonFlagStatus? : CourseLessonFlagStatusEntity;
    CourseLessonFlagType? : CourseLessonFlagTypeEntity;
    Question? : QuestionEntity;
    Quiz? : QuizEntity;
    ModifiedByDwUser? : DwUserEntity;
    CreatedByDwUser? : DwUserEntity;
}

export interface CourseLessonFlagStatusEntity extends DwOrmData {
    // Attributes
    CourseLessonFlagStatusId?: number;
    FlagStatus?: string;


    // Relations
    CourseLessonFlag? : CourseLessonFlagEntity[];
}

export interface CourseLessonFlagTypeEntity extends DwOrmData {
    // Attributes
    CourseLessonFlagTypeId?: number;
    FlagType?: string;


    // Relations
    CourseLessonFlag? : CourseLessonFlagEntity[];
}

export interface CourseLessonProgressEntity extends DwOrmData {
    // Attributes
    CourseLessonProgressId?: number;
    CourseLessonId?: number;
    CourseModuleProgressId?: number;
    LessonComplete?: boolean;
    VideoFurthestTimeSeconds?: number;
    BestQuizResultId?: number;
    LastActivityDateTime?: string;
    LessonNotes?: string;
    PercentComplete?: number;
    TotalTimeSeconds?: number;
    FirstActivityDateTime?: string;
    CompletedDateTime?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    LessonProgressStatusId?: number;
    CompletedQuizAttemptCount?: number;
    PassedQuizAttemptCount?: number;

    // Display Attributes
    CourseLessonIdDisplay?: string;
    CourseModuleProgressIdDisplay?: string;
    BestQuizResultIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    LessonProgressStatusIdDisplay?: string;

    // Relations
    CourseLesson? : CourseLessonEntity;
    CourseModuleProgress? : CourseModuleProgressEntity;
    BestQuizResult? : QuizResultEntity;
    LessonProgressStatusIdReferenceStatus? : ReferenceStatusEntity;
    CourseLessonSession? : CourseLessonSessionEntity[];
    QuizResult? : QuizResultEntity[];
    RoAssignmentStudentCourseLessonProgress? : RoAssignmentStudentCourseLessonProgressEntity[];
}

export interface CourseLessonSessionEntity extends DwOrmData {
    // Attributes
    CourseLessonSessionId?: number;
    CourseLessonProgressId?: number;
    LessonCompleted?: boolean;
    VideoId?: number;
    VideoFurthestTimeSeconds?: number;
    QuizResultId?: number;
    SessionStartDateTime?: string;
    SessionEndDateTime?: string;
    TotalTimeSeconds?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    LessonSessionStatusId?: number;

    // Display Attributes
    CourseLessonProgressIdDisplay?: string;
    QuizResultIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    LessonSessionStatusIdDisplay?: string;

    // Relations
    CourseLessonProgress? : CourseLessonProgressEntity;
    QuizResult? : QuizResultEntity;
    LessonSessionStatusIdReferenceStatus? : ReferenceStatusEntity;
}

export interface CourseModificationHistoryEntity extends DwOrmData {
    // Attributes
    CourseModicationHistoryId?: number;
    CourseId?: number;
    CourseChangeDateTime?: string;
    CourseChangeDetail?: string;
    Processed?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    CourseIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    Course? : CourseEntity;
}

export interface CourseModuleEntity extends DwOrmData {
    // Attributes
    CourseModuleId?: number;
    CourseId?: number;
    ModuleName?: string;
    ModuleDescription?: string;
    ModuleImageMediaId?: number;
    ModuleOrder?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    ModuleStatusId?: number;
    TotalModuleTimeSeconds?: number;
    TotalModuleVideoTimeSeconds?: number;
    TotalModuleQuizTimeSeconds?: number;
    AIOverviewHtml?: string;
    AIKeyConceptText?: string;
    AIProcessingReferenceId?: number;
    ModuleBasicName?: string;
    DisableDocumentLinking?: boolean;

    // Display Attributes
    CourseIdDisplay?: string;
    ModuleImageMediaIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    ModuleStatusIdDisplay?: string;
    AIProcessingReferenceIdDisplay?: string;

    // Relations
    AIProcessingReference? : AIProcessingReferenceEntity;
    Course? : CourseEntity;
    ModuleImageDwMedia? : DwMediaEntity;
    ModuleImageDwroMedia? : DwRoMediaEntity;
    ModuleStatusIdReferenceStatus? : ReferenceStatusEntity;
    AIPromptRequest? : AIPromptRequestEntity[];
    CourseLesson? : CourseLessonEntity[];
    CourseModuleDocumentItem? : CourseModuleDocumentItemEntity[];
    CourseModuleProgress? : CourseModuleProgressEntity[];
    DocumentLinkProcessingRunItem? : DocumentLinkProcessingRunItemEntity[];
    Question? : QuestionEntity[];
    StudentModuleSummary? : StudentModuleSummaryEntity[];
}

export interface CourseModuleDocumentItemEntity extends DwOrmData {
    // Attributes
    CourseModuleDocumentItemId?: number;
    CourseModuleId?: number;
    CourseDocumentItemId?: number;
    AiProcessingReferenceId?: number;
    CourseModuleDocumentItemStatusId?: number;

    // Display Attributes
    CourseModuleIdDisplay?: string;
    CourseDocumentItemIdDisplay?: string;
    AiProcessingReferenceIdDisplay?: string;
    CourseModuleDocumentItemStatusIdDisplay?: string;

    // Relations
    AiProcessingReferenceIdAIProcessingReference? : AIProcessingReferenceEntity;
    CourseDocumentItem? : CourseDocumentItemEntity;
    CourseModule? : CourseModuleEntity;
    CourseModuleDocumentItemStatusIdReferenceStatus? : ReferenceStatusEntity;
}

export interface CourseModuleProgressEntity extends DwOrmData {
    // Attributes
    CourseModuleProgressId?: number;
    CourseModuleId?: number;
    PercentComplete?: number;
    LessonsCompleted?: number;
    LessonsCount?: number;
    StudentCourseId?: number;
    LastActivityDateTime?: string;
    TotalTimeSeconds?: number;
    FirstActivityDateTime?: string;
    CompletedDateTime?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    ModuleProgressStatusId?: number;
    TotalVideoTimeSeconds?: number;
    TotalQuizTimeSeconds?: number;
    AISummaryLastProcessedDateTime?: string;
    AIPromptRequestId?: number;

    // Display Attributes
    CourseModuleIdDisplay?: string;
    StudentCourseIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    ModuleProgressStatusIdDisplay?: string;
    AIPromptRequestIdDisplay?: string;

    // Relations
    AIPromptRequest? : AIPromptRequestEntity;
    CourseModule? : CourseModuleEntity;
    ModuleProgressStatusIdReferenceStatus? : ReferenceStatusEntity;
    StudentCourse? : StudentCourseEntity;
    CourseLessonProgress? : CourseLessonProgressEntity[];
    StudentModuleSummary? : StudentModuleSummaryEntity[];
}

export interface CoursePurchaseEntity extends DwOrmData {
    // Attributes
    CoursePurchaseId?: number;
    AddCoursePackage?: boolean;
    PaymentPartyTypeId?: number;
    InvoiceId?: number;
    UseFlightSchoolGroup?: boolean;
    FlightSchoolGroupId?: number;
    DiscountCode?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    StripeCheckoutSessionId?: number;

    // Display Attributes
    PaymentPartyTypeIdDisplay?: string;
    InvoiceIdDisplay?: string;
    FlightSchoolGroupIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    StripeCheckoutSessionIdDisplay?: string;

    // Relations
    FlightSchoolGroup? : FlightSchoolGroupEntity;
    Invoice? : InvoiceEntity;
    PaymentPartyType? : PaymentPartyTypeEntity;
    StripeCheckoutSession? : StripeCheckoutSessionEntity;
    CoursePurchaseCourse? : CoursePurchaseCourseEntity[];
    CoursePurchasePackage? : CoursePurchasePackageEntity[];
    CoursePurchaseReservation? : CoursePurchaseReservationEntity[];
    CoursePurchaseStudent? : CoursePurchaseStudentEntity[];
}

export interface CoursePurchaseBillingAttemptEntity extends DwOrmData {
    // Attributes
    CoursePurchaseBillingAttemptId?: number;
    CoursePurchaseReservationId?: number;
    OperationKey?: string;
    AttemptNumber?: number;
    StripeIdempotencyKey?: string;
    RequestFingerprint?: string;
    CoursePurchaseBillingAttemptStatusId?: number;
    StripeInvoiceRef?: string;
    StripePaymentIntentRef?: string;
    StripeCheckoutSessionRef?: string;
    LastErrorLogId?: number;
    LastErrorMessage?: string;
    CompletedUtc?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    CoursePurchaseReservationIdDisplay?: string;
    CoursePurchaseBillingAttemptStatusIdDisplay?: string;

    // Relations
    CoursePurchaseBillingAttemptStatus? : CoursePurchaseBillingAttemptStatusEntity;
    CoursePurchaseReservation? : CoursePurchaseReservationEntity;
}

export interface CoursePurchaseBillingAttemptStatusEntity extends DwOrmData {
    // Attributes
    CoursePurchaseBillingAttemptStatusId?: number;
    CoursePurchaseBillingAttemptStatus?: string;


    // Relations
    CoursePurchaseBillingAttempt? : CoursePurchaseBillingAttemptEntity[];
}

export interface CoursePurchaseCourseEntity extends DwOrmData {
    // Attributes
    CoursePurchaseCourseId?: number;
    CoursePurchaseId?: number;
    CourseId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    CoursePurchaseIdDisplay?: string;
    CourseIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    Course? : CourseEntity;
    CoursePurchase? : CoursePurchaseEntity;
}

export interface CoursePurchasePackageEntity extends DwOrmData {
    // Attributes
    CoursePurchasePackageId?: number;
    CoursePurchaseId?: number;
    PackageId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    CoursePurchaseIdDisplay?: string;
    PackageIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    CoursePurchase? : CoursePurchaseEntity;
    Package? : PackageEntity;
}

export interface CoursePurchaseReservationEntity extends DwOrmData {
    // Attributes
    CoursePurchaseReservationId?: number;
    RequestKey?: string;
    RequestFingerprint?: string;
    CoursePurchaseId?: number;
    FlightSchoolId?: number;
    PaymentPartyTypeId?: number;
    CoursePurchaseReservationStatusId?: number;
    InvoiceId?: number;
    WorkerToken?: string;
    WorkerLeaseExpiresUtc?: string;
    LastAttemptUtc?: string;
    LastErrorLogId?: number;
    LastErrorMessage?: string;
    FulfilledUtc?: string;
    ReleasedUtc?: string;
    ReleaseReason?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    CoursePurchaseIdDisplay?: string;
    FlightSchoolIdDisplay?: string;
    PaymentPartyTypeIdDisplay?: string;
    CoursePurchaseReservationStatusIdDisplay?: string;
    InvoiceIdDisplay?: string;

    // Relations
    CoursePurchase? : CoursePurchaseEntity;
    CoursePurchaseReservationStatus? : CoursePurchaseReservationStatusEntity;
    FlightSchool? : FlightSchoolEntity;
    Invoice? : InvoiceEntity;
    PaymentPartyType? : PaymentPartyTypeEntity;
    CoursePurchaseBillingAttempt? : CoursePurchaseBillingAttemptEntity[];
    CoursePurchaseReservationCourse? : CoursePurchaseReservationCourseEntity[];
}

export interface CoursePurchaseReservationCourseEntity extends DwOrmData {
    // Attributes
    CoursePurchaseReservationCourseId?: number;
    CoursePurchaseReservationId?: number;
    UserId?: number;
    StudentId?: number;
    CourseId?: number;
    CoursePackageId?: number;
    InvoiceLineId?: number;
    StudentCourseId?: number;
    FulfilledUtc?: string;
    ReleasedUtc?: string;
    ReleaseReason?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    CoursePurchaseReservationIdDisplay?: string;
    UserIdDisplay?: string;
    StudentIdDisplay?: string;
    CourseIdDisplay?: string;
    CoursePackageIdDisplay?: string;
    InvoiceLineIdDisplay?: string;
    StudentCourseIdDisplay?: string;

    // Relations
    Course? : CourseEntity;
    CoursePurchaseReservation? : CoursePurchaseReservationEntity;
    InvoiceLine? : InvoiceLineEntity;
    CoursePackage? : PackageEntity;
    Student? : StudentEntity;
    StudentCourse? : StudentCourseEntity;
    DwUser? : DwUserEntity;
}

export interface CoursePurchaseReservationStatusEntity extends DwOrmData {
    // Attributes
    CoursePurchaseReservationStatusId?: number;
    CoursePurchaseReservationStatus?: string;


    // Relations
    CoursePurchaseReservation? : CoursePurchaseReservationEntity[];
}

export interface CoursePurchaseStudentEntity extends DwOrmData {
    // Attributes
    CoursePurchaseStudent?: number;
    CoursePurchaseId?: number;
    StudentId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    CoursePurchaseIdDisplay?: string;
    StudentIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    CoursePurchase? : CoursePurchaseEntity;
    Student? : StudentEntity;
}

export interface CourseTypeEntity extends DwOrmData {
    // Attributes
    CourseTypeId?: number;
    CourseType?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    Course? : CourseEntity[];
}

export interface DailyQuizEntity extends DwOrmData {
    // Attributes
    DailyQuizId?: number;
    StudentCourseId?: number;
    DailyQuizDate?: string;
    AttemptCount?: number;
    MaxAttempts?: number;
    PassingPercent?: number;
    BestQuizResultId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    StudentId?: number;

    // Display Attributes
    StudentCourseIdDisplay?: string;
    BestQuizResultIdDisplay?: string;
    StudentIdDisplay?: string;

    // Relations
    BestQuizResult? : QuizResultEntity;
    Student? : StudentEntity;
    StudentCourse? : StudentCourseEntity;
    QuizResult? : QuizResultEntity[];
}

export interface DiscountEntity extends DwOrmData {
    // Attributes
    DiscountId?: number;
    DiscountName?: string;
    DiscountCode?: string;
    StartDate?: string;
    EndDate?: string;
    AllowedUses?: number;
    CurrentUses?: number;
    AllowedUsesPerUser?: number;
    AllowedUsesPerSchool?: number;
    LimitToUserId?: number;
    LimitToFlightSchoolId?: number;
    ApplyToCourse?: boolean;
    ApplyToSubscription?: boolean;
    CourseDiscountAmount?: number;
    CourseDiscountPercent?: number;
    SubscriptionDiscountAmount?: number;
    SubscriptionDiscountPercent?: number;
    SubscriptionTierId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    IsActive?: boolean;
    IsDefaultNewSchoolDiscount?: boolean;
    SubscriptionExpiresAfterMonths?: number;
    DiscountAppliedDescription?: string;
    StripePromotionCodeId?: string;
    StripeCouponCodeId?: string;

    // Display Attributes
    LimitToUserIdDisplay?: string;
    LimitToFlightSchoolIdDisplay?: string;
    SubscriptionTierIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    LimitToFlightSchool? : FlightSchoolEntity;
    SubscriptionTier? : SubscriptionTierEntity;
    LimitToDwUser? : DwUserEntity;
    DiscountCourse? : DiscountCourseEntity[];
    DiscountPackage? : DiscountPackageEntity[];
    DiscountSubscriptionRole? : DiscountSubscriptionRoleEntity[];
    DiscountUsageFlightSchool? : DiscountUsageFlightSchoolEntity[];
    DiscountUsageUser? : DiscountUsageUserEntity[];
    InvoiceLine? : InvoiceLineEntity[];
    StripeCheckoutSession? : StripeCheckoutSessionEntity[];
    Subscription? : SubscriptionEntity[];
}

export interface DiscountCourseEntity extends DwOrmData {
    // Attributes
    DiscountCourseId?: number;
    DiscountId?: number;
    CourseId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    DiscountIdDisplay?: string;
    CourseIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    Course? : CourseEntity;
    Discount? : DiscountEntity;
}

export interface DiscountPackageEntity extends DwOrmData {
    // Attributes
    DiscountPackageId?: number;
    DiscountId?: number;
    PackageId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    DiscountIdDisplay?: string;
    PackageIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    Discount? : DiscountEntity;
    Package? : PackageEntity;
}

export interface DiscountSubscriptionRoleEntity extends DwOrmData {
    // Attributes
    DiscountSubscriptionRoleId?: number;
    DiscountId?: number;
    SubscriptionRoleId?: number;
    DiscountAmount?: number;
    DiscountPercent?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    DiscountIdDisplay?: string;
    SubscriptionRoleIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    Discount? : DiscountEntity;
    SubscriptionRole? : SubscriptionRoleEntity;
}

export interface DiscountUsageFlightSchoolEntity extends DwOrmData {
    // Attributes
    DiscountUsageFlightSchoolId?: number;
    DiscountId?: number;
    FlightSchoolId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    InvoiceLineId?: number;
    DiscountAppliedDateTime?: string;
    DiscountExpirationDateTime?: string;

    // Display Attributes
    DiscountIdDisplay?: string;
    FlightSchoolIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    InvoiceLineIdDisplay?: string;

    // Relations
    Discount? : DiscountEntity;
    FlightSchool? : FlightSchoolEntity;
    InvoiceLine? : InvoiceLineEntity;
}

export interface DiscountUsageUserEntity extends DwOrmData {
    // Attributes
    DiscountUsageUserId?: number;
    DiscountId?: number;
    UserId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    DiscountIdDisplay?: string;
    UserIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    Discount? : DiscountEntity;
    DwUser? : DwUserEntity;
}

export interface DocumentAiProcessingStatusEntity extends DwOrmData {
    // Attributes
    DocumentAiProcessingStatusId?: number;
    DocumentAiProcessingStatus?: string;


    // Relations
    DocumentItem? : DocumentItemEntity[];
}

export interface DocumentAnchorEntity extends DwOrmData {
    // Attributes
    DocumentAnchorId?: number;
    DocumentSectionId?: number;
    DocumentAnchorTypeId?: number;
    AnchorKey?: string;
    Label?: string;
    DisplayOrder?: number;
    ReferenceStatusId?: number;

    // Display Attributes
    DocumentSectionIdDisplay?: string;
    DocumentAnchorTypeIdDisplay?: string;
    ReferenceStatusIdDisplay?: string;

    // Relations
    DocumentAnchorType? : DocumentAnchorTypeEntity;
    DocumentSection? : DocumentSectionEntity;
    ReferenceStatus? : ReferenceStatusEntity;
    CourseLessonDocumentLinkReference? : CourseLessonDocumentLinkReferenceEntity[];
}

export interface DocumentAnchorTypeEntity extends DwOrmData {
    // Attributes
    DocumentAnchorTypeId?: number;
    DocumentAnchorType?: string;


    // Relations
    DocumentAnchor? : DocumentAnchorEntity[];
}

export interface DocumentAssetEntity extends DwOrmData {
    // Attributes
    DocumentAssetId?: number;
    DocumentVersionId?: number;
    DocumentSectionId?: number;
    DocumentAssetTypeId?: number;
    AssetKey?: string;
    MediaId?: number;
    ReferenceStatusId?: number;

    // Display Attributes
    DocumentVersionIdDisplay?: string;
    DocumentSectionIdDisplay?: string;
    DocumentAssetTypeIdDisplay?: string;
    MediaIdDisplay?: string;
    ReferenceStatusIdDisplay?: string;

    // Relations
    DocumentAssetType? : DocumentAssetTypeEntity;
    DocumentSection? : DocumentSectionEntity;
    DocumentVersion? : DocumentVersionEntity;
    DwMedia? : DwMediaEntity;
    ReferenceStatus? : ReferenceStatusEntity;
}

export interface DocumentAssetTypeEntity extends DwOrmData {
    // Attributes
    DocumentAssetTypeId?: number;
    DocumentAssetType?: string;


    // Relations
    DocumentAsset? : DocumentAssetEntity[];
}

export interface DocumentChangeLogTypeEntity extends DwOrmData {
    // Attributes
    DocumentChangeLogTypeId?: number;
    DocumentChangeLogType?: string;


    // Relations
    ChangeLogTypeIdDocumentFolderChangeLog? : DocumentFolderChangeLogEntity[];
    ChangeLogTypeIdDocumentItemChangeLog? : DocumentItemChangeLogEntity[];
}

export interface DocumentContentFormatTypeEntity extends DwOrmData {
    // Attributes
    DocumentContentFormatTypeId?: number;
    DocumentContentFormatType?: string;


    // Relations
    DocumentSectionContent? : DocumentSectionContentEntity[];
}

export interface DocumentFolderEntity extends DwOrmData {
    // Attributes
    DocumentFolderId?: number;
    DocumentGroupId?: number;
    ParentDocumentFolderId?: number;
    FolderName?: string;
    FolderIconMediaId?: number;
    DocumentItemStatusId?: number;
    DocumentOwnershipTypeId?: number;
    FlightSchoolId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    DocumentGroupIdDisplay?: string;
    ParentDocumentFolderIdDisplay?: string;
    FolderIconMediaIdDisplay?: string;
    DocumentItemStatusIdDisplay?: string;
    DocumentOwnershipTypeIdDisplay?: string;
    FlightSchoolIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    DocumentGroup? : DocumentGroupEntity;
    DocumentItemStatus? : DocumentItemStatusEntity;
    DocumentOwnershipTypeIdDocumentOwnerType? : DocumentOwnerTypeEntity;
    FlightSchool? : FlightSchoolEntity;
    FolderIconDwMedia? : DwMediaEntity;
    ParentDocumentFolder? : DocumentFolderEntity;
    DocumentFolderChangeLog? : DocumentFolderChangeLogEntity[];
    ParentDocumentItem? : DocumentItemEntity[];
    // Duplicate property excluded
    // ParentDocumentFolder : DocumentFolderEntity[];
}

export interface DocumentFolderChangeLogEntity extends DwOrmData {
    // Attributes
    DocumentFolderChangeLogId?: number;
    DocumentFolderId?: number;
    ChangeLogTypeId?: number;
    ChangeLogText?: string;
    CreatedBy?: number;
    CreateDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    DocumentFolderIdDisplay?: string;
    ChangeLogTypeIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    ChangeLogTypeIdDocumentChangeLogType? : DocumentChangeLogTypeEntity;
    DocumentFolder? : DocumentFolderEntity;
}

export interface DocumentGroupEntity extends DwOrmData {
    // Attributes
    DocumentGroupId?: number;
    DocumentGroupName?: string;
    IsDefault?: boolean;
    AllowSchoolDocuments?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    DocumentFolder? : DocumentFolderEntity[];
    DocumentItem? : DocumentItemEntity[];
}

export interface DocumentImportJobEntity extends DwOrmData {
    // Attributes
    DocumentImportJobId?: number;
    DocumentPublicationId?: number;
    DocumentImportJobTypeId?: number;
    DocumentImportJobStatusId?: number;
    StartedDateTime?: string;
    CompletedDateTime?: string;
    ImportedDocumentVersionId?: number;
    ErrorText?: string;
    LastUpdatedDateTime?: string;
    ProgressText?: string;
    LastErrorLogId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    DocumentPublicationIdDisplay?: string;
    DocumentImportJobTypeIdDisplay?: string;
    DocumentImportJobStatusIdDisplay?: string;
    ImportedDocumentVersionIdDisplay?: string;
    LastErrorLogIdDisplay?: string;

    // Relations
    DocumentImportJobStatus? : DocumentImportJobStatusEntity;
    DocumentImportJobType? : DocumentImportJobTypeEntity;
    DocumentPublication? : DocumentPublicationEntity;
    ImportedDocumentVersion? : DocumentVersionEntity;
}

export interface DocumentImportJobStatusEntity extends DwOrmData {
    // Attributes
    DocumentImportJobStatusId?: number;
    DocumentImportJobStatus?: string;


    // Relations
    DocumentImportJob? : DocumentImportJobEntity[];
}

export interface DocumentImportJobTypeEntity extends DwOrmData {
    // Attributes
    DocumentImportJobTypeId?: number;
    DocumentImportJobType?: string;


    // Relations
    DocumentImportJob? : DocumentImportJobEntity[];
}

export interface DocumentItemEntity extends DwOrmData {
    // Attributes
    DocumentItemId?: number;
    DocumentGroupId?: number;
    DocumentItemName?: string;
    MediaId?: number;
    CardIconMediaId?: number;
    DocumentTypeId?: number;
    DocumentItemStatusId?: number;
    EmbeddedMarkup?: string;
    ExtractedImageMediaId?: number;
    UseCustomCardIcon?: boolean;
    DocumentOwnershipTypeId?: number;
    FlightSchoolId?: number;
    ParentDocumentFolderId?: number;
    RequireStudentAcknowledgement?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    AiProcessingReferenceId?: number;
    DocumentFileHash?: string;
    DocumentAiComplete?: boolean;
    DocumentAiProcessingStatusId?: number;
    DocumentAiProcessingProgressText?: string;
    DocumentAiProcessingErrorText?: string;
    DocumentAiProcessingStartDateTime?: string;
    DocumentAiProcessingCompletedDateTime?: string;
    DocumentAiProcessingLastUpdatedDateTime?: string;
    DocumentAiProcessingEstimatedCompletedDateTime?: string;
    DocumentAiProcessingTotalChunkCount?: number;
    DocumentAiProcessingProcessedChunkCount?: number;
    DocumentAiProcessingFailedChunkCount?: number;
    DocumentAiProcessingTotalModuleLinkCount?: number;
    DocumentAiProcessingProcessedModuleLinkCount?: number;
    DocumentAiProcessingFailedModuleLinkCount?: number;

    // Display Attributes
    DocumentGroupIdDisplay?: string;
    MediaIdDisplay?: string;
    CardIconMediaIdDisplay?: string;
    DocumentTypeIdDisplay?: string;
    DocumentItemStatusIdDisplay?: string;
    ExtractedImageMediaIdDisplay?: string;
    DocumentOwnershipTypeIdDisplay?: string;
    FlightSchoolIdDisplay?: string;
    ParentDocumentFolderIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    DocumentAiProcessingStatusIdDisplay?: string;

    // Relations
    DocumentAiProcessingStatus? : DocumentAiProcessingStatusEntity;
    ParentDocumentFolder? : DocumentFolderEntity;
    DocumentGroup? : DocumentGroupEntity;
    DocumentItemStatus? : DocumentItemStatusEntity;
    DocumentOwnershipTypeIdDocumentOwnerType? : DocumentOwnerTypeEntity;
    DocumentType? : DocumentTypeEntity;
    FlightSchool? : FlightSchoolEntity;
    DwMedia? : DwMediaEntity;
    CardIconDwMedia? : DwMediaEntity;
    ExtractedImageDwMedia? : DwMediaEntity;
    CourseDocumentItem? : CourseDocumentItemEntity[];
    CourseLesson? : CourseLessonEntity[];
    CourseLessonDocumentLink? : CourseLessonDocumentLinkEntity[];
    DocumentItemAcknowledgement? : DocumentItemAcknowledgementEntity[];
    DocumentItemChangeLog? : DocumentItemChangeLogEntity[];
    DocumentItemChunk? : DocumentItemChunkEntity[];
    DocumentItemPage? : DocumentItemPageEntity[];
    DocumentLinkProcessingRun? : DocumentLinkProcessingRunEntity[];
    DocumentPublication? : DocumentPublicationEntity[];
    UserDocumentSectionFavorite? : UserDocumentSectionFavoriteEntity[];
}

export interface DocumentItemAcknowledgementEntity extends DwOrmData {
    // Attributes
    DocumentItemAcknowledgementId?: number;
    DocumentItemId?: number;
    StudentId?: number;
    AcknowledgedDateTime?: string;

    // Display Attributes
    DocumentItemIdDisplay?: string;
    StudentIdDisplay?: string;

    // Relations
    DocumentItem? : DocumentItemEntity;
    Student? : StudentEntity;
}

export interface DocumentItemChangeLogEntity extends DwOrmData {
    // Attributes
    DocumentItemChangeLogId?: number;
    DocumentItemId?: number;
    ChangeLogTypeId?: number;
    ChangeLogText?: string;
    CreatedBy?: number;
    CreateDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    MediaId?: number;

    // Display Attributes
    DocumentItemIdDisplay?: string;
    ChangeLogTypeIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    ChangeLogTypeIdDocumentChangeLogType? : DocumentChangeLogTypeEntity;
    DocumentItem? : DocumentItemEntity;
}

export interface DocumentItemChunkEntity extends DwOrmData {
    // Attributes
    DocumentItemChunkId?: number;
    DocumentItemId?: number;
    ChunkIndex?: number;
    StartPageNumber?: number;
    EndPageNumber?: number;
    ChunkText?: string;
    ChunkSummary?: string;
    CharacterCount?: number;
    AIProcessingReferenceId?: number;
    Keywords?: string;
    Topics?: string;
    ImportantTerms?: string;
    VectorReferenceId?: number;
    DocumentItemChunkContentTypeId?: number;

    // Display Attributes
    DocumentItemIdDisplay?: string;
    AIProcessingReferenceIdDisplay?: string;
    VectorReferenceIdDisplay?: string;
    DocumentItemChunkContentTypeIdDisplay?: string;

    // Relations
    AIProcessingReference? : AIProcessingReferenceEntity;
    DocumentItem? : DocumentItemEntity;
    DocumentItemChunkContentType? : DocumentItemChunkContentTypeEntity;
    VectorReference? : VectorReferenceEntity;
}

export interface DocumentItemChunkContentTypeEntity extends DwOrmData {
    // Attributes
    DocumentItemChunkContentTypeId?: number;
    DocumentItemChunkContentType?: string;
    ExcludeFromVectorSearch?: boolean;


    // Relations
    DocumentItemChunk? : DocumentItemChunkEntity[];
}

export interface DocumentItemPageEntity extends DwOrmData {
    // Attributes
    DocumentItemPageId?: number;
    DocumentItemId?: number;
    PageNumber?: number;
    PageText?: string;
    CharacterCount?: number;
    HasText?: boolean;

    // Display Attributes
    DocumentItemIdDisplay?: string;

    // Relations
    DocumentItem? : DocumentItemEntity;
}

export interface DocumentItemStatusEntity extends DwOrmData {
    // Attributes
    DocumentItemStatusId?: number;
    DocumentItemStatus?: string;


    // Relations
    DocumentFolder? : DocumentFolderEntity[];
    DocumentItem? : DocumentItemEntity[];
}

export interface DocumentLinkProcessingRunEntity extends DwOrmData {
    // Attributes
    DocumentLinkProcessingRunId?: number;
    DocumentItemId?: number;
    DocumentPublicationId?: number;
    DocumentVersionId?: number;
    CourseId?: number;
    DocumentLinkProcessingTriggerTypeId?: number;
    DocumentLinkProcessingRunStatusId?: number;
    CorrelationId?: string;
    CurrentStage?: string;
    ProgressText?: string;
    ErrorText?: string;
    StartedDateTime?: string;
    CompletedDateTime?: string;
    LastUpdatedDateTime?: string;
    TotalLessonCount?: number;
    EvaluatedLessonCount?: number;
    DirectLinkedCount?: number;
    AIQueuedCount?: number;
    AILinkedCount?: number;
    SkippedCount?: number;
    FailedCount?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    DocumentItemIdDisplay?: string;
    DocumentPublicationIdDisplay?: string;
    DocumentVersionIdDisplay?: string;
    CourseIdDisplay?: string;
    DocumentLinkProcessingTriggerTypeIdDisplay?: string;
    DocumentLinkProcessingRunStatusIdDisplay?: string;

    // Relations
    Course? : CourseEntity;
    DocumentItem? : DocumentItemEntity;
    DocumentLinkProcessingRunStatus? : DocumentLinkProcessingRunStatusEntity;
    DocumentLinkProcessingTriggerType? : DocumentLinkProcessingTriggerTypeEntity;
    DocumentPublication? : DocumentPublicationEntity;
    DocumentVersion? : DocumentVersionEntity;
    DocumentLinkProcessingRunItem? : DocumentLinkProcessingRunItemEntity[];
}

export interface DocumentLinkProcessingRunItemEntity extends DwOrmData {
    // Attributes
    DocumentLinkProcessingRunItemId?: number;
    DocumentLinkProcessingRunId?: number;
    CourseId?: number;
    CourseModuleId?: number;
    CourseLessonId?: number;
    CourseLessonDocumentLinkId?: number;
    AIProcessingReferenceId?: number;
    DocumentLinkProcessingRunItemStatusId?: number;
    DocumentLinkSourceTypeId?: number;
    ProgressText?: string;
    ErrorCode?: string;
    ErrorText?: string;
    StartedDateTime?: string;
    CompletedDateTime?: string;
    LastUpdatedDateTime?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    DocumentLinkProcessingRunIdDisplay?: string;
    CourseIdDisplay?: string;
    CourseModuleIdDisplay?: string;
    CourseLessonIdDisplay?: string;
    CourseLessonDocumentLinkIdDisplay?: string;
    AIProcessingReferenceIdDisplay?: string;
    DocumentLinkProcessingRunItemStatusIdDisplay?: string;
    DocumentLinkSourceTypeIdDisplay?: string;

    // Relations
    AIProcessingReference? : AIProcessingReferenceEntity;
    Course? : CourseEntity;
    CourseLesson? : CourseLessonEntity;
    CourseLessonDocumentLink? : CourseLessonDocumentLinkEntity;
    CourseModule? : CourseModuleEntity;
    DocumentLinkProcessingRun? : DocumentLinkProcessingRunEntity;
    DocumentLinkProcessingRunItemStatus? : DocumentLinkProcessingRunItemStatusEntity;
    DocumentLinkSourceType? : DocumentLinkSourceTypeEntity;
}

export interface DocumentLinkProcessingRunItemStatusEntity extends DwOrmData {
    // Attributes
    DocumentLinkProcessingRunItemStatusId?: number;
    DocumentLinkProcessingRunItemStatus?: string;


    // Relations
    DocumentLinkProcessingRunItem? : DocumentLinkProcessingRunItemEntity[];
}

export interface DocumentLinkProcessingRunStatusEntity extends DwOrmData {
    // Attributes
    DocumentLinkProcessingRunStatusId?: number;
    DocumentLinkProcessingRunStatus?: string;


    // Relations
    DocumentLinkProcessingRun? : DocumentLinkProcessingRunEntity[];
}

export interface DocumentLinkProcessingTriggerTypeEntity extends DwOrmData {
    // Attributes
    DocumentLinkProcessingTriggerTypeId?: number;
    DocumentLinkProcessingTriggerType?: string;


    // Relations
    DocumentLinkProcessingRun? : DocumentLinkProcessingRunEntity[];
}

export interface DocumentLinkSourceTypeEntity extends DwOrmData {
    // Attributes
    DocumentLinkSourceTypeId?: number;
    DocumentLinkSourceType?: string;


    // Relations
    DocumentLinkProcessingRunItem? : DocumentLinkProcessingRunItemEntity[];
}

export interface DocumentOwnerTypeEntity extends DwOrmData {
    // Attributes
    DocumentOwnerTypeId?: number;
    DocumentOwnerType?: string;


    // Relations
    DocumentOwnershipTypeIdDocumentFolder? : DocumentFolderEntity[];
    DocumentOwnershipTypeIdDocumentItem? : DocumentItemEntity[];
}

export interface DocumentPublicationEntity extends DwOrmData {
    // Attributes
    DocumentPublicationId?: number;
    DocumentItemId?: number;
    DocumentPublicationTypeId?: number;
    PublicationCode?: string;
    PublicationName?: string;
    ReferenceStatusId?: number;
    CurrentDocumentVersionId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    DocumentReferenceSourceId?: number;

    // Display Attributes
    DocumentItemIdDisplay?: string;
    DocumentPublicationTypeIdDisplay?: string;
    ReferenceStatusIdDisplay?: string;
    CurrentDocumentVersionIdDisplay?: string;
    DocumentReferenceSourceIdDisplay?: string;

    // Relations
    DocumentItem? : DocumentItemEntity;
    DocumentPublicationType? : DocumentPublicationTypeEntity;
    DocumentReferenceSource? : DocumentReferenceSourceEntity;
    CurrentDocumentVersion? : DocumentVersionEntity;
    ReferenceStatus? : ReferenceStatusEntity;
    CourseLessonDocumentLinkReference? : CourseLessonDocumentLinkReferenceEntity[];
    DocumentImportJob? : DocumentImportJobEntity[];
    DocumentLinkProcessingRun? : DocumentLinkProcessingRunEntity[];
    DocumentVersion? : DocumentVersionEntity[];
}

export interface DocumentPublicationTypeEntity extends DwOrmData {
    // Attributes
    DocumentPublicationTypeId?: number;
    DocumentPublicationType?: string;


    // Relations
    DocumentPublication? : DocumentPublicationEntity[];
}

export interface DocumentReferenceSourceEntity extends DwOrmData {
    // Attributes
    DocumentReferenceSourceId?: number;
    DocumentReferenceSource?: string;


    // Relations
    DocumentPublication? : DocumentPublicationEntity[];
}

export interface DocumentSectionEntity extends DwOrmData {
    // Attributes
    DocumentSectionId?: number;
    DocumentVersionId?: number;
    ParentDocumentSectionId?: number;
    DocumentSectionTypeId?: number;
    SectionKey?: string;
    SectionSlug?: string;
    Label?: string;
    Title?: string;
    DisplayOrder?: number;
    ReferenceStatusId?: number;
    VectorReferenceId?: number;

    // Display Attributes
    DocumentVersionIdDisplay?: string;
    ParentDocumentSectionIdDisplay?: string;
    DocumentSectionTypeIdDisplay?: string;
    ReferenceStatusIdDisplay?: string;
    VectorReferenceIdDisplay?: string;

    // Relations
    DocumentSectionType? : DocumentSectionTypeEntity;
    DocumentVersion? : DocumentVersionEntity;
    ParentDocumentSection? : DocumentSectionEntity;
    ReferenceStatus? : ReferenceStatusEntity;
    VectorReference? : VectorReferenceEntity;
    CourseLessonDocumentLinkReference? : CourseLessonDocumentLinkReferenceEntity[];
    DocumentAnchor? : DocumentAnchorEntity[];
    DocumentAsset? : DocumentAssetEntity[];
    DocumentSectionContent? : DocumentSectionContentEntity[];
    // Duplicate property excluded
    // ParentDocumentSection : DocumentSectionEntity[];
    OriginalUserDocumentSectionFavorite? : UserDocumentSectionFavoriteEntity[];
}

export interface DocumentSectionContentEntity extends DwOrmData {
    // Attributes
    DocumentSectionContentId?: number;
    DocumentSectionId?: number;
    DocumentContentFormatTypeId?: number;
    BlockJson?: string;
    PlainText?: string;
    ReferenceStatusId?: number;

    // Display Attributes
    DocumentSectionIdDisplay?: string;
    DocumentContentFormatTypeIdDisplay?: string;
    ReferenceStatusIdDisplay?: string;

    // Relations
    DocumentContentFormatType? : DocumentContentFormatTypeEntity;
    DocumentSection? : DocumentSectionEntity;
    ReferenceStatus? : ReferenceStatusEntity;
}

export interface DocumentSectionTypeEntity extends DwOrmData {
    // Attributes
    DocumentSectionTypeId?: number;
    DocumentSectionType?: string;


    // Relations
    DocumentSection? : DocumentSectionEntity[];
}

export interface DocumentTypeEntity extends DwOrmData {
    // Attributes
    DocumentTypeId?: number;
    DocumentType?: string;
    UseEmbeddedMarkup?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    DocumentItem? : DocumentItemEntity[];
}

export interface DocumentVersionEntity extends DwOrmData {
    // Attributes
    DocumentVersionId?: number;
    DocumentPublicationId?: number;
    DocumentVersionTypeId?: number;
    VersionLabel?: string;
    SourceVersion?: string;
    SourcePublishedDate?: string;
    ReferenceStatusId?: number;
    IsPublished?: boolean;
    PublishedDateTime?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    DocumentPublicationIdDisplay?: string;
    DocumentVersionTypeIdDisplay?: string;
    ReferenceStatusIdDisplay?: string;

    // Relations
    DocumentPublication? : DocumentPublicationEntity;
    DocumentVersionType? : DocumentVersionTypeEntity;
    ReferenceStatus? : ReferenceStatusEntity;
    CourseLessonDocumentLinkReference? : CourseLessonDocumentLinkReferenceEntity[];
    DocumentAsset? : DocumentAssetEntity[];
    ImportedDocumentImportJob? : DocumentImportJobEntity[];
    DocumentLinkProcessingRun? : DocumentLinkProcessingRunEntity[];
    CurrentDocumentPublication? : DocumentPublicationEntity[];
    DocumentSection? : DocumentSectionEntity[];
    OriginalUserDocumentSectionFavorite? : UserDocumentSectionFavoriteEntity[];
}

export interface DocumentVersionTypeEntity extends DwOrmData {
    // Attributes
    DocumentVersionTypeId?: number;
    DocumentVersionType?: string;


    // Relations
    DocumentVersion? : DocumentVersionEntity[];
}

export interface FlightSchoolEntity extends DwOrmData {
    // Attributes
    FlightSchoolId?: number;
    FlightSchoolName?: string;
    FlightSchoolStatusId?: number;
    NumberOfAircraft?: number;
    Location?: string;
    NumberOfStudents?: number;
    PercentDiscount?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    IsDefaultFlightSchool?: boolean;
    FlightSchoolBrandingId?: number;
    ProfitSharingPercentageOverride?: number;
    IsMarketplaceEnabled?: boolean;
    PortalConfigId?: string;
    ProfitSharingExcludeOnSchoolInvoices?: boolean;
    IsAIModuleSummaryEnabled?: boolean;
    UniqueId?: string;
    DeferredCourseBillingEnabled?: boolean;
    StudentProfitSharingReductionEnabled?: boolean;
    UniversityBillingModeEnabled?: boolean;
    DeferredInvoicePaymentTermsDays?: number;
    InactiveStudentRemovalEnabled?: boolean;
    InactiveStudentRemovalDays?: number;
    BillingContactEmail?: string;
    BillingAddressId?: number;
    RestrictRegistrationEmailDomains?: boolean;
    AllowInstructorRegistrationRoleSelection?: boolean;
    DefaultTimeZoneId?: number;
    IsTaxExempt?: boolean;
    SchoolBillingModeId?: number;

    // Display Attributes
    FlightSchoolStatusIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    FlightSchoolBrandingIdDisplay?: string;
    BillingAddressIdDisplay?: string;
    DefaultTimeZoneIdDisplay?: string;
    SchoolBillingModeIdDisplay?: string;

    // Relations
    BillingAddress? : AddressEntity;
    FlightSchoolBranding? : FlightSchoolBrandingEntity;
    FlightSchoolStatus? : FlightSchoolStatusEntity;
    SchoolBillingMode? : SchoolBillingModeEntity;
    DefaultTimeZoneIdTimeZone? : TimeZoneEntity;
    Assignment? : AssignmentEntity[];
    CourseAvailabilityNotification? : CourseAvailabilityNotificationEntity[];
    CoursePurchaseReservation? : CoursePurchaseReservationEntity[];
    LimitToDiscount? : DiscountEntity[];
    DiscountUsageFlightSchool? : DiscountUsageFlightSchoolEntity[];
    DocumentFolder? : DocumentFolderEntity[];
    DocumentItem? : DocumentItemEntity[];
    FlightSchoolBillingContact? : FlightSchoolBillingContactEntity[];
    FlightSchoolCourse? : FlightSchoolCourseEntity[];
    FlightSchoolFeature? : FlightSchoolFeatureEntity[];
    FlightSchoolGroup? : FlightSchoolGroupEntity[];
    FlightSchoolInstructor? : FlightSchoolInstructorEntity[];
    FlightSchoolPackage? : FlightSchoolPackageEntity[];
    FlightSchoolRegistrationEmailDomain? : FlightSchoolRegistrationEmailDomainEntity[];
    FlightSchoolRegistrationLink? : FlightSchoolRegistrationLinkEntity[];
    GamificationConfiguration? : GamificationConfigurationEntity[];
    Instructor? : InstructorEntity[];
    IntegrationOrganization? : IntegrationOrganizationEntity[];
    Invoice? : InvoiceEntity[];
    JoinRequest? : JoinRequestEntity[];
    JoinRequestCoursePurchase? : JoinRequestCoursePurchaseEntity[];
    MultipleAssignFlightSchool? : MultipleAssignFlightSchoolEntity[];
    ProcessorConfig? : ProcessorConfigEntity;
    ProfitShare? : ProfitShareEntity[];
    RoFlightSchoolCoursePackageCount? : RoFlightSchoolCoursePackageCountEntity[];
    RoFlightSchoolCourseUnique? : RoFlightSchoolCourseUniqueEntity[];
    RoFlightSchoolPaymentInfo? : RoFlightSchoolPaymentInfoEntity[];
    RoSchoolBillingDetails? : RoSchoolBillingDetailsEntity;
    RoSchoolInvoices? : RoSchoolInvoicesEntity[];
    RoSchoolPaymentMethod? : RoSchoolPaymentMethodEntity[];
    RoSchoolStudentStats? : RoSchoolStudentStatsEntity;
    RoStudentCourseDetail? : RoStudentCourseDetailEntity[];
    RoStudentSchoolCourses? : RoStudentSchoolCoursesEntity[];
    SchoolBillingPolicyPeriod? : SchoolBillingPolicyPeriodEntity[];
    Subscription? : SubscriptionEntity[];
    SubscriptionCourseTracking? : SubscriptionCourseTrackingEntity[];
    SubscriptionTierFlightSchool? : SubscriptionTierFlightSchoolEntity[];
    UserDetail? : UserDetailEntity[];
}

export interface FlightSchoolBillingContactEntity extends DwOrmData {
    // Attributes
    FlightSchoolBillingContactId?: number;
    FlightSchoolId?: number;
    UserId?: number;
    EmailAddress?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    FlightSchoolIdDisplay?: string;
    UserIdDisplay?: string;

    // Relations
    FlightSchool? : FlightSchoolEntity;
    DwUser? : DwUserEntity;
}

export interface FlightSchoolBrandingEntity extends DwOrmData {
    // Attributes
    FlightSchoolBrandingId?: number;
    SubdomainSetupStatusId?: number;
    SubdomainTypeId?: number;
    DomainName?: string;
    ThemeId?: number;
    NavigationColorSetId?: number;
    SidebarColorSetId?: number;
    UseCustomColors?: boolean;
    LoginColorSetId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    DomainAutoJoinSchool?: boolean;
    UseCustomLoginMedia?: boolean;
    StandardLoginMediaId?: number;
    CustomLoginMediaGroupId?: number;
    MobileAppIconMediaId?: number;

    // Display Attributes
    SubdomainSetupStatusIdDisplay?: string;
    SubdomainTypeIdDisplay?: string;
    ThemeIdDisplay?: string;
    NavigationColorSetIdDisplay?: string;
    SidebarColorSetIdDisplay?: string;
    LoginColorSetIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    StandardLoginMediaIdDisplay?: string;
    CustomLoginMediaGroupIdDisplay?: string;
    MobileAppIconMediaIdDisplay?: string;

    // Relations
    MobileAppIconDwMedia? : DwMediaEntity;
    CustomLoginDwMediaGroup? : DwMediaGroupEntity;
    NavigationColorSetIdStandardColorSet? : StandardColorSetEntity;
    SidebarColorSetIdStandardColorSet? : StandardColorSetEntity;
    LoginColorSetIdStandardColorSet? : StandardColorSetEntity;
    StandardLoginMedia? : StandardLoginMediaEntity;
    SubdomainSetupStatus? : SubdomainSetupStatusEntity;
    SubdomainType? : SubdomainTypeEntity;
    DwTheme? : DwThemeEntity;
    FlightSchool? : FlightSchoolEntity[];
}

export interface FlightSchoolCourseEntity extends DwOrmData {
    // Attributes
    FlightSchoolCourseId?: number;
    FlightSchoolId?: number;
    CourseId?: number;
    SchoolCoursePrice?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    FlightSchoolIdDisplay?: string;
    CourseIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    Course? : CourseEntity;
    FlightSchool? : FlightSchoolEntity;
}

export interface FlightSchoolFeatureEntity extends DwOrmData {
    // Attributes
    FlightSchoolFeatureId?: number;
    FlightSchoolId?: number;
    SchoolFeatureId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    FlightSchoolIdDisplay?: string;
    SchoolFeatureIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    FlightSchool? : FlightSchoolEntity;
    SchoolFeature? : SchoolFeatureEntity;
}

export interface FlightSchoolGroupEntity extends DwOrmData {
    // Attributes
    FlightSchoolGroupId?: number;
    FlightSchoolId?: number;
    GroupName?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    FlightSchoolIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    FlightSchool? : FlightSchoolEntity;
    Assignment? : AssignmentEntity[];
    CoursePurchase? : CoursePurchaseEntity[];
    FlightSchoolGroupStudent? : FlightSchoolGroupStudentEntity[];
    JoinRequest? : JoinRequestEntity[];
}

export interface FlightSchoolGroupStudentEntity extends DwOrmData {
    // Attributes
    FlightSchoolGroupStudentId?: number;
    FlightSchoolGroupId?: number;
    StudentId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    FlightSchoolGroupIdDisplay?: string;
    StudentIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    FlightSchoolGroup? : FlightSchoolGroupEntity;
    Student? : StudentEntity;
}

export interface FlightSchoolInstructorEntity extends DwOrmData {
    // Attributes
    FlightSchoolInstructorId?: number;
    FlightSchoolId?: number;
    InstructorId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    FlightSchoolIdDisplay?: string;
    InstructorIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    FlightSchool? : FlightSchoolEntity;
    Instructor? : InstructorEntity;
}

export interface FlightSchoolPackageEntity extends DwOrmData {
    // Attributes
    FlightSchoolPackageId?: number;
    FlightSchoolId?: number;
    PackageId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    FlightSchoolIdDisplay?: string;
    PackageIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    FlightSchool? : FlightSchoolEntity;
    Package? : PackageEntity;
}

export interface FlightSchoolPositionEntity extends DwOrmData {
    // Attributes
    Description?: string;
    FlightSchoolPositionId?: number;
    FlightSchoolPosition?: string;
    PositionOrder?: number;
    IsInstructor?: boolean;


    // Relations
    Student? : StudentEntity[];
}

export interface FlightSchoolRegistrationEmailDomainEntity extends DwOrmData {
    // Attributes
    FlightSchoolRegistrationEmailDomainId?: number;
    FlightSchoolId?: number;
    EmailDomain?: string;
    Active?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    FlightSchoolIdDisplay?: string;

    // Relations
    FlightSchool? : FlightSchoolEntity;
}

export interface FlightSchoolRegistrationLinkEntity extends DwOrmData {
    // Attributes
    FlightSchoolRegistrationLinkId?: number;
    FlightSchoolId?: number;
    RegistrationToken?: string;
    Active?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    JoinRequestTypeId?: number;

    // Display Attributes
    FlightSchoolIdDisplay?: string;
    JoinRequestTypeIdDisplay?: string;

    // Relations
    FlightSchool? : FlightSchoolEntity;
    JoinRequestType? : JoinRequestTypeEntity;
}

export interface FlightSchoolStatusEntity extends DwOrmData {
    // Attributes
    FlightSchoolStatusId?: number;
    FlightSchoolStatus?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    FlightSchool? : FlightSchoolEntity[];
}

export interface GamificationConfigurationEntity extends DwOrmData {
    // Attributes
    GamificationConfigurationId?: number;
    FlightSchoolId?: number;
    WeatherDayGrantQuantity?: number;
    WeatherDayGrantPeriodDays?: number;
    WeatherDayMaximumBalance?: number;
    WeatherDayAutoApply?: boolean;
    WeekStartDay?: number;
    ActiveLearningDailyCapSeconds?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    DailyQuizAnswerReviewEnabled?: boolean;

    // Display Attributes
    FlightSchoolIdDisplay?: string;

    // Relations
    FlightSchool? : FlightSchoolEntity;
    StudentWeatherDayTransaction? : StudentWeatherDayTransactionEntity[];
}

export interface InstructorEntity extends DwOrmData {
    // Attributes
    InstructorId?: number;
    UserId?: number;
    FlightSchoolId?: number;
    InstructorStatusId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    UserIdDisplay?: string;
    FlightSchoolIdDisplay?: string;
    InstructorStatusIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    FlightSchool? : FlightSchoolEntity;
    InstructorStatus? : InstructorStatusEntity;
    DwUser? : DwUserEntity;
    Assignment? : AssignmentEntity[];
    FlightSchoolInstructor? : FlightSchoolInstructorEntity[];
    InstructorStudent? : InstructorStudentEntity[];
    RoInstructorAssignmentsPerWeek? : RoInstructorAssignmentsPerWeekEntity[];
    RoStudentCourseInstructor? : RoStudentCourseInstructorEntity[];
    StudentCourseLockInstructor? : StudentCourseLockInstructorEntity[];
}

export interface InstructorStatusEntity extends DwOrmData {
    // Attributes
    InstructorStatusId?: number;
    InstructorStatus?: string;


    // Relations
    Instructor? : InstructorEntity[];
}

export interface InstructorStudentEntity extends DwOrmData {
    // Attributes
    InstructorStudentId?: number;
    InstructorId?: number;
    StudentId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    InstructorIdDisplay?: string;
    StudentIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    Instructor? : InstructorEntity;
    Student? : StudentEntity;
    RoSchoolCourseEnrollmentStatsStudentId? : RoSchoolCourseEnrollmentStatsEntity[];
}

export interface IntegrationCoursePurchaseEntity extends DwOrmData {
    // Attributes
    IntegrationUserId?: number;
    IntegrationPurchaseReferenceKey?: string;
    CourseId?: number;
    StudentCourseId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    IntegrationCoursePurchaseRequestId?: number;
    IntegrationCoursePurchaseId?: number;

    // Display Attributes
    IntegrationUserIdDisplay?: string;
    CourseIdDisplay?: string;
    StudentCourseIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    IntegrationCoursePurchaseRequestIdDisplay?: string;

    // Relations
    Course? : CourseEntity;
    IntegrationCoursePurchaseRequest? : IntegrationCoursePurchaseRequestEntity;
    IntegrationUser? : IntegrationUserEntity;
    StudentCourse? : StudentCourseEntity;
}

export interface IntegrationCoursePurchaseRequestEntity extends DwOrmData {
    // Attributes
    IntegrationCoursePurchaseRequestId?: number;
    IntegrationOrganizationId?: number;
    IntegrationCoursePurchaseRequestStatusId?: number;
    IntegrationUserId?: number;
    UserEmail?: string;
    UserFullName?: string;
    CourseId?: number;
    IntegrationPurchaseReferenceKey?: string;
    UserReferenceKey?: string;
    UserAlternateReferenceKey?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    IntegrationOrganizationIdDisplay?: string;
    IntegrationCoursePurchaseRequestStatusIdDisplay?: string;
    IntegrationUserIdDisplay?: string;
    CourseIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    Course? : CourseEntity;
    IntegrationCoursePurchaseRequestStatus? : IntegrationCoursePurchaseRequestStatusEntity;
    IntegrationOrganization? : IntegrationOrganizationEntity;
    IntegrationUser? : IntegrationUserEntity;
    IntegrationCoursePurchase? : IntegrationCoursePurchaseEntity[];
}

export interface IntegrationCoursePurchaseRequestStatusEntity extends DwOrmData {
    // Attributes
    IntegrationCoursePurchaseRequestStatusId?: number;
    IntegrationCoursePurchaseRequestStatus?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    IntegrationCoursePurchaseRequest? : IntegrationCoursePurchaseRequestEntity[];
}

export interface IntegrationEventTypeEntity extends DwOrmData {
    // Attributes
    IntegrationEventTypeId?: number;
    IntegrationEventType?: string;
    IntegrationCode?: string;


    // Relations
    IntegrationUserEvent? : IntegrationUserEventEntity[];
}

export interface IntegrationOrganizationEntity extends DwOrmData {
    // Attributes
    IntegrationOrganizationId?: number;
    IntegrationSystemId?: number;
    FlightSchoolId?: number;
    IntegrationOrganizationStatusId?: number;
    OrganizationReferenceKey?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    IntegrationSystemIdDisplay?: string;
    FlightSchoolIdDisplay?: string;
    IntegrationOrganizationStatusIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    FlightSchool? : FlightSchoolEntity;
    IntegrationOrganizationStatus? : IntegrationOrganizationStatusEntity;
    IntegrationSystem? : IntegrationSystemEntity;
    IntegrationCoursePurchaseRequest? : IntegrationCoursePurchaseRequestEntity[];
    IntegrationUser? : IntegrationUserEntity[];
}

export interface IntegrationOrganizationStatusEntity extends DwOrmData {
    // Attributes
    IntegrationOrganizationStatusId?: number;
    IntegrationOrganizationStatus?: string;


    // Relations
    IntegrationOrganization? : IntegrationOrganizationEntity[];
}

export interface IntegrationSystemEntity extends DwOrmData {
    // Attributes
    IntegrationSystemId?: number;
    SystemName?: string;
    SystemUrl?: string;
    DomainName?: string;
    TrackEvents?: boolean;
    ApiRootUrl?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    IntegrationOrganization? : IntegrationOrganizationEntity[];
    IntegrationSystemCourse? : IntegrationSystemCourseEntity[];
}

export interface IntegrationSystemCourseEntity extends DwOrmData {
    // Attributes
    IntegrationSystemCourseId?: number;
    IntegrationSystemId?: number;
    CourseId?: number;

    // Display Attributes
    IntegrationSystemIdDisplay?: string;
    CourseIdDisplay?: string;

    // Relations
    Course? : CourseEntity;
    IntegrationSystem? : IntegrationSystemEntity;
}

export interface IntegrationUserEntity extends DwOrmData {
    // Attributes
    IntegrationUserId?: number;
    IntegrationOrganizationId?: number;
    IntegrationUserStatusId?: number;
    UserId?: number;
    AuthenticationTokenKey?: string;
    UserReferenceKey?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    UserAlternateReferenceKey?: string;

    // Display Attributes
    IntegrationOrganizationIdDisplay?: string;
    IntegrationUserStatusIdDisplay?: string;
    UserIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    IntegrationOrganization? : IntegrationOrganizationEntity;
    IntegrationUserStatus? : IntegrationUserStatusEntity;
    DwUser? : DwUserEntity;
    IntegrationCoursePurchase? : IntegrationCoursePurchaseEntity[];
    IntegrationCoursePurchaseRequest? : IntegrationCoursePurchaseRequestEntity[];
    IntegrationUserEvent? : IntegrationUserEventEntity[];
}

export interface IntegrationUserEventEntity extends DwOrmData {
    // Attributes
    IntegrationUserEventId?: number;
    IntegrationUserId?: number;
    CourseId?: number;
    IntegrationEventTypeId?: number;
    EventSentAttemptCount?: number;
    LastLogId?: number;
    IntegrationUserEventStatusId?: number;
    LastEventSendDateTime?: string;
    EventTimestamp?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    CousreLessonId?: number;

    // Display Attributes
    IntegrationUserIdDisplay?: string;
    CourseIdDisplay?: string;
    IntegrationEventTypeIdDisplay?: string;
    LastLogIdDisplay?: string;
    IntegrationUserEventStatusIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    CousreLessonIdDisplay?: string;

    // Relations
    Course? : CourseEntity;
    CousreLessonIdCourseLesson? : CourseLessonEntity;
    IntegrationEventType? : IntegrationEventTypeEntity;
    IntegrationUser? : IntegrationUserEntity;
    IntegrationUserEventStatus? : IntegrationUserEventStatusEntity;
}

export interface IntegrationUserEventStatusEntity extends DwOrmData {
    // Attributes
    IntegrationUserEventStatusId?: number;
    IntegrationUserEventStatus?: string;


    // Relations
    IntegrationUserEvent? : IntegrationUserEventEntity[];
}

export interface IntegrationUserStatusEntity extends DwOrmData {
    // Attributes
    IntegrationUserStatusId?: number;
    IntegrationUserStatus?: string;


    // Relations
    IntegrationUser? : IntegrationUserEntity[];
}

export interface InvoiceEntity extends DwOrmData {
    // Attributes
    InvoiceId?: number;
    FlightSchoolId?: number;
    ProcessorInvoiceId?: string;
    InvoiceDate?: string;
    InvoiceAmount?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    InvoicePdfUrl?: string;
    InvoiceControlNumber?: string;
    InvoiceHostedUrl?: string;
    InvoiceNumber?: string;
    UserId?: number;
    InvoiceTypeId?: number;
    InvoiceStatusId?: number;
    FailureLogId?: number;
    TaxAmount?: number;
    PaidAmount?: number;
    LastInvoiceErrorLogId?: number;
    InvoiceFinalAmount?: number;
    PaymentPartyTypeId?: number;
    PaymentMethodId?: number;
    InvoicePeriodStart?: string;
    InvoicePeriodEnd?: string;
    StripeCheckoutSessionId?: number;
    StripeInvoiceRef?: string;
    InvoiceDueDate?: string;
    InvoicePaymentTermsDays?: number;
    InvoiceBillingEmail?: string;
    InvoiceBillingTimeZone?: string;
    InvoiceFinalizedDateTime?: string;

    // Display Attributes
    FlightSchoolIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    UserIdDisplay?: string;
    InvoiceTypeIdDisplay?: string;
    InvoiceStatusIdDisplay?: string;
    FailureLogIdDisplay?: string;
    LastInvoiceErrorLogIdDisplay?: string;
    PaymentPartyTypeIdDisplay?: string;
    PaymentMethodIdDisplay?: string;
    StripeCheckoutSessionIdDisplay?: string;

    // Relations
    FlightSchool? : FlightSchoolEntity;
    LastInvoiceErrorLog? : InvoiceErrorLogEntity;
    InvoiceStatus? : InvoiceStatusEntity;
    InvoiceType? : InvoiceTypeEntity;
    PaymentMethod? : PaymentMethodEntity;
    PaymentPartyType? : PaymentPartyTypeEntity;
    StripeCheckoutSession? : StripeCheckoutSessionEntity;
    DwUser? : DwUserEntity;
    CoursePurchase? : CoursePurchaseEntity[];
    CoursePurchaseReservation? : CoursePurchaseReservationEntity[];
    InvoiceErrorLog? : InvoiceErrorLogEntity[];
    InvoiceLine? : InvoiceLineEntity[];
    InvoiceRefund? : InvoiceRefundEntity[];
    JoinRequestCoursePurchase? : JoinRequestCoursePurchaseEntity[];
    RoSchoolInvoices? : RoSchoolInvoicesEntity[];
}

export interface InvoiceErrorCodeEntity extends DwOrmData {
    // Attributes
    InvoiceErrorCodeId?: number;
    InvoiceErrorCode?: string;
    InvoiceErrorDescription?: string;
    IsStripeError?: boolean;
    StripeErrorCode?: string;
    EndUserErrorDescription?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    InvoiceErrorLog? : InvoiceErrorLogEntity[];
}

export interface InvoiceErrorLogEntity extends DwOrmData {
    // Attributes
    InvoiceErrorLogId?: number;
    InvoiceId?: number;
    LogId?: number;
    InvoiceErrorCodeId?: number;
    StripeDetailedError?: string;
    StripErrorCode?: string;
    StripeErrorType?: string;
    StripErrorDeclinedCode?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    InvoiceIdDisplay?: string;
    LogIdDisplay?: string;
    InvoiceErrorCodeIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    Invoice? : InvoiceEntity;
    InvoiceErrorCode? : InvoiceErrorCodeEntity;
    LastInvoice? : InvoiceEntity[];
}

export interface InvoiceLineEntity extends DwOrmData {
    // Attributes
    InvoiceLineId?: number;
    InvoiceId?: number;
    Description?: string;
    Quantity?: number;
    ItemCost?: number;
    TotalCost?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    SubscriptionId?: number;
    DiscountId?: number;
    ProductId?: number;

    // Display Attributes
    InvoiceIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    SubscriptionIdDisplay?: string;
    DiscountIdDisplay?: string;
    ProductIdDisplay?: string;

    // Relations
    Discount? : DiscountEntity;
    Invoice? : InvoiceEntity;
    Product? : ProductEntity;
    Subscription? : SubscriptionEntity;
    CoursePurchaseReservationCourse? : CoursePurchaseReservationCourseEntity[];
    DiscountUsageFlightSchool? : DiscountUsageFlightSchoolEntity[];
    JoinRequestCoursePurchase? : JoinRequestCoursePurchaseEntity[];
    ProfitShare? : ProfitShareEntity[];
}

export interface InvoiceLogEntity extends DwOrmData {
    // Attributes
    InvoiceLogId?: number;
    CreatedDateTime?: string;
    InvoiceControlNumber?: string;
    Successful?: boolean;
    Result?: string;
    ProcessorLogId?: number;
    LoggingServiceId?: number;
    CreatedBy?: number;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    ProcessorLogIdDisplay?: string;
    LoggingServiceIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    ProcessorLog? : ProcessorLogEntity;
}

export interface InvoiceRefundEntity extends DwOrmData {
    // Attributes
    InvoiceRefundId?: number;
    InvoiceId?: number;
    RefundDateTime?: string;
    RefundAmount?: number;
    RefundReason?: string;
    RefundPaymentRef?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    InvoiceIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    Invoice? : InvoiceEntity;
}

export interface InvoiceStatusEntity extends DwOrmData {
    // Attributes
    InvoiceStatusId?: number;
    InvoiceStatus?: string;


    // Relations
    Invoice? : InvoiceEntity[];
}

export interface InvoiceTypeEntity extends DwOrmData {
    // Attributes
    InvoiceTypeId?: number;
    InvoiceType?: string;


    // Relations
    Invoice? : InvoiceEntity[];
}

export interface JoinRequestEntity extends DwOrmData {
    // Attributes
    JoinRequestId?: number;
    FlightSchoolId?: number;
    JoinRequestTypeId?: number;
    MessageHtml?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    UsePackage?: boolean;
    CoursePackageId?: number;
    JoinRequestStatusId?: number;
    AssignToGroup?: boolean;
    FlightSchoolGroupId?: number;
    DiscountCode?: string;

    // Display Attributes
    FlightSchoolIdDisplay?: string;
    JoinRequestTypeIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    CoursePackageIdDisplay?: string;
    JoinRequestStatusIdDisplay?: string;
    FlightSchoolGroupIdDisplay?: string;

    // Relations
    FlightSchool? : FlightSchoolEntity;
    FlightSchoolGroup? : FlightSchoolGroupEntity;
    JoinRequestStatus? : JoinRequestStatusEntity;
    JoinRequestType? : JoinRequestTypeEntity;
    CoursePackage? : PackageEntity;
    JoinRequestCourse? : JoinRequestCourseEntity[];
    JoinRequestCoursePurchase? : JoinRequestCoursePurchaseEntity[];
    JoinRequestEmail? : JoinRequestEmailEntity[];
}

export interface JoinRequestCourseEntity extends DwOrmData {
    // Attributes
    JoinRequestCourseId?: number;
    JoinRequestId?: number;
    CourseId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    JoinRequestIdDisplay?: string;
    CourseIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    Course? : CourseEntity;
    JoinRequest? : JoinRequestEntity;
}

export interface JoinRequestCourseFulfillmentStatusEntity extends DwOrmData {
    // Attributes
    JoinRequestCourseFulfillmentStatusId?: number;
    JoinRequestCourseFulfillmentStatus?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
    JoinRequestCoursePurchase? : JoinRequestCoursePurchaseEntity[];
}

export interface JoinRequestCoursePurchaseEntity extends DwOrmData {
    // Attributes
    JoinRequestCoursePurchaseId?: number;
    JoinRequestId?: number;
    JoinRequestEmailId?: number;
    FlightSchoolId?: number;
    EmailAddress?: string;
    NormalizedEmailAddress?: string;
    CourseId?: number;
    CoursePackageId?: number;
    ProductId?: number;
    InvoiceId?: number;
    InvoiceLineId?: number;
    UserId?: number;
    StudentId?: number;
    StudentCourseId?: number;
    JoinRequestCoursePurchaseStatusId?: number;
    JoinRequestCourseFulfillmentStatusId?: number;
    IsLegacyBackfill?: boolean;
    PurchasedDateTime?: string;
    FulfilledDateTime?: string;
    LastAttemptDateTime?: string;
    LastErrorMessage?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    JoinRequestIdDisplay?: string;
    JoinRequestEmailIdDisplay?: string;
    FlightSchoolIdDisplay?: string;
    CourseIdDisplay?: string;
    CoursePackageIdDisplay?: string;
    ProductIdDisplay?: string;
    InvoiceIdDisplay?: string;
    InvoiceLineIdDisplay?: string;
    UserIdDisplay?: string;
    StudentIdDisplay?: string;
    StudentCourseIdDisplay?: string;
    JoinRequestCoursePurchaseStatusIdDisplay?: string;
    JoinRequestCourseFulfillmentStatusIdDisplay?: string;

    // Relations
    Course? : CourseEntity;
    FlightSchool? : FlightSchoolEntity;
    Invoice? : InvoiceEntity;
    InvoiceLine? : InvoiceLineEntity;
    JoinRequest? : JoinRequestEntity;
    JoinRequestCourseFulfillmentStatus? : JoinRequestCourseFulfillmentStatusEntity;
    JoinRequestCoursePurchaseStatus? : JoinRequestCoursePurchaseStatusEntity;
    JoinRequestEmail? : JoinRequestEmailEntity;
    CoursePackage? : PackageEntity;
    Product? : ProductEntity;
    Student? : StudentEntity;
    StudentCourse? : StudentCourseEntity;
    DwUser? : DwUserEntity;
}

export interface JoinRequestCoursePurchaseStatusEntity extends DwOrmData {
    // Attributes
    JoinRequestCoursePurchaseStatusId?: number;
    JoinRequestCoursePurchaseStatus?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
    JoinRequestCoursePurchase? : JoinRequestCoursePurchaseEntity[];
}

export interface JoinRequestEmailEntity extends DwOrmData {
    // Attributes
    JoinRequestEmailId?: number;
    JoinRequestId?: number;
    EmailAddress?: string;
    Accepted?: boolean;
    UserId?: number;
    AcceptedDateTime?: string;
    LastResendRequestDateTime?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    JoinRequestIdDisplay?: string;
    UserIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    JoinRequest? : JoinRequestEntity;
    DwUser? : DwUserEntity;
    JoinRequestCoursePurchase? : JoinRequestCoursePurchaseEntity[];
    ProfitShare? : ProfitShareEntity[];
}

export interface JoinRequestStatusEntity extends DwOrmData {
    // Attributes
    JoinRequestStatusId?: number;
    JoinRequestStatus?: string;


    // Relations
    JoinRequest? : JoinRequestEntity[];
}

export interface JoinRequestTypeEntity extends DwOrmData {
    // Attributes
    JoinRequestTypeId?: number;
    JoinRequestType?: string;
    UserTypeId?: number;
    IncludeCourses?: boolean;
    JobRequestTypeDescription?: string;

    // Display Attributes
    UserTypeIdDisplay?: string;

    // Relations
    DwUserType? : DwUserTypeEntity;
    FlightSchoolRegistrationLink? : FlightSchoolRegistrationLinkEntity[];
    JoinRequest? : JoinRequestEntity[];
    JoinRequestTypeRole? : JoinRequestTypeRoleEntity[];
    JoinRequestTypeSubscriptionRole? : JoinRequestTypeSubscriptionRoleEntity[];
}

export interface JoinRequestTypeRoleEntity extends DwOrmData {
    // Attributes
    JoinRequestTypeRoleId?: number;
    JoinRequestTypeId?: number;
    RoleId?: number;

    // Display Attributes
    JoinRequestTypeIdDisplay?: string;
    RoleIdDisplay?: string;

    // Relations
    JoinRequestType? : JoinRequestTypeEntity;
    DwRole? : DwRoleEntity;
}

export interface JoinRequestTypeSubscriptionRoleEntity extends DwOrmData {
    // Attributes
    JoinRequestTypeSubscriptionRoleId?: number;
    JoinRequestTypeId?: number;
    SubscriptionRoleId?: number;

    // Display Attributes
    JoinRequestTypeIdDisplay?: string;
    SubscriptionRoleIdDisplay?: string;

    // Relations
    JoinRequestType? : JoinRequestTypeEntity;
    SubscriptionRole? : SubscriptionRoleEntity;
}

export interface LessonTypeEntity extends DwOrmData {
    // Attributes
    LessonTypeId?: number;
    LessonType?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    CourseLesson? : CourseLessonEntity[];
}

export interface DwMediaEntity extends DwOrmData {
    // Attributes
    ContainerName?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    IsDeleted?: boolean;
    IsSecure?: boolean;
    MediaFolderId?: number;
    MediaGroupId?: number;
    MediaId?: number;
    MediaName?: string;
    MediaStorageTypeId?: number;
    MediaTypeId?: number;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    CreatedByDisplay?: string;
    MediaFolderIdDisplay?: string;
    MediaGroupIdDisplay?: string;
    MediaStorageTypeIdDisplay?: string;
    MediaTypeIdDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    DwMediaGroup? : DwMediaGroupEntity;
    Assignment? : AssignmentEntity[];
    CourseImageCourse? : CourseEntity[];
    EndorsementPDFCourseEndorsement? : CourseEndorsementEntity[];
    EndorsementPDFCourseEndorsementStudent? : CourseEndorsementStudentEntity[];
    ModuleImageCourseModule? : CourseModuleEntity[];
    DocumentAsset? : DocumentAssetEntity[];
    FolderIconDocumentFolder? : DocumentFolderEntity[];
    DocumentItem? : DocumentItemEntity[];
    CardIconDocumentItem? : DocumentItemEntity[];
    ExtractedImageDocumentItem? : DocumentItemEntity[];
    MobileAppIconFlightSchoolBranding? : FlightSchoolBrandingEntity[];
    DwroMedia? : DwRoMediaEntity;
    StandardLoginMedia? : StandardLoginMediaEntity[];
    AlternateLogoDwTheme? : DwThemeEntity[];
    LogoDwTheme? : DwThemeEntity[];
    LogoLoginDwTheme? : DwThemeEntity[];
    UserPictureDwUser? : DwUserEntity[];
    UserBackgroundDwUser? : DwUserEntity[];
}

export interface DwMediaGroupEntity extends DwOrmData {
    // Attributes
    CreatedBy?: number;
    CreatedDateTime?: string;
    GroupName?: string;
    IsGlobalGroup?: boolean;
    IsSecure?: boolean;
    MediaGroupId?: number;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    PartyReferenceId?: number;

    // Display Attributes
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    PartyReferenceIdDisplay?: string;

    // Relations
    CustomLoginFlightSchoolBranding? : FlightSchoolBrandingEntity[];
    DwMedia? : DwMediaEntity[];
    DwroMedia? : DwRoMediaEntity[];
}

export interface DwMetaDataItemEntity extends DwOrmData {
    // Attributes
    CreatedBy?: number;
    CreatedDateTime?: string;
    Display?: string;
    EnableHistory?: boolean;
    GenerateClientCode?: boolean;
    IsView?: boolean;
    ItemName?: string;
    Layer?: string;
    MetaDataDatabaseId?: number;
    MetaDataEnvironmentOfRecordTypeId?: number;
    MetaDataGroupId?: number;
    MetaDataItemId?: number;
    MetaDataItemStatusId?: number;
    MetaDataItemTypeId?: number;
    MetaDataSystemId?: number;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    SchemaName?: string;
    UniqueId?: string;
    UniqueItemName?: string;

    // Display Attributes
    CreatedByDisplay?: string;
    MetaDataDatabaseIdDisplay?: string;
    MetaDataEnvironmentOfRecordTypeIdDisplay?: string;
    MetaDataGroupIdDisplay?: string;
    MetaDataItemStatusIdDisplay?: string;
    MetaDataItemTypeIdDisplay?: string;
    MetaDataSystemIdDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    AIProcessingReference? : AIProcessingReferenceEntity[];
    SourceStudentActivity? : StudentActivityEntity[];
    RelatedStudentActivity? : StudentActivityEntity[];
}

export interface MetricTypeEntity extends DwOrmData {
    // Attributes
    MetricTypeId?: number;
    MetricTypeKey?: string;
    MetricTypeName?: string;
    ValueUnit?: string;
    SupportsGlobalScope?: boolean;
    SupportsCourseScope?: boolean;
    Active?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
    AchievementTier? : AchievementTierEntity[];
}

export interface ModificationHistoryEntity extends DwOrmData {
    // Attributes
    ModificationHistoryId?: number;
    CourseId?: number;
    CourseChangeDateTime?: string;
    CourseChangeDetail?: string;
    ModificationHistoryStatusId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    LastLogId?: number;
    StudentCoursesComplete?: number;
    StudentCoursesFailed?: number;
    StudentCoursesTotal?: number;
    PercentComplete?: number;
    TimeProcessingSeconds?: number;
    ForceUpdate?: boolean;
    StudentCoursesProcessed?: number;

    // Display Attributes
    CourseIdDisplay?: string;
    ModificationHistoryStatusIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    LastLogIdDisplay?: string;

    // Relations
    Course? : CourseEntity;
    ModificationHistoryStatus? : ModificationHistoryStatusEntity;
    ModificationHistoryStudent? : ModificationHistoryStudentEntity[];
}

export interface ModificationHistoryStatusEntity extends DwOrmData {
    // Attributes
    ModificationHistoryStatusId?: number;
    ModificationHistoryStatus?: string;


    // Relations
    ModificationHistory? : ModificationHistoryEntity[];
}

export interface ModificationHistoryStudentEntity extends DwOrmData {
    // Attributes
    ModificationHistoryStudentId?: number;
    ModificationHistoryId?: number;
    StudentCourseId?: number;
    ModificationHistoryStudentStatusId?: number;
    LastLogId?: number;
    LastProcessedDateTime?: string;
    AttemptCount?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    TimeProcessingSeconds?: number;

    // Display Attributes
    ModificationHistoryIdDisplay?: string;
    StudentCourseIdDisplay?: string;
    ModificationHistoryStudentStatusIdDisplay?: string;
    LastLogIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    ModificationHistory? : ModificationHistoryEntity;
    ModificationHistoryStudentStatus? : ModificationHistoryStudentStatusEntity;
    StudentCourse? : StudentCourseEntity;
}

export interface ModificationHistoryStudentStatusEntity extends DwOrmData {
    // Attributes
    ModificationHistoryStudentStatusId?: number;
    ModificationHistoryStudentStatus?: string;


    // Relations
    ModificationHistoryStudent? : ModificationHistoryStudentEntity[];
}

export interface MultipleAssignEntity extends DwOrmData {
    // Attributes
    MultipleAssignId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    MultipleAssignCourse? : MultipleAssignCourseEntity[];
    MultipleAssignFlightSchool? : MultipleAssignFlightSchoolEntity[];
    MultipleAssignPackage? : MultipleAssignPackageEntity[];
}

export interface MultipleAssignCourseEntity extends DwOrmData {
    // Attributes
    MultipleAssignCourseId?: number;
    MultipleAssignId?: number;
    CourseId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    MultipleAssignIdDisplay?: string;
    CourseIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    Course? : CourseEntity;
    MultipleAssign? : MultipleAssignEntity;
}

export interface MultipleAssignFlightSchoolEntity extends DwOrmData {
    // Attributes
    MultipleAssignFlightSchoolId?: number;
    MultipleAssignId?: number;
    FlightSchoolId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    MultipleAssignIdDisplay?: string;
    FlightSchoolIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    FlightSchool? : FlightSchoolEntity;
    MultipleAssign? : MultipleAssignEntity;
}

export interface MultipleAssignPackageEntity extends DwOrmData {
    // Attributes
    MultipleAssignPackageId?: number;
    MultipleAssignId?: number;
    PackageId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    MultipleAssignIdDisplay?: string;
    PackageIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    MultipleAssign? : MultipleAssignEntity;
    Package? : PackageEntity;
}

export interface PackageEntity extends DwOrmData {
    // Attributes
    PackageId?: number;
    PackageName?: string;
    PackageDescription?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    RetailPrice?: number;
    PackageMediaId?: number;

    // Display Attributes
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    CoursePurchasePackage? : CoursePurchasePackageEntity[];
    CourseCoursePurchaseReservationCourse? : CoursePurchaseReservationCourseEntity[];
    DiscountPackage? : DiscountPackageEntity[];
    FlightSchoolPackage? : FlightSchoolPackageEntity[];
    CourseJoinRequest? : JoinRequestEntity[];
    CourseJoinRequestCoursePurchase? : JoinRequestCoursePurchaseEntity[];
    MultipleAssignPackage? : MultipleAssignPackageEntity[];
    PackageCourse? : PackageCourseEntity[];
    Product? : ProductEntity;
}

export interface PackageCourseEntity extends DwOrmData {
    // Attributes
    PackageCourseId?: number;
    PackageId?: number;
    CourseId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    PackageIdDisplay?: string;
    CourseIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    Course? : CourseEntity;
    Package? : PackageEntity;
}

export interface PaymentEventEntity extends DwOrmData {
    // Attributes
    PaymentEventId?: number;
    PaymentEventSourceId?: number;
    PaymentEventTypeId?: number;
    PaymentEventStatusId?: number;
    PayloadJSON?: string;
    EventSourceVersion?: string;
    CreatedDateTime?: string;
    ModifiedDateTime?: string;
    PaymentEventDetailType?: string;
    LastErrorLogId?: number;
    PaymentEventKey?: string;

    // Display Attributes
    PaymentEventSourceIdDisplay?: string;
    PaymentEventTypeIdDisplay?: string;
    PaymentEventStatusIdDisplay?: string;

    // Relations
    PaymentEventSource? : PaymentEventSourceEntity;
    PaymentEventStatus? : PaymentEventStatusEntity;
    PaymentEventType? : PaymentEventTypeEntity;
    StripeCheckoutSession? : StripeCheckoutSessionEntity[];
}

export interface PaymentEventSourceEntity extends DwOrmData {
    // Attributes
    PaymentEventSourceId?: number;
    PaymentEventSource?: string;


    // Relations
    PaymentEvent? : PaymentEventEntity[];
}

export interface PaymentEventStatusEntity extends DwOrmData {
    // Attributes
    PaymentEventStatusId?: number;
    PaymentEventStatus?: string;


    // Relations
    PaymentEvent? : PaymentEventEntity[];
}

export interface PaymentEventTypeEntity extends DwOrmData {
    // Attributes
    PaymentEventTypeId?: number;
    PaymentEventType?: string;


    // Relations
    PaymentEvent? : PaymentEventEntity[];
}

export interface PaymentMethodEntity extends DwOrmData {
    // Attributes
    PaymentMethodId?: number;
    ProcessorConfigId?: number;
    PaymentId?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    IsDefault?: boolean;
    IsActive?: boolean;
    ClientSecret?: string;
    SetupIntentId?: string;
    BillingName?: string;
    BillingEmail?: string;
    DisplayName?: string;
    BillingPostalCode?: string;

    // Display Attributes
    ProcessorConfigIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    ProcessorConfig? : ProcessorConfigEntity;
    Invoice? : InvoiceEntity[];
}

export interface PaymentPartyTypeEntity extends DwOrmData {
    // Attributes
    PaymentPartyTypeId?: number;
    PaymentPartyType?: string;


    // Relations
    CoursePurchase? : CoursePurchaseEntity[];
    CoursePurchaseReservation? : CoursePurchaseReservationEntity[];
    Invoice? : InvoiceEntity[];
}

export interface PilotTypeEntity extends DwOrmData {
    // Attributes
    PilotTypeId?: number;
    PilotType?: string;
    Order?: number;
    RequireReferenceFields?: boolean;


    // Relations
    Student? : StudentEntity[];
}

export interface PostalCodeEntity extends DwOrmData {
    // Attributes
    PostalCodeId?: number;
    StateProvinceId?: number;
    PostalCode?: string;
    Plus4?: string;
    City?: string;
    County?: string;
    AreaCode?: string;
    Latitude?: number;
    Longitude?: number;
    GmtOffset?: number;
    ObservesDst?: boolean;
    IsMetropolitanArea?: boolean;
    TimeZoneId?: number;
    CreatedDateTime?: string;
    CreatedBy?: number;
    ModifiedDateTime?: string;
    ModifiedBy?: number;

    // Display Attributes
    StateProvinceIdDisplay?: string;
    TimeZoneIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    StateProvince? : StateProvinceEntity;
    TimeZoneIdTimeZone? : TimeZoneEntity;
}

export interface DwProcessDefinitionEntity extends DwOrmData {
    // Attributes
    ConfigJSON?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    ProcessDefinitionId?: number;
    ProcessDescription?: string;
    ProcessDisplay?: string;
    ProcessMeaning?: string;
    ProcessTypeId?: number;

    // Display Attributes
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    ProcessTypeIdDisplay?: string;

    // Relations
}

export interface ProcessorConfigEntity extends DwOrmData {
    // Attributes
    ProcessorConfigId?: number;
    FlightSchoolId?: number;
    CustomerId?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    IsActive?: boolean;
    UserId?: number;
    PayoutAccountId?: string;
    DetailsSubmitted?: boolean;
    ChargesEnabled?: boolean;

    // Display Attributes
    FlightSchoolIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    UserIdDisplay?: string;

    // Relations
    FlightSchool? : FlightSchoolEntity;
    DwUser? : DwUserEntity;
    PaymentMethod? : PaymentMethodEntity[];
    ProcessorConfigCustomerHistory? : ProcessorConfigCustomerHistoryEntity[];
    RoSchoolPaymentMethod? : RoSchoolPaymentMethodEntity;
}

export interface ProcessorConfigCustomerHistoryEntity extends DwOrmData {
    // Attributes
    ProcessorConfigCustomerHistoryId?: number;
    ProcessorConfigId?: number;
    PreviousCustomerId?: string;
    NewCustomerId?: string;
    PaymentMethodsDeactivated?: number;
    ChangedBy?: number;
    ChangedDateTime?: string;

    // Display Attributes
    ProcessorConfigIdDisplay?: string;
    ChangedByDisplay?: string;

    // Relations
    ProcessorConfig? : ProcessorConfigEntity;
    ChangedByDwUser? : DwUserEntity;
}

export interface ProcessorLogEntity extends DwOrmData {
    // Attributes
    ProcessorLogId?: number;
    Severity?: number;
    Item?: string;
    Activity?: string;
    Description?: string;
    StripeErr?: string;
    StripeErrDesc?: string;
    StripeErrCode?: string;
    StripeErrMessage?: string;
    StripeErrType?: string;
    StripeErrDeclineCode?: string;
    HttpCode?: string;
    ProcessId1?: string;
    ProcessId2?: string;
    CreatedDateTime?: string;
    CreatedBy?: number;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    InvoiceLog? : InvoiceLogEntity[];
}

export interface ProductEntity extends DwOrmData {
    // Attributes
    ProductId?: number;
    CourseId?: number;
    PackageId?: number;
    SubscriptionTierId?: number;
    RetailPrice?: number;
    StripeProductId?: string;
    StripPriceId?: string;
    ProductTypeId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    StripPaymentLinkId?: string;
    StripePaymentLinkUrl?: string;

    // Display Attributes
    CourseIdDisplay?: string;
    PackageIdDisplay?: string;
    SubscriptionTierIdDisplay?: string;
    ProductTypeIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    Course? : CourseEntity;
    Package? : PackageEntity;
    ProductType? : ProductTypeEntity;
    SubscriptionTier? : SubscriptionTierEntity;
    InvoiceLine? : InvoiceLineEntity[];
    JoinRequestCoursePurchase? : JoinRequestCoursePurchaseEntity[];
    ProductPaymentLink? : ProductPaymentLinkEntity[];
    ProfitShare? : ProfitShareEntity[];
    RoProduct? : RoProductEntity;
    StripeCheckoutSessionProduct? : StripeCheckoutSessionProductEntity[];
}

export interface ProductPaymentLinkEntity extends DwOrmData {
    // Attributes
    ProductPaymentLinkId?: number;
    ProductId?: number;
    StripePriceId?: string;
    StripePaymentLinkId?: string;
    StripePaymentLinkUrl?: string;
    ProductRetailPrice?: number;
    IsActive?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    StripeConfirmationUrl?: string;

    // Display Attributes
    ProductIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    Product? : ProductEntity;
}

export interface ProductTypeEntity extends DwOrmData {
    // Attributes
    ProductTypeId?: number;
    ProductType?: string;


    // Relations
    Product? : ProductEntity[];
}

export interface ProfitShareEntity extends DwOrmData {
    // Attributes
    ProfitShareId?: number;
    FlightSchoolId?: number;
    StudentId?: number;
    RetailPrice?: number;
    ProfitSharingPercentage?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    ProfitSharingAmount?: number;
    AffiliateUserId?: number;
    ProductId?: number;
    InvoiceLineId?: number;
    ProfitShareStatusId?: number;
    ProfitShareTypeId?: number;
    PaymentPartyTypeId?: number;
    PaymentInvoiceLineId?: number;
    JoinRequestEmailId?: number;

    // Display Attributes
    FlightSchoolIdDisplay?: string;
    StudentIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    AffiliateUserIdDisplay?: string;
    ProductIdDisplay?: string;
    InvoiceLineIdDisplay?: string;
    ProfitShareStatusIdDisplay?: string;
    ProfitShareTypeIdDisplay?: string;
    JoinRequestEmailIdDisplay?: string;

    // Relations
    FlightSchool? : FlightSchoolEntity;
    InvoiceLine? : InvoiceLineEntity;
    JoinRequestEmail? : JoinRequestEmailEntity;
    Product? : ProductEntity;
    RoProductProductId? : RoProductEntity;
    ProfitShareStatus? : ProfitShareStatusEntity;
    ProfitShareType? : ProfitShareTypeEntity;
    Student? : StudentEntity;
    AffiliateDwUser? : DwUserEntity;
}

export interface ProfitShareStatusEntity extends DwOrmData {
    // Attributes
    ProfitShareStatusId?: number;
    ProfitShareStatus?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    ProfitShare? : ProfitShareEntity[];
}

export interface ProfitShareTypeEntity extends DwOrmData {
    // Attributes
    ProfitShareTypeId?: number;
    ProfitShareType?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    ProfitShare? : ProfitShareEntity[];
}

export interface ProgramTypeEntity extends DwOrmData {
    // Attributes
    ProgramTypeId?: number;
    ProgramType?: string;
    ProgramTypeDescription?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    Course? : CourseEntity[];
}

export interface QuestionEntity extends DwOrmData {
    // Attributes
    QuestionName?: string;
    Question?: string;
    QuestionImageMediaId?: number;
    CorrectAnswer?: string;
    CorrectAnswerNotes?: string;
    CorrectAnswerImageMediaId?: number;
    QuestionTypeId?: number;
    QuestionId?: number;
    UseRandomOrder?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    CourseId?: number;
    CourseModuleId?: number;
    QuestionStatusId?: number;
    QuestionAIProcessingStatusId?: number;

    // Display Attributes
    QuestionImageMediaIdDisplay?: string;
    CorrectAnswerImageMediaIdDisplay?: string;
    QuestionTypeIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    CourseIdDisplay?: string;
    CourseModuleIdDisplay?: string;
    QuestionStatusIdDisplay?: string;
    QuestionAIProcessingStatusIdDisplay?: string;

    // Relations
    Course? : CourseEntity;
    CourseModule? : CourseModuleEntity;
    QuestionImageDwroMedia? : DwRoMediaEntity;
    CorrectAnswerImageDwroMedia? : DwRoMediaEntity;
    QuestionAIProcessingStatus? : QuestionAIProcessingStatusEntity;
    QuestionStatus? : QuestionStatusEntity;
    QuestionType? : QuestionTypeEntity;
    CourseLessonFlag? : CourseLessonFlagEntity[];
    QuestionAnswer? : QuestionAnswerEntity[];
    QuestionTagLink? : QuestionTagLinkEntity[];
    QuizQuestionLink? : QuizQuestionLinkEntity[];
    QuizResultQuestion? : QuizResultQuestionEntity[];
}

export interface QuestionNotUsedEntity extends DwOrmData {
    // Attributes
    QuizQuestionId?: number;
    QuestionName?: string;
    Question?: string;
    QuestionImageMediaId?: number;
    QuestionOrder?: number;
    QuestionTypeId?: number;
    CorrectAnswer?: string;
    CorrectAnswerNotes?: string;
    CorrectAnswerImageMediaId?: number;
    QuestionWeight?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    QuizQuestionAnswerNotUsed? : QuizQuestionAnswerNotUsedEntity[];
}

export interface QuestionAIProcessingStatusEntity extends DwOrmData {
    // Attributes
    QuestionAIProcessingStatusId?: number;
    QuestionAIProcessingStatus?: string;


    // Relations
    Question? : QuestionEntity[];
}

export interface QuestionAnswerEntity extends DwOrmData {
    // Attributes
    QuestionAnswerId?: number;
    QuestionId?: number;
    AnswerText?: string;
    AnswerImageMediaId?: number;
    IsCorrectAnswer?: boolean;
    ExplanationText?: string;
    AnswerOrder?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    QuestionIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    Question? : QuestionEntity;
    QuestionAnswerAIExplanation? : QuestionAnswerAIExplanationEntity;
    QuizResultQuestion? : QuizResultQuestionEntity[];
}

export interface QuestionAnswerAIExplanationEntity extends DwOrmData {
    // Attributes
    QuestionAnswerAIExplanationId?: number;
    QuestionAnswerId?: number;
    ExplanationHtml?: string;

    // Display Attributes
    QuestionAnswerIdDisplay?: string;

    // Relations
    QuestionAnswer? : QuestionAnswerEntity;
}

export interface QuestionImportCharacterConversionEntity extends DwOrmData {
    // Attributes
    QuestionImportCharacterConversionId?: number;
    AsciiValue?: number;
    RemoveValue?: boolean;
    ReplacementValue?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
}

export interface QuestionStatusEntity extends DwOrmData {
    // Attributes
    QuestionStatusId?: number;
    QuestionStatus?: string;


    // Relations
    Question? : QuestionEntity[];
}

export interface QuestionTagEntity extends DwOrmData {
    // Attributes
    QuestionTagId?: number;
    TagName?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    QuestionTagLink? : QuestionTagLinkEntity[];
    TagIdVideoTagLink? : VideoTagLinkEntity[];
}

export interface QuestionTagLinkEntity extends DwOrmData {
    // Attributes
    QuestionTagLinkd?: number;
    QuestionId?: number;
    QuestionTagId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    QuestionIdDisplay?: string;
    QuestionTagIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    Question? : QuestionEntity;
    QuestionTag? : QuestionTagEntity;
}

export interface QuestionTypeEntity extends DwOrmData {
    // Attributes
    QuestionTypeId?: number;
    QuestionType?: string;
    ConfigureAnswers?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    Question? : QuestionEntity[];
}

export interface QuizEntity extends DwOrmData {
    // Attributes
    QuizId?: number;
    QuizName?: string;
    QuizTypeId?: number;
    UseRandomOrder?: boolean;
    MaxQuestionsToShow?: number;
    TimeLimitMinutes?: number;
    MaxAttempts?: number;
    PassingPercent?: number;
    ShowAnswersOnFail?: boolean;
    ShowAnswersOnPass?: boolean;
    UseWeightedAnswers?: boolean;
    QuizDescription?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    QuizStatusId?: number;

    // Display Attributes
    QuizTypeIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    QuizStatusIdDisplay?: string;

    // Relations
    QuizType? : QuizTypeEntity;
    QuizStatusIdReferenceStatus? : ReferenceStatusEntity;
    CourseLesson? : CourseLessonEntity[];
    CourseLessonFlag? : CourseLessonFlagEntity[];
    QuizQuestionLink? : QuizQuestionLinkEntity[];
    QuizReferenceQuizLink? : QuizReferenceQuizLinkEntity[];
    ReferenceQuizReferenceQuizLink? : QuizReferenceQuizLinkEntity[];
    QuizResult? : QuizResultEntity[];
}

export interface QuizOutcomeEntity extends DwOrmData {
    // Attributes
    QuizOutcomeId?: number;
    QuizOutcome?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
}

export interface QuizQuestionAnswerNotUsedEntity extends DwOrmData {
    // Attributes
    QuizQuestionAnswerId?: number;
    QuizQuestionId?: number;
    AnswerText?: string;
    AnswerImageMediaId?: number;
    IsCorrectAnswer?: boolean;
    ExplanationText?: string;
    AnswerOrder?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    QuizQuestionIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    QuestionNotUsed? : QuestionNotUsedEntity;
}

export interface QuizQuestionLinkEntity extends DwOrmData {
    // Attributes
    QuizId?: number;
    QuestionId?: number;
    QuizQuestionLinkId?: number;
    QuestionOrder?: number;
    QuestionWeight?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    IsDeleted?: boolean;

    // Display Attributes
    QuizIdDisplay?: string;
    QuestionIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    Question? : QuestionEntity;
    Quiz? : QuizEntity;
    SourceQuizResultQuestion? : QuizResultQuestionEntity[];
}

export interface QuizReferenceQuizLinkEntity extends DwOrmData {
    // Attributes
    QuizReferenceQuizLinkId?: number;
    QuizId?: number;
    ReferenceQuizId?: number;
    QuizWeight?: number;
    RequireCompletion?: boolean;
    PrioritizeMissedQuestions?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    QuizIdDisplay?: string;
    ReferenceQuizIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    Quiz? : QuizEntity;
    ReferenceQuiz? : QuizEntity;
}

export interface QuizResultEntity extends DwOrmData {
    // Attributes
    QuizResultId?: number;
    QuizId?: number;
    IsComplete?: boolean;
    CompletedQuestions?: number;
    TotalQuestions?: number;
    QuizScore?: number;
    PerfectScore?: number;
    QuizStartDateTime?: string;
    QuizStopDateTime?: string;
    PercentageScore?: number;
    QuizResultStatusId?: number;
    TotalTimeSeconds?: number;
    CorrectQuestions?: number;
    StudentCourseId?: number;
    CourseLessonProgressId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    ProgressReset?: boolean;
    QuizResultTypeId?: number;
    DailyQuizId?: number;
    AttemptNumber?: number;

    // Display Attributes
    QuizIdDisplay?: string;
    QuizResultStatusIdDisplay?: string;
    StudentCourseIdDisplay?: string;
    CourseLessonProgressIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    QuizResultTypeIdDisplay?: string;
    DailyQuizIdDisplay?: string;

    // Relations
    CourseLessonProgress? : CourseLessonProgressEntity;
    DailyQuiz? : DailyQuizEntity;
    Quiz? : QuizEntity;
    QuizResultStatus? : QuizResultStatusEntity;
    QuizResultType? : QuizResultTypeEntity;
    StudentCourse? : StudentCourseEntity;
    BestCourseLessonProgress? : CourseLessonProgressEntity[];
    CourseLessonSession? : CourseLessonSessionEntity[];
    BestDailyQuiz? : DailyQuizEntity[];
    QuizResultQuestion? : QuizResultQuestionEntity[];
    DailyStudentGamificationDay? : StudentGamificationDayEntity[];
}

export interface QuizResultQuestionEntity extends DwOrmData {
    // Attributes
    QuizResultQuestionId?: number;
    QuizResultId?: number;
    AnswerValue?: string;
    IsCorrect?: boolean;
    QuestionStartDateTime?: string;
    QuestionEndDateTime?: string;
    QuestionId?: number;
    QuestionAnswerId?: number;
    TotalTimeSeconds?: number;
    IsAnswered?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    QuestionOrder?: number;
    SourceQuizQuestionLinkId?: number;

    // Display Attributes
    QuizResultIdDisplay?: string;
    QuestionIdDisplay?: string;
    QuestionAnswerIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    SourceQuizQuestionLinkIdDisplay?: string;

    // Relations
    Question? : QuestionEntity;
    QuestionAnswer? : QuestionAnswerEntity;
    SourceQuizQuestionLink? : QuizQuestionLinkEntity;
    QuizResult? : QuizResultEntity;
}

export interface QuizResultStatusEntity extends DwOrmData {
    // Attributes
    QuizResultStatusId?: number;
    QuizResultStatus?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    QuizResult? : QuizResultEntity[];
}

export interface QuizResultTypeEntity extends DwOrmData {
    // Attributes
    QuizResultTypeId?: number;
    QuizResultType?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
    QuizResult? : QuizResultEntity[];
}

export interface QuizTypeEntity extends DwOrmData {
    // Attributes
    QuizTypeId?: number;
    QuizType?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    ShowQuizReferences?: boolean;

    // Display Attributes
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    Quiz? : QuizEntity[];
}

export interface ReferenceImageEntity extends DwOrmData {
    // Attributes
    ReferenceImageId?: number;
    ReferenceImageName?: string;
    ImageMediaId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    CourseEndorsementTemplateField? : CourseEndorsementTemplateFieldEntity[];
}

export interface ReferenceStatusEntity extends DwOrmData {
    // Attributes
    ReferenceStatusId?: number;
    ReferenceStatus?: string;


    // Relations
    CourseStatusIdCourse? : CourseEntity[];
    CourseDocumentItemStatusIdCourseDocumentItem? : CourseDocumentItemEntity[];
    CourseEndorsementStudentStatusIdCourseEndorsementStudent? : CourseEndorsementStudentEntity[];
    LessonStatusIdCourseLesson? : CourseLessonEntity[];
    CourseLessonDocumentLinkStatusIdCourseLessonDocumentLink? : CourseLessonDocumentLinkEntity[];
    CourseLessonDocumentLinkReference? : CourseLessonDocumentLinkReferenceEntity[];
    LessonProgressStatusIdCourseLessonProgress? : CourseLessonProgressEntity[];
    LessonSessionStatusIdCourseLessonSession? : CourseLessonSessionEntity[];
    ModuleStatusIdCourseModule? : CourseModuleEntity[];
    CourseModuleDocumentItemStatusIdCourseModuleDocumentItem? : CourseModuleDocumentItemEntity[];
    ModuleProgressStatusIdCourseModuleProgress? : CourseModuleProgressEntity[];
    DocumentAnchor? : DocumentAnchorEntity[];
    DocumentAsset? : DocumentAssetEntity[];
    DocumentPublication? : DocumentPublicationEntity[];
    DocumentSection? : DocumentSectionEntity[];
    DocumentSectionContent? : DocumentSectionContentEntity[];
    DocumentVersion? : DocumentVersionEntity[];
    QuizStatusIdQuiz? : QuizEntity[];
    StandardLoginMedia? : StandardLoginMediaEntity[];
    StudentCourseStatusIdStudentCourse? : StudentCourseEntity[];
    UserDocumentSectionFavorite? : UserDocumentSectionFavoriteEntity[];
}

export interface RoAcsWrittenMissedCodeStatsEntity extends DwOrmData {
    // Attributes
    AcsWrittenResultId?: number;
    AllCodesCount?: number;
    MatchedCodeCount?: number;
    UnMatchedCodesCount?: number;


    // Relations
    AcsWrittenResult? : AcsWrittenResultEntity;
}

export interface RoAssignmentDetailEntity extends DwOrmData {
    // Attributes
    FlightSchoolId?: number;
    AssignedDateTime?: string;
    DueDateTime?: string;
    CompletedDateTime?: string;
    CreatedDateTime?: string;
    AssignmentStatusId?: number;
    InstructorId?: number;
    StudentId?: number;
    PercentComplete?: number;
    StudentCompletedDateTime?: string;
    Acknowledged?: boolean;
    AcknowledgedDateTime?: string;


    // Relations
}

export interface RoAssignmentResetLessonImpactEntity extends DwOrmData {
    // Attributes
    CourseLessonProgressId?: number;
    StudentId?: number;
    StudentCourseId?: number;
    CourseId?: number;
    CourseModuleId?: number;
    CourseLessonId?: number;
    HasProgress?: boolean;
    StudentCount?: number;
    Completed?: boolean;
    CompletedStudentCount?: number;
    PassedQuizCount?: number;


    // Relations
}

export interface RoAssignmentResetStudentImpactEntity extends DwOrmData {
    // Attributes
    CourseLessonProgressId?: number;
    StudentId?: number;
    UserId?: number;
    DisplayName?: string;
    StudentCourseId?: number;
    CourseId?: number;
    CourseModuleId?: number;
    CourseLessonId?: number;
    Completed?: boolean;
    PassedQuizCount?: number;


    // Relations
}

export interface RoAssignmentStudentCompletedDetailsEntity extends DwOrmData {
    // Attributes
    AssignmentStudentId?: number;
    AssignmentId?: number;
    CompletedOnTime?: boolean;

    // Display Attributes
    AssignmentStudentIdDisplay?: string;

    // Relations
    AssignmentStudent? : AssignmentStudentEntity;
}

export interface RoAssignmentStudentCourseLessonProgressEntity extends DwOrmData {
    // Attributes
    AssignmentStudentId?: number;
    StudentId?: number;
    CourseLessonId?: number;
    CourseLessonProgressId?: number;
    LessonComplete?: boolean;
    PercentComplete?: number;
    UserId?: number;
    assignmentId?: number;
    LessonName?: string;
    CourseModuleId?: number;
    ModuleName?: string;
    CourseId?: number;
    CourseName?: string;
    LessonOrder?: number;
    ModuleOrder?: number;
    StudentCourseId?: number;
    StudentCourseStatusId?: number;
    CourseModuleProgressId?: number;
    ModuleProgressStatusId?: number;
    LessonProgressStatusId?: number;
    AssignmentStudentCourseLessonProgressId?: number;

    // Display Attributes
    AssignmentStudentIdDisplay?: string;
    CourseLessonIdDisplay?: string;
    CourseLessonProgressIdDisplay?: string;
    assignmentIdDisplay?: string;

    // Relations
    AssignmentIdAssignment? : AssignmentEntity;
    AssignmentStudent? : AssignmentStudentEntity;
    CourseLesson? : CourseLessonEntity;
    CourseLessonProgress? : CourseLessonProgressEntity;
}

export interface RoAssignmentStudentStatEntity extends DwOrmData {
    // Attributes
    AssignmentId?: number;
    StudentCount?: number;
    StudentPastDueCount?: number;
    StudentCompleteCount?: number;
    StudentActiveCount?: number;
    StudentIncompleteCount?: number;
    CompletedPercent?: number;
    PastDuePercent?: number;
    ActivePercent?: number;
    IncompletePercent?: number;

    // Display Attributes
    AssignmentIdDisplay?: string;

    // Relations
    Assignment? : AssignmentEntity;
}

export interface RoCompletedInvoicesEntity extends DwOrmData {
    // Attributes
    InvoiceControlNumber?: string;


    // Relations
}

export interface RoCourseEndorsementStudentActiveEntity extends DwOrmData {
    // Attributes
    CourseEndorsementStudentId?: number;
    CourseEndorsementId?: number;
    StudentCourseId?: number;
    CompletionDateTime?: string;
    ExpirationDateTime?: string;
    EndorsementPDFMediaId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    CourseEndorsementStudentStatusId?: number;
    UniqueColumn?: string;

    // Display Attributes
    StudentCourseIdDisplay?: string;

    // Relations
    StudentCourse? : StudentCourseEntity;
}

export interface RoCourseModuleLessonEntity extends DwOrmData {
    // Attributes
    CourseId?: number;
    CourseName?: string;
    CourseModuleId?: number;
    ModuleName?: string;
    ModuleOrder?: number;
    CourseLessonId?: number;
    LessonName?: string;
    LessonOrder?: number;
    QuizId?: number;
    LessonTypeId?: number;
    VideoId?: number;


    // Relations
}

export interface RoFlightSchoolAdminsEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    UserDetailId?: number;
    FlightSchoolId?: number;
    Email?: string;
    FirstName?: string;
    LastName?: string;


    // Relations
}

export interface RoFlightSchoolCoursePackageCountEntity extends DwOrmData {
    // Attributes
    FlightSchoolId?: number;
    FlightSchoolName?: string;
    CourseCount?: number;
    PackageCount?: number;

    // Display Attributes
    FlightSchoolIdDisplay?: string;

    // Relations
    FlightSchool? : FlightSchoolEntity;
}

export interface RoFlightSchoolCourseUniqueEntity extends DwOrmData {
    // Attributes
    FlightSchoolId?: number;
    CourseId?: number;

    // Display Attributes
    FlightSchoolIdDisplay?: string;
    CourseIdDisplay?: string;

    // Relations
    Course? : CourseEntity;
    FlightSchool? : FlightSchoolEntity;
}

export interface RoFlightSchoolPaymentInfoEntity extends DwOrmData {
    // Attributes
    FlightSchoolId?: number;
    ProcessorConfigId?: number;
    ProcessorConfigIsActive?: boolean;
    DefaultPaymentMethodId?: number;
    PaymentMethodDisplayName?: string;
    PaymentMethodIsActive?: boolean;
    PaymentMethodIsDefault?: boolean;
    HasDefaultPaymentMethod?: boolean;


    // Relations
    FlightSchool? : FlightSchoolEntity;
}

export interface RoInstructorAssignmentsPerWeekEntity extends DwOrmData {
    // Attributes
    FlightSchoolId?: number;
    InstructorId?: number;
    Week?: number;
    AssignedWeekEndingDate?: string;
    AssignmentCount?: number;
    CourseId?: number;


    // Relations
    Instructor? : InstructorEntity;
}

export interface RoIntegationCouresPurchaseEntity extends DwOrmData {
    // Attributes
    IntegrationCoursePurchaseKey?: string;
    RecordType?: string;
    PurchaseStatusId?: number;
    CourseId?: number;
    IntegrationOrganizationId?: number;
    UserFullName?: string;
    UserEmail?: string;
    RecordKey?: number;
    HasRequest?: boolean;
    CreatedDateTime?: string;
    CreatedBy?: number;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    PurchaseStatusIdDisplay?: string;
    CourseIdDisplay?: string;
    IntegrationOrganizationIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
}

export interface DwRoleEntity extends DwOrmData {
    // Attributes
    ApplicationId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    IsBuiltIn?: boolean;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    RoleDisplay?: string;
    RoleId?: number;
    RoleMeaning?: string;
    UniqueId?: string;

    // Display Attributes
    ApplicationIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    JoinRequestTypeRole? : JoinRequestTypeRoleEntity[];
    DevwareSubscriptionRole? : SubscriptionRoleEntity[];
    DwUserRole? : DwUserRoleEntity[];
}

export interface RoLessonQuizStatsEntity extends DwOrmData {
    // Attributes
    StudentId?: number;
    UserId?: number;
    StudentName?: string;
    FirstName?: string;
    LastName?: string;
    MediaPath?: string;
    StudentCourseId?: number;
    LastActivityDateTime?: string;
    PercentComplete?: number;
    TotalTimeSeconds?: number;
    CompletedDateTime?: string;
    CreatedDateTime?: string;
    FirstActivityDateTime?: string;
    CourseId?: number;
    CourseName?: string;
    CourseModuleId?: number;
    ModuleName?: string;
    SessionStartDateTime?: string;
    SessionEndDateTime?: string;
    CourseLessonId?: number;
    LessonName?: string;
    LessonCompleted?: boolean;
    PercentageScore?: number;
    QuizResultStatusId?: number;
    ProgressReset?: boolean;
    QuizPassed?: number;
    QuizFailed?: number;
    FlightSchoolId?: number;
    FlightSchoolName?: string;
    CourseTotalTimeSeconds?: number;
    SessionTimeSeconds?: number;


    // Relations
}

export interface DwRoMediaEntity extends DwOrmData {
    // Attributes
    ContainerName?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    FileName?: string;
    ImageHeight?: number;
    ImageWidth?: number;
    IsDeleted?: boolean;
    IsSecure?: boolean;
    MediaDetailKey?: string;
    MediaFolderId?: number;
    MediaGroupId?: number;
    MediaId?: number;
    MediaName?: string;
    MediaPath?: string;
    MediaSizeType?: string;
    MediaSizeTypeId?: number;
    MediaTypeId?: number;
    SizeInBytes?: number;
    Version?: number;

    // Display Attributes
    CreatedByDisplay?: string;
    MediaGroupIdDisplay?: string;
    MediaIdDisplay?: string;

    // Relations
    DwMedia? : DwMediaEntity;
    DwMediaGroup? : DwMediaGroupEntity;
    CourseImageCourse? : CourseEntity[];
    LessonImageCourseLesson? : CourseLessonEntity[];
    ModuleImageCourseModule? : CourseModuleEntity[];
    QuestionImageQuestion? : QuestionEntity[];
    CorrectAnswerImageQuestion? : QuestionEntity[];
    StandardLoginMedia? : StandardLoginMediaEntity;
}

export interface RoModuleLessonMaxOrderEntity extends DwOrmData {
    // Attributes
    CourseId?: number;
    CourseName?: string;
    CourseModuleId?: number;
    ModuleName?: string;
    ModuleMaxOrder?: number;
    LessonMaxOrder?: number;


    // Relations
}

export interface RoPostLoginSummaryEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    FlightSchoolId?: number;
    StudentId?: number;
    OnboardingVersion?: number;
    IsStudent?: boolean;
    IsInstructor?: boolean;
    IsLeadInstructor?: boolean;
    IsFlightSchoolAdmin?: boolean;
    IsFlightSchool?: boolean;
    PendingTermsCount?: number;
    PendingDocumentCount?: number;
    PendingAssignmentCount?: number;

    // Display Attributes
    UserIdDisplay?: string;
    FlightSchoolIdDisplay?: string;

    // Relations
}

export interface RoProductEntity extends DwOrmData {
    // Attributes
    ProductName?: string;
    ProductId?: number;
    CourseId?: number;
    PackageId?: number;
    SubscriptionTierId?: number;
    RetailPrice?: number;
    StripeProductId?: string;
    StripPriceId?: string;
    ProductTypeId?: number;
    MediaPath?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    ProductIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    Product? : ProductEntity;
    ProfitShareProductId? : ProfitShareEntity[];
}

export interface RoSchoolAssignmentStatsEntity extends DwOrmData {
    // Attributes
    FlightSchoolId?: number;
    FlightSchoolName?: string;
    CourseId?: number;
    CourseName?: string;
    AssignmentId?: number;
    AssignmentCreatedDateTime?: string;
    DueDateTime?: string;
    AssignmentStatusId?: number;
    AssignmentPastDue?: number;


    // Relations
    AssignmentStudentAssignmentId? : AssignmentStudentEntity;
    RoSchoolCourseEnrollmentStats? : RoSchoolCourseEnrollmentStatsEntity;
}

export interface RoSchoolBillingDetailsEntity extends DwOrmData {
    // Attributes
    FlightSchoolId?: number;
    School?: string;
    SchoolStatus?: string;
    Tier?: number;
    ProfitSharingRate?: number;
    Count?: number;
    SubscriptionRoleId?: number;
    Role?: string;
    ProfitSharingAmountCurrentMonth?: number;
    CurrentMonthShort?: string;
    CurrentMonthLong?: string;

    // Display Attributes
    FlightSchoolIdDisplay?: string;
    TierDisplay?: string;
    SubscriptionRoleIdDisplay?: string;

    // Relations
    FlightSchool? : FlightSchoolEntity;
    TierSubscription? : SubscriptionEntity;
    SubscriptionRole? : SubscriptionRoleEntity;
}

export interface RoSchoolCourseEnrollmentStatsEntity extends DwOrmData {
    // Attributes
    FlightSchoolId?: number;
    FlightSchoolName?: string;
    CourseId?: number;
    CourseName?: string;
    StudentId?: number;
    UserId?: number;
    StudentName?: string;
    LastActivityDateTime?: string;
    PercentComplete?: number;
    TotalTimeSeconds?: number;
    CompletedDateTime?: string;
    FirstActivityDateTime?: string;
    ActiveStudent?: number;
    IsComplete?: number;
    InProgressTotalTimeSeconds?: number;
    CompletedTotalTimeSeconds?: number;
    InProgressPercentComplete?: number;
    AcsTestPassedFirstTime?: number;
    AcsTestUploaded?: number;
    AcsTestPassed?: number;
    AcsAwaitingUpload?: number;
    PastDueAssignments?: number;
    ProgressDaysLearningLastActivity?: number;
    ProgressPercentPerDayLastActivity?: number;
    LearningTimePerDayLastActivity?: number;
    ProgressDaysLearningNow?: number;
    ProgressPercentPerDayNow?: number;
    LearningTimePerDayNow?: number;
    FirstName?: string;
    LastName?: string;
    MediaPath?: string;
    CreatedDateTime?: string;
    StudentCourseId?: number;
    AcsTestAverageScore?: number;
    HideInReporting?: boolean;

    // Display Attributes
    StudentIdDisplay?: string;

    // Relations
    InstructorStudentStudentId? : InstructorStudentEntity;
    StudentCourseLockInstructorStudentCourseId? : StudentCourseLockInstructorEntity;
    RoSchoolAssignmentStats? : RoSchoolAssignmentStatsEntity;
    RoStudentCourseInstructor? : RoStudentCourseInstructorEntity[];
}

export interface RoSchoolInvoicesEntity extends DwOrmData {
    // Attributes
    FlightSchoolId?: number;
    InvoiceId?: number;
    InvoiceDate?: string;
    InvoiceAmount?: number;
    InvoiceControlNumber?: string;
    RelatedInvoiceId?: number;

    // Display Attributes
    FlightSchoolIdDisplay?: string;
    InvoiceIdDisplay?: string;

    // Relations
    FlightSchool? : FlightSchoolEntity;
    Invoice? : InvoiceEntity;
}

export interface RoSchoolPaymentMethodEntity extends DwOrmData {
    // Attributes
    FlightSchoolId?: number;
    ProcessorConfigId?: number;
    Displayname?: string;
    PaymentMethodId?: number;
    PaymentId?: string;
    SetupIntentId?: string;
    BillingName?: string;
    BillingEmail?: string;
    IsDefault?: boolean;
    IsActive?: boolean;
    BillingPostalCode?: string;
    ProcessConfigActive?: boolean;

    // Display Attributes
    FlightSchoolIdDisplay?: string;
    ProcessorConfigIdDisplay?: string;

    // Relations
    FlightSchool? : FlightSchoolEntity;
    ProcessorConfig? : ProcessorConfigEntity;
}

export interface RoSchoolStudentStatsEntity extends DwOrmData {
    // Attributes
    FlightSchoolId?: number;
    FlightSchoolName?: string;
    EnrolledCount?: number;
    EndorsedCount?: number;
    AssignmentsThisWeekCount?: number;
    AssignmentPastDueCount?: number;


    // Relations
    FlightSchool? : FlightSchoolEntity;
}

export interface RoSchoolSubscriptionEntity extends DwOrmData {
    // Attributes
    SubscriptionId?: number;
    SubscriptionTierId?: number;
    FlightSchoolId?: number;
    EffectiveStartDate?: string;
    EffectiveEndDate?: string;
    SubscriptionStatus?: string;
    PendingSubscriptionId?: number;
    PendingSubscriptionTierId?: number;
    Pending?: boolean;
    PreviousSubscriptionId?: number;
    PreviousSubscriptionTierId?: number;

    // Display Attributes
    SubscriptionIdDisplay?: string;
    PendingSubscriptionIdDisplay?: string;
    PreviousSubscriptionIdDisplay?: string;

    // Relations
    PendingSubscription? : SubscriptionEntity;
    Subscription? : SubscriptionEntity;
    PreviousSubscription? : SubscriptionEntity;
}

export interface RoStudentCourseAcsTestResultDetailEntity extends DwOrmData {
    // Attributes
    StudentCourseId?: number;
    ACSTestResultCount?: number;
    PassedAny?: boolean;
    FailedAny?: boolean;

    // Display Attributes
    StudentCourseIdDisplay?: string;

    // Relations
    StudentCourse? : StudentCourseEntity;
}

export interface RoStudentCourseDetailEntity extends DwOrmData {
    // Attributes
    FlightSchoolId?: number;
    FlightSchoolName?: string;
    UserId?: number;
    StudentName?: string;
    LastLoginDateTime?: string;
    UserPictureMediaPath?: string;
    ImageWidth?: number;
    ImageHeight?: number;
    StudentId?: number;
    StudentCourseId?: number;
    StudentCourseStatusId?: number;
    CourseId?: number;
    CourseName?: string;
    PercentComplete?: number;
    LastActivityDateTime?: string;
    FirstActivityDateTime?: string;
    ModulesCount?: number;
    ModulesCompleted?: number;
    LessonCount?: number;
    LessonsCompleted?: number;
    TotalTimeSeconds?: number;
    TotalVideoTimeSeconds?: number;
    TotalQuizTimeSeconds?: number;
    CompletedDateTime?: string;
    IsEndorsed?: boolean;
    IsStudent?: boolean;
    IsInstructor?: boolean;
    IsFlightSchoolAdmin?: boolean;
    IsFlightSchool?: boolean;


    // Relations
    FlightSchool? : FlightSchoolEntity;
}

export interface RoStudentCourseInstructorEntity extends DwOrmData {
    // Attributes
    StudentCourseId?: number;
    InstructorId?: number;

    // Display Attributes
    StudentCourseIdDisplay?: string;
    InstructorIdDisplay?: string;

    // Relations
    Instructor? : InstructorEntity;
    StudentCourse? : StudentCourseEntity;
    RoSchoolCourseEnrollmentStats? : RoSchoolCourseEnrollmentStatsEntity;
}

export interface RoStudentCourseProgressMismatchEntity extends DwOrmData {
    // Attributes
    StudentCourseId?: number;
    LessonsCompleted?: number;
    LessonCount?: number;
    LessonCompleteActual?: number;
    LessonCountActual?: number;
    ModulesCompleted?: number;
    ModulesCount?: number;
    ModuleCount?: number;


    // Relations
}

export interface RoStudentOverviewDetailsEntity extends DwOrmData {
    // Attributes
    StudentId?: number;
    UserId?: number;
    FullName?: string;
    FlightSchoolId?: number;
    FlightSchoolName?: string;
    CreatedDateTime?: string;
    LastLoginDateTime?: string;
    HighestRole?: string;
    OverallProgressPercent?: number;
    ActiveAssignments?: number;
    CompletedActiveAssignments?: number;
    OverdueActiveAssignments?: number;

    // Display Attributes
    UserIdDisplay?: string;

    // Relations
    DwUser? : DwUserEntity;
}

export interface RoStudentPaymentMethodEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    ProcessorConfigId?: number;
    DisplayName?: string;
    PaymentMethodId?: number;
    PaymentId?: string;
    SetupIntentId?: string;
    BillingName?: string;
    BillingEmail?: string;
    IsDefault?: boolean;
    IsActive?: boolean;
    BillingPostalCode?: string;
    ProcessConfigActive?: boolean;

    // Display Attributes
    UserIdDisplay?: string;

    // Relations
    DwUser? : DwUserEntity;
}

export interface RoStudentSchoolCoursesEntity extends DwOrmData {
    // Attributes
    StudentId?: number;
    StudentCourseId?: number;
    CourseId?: number;
    CourseName?: string;
    FlightSchoolId?: number;
    StudentName?: string;
    UserId?: number;

    // Display Attributes
    StudentIdDisplay?: string;
    StudentCourseIdDisplay?: string;
    CourseIdDisplay?: string;
    FlightSchoolIdDisplay?: string;
    UserIdDisplay?: string;

    // Relations
    Course? : CourseEntity;
    FlightSchool? : FlightSchoolEntity;
    Student? : StudentEntity;
    StudentCourse? : StudentCourseEntity;
    DwUser? : DwUserEntity;
}

export interface RoUserRoleDetailEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    IsStudent?: boolean;
    IsInstructor?: boolean;
    IsLeadInstructor?: boolean;
    IsFlightSchoolAdmin?: boolean;
    IsFlightSchool?: boolean;

    // Display Attributes
    UserIdDisplay?: string;

    // Relations
    DwUser? : DwUserEntity;
}

export interface RptInvoiceProductDetailEntity extends DwOrmData {
    // Attributes
    FlightSchoolId?: number;
    UserId?: number;
    InvoiceStatusId?: number;
    InvoiceId?: number;
    InvoiceNumber?: string;
    InvoiceStatus?: string;
    InvoiceTypeId?: number;
    InvoiceType?: string;
    ProductId?: number;
    ProductName?: string;
    ProductTypeId?: number;
    ProductType?: string;
    CourseId?: number;
    PackageId?: number;
    SubscriptionTierId?: number;
    ItemCost?: number;
    Quantity?: number;
    TotalCost?: number;
    InvoiceLineId?: number;
    FlightSchoolName?: string;
    InvoiceDate?: string;
    PaymentPartyTypeId?: number;
    PaymentPartyType?: string;
    StudentName?: string;


    // Relations
}

export interface RptProfitShareEntity extends DwOrmData {
    // Attributes
    ProfitShareId?: number;
    FlightSchoolId?: number;
    FlightSchoolName?: string;
    StudentId?: number;
    StudentName?: string;
    ProductId?: number;
    ProductName?: string;
    ProductTypeId?: number;
    ProductType?: string;
    CourseId?: number;
    PackageId?: number;
    SubscriptionTierId?: number;
    RetailPrice?: number;
    ProfitSharingPercentage?: number;
    ProfitSharingAmount?: number;
    ProfitShareStatusId?: number;
    ProfitShareStatus?: string;
    ProfitShareTypeId?: number;
    ProfitShareType?: string;
    InvoiceLineId?: number;
    InvoiceId?: number;
    CreatedDateTime?: string;
    PaymentPartyTypeId?: number;
    PaymentPartyType?: string;
    Month?: number;
    Year?: number;

    // Display Attributes
    ProfitShareStatusIdDisplay?: string;
    ProfitShareTypeIdDisplay?: string;

    // Relations
}

export interface SchoolBillingModeEntity extends DwOrmData {
    // Attributes
    SchoolBillingModeId?: number;
    SchoolBillingMode?: string;
    SchoolBillingModeDescription?: string;
    DeferredCoursePurchases?: boolean;
    DeferredSubscriptionBilling?: boolean;
    UsesPaymentTerms?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
    FlightSchool? : FlightSchoolEntity[];
    SchoolBillingPolicyPeriod? : SchoolBillingPolicyPeriodEntity[];
}

export interface SchoolBillingPolicyPeriodEntity extends DwOrmData {
    // Attributes
    SchoolBillingPolicyPeriodId?: number;
    FlightSchoolId?: number;
    EffectiveStartDate?: string;
    EffectiveEndDate?: string;
    BillingTimeZone?: string;
    ReviewNotes?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    SchoolBillingModeId?: number;

    // Display Attributes
    FlightSchoolIdDisplay?: string;
    SchoolBillingModeIdDisplay?: string;

    // Relations
    FlightSchool? : FlightSchoolEntity;
    SchoolBillingMode? : SchoolBillingModeEntity;
}

export interface SchoolFeatureEntity extends DwOrmData {
    // Attributes
    SchoolFeatureId?: number;
    SchoolFeature?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    IsDefault?: boolean;

    // Display Attributes
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    FlightSchoolFeature? : FlightSchoolFeatureEntity[];
}

export interface StandardColorSetEntity extends DwOrmData {
    // Attributes
    StandardColorSetId?: number;
    ForegroundColor?: string;
    BackgroundColor?: string;
    ColorSetName?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    NavigationColorSetIdFlightSchoolBranding? : FlightSchoolBrandingEntity[];
    SidebarColorSetIdFlightSchoolBranding? : FlightSchoolBrandingEntity[];
    LoginColorSetIdFlightSchoolBranding? : FlightSchoolBrandingEntity[];
}

export interface StandardLoginMediaEntity extends DwOrmData {
    // Attributes
    StandardLoginMediaId?: number;
    LoginMediaName?: string;
    MediaId?: number;
    ReferenceStatusId?: number;
    IsDefault?: boolean;

    // Display Attributes
    MediaIdDisplay?: string;
    ReferenceStatusIdDisplay?: string;

    // Relations
    DwroMedia? : DwRoMediaEntity;
    DwMedia? : DwMediaEntity;
    ReferenceStatus? : ReferenceStatusEntity;
    FlightSchoolBranding? : FlightSchoolBrandingEntity[];
}

export interface StateProvinceEntity extends DwOrmData {
    // Attributes
    StateProvinceId?: number;
    CountryId?: number;
    StateProvinceName?: string;
    StateProvinceShortName?: string;
    StateCode?: string;
    CreatedDateTime?: string;
    CreatedBy?: number;
    ModifiedDateTime?: string;
    ModifiedBy?: number;

    // Display Attributes
    CountryIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    Country? : CountryEntity;
    Address? : AddressEntity[];
    PostalCode? : PostalCodeEntity[];
}

export interface StripeCheckoutSessionEntity extends DwOrmData {
    // Attributes
    StripeCheckoutSessionId?: number;
    PaymentEventId?: number;
    SessionCompletedDateTime?: string;
    PaymentLinkId?: string;
    CustomerName?: string;
    CustomerEmail?: string;
    CustomerAddressId?: number;
    SubtotalAmount?: number;
    DiscountAmount?: number;
    DiscountId?: number;
    TaxAmount?: number;
    PaidAmount?: number;
    StripeCustomerId?: string;
    LastLogId?: number;
    StripeSessionId?: string;
    StripeCheckoutSessionStatusId?: number;
    ProductsDescription?: string;

    // Display Attributes
    PaymentEventIdDisplay?: string;
    CustomerAddressIdDisplay?: string;
    DiscountIdDisplay?: string;
    LastLogIdDisplay?: string;
    StripeCheckoutSessionStatusIdDisplay?: string;

    // Relations
    CustomerAddress? : AddressEntity;
    Discount? : DiscountEntity;
    PaymentEvent? : PaymentEventEntity;
    StripeCheckoutSessionStatus? : StripeCheckoutSessionStatusEntity;
    CoursePurchase? : CoursePurchaseEntity[];
    Invoice? : InvoiceEntity[];
    StripeCheckoutSessionProduct? : StripeCheckoutSessionProductEntity[];
}

export interface StripeCheckoutSessionProductEntity extends DwOrmData {
    // Attributes
    StripeCheckoutSessionProductId?: number;
    StripeCheckoutSessionId?: number;
    ProductId?: number;

    // Display Attributes
    StripeCheckoutSessionIdDisplay?: string;
    ProductIdDisplay?: string;

    // Relations
    Product? : ProductEntity;
    StripeCheckoutSession? : StripeCheckoutSessionEntity;
}

export interface StripeCheckoutSessionStatusEntity extends DwOrmData {
    // Attributes
    StripeCheckoutSessionStatusId?: number;
    StripeCheckoutSessionStatus?: string;


    // Relations
    StripeCheckoutSession? : StripeCheckoutSessionEntity[];
}

export interface StudentEntity extends DwOrmData {
    // Attributes
    StudentId?: number;
    UserId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    AddressId?: number;
    PilotCertificateNumber?: string;
    CitizenshipCountryId?: number;
    BirthDate?: string;
    PilotTypeId?: number;
    FlightSchoolPositionId?: number;
    AcquisitionSourceId?: number;
    AcquisitionSourceOther?: string;
    InstructorCertifcateNumber?: string;
    StudentCode?: string;
    AviationGoalId?: number;
    TimeZoneId?: number;

    // Display Attributes
    UserIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    AddressIdDisplay?: string;
    CitizenshipCountryIdDisplay?: string;
    PilotTypeIdDisplay?: string;
    FlightSchoolPositionIdDisplay?: string;
    AcquisitionSourceIdDisplay?: string;
    AviationGoalIdDisplay?: string;
    TimeZoneIdDisplay?: string;

    // Relations
    AcquisitionSource? : AcquisitionSourceEntity;
    Address? : AddressEntity;
    AviationGoal? : AviationGoalEntity;
    CitizenshipCountry? : CountryEntity;
    FlightSchoolPosition? : FlightSchoolPositionEntity;
    PilotType? : PilotTypeEntity;
    TimeZoneIdTimeZone? : TimeZoneEntity;
    DwUser? : DwUserEntity;
    AssignmentStudent? : AssignmentStudentEntity[];
    CoursePurchaseReservationCourse? : CoursePurchaseReservationCourseEntity[];
    CoursePurchaseStudent? : CoursePurchaseStudentEntity[];
    DailyQuiz? : DailyQuizEntity[];
    DocumentItemAcknowledgement? : DocumentItemAcknowledgementEntity[];
    FlightSchoolGroupStudent? : FlightSchoolGroupStudentEntity[];
    InstructorStudent? : InstructorStudentEntity[];
    JoinRequestCoursePurchase? : JoinRequestCoursePurchaseEntity[];
    ProfitShare? : ProfitShareEntity[];
    RoStudentSchoolCourses? : RoStudentSchoolCoursesEntity[];
    StudentAchievement? : StudentAchievementEntity[];
    StudentActivity? : StudentActivityEntity[];
    StudentCourse? : StudentCourseEntity[];
    StudentGamificationDay? : StudentGamificationDayEntity[];
    StudentGamificationSummary? : StudentGamificationSummaryEntity[];
    StudentLessonProgressEvent? : StudentLessonProgressEventEntity[];
    StudentProgressResetEvent? : StudentProgressResetEventEntity[];
    StudentWeatherDayTransaction? : StudentWeatherDayTransactionEntity[];
    SubscriptionCourseTracking? : SubscriptionCourseTrackingEntity[];
}

export interface StudentAchievementEntity extends DwOrmData {
    // Attributes
    StudentAchievementId?: number;
    StudentId?: number;
    AchievementDefinitionId?: number;
    StudentCourseId?: number;
    CurrentMetricValue?: number;
    CurrentAchievementTierId?: number;
    NextAchievementTierId?: number;
    NextThreshold?: number;
    ProgressPercent?: number;
    LastCalculatedDateTime?: string;
    CreatedDateTime?: string;
    ModifiedDateTime?: string;

    // Display Attributes
    StudentIdDisplay?: string;
    AchievementDefinitionIdDisplay?: string;
    StudentCourseIdDisplay?: string;
    CurrentAchievementTierIdDisplay?: string;
    NextAchievementTierIdDisplay?: string;

    // Relations
    AchievementDefinition? : AchievementDefinitionEntity;
    CurrentAchievementTier? : AchievementTierEntity;
    NextAchievementTier? : AchievementTierEntity;
    Student? : StudentEntity;
    StudentCourse? : StudentCourseEntity;
    StudentAchievementAward? : StudentAchievementAwardEntity[];
}

export interface StudentAchievementAwardEntity extends DwOrmData {
    // Attributes
    StudentAchievementAwardId?: number;
    StudentAchievementId?: number;
    AchievementTierId?: number;
    EarnedDateTime?: string;
    CalculationContext?: string;
    CreatedDateTime?: string;

    // Display Attributes
    StudentAchievementIdDisplay?: string;
    AchievementTierIdDisplay?: string;

    // Relations
    AchievementTier? : AchievementTierEntity;
    StudentAchievement? : StudentAchievementEntity;
}

export interface StudentActivityEntity extends DwOrmData {
    // Attributes
    StudentActivityId?: number;
    StudentId?: number;
    StudentActivityTypeId?: number;
    ActivityDateTime?: string;
    ActorUserId?: number;
    ActorDisplayName?: string;
    ActorRoleName?: string;
    ActivityTitle?: string;
    ActivityDetail?: string;
    OldValueText?: string;
    NewValueText?: string;
    SourceMetaDataItemId?: number;
    SourceKeyValue?: number;
    RelatedMetaDataItemId?: number;
    RelatedKeyValue?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    CourseAssignmentSourceTypeId?: number;
    StudentAcknowledgedDateTime?: string;

    // Display Attributes
    StudentIdDisplay?: string;
    StudentActivityTypeIdDisplay?: string;
    ActorUserIdDisplay?: string;
    SourceMetaDataItemIdDisplay?: string;
    RelatedMetaDataItemIdDisplay?: string;
    CourseAssignmentSourceTypeIdDisplay?: string;

    // Relations
    CourseAssignmentSourceType? : CourseAssignmentSourceTypeEntity;
    SourceDwMetaDataItem? : DwMetaDataItemEntity;
    RelatedDwMetaDataItem? : DwMetaDataItemEntity;
    Student? : StudentEntity;
    StudentActivityType? : StudentActivityTypeEntity;
    ActorDwUser? : DwUserEntity;
}

export interface StudentActivityTypeEntity extends DwOrmData {
    // Attributes
    StudentActivityTypeId?: number;
    ActivityTypeKey?: string;
    ActivityTypeName?: string;
    ActivityCssClass?: string;
    SortOrder?: number;
    Active?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
    StudentActivity? : StudentActivityEntity[];
}

export interface StudentCourseEntity extends DwOrmData {
    // Attributes
    StudentCourseId?: number;
    StudentId?: number;
    CourseId?: number;
    IsActive?: boolean;
    PercentComplete?: number;
    ModulesCompleted?: number;
    ModulesCount?: number;
    LastActivityDateTime?: string;
    LessonsCompleted?: number;
    LessonCount?: number;
    TotalTimeSeconds?: number;
    FirstActivityDateTime?: string;
    CompletedDateTime?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    StudentCourseStatusId?: number;
    IsEndorsed?: boolean;
    TotalVideoTimeSeconds?: number;
    TotalQuizTimeSeconds?: number;
    NextCourseLessonId?: number;
    AcsTestPassedFirstTime?: boolean;
    AcsTestUploaded?: boolean;
    AcsTestPassed?: boolean;
    HideInReporting?: boolean;
    AcsTestLastScore?: number;
    StudentCourseProgressStatusId?: number;

    // Display Attributes
    StudentIdDisplay?: string;
    CourseIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    StudentCourseStatusIdDisplay?: string;
    NextCourseLessonIdDisplay?: string;
    StudentCourseProgressStatusIdDisplay?: string;

    // Relations
    Course? : CourseEntity;
    NextCourseLesson? : CourseLessonEntity;
    StudentCourseStatusIdReferenceStatus? : ReferenceStatusEntity;
    Student? : StudentEntity;
    StudentCourseProgressStatus? : StudentCourseProgressStatusEntity;
    AcsWrittenResult? : AcsWrittenResultEntity[];
    StudentCoursetIdAIPromptRequest? : AIPromptRequestEntity[];
    CourseEndorsementStudent? : CourseEndorsementStudentEntity;
    CourseModuleProgress? : CourseModuleProgressEntity[];
    CoursePurchaseReservationCourse? : CoursePurchaseReservationCourseEntity[];
    DailyQuiz? : DailyQuizEntity[];
    IntegrationCoursePurchase? : IntegrationCoursePurchaseEntity;
    JoinRequestCoursePurchase? : JoinRequestCoursePurchaseEntity[];
    ModificationHistoryStudent? : ModificationHistoryStudentEntity[];
    QuizResult? : QuizResultEntity[];
    RoCourseEndorsementStudentActive? : RoCourseEndorsementStudentActiveEntity[];
    RoStudentCourseAcsTestResultDetail? : RoStudentCourseAcsTestResultDetailEntity;
    RoStudentCourseInstructor? : RoStudentCourseInstructorEntity[];
    RoStudentSchoolCourses? : RoStudentSchoolCoursesEntity[];
    StudentAchievement? : StudentAchievementEntity[];
    StudentCourseLockInstructor? : StudentCourseLockInstructorEntity[];
    StudentModuleSummary? : StudentModuleSummaryEntity[];
    StudentProgressResetEvent? : StudentProgressResetEventEntity[];
    SubscriptionCourseTracking? : SubscriptionCourseTrackingEntity[];
}

export interface StudentCourseLockInstructorEntity extends DwOrmData {
    // Attributes
    StudentCourseLockInstructorId?: number;
    StudentCourseId?: number;
    InstructorId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    StudentCourseIdDisplay?: string;
    InstructorIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    Instructor? : InstructorEntity;
    StudentCourse? : StudentCourseEntity;
    RoSchoolCourseEnrollmentStatsStudentCourseId? : RoSchoolCourseEnrollmentStatsEntity[];
}

export interface StudentCourseProgressStatusEntity extends DwOrmData {
    // Attributes
    StudentCourseProgressStatusId?: number;
    ProgressStatusKey?: string;
    ProgressStatusName?: string;
    ProgressStatusCssClass?: string;
    SortOrder?: number;
    Active?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
    StudentCourse? : StudentCourseEntity[];
}

export interface StudentGamificationDayEntity extends DwOrmData {
    // Attributes
    StudentGamificationDayId?: number;
    StudentId?: number;
    ActivityDate?: string;
    TimeZoneId?: number;
    AppliedUtcOffsetMinutes?: number;
    HasActualActivity?: boolean;
    CompletedLessonCount?: number;
    VerifiedActiveTimeSeconds?: number;
    CountedActiveTimeSeconds?: number;
    DailyQuizCompleted?: boolean;
    DailyQuizCorrectAnswerCount?: number;
    DailyQuizResultId?: number;
    WeatherDayApplied?: boolean;
    CreatedDateTime?: string;
    RecalculatedDateTime?: string;

    // Display Attributes
    StudentIdDisplay?: string;
    TimeZoneIdDisplay?: string;
    DailyQuizResultIdDisplay?: string;

    // Relations
    DailyQuizResult? : QuizResultEntity;
    Student? : StudentEntity;
    TimeZoneIdTimeZone? : TimeZoneEntity;
    StudentWeatherDayTransaction? : StudentWeatherDayTransactionEntity[];
}

export interface StudentGamificationSummaryEntity extends DwOrmData {
    // Attributes
    StudentId?: number;
    CurrentProtectedStreakDays?: number;
    LongestProtectedStreakDays?: number;
    WeatherDayBalance?: number;
    LastActualActivityDate?: string;
    LastCoveredActivityDate?: string;
    LastWeatherDayGrantDate?: string;
    TimeZoneId?: number;
    LastRecalculatedDateTime?: string;
    CreatedDateTime?: string;
    ModifiedDateTime?: string;
    StudentGamificationSummaryId?: number;

    // Display Attributes
    StudentIdDisplay?: string;
    TimeZoneIdDisplay?: string;

    // Relations
    Student? : StudentEntity;
    TimeZoneIdTimeZone? : TimeZoneEntity;
}

export interface StudentLessonProgressEventEntity extends DwOrmData {
    // Attributes
    StudentLessonProgressEventId?: number;
    StudentId?: number;
    DeviceInstallationId?: string;
    EventId?: string;
    ClientSequence?: number;
    EventType?: string;
    OccurredAtUtc?: string;
    ProcessingState?: string;
    ProcessedAtUtc?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    StudentIdDisplay?: string;

    // Relations
    Student? : StudentEntity;
}

export interface StudentModuleSummaryEntity extends DwOrmData {
    // Attributes
    StudentModuleSummaryId?: number;
    StudentCourseId?: number;
    CourseModuleId?: number;
    ModuleSummaryHtml?: string;
    StudentModuleSummaryStatusId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    CourseModuleProgressId?: number;

    // Display Attributes
    StudentCourseIdDisplay?: string;
    CourseModuleIdDisplay?: string;
    StudentModuleSummaryStatusIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    CourseModuleProgressIdDisplay?: string;

    // Relations
    CourseModule? : CourseModuleEntity;
    CourseModuleProgress? : CourseModuleProgressEntity;
    StudentCourse? : StudentCourseEntity;
    StudentModuleSummaryStatus? : StudentModuleSummaryStatusEntity;
}

export interface StudentModuleSummaryStatusEntity extends DwOrmData {
    // Attributes
    StudentModuleSummaryStatusId?: number;
    StudentModuleSummaryStatus?: string;


    // Relations
    StudentModuleSummary? : StudentModuleSummaryEntity[];
}

export interface StudentProgressResetEventEntity extends DwOrmData {
    // Attributes
    StudentProgressResetEventId?: number;
    ResetBatchId?: string;
    StudentId?: number;
    StudentCourseId?: number;
    CourseId?: number;
    AssignmentId?: number;
    AssignmentStudentId?: number;
    ResetSourceType?: string;
    ResetReason?: string;
    ResetDateTime?: string;
    ResetByUserId?: number;
    ResetByDisplayName?: string;
    AffectedModuleCount?: number;
    AffectedLessonCount?: number;
    CompletedLessonCount?: number;
    PassedQuizCount?: number;
    SnapshotVersion?: number;
    ResetSnapshotJson?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;

    // Display Attributes
    StudentIdDisplay?: string;
    StudentCourseIdDisplay?: string;
    CourseIdDisplay?: string;
    AssignmentIdDisplay?: string;
    AssignmentStudentIdDisplay?: string;
    ResetByUserIdDisplay?: string;

    // Relations
    Assignment? : AssignmentEntity;
    AssignmentStudent? : AssignmentStudentEntity;
    Course? : CourseEntity;
    Student? : StudentEntity;
    StudentCourse? : StudentCourseEntity;
    ResetByDwUser? : DwUserEntity;
}

export interface StudentWeatherDayTransactionEntity extends DwOrmData {
    // Attributes
    StudentWeatherDayTransactionId?: number;
    StudentId?: number;
    TransactionType?: string;
    Quantity?: number;
    EffectiveDate?: string;
    GrantPeriodStartDate?: string;
    StudentGamificationDayId?: number;
    GamificationConfigurationId?: number;
    CalculationContext?: string;
    CreatedDateTime?: string;

    // Display Attributes
    StudentIdDisplay?: string;
    StudentGamificationDayIdDisplay?: string;
    GamificationConfigurationIdDisplay?: string;

    // Relations
    GamificationConfiguration? : GamificationConfigurationEntity;
    Student? : StudentEntity;
    StudentGamificationDay? : StudentGamificationDayEntity;
}

export interface SubdomainSetupStatusEntity extends DwOrmData {
    // Attributes
    SubdomainSetupStatusId?: number;
    SubdomainSetupStatus?: string;


    // Relations
    FlightSchoolBranding? : FlightSchoolBrandingEntity[];
}

export interface SubdomainTypeEntity extends DwOrmData {
    // Attributes
    SubdomainTypeId?: number;
    SubdomainType?: string;


    // Relations
    FlightSchoolBranding? : FlightSchoolBrandingEntity[];
}

export interface SubscriptionEntity extends DwOrmData {
    // Attributes
    SubscriptionId?: number;
    FlightSchoolId?: number;
    SubscriptionTierId?: number;
    SubscriptionStatusId?: number;
    EffectiveStartDate?: string;
    EffectiveEndDate?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    Pending?: boolean;
    DiscountId?: number;
    FirstInvoiceDateTime?: string;
    LastInvoiceDateTime?: string;
    NextInvoiceDateTime?: string;
    DiscountAppliedDate?: string;
    DiscountExpirationDate?: string;

    // Display Attributes
    FlightSchoolIdDisplay?: string;
    SubscriptionTierIdDisplay?: string;
    SubscriptionStatusIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    DiscountIdDisplay?: string;

    // Relations
    Discount? : DiscountEntity;
    FlightSchool? : FlightSchoolEntity;
    SubscriptionStatus? : SubscriptionStatusEntity;
    SubscriptionTier? : SubscriptionTierEntity;
    InvoiceLine? : InvoiceLineEntity[];
    TierRoSchoolBillingDetails? : RoSchoolBillingDetailsEntity;
    PendingRoSchoolSubscription? : RoSchoolSubscriptionEntity;
    RoSchoolSubscription? : RoSchoolSubscriptionEntity;
    PreviousRoSchoolSubscription? : RoSchoolSubscriptionEntity;
    SubscriptionCourseTracking? : SubscriptionCourseTrackingEntity[];
    SubscriptionRoleTracking? : SubscriptionRoleTrackingEntity[];
}

export interface SubscriptionCourseTrackingEntity extends DwOrmData {
    // Attributes
    SubscriptionCourseTrackingId?: number;
    StudentCourseId?: number;
    StudentId?: number;
    FlightSchoolId?: number;
    SubscriptionId?: number;
    SubscriptionRoleId?: number;
    CourseId?: number;
    GrantedDateTime?: string;
    Revoked?: boolean;
    RevokedDateTime?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    StudentCourseIdDisplay?: string;
    StudentIdDisplay?: string;
    FlightSchoolIdDisplay?: string;
    SubscriptionIdDisplay?: string;
    SubscriptionRoleIdDisplay?: string;
    CourseIdDisplay?: string;

    // Relations
    Course? : CourseEntity;
    FlightSchool? : FlightSchoolEntity;
    Student? : StudentEntity;
    StudentCourse? : StudentCourseEntity;
    Subscription? : SubscriptionEntity;
    SubscriptionRole? : SubscriptionRoleEntity;
}

export interface SubscriptionFeatureEntity extends DwOrmData {
    // Attributes
    SubscriptionFeatureId?: number;
    SubscriptionFeature?: string;
    FeatureKey?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    SubscriptionTierFeature? : SubscriptionTierFeatureEntity[];
}

export interface SubscriptionRoleEntity extends DwOrmData {
    // Attributes
    SubscriptionRoleId?: number;
    SubscriptionRole?: string;
    DevwareRoleId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    ProductId?: string;

    // Display Attributes
    DevwareRoleIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    DevwareDwRole? : DwRoleEntity;
    DiscountSubscriptionRole? : DiscountSubscriptionRoleEntity[];
    JoinRequestTypeSubscriptionRole? : JoinRequestTypeSubscriptionRoleEntity[];
    RoSchoolBillingDetails? : RoSchoolBillingDetailsEntity;
    SubscriptionCourseTracking? : SubscriptionCourseTrackingEntity[];
    SubscriptionRoleTracking? : SubscriptionRoleTrackingEntity[];
    SubscriptionTierRole? : SubscriptionTierRoleEntity[];
    UserSubscriptionRole? : UserSubscriptionRoleEntity[];
}

export interface SubscriptionRoleTrackingEntity extends DwOrmData {
    // Attributes
    SubscriptionRoleTrackingId?: number;
    SubscriptionId?: number;
    SubscriptionRoleId?: number;
    StartDate?: string;
    EndDate?: string;
    MinCount?: number;
    MinCountDate?: string;
    MaxCount?: number;
    MaxCountDate?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    InvoiceMonth?: number;
    InvoiceYear?: number;

    // Display Attributes
    SubscriptionIdDisplay?: string;
    SubscriptionRoleIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    Subscription? : SubscriptionEntity;
    SubscriptionRole? : SubscriptionRoleEntity;
}

export interface SubscriptionStatusEntity extends DwOrmData {
    // Attributes
    SubscriptionStatusId?: number;
    SubscriptionStatus?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    Subscription? : SubscriptionEntity[];
}

export interface SubscriptionTierEntity extends DwOrmData {
    // Attributes
    SubscriptionTierId?: number;
    SubscriptionTierName?: string;
    SubscriptionTierStatusId?: number;
    EffectiveStartDate?: string;
    EffectiveEndDate?: string;
    PlatformMonthlyCost?: number;
    ProfitSharingPercentage?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    ProductId?: string;
    PriceId?: string;
    Description?: string;
    IsDefaultTier?: boolean;
    SubscriptionTierOrder?: number;
    LimitToSchools?: boolean;

    // Display Attributes
    SubscriptionTierStatusIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    SubscriptionTierStatus? : SubscriptionTierStatusEntity;
    Discount? : DiscountEntity[];
    Product? : ProductEntity;
    Subscription? : SubscriptionEntity[];
    SubscriptionTierBenefit? : SubscriptionTierBenefitEntity[];
    SubscriptionTierFeature? : SubscriptionTierFeatureEntity[];
    SubscriptionTierFlightSchool? : SubscriptionTierFlightSchoolEntity[];
    SubscriptionTierRole? : SubscriptionTierRoleEntity[];
}

export interface SubscriptionTierBenefitEntity extends DwOrmData {
    // Attributes
    SubscriptionTierBenefitId?: number;
    SubscriptionTierId?: number;
    BenefitDescription?: string;
    Display?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    SubscriptionTierIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    SubscriptionTier? : SubscriptionTierEntity;
}

export interface SubscriptionTierFeatureEntity extends DwOrmData {
    // Attributes
    SubscriptionTierFeatureId?: number;
    SubscriptionTierId?: number;
    SubscriptionFeatureId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    SubscriptionTierIdDisplay?: string;
    SubscriptionFeatureIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    SubscriptionFeature? : SubscriptionFeatureEntity;
    SubscriptionTier? : SubscriptionTierEntity;
}

export interface SubscriptionTierFlightSchoolEntity extends DwOrmData {
    // Attributes
    SubscriptionTierFlightSchoolId?: number;
    SubscriptionTierId?: number;
    FlightSchoolId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    SubscriptionTierIdDisplay?: string;
    FlightSchoolIdDisplay?: string;

    // Relations
    FlightSchool? : FlightSchoolEntity;
    SubscriptionTier? : SubscriptionTierEntity;
}

export interface SubscriptionTierRoleEntity extends DwOrmData {
    // Attributes
    SubscriptionTierRoleId?: number;
    SubscriptionTierId?: number;
    SubscriptionRoleId?: number;
    MonthlyCost?: number;
    MinimumBilled?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    PriceId?: string;

    // Display Attributes
    SubscriptionTierIdDisplay?: string;
    SubscriptionRoleIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    SubscriptionRole? : SubscriptionRoleEntity;
    SubscriptionTier? : SubscriptionTierEntity;
}

export interface SubscriptionTierStatusEntity extends DwOrmData {
    // Attributes
    SubscriptionTierStatusId?: number;
    SubscriptionTierStatus?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    SubscriptionTier? : SubscriptionTierEntity[];
}

export interface TemplateFieldAlignmentEntity extends DwOrmData {
    // Attributes
    TemplateFieldAlignmentId?: number;
    AlignmentDisplay?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    CourseEndorsementTemplateField? : CourseEndorsementTemplateFieldEntity[];
}

export interface TemplateFieldTypeEntity extends DwOrmData {
    // Attributes
    TemplateFieldTypeId?: number;
    FieldType?: string;


    // Relations
    CourseEndorsementTemplateField? : CourseEndorsementTemplateFieldEntity[];
}

export interface TemplateFontStyleEntity extends DwOrmData {
    // Attributes
    TemplateFontStyleId?: number;
    StyleName?: string;
    FontFamily?: string;
    FontSize?: number;
    IsBold?: boolean;
    IsItalics?: boolean;
    Color?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    CourseEndorsementTemplateField? : CourseEndorsementTemplateFieldEntity[];
}

export interface DwThemeEntity extends DwOrmData {
    // Attributes
    ThemeId?: number;
    ThemeName?: string;
    IsDefault?: boolean;
    LogoMediaId?: number;
    LogoWidth?: number;
    LogoHeight?: number;
    AlternateLogoMediaId?: number;
    AlternateLogoWidth?: number;
    AlternateLogoHeight?: number;
    LogoLoginMediaId?: number;
    LogoLoginWidth?: number;
    LogoLoginHeight?: number;

    // Display Attributes
    LogoMediaIdDisplay?: string;
    AlternateLogoMediaIdDisplay?: string;
    LogoLoginMediaIdDisplay?: string;

    // Relations
    AlternateLogoDwMedia? : DwMediaEntity;
    LogoDwMedia? : DwMediaEntity;
    LogoLoginDwMedia? : DwMediaEntity;
    FlightSchoolBranding? : FlightSchoolBrandingEntity[];
    DwThemeProperty? : DwThemePropertyEntity[];
}

export interface DwThemePropertyEntity extends DwOrmData {
    // Attributes
    ThemePropertyId?: number;
    ThemeId?: number;
    ThemePropertyDefinitionId?: number;
    PropertyValue?: string;

    // Display Attributes
    ThemeIdDisplay?: string;
    ThemePropertyDefinitionIdDisplay?: string;

    // Relations
    DwTheme? : DwThemeEntity;
    DwThemePropertyDefinition? : DwThemePropertyDefinitionEntity;
}

export interface DwThemePropertyDefinitionEntity extends DwOrmData {
    // Attributes
    ThemePropertyDefinitionId?: number;
    PropertyDisplay?: string;
    PropertyName?: string;
    ThemePropertyTypeId?: number;

    // Display Attributes
    ThemePropertyTypeIdDisplay?: string;

    // Relations
    DwThemePropertyType? : DwThemePropertyTypeEntity;
    DwThemeProperty? : DwThemePropertyEntity[];
}

export interface DwThemePropertyTypeEntity extends DwOrmData {
    // Attributes
    ThemePropertyTypeId?: number;
    PropertyType?: string;


    // Relations
    DwThemePropertyDefinition? : DwThemePropertyDefinitionEntity[];
}

export interface TimeZoneEntity extends DwOrmData {
    // Attributes
    TimezoneId?: number;
    TimezoneName?: string;
    TimezoneShortName?: string;
    GmtOffSet?: number;
    TimeZoneDescription?: string;
    IANAIdentifier?: string;
    DotNetBCLIdentifier?: string;


    // Relations
    Address? : AddressEntity[];
    DefaultTimeZoneIdFlightSchool? : FlightSchoolEntity[];
    TimeZoneIdPostalCode? : PostalCodeEntity[];
    TimeZoneIdStudent? : StudentEntity[];
    TimeZoneIdStudentGamificationDay? : StudentGamificationDayEntity[];
    TimeZoneIdStudentGamificationSummary? : StudentGamificationSummaryEntity[];
}

export interface DwUserEntity extends DwOrmData {
    // Attributes
    AlternateName?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    Email?: string;
    FirstName?: string;
    ForcePasswordChange?: boolean;
    IsActive?: boolean;
    IsEmailVerified?: boolean;
    IsTwoFactorAuthenticationEnabled?: boolean;
    LastLoginDateTime?: string;
    LastName?: string;
    LastPasswordChangeDateTime?: string;
    MobilePhone?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    OrganizationId?: number;
    PartyReferenceId?: number;
    TwoFactorAuthenticationTypeId?: number;
    UserBackgroundMediaId?: number;
    UserId?: number;
    UserKey?: string;
    UserName?: string;
    UserPictureMediaId?: number;
    UserTypeId?: number;
    Password?: number;

    // Display Attributes
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    OrganizationIdDisplay?: string;
    PartyReferenceIdDisplay?: string;
    TwoFactorAuthenticationTypeIdDisplay?: string;
    UserBackgroundMediaIdDisplay?: string;
    UserPictureMediaIdDisplay?: string;
    UserTypeIdDisplay?: string;

    // Relations
    UserPictureDwMedia? : DwMediaEntity;
    UserBackgroundDwMedia? : DwMediaEntity;
    DwUserType? : DwUserTypeEntity;
    CourseAvailabilityNotification? : CourseAvailabilityNotificationEntity[];
    ModifiedByCourseLessonFlag? : CourseLessonFlagEntity[];
    CreatedByCourseLessonFlag? : CourseLessonFlagEntity[];
    CoursePurchaseReservationCourse? : CoursePurchaseReservationCourseEntity[];
    LimitToDiscount? : DiscountEntity[];
    DiscountUsageUser? : DiscountUsageUserEntity[];
    FlightSchoolBillingContact? : FlightSchoolBillingContactEntity[];
    Instructor? : InstructorEntity;
    IntegrationUser? : IntegrationUserEntity[];
    Invoice? : InvoiceEntity[];
    JoinRequestCoursePurchase? : JoinRequestCoursePurchaseEntity[];
    JoinRequestEmail? : JoinRequestEmailEntity[];
    ProcessorConfig? : ProcessorConfigEntity[];
    ChangedByProcessorConfigCustomerHistory? : ProcessorConfigCustomerHistoryEntity[];
    AffiliateProfitShare? : ProfitShareEntity[];
    RoStudentOverviewDetails? : RoStudentOverviewDetailsEntity;
    RoStudentPaymentMethod? : RoStudentPaymentMethodEntity[];
    RoStudentSchoolCourses? : RoStudentSchoolCoursesEntity[];
    RoUserRoleDetail? : RoUserRoleDetailEntity;
    Student? : StudentEntity;
    ActorStudentActivity? : StudentActivityEntity[];
    ResetByStudentProgressResetEvent? : StudentProgressResetEventEntity[];
    UserDetail? : UserDetailEntity;
    UserDocumentSectionFavorite? : UserDocumentSectionFavoriteEntity[];
    DwUserRole? : DwUserRoleEntity[];
    UserSubscriptionRole? : UserSubscriptionRoleEntity[];
}

export interface UserDetailEntity extends DwOrmData {
    // Attributes
    UserDetailId?: number;
    UserId?: number;
    FlightSchoolId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    PortalConfigId?: string;
    OnboardingVersion?: number;

    // Display Attributes
    UserIdDisplay?: string;
    FlightSchoolIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    FlightSchool? : FlightSchoolEntity;
    DwUser? : DwUserEntity;
}

export interface UserDocumentSectionFavoriteEntity extends DwOrmData {
    // Attributes
    UserDocumentSectionFavoriteId?: number;
    UserId?: number;
    DocumentItemId?: number;
    SectionReferenceKey?: string;
    ReferenceLocatorText?: string;
    OriginalDocumentVersionId?: number;
    OriginalDocumentSectionId?: number;
    ReferenceStatusId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    UserIdDisplay?: string;
    DocumentItemIdDisplay?: string;
    OriginalDocumentVersionIdDisplay?: string;
    OriginalDocumentSectionIdDisplay?: string;
    ReferenceStatusIdDisplay?: string;

    // Relations
    DocumentItem? : DocumentItemEntity;
    OriginalDocumentSection? : DocumentSectionEntity;
    OriginalDocumentVersion? : DocumentVersionEntity;
    ReferenceStatus? : ReferenceStatusEntity;
    DwUser? : DwUserEntity;
}

export interface DwUserRoleEntity extends DwOrmData {
    // Attributes
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    RoleId?: number;
    UserId?: number;
    UserRoleId?: number;

    // Display Attributes
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    RoleIdDisplay?: string;
    UserIdDisplay?: string;

    // Relations
    DwRole? : DwRoleEntity;
    DwUser? : DwUserEntity;
}

export interface UserSubscriptionRoleEntity extends DwOrmData {
    // Attributes
    UserSubscriptionRoleId?: number;
    UserId?: number;
    SubscriptionRoleId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    UserIdDisplay?: string;
    SubscriptionRoleIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    SubscriptionRole? : SubscriptionRoleEntity;
    DwUser? : DwUserEntity;
}

export interface DwUserTypeEntity extends DwOrmData {
    // Attributes
    ShowOnRegistration?: boolean;
    UserTypeClasses?: string;
    UserTypeDescription?: string;
    UserTypeDisplay?: string;
    UserTypeId?: number;
    UserTypeOrder?: number;


    // Relations
    JoinRequestType? : JoinRequestTypeEntity[];
    DwUser? : DwUserEntity[];
}

export interface VectorProviderEntity extends DwOrmData {
    // Attributes
    VectorProviderId?: number;
    ProviderName?: string;
    ProviderType?: string;
    EnvironmentKey?: string;
    DisplayName?: string;
    IsActive?: boolean;


    // Relations
    VectorReference? : VectorReferenceEntity[];
}

export interface VectorReferenceEntity extends DwOrmData {
    // Attributes
    VectorReferenceId?: number;
    VectorProviderId?: number;
    MetaDataItemId?: number;
    KeyValue?: number;
    VectorNamespace?: string;
    VectorId?: string;
    EmbeddingModel?: string;
    EmbeddingDimensions?: number;
    IndexedDateTime?: string;
    LastIndexedHash?: string;
    IsActive?: boolean;

    // Display Attributes
    VectorProviderIdDisplay?: string;

    // Relations
    VectorProvider? : VectorProviderEntity;
    DocumentItemChunk? : DocumentItemChunkEntity[];
    DocumentSection? : DocumentSectionEntity[];
}

export interface VideoEntity extends DwOrmData {
    // Attributes
    VideoId?: number;
    VideoName?: string;
    VideoLibraryId?: number;
    VideoKey?: string;
    DirectPlayUrl?: string;
    ThumbnailUrl?: string;
    VideoStreamingProviderId?: number;
    VideoStatusId?: number;
    VideoSizeBytes?: number;
    VideoDurationSeconds?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    AllowMp4?: boolean;
    IsPrivateVideo?: boolean;
    OriginalFileName?: string;
    VideoDescription?: string;
    VideoProcessingStatusId?: number;
    LastVideoProcessingStatusUpdate?: string;

    // Display Attributes
    VideoLibraryIdDisplay?: string;
    VideoStreamingProviderIdDisplay?: string;
    VideoStatusIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    VideoProcessingStatusIdDisplay?: string;

    // Relations
    VideoLibrary? : VideoLibraryEntity;
    VideoProcessingStatus? : VideoProcessingStatusEntity;
    VideoStatus? : VideoStatusEntity;
    VideoStreamingProvider? : VideoStreamingProviderEntity;
    CourseLesson? : CourseLessonEntity[];
    VideoHistory? : VideoHistoryEntity[];
    VideoTagLink? : VideoTagLinkEntity[];
}

export interface VideoHistoryEntity extends DwOrmData {
    // Attributes
    VideoHistoryId?: number;
    VideoId?: number;
    VideoKey?: string;
    DirectPlayUrl?: string;
    ThumbnailUrl?: string;
    VideoSizeBytes?: number;
    VideoDurationSeconds?: number;
    AllowMp4?: boolean;
    IsPrivateVideo?: boolean;
    OriginalFileName?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    VideoIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    Video? : VideoEntity;
}

export interface VideoLibraryEntity extends DwOrmData {
    // Attributes
    VideoLibraryId?: number;
    VideoLibraryName?: string;
    VideoLibraryKey?: string;
    VideoStreamingProviderId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    PlaybackConfigKey?: string;
    AuthenticatedPlaybackEnabled?: boolean;
    PlaybackConfigRevision?: number;
    VideoPlaybackAuthenticationModeId?: number;

    // Display Attributes
    VideoStreamingProviderIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;
    VideoPlaybackAuthenticationModeIdDisplay?: string;

    // Relations
    VideoPlaybackAuthenticationMode? : VideoPlaybackAuthenticationModeEntity;
    VideoStreamingProvider? : VideoStreamingProviderEntity;
    Video? : VideoEntity[];
}

export interface VideoPlaybackAuthenticationModeEntity extends DwOrmData {
    // Attributes
    VideoPlaybackAuthenticationModeId?: number;
    VideoPlaybackAuthenticationMode?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;


    // Relations
    VideoLibrary? : VideoLibraryEntity[];
}

export interface VideoProcessingStatusEntity extends DwOrmData {
    // Attributes
    VideoProcessingStatusId?: number;
    VideoProcessingStatus?: string;


    // Relations
    Video? : VideoEntity[];
}

export interface VideoStatusEntity extends DwOrmData {
    // Attributes
    VideoStatusId?: number;
    VideoStatus?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    Video? : VideoEntity[];
}

export interface VideoStreamingProviderEntity extends DwOrmData {
    // Attributes
    VideoStreamingProviderId?: number;
    ProviderName?: string;
    ProviderManagementUrl?: string;
    AutoPlay?: boolean;
    ContinueFromLastPosition?: boolean;
    AllowSeek?: boolean;
    SeekThreshholdSeconds?: number;
    PreloadVideo?: boolean;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    AllowMp4Default?: boolean;
    IsPrivateVideoDefault?: boolean;

    // Display Attributes
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    Video? : VideoEntity[];
    VideoLibrary? : VideoLibraryEntity[];
}

export interface VideoTagLinkEntity extends DwOrmData {
    // Attributes
    VideoTagLink?: number;
    VideoId?: number;
    TagId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;

    // Display Attributes
    VideoIdDisplay?: string;
    TagIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    TagIdQuestionTag? : QuestionTagEntity;
    Video? : VideoEntity;
}

// Generated Query Interfaces
/** Entity for Query Meaning Course_List-_For_Student  */
export interface CourseListForStudentQueryEntity extends DwOrmData {
    // Attributes
    CourseId?: number;
    CourseName?: string;
    CourseDescription?: string;
    CourseTypeId?: number;
    CourseImageMediaId?: number;
    CourseNotes?: string;
    AircraftTypeId?: number;
    AvionicsType?: string;
    ProgramTypeId?: number;
    RetailPrice?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    CourseStatusId?: number;
    TotalCourseTimeSeconds?: number;
    TotalCourseVideoTimeSeconds?: number;
    TotalCourseQuizTimeSeconds?: number;
    CourseKey?: string;
    DefaultSchoolCourse?: boolean;
    AcsTestId?: number;
    CourseOrder?: number;
    ModulePrefixOverride?: string;
    ComingSoon?: boolean;
    StudentCourseStudentCourseId?: number;
    StudentCourseStudentId?: number;
    StudentCourseCourseId?: number;
    StudentCourseIsActive?: boolean;
    StudentCoursePercentComplete?: number;
    StudentCourseModulesCompleted?: number;
    StudentCourseModulesCount?: number;
    StudentCourseLastActivityDateTime?: string;
    StudentCourseIsEndorsed?: boolean;
    StudentCourseStudentCourseStatusId?: number;
    StudentUserId?: number;
    AcsTestResultCount?: number;
    AcsTestResultsPassedAny?: boolean;
    AcsTestResultsFailedAny?: boolean;
    CourseEndorsementStudentCourseEndorsementStudentId?: number;
    CourseEndorsementStudentCourseEndorsementId?: number;
    CourseEndorsementStudentCompletionDateTime?: string;
    CourseEndorsementStudentExpirationDateTime?: string;
    CourseEndorsementStudentEndorsementPDFMediaId?: number;
    NextCourseLessonCourseLessonId?: number;
    NextCourseLessonLessonName?: string;
    CourseModuleCourseModuleId?: number;
    CourseModuleCourseId?: number;
    MediaImageHeight?: number;
    MediaImageWidth?: number;
    MediaMediaPath?: string;

    // Relations
    AcsTest? : AcsTestEntity;
    AircraftType? : AircraftTypeEntity;
    CourseType? : CourseTypeEntity;
    CourseImageDwMedia? : DwMediaEntity;
    CourseImageDwroMedia? : DwRoMediaEntity;
    ProgramType? : ProgramTypeEntity;
    CourseStatusIdReferenceStatus? : ReferenceStatusEntity;
    AcsTaskMultiAssign? : AcsTaskMultiAssignEntity[];
    AIPromptRequest? : AIPromptRequestEntity[];
    Assignment? : AssignmentEntity[];
    CourseAvailabilityNotification? : CourseAvailabilityNotificationEntity[];
    CourseDocumentItem? : CourseDocumentItemEntity[];
    CourseEndorsement? : CourseEndorsementEntity;
    CourseLessonFlag? : CourseLessonFlagEntity[];
    CourseModificationHistory? : CourseModificationHistoryEntity[];
    CourseModule? : CourseModuleEntity[];
    CoursePurchaseCourse? : CoursePurchaseCourseEntity[];
    CoursePurchaseReservationCourse? : CoursePurchaseReservationCourseEntity[];
    DiscountCourse? : DiscountCourseEntity[];
    DocumentLinkProcessingRun? : DocumentLinkProcessingRunEntity[];
    DocumentLinkProcessingRunItem? : DocumentLinkProcessingRunItemEntity[];
    FlightSchoolCourse? : FlightSchoolCourseEntity[];
    IntegrationCoursePurchase? : IntegrationCoursePurchaseEntity[];
    IntegrationCoursePurchaseRequest? : IntegrationCoursePurchaseRequestEntity[];
    IntegrationSystemCourse? : IntegrationSystemCourseEntity[];
    IntegrationUserEvent? : IntegrationUserEventEntity[];
    JoinRequestCourse? : JoinRequestCourseEntity[];
    JoinRequestCoursePurchase? : JoinRequestCoursePurchaseEntity[];
    ModificationHistory? : ModificationHistoryEntity[];
    MultipleAssignCourse? : MultipleAssignCourseEntity[];
    PackageCourse? : PackageCourseEntity[];
    Product? : ProductEntity;
    Question? : QuestionEntity[];
    RoFlightSchoolCourseUnique? : RoFlightSchoolCourseUniqueEntity[];
    RoStudentSchoolCourses? : RoStudentSchoolCoursesEntity[];
    StudentCourse? : StudentCourseEntity[];
    StudentProgressResetEvent? : StudentProgressResetEventEntity[];
    SubscriptionCourseTracking? : SubscriptionCourseTrackingEntity[];
}

/** Entity for Query Meaning Module_List-For_Student  */
export interface ModuleListForStudentQueryEntity extends DwOrmData {
    // Attributes
    CourseModuleId?: number;
    CourseId?: number;
    CourseIdDisplay?: string;
    ModuleName?: string;
    ModuleDescription?: string;
    ModuleImageMediaId?: number;
    ModuleImageMediaIdDisplay?: string;
    ModuleOrder?: number;
    CreatedBy?: number;
    CreatedByDisplay?: string;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedByDisplay?: string;
    ModifiedDateTime?: string;
    ModuleStatusId?: number;
    ModuleStatusIdDisplay?: string;
    TotalModuleTimeSeconds?: number;
    TotalModuleVideoTimeSeconds?: number;
    TotalModuleQuizTimeSeconds?: number;
    AIOverviewHtml?: string;
    AIKeyConceptText?: string;
    AIProcessingReferenceId?: number;
    AIProcessingReferenceIdDisplay?: string;
    ModuleBasicName?: string;
    DisableDocumentLinking?: boolean;
    CourseModuleProgressCourseModuleProgressId?: number;
    CourseModuleProgressPercentComplete?: number;
    CourseModuleProgressLessonsCompleted?: number;
    CourseModuleProgressLessonsCount?: number;
    CourseModuleProgressLastActivityDateTime?: string;
    CourseModuleProgressTotalTimeSeconds?: number;
    CourseModuleProgressFirstActivityDateTime?: string;
    CourseModuleProgressCompletedDateTime?: string;
    StudentCourseIsActive?: boolean;
    StudentStudentId?: number;
    StudentUserId?: number;
    StudentUserIdDisplay?: string;
    CourseImageMediaPath?: string;
    AIPromptRequestAIPromptRequestId?: number;
    AIPromptRequestAIPromptRequestStatusId?: number;
    AIPromptRequestAIPromptRequestStatusIdDisplay?: string;
    MediaImageWidth?: number;
    MediaImageHeight?: number;
    MediaMediaPath?: string;

    // Relations
    AIProcessingReference? : AIProcessingReferenceEntity;
    Course? : CourseEntity;
    ModuleImageDwMedia? : DwMediaEntity;
    ModuleImageDwroMedia? : DwRoMediaEntity;
    ModuleStatusIdReferenceStatus? : ReferenceStatusEntity;
    AIPromptRequest? : AIPromptRequestEntity[];
    CourseLesson? : CourseLessonEntity[];
    CourseModuleDocumentItem? : CourseModuleDocumentItemEntity[];
    CourseModuleProgress? : CourseModuleProgressEntity[];
    DocumentLinkProcessingRunItem? : DocumentLinkProcessingRunItemEntity[];
    Question? : QuestionEntity[];
    StudentModuleSummary? : StudentModuleSummaryEntity[];
}

/** Entity for Query Meaning Lesson_List-For_Student  */
export interface LessonListForStudentQueryEntity extends DwOrmData {
    // Attributes
    CourseLessonId?: number;
    CourseModuleId?: number;
    CourseModuleIdDisplay?: string;
    LessonName?: string;
    LessonDescription?: string;
    LessonTypeId?: number;
    LessonTypeIdDisplay?: string;
    VideoId?: number;
    VideoIdDisplay?: string;
    QuizId?: number;
    QuizIdDisplay?: string;
    LessonOrder?: number;
    LessonImageMediaId?: number;
    LessonImageMediaIdDisplay?: string;
    IsPreview?: boolean;
    CourseLessonProgressCourseLessonProgressId?: number;
    CourseLessonProgressLessonComplete?: boolean;
    CourseLessonProgressVideoFurthestTimeSeconds?: number;
    CourseLessonProgressBestQuizResultId?: number;
    CourseLessonProgressBestQuizResultIdDisplay?: string;
    CourseLessonProgressLastActivityDateTime?: string;
    CourseLessonProgressPercentComplete?: number;
    CourseLessonProgressTotalTimeSeconds?: number;
    CourseLessonProgressFirstActivityDateTime?: string;
    CourseLessonProgressCompletedDateTime?: string;
    CourseLessonProgressCourseLessonId?: number;
    CourseLessonProgressCourseLessonIdDisplay?: string;
    CourseLessonProgressLessonProgressStatusId?: number;
    CourseLessonProgressLessonProgressStatusIdDisplay?: string;
    CourseLessonProgressCourseModuleProgressId?: number;
    CourseLessonProgressCourseModuleProgressIdDisplay?: string;
    CourseLessonProgressCreatedBy?: number;
    CourseLessonProgressCreatedByDisplay?: string;
    CourseLessonProgressCreatedDateTime?: string;
    CourseLessonProgressModifiedBy?: number;
    CourseLessonProgressModifiedByDisplay?: string;
    CourseLessonProgressModifiedDateTime?: string;
    CourseModuleProgressCourseModuleId?: number;
    CourseModuleProgressCourseModuleIdDisplay?: string;
    StudentCourseCourseId?: number;
    StudentCourseCourseIdDisplay?: string;
    StudentCourseIsActive?: boolean;
    StudentStudentId?: number;
    StudentUserId?: number;
    StudentUserIdDisplay?: string;
    CourseImageMediaPath?: string;
    CourseModuleCourseId?: number;
    CourseModuleCourseIdDisplay?: string;
    ModuleImageMediaPath?: string;
    VideoThumbnailUrl?: string;
    VideoVideoName?: string;
    LessonImageDwroMediaMediaPath?: string;

    // Relations
    AIProcessingReference? : AIProcessingReferenceEntity;
    CourseModule? : CourseModuleEntity;
    DocumentItem? : DocumentItemEntity;
    LessonType? : LessonTypeEntity;
    LessonImageDwroMedia? : DwRoMediaEntity;
    Quiz? : QuizEntity;
    LessonStatusIdReferenceStatus? : ReferenceStatusEntity;
    Video? : VideoEntity;
    AcsTaskMultiAssignLesson? : AcsTaskMultiAssignLessonEntity[];
    AIPromptRequest? : AIPromptRequestEntity[];
    AssignmentCourseLesson? : AssignmentCourseLessonEntity[];
    CourseEndorsementLesson? : CourseEndorsementLessonEntity[];
    CourseLessonAcsTask? : CourseLessonAcsTaskEntity[];
    CourseLessonDocumentLink? : CourseLessonDocumentLinkEntity[];
    CourseLessonFlag? : CourseLessonFlagEntity[];
    CourseLessonProgress? : CourseLessonProgressEntity[];
    DocumentLinkProcessingRunItem? : DocumentLinkProcessingRunItemEntity[];
    CousreLessonIdIntegrationUserEvent? : IntegrationUserEventEntity[];
    RoAssignmentStudentCourseLessonProgress? : RoAssignmentStudentCourseLessonProgressEntity[];
    NextStudentCourse? : StudentCourseEntity[];
}

/** Entity for Query Meaning Student-Course_Progress  */
export interface StudentCourseProgressQueryEntity extends DwOrmData {
    // Attributes
    StudentId?: number;
    UserId?: number;
    UserIdDisplay?: string;
    CreatedBy?: number;
    CreatedByDisplay?: string;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedByDisplay?: string;
    ModifiedDateTime?: string;
    AddressId?: number;
    AddressIdDisplay?: string;
    PilotCertificateNumber?: string;
    CitizenshipCountryId?: number;
    CitizenshipCountryIdDisplay?: string;
    BirthDate?: string;
    PilotTypeId?: number;
    PilotTypeIdDisplay?: string;
    FlightSchoolPositionId?: number;
    FlightSchoolPositionIdDisplay?: string;
    AcquisitionSourceId?: number;
    AcquisitionSourceIdDisplay?: string;
    AcquisitionSourceOther?: string;
    InstructorCertifcateNumber?: string;
    StudentCode?: string;
    AviationGoalId?: number;
    AviationGoalIdDisplay?: string;
    TimeZoneId?: number;
    TimeZoneIdDisplay?: string;
    StudentCourseStudentCourseId?: number;
    StudentCourseIsActive?: boolean;
    StudentCoursePercentComplete?: number;
    StudentCourseModulesCompleted?: number;
    StudentCourseModulesCount?: number;
    StudentCourseLastActivityDateTime?: string;
    StudentCourseLessonsCompleted?: number;
    StudentCourseLessonCount?: number;
    StudentCourseTotalTimeSeconds?: number;
    StudentCourseStudentId?: number;
    StudentCourseStudentIdDisplay?: string;
    StudentCourseCourseId?: number;
    StudentCourseCourseIdDisplay?: string;
    StudentCourseFirstActivityDateTime?: string;
    StudentCourseCompletedDateTime?: string;
    StudentCourseIsEndorsed?: boolean;
    StudentCourseStudentCourseProgressStatusId?: number;
    StudentCourseStudentCourseProgressStatusIdDisplay?: string;
    CourseCourseId?: number;
    CourseCourseName?: string;
    CourseCourseDescription?: string;
    CourseCourseStatusId?: number;
    CourseCourseStatusIdDisplay?: string;
    CourseImageDwroMediaMediaPath?: string;
    CourseEndorsementStudentCompletionDateTime?: string;
    CourseEndorsementStudentExpirationDateTime?: string;
    AcsTestResultsACSTestResultCount?: number;
    AcsTestResultsPassedAny?: boolean;
    AcsTestResultsFailedAny?: boolean;
    UserDetailFlightSchoolId?: number;
    UserDetailFlightSchoolIdDisplay?: string;
    UserDetailUserDetailId?: number;

    // Relations
    AcquisitionSource? : AcquisitionSourceEntity;
    Address? : AddressEntity;
    AviationGoal? : AviationGoalEntity;
    CitizenshipCountry? : CountryEntity;
    FlightSchoolPosition? : FlightSchoolPositionEntity;
    PilotType? : PilotTypeEntity;
    TimeZoneIdTimeZone? : TimeZoneEntity;
    DwUser? : DwUserEntity;
    AssignmentStudent? : AssignmentStudentEntity[];
    CoursePurchaseReservationCourse? : CoursePurchaseReservationCourseEntity[];
    CoursePurchaseStudent? : CoursePurchaseStudentEntity[];
    DailyQuiz? : DailyQuizEntity[];
    DocumentItemAcknowledgement? : DocumentItemAcknowledgementEntity[];
    FlightSchoolGroupStudent? : FlightSchoolGroupStudentEntity[];
    InstructorStudent? : InstructorStudentEntity[];
    JoinRequestCoursePurchase? : JoinRequestCoursePurchaseEntity[];
    ProfitShare? : ProfitShareEntity[];
    RoStudentSchoolCourses? : RoStudentSchoolCoursesEntity[];
    StudentAchievement? : StudentAchievementEntity[];
    StudentActivity? : StudentActivityEntity[];
    StudentCourse? : StudentCourseEntity[];
    StudentGamificationDay? : StudentGamificationDayEntity[];
    StudentGamificationSummary? : StudentGamificationSummaryEntity[];
    StudentLessonProgressEvent? : StudentLessonProgressEventEntity[];
    StudentProgressResetEvent? : StudentProgressResetEventEntity[];
    StudentWeatherDayTransaction? : StudentWeatherDayTransactionEntity[];
    SubscriptionCourseTracking? : SubscriptionCourseTrackingEntity[];
}

/** Entity for Query Meaning Student-Module_Progress  */
export interface StudentModuleProgressQueryEntity extends DwOrmData {
    // Attributes
    CourseModuleProgressId?: number;
    CourseModuleId?: number;
    CourseModuleIdDisplay?: string;
    PercentComplete?: number;
    LessonsCompleted?: number;
    LessonsCount?: number;
    StudentCourseId?: number;
    StudentCourseIdDisplay?: string;
    LastActivityDateTime?: string;
    TotalTimeSeconds?: number;
    FirstActivityDateTime?: string;
    CompletedDateTime?: string;
    CreatedBy?: number;
    CreatedByDisplay?: string;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedByDisplay?: string;
    ModifiedDateTime?: string;
    ModuleProgressStatusId?: number;
    ModuleProgressStatusIdDisplay?: string;
    TotalVideoTimeSeconds?: number;
    TotalQuizTimeSeconds?: number;
    AISummaryLastProcessedDateTime?: string;
    AIPromptRequestId?: number;
    AIPromptRequestIdDisplay?: string;
    CourseModuleModuleOrder?: number;
    CourseModuleModuleName?: string;
    ImageMediaPath?: string;
    CourseImageMediaPath?: string;
    AIPromptRequestResult?: string;
    AIPromptRequestAIPromptRequestStatusId?: number;
    AIPromptRequestAIPromptRequestStatusIdDisplay?: string;
    AIPromptRequestLastLogId?: number;
    AIPromptRequestLastLogIdDisplay?: string;

    // Relations
    AIPromptRequest? : AIPromptRequestEntity;
    CourseModule? : CourseModuleEntity;
    ModuleProgressStatusIdReferenceStatus? : ReferenceStatusEntity;
    StudentCourse? : StudentCourseEntity;
    CourseLessonProgress? : CourseLessonProgressEntity[];
    StudentModuleSummary? : StudentModuleSummaryEntity[];
}

/** Entity for Query Meaning Student-Lesson_Progress  */
export interface StudentLessonProgressQueryEntity extends DwOrmData {
    // Attributes
    CourseLessonProgressId?: number;
    CourseLessonId?: number;
    CourseLessonIdDisplay?: string;
    CourseModuleProgressId?: number;
    CourseModuleProgressIdDisplay?: string;
    LessonComplete?: boolean;
    VideoFurthestTimeSeconds?: number;
    BestQuizResultId?: number;
    BestQuizResultIdDisplay?: string;
    LastActivityDateTime?: string;
    LessonNotes?: string;
    PercentComplete?: number;
    TotalTimeSeconds?: number;
    FirstActivityDateTime?: string;
    CompletedDateTime?: string;
    SessionCount?: number;
    CourseLessonLessonName?: string;
    CourseLessonLessonDescription?: string;
    CourseLessonLessonTypeId?: number;
    CourseLessonLessonTypeIdDisplay?: string;
    CourseLessonLessonOrder?: number;
    CourseLessonVideoId?: number;
    CourseLessonVideoIdDisplay?: string;
    CourseLessonQuizId?: number;
    CourseLessonQuizIdDisplay?: string;
    LessonImageDwroMediaMediaPath?: string;
    VideoThumbnailUrl?: string;
    BestQuizResultPercentageScore?: number;
    BestQuizResultQuizResultStatusId?: number;
    BestQuizResultQuizResultStatusIdDisplay?: string;
    CourseModuleProgressStudentCourseId?: number;
    CourseModuleProgressStudentCourseIdDisplay?: string;
    CourseModuleProgressCourseModuleId?: number;
    CourseModuleProgressCourseModuleIdDisplay?: string;
    StudentCourseCourseId?: number;
    StudentCourseCourseIdDisplay?: string;
    StudentCourseStudentId?: number;
    StudentCourseStudentIdDisplay?: string;
    StudentUserId?: number;
    StudentUserIdDisplay?: string;
    CourseImageMediaPath?: string;
    ModuleImageMediaPath?: string;

    // Relations
    CourseLesson? : CourseLessonEntity;
    CourseModuleProgress? : CourseModuleProgressEntity;
    BestQuizResult? : QuizResultEntity;
    LessonProgressStatusIdReferenceStatus? : ReferenceStatusEntity;
    CourseLessonSession? : CourseLessonSessionEntity[];
    QuizResult? : QuizResultEntity[];
    RoAssignmentStudentCourseLessonProgress? : RoAssignmentStudentCourseLessonProgressEntity[];
}

/** Entity for Query Meaning Student-Lessson_Progress-NoCount  */
export interface StudentLesssonProgressNoCountQueryEntity extends DwOrmData {
    // Attributes
    CourseLessonProgressId?: number;
    CourseLessonId?: number;
    CourseLessonIdDisplay?: string;
    CourseModuleProgressId?: number;
    CourseModuleProgressIdDisplay?: string;
    LessonComplete?: boolean;
    VideoFurthestTimeSeconds?: number;
    BestQuizResultId?: number;
    BestQuizResultIdDisplay?: string;
    LastActivityDateTime?: string;
    LessonNotes?: string;
    PercentComplete?: number;
    TotalTimeSeconds?: number;
    FirstActivityDateTime?: string;
    CompletedDateTime?: string;
    CourseLessonLessonName?: string;
    CourseLessonLessonDescription?: string;
    CourseLessonLessonTypeId?: number;
    CourseLessonLessonTypeIdDisplay?: string;
    CourseLessonLessonOrder?: number;
    CourseLessonVideoId?: number;
    CourseLessonVideoIdDisplay?: string;
    CourseLessonQuizId?: number;
    CourseLessonQuizIdDisplay?: string;
    LessonImageDwroMediaMediaPath?: string;
    VideoThumbnailUrl?: string;
    BestQuizResultPercentageScore?: number;
    BestQuizResultQuizResultStatusId?: number;
    BestQuizResultQuizResultStatusIdDisplay?: string;
    CourseModuleProgressStudentCourseId?: number;
    CourseModuleProgressStudentCourseIdDisplay?: string;
    CourseModuleProgressCourseModuleId?: number;
    CourseModuleProgressCourseModuleIdDisplay?: string;
    StudentCourseCourseId?: number;
    StudentCourseCourseIdDisplay?: string;
    StudentCourseStudentId?: number;
    StudentCourseStudentIdDisplay?: string;
    StudentUserId?: number;
    StudentUserIdDisplay?: string;
    CourseImageMediaPath?: string;
    CourseModuleModuleName?: string;
    CourseModuleModuleOrder?: number;
    ModuleImageMediaPath?: string;

    // Relations
    CourseLesson? : CourseLessonEntity;
    CourseModuleProgress? : CourseModuleProgressEntity;
    BestQuizResult? : QuizResultEntity;
    LessonProgressStatusIdReferenceStatus? : ReferenceStatusEntity;
    CourseLessonSession? : CourseLessonSessionEntity[];
    QuizResult? : QuizResultEntity[];
    RoAssignmentStudentCourseLessonProgress? : RoAssignmentStudentCourseLessonProgressEntity[];
}

/** Entity for Query Meaning Student-Course_Progress-by-student-course  */
export interface StudentCourseProgressByStudentCourseQueryEntity extends DwOrmData {
    // Attributes
    StudentCourseId?: number;
    IsActive?: boolean;
    PercentComplete?: number;
    ModulesCompleted?: number;
    ModulesCount?: number;
    LastActivityDateTime?: string;
    LessonsCompleted?: number;
    LessonCount?: number;
    TotalTimeSeconds?: number;
    StudentId?: number;
    StudentIdDisplay?: string;
    CourseId?: number;
    CourseIdDisplay?: string;
    FirstActivityDateTime?: string;
    CompletedDateTime?: string;
    StudentStudentId?: number;
    StudentUserId?: number;
    StudentUserIdDisplay?: string;
    StudentCreatedBy?: number;
    StudentCreatedByDisplay?: string;
    StudentCreatedDateTime?: string;
    StudentModifiedBy?: number;
    StudentModifiedByDisplay?: string;
    StudentModifiedDateTime?: string;
    UserDetailFlightSchoolId?: number;
    UserDetailFlightSchoolIdDisplay?: string;

    // Relations
    Course? : CourseEntity;
    NextCourseLesson? : CourseLessonEntity;
    StudentCourseStatusIdReferenceStatus? : ReferenceStatusEntity;
    Student? : StudentEntity;
    StudentCourseProgressStatus? : StudentCourseProgressStatusEntity;
    AcsWrittenResult? : AcsWrittenResultEntity[];
    StudentCoursetIdAIPromptRequest? : AIPromptRequestEntity[];
    CourseEndorsementStudent? : CourseEndorsementStudentEntity;
    CourseModuleProgress? : CourseModuleProgressEntity[];
    CoursePurchaseReservationCourse? : CoursePurchaseReservationCourseEntity[];
    DailyQuiz? : DailyQuizEntity[];
    IntegrationCoursePurchase? : IntegrationCoursePurchaseEntity;
    JoinRequestCoursePurchase? : JoinRequestCoursePurchaseEntity[];
    ModificationHistoryStudent? : ModificationHistoryStudentEntity[];
    QuizResult? : QuizResultEntity[];
    RoCourseEndorsementStudentActive? : RoCourseEndorsementStudentActiveEntity[];
    RoStudentCourseAcsTestResultDetail? : RoStudentCourseAcsTestResultDetailEntity;
    RoStudentCourseInstructor? : RoStudentCourseInstructorEntity[];
    RoStudentSchoolCourses? : RoStudentSchoolCoursesEntity[];
    StudentAchievement? : StudentAchievementEntity[];
    StudentCourseLockInstructor? : StudentCourseLockInstructorEntity[];
    StudentModuleSummary? : StudentModuleSummaryEntity[];
    StudentProgressResetEvent? : StudentProgressResetEventEntity[];
    SubscriptionCourseTracking? : SubscriptionCourseTrackingEntity[];
}

/** Entity for Query Meaning Student-Module/Lesson_Activity  */
export interface StudentModuleLessonActivityQueryEntity extends DwOrmData {
    // Attributes
    CourseModuleId?: number;
    CourseModuleIdDisplay?: string;
    CourseLessonProgressCourseLessonId?: number;
    CourseLessonProgressCourseLessonIdDisplay?: string;
    CourseLessonProgressLessonComplete?: boolean;
    CourseLessonProgressVideoFurthestTimeSeconds?: number;
    CourseLessonProgressBestQuizResultId?: number;
    CourseLessonProgressBestQuizResultIdDisplay?: string;
    CourseLessonProgressLastActivityDateTime?: string;
    CourseLessonProgressPercentComplete?: number;
    CourseLessonProgressTotalTimeSeconds?: number;
    CourseLessonProgressFirstActivityDateTime?: string;
    CourseLessonProgressCompletedDateTime?: string;
    CourseLessonSessionCourseLessonSessionId?: number;
    CourseLessonSessionCourseLessonProgressId?: number;
    CourseLessonSessionCourseLessonProgressIdDisplay?: string;
    CourseLessonSessionLessonCompleted?: boolean;
    CourseLessonSessionVideoId?: number;
    CourseLessonSessionVideoFurthestTimeSeconds?: number;
    CourseLessonSessionQuizResultId?: number;
    CourseLessonSessionQuizResultIdDisplay?: string;
    CourseLessonSessionSessionStartDateTime?: string;
    CourseLessonSessionSessionEndDateTime?: string;
    CourseLessonSessionTotalTimeSeconds?: number;
    QuizResultCompletedQuestions?: number;
    QuizResultTotalQuestions?: number;
    QuizResultQuizScore?: number;
    QuizResultPerfectScore?: number;
    QuizResultPercentageScore?: number;
    QuizResultQuizResultStatusId?: number;
    QuizResultQuizResultStatusIdDisplay?: string;
    QuizResultQuizId?: number;
    QuizResultQuizIdDisplay?: string;
    QuizResultQuizResultId?: number;
    QuizResultProgressReset?: boolean;

    // Relations
    AIPromptRequest? : AIPromptRequestEntity;
    CourseModule? : CourseModuleEntity;
    ModuleProgressStatusIdReferenceStatus? : ReferenceStatusEntity;
    StudentCourse? : StudentCourseEntity;
    CourseLessonProgress? : CourseLessonProgressEntity[];
    StudentModuleSummary? : StudentModuleSummaryEntity[];
}

/** Entity for Query Meaning Flight_School_Group_with_StudentCourse_Detail  */
export interface FlightSchoolGroupWithStudentCourseDetailQueryEntity extends DwOrmData {
    // Attributes
    FlightSchoolGroupId?: number;
    FlightSchoolId?: number;
    FlightSchoolIdDisplay?: string;
    GroupName?: string;
    CreatedBy?: number;
    CreatedByDisplay?: string;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedByDisplay?: string;
    ModifiedDateTime?: string;
    FlightSchoolGroupStudentStudentId?: number;
    FlightSchoolGroupStudentStudentIdDisplay?: string;
    FlightSchoolGroupStudentFlightSchoolGroupStudentId?: number;
    StudentStudentId?: number;
    StudentUserId?: number;
    StudentUserIdDisplay?: string;
    StudentCourseStudentCourseId?: number;
    StudentCourseCourseId?: number;
    StudentCourseCourseIdDisplay?: string;
    StudentCourseIsActive?: boolean;
    UserDetailUserDetailId?: number;
    UserDetailFlightSchoolId?: number;
    UserDetailFlightSchoolIdDisplay?: string;

    // Relations
    FlightSchool? : FlightSchoolEntity;
    Assignment? : AssignmentEntity[];
    CoursePurchase? : CoursePurchaseEntity[];
    FlightSchoolGroupStudent? : FlightSchoolGroupStudentEntity[];
    JoinRequest? : JoinRequestEntity[];
}

/** Entity for Query Meaning Assignment_Student-Lesson_Sesson_Grid  */
export interface AssignmentStudentLessonSessonGridQueryEntity extends DwOrmData {
    // Attributes
    AssignmentStudentId?: number;
    AssignmentId?: number;
    AssignmentIdDisplay?: string;
    StudentId?: number;
    StudentIdDisplay?: string;
    PercentComplete?: number;
    CompletedDateTime?: string;
    CreatedBy?: number;
    CreatedByDisplay?: string;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedByDisplay?: string;
    ModifiedDateTime?: string;
    Acknowledged?: boolean;
    AcknowledgedDateTime?: string;
    AiPromptRequestId?: number;
    AiPromptRequestIdDisplay?: string;
    ShowAISummary?: boolean;
    StudentUserId?: number;
    StudentUserIdDisplay?: string;
    RoAssignmentStudentCourseLessonProgressStudentId?: number;
    CourseLessonProgressBestQuizResultId?: number;
    CourseLessonProgressBestQuizResultIdDisplay?: string;
    CourseLessonProgressCompletedDateTime?: string;
    CourseLessonProgressCourseLessonId?: number;
    CourseLessonProgressCourseLessonIdDisplay?: string;
    CourseLessonProgressCourseLessonProgressId?: number;
    CourseLessonProgressCourseModuleProgressId?: number;
    CourseLessonProgressCourseModuleProgressIdDisplay?: string;
    CourseLessonProgressCreatedBy?: number;
    CourseLessonProgressCreatedByDisplay?: string;
    CourseLessonProgressCreatedDateTime?: string;
    CourseLessonProgressFirstActivityDateTime?: string;
    CourseLessonProgressLastActivityDateTime?: string;
    CourseLessonProgressLessonComplete?: boolean;
    CourseLessonProgressLessonNotes?: string;
    CourseLessonProgressModifiedBy?: number;
    CourseLessonProgressModifiedByDisplay?: string;
    CourseLessonProgressModifiedDateTime?: string;
    CourseLessonProgressPercentComplete?: number;
    CourseLessonProgressTotalTimeSeconds?: number;
    CourseLessonProgressVideoFurthestTimeSeconds?: number;
    SessionCourseLessonSessionId?: number;
    SessionCourseLessonProgressId?: number;
    SessionCourseLessonProgressIdDisplay?: string;
    SessionLessonCompleted?: boolean;
    SessionVideoId?: number;
    SessionVideoFurthestTimeSeconds?: number;
    SessionQuizResultId?: number;
    SessionQuizResultIdDisplay?: string;
    SessionSessionStartDateTime?: string;
    SessionSessionEndDateTime?: string;
    SessionTotalTimeSeconds?: number;
    SessionCreatedBy?: number;
    SessionCreatedByDisplay?: string;
    SessionCreatedDateTime?: string;
    SessionModifiedBy?: number;
    SessionModifiedByDisplay?: string;
    SessionModifiedDateTime?: string;
    QuizResultQuizResultId?: number;
    QuizResultQuizId?: number;
    QuizResultQuizIdDisplay?: string;
    QuizResultQuizScore?: number;
    QuizResultPercentageScore?: number;
    QuizResultQuizResultStatusId?: number;
    QuizResultQuizResultStatusIdDisplay?: string;
    CourseLessonLessonName?: string;
    CourseLessonCourseModuleId?: number;
    CourseLessonCourseModuleIdDisplay?: string;

    // Relations
    AiPromptRequestIdAIPromptRequest? : AIPromptRequestEntity;
    Assignment? : AssignmentEntity;
    Student? : StudentEntity;
    AIPromptRequest? : AIPromptRequestEntity[];
    RoAssignmentStudentCompletedDetails? : RoAssignmentStudentCompletedDetailsEntity;
    RoAssignmentStudentCourseLessonProgress? : RoAssignmentStudentCourseLessonProgressEntity[];
    RoSchoolAssignmentStatsAssignmentId? : RoSchoolAssignmentStatsEntity[];
    StudentProgressResetEvent? : StudentProgressResetEventEntity[];
}

/** Entity for Query Meaning Assignment_Lesson_with_Progress-For_Student  */
export interface AssignmentLessonWithProgressForStudentQueryEntity extends DwOrmData {
    // Attributes
    AssignmentCourseLessonId?: number;
    AssignmentId?: number;
    AssignmentIdDisplay?: string;
    CourseLessonId?: number;
    CourseLessonIdDisplay?: string;
    CreatedBy?: number;
    CreatedByDisplay?: string;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedByDisplay?: string;
    ModifiedDateTime?: string;
    AssignmentAssignmentDescription?: string;
    AssignmentAssignmentStatusId?: number;
    AssignmentAssignmentStatusIdDisplay?: string;
    AssignmentAssignedDateTime?: string;
    AssignmentDueDateTime?: string;
    AssignmentCourseId?: number;
    AssignmentCourseIdDisplay?: string;
    AssignmentStudentAssignmentStudentId?: number;
    AssignmentStudentStudentId?: number;
    AssignmentStudentStudentIdDisplay?: string;
    AssignmentStudentPercentComplete?: number;
    AssignmentStudentCompletedDateTime?: string;
    StudentUserId?: number;
    StudentUserIdDisplay?: string;
    CourseLessonLessonName?: string;
    CourseLessonCourseModuleId?: number;
    CourseLessonCourseModuleIdDisplay?: string;
    CourseLessonLessonTypeId?: number;
    CourseLessonLessonTypeIdDisplay?: string;
    CourseLessonLessonOrder?: number;
    CourseLessonProgressCourseLessonId?: number;
    CourseLessonProgressCourseLessonIdDisplay?: string;
    CourseLessonProgressLessonComplete?: boolean;
    CourseLessonProgressVideoFurthestTimeSeconds?: number;
    CourseLessonProgressBestQuizResultId?: number;
    CourseLessonProgressBestQuizResultIdDisplay?: string;
    CourseLessonProgressPercentComplete?: number;
    CourseLessonProgressLastActivityDateTime?: string;
    CourseModuleProgressCourseModuleProgressId?: number;
    CourseModuleProgressCourseModuleId?: number;
    CourseModuleProgressCourseModuleIdDisplay?: string;
    CourseModuleProgressStudentCourseId?: number;
    CourseModuleProgressStudentCourseIdDisplay?: string;
    StudentCourseStudentId?: number;
    StudentCourseStudentIdDisplay?: string;
    StudentFromProgressUserId?: number;
    StudentFromProgressUserIdDisplay?: string;
    CourseModuleModuleName?: string;
    CourseModuleModuleOrder?: number;
    CourseModuleCourseModuleId?: number;
    CourseModuleCourseId?: number;
    CourseModuleCourseIdDisplay?: string;

    // Relations
    Assignment? : AssignmentEntity;
    CourseLesson? : CourseLessonEntity;
}

/** Entity for Query Meaning Assignment-By_Student  */
export interface AssignmentByStudentQueryEntity extends DwOrmData {
    // Attributes
    AssignmentId?: number;
    CourseId?: number;
    CourseIdDisplay?: string;
    AssignmentDescription?: string;
    AssignmentTypeId?: number;
    AssignmentTypeIdDisplay?: string;
    AssignmentStatusId?: number;
    AssignmentStatusIdDisplay?: string;
    AssignmentLinkUrl?: string;
    MediaId?: number;
    DueDateTime?: string;
    FlightSchoolGroupId?: number;
    FlightSchoolGroupIdDisplay?: string;
    AssignedDateTime?: string;
    CompletedDateTime?: string;
    FlightSchoolId?: number;
    FlightSchoolIdDisplay?: string;
    ResetLessonProgress?: boolean;
    UseGroupAssignment?: boolean;
    InstructorId?: number;
    InstructorIdDisplay?: string;
    CreatedBy?: number;
    CreatedByDisplay?: string;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedByDisplay?: string;
    ModifiedDateTime?: string;
    AssignmentStudentAssignmentStudentId?: number;
    AssignmentStudentPercentComplete?: number;
    AssignmentStudentCompletedDateTime?: string;
    StudentUserId?: number;
    StudentUserIdDisplay?: string;
    StudentStudentId?: number;

    // Relations
    AssignmentStatus? : AssignmentStatusEntity;
    AssignmentType? : AssignmentTypeEntity;
    Course? : CourseEntity;
    FlightSchool? : FlightSchoolEntity;
    FlightSchoolGroup? : FlightSchoolGroupEntity;
    Instructor? : InstructorEntity;
    DwMedia? : DwMediaEntity;
    AssignmentCourseLesson? : AssignmentCourseLessonEntity[];
    AssignmentStudent? : AssignmentStudentEntity[];
    AssignmentIdRoAssignmentStudentCourseLessonProgress? : RoAssignmentStudentCourseLessonProgressEntity[];
    RoAssignmentStudentStat? : RoAssignmentStudentStatEntity[];
    StudentProgressResetEvent? : StudentProgressResetEventEntity[];
}

/** Entity for Query Meaning Assignment_Student-Lesson_Progress-_List  */
export interface AssignmentStudentLessonProgressListQueryEntity extends DwOrmData {
    // Attributes
    AssignmentStudentId?: number;
    AssignmentStudentIdDisplay?: string;
    StudentId?: number;
    CourseLessonId?: number;
    CourseLessonIdDisplay?: string;
    CourseLessonProgressId?: number;
    AssignmentStudentAssignmentStudentId?: number;
    AssignmentStudentAssignmentId?: number;
    AssignmentStudentAssignmentIdDisplay?: string;
    AssignmentStudentStudentId?: number;
    AssignmentStudentStudentIdDisplay?: string;
    AssignmentStudentPercentComplete?: number;
    AssignmentStudentCompletedDateTime?: string;
    CourseLessonProgressLessonComplete?: boolean;
    CourseLessonCourseLessonId?: number;
    CourseLessonCourseModuleId?: number;
    CourseLessonCourseModuleIdDisplay?: string;
    CourseLessonLessonName?: string;
    CourseLessonLessonDescription?: string;
    CourseLessonLessonTypeId?: number;
    CourseLessonLessonTypeIdDisplay?: string;
    CourseLessonVideoId?: number;
    CourseLessonVideoIdDisplay?: string;
    CourseLessonQuizId?: number;
    CourseLessonQuizIdDisplay?: string;
    CourseLessonLessonOrder?: number;
    LessonImageDwroMediaMediaPath?: string;

    // Relations
    AssignmentIdAssignment? : AssignmentEntity;
    AssignmentStudent? : AssignmentStudentEntity;
    CourseLesson? : CourseLessonEntity;
    CourseLessonProgress? : CourseLessonProgressEntity;
}

/** Entity for Query Meaning Student_By_Instructor  */
export interface StudentByInstructorQueryEntity extends DwOrmData {
    // Attributes
    StudentId?: number;
    UserId?: number;
    UserIdDisplay?: string;
    CreatedBy?: number;
    CreatedByDisplay?: string;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedByDisplay?: string;
    ModifiedDateTime?: string;
    AddressId?: number;
    AddressIdDisplay?: string;
    PilotCertificateNumber?: string;
    CitizenshipCountryId?: number;
    CitizenshipCountryIdDisplay?: string;
    BirthDate?: string;
    PilotTypeId?: number;
    PilotTypeIdDisplay?: string;
    FlightSchoolPositionId?: number;
    FlightSchoolPositionIdDisplay?: string;
    AcquisitionSourceId?: number;
    AcquisitionSourceIdDisplay?: string;
    AcquisitionSourceOther?: string;
    InstructorCertifcateNumber?: string;
    StudentCode?: string;
    AviationGoalId?: number;
    AviationGoalIdDisplay?: string;
    TimeZoneId?: number;
    TimeZoneIdDisplay?: string;
    DwUserFirstName?: string;
    DwUserLastName?: string;
    DwUserEmail?: string;
    DwroMediaMediaPath?: string;
    UserDetailUserDetailId?: number;
    UserDetailFlightSchoolId?: number;
    UserDetailFlightSchoolIdDisplay?: string;
    InstructorStudentInstructorId?: number;
    InstructorStudentInstructorIdDisplay?: string;
    InstructorStudentInstructorStudentId?: number;
    InstructorInstructorId?: number;
    InstructorUserId?: number;
    InstructorUserIdDisplay?: string;

    // Relations
    AcquisitionSource? : AcquisitionSourceEntity;
    Address? : AddressEntity;
    AviationGoal? : AviationGoalEntity;
    CitizenshipCountry? : CountryEntity;
    FlightSchoolPosition? : FlightSchoolPositionEntity;
    PilotType? : PilotTypeEntity;
    TimeZoneIdTimeZone? : TimeZoneEntity;
    DwUser? : DwUserEntity;
    AssignmentStudent? : AssignmentStudentEntity[];
    CoursePurchaseReservationCourse? : CoursePurchaseReservationCourseEntity[];
    CoursePurchaseStudent? : CoursePurchaseStudentEntity[];
    DailyQuiz? : DailyQuizEntity[];
    DocumentItemAcknowledgement? : DocumentItemAcknowledgementEntity[];
    FlightSchoolGroupStudent? : FlightSchoolGroupStudentEntity[];
    InstructorStudent? : InstructorStudentEntity[];
    JoinRequestCoursePurchase? : JoinRequestCoursePurchaseEntity[];
    ProfitShare? : ProfitShareEntity[];
    RoStudentSchoolCourses? : RoStudentSchoolCoursesEntity[];
    StudentAchievement? : StudentAchievementEntity[];
    StudentActivity? : StudentActivityEntity[];
    StudentCourse? : StudentCourseEntity[];
    StudentGamificationDay? : StudentGamificationDayEntity[];
    StudentGamificationSummary? : StudentGamificationSummaryEntity[];
    StudentLessonProgressEvent? : StudentLessonProgressEventEntity[];
    StudentProgressResetEvent? : StudentProgressResetEventEntity[];
    StudentWeatherDayTransaction? : StudentWeatherDayTransactionEntity[];
    SubscriptionCourseTracking? : SubscriptionCourseTrackingEntity[];
}

/** Entity for Query Meaning Student-By_School  */
export interface StudentBySchoolQueryEntity extends DwOrmData {
    // Attributes
    StudentId?: number;
    UserId?: number;
    UserIdDisplay?: string;
    CreatedBy?: number;
    CreatedByDisplay?: string;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedByDisplay?: string;
    ModifiedDateTime?: string;
    AddressId?: number;
    AddressIdDisplay?: string;
    PilotCertificateNumber?: string;
    CitizenshipCountryId?: number;
    CitizenshipCountryIdDisplay?: string;
    BirthDate?: string;
    PilotTypeId?: number;
    PilotTypeIdDisplay?: string;
    FlightSchoolPositionId?: number;
    FlightSchoolPositionIdDisplay?: string;
    AcquisitionSourceId?: number;
    AcquisitionSourceIdDisplay?: string;
    AcquisitionSourceOther?: string;
    InstructorCertifcateNumber?: string;
    StudentCode?: string;
    AviationGoalId?: number;
    AviationGoalIdDisplay?: string;
    TimeZoneId?: number;
    TimeZoneIdDisplay?: string;
    DwUserFirstName?: string;
    DwUserLastName?: string;
    DwroMediaMediaPath?: string;
    UserDetailUserDetailId?: number;
    UserDetailFlightSchoolId?: number;
    UserDetailFlightSchoolIdDisplay?: string;

    // Relations
    AcquisitionSource? : AcquisitionSourceEntity;
    Address? : AddressEntity;
    AviationGoal? : AviationGoalEntity;
    CitizenshipCountry? : CountryEntity;
    FlightSchoolPosition? : FlightSchoolPositionEntity;
    PilotType? : PilotTypeEntity;
    TimeZoneIdTimeZone? : TimeZoneEntity;
    DwUser? : DwUserEntity;
    AssignmentStudent? : AssignmentStudentEntity[];
    CoursePurchaseReservationCourse? : CoursePurchaseReservationCourseEntity[];
    CoursePurchaseStudent? : CoursePurchaseStudentEntity[];
    DailyQuiz? : DailyQuizEntity[];
    DocumentItemAcknowledgement? : DocumentItemAcknowledgementEntity[];
    FlightSchoolGroupStudent? : FlightSchoolGroupStudentEntity[];
    InstructorStudent? : InstructorStudentEntity[];
    JoinRequestCoursePurchase? : JoinRequestCoursePurchaseEntity[];
    ProfitShare? : ProfitShareEntity[];
    RoStudentSchoolCourses? : RoStudentSchoolCoursesEntity[];
    StudentAchievement? : StudentAchievementEntity[];
    StudentActivity? : StudentActivityEntity[];
    StudentCourse? : StudentCourseEntity[];
    StudentGamificationDay? : StudentGamificationDayEntity[];
    StudentGamificationSummary? : StudentGamificationSummaryEntity[];
    StudentLessonProgressEvent? : StudentLessonProgressEventEntity[];
    StudentProgressResetEvent? : StudentProgressResetEventEntity[];
    StudentWeatherDayTransaction? : StudentWeatherDayTransactionEntity[];
    SubscriptionCourseTracking? : SubscriptionCourseTrackingEntity[];
}

/** Entity for Query Meaning Student_Course-For_Context  */
export interface StudentCourseForContextQueryEntity extends DwOrmData {
    // Attributes
    StudentCourseId?: number;
    StudentId?: number;
    StudentIdDisplay?: string;
    CourseId?: number;
    CourseIdDisplay?: string;
    IsActive?: boolean;
    LastActivityDateTime?: string;
    CompletedDateTime?: string;
    StudentCourseStatusId?: number;
    StudentCourseStatusIdDisplay?: string;
    IsEndorsed?: boolean;
    TotalVideoTimeSeconds?: number;
    TotalQuizTimeSeconds?: number;
    PercentComplete?: number;
    ModulesCompleted?: number;
    ModulesCount?: number;
    LessonsCompleted?: number;
    LessonCount?: number;
    AcsTestPassedFirstTime?: boolean;
    AcsTestPassed?: boolean;
    AcsTestUploaded?: boolean;
    StudentUserId?: number;
    StudentUserIdDisplay?: string;
    StudentStudentId?: number;
    CourseCourseId?: number;
    CourseCourseName?: string;
    CourseAcsTestId?: number;
    CourseAcsTestIdDisplay?: string;
    RoStudentCourseAcsTestResultDetailACSTestResultCount?: number;
    RoStudentCourseAcsTestResultDetailFailedAny?: boolean;
    RoStudentCourseAcsTestResultDetailPassedAny?: boolean;
    CourseEndorsementStudentCourseEndorsementStudentId?: number;
    CourseEndorsementStudentCourseEndorsementId?: number;
    CourseEndorsementStudentStudentCourseId?: number;
    CourseEndorsementStudentStudentCourseIdDisplay?: string;
    CourseEndorsementStudentCompletionDateTime?: string;
    CourseEndorsementStudentExpirationDateTime?: string;
    CourseEndorsementStudentEndorsementPDFMediaId?: number;
    CourseEndorsementStudentCourseEndorsementStudentStatusId?: number;

    // Relations
    Course? : CourseEntity;
    NextCourseLesson? : CourseLessonEntity;
    StudentCourseStatusIdReferenceStatus? : ReferenceStatusEntity;
    Student? : StudentEntity;
    StudentCourseProgressStatus? : StudentCourseProgressStatusEntity;
    AcsWrittenResult? : AcsWrittenResultEntity[];
    StudentCoursetIdAIPromptRequest? : AIPromptRequestEntity[];
    CourseEndorsementStudent? : CourseEndorsementStudentEntity;
    CourseModuleProgress? : CourseModuleProgressEntity[];
    CoursePurchaseReservationCourse? : CoursePurchaseReservationCourseEntity[];
    DailyQuiz? : DailyQuizEntity[];
    IntegrationCoursePurchase? : IntegrationCoursePurchaseEntity;
    JoinRequestCoursePurchase? : JoinRequestCoursePurchaseEntity[];
    ModificationHistoryStudent? : ModificationHistoryStudentEntity[];
    QuizResult? : QuizResultEntity[];
    RoCourseEndorsementStudentActive? : RoCourseEndorsementStudentActiveEntity[];
    RoStudentCourseAcsTestResultDetail? : RoStudentCourseAcsTestResultDetailEntity;
    RoStudentCourseInstructor? : RoStudentCourseInstructorEntity[];
    RoStudentSchoolCourses? : RoStudentSchoolCoursesEntity[];
    StudentAchievement? : StudentAchievementEntity[];
    StudentCourseLockInstructor? : StudentCourseLockInstructorEntity[];
    StudentModuleSummary? : StudentModuleSummaryEntity[];
    StudentProgressResetEvent? : StudentProgressResetEventEntity[];
    SubscriptionCourseTracking? : SubscriptionCourseTrackingEntity[];
}

/** Entity for Query Meaning Join_Request-Details-Grid  */
export interface JoinRequestDetailsGridQueryEntity extends DwOrmData {
    // Attributes
    JoinRequestId?: number;
    FlightSchoolId?: number;
    FlightSchoolIdDisplay?: string;
    JoinRequestTypeId?: number;
    JoinRequestTypeIdDisplay?: string;
    MessageHtml?: string;
    CreatedBy?: number;
    CreatedByDisplay?: string;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedByDisplay?: string;
    ModifiedDateTime?: string;
    UsePackage?: boolean;
    CoursePackageId?: number;
    CoursePackageIdDisplay?: string;
    JoinRequestStatusId?: number;
    JoinRequestStatusIdDisplay?: string;
    AssignToGroup?: boolean;
    FlightSchoolGroupId?: number;
    FlightSchoolGroupIdDisplay?: string;
    DiscountCode?: string;
    JoinRequestEmailEmailAddress?: string;
    JoinRequestEmailAccepted?: boolean;
    JoinRequestEmailUserId?: number;
    JoinRequestEmailUserIdDisplay?: string;
    JoinRequestEmailAcceptedDateTime?: string;
    JoinRequestEmailLastResendRequestDateTime?: string;
    JoinRequestEmailJoinRequestEmailId?: number;
    JoinRequestEmailJoinRequestId?: number;
    JoinRequestEmailJoinRequestIdDisplay?: string;

    // Relations
    FlightSchool? : FlightSchoolEntity;
    FlightSchoolGroup? : FlightSchoolGroupEntity;
    JoinRequestStatus? : JoinRequestStatusEntity;
    JoinRequestType? : JoinRequestTypeEntity;
    CoursePackage? : PackageEntity;
    JoinRequestCourse? : JoinRequestCourseEntity[];
    JoinRequestCoursePurchase? : JoinRequestCoursePurchaseEntity[];
    JoinRequestEmail? : JoinRequestEmailEntity[];
}

/** Entity for Query Meaning Course_List_For_Student_Marketplace  */
export interface CourseListForStudentMarketplaceQueryEntity extends DwOrmData {
    // Attributes
    CourseId?: number;
    CourseName?: string;
    CourseDescription?: string;
    CourseTypeId?: number;
    CourseTypeIdDisplay?: string;
    CourseImageMediaId?: number;
    CourseImageMediaIdDisplay?: string;
    CourseNotes?: string;
    AircraftTypeId?: number;
    AircraftTypeIdDisplay?: string;
    AvionicsType?: string;
    ProgramTypeId?: number;
    ProgramTypeIdDisplay?: string;
    RetailPrice?: number;
    CreatedBy?: number;
    CreatedByDisplay?: string;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedByDisplay?: string;
    ModifiedDateTime?: string;
    CourseStatusId?: number;
    CourseStatusIdDisplay?: string;
    TotalCourseTimeSeconds?: number;
    TotalCourseVideoTimeSeconds?: number;
    TotalCourseQuizTimeSeconds?: number;
    CourseKey?: string;
    DefaultSchoolCourse?: boolean;
    AcsTestId?: number;
    AcsTestIdDisplay?: string;
    CourseOrder?: number;
    ModulePrefixOverride?: string;
    ComingSoon?: boolean;
    MediaImageHeight?: number;
    MediaImageWidth?: number;
    MediaMediaPath?: string;
    RoStudentSchoolCoursesFlightSchoolId?: number;
    RoStudentSchoolCoursesFlightSchoolIdDisplay?: string;
    RoStudentSchoolCoursesCourseName?: string;
    RoStudentSchoolCoursesStudentName?: string;
    RoStudentSchoolCoursesUserId?: number;
    RoStudentSchoolCoursesUserIdDisplay?: string;
    RoStudentSchoolCoursesStudentCourseId?: number;
    RoStudentSchoolCoursesCourseId?: number;
    RoStudentSchoolCoursesCourseIdDisplay?: string;
    RoStudentSchoolCoursesStudentId?: number;
    RoStudentSchoolCoursesStudentIdDisplay?: string;
    StudentCourseStudentCourseId?: number;
    StudentCourseStudentId?: number;
    StudentCourseStudentIdDisplay?: string;
    StudentCourseCourseId?: number;
    StudentCourseCourseIdDisplay?: string;
    StudentCourseIsActive?: boolean;
    StudentCoursePercentComplete?: number;
    StudentCourseModulesCompleted?: number;
    StudentCourseModulesCount?: number;
    StudentCourseLastActivityDateTime?: string;
    StudentCourseLessonsCompleted?: number;
    StudentCourseLessonCount?: number;
    StudentCourseTotalTimeSeconds?: number;
    StudentCourseFirstActivityDateTime?: string;
    StudentCourseCompletedDateTime?: string;
    StudentCourseStudentCourseStatusId?: number;
    StudentCourseStudentCourseStatusIdDisplay?: string;
    StudentCourseIsEndorsed?: boolean;
    ResultCount?: number;
    AcsTestResultsPassedAny?: boolean;
    AcsTestResultsFailedAny?: boolean;
    CourseEndorsementStudentCourseEndorsementStudentId?: number;
    CourseEndorsementStudentCourseEndorsementId?: number;
    CourseEndorsementStudentCompletionDateTime?: string;
    CourseEndorsementStudentExpirationDateTime?: string;
    CourseEndorsementStudentEndorsementPDFMediaId?: number;
    ProductProductId?: number;
    ProductProductTypeId?: number;
    ProductProductTypeIdDisplay?: string;
    ProductRetailPrice?: number;

    // Relations
    AcsTest? : AcsTestEntity;
    AircraftType? : AircraftTypeEntity;
    CourseType? : CourseTypeEntity;
    CourseImageDwMedia? : DwMediaEntity;
    CourseImageDwroMedia? : DwRoMediaEntity;
    ProgramType? : ProgramTypeEntity;
    CourseStatusIdReferenceStatus? : ReferenceStatusEntity;
    AcsTaskMultiAssign? : AcsTaskMultiAssignEntity[];
    AIPromptRequest? : AIPromptRequestEntity[];
    Assignment? : AssignmentEntity[];
    CourseAvailabilityNotification? : CourseAvailabilityNotificationEntity[];
    CourseDocumentItem? : CourseDocumentItemEntity[];
    CourseEndorsement? : CourseEndorsementEntity;
    CourseLessonFlag? : CourseLessonFlagEntity[];
    CourseModificationHistory? : CourseModificationHistoryEntity[];
    CourseModule? : CourseModuleEntity[];
    CoursePurchaseCourse? : CoursePurchaseCourseEntity[];
    CoursePurchaseReservationCourse? : CoursePurchaseReservationCourseEntity[];
    DiscountCourse? : DiscountCourseEntity[];
    DocumentLinkProcessingRun? : DocumentLinkProcessingRunEntity[];
    DocumentLinkProcessingRunItem? : DocumentLinkProcessingRunItemEntity[];
    FlightSchoolCourse? : FlightSchoolCourseEntity[];
    IntegrationCoursePurchase? : IntegrationCoursePurchaseEntity[];
    IntegrationCoursePurchaseRequest? : IntegrationCoursePurchaseRequestEntity[];
    IntegrationSystemCourse? : IntegrationSystemCourseEntity[];
    IntegrationUserEvent? : IntegrationUserEventEntity[];
    JoinRequestCourse? : JoinRequestCourseEntity[];
    JoinRequestCoursePurchase? : JoinRequestCoursePurchaseEntity[];
    ModificationHistory? : ModificationHistoryEntity[];
    MultipleAssignCourse? : MultipleAssignCourseEntity[];
    PackageCourse? : PackageCourseEntity[];
    Product? : ProductEntity;
    Question? : QuestionEntity[];
    RoFlightSchoolCourseUnique? : RoFlightSchoolCourseUniqueEntity[];
    RoStudentSchoolCourses? : RoStudentSchoolCoursesEntity[];
    StudentCourse? : StudentCourseEntity[];
    StudentProgressResetEvent? : StudentProgressResetEventEntity[];
    SubscriptionCourseTracking? : SubscriptionCourseTrackingEntity[];
}

/** Entity for Query Meaning StudentCourse_ForAssignment  */
export interface StudentCourseForAssignmentQueryEntity extends DwOrmData {
    // Attributes
    StudentCourseId?: number;
    StudentId?: number;
    StudentIdDisplay?: string;
    CourseId?: number;
    CourseIdDisplay?: string;
    IsActive?: boolean;
    PercentComplete?: number;
    CourseCourseId?: number;
    CourseCourseName?: string;
    StudentUserId?: number;
    StudentUserIdDisplay?: string;

    // Relations
    Course? : CourseEntity;
    NextCourseLesson? : CourseLessonEntity;
    StudentCourseStatusIdReferenceStatus? : ReferenceStatusEntity;
    Student? : StudentEntity;
    StudentCourseProgressStatus? : StudentCourseProgressStatusEntity;
    AcsWrittenResult? : AcsWrittenResultEntity[];
    StudentCoursetIdAIPromptRequest? : AIPromptRequestEntity[];
    CourseEndorsementStudent? : CourseEndorsementStudentEntity;
    CourseModuleProgress? : CourseModuleProgressEntity[];
    CoursePurchaseReservationCourse? : CoursePurchaseReservationCourseEntity[];
    DailyQuiz? : DailyQuizEntity[];
    IntegrationCoursePurchase? : IntegrationCoursePurchaseEntity;
    JoinRequestCoursePurchase? : JoinRequestCoursePurchaseEntity[];
    ModificationHistoryStudent? : ModificationHistoryStudentEntity[];
    QuizResult? : QuizResultEntity[];
    RoCourseEndorsementStudentActive? : RoCourseEndorsementStudentActiveEntity[];
    RoStudentCourseAcsTestResultDetail? : RoStudentCourseAcsTestResultDetailEntity;
    RoStudentCourseInstructor? : RoStudentCourseInstructorEntity[];
    RoStudentSchoolCourses? : RoStudentSchoolCoursesEntity[];
    StudentAchievement? : StudentAchievementEntity[];
    StudentCourseLockInstructor? : StudentCourseLockInstructorEntity[];
    StudentModuleSummary? : StudentModuleSummaryEntity[];
    StudentProgressResetEvent? : StudentProgressResetEventEntity[];
    SubscriptionCourseTracking? : SubscriptionCourseTrackingEntity[];
}

/** Entity for Query Meaning Profit_Sharing-Totals_By_School  */
export interface ProfitSharingTotalsBySchoolQueryEntity extends DwOrmData {
    // Attributes
    FlightSchoolId?: number;
    FlightSchoolName?: string;
    Year?: number;
    Month?: number;
    ProfitShareTypeId?: number;
    ProfitShareType?: string;
    Sum?: number;

    // Relations
}

/** Entity for Query Meaning Subscription_Tier-Active  */
export interface SubscriptionTierActiveQueryEntity extends DwOrmData {
    // Attributes
    SubscriptionTierId?: number;
    SubscriptionTierName?: string;
    SubscriptionTierStatusId?: number;
    SubscriptionTierStatusIdDisplay?: string;
    EffectiveStartDate?: string;
    EffectiveEndDate?: string;
    PlatformMonthlyCost?: number;
    ProfitSharingPercentage?: number;
    CreatedBy?: number;
    CreatedByDisplay?: string;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedByDisplay?: string;
    ModifiedDateTime?: string;
    ProductId?: string;
    PriceId?: string;
    Description?: string;
    IsDefaultTier?: boolean;
    SubscriptionTierOrder?: number;
    LimitToSchools?: boolean;

    // Relations
    SubscriptionTierStatus? : SubscriptionTierStatusEntity;
    Discount? : DiscountEntity[];
    Product? : ProductEntity;
    Subscription? : SubscriptionEntity[];
    SubscriptionTierBenefit? : SubscriptionTierBenefitEntity[];
    SubscriptionTierFeature? : SubscriptionTierFeatureEntity[];
    SubscriptionTierFlightSchool? : SubscriptionTierFlightSchoolEntity[];
    SubscriptionTierRole? : SubscriptionTierRoleEntity[];
}

/** Entity for Query Meaning Subscription_Details  */
export interface SubscriptionDetailsQueryEntity extends DwOrmData {
    // Attributes
    SubscriptionId?: number;
    FlightSchoolId?: number;
    FlightSchoolIdDisplay?: string;
    SubscriptionTierId?: number;
    SubscriptionTierIdDisplay?: string;
    SubscriptionStatusId?: number;
    SubscriptionStatusIdDisplay?: string;
    EffectiveStartDate?: string;
    EffectiveEndDate?: string;
    FirstInvoiceDateTime?: string;
    LastInvoiceDateTime?: string;
    NextInvoiceDateTime?: string;
    DiscountAppliedDate?: string;
    DiscountExpirationDate?: string;
    DiscountDiscountCode?: string;

    // Relations
    Discount? : DiscountEntity;
    FlightSchool? : FlightSchoolEntity;
    SubscriptionStatus? : SubscriptionStatusEntity;
    SubscriptionTier? : SubscriptionTierEntity;
    InvoiceLine? : InvoiceLineEntity[];
    TierRoSchoolBillingDetails? : RoSchoolBillingDetailsEntity;
    PendingRoSchoolSubscription? : RoSchoolSubscriptionEntity;
    RoSchoolSubscription? : RoSchoolSubscriptionEntity;
    PreviousRoSchoolSubscription? : RoSchoolSubscriptionEntity;
    SubscriptionCourseTracking? : SubscriptionCourseTrackingEntity[];
    SubscriptionRoleTracking? : SubscriptionRoleTrackingEntity[];
}

/** Entity for Query Meaning Course_Module_Progress-With_AI_Summary  */
export interface CourseModuleProgressWithAISummaryQueryEntity extends DwOrmData {
    // Attributes
    CourseModuleProgressId?: number;
    StudentCourseId?: number;
    StudentCourseIdDisplay?: string;
    CourseModuleId?: number;
    CourseModuleIdDisplay?: string;
    LessonsCount?: number;
    LessonsCompleted?: number;
    PercentComplete?: number;
    LastActivityDateTime?: string;
    FirstActivityDateTime?: string;
    CompletedDateTime?: string;
    TotalTimeSeconds?: number;
    TotalVideoTimeSeconds?: number;
    TotalQuizTimeSeconds?: number;
    ModuleProgressStatusId?: number;
    ModuleProgressStatusIdDisplay?: string;
    AIPromptRequestAIPromptRequestId?: number;
    AIPromptRequestResult?: string;
    AIPromptRequestAIPromptRequestStatusId?: number;
    AIPromptRequestAIPromptRequestStatusIdDisplay?: string;
    StudentCourseStudentCourseId?: number;
    StudentStudentId?: number;
    StudentUserId?: number;
    StudentUserIdDisplay?: string;
    DwUserFirstName?: string;
    DwUserLastName?: string;
    DwUserEmail?: string;

    // Relations
    AIPromptRequest? : AIPromptRequestEntity;
    CourseModule? : CourseModuleEntity;
    ModuleProgressStatusIdReferenceStatus? : ReferenceStatusEntity;
    StudentCourse? : StudentCourseEntity;
    CourseLessonProgress? : CourseLessonProgressEntity[];
    StudentModuleSummary? : StudentModuleSummaryEntity[];
}

/** Entity for Query Meaning Assignment_Student-Acknowledgements  */
export interface AssignmentStudentAcknowledgementsQueryEntity extends DwOrmData {
    // Attributes
    AssignmentStudentId?: number;
    AssignmentId?: number;
    AssignmentIdDisplay?: string;
    StudentId?: number;
    StudentIdDisplay?: string;
    PercentComplete?: number;
    CompletedDateTime?: string;
    CreatedBy?: number;
    CreatedByDisplay?: string;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedByDisplay?: string;
    ModifiedDateTime?: string;
    Acknowledged?: boolean;
    AcknowledgedDateTime?: string;
    AiPromptRequestId?: number;
    AiPromptRequestIdDisplay?: string;
    ShowAISummary?: boolean;
    StudentStudentId?: number;
    StudentUserId?: number;
    StudentUserIdDisplay?: string;
    AssignmentAssignmentId?: number;
    AssignmentCourseId?: number;
    AssignmentCourseIdDisplay?: string;
    AssignmentAssignmentDescription?: string;
    AssignmentAssignmentStatusId?: number;
    AssignmentAssignmentStatusIdDisplay?: string;
    AssignmentDueDateTime?: string;
    AssignmentAssignedDateTime?: string;
    AssignmentInstructorId?: number;
    AssignmentInstructorIdDisplay?: string;

    // Relations
    AiPromptRequestIdAIPromptRequest? : AIPromptRequestEntity;
    Assignment? : AssignmentEntity;
    Student? : StudentEntity;
    AIPromptRequest? : AIPromptRequestEntity[];
    RoAssignmentStudentCompletedDetails? : RoAssignmentStudentCompletedDetailsEntity;
    RoAssignmentStudentCourseLessonProgress? : RoAssignmentStudentCourseLessonProgressEntity[];
    RoSchoolAssignmentStatsAssignmentId? : RoSchoolAssignmentStatsEntity[];
    StudentProgressResetEvent? : StudentProgressResetEventEntity[];
}

/** Entity for Query Meaning Document_Items-List  */
export interface DocumentItemsListQueryEntity extends DwOrmData {
    // Attributes
    DocumentItemId?: number;
    DocumentGroupId?: number;
    DocumentGroupIdDisplay?: string;
    DocumentItemName?: string;
    MediaId?: number;
    MediaIdDisplay?: string;
    CardIconMediaId?: number;
    CardIconMediaIdDisplay?: string;
    DocumentTypeId?: number;
    DocumentTypeIdDisplay?: string;
    DocumentItemStatusId?: number;
    DocumentItemStatusIdDisplay?: string;
    EmbeddedMarkup?: string;
    ExtractedImageMediaId?: number;
    ExtractedImageMediaIdDisplay?: string;
    UseCustomCardIcon?: boolean;
    DocumentOwnershipTypeId?: number;
    DocumentOwnershipTypeIdDisplay?: string;
    FlightSchoolId?: number;
    FlightSchoolIdDisplay?: string;
    ParentDocumentFolderId?: number;
    ParentDocumentFolderIdDisplay?: string;
    RequireStudentAcknowledgement?: boolean;
    CreatedBy?: number;
    CreatedByDisplay?: string;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedByDisplay?: string;
    ModifiedDateTime?: string;
    AiProcessingReferenceId?: number;
    DocumentFileHash?: string;
    DocumentAiComplete?: boolean;
    DocumentAiProcessingStatusId?: number;
    DocumentAiProcessingStatusIdDisplay?: string;
    DocumentAiProcessingProgressText?: string;
    DocumentAiProcessingErrorText?: string;
    DocumentAiProcessingStartDateTime?: string;
    DocumentAiProcessingCompletedDateTime?: string;
    DocumentAiProcessingLastUpdatedDateTime?: string;
    DocumentAiProcessingEstimatedCompletedDateTime?: string;
    DocumentAiProcessingTotalChunkCount?: number;
    DocumentAiProcessingProcessedChunkCount?: number;
    DocumentAiProcessingFailedChunkCount?: number;
    DocumentAiProcessingTotalModuleLinkCount?: number;
    DocumentAiProcessingProcessedModuleLinkCount?: number;
    DocumentAiProcessingFailedModuleLinkCount?: number;
    DocumentGroupDocumentGroupName?: string;
    DocumentGroupIsDefault?: boolean;
    DocumentTypeDocumentType?: string;
    DocumentTypeUseEmbeddedMarkup?: boolean;
    DocumentTypeDocumentTypeId?: number;
    MediaImageHeight?: number;
    MediaImageWidth?: number;
    MediaMediaPath?: string;
    ExtractedMediaImageHeight?: number;
    ExtractedMediaImageWidth?: number;
    ExtractedMediaMediaPath?: string;

    // Relations
    DocumentAiProcessingStatus? : DocumentAiProcessingStatusEntity;
    ParentDocumentFolder? : DocumentFolderEntity;
    DocumentGroup? : DocumentGroupEntity;
    DocumentItemStatus? : DocumentItemStatusEntity;
    DocumentOwnershipTypeIdDocumentOwnerType? : DocumentOwnerTypeEntity;
    DocumentType? : DocumentTypeEntity;
    FlightSchool? : FlightSchoolEntity;
    DwMedia? : DwMediaEntity;
    CardIconDwMedia? : DwMediaEntity;
    ExtractedImageDwMedia? : DwMediaEntity;
    CourseDocumentItem? : CourseDocumentItemEntity[];
    CourseLesson? : CourseLessonEntity[];
    CourseLessonDocumentLink? : CourseLessonDocumentLinkEntity[];
    DocumentItemAcknowledgement? : DocumentItemAcknowledgementEntity[];
    DocumentItemChangeLog? : DocumentItemChangeLogEntity[];
    DocumentItemChunk? : DocumentItemChunkEntity[];
    DocumentItemPage? : DocumentItemPageEntity[];
    DocumentLinkProcessingRun? : DocumentLinkProcessingRunEntity[];
    DocumentPublication? : DocumentPublicationEntity[];
    UserDocumentSectionFavorite? : UserDocumentSectionFavoriteEntity[];
}

/** Entity for Query Meaning Flight_School_Reports-Course_Counts  */
export interface FlightSchoolReportsCourseCountsQueryEntity extends DwOrmData {
    // Attributes
    FlightSchoolId?: number;
    FlightSchoolName?: string;
    CourseId?: number;
    CourseName?: string;
    Count?: number;

    // Relations
    FlightSchool? : FlightSchoolEntity;
}

/** Entity for Query Meaning Instructor_Leaderboard  */
export interface InstructorLeaderboardQueryEntity extends DwOrmData {
    // Attributes
    InstructorId?: number;
    UserId?: number;
    UserIdDisplay?: string;
    FlightSchoolId?: number;
    FlightSchoolIdDisplay?: string;
    InstructorStatusId?: number;
    InstructorStatusIdDisplay?: string;
    CreatedBy?: number;
    CreatedByDisplay?: string;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedByDisplay?: string;
    ModifiedDateTime?: string;
    InstructorUserFirstName?: string;
    InstructorUserLastName?: string;
    InstructorUserIsActive?: boolean;
    DwroMediaMediaPath?: string;
    StudentStatFlightSchoolId?: number;
    StudentStatFlightSchoolName?: string;
    StudentStatCourseId?: number;
    StudentStatCourseName?: string;
    StudentStatStudentId?: number;
    StudentStatStudentIdDisplay?: string;
    StudentStatUserId?: number;
    StudentStatStudentName?: string;
    StudentStatLastActivityDateTime?: string;
    StudentStatPercentComplete?: number;
    StudentStatTotalTimeSeconds?: number;
    StudentStatCompletedDateTime?: string;
    StudentStatFirstActivityDateTime?: string;
    StudentStatActiveStudent?: number;
    StudentStatIsComplete?: number;
    StudentStatInProgressTotalTimeSeconds?: number;
    StudentStatCompletedTotalTimeSeconds?: number;
    StudentStatInProgressPercentComplete?: number;
    StudentStatAcsTestPassedFirstTime?: number;
    StudentStatAcsTestUploaded?: number;
    StudentStatAcsTestPassed?: number;
    StudentStatAcsAwaitingUpload?: number;
    StudentStatPastDueAssignments?: number;
    StudentStatProgressDaysLearningLastActivity?: number;
    StudentStatProgressPercentPerDayLastActivity?: number;
    StudentStatLearningTimePerDayLastActivity?: number;
    StudentStatProgressDaysLearningNow?: number;
    StudentStatProgressPercentPerDayNow?: number;
    StudentStatLearningTimePerDayNow?: number;
    StudentStatFirstName?: string;
    StudentStatLastName?: string;
    StudentStatMediaPath?: string;
    StudentStatCreatedDateTime?: string;
    StudentStatStudentCourseId?: number;
    StudentStatAcsTestAverageScore?: number;
    StudentStatHideInReporting?: boolean;

    // Relations
    FlightSchool? : FlightSchoolEntity;
    InstructorStatus? : InstructorStatusEntity;
    DwUser? : DwUserEntity;
    Assignment? : AssignmentEntity[];
    FlightSchoolInstructor? : FlightSchoolInstructorEntity[];
    InstructorStudent? : InstructorStudentEntity[];
    RoInstructorAssignmentsPerWeek? : RoInstructorAssignmentsPerWeekEntity[];
    RoStudentCourseInstructor? : RoStudentCourseInstructorEntity[];
    StudentCourseLockInstructor? : StudentCourseLockInstructorEntity[];
}

/** Entity for Query Meaning Users-Manage-Users-Course-Progress-Grid  */
export interface UsersManageUsersCourseProgressGridQueryEntity extends DwOrmData {
    // Attributes
    AlternateName?: string;
    CreatedBy?: number;
    CreatedByDisplay?: string;
    CreatedDateTime?: string;
    Email?: string;
    FirstName?: string;
    ForcePasswordChange?: boolean;
    IsActive?: boolean;
    IsEmailVerified?: boolean;
    IsTwoFactorAuthenticationEnabled?: boolean;
    LastLoginDateTime?: string;
    LastName?: string;
    LastPasswordChangeDateTime?: string;
    MobilePhone?: string;
    ModifiedBy?: number;
    ModifiedByDisplay?: string;
    ModifiedDateTime?: string;
    OrganizationId?: number;
    OrganizationIdDisplay?: string;
    PartyReferenceId?: number;
    PartyReferenceIdDisplay?: string;
    TwoFactorAuthenticationTypeId?: number;
    TwoFactorAuthenticationTypeIdDisplay?: string;
    UserBackgroundMediaId?: number;
    UserBackgroundMediaIdDisplay?: string;
    UserId?: number;
    UserKey?: string;
    UserName?: string;
    UserPictureMediaId?: number;
    UserPictureMediaIdDisplay?: string;
    UserTypeId?: number;
    UserTypeIdDisplay?: string;
    Password?: number;
    Roles?: string;
    UserDetailUserDetailId?: number;
    UserDetailFlightSchoolId?: number;
    UserDetailFlightSchoolIdDisplay?: string;
    UserDetailUserId?: number;
    UserDetailUserIdDisplay?: string;
    StudentStudentId?: number;
    Groups?: string;
    Courses?: string;
    AssignmentInstructor?: string;
    StudentCourseStudentCourseId?: number;
    StudentCourseStudentId?: number;
    StudentCourseStudentIdDisplay?: string;
    StudentCourseCourseId?: number;
    StudentCourseCourseIdDisplay?: string;
    StudentCourseIsActive?: boolean;
    StudentCoursePercentComplete?: number;
    StudentCourseModulesCompleted?: number;
    StudentCourseModulesCount?: number;
    StudentCourseLastActivityDateTime?: string;
    StudentCourseLessonsCompleted?: number;
    StudentCourseLessonCount?: number;
    StudentCourseTotalTimeSeconds?: number;
    StudentCourseFirstActivityDateTime?: string;
    StudentCourseCompletedDateTime?: string;
    StudentCourseCreatedBy?: number;
    StudentCourseCreatedByDisplay?: string;
    StudentCourseCreatedDateTime?: string;
    StudentCourseModifiedBy?: number;
    StudentCourseModifiedByDisplay?: string;
    StudentCourseModifiedDateTime?: string;
    StudentCourseStudentCourseStatusId?: number;
    StudentCourseStudentCourseStatusIdDisplay?: string;
    StudentCourseIsEndorsed?: boolean;
    StudentCourseTotalVideoTimeSeconds?: number;
    StudentCourseTotalQuizTimeSeconds?: number;
    StudentCourseNextCourseLessonId?: number;
    StudentCourseNextCourseLessonIdDisplay?: string;
    StudentCourseAcsTestPassedFirstTime?: boolean;
    StudentCourseAcsTestUploaded?: boolean;
    StudentCourseAcsTestPassed?: boolean;
    StudentCourseHideInReporting?: boolean;
    StudentCourseAcsTestLastScore?: number;
    StudentCourseProgressStatusStudentCourseProgressStatusId?: number;
    StudentCourseProgressStatusProgressStatusKey?: string;
    StudentCourseProgressStatusProgressStatusName?: string;
    StudentCourseProgressStatusProgressStatusCssClass?: string;
    StudentCourseProgressStatusSortOrder?: number;
    DwroMediaMediaPath?: string;
    RoUserRoleDetailIsStudent?: boolean;
    RoUserRoleDetailIsInstructor?: boolean;
    RoUserRoleDetailIsLeadInstructor?: boolean;
    RoUserRoleDetailIsFlightSchoolAdmin?: boolean;
    RoUserRoleDetailIsFlightSchool?: boolean;

    // Relations
    UserPictureDwMedia? : DwMediaEntity;
    UserBackgroundDwMedia? : DwMediaEntity;
    DwUserType? : DwUserTypeEntity;
    CourseAvailabilityNotification? : CourseAvailabilityNotificationEntity[];
    ModifiedByCourseLessonFlag? : CourseLessonFlagEntity[];
    CreatedByCourseLessonFlag? : CourseLessonFlagEntity[];
    CoursePurchaseReservationCourse? : CoursePurchaseReservationCourseEntity[];
    LimitToDiscount? : DiscountEntity[];
    DiscountUsageUser? : DiscountUsageUserEntity[];
    FlightSchoolBillingContact? : FlightSchoolBillingContactEntity[];
    Instructor? : InstructorEntity;
    IntegrationUser? : IntegrationUserEntity[];
    Invoice? : InvoiceEntity[];
    JoinRequestCoursePurchase? : JoinRequestCoursePurchaseEntity[];
    JoinRequestEmail? : JoinRequestEmailEntity[];
    ProcessorConfig? : ProcessorConfigEntity[];
    ChangedByProcessorConfigCustomerHistory? : ProcessorConfigCustomerHistoryEntity[];
    AffiliateProfitShare? : ProfitShareEntity[];
    RoStudentOverviewDetails? : RoStudentOverviewDetailsEntity;
    RoStudentPaymentMethod? : RoStudentPaymentMethodEntity[];
    RoStudentSchoolCourses? : RoStudentSchoolCoursesEntity[];
    RoUserRoleDetail? : RoUserRoleDetailEntity;
    Student? : StudentEntity;
    ActorStudentActivity? : StudentActivityEntity[];
    ResetByStudentProgressResetEvent? : StudentProgressResetEventEntity[];
    UserDetail? : UserDetailEntity;
    UserDocumentSectionFavorite? : UserDocumentSectionFavoriteEntity[];
    DwUserRole? : DwUserRoleEntity[];
    UserSubscriptionRole? : UserSubscriptionRoleEntity[];
}

/** Entity for Query Meaning Document_Item-Student_Acknowledgement  */
export interface DocumentItemStudentAcknowledgementQueryEntity extends DwOrmData {
    // Attributes
    DocumentItemId?: number;
    DocumentGroupId?: number;
    DocumentGroupIdDisplay?: string;
    DocumentItemName?: string;
    MediaId?: number;
    MediaIdDisplay?: string;
    CardIconMediaId?: number;
    CardIconMediaIdDisplay?: string;
    DocumentTypeId?: number;
    DocumentTypeIdDisplay?: string;
    DocumentItemStatusId?: number;
    DocumentItemStatusIdDisplay?: string;
    EmbeddedMarkup?: string;
    ExtractedImageMediaId?: number;
    ExtractedImageMediaIdDisplay?: string;
    UseCustomCardIcon?: boolean;
    DocumentOwnershipTypeId?: number;
    DocumentOwnershipTypeIdDisplay?: string;
    FlightSchoolId?: number;
    FlightSchoolIdDisplay?: string;
    ParentDocumentFolderId?: number;
    ParentDocumentFolderIdDisplay?: string;
    RequireStudentAcknowledgement?: boolean;
    CreatedBy?: number;
    CreatedByDisplay?: string;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedByDisplay?: string;
    ModifiedDateTime?: string;
    AiProcessingReferenceId?: number;
    DocumentFileHash?: string;
    DocumentAiComplete?: boolean;
    DocumentAiProcessingStatusId?: number;
    DocumentAiProcessingStatusIdDisplay?: string;
    DocumentAiProcessingProgressText?: string;
    DocumentAiProcessingErrorText?: string;
    DocumentAiProcessingStartDateTime?: string;
    DocumentAiProcessingCompletedDateTime?: string;
    DocumentAiProcessingLastUpdatedDateTime?: string;
    DocumentAiProcessingEstimatedCompletedDateTime?: string;
    DocumentAiProcessingTotalChunkCount?: number;
    DocumentAiProcessingProcessedChunkCount?: number;
    DocumentAiProcessingFailedChunkCount?: number;
    DocumentAiProcessingTotalModuleLinkCount?: number;
    DocumentAiProcessingProcessedModuleLinkCount?: number;
    DocumentAiProcessingFailedModuleLinkCount?: number;
    DocumentItemAcknowledgementStudentId?: number;
    DocumentItemAcknowledgementStudentIdDisplay?: string;
    DocumentItemAcknowledgementAcknowledgedDateTime?: string;
    DocumentItemAcknowledgementDocumentItemId?: number;
    DocumentItemAcknowledgementDocumentItemIdDisplay?: string;
    DocumentItemAcknowledgementDocumentItemAcknowledgementId?: number;

    // Relations
    DocumentAiProcessingStatus? : DocumentAiProcessingStatusEntity;
    ParentDocumentFolder? : DocumentFolderEntity;
    DocumentGroup? : DocumentGroupEntity;
    DocumentItemStatus? : DocumentItemStatusEntity;
    DocumentOwnershipTypeIdDocumentOwnerType? : DocumentOwnerTypeEntity;
    DocumentType? : DocumentTypeEntity;
    FlightSchool? : FlightSchoolEntity;
    DwMedia? : DwMediaEntity;
    CardIconDwMedia? : DwMediaEntity;
    ExtractedImageDwMedia? : DwMediaEntity;
    CourseDocumentItem? : CourseDocumentItemEntity[];
    CourseLesson? : CourseLessonEntity[];
    CourseLessonDocumentLink? : CourseLessonDocumentLinkEntity[];
    DocumentItemAcknowledgement? : DocumentItemAcknowledgementEntity[];
    DocumentItemChangeLog? : DocumentItemChangeLogEntity[];
    DocumentItemChunk? : DocumentItemChunkEntity[];
    DocumentItemPage? : DocumentItemPageEntity[];
    DocumentLinkProcessingRun? : DocumentLinkProcessingRunEntity[];
    DocumentPublication? : DocumentPublicationEntity[];
    UserDocumentSectionFavorite? : UserDocumentSectionFavoriteEntity[];
}

/** Entity for Query Meaning Manage_Users  */
export interface ManageUsersQueryEntity extends DwOrmData {
    // Attributes
    AlternateName?: string;
    CreatedBy?: number;
    CreatedByDisplay?: string;
    CreatedDateTime?: string;
    Email?: string;
    FirstName?: string;
    ForcePasswordChange?: boolean;
    IsActive?: boolean;
    IsEmailVerified?: boolean;
    IsTwoFactorAuthenticationEnabled?: boolean;
    LastLoginDateTime?: string;
    LastName?: string;
    LastPasswordChangeDateTime?: string;
    MobilePhone?: string;
    ModifiedBy?: number;
    ModifiedByDisplay?: string;
    ModifiedDateTime?: string;
    OrganizationId?: number;
    OrganizationIdDisplay?: string;
    PartyReferenceId?: number;
    PartyReferenceIdDisplay?: string;
    TwoFactorAuthenticationTypeId?: number;
    TwoFactorAuthenticationTypeIdDisplay?: string;
    UserBackgroundMediaId?: number;
    UserBackgroundMediaIdDisplay?: string;
    UserId?: number;
    UserKey?: string;
    UserName?: string;
    UserPictureMediaId?: number;
    UserPictureMediaIdDisplay?: string;
    UserTypeId?: number;
    UserTypeIdDisplay?: string;
    Password?: number;
    Roles?: string;
    UserFullName?: string;
    UserDetailUserDetailId?: number;
    UserDetailFlightSchoolId?: number;
    UserDetailFlightSchoolIdDisplay?: string;
    UserDetailUserId?: number;
    UserDetailUserIdDisplay?: string;
    StudentStudentId?: number;
    Groups?: string;
    Courses?: string;
    AssignmentInstructor?: string;
    DwroMediaMediaPath?: string;
    RoUserRoleDetailIsStudent?: boolean;
    RoUserRoleDetailIsInstructor?: boolean;
    RoUserRoleDetailIsLeadInstructor?: boolean;
    RoUserRoleDetailIsFlightSchoolAdmin?: boolean;
    RoUserRoleDetailIsFlightSchool?: boolean;

    // Relations
    UserPictureDwMedia? : DwMediaEntity;
    UserBackgroundDwMedia? : DwMediaEntity;
    DwUserType? : DwUserTypeEntity;
    CourseAvailabilityNotification? : CourseAvailabilityNotificationEntity[];
    ModifiedByCourseLessonFlag? : CourseLessonFlagEntity[];
    CreatedByCourseLessonFlag? : CourseLessonFlagEntity[];
    CoursePurchaseReservationCourse? : CoursePurchaseReservationCourseEntity[];
    LimitToDiscount? : DiscountEntity[];
    DiscountUsageUser? : DiscountUsageUserEntity[];
    FlightSchoolBillingContact? : FlightSchoolBillingContactEntity[];
    Instructor? : InstructorEntity;
    IntegrationUser? : IntegrationUserEntity[];
    Invoice? : InvoiceEntity[];
    JoinRequestCoursePurchase? : JoinRequestCoursePurchaseEntity[];
    JoinRequestEmail? : JoinRequestEmailEntity[];
    ProcessorConfig? : ProcessorConfigEntity[];
    ChangedByProcessorConfigCustomerHistory? : ProcessorConfigCustomerHistoryEntity[];
    AffiliateProfitShare? : ProfitShareEntity[];
    RoStudentOverviewDetails? : RoStudentOverviewDetailsEntity;
    RoStudentPaymentMethod? : RoStudentPaymentMethodEntity[];
    RoStudentSchoolCourses? : RoStudentSchoolCoursesEntity[];
    RoUserRoleDetail? : RoUserRoleDetailEntity;
    Student? : StudentEntity;
    ActorStudentActivity? : StudentActivityEntity[];
    ResetByStudentProgressResetEvent? : StudentProgressResetEventEntity[];
    UserDetail? : UserDetailEntity;
    UserDocumentSectionFavorite? : UserDocumentSectionFavoriteEntity[];
    DwUserRole? : DwUserRoleEntity[];
    UserSubscriptionRole? : UserSubscriptionRoleEntity[];
}

/** Entity for Query Meaning Assignment_Student-Grid  */
export interface AssignmentStudentGridQueryEntity extends DwOrmData {
    // Attributes
    AssignmentStudentId?: number;
    AssignmentId?: number;
    AssignmentIdDisplay?: string;
    StudentId?: number;
    StudentIdDisplay?: string;
    PercentComplete?: number;
    CompletedDateTime?: string;
    CreatedBy?: number;
    CreatedByDisplay?: string;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedByDisplay?: string;
    ModifiedDateTime?: string;
    Acknowledged?: boolean;
    AcknowledgedDateTime?: string;
    AiPromptRequestId?: number;
    AiPromptRequestIdDisplay?: string;
    ShowAISummary?: boolean;
    AssignmentAssignmentId?: number;
    AssignmentCourseId?: number;
    AssignmentCourseIdDisplay?: string;
    AssignmentAssignmentDescription?: string;
    AssignmentAssignedDateTime?: string;
    AssignmentDueDateTime?: string;
    AssignmentCompletedDateTime?: string;
    AssignmentAssignmentTypeId?: number;
    AssignmentAssignmentTypeIdDisplay?: string;
    AssignmentAssignmentStatusId?: number;
    AssignmentAssignmentStatusIdDisplay?: string;
    AssignmentAssignmentLinkUrl?: string;
    AssignmentFlightSchoolGroupId?: number;
    AssignmentFlightSchoolGroupIdDisplay?: string;
    AssignmentFlightSchoolId?: number;
    AssignmentFlightSchoolIdDisplay?: string;
    Lessons?: string;
    RoAssignmentStudentCompletedDetailsCompletedOnTime?: boolean;

    // Relations
    AiPromptRequestIdAIPromptRequest? : AIPromptRequestEntity;
    Assignment? : AssignmentEntity;
    Student? : StudentEntity;
    AIPromptRequest? : AIPromptRequestEntity[];
    RoAssignmentStudentCompletedDetails? : RoAssignmentStudentCompletedDetailsEntity;
    RoAssignmentStudentCourseLessonProgress? : RoAssignmentStudentCourseLessonProgressEntity[];
    RoSchoolAssignmentStatsAssignmentId? : RoSchoolAssignmentStatsEntity[];
    StudentProgressResetEvent? : StudentProgressResetEventEntity[];
}

/** Entity for Query Meaning Assignment-With_Student-Grid  */
export interface AssignmentWithStudentGridQueryEntity extends DwOrmData {
    // Attributes
    AssignmentId?: number;
    CourseId?: number;
    CourseIdDisplay?: string;
    AssignmentDescription?: string;
    AssignmentTypeId?: number;
    AssignmentTypeIdDisplay?: string;
    AssignmentStatusId?: number;
    AssignmentStatusIdDisplay?: string;
    AssignmentLinkUrl?: string;
    MediaId?: number;
    DueDateTime?: string;
    FlightSchoolGroupId?: number;
    FlightSchoolGroupIdDisplay?: string;
    AssignedDateTime?: string;
    CompletedDateTime?: string;
    FlightSchoolId?: number;
    FlightSchoolIdDisplay?: string;
    ResetLessonProgress?: boolean;
    UseGroupAssignment?: boolean;
    InstructorId?: number;
    InstructorIdDisplay?: string;
    CreatedBy?: number;
    CreatedByDisplay?: string;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedByDisplay?: string;
    ModifiedDateTime?: string;
    Students?: string;
    RoAssignmentStudentStatActivePercent?: number;
    RoAssignmentStudentStatAssignmentId?: number;
    RoAssignmentStudentStatAssignmentIdDisplay?: string;
    RoAssignmentStudentStatCompletedPercent?: number;
    RoAssignmentStudentStatIncompletePercent?: number;
    RoAssignmentStudentStatPastDuePercent?: number;
    RoAssignmentStudentStatStudentActiveCount?: number;
    RoAssignmentStudentStatStudentCompleteCount?: number;
    RoAssignmentStudentStatStudentCount?: number;
    RoAssignmentStudentStatStudentIncompleteCount?: number;
    RoAssignmentStudentStatStudentPastDueCount?: number;

    // Relations
    AssignmentStatus? : AssignmentStatusEntity;
    AssignmentType? : AssignmentTypeEntity;
    Course? : CourseEntity;
    FlightSchool? : FlightSchoolEntity;
    FlightSchoolGroup? : FlightSchoolGroupEntity;
    Instructor? : InstructorEntity;
    DwMedia? : DwMediaEntity;
    AssignmentCourseLesson? : AssignmentCourseLessonEntity[];
    AssignmentStudent? : AssignmentStudentEntity[];
    AssignmentIdRoAssignmentStudentCourseLessonProgress? : RoAssignmentStudentCourseLessonProgressEntity[];
    RoAssignmentStudentStat? : RoAssignmentStudentStatEntity[];
    StudentProgressResetEvent? : StudentProgressResetEventEntity[];
}

/** Entity for Query Meaning Course_Module_Document-With_AI_Processing_Status  */
export interface CourseModuleDocumentWithAIProcessingStatusQueryEntity extends DwOrmData {
    // Attributes
    CourseModuleDocumentItemId?: number;
    CourseModuleId?: number;
    CourseModuleIdDisplay?: string;
    CourseDocumentItemId?: number;
    CourseDocumentItemIdDisplay?: string;
    AiProcessingReferenceId?: number;
    AiProcessingReferenceIdDisplay?: string;
    CourseModuleDocumentItemStatusId?: number;
    CourseModuleDocumentItemStatusIdDisplay?: string;
    AiProcessingReferenceIdAIProcessingReferenceAIProcessingStatusId?: number;
    AiProcessingReferenceIdAIProcessingReferenceAIProcessingStatusIdDisplay?: string;

    // Relations
    AiProcessingReferenceIdAIProcessingReference? : AIProcessingReferenceEntity;
    CourseDocumentItem? : CourseDocumentItemEntity;
    CourseModule? : CourseModuleEntity;
    CourseModuleDocumentItemStatusIdReferenceStatus? : ReferenceStatusEntity;
}

/** Entity for Query Meaning Standard_Login_Media-with_Media_Path  */
export interface StandardLoginMediaWithMediaPathQueryEntity extends DwOrmData {
    // Attributes
    StandardLoginMediaId?: number;
    LoginMediaName?: string;
    MediaId?: number;
    ReferenceStatusId?: number;
    IsDefault?: boolean;
    DwroMediaMediaName?: string;
    DwroMediaMediaPath?: string;
    DwroMediaImageWidth?: number;
    DwroMediaImageHeight?: number;

    // Relations
    DwroMedia? : DwRoMediaEntity;
    DwMedia? : DwMediaEntity;
    ReferenceStatus? : ReferenceStatusEntity;
    FlightSchoolBranding? : FlightSchoolBrandingEntity[];
}

    // Lookup Value Enums  {
export enum QuizResultStatusAllItems {
        Incomplete = 1,
        CompleteUngraded = 2,
        Passed = 3,
        Failed = 4,
        Deleted = 5,
    }

export enum VideoStatusAllItems {
        Uploading = 1,
        Encoding = 2,
        Active = 3,
        Deleted = 4,
    }

export enum FlightSchoolStatusAllItems {
        Submitted = 1,
        Active = 2,
        Inactive = 3,
        Rejected = 4,
    }

export enum QuestionStatusAllItems {
        Draft = 1,
        Active = 2,
        Inactive = 3,
        Deleted = 4,
    }

export enum AssignmentStatusAllItems {
        Active = 1,
        Completed = 2,
        Cancelled = 3,
        Deleted = 4,
    }

export enum JoinRequestStatusAllItems {
        Pending = 1,
        Completed = 2,
        Deleted = 3,
    }

export enum InstructorStatusAllItems {
        Active = 1,
        Inactive = 2,
    }

export enum CourseLessonFlagStatusAllItems {
        New = 1,
        Complete = 2,
        Reviewed = 3,
    }

export enum ReferenceStatusAllItems {
        Active = 1,
        Inactive = 2,
        Deleted = 3,
    }

export enum SubdomainSetupStatusAllItems {
        New = 1,
        InProgress = 2,
        Completed = 3,
    }

export enum SubscriptionTierStatusAllItems {
        Active = 1,
        Inactive = 2,
    }

export enum SubscriptionStatusAllItems {
        Active = 1,
        Inactive = 2,
        Future = 3,
    }

export enum IntegrationOrganizationStatusAllItems {
        Active = 1,
        Disabled = 2,
    }

export enum IntegrationUserStatusAllItems {
        Active = 1,
        Disabled = 2,
        Pending = 3,
    }

export enum ProfitShareStatusAllItems {
        Unpaid = 1,
        Paid = 2,
        Failed = 3,
        PendingInvoicePayment = 4,
        RemovedPaymentFailed = 5,
        PaidInvoiceReduction = 6,
        Refunded = 7,
    }

export enum InvoiceStatusAllItems {
        New = 1,
        Failed = 2,
        Paid = 3,
        Deleted = 4,
        Reprocess = 5,
        Refunded = 6,
        PayoutComplete = 7,
        PayoutFailed = 8,
        AwaitingPayment = 9,
    }

export enum IntegrationUserEventStatusAllItems {
        New = 1,
        Success = 2,
        FailedRetry = 3,
        FailedPermanent = 4,
    }

export enum ModificationHistoryStatusAllItems {
        New = 1,
        DuplicateUpdateIgnoring = 2,
        Success = 3,
        InProgress = 4,
        Failed = 5,
    }

export enum ModificationHistoryStudentStatusAllItems {
        New = 1,
        FailedRetry = 2,
        FailedPermanent = 3,
        Success = 4,
        SuccessNoChanges = 5,
    }

export enum AcsTestStatusAllItems {
        Active = 1,
        Expired = 2,
        Deleted = 3,
    }

export enum AcsWrittenTestStatusAllItems {
        Processing = 1,
        FailedInvalid = 2,
        Success = 3,
        Deleted = 4,
        New = 5,
    }

export enum PaymentEventStatusAllItems {
        New = 1,
        Processing = 2,
        Success = 3,
        Failed = 4,
    }

export enum StripeCheckoutSessionStatusAllItems {
        New = 1,
        Processing = 2,
        Success = 3,
        Failed = 4,
        Unmatched = 5,
        SuccessCoursesPreviouslyAdded = 6,
    }

export enum StudentModuleSummaryStatusAllItems {
        Processing = 1,
        Failed = 2,
        Complete = 3,
        Deleted = 4,
    }

export enum AIPromptRequestStatusAllItems {
        New = 1,
        Processing = 2,
        Success = 3,
        Failed = 4,
        Deleted = 5,
    }

export enum AiPromptSetupStatusAllItems {
        Active = 1,
        Inactive = 2,
        Deleted = 3,
    }

export enum IntegrationCoursePurchaseRequestStatusAllItems {
        New = 1,
        Processed = 2,
        Complete = 3,
    }

export enum QuestionAIProcessingStatusAllItems {
        New = 1,
        Processing = 2,
        Reprocess = 3,
        Success = 4,
        Failed = 5,
    }

export enum DocumentItemStatusAllItems {
        Active = 1,
        Inactive = 2,
    }

export enum AIProcessingReferenceStatusAllItems {
        New = 1,
        Processing = 2,
        Success = 3,
        Failed = 4,
        Reprocess = 5,
        Hold = 6,
    }

export enum DocumentAiProcessingStatusAllItems {
        New = 1,
        ReprocessRequested = 2,
        ExtractingPagesAndChunks = 3,
        FailedExtractingPagesAndChunks = 4,
        ProcessingDocumentChunks = 5,
        FailedProcessingDocumentChunks = 6,
        ProcessingModuleDocumentLinks = 7,
        FailedProcessingModuleDocumentLinks = 8,
        Complete = 9,
        Hold = 10,
    }

export enum CourseDocumentProcessingStatusAllItems {
        New = 1,
        Queued = 2,
        ProcessingModules = 3,
        Complete = 4,
        Failed = 5,
        ReprocessRequested = 6,
    }

export enum VideoProcessingStatusAllItems {
        New = 1,
        Encoding = 2,
        EncodingComplete = 3,
        Transcribing = 4,
        TranscribingComplete = 5,
        DescriptionProcessing = 6,
        Complete = 7,
    }

export enum DocumentImportJobStatusAllItems {
        New = 1,
        Running = 2,
        Complete = 3,
        Failed = 4,
    }

export enum StudentCourseProgressStatusAllItems {
        NotStarted = 1,
        InProgress = 2,
        Complete = 3,
        EndorsedWaitingForAcs = 4,
        AcsFailed = 5,
        AcsPassed = 6,
    }

export enum DocumentLinkProcessingRunItemStatusAllItems {
        Pending = 1,
        DirectLinked = 2,
        AIQueued = 3,
        AIProcessing = 4,
        AILinked = 5,
        SkippedActive = 6,
        SkippedDisabled = 7,
        NoMatch = 8,
        Failed = 9,
        OnHold = 10,
    }

export enum DocumentLinkProcessingRunStatusAllItems {
        Queued = 1,
        Processing = 2,
        WaitingForAI = 3,
        Complete = 4,
        CompleteWithErrors = 5,
        Failed = 6,
        Cancelled = 7,
    }

export enum JoinRequestCourseFulfillmentStatusAllItems {
        Pending = 1,
        Fulfilled = 2,
        AlreadyAssigned = 3,
        Failed = 4,
        Cancelled = 5,
        LegacyUnknown = 6,
    }

export enum JoinRequestCoursePurchaseStatusAllItems {
        Pending = 1,
        Invoiced = 2,
        Failed = 3,
        Refunded = 4,
        LegacyUnverified = 5,
        NoCharge = 6,
    }

export enum CoursePurchaseReservationStatusAllItems {
        Reserved = 1,
        BillingPrepared = 2,
        BillingCommitted = 3,
        Fulfilled = 4,
        RetryPending = 5,
        ReviewRequired = 6,
        Released = 7,
    }

export enum CoursePurchaseBillingAttemptStatusAllItems {
        Pending = 1,
        Succeeded = 2,
        ConfirmedFailure = 3,
        OutcomeUnknown = 4,
    }

// Excluding lookup Meta Data Item (group by database) because it contains 504 items which exceeds the max item setting of 100.  Override in cli config for code gen using ExcludeLookupsMaxCount
// Excluding lookup MediaGroup All Items because it contains 1000 items which exceeds the max item setting of 100.  Override in cli config for code gen using ExcludeLookupsMaxCount
export enum FlightSchoolGroupAllItems {
        PrivateGroundSummer2024 = 1,
        FallSemester2024FullTrack = 2,
        APGGroup1 = 3,
        AntonySFlightSchoolGroup1 = 4,
        SummerSemester2026 = 5,
        Test2 = 6,
        Summer2026 = 7,
        Fall2026 = 8,
        Test = 9,
        AviatorProGroup = 10,
    }

export enum FlightSchoolGroupStudentAllItems {
        FlightSchoolGroupStudentId3 = 3,
        FlightSchoolGroupStudentId5 = 5,
        FlightSchoolGroupStudentId6 = 6,
        FlightSchoolGroupStudentId14 = 14,
        FlightSchoolGroupStudentId15 = 15,
        FlightSchoolGroupStudentId16 = 16,
        FlightSchoolGroupStudentId17 = 17,
        FlightSchoolGroupStudentId19 = 19,
        FlightSchoolGroupStudentId20 = 20,
        FlightSchoolGroupStudentId23 = 23,
        FlightSchoolGroupStudentId24 = 24,
        FlightSchoolGroupStudentId27 = 27,
        FlightSchoolGroupStudentId28 = 28,
        FlightSchoolGroupStudentId29 = 29,
        FlightSchoolGroupStudentId31 = 31,
        FlightSchoolGroupStudentId32 = 32,
        FlightSchoolGroupStudentId34 = 34,
        FlightSchoolGroupStudentId35 = 35,
        FlightSchoolGroupStudentId36 = 36,
        FlightSchoolGroupStudentId37 = 37,
        FlightSchoolGroupStudentId38 = 38,
        FlightSchoolGroupStudentId39 = 39,
        FlightSchoolGroupStudentId41 = 41,
    }

export enum FlightSchoolGroupStudentBySchool {
    }

export enum FlightSchoolGroupBySchool {
    }

export enum DocumentGroupAllItems {
        Documents = 1,
        ProTools = 2,
        FARAIM = 3,
    }

export enum UserTypeAllItems {
        Student = 1,
        FlightSchool = 2,
        AviatorOnlineAdmin = 3,
        FlightInstructor = 4,
    }

export enum CourseTypeAllItems {
        Curriculum = 1,
        AircraftSpecific = 7,
    }

export enum ProgramTypeAllItems {
        Num61 = 1,
        Num141 = 2,
        Num135 = 3,
        Num91 = 4,
        Num121 = 5,
        Num91K = 6,
    }

export enum AircraftTypeAllItems {
        Cessna172Skyhawk = 1,
        PiperArcherII = 2,
        PiperArcherIII = 3,
        PiperWarrior = 4,
        PiperCherokee = 5,
        PiperArrow = 7,
        PiperSeminole = 8,
        VansRV9A = 9,
    }

export enum LessonTypeAllItems {
        Video = 1,
        Quiz = 2,
        ProTools = 3,
    }

export enum QuizTypeAllItems {
        Quiz = 1,
        CourseFinal = 2,
        ModuleFinal = 3,
    }

export enum QuestionTypeAllItems {
        TrueOrFalse = 1,
        MultipleChoice = 2,
        MultipleAnswer = 3,
    }

export enum AssignmentTypeAllItems {
        Lesson = 1,
        Link = 2,
        FilePDF = 3,
        Text = 4,
    }

export enum JoinRequestTypeRoleAllItems {
        JoinRequestTypeRoleId1 = 1,
        JoinRequestTypeRoleId2 = 2,
    }

export enum JoinRequestTypeAllItems {
        StudentRequest = 1,
        FlightInstructor = 2,
        FlightSchoolAdmin = 3,
    }

export enum TemplateFieldTypeAllItems {
        Field = 1,
        Text = 2,
        Image = 3,
    }

export enum CourseLessonFlagTypeAllItems {
        LessonFlag = 1,
        QuestionFlag = 2,
    }

export enum ThemePropertyTypeAllItems {
        Color = 1,
        Text = 2,
        Length = 3,
    }

export enum SubdomainTypeAllItems {
        NotSetup = 1,
        SubdomainAviatorProCom = 2,
        FullDomain = 3,
    }

export enum ProductTypeAllItems {
        Course = 1,
        Package = 2,
        SubscriptionTier = 3,
    }

export enum PaymentPartyTypeAllItems {
        Student = 1,
        FlightSchool = 2,
    }

export enum ProfitShareTypeAllItems {
        SchoolInvoiceReduction = 1,
        Affiliate = 2,
        SchoolPayout = 3,
    }

export enum InvoiceTypeAllItems {
        SchoolCourse = 1,
        SchoolSubscriptionPreviousMonth = 2,
        SchoolProfitSharing = 3,
        StudentCourse = 4,
        SchoolSubscriptionPrepaid = 5,
        StudentCoursePaymentLink = 6,
        SchoolCourseDeferred = 7,
        SchoolCourseUniversity = 8,
        SchoolCourseDeferredSubscriptionCourse = 9,
    }

export enum JoinRequestTypeSubscriptionRoleAllItems {
        JoinRequestTypeSubscriptionRoleId1 = 1,
        JoinRequestTypeSubscriptionRoleId2 = 2,
    }

export enum IntegrationEventTypeAllItems {
        CoursePurchased = 1,
        CourseEndorsed = 2,
        CourseComplete = 3,
        CompanyEnable = 4,
        CompanyDisable = 5,
        StudentEnable = 6,
        StudentDisable = 7,
        LessonComplete = 8,
    }

export enum AcsCodeTypeAllItems {
        Knowledge = 1,
        RiskManagement = 2,
        Skills = 3,
    }

export enum PaymentEventTypeAllItems {
        Unknown = 1,
        CheckoutSession = 2,
    }

export enum AIPromptResultTypeAllItems {
        HTML = 1,
        Text = 2,
        JSON = 3,
    }

export enum AiPromptRequestTypeAllItems {
    }

export enum AIPromptTypeAllItems {
        ModuleSummary = 1,
        AssignmentSummary = 2,
        QuestionExplanation = 3,
        ACSWrittenTestExtraction = 4,
        LessonAIOverview = 5,
        ModuleAIOverview = 6,
        DocumentAILessonLinking = 7,
    }

export enum AIPromptTokenTypeAllItems {
        CourseDetails = 1,
        CourseProgress = 2,
        QuizSummaries = 3,
        AssignmentDetails = 4,
        AssignmentStudentDetails = 5,
    }

export enum DocumentTypeAllItems {
        PDFDocument = 1,
        SketchFab3D = 2,
        FARAIM = 3,
    }

export enum DocumentOwnerTypeAllItems {
        AviatorPro = 1,
        FlightSchool = 2,
    }

export enum DocumentChangeLogTypeAllItems {
        Created = 1,
        Renamed = 2,
        Deleted = 3,
        FileReplaced = 4,
        Moved = 5,
        AcknowledgementChanged = 6,
    }

export enum DocumentItemChunkContentTypeAllItems {
        Instructional = 1,
        FrontMatter = 2,
        ReferenceMatter = 3,
        IndexGlossary = 4,
        AppendixStructural = 5,
        OtherStructural = 6,
    }

export enum PilotTypeAllItems {
        StudentPilot = 1,
        PrivatePilot = 2,
        Instrument = 3,
        Commercial = 4,
        CFIInstructor = 5,
        ATPAirline = 6,
        FlightSchool = 7,
        Other = 8,
    }

export enum DocumentSectionTypeAllItems {
        Title = 1,
        Chapter = 2,
        Subchapter = 3,
        Part = 4,
        Subpart = 5,
        Section = 6,
        Appendix = 7,
        Paragraph = 8,
        SubjectGroup = 9,
    }

export enum DocumentContentFormatTypeAllItems {
        BlockJsonV1 = 1,
    }

export enum DocumentAssetTypeAllItems {
        Image = 1,
        FigureImage = 2,
    }

export enum DocumentAnchorTypeAllItems {
        Section = 1,
        Paragraph = 2,
        Figure = 3,
        Table = 4,
        Note = 5,
    }

export enum DocumentImportJobTypeAllItems {
        FullImport = 1,
        IncrementalImport = 2,
        RebuildContent = 3,
    }

export enum DocumentPublicationTypeAllItems {
        FAR = 1,
        AIM = 2,
    }

export enum DocumentVersionTypeAllItems {
        Imported = 1,
        ManualDraft = 2,
        Archived = 3,
    }

export enum StudentActivityTypeAllItems {
        AccountCreated = 1,
        CourseAssigned = 2,
        InstructorAdded = 3,
        InstructorRemoved = 4,
        GroupAdded = 5,
        GroupRemoved = 6,
        AssignmentDueDateSet = 7,
        AssignmentAssigned = 8,
        ProfileFieldUpdated = 9,
        StudentStartedCourse = 10,
        StudentEndorsed = 11,
        WrittenUploaded = 12,
        RemovedFromSchool = 13,
        SchoolChanged = 14,
        CourseProgressReset = 15,
    }

export enum DocumentLinkProcessingTriggerTypeAllItems {
        DocumentLinked = 1,
        Manual = 2,
        CourseChanged = 3,
        Retry = 4,
    }

export enum DocumentLinkSourceTypeAllItems {
        Deterministic = 1,
        AI = 2,
        Manual = 3,
        Imported = 4,
    }

export enum CourseAssignmentSourceTypeAllItems {
        StudentPurchase = 1,
        JoinRequest = 2,
        SchoolDirectAssignment = 3,
        PaymentLinkStudent = 4,
        IntegrationFSP = 5,
    }

export enum QuizResultTypeAllItems {
        LessonQuiz = 1,
        DailyQuiz = 2,
    }

export enum MetricTypeAllItems {
        ProtectedActivityStreakDays = 1,
        FirstAttemptQuizPassCount = 2,
        PerfectQuizScoreCount = 3,
        CompletedCourseModuleCount = 4,
        CompletedCourseModulePercent = 5,
    }

export enum QuizOutcomeAllItems {
    }

export enum VideoStreamingProviderAllItems {
        BunnyNet = 1,
        ApiVideo = 2,
    }

export enum VideoLibraryByStreamingProvider {
        APProduction = 1,
        PrivatePilot = 2,
        // Duplicate property Name found
        PrivatePilot_3 = 3,
        PerformanceTest = 4,
        DevwareAviatorTest = 5,
        // Duplicate property Name found
        APProduction_6 = 6,
    }

export enum VectorProviderAllItems {
        Pinecone = 1,
    }

export enum AIPromptModelAllItems {
        ChatGPT41 = 1,
        ChatGPT41Mini = 2,
        ChatGPT41Nano = 3,
        ChatGPT5 = 4,
        ChatGPT5Mini = 5,
        ChatGPT5Nano = 6,
        ChatGPT54 = 7,
        ChatGPT54Mini = 8,
        ChatGPT54Nano = 9,
        ChatGPT55 = 10,
        ChatGPT6Luna = 11,
    }

export enum VideoPlaybackAuthenticationModeAllItems {
        Disabled = 1,
        Shadow = 2,
        Enabled = 3,
        Required = 4,
    }

export enum SchoolBillingModeAllItems {
        UniversityBilling = 1,
        DeferredBilling = 2,
        DeferredSubscription = 3,
        AllUpfront = 4,
    }

export enum SubscriptionRoleAllItems {
        Instructor = 2,
        FlightSchoolAdmin = 3,
        FlightSchoolOps = 4,
        LeadInstructor = 5,
    }

export enum UserSubscriptionRoleAllItems {
        UserSubscriptionRoleId54 = 54,
        UserSubscriptionRoleId55 = 55,
        UserSubscriptionRoleId56 = 56,
        UserSubscriptionRoleId57 = 57,
        UserSubscriptionRoleId59 = 59,
        UserSubscriptionRoleId60 = 60,
        UserSubscriptionRoleId62 = 62,
        UserSubscriptionRoleId72 = 72,
        UserSubscriptionRoleId74 = 74,
        UserSubscriptionRoleId75 = 75,
        UserSubscriptionRoleId76 = 76,
        UserSubscriptionRoleId77 = 77,
        UserSubscriptionRoleId78 = 78,
        UserSubscriptionRoleId79 = 79,
        UserSubscriptionRoleId82 = 82,
        UserSubscriptionRoleId83 = 83,
        UserSubscriptionRoleId84 = 84,
        UserSubscriptionRoleId92 = 92,
        UserSubscriptionRoleId93 = 93,
        UserSubscriptionRoleId94 = 94,
        UserSubscriptionRoleId95 = 95,
        UserSubscriptionRoleId96 = 96,
        UserSubscriptionRoleId106 = 106,
        UserSubscriptionRoleId107 = 107,
        UserSubscriptionRoleId108 = 108,
        UserSubscriptionRoleId113 = 113,
        UserSubscriptionRoleId114 = 114,
        UserSubscriptionRoleId115 = 115,
        UserSubscriptionRoleId116 = 116,
        UserSubscriptionRoleId117 = 117,
        UserSubscriptionRoleId118 = 118,
        UserSubscriptionRoleId119 = 119,
        UserSubscriptionRoleId120 = 120,
        UserSubscriptionRoleId121 = 121,
        UserSubscriptionRoleId122 = 122,
        UserSubscriptionRoleId123 = 123,
        UserSubscriptionRoleId124 = 124,
        UserSubscriptionRoleId125 = 125,
        UserSubscriptionRoleId126 = 126,
        UserSubscriptionRoleId127 = 127,
        UserSubscriptionRoleId128 = 128,
        UserSubscriptionRoleId129 = 129,
        UserSubscriptionRoleId130 = 130,
        UserSubscriptionRoleId131 = 131,
        UserSubscriptionRoleId132 = 132,
        UserSubscriptionRoleId133 = 133,
        UserSubscriptionRoleId134 = 134,
        UserSubscriptionRoleId137 = 137,
        UserSubscriptionRoleId138 = 138,
        UserSubscriptionRoleId141 = 141,
        UserSubscriptionRoleId142 = 142,
        UserSubscriptionRoleId143 = 143,
        UserSubscriptionRoleId144 = 144,
        UserSubscriptionRoleId145 = 145,
        UserSubscriptionRoleId146 = 146,
        UserSubscriptionRoleId151 = 151,
        UserSubscriptionRoleId152 = 152,
    }

// Excluding lookup SubscriptionRoleTracking All Items because it contains 1000 items which exceeds the max item setting of 100.  Override in cli config for code gen using ExcludeLookupsMaxCount
export enum DiscountSubscriptionRoleAllItems {
        DiscountSubscriptionRoleId1 = 1,
    }

export enum SubscriptionRoleBySubscriptionTierLookup {
    }

export enum SubscriptionFeatureKeys {
        Assignments = 1,
        WhilteLabeling = 2,
        WhiteLabelingFullDomain = 3,
        ViewCourseProgress = 4,
        ProfitSharing = 5,
        AIModuleSummary = 6,
        UnlimitedCourseAccess = 7,
        MobileWhiteLabeling = 8,
    }

export enum PaymentEventSourceAllItems {
        Stripe = 1,
    }

export enum AcquisitionSourceAllItems {
        GoogleSearch = 1,
        ChatGPT = 2,
        Claude = 3,
        YouTube = 4,
        SocialMedia = 5,
        FlightSchoolInstructor = 6,
        FriendReferral = 7,
        AviationEvent = 8,
        Other = 9,
    }

export enum DocumentReferenceSourceAllItems {
        FAR = 1,
        AIM = 2,
    }




